import k$1, { useEffect, useMemo, useCallback, createContext, useState, useContext, useRef, useLayoutEffect, Fragment } from "react";
import { observer } from "mobx-react";
import PropTypes, { PropTypes as PropTypes$1 } from "prop-types";
import { Icon, Colors, Button, HSpacer, classUtil, Text as Text$1, VSpacer, ErrorModal, ToastAlert, Alert, Link, Radio, Input, Modal, Tooltip, CopyToClipboard, LoadingOverlay, Address, HoverCard, Accordion, LabeledContent, RadioGroup, Flex, RawDropdown, Textarea, Select, Checkbox, EmptyState, Pill, FileUpload as FileUpload$1, Drawer, FilePreview as FilePreview$1, FilePreviewFooter, FilePreviewName, FilePreviewActions, BoxContainer, Container, Row, Col, RadioGroupItem, FormError, FormLabel, SplitButton, FocusTrap, History, Breadcrumbs, Tabs, Admonition, Metrics, Multiselect, Toggle, StatusIndicator } from "@mqd/volt-base";
import { flipFlop, secureStorage } from "@mqd/bootstrap";
import moment from "moment";
import { formatMoney, MaskedInput } from "@mqd/volt-currency";
import { decorate, observable, action, computed, ObservableSet, runInAction, toJS, reaction } from "mobx";
import { ParentStore, ParentTable, segmentTrackEvent, SegmentTrackHOC, PaginationStore, ParentTableStore, containerHeightHOC } from "@mqd/store-helpers";
import { Actions as Actions$1, Table, ActionPlaceholder, ActionsHeader, clearColumnConfig, ActionsCell, Pagination } from "@mqd/volt-table";
import { DatePicker } from "@mqd/volt-date-picker";
import { useLazyQuery, useQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import gqlUtils from "@mqd/graphql-utils";
import { TRANSACTION_TYPES } from "@mqd/mqd-constants";
import require$$1 from "react-dom";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production_min = {};
var hasRequiredReactJsxRuntime_production_min;
function requireReactJsxRuntime_production_min() {
  if (hasRequiredReactJsxRuntime_production_min)
    return reactJsxRuntime_production_min;
  hasRequiredReactJsxRuntime_production_min = 1;
  /** @license React v16.14.0
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var f = k$1, g = 60103;
  reactJsxRuntime_production_min.Fragment = 60107;
  if ("function" === typeof Symbol && Symbol.for) {
    var h = Symbol.for;
    g = h("react.element");
    reactJsxRuntime_production_min.Fragment = h("react.fragment");
  }
  var m = f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, n = Object.prototype.hasOwnProperty, p = { key: true, ref: true, __self: true, __source: true };
  function q(c, a, k2) {
    var b, d = {}, e = null, l = null;
    void 0 !== k2 && (e = "" + k2);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for (b in a)
      n.call(a, b) && !p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps)
      for (b in a = c.defaultProps, a)
        void 0 === d[b] && (d[b] = a[b]);
    return { $$typeof: g, type: c, key: e, ref: l, props: d, _owner: m.current };
  }
  reactJsxRuntime_production_min.jsx = q;
  reactJsxRuntime_production_min.jsxs = q;
  return reactJsxRuntime_production_min;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development)
    return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  (function(exports) {
    /** @license React v16.14.0
     * react-jsx-runtime.development.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    if (process.env.NODE_ENV !== "production") {
      (function() {
        var React = k$1;
        var REACT_ELEMENT_TYPE = 60103;
        var REACT_PORTAL_TYPE = 60106;
        exports.Fragment = 60107;
        var REACT_STRICT_MODE_TYPE = 60108;
        var REACT_PROFILER_TYPE = 60114;
        var REACT_PROVIDER_TYPE = 60109;
        var REACT_CONTEXT_TYPE = 60110;
        var REACT_FORWARD_REF_TYPE = 60112;
        var REACT_SUSPENSE_TYPE = 60113;
        var REACT_SUSPENSE_LIST_TYPE = 60120;
        var REACT_MEMO_TYPE = 60115;
        var REACT_LAZY_TYPE = 60116;
        var REACT_BLOCK_TYPE = 60121;
        var REACT_SERVER_BLOCK_TYPE = 60122;
        var REACT_FUNDAMENTAL_TYPE = 60117;
        var REACT_DEBUG_TRACING_MODE_TYPE = 60129;
        var REACT_LEGACY_HIDDEN_TYPE = 60131;
        if (typeof Symbol === "function" && Symbol.for) {
          var symbolFor = Symbol.for;
          REACT_ELEMENT_TYPE = symbolFor("react.element");
          REACT_PORTAL_TYPE = symbolFor("react.portal");
          exports.Fragment = symbolFor("react.fragment");
          REACT_STRICT_MODE_TYPE = symbolFor("react.strict_mode");
          REACT_PROFILER_TYPE = symbolFor("react.profiler");
          REACT_PROVIDER_TYPE = symbolFor("react.provider");
          REACT_CONTEXT_TYPE = symbolFor("react.context");
          REACT_FORWARD_REF_TYPE = symbolFor("react.forward_ref");
          REACT_SUSPENSE_TYPE = symbolFor("react.suspense");
          REACT_SUSPENSE_LIST_TYPE = symbolFor("react.suspense_list");
          REACT_MEMO_TYPE = symbolFor("react.memo");
          REACT_LAZY_TYPE = symbolFor("react.lazy");
          REACT_BLOCK_TYPE = symbolFor("react.block");
          REACT_SERVER_BLOCK_TYPE = symbolFor("react.server.block");
          REACT_FUNDAMENTAL_TYPE = symbolFor("react.fundamental");
          symbolFor("react.scope");
          symbolFor("react.opaque.id");
          REACT_DEBUG_TRACING_MODE_TYPE = symbolFor("react.debug_trace_mode");
          symbolFor("react.offscreen");
          REACT_LEGACY_HIDDEN_TYPE = symbolFor("react.legacy_hidden");
        }
        var MAYBE_ITERATOR_SYMBOL = typeof Symbol === "function" && Symbol.iterator;
        var FAUX_ITERATOR_SYMBOL = "@@iterator";
        function getIteratorFn(maybeIterable) {
          if (maybeIterable === null || typeof maybeIterable !== "object") {
            return null;
          }
          var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
          if (typeof maybeIterator === "function") {
            return maybeIterator;
          }
          return null;
        }
        var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        function error(format) {
          {
            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }
            printWarning("error", format, args);
          }
        }
        function printWarning(level, format, args) {
          {
            var ReactDebugCurrentFrame2 = ReactSharedInternals.ReactDebugCurrentFrame;
            var stack = "";
            if (currentlyValidatingElement) {
              var name = getComponentName(currentlyValidatingElement.type);
              var owner = currentlyValidatingElement._owner;
              stack += describeComponentFrame(name, currentlyValidatingElement._source, owner && getComponentName(owner.type));
            }
            stack += ReactDebugCurrentFrame2.getStackAddendum();
            if (stack !== "") {
              format += "%s";
              args = args.concat([stack]);
            }
            var argsWithFormat = args.map(function(item) {
              return "" + item;
            });
            argsWithFormat.unshift("Warning: " + format);
            Function.prototype.apply.call(console[level], console, argsWithFormat);
          }
        }
        var enableScopeAPI = false;
        function isValidElementType(type) {
          if (typeof type === "string" || typeof type === "function") {
            return true;
          }
          if (type === exports.Fragment || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI) {
            return true;
          }
          if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
              return true;
            }
          }
          return false;
        }
        var BEFORE_SLASH_RE = /^(.*)[\\\/]/;
        function describeComponentFrame(name, source, ownerName) {
          var sourceInfo = "";
          if (source) {
            var path = source.fileName;
            var fileName = path.replace(BEFORE_SLASH_RE, "");
            {
              if (/^index\./.test(fileName)) {
                var match = path.match(BEFORE_SLASH_RE);
                if (match) {
                  var pathBeforeSlash = match[1];
                  if (pathBeforeSlash) {
                    var folderName = pathBeforeSlash.replace(BEFORE_SLASH_RE, "");
                    fileName = folderName + "/" + fileName;
                  }
                }
              }
            }
            sourceInfo = " (at " + fileName + ":" + source.lineNumber + ")";
          } else if (ownerName) {
            sourceInfo = " (created by " + ownerName + ")";
          }
          return "\n    in " + (name || "Unknown") + sourceInfo;
        }
        var Resolved = 1;
        function refineResolvedLazyComponent(lazyComponent) {
          return lazyComponent._status === Resolved ? lazyComponent._result : null;
        }
        function getWrappedName(outerType, innerType, wrapperName) {
          var functionName = innerType.displayName || innerType.name || "";
          return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
        }
        function getComponentName(type) {
          if (type == null) {
            return null;
          }
          {
            if (typeof type.tag === "number") {
              error("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue.");
            }
          }
          if (typeof type === "function") {
            return type.displayName || type.name || null;
          }
          if (typeof type === "string") {
            return type;
          }
          switch (type) {
            case exports.Fragment:
              return "Fragment";
            case REACT_PORTAL_TYPE:
              return "Portal";
            case REACT_PROFILER_TYPE:
              return "Profiler";
            case REACT_STRICT_MODE_TYPE:
              return "StrictMode";
            case REACT_SUSPENSE_TYPE:
              return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
              return "SuspenseList";
          }
          if (typeof type === "object") {
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                return "Context.Consumer";
              case REACT_PROVIDER_TYPE:
                return "Context.Provider";
              case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
              case REACT_MEMO_TYPE:
                return getComponentName(type.type);
              case REACT_BLOCK_TYPE:
                return getComponentName(type.render);
              case REACT_LAZY_TYPE: {
                var thenable = type;
                var resolvedThenable = refineResolvedLazyComponent(thenable);
                if (resolvedThenable) {
                  return getComponentName(resolvedThenable);
                }
                break;
              }
            }
          }
          return null;
        }
        var loggedTypeFailures = {};
        ReactSharedInternals.ReactDebugCurrentFrame;
        var currentlyValidatingElement = null;
        function setCurrentlyValidatingElement(element) {
          {
            currentlyValidatingElement = element;
          }
        }
        function checkPropTypes(typeSpecs, values, location, componentName, element) {
          {
            var has = Function.call.bind(Object.prototype.hasOwnProperty);
            for (var typeSpecName in typeSpecs) {
              if (has(typeSpecs, typeSpecName)) {
                var error$1 = void 0;
                try {
                  if (typeof typeSpecs[typeSpecName] !== "function") {
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                  }
                  error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (ex) {
                  error$1 = ex;
                }
                if (error$1 && !(error$1 instanceof Error)) {
                  setCurrentlyValidatingElement(element);
                  error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                  setCurrentlyValidatingElement(null);
                }
                if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                  loggedTypeFailures[error$1.message] = true;
                  setCurrentlyValidatingElement(element);
                  error("Failed %s type: %s", location, error$1.message);
                  setCurrentlyValidatingElement(null);
                }
              }
            }
          }
        }
        var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
        var hasOwnProperty2 = Object.prototype.hasOwnProperty;
        var RESERVED_PROPS = {
          key: true,
          ref: true,
          __self: true,
          __source: true
        };
        var specialPropKeyWarningShown;
        var specialPropRefWarningShown;
        var didWarnAboutStringRefs;
        {
          didWarnAboutStringRefs = {};
        }
        function hasValidRef(config) {
          {
            if (hasOwnProperty2.call(config, "ref")) {
              var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.ref !== void 0;
        }
        function hasValidKey(config) {
          {
            if (hasOwnProperty2.call(config, "key")) {
              var getter = Object.getOwnPropertyDescriptor(config, "key").get;
              if (getter && getter.isReactWarning) {
                return false;
              }
            }
          }
          return config.key !== void 0;
        }
        function warnIfStringRefCannotBeAutoConverted(config, self2) {
          {
            if (typeof config.ref === "string" && ReactCurrentOwner.current && self2 && ReactCurrentOwner.current.stateNode !== self2) {
              var componentName = getComponentName(ReactCurrentOwner.current.type);
              if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentName(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
              }
            }
          }
        }
        function defineKeyPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingKey = function() {
              if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingKey.isReactWarning = true;
            Object.defineProperty(props, "key", {
              get: warnAboutAccessingKey,
              configurable: true
            });
          }
        }
        function defineRefPropWarningGetter(props, displayName) {
          {
            var warnAboutAccessingRef = function() {
              if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
              }
            };
            warnAboutAccessingRef.isReactWarning = true;
            Object.defineProperty(props, "ref", {
              get: warnAboutAccessingRef,
              configurable: true
            });
          }
        }
        var ReactElement = function(type, key, ref, self2, source, owner, props) {
          var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type,
            key,
            ref,
            props,
            // Record the component responsible for creating this element.
            _owner: owner
          };
          {
            element._store = {};
            Object.defineProperty(element._store, "validated", {
              configurable: false,
              enumerable: false,
              writable: true,
              value: false
            });
            Object.defineProperty(element, "_self", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: self2
            });
            Object.defineProperty(element, "_source", {
              configurable: false,
              enumerable: false,
              writable: false,
              value: source
            });
            if (Object.freeze) {
              Object.freeze(element.props);
              Object.freeze(element);
            }
          }
          return element;
        };
        function jsxDEV(type, config, maybeKey, source, self2) {
          {
            var propName;
            var props = {};
            var key = null;
            var ref = null;
            if (maybeKey !== void 0) {
              key = "" + maybeKey;
            }
            if (hasValidKey(config)) {
              key = "" + config.key;
            }
            if (hasValidRef(config)) {
              ref = config.ref;
              warnIfStringRefCannotBeAutoConverted(config, self2);
            }
            for (propName in config) {
              if (hasOwnProperty2.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                props[propName] = config[propName];
              }
            }
            if (type && type.defaultProps) {
              var defaultProps = type.defaultProps;
              for (propName in defaultProps) {
                if (props[propName] === void 0) {
                  props[propName] = defaultProps[propName];
                }
              }
            }
            if (key || ref) {
              var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
              if (key) {
                defineKeyPropWarningGetter(props, displayName);
              }
              if (ref) {
                defineRefPropWarningGetter(props, displayName);
              }
            }
            return ReactElement(type, key, ref, self2, source, ReactCurrentOwner.current, props);
          }
        }
        var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
        ReactSharedInternals.ReactDebugCurrentFrame;
        function setCurrentlyValidatingElement$1(element) {
          currentlyValidatingElement = element;
        }
        var propTypesMisspellWarningShown;
        {
          propTypesMisspellWarningShown = false;
        }
        function isValidElement(object) {
          {
            return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
          }
        }
        function getDeclarationErrorAddendum() {
          {
            if (ReactCurrentOwner$1.current) {
              var name = getComponentName(ReactCurrentOwner$1.current.type);
              if (name) {
                return "\n\nCheck the render method of `" + name + "`.";
              }
            }
            return "";
          }
        }
        function getSourceInfoErrorAddendum(source) {
          {
            return "";
          }
        }
        var ownerHasKeyUseWarning = {};
        function getCurrentComponentErrorInfo(parentType) {
          {
            var info = getDeclarationErrorAddendum();
            if (!info) {
              var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
              if (parentName) {
                info = "\n\nCheck the top-level render call using <" + parentName + ">.";
              }
            }
            return info;
          }
        }
        function validateExplicitKey(element, parentType) {
          {
            if (!element._store || element._store.validated || element.key != null) {
              return;
            }
            element._store.validated = true;
            var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
            if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
              return;
            }
            ownerHasKeyUseWarning[currentComponentErrorInfo] = true;
            var childOwner = "";
            if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) {
              childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
            }
            setCurrentlyValidatingElement$1(element);
            error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
            setCurrentlyValidatingElement$1(null);
          }
        }
        function validateChildKeys(node, parentType) {
          {
            if (typeof node !== "object") {
              return;
            }
            if (Array.isArray(node)) {
              for (var i = 0; i < node.length; i++) {
                var child = node[i];
                if (isValidElement(child)) {
                  validateExplicitKey(child, parentType);
                }
              }
            } else if (isValidElement(node)) {
              if (node._store) {
                node._store.validated = true;
              }
            } else if (node) {
              var iteratorFn = getIteratorFn(node);
              if (typeof iteratorFn === "function") {
                if (iteratorFn !== node.entries) {
                  var iterator = iteratorFn.call(node);
                  var step;
                  while (!(step = iterator.next()).done) {
                    if (isValidElement(step.value)) {
                      validateExplicitKey(step.value, parentType);
                    }
                  }
                }
              }
            }
          }
        }
        function validatePropTypes(element) {
          {
            var type = element.type;
            if (type === null || type === void 0 || typeof type === "string") {
              return;
            }
            var propTypes;
            if (typeof type === "function") {
              propTypes = type.propTypes;
            } else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            type.$$typeof === REACT_MEMO_TYPE)) {
              propTypes = type.propTypes;
            } else {
              return;
            }
            if (propTypes) {
              var name = getComponentName(type);
              checkPropTypes(propTypes, element.props, "prop", name, element);
            } else if (type.PropTypes !== void 0 && !propTypesMisspellWarningShown) {
              propTypesMisspellWarningShown = true;
              var _name = getComponentName(type);
              error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
            }
            if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) {
              error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
            }
          }
        }
        function validateFragmentProps(fragment) {
          {
            var keys2 = Object.keys(fragment.props);
            for (var i = 0; i < keys2.length; i++) {
              var key = keys2[i];
              if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
              }
            }
            if (fragment.ref !== null) {
              setCurrentlyValidatingElement$1(fragment);
              error("Invalid attribute `ref` supplied to `React.Fragment`.");
              setCurrentlyValidatingElement$1(null);
            }
          }
        }
        function jsxWithValidation(type, props, key, isStaticChildren, source, self2) {
          {
            var validType = isValidElementType(type);
            if (!validType) {
              var info = "";
              if (type === void 0 || typeof type === "object" && type !== null && Object.keys(type).length === 0) {
                info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
              }
              var sourceInfo = getSourceInfoErrorAddendum();
              if (sourceInfo) {
                info += sourceInfo;
              } else {
                info += getDeclarationErrorAddendum();
              }
              var typeString;
              if (type === null) {
                typeString = "null";
              } else if (Array.isArray(type)) {
                typeString = "array";
              } else if (type !== void 0 && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentName(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
              } else {
                typeString = typeof type;
              }
              error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
            }
            var element = jsxDEV(type, props, key, source, self2);
            if (element == null) {
              return element;
            }
            if (validType) {
              var children = props.children;
              if (children !== void 0) {
                if (isStaticChildren) {
                  if (Array.isArray(children)) {
                    for (var i = 0; i < children.length; i++) {
                      validateChildKeys(children[i], type);
                    }
                    if (Object.freeze) {
                      Object.freeze(children);
                    }
                  } else {
                    error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                  }
                } else {
                  validateChildKeys(children, type);
                }
              }
            }
            if (type === exports.Fragment) {
              validateFragmentProps(element);
            } else {
              validatePropTypes(element);
            }
            return element;
          }
        }
        function jsxWithValidationStatic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, true);
          }
        }
        function jsxWithValidationDynamic(type, props, key) {
          {
            return jsxWithValidation(type, props, key, false);
          }
        }
        var jsx = jsxWithValidationDynamic;
        var jsxs = jsxWithValidationStatic;
        exports.jsx = jsx;
        exports.jsxs = jsxs;
      })();
    }
  })(reactJsxRuntime_development);
  return reactJsxRuntime_development;
}
if (process.env.NODE_ENV === "production") {
  jsxRuntime.exports = requireReactJsxRuntime_production_min();
} else {
  jsxRuntime.exports = requireReactJsxRuntime_development();
}
var jsxRuntimeExports = jsxRuntime.exports;
const ALERT = "alert";
const MODAL = "modal";
const TOAST = "toast";
const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];
const NO_OP = () => {
};
const OTHER_DISPUTES = "OTHER_DISPUTES";
const TRANSACTION_STATES = {
  CLEARED: "CLEARED",
  COMPLETION: "COMPLETION",
  DECLINED: "DECLINED",
  ERROR: "ERROR",
  PENDING: "PENDING"
};
const DISPUTES = {
  DISPUTE: "DISPUTE",
  LEGACY_DISPUTE: "LEGACY_DISPUTE"
};
const CHANGE_CASE_TYPE = "CHANGE_CASE_TYPE";
const LEGACY_DISPUTE_REASONS_MAP = /* @__PURE__ */ new Map([[OTHER_DISPUTES, {
  label: "Other disputes"
}], ["OTHER_MAESTRO_DISPUTES", {
  label: "Other Maestro disputes"
}], ["OTHER_PULSE_DISPUTES", {
  label: "Other Pulse disputes"
}]]);
const TMS_PROGRAMS = ["sqr"];
const DISPUTE_STATE_MAP = {
  ARBITRATION: "ARBITRATION",
  CASE_WON: "CASE_WON",
  CLOSED: "CLOSED",
  INITIATED: "INITIATED",
  PRE_ARBITRATION: "PRE_ARBITRATION",
  REPRESENTMENT: "REPRESENTMENT",
  NETWORK_REJECTED: "NETWORK_REJECTED",
  CASE_LOST: "CASE_LOST",
  PREARB_RECEIVED: "PREARB_RECEIVED",
  PREARB_RESPONDED: "PREARB_RESPONDED"
};
const STATE_MAP = {
  CLOSED: "CLOSED",
  PENDING_CLOSE: "PENDING_CLOSE",
  NONE: "NONE",
  READY: "READY",
  //allow state for converting to non-integrated
  CHARGEBACK_INITIATED: "CHARGEBACK_INITIATED",
  OPEN_WITH_ACTION_REQUIRED: "OPEN_WITH_ACTION_REQUIRED",
  OPEN: "OPEN"
};
const TRANSITION_ACTIONS = {
  REVIEW: "REVIEW",
  RE_OPEN: "RE_OPEN",
  CLOSE: "CLOSE",
  WITHDRAW_AND_CLOSE: "WITHDRAW_AND_CLOSE",
  WRITE_OFF: "WRITE_OFF"
};
const EXPAND_PARAMS = {
  REGULATION_DETAILS: "regulation_details"
};
const SORT_OPTIONS = {
  CREATED_NEWEST: "-createdTime",
  CREATED_OLDEST: "createdTime",
  LAST_MODIFIED_NEWEST: "-lastModifiedTime",
  LAST_MODIFIED_OLDEST: "lastModifiedTime"
};
const SORT_OPTIONS_LABELS = {
  [SORT_OPTIONS.CREATED_NEWEST]: "Sort by creation time: Newest",
  [SORT_OPTIONS.CREATED_OLDEST]: "Sort by creation time: Oldest",
  [SORT_OPTIONS.LAST_MODIFIED_NEWEST]: "Sort by modification time: Newest",
  [SORT_OPTIONS.LAST_MODIFIED_OLDEST]: "Sort by modification time: Oldest"
};
const LEGACY_ZENDESK_PROGRAM_SHORTCODES = ["coin", "coineu", "coinuk"];
const sentenceCase = (str = "", split = "_") => {
  try {
    const splitStr = str.split(split).join(" ");
    const sentence = splitStr.charAt(0).toUpperCase() + splitStr.substr(1).toLowerCase();
    return sentence;
  } catch (e) {
    return str;
  }
};
const allCaps = (str = "", split = "_") => {
  try {
    return str.split(split).join(" ").toUpperCase();
  } catch (err) {
    return str;
  }
};
const titleCase = (str = "", split = "_") => {
  try {
    const splitStr = str.split(split).join(" ");
    return splitStr.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
  } catch (e) {
    return str;
  }
};
const normalizeParagraphStyles = (str = "", useSentenceCase = true) => {
  try {
    const punctuationMarkAndFirstLetter = /[!|/?|.]( )?./g;
    const text = useSentenceCase ? sentenceCase(str) : str;
    return text.replace(punctuationMarkAndFirstLetter, (letterAndMark) => letterAndMark.toUpperCase());
  } catch (e) {
    return str;
  }
};
const isNumeric = (value) => {
  return !isNaN(value - parseFloat(value));
};
const formatUTCMoment = (timestamp, options = {}) => {
  try {
    const {
      showDate = true,
      showTime = true,
      showTimezone = false,
      dateFormat = "YYYY-MM-DD"
    } = options;
    const utcMoment = moment.utc(timestamp);
    let formattedTime = "";
    if (!utcMoment.isValid())
      return timestamp;
    if (showDate) {
      formattedTime += utcMoment.format(dateFormat);
      if (showTime) {
        formattedTime += " " + utcMoment.format("HH:mm");
      }
    } else if (showTime) {
      formattedTime += utcMoment.format("HH:mm");
    }
    if (showTimezone) {
      formattedTime += utcMoment.format(" z");
    }
    return formattedTime;
  } catch (err) {
    console.error(`Error (formatUTCMoment util): ${err}`);
    return timestamp;
  }
};
const formatTimeAgo = (time, unit) => {
  if (time > 1) {
    return `${time} ${unit}s ago`;
  }
  return `${time} ${unit} ago`;
};
const relativeUpdatedTime = (timestamp) => {
  const utcMoment = moment.utc(timestamp);
  const timeFromNow = utcMoment.fromNow();
  const oneHourAgo = moment.utc().subtract({
    hours: 1
  });
  const oneDayAgo = moment.utc().subtract({
    days: 1
  });
  if (utcMoment.isAfter(oneHourAgo)) {
    return timeFromNow;
  }
  if (utcMoment.isAfter(oneDayAgo)) {
    const hoursDiff = utcMoment.diff(moment.utc(), "hour", true);
    const roundedHoursDiff = Math.round(hoursDiff);
    return formatTimeAgo(Math.abs(roundedHoursDiff), "hour");
  }
  if (utcMoment.isBefore(oneDayAgo)) {
    const daysDiff = utcMoment.diff(moment.utc(), "day", true);
    const roundedDaysDiff = Math.round(daysDiff);
    return formatTimeAgo(Math.abs(roundedDaysDiff), "day");
  }
};
const isWithinXDays = (timestamp, numDays = 45) => {
  const utcTimestamp = moment.utc(timestamp);
  const daysDuration = moment.duration(numDays, "days").asMilliseconds();
  const diff = utcTimestamp.diff(moment.utc(), "millisecond", true);
  return Math.abs(diff) < daysDuration;
};
const isOlderThanDate = (timestamp, date) => {
  return toLocal(timestamp).isBefore(toLocal(date));
};
const formatHour = (timeInHourFormat, isTwelveHourFormat = false) => {
  const twelveFormat = "h:mm A";
  const twentyFourFormat = "HH:mm";
  const inputFormat = isTwelveHourFormat ? twelveFormat : twentyFourFormat;
  const outputFormat = isTwelveHourFormat ? twentyFourFormat : twelveFormat;
  const timeInstance = moment(timeInHourFormat, inputFormat);
  if (timeInstance.isValid()) {
    return timeInstance.format(outputFormat);
  }
  return timeInHourFormat;
};
const formatDate = (timestamp) => {
  return moment(timestamp).format("ll");
};
const toLocal = (timestamp) => {
  return moment(timestamp).local();
};
const formatDateForDateTimeInput = (timestamp) => {
  return toLocal(timestamp).format("YYYY-MM-DDTHH:mm");
};
const convertDateToUTC = (timestamp) => {
  return timestamp && moment(timestamp).utc();
};
const isDateInFuture = (timestamp) => {
  return toLocal(timestamp).isAfter(moment());
};
const convertDateFromUTCToLocal = (timestamp) => {
  return toLocal(timestamp).format("YYYY-MM-DD HH:mm");
};
const formatMoneyAmount = (str) => {
  try {
    return parseFloat(str).toFixed(2);
  } catch (err) {
    return str;
  }
};
const removeUnnecessaryWords = (text = "") => {
  return text.replace(/NetworkCaseID: \d*/g, "");
};
const formatNetworkError = (rawError, useSentenceCase = true) => {
  if (typeof rawError === "string")
    return rawError;
  if (rawError instanceof Error)
    return rawError.message;
  if (!(Array.isArray(rawError) && rawError[0].message))
    return null;
  let {
    message
  } = rawError[0];
  const bannedChars = /com\.|java\.|{|}|[a-z]Api|[Aa]pi[A-Z]/g;
  if (message.search(bannedChars) !== -1)
    return null;
  message = removeUnnecessaryWords(message);
  return normalizeParagraphStyles(message, useSentenceCase);
};
const convertNumberToCurrency = (value, unit) => {
  if (!value)
    return null;
  let returnValue = `${formatMoney(Number.parseFloat(value))}`;
  if (unit)
    returnValue = returnValue + ` ${unit}`;
  return returnValue;
};
const formatDateAsUTCString = (date) => {
  return date ? moment.utc(date).format("M/D/Y, H:mm UTC") : "";
};
const isValidMoneyAmount = (value) => {
  const moneyRegex = /^\d+(?:\.\d{2})$/;
  return testWithRegex(moneyRegex, value);
};
const isValidFilingIca = (value) => {
  const numericRegex = /^\d{1,11}$/;
  return testWithRegex(numericRegex, value);
};
const isValidNetworkMemo = (value) => {
  const memoRegex = /^([\sa-zA-Z0-9~!@#$%^&*()_+{}|:"<>?,./;'[\]\-=]){1,1500}$/;
  return testWithRegex(memoRegex, value);
};
const testWithRegex = (regex, value) => {
  try {
    return regex.test(value);
  } catch (err) {
    return false;
  }
};
const safeParse = (jsonString) => {
  try {
    return JSON.parse(jsonString);
  } catch (err) {
    return {};
  }
};
const convertBoolValues = (val) => {
  if (val === true)
    return "Yes";
  if (val === false)
    return "No";
  return val;
};
const formatReason = (reason = {}) => {
  const {
    label,
    VISA: VISA2,
    MASTERCARD: MASTERCARD2,
    DISCOVER,
    MAESTRO,
    PULSE: PULSE2
  } = reason;
  if (!label || !(VISA2 || MASTERCARD2 || DISCOVER || MAESTRO || PULSE2))
    return;
  const formatted = `${label}`;
  const networkCodes = [];
  Object.keys({
    VISA: VISA2,
    MASTERCARD: MASTERCARD2,
    DISCOVER,
    MAESTRO,
    PULSE: PULSE2
  }).forEach((network) => {
    if (network && reason[network] && reason[network] !== "0000") {
      const formattedNetwork = sentenceCase(network).slice(0, 4);
      networkCodes.push(`${formattedNetwork} ${reason[network]}`);
    }
  });
  if (networkCodes) {
    return Object.assign({}, reason, {
      label: `${formatted} (${networkCodes.join(", ")})`
    });
  }
  return Object.assign({}, reason, {
    label: formatted
  });
};
const baseDisputeFormFields = {
  assignee: {
    label: "Case assignee (optional)",
    testId: "dispute-assignee-input"
  },
  dispute_amount: {
    label: "Dispute amount",
    testId: "dispute-amount-input"
  },
  dispute_amount_change_reason: {
    label: "Dispute amount change reason",
    testId: "dispute-amount-change-reason-select"
  },
  cardholder_contact_date: {
    label: "Cardholder contact date",
    testId: "dispute-cardholder-contact-date-input"
  },
  dispute_reason: {
    label: "Dispute reason",
    testId: "dispute-reason-select"
  },
  account_status: {
    label: "What is the status of the account",
    testId: "account-status"
  },
  fraud_type_classification_select: {
    label: "Fraud Type classification",
    testId: "fraud_type_classification-select"
  },
  regulation_subcategory: {
    label: "Dispute category",
    testId: "regulation_subcategory-input"
  },
  exception_reason_apply: {
    label: "Does any exception or good reason apply?",
    testId: "exception_reason_apply-input"
  },
  disabled_dispute_amount_input: {
    testId: "disabled-dispute-amount-input"
  },
  partial_dispute_amount_radio: {
    label: "Other amount",
    testId: "partial-dispute-amount-radio"
  },
  full_dispute_amount_radio: {
    label: "Full transaction amount",
    testId: "full-dispute-amount-radio"
  },
  memo: {
    label: "Notes for internal use",
    testId: "dispute-notes"
  },
  network_comment: {
    label: "Comments sent to Network",
    testId: "dispute-comments"
  },
  chip_on_card: {
    label: "Does the card have a chip?",
    testId: "chip_on_card",
    groupName: "dispute-visa-fraud"
  },
  fraud_type: {
    label: "Fraud type",
    testId: "fraud_type"
  },
  is_dispute_impacted_by_local_law_or_regulation: {
    label: "Is this dispute impacted by local law/regulation",
    testId: "is_dispute_impacted_by_local_law_or_regulation",
    groupName: "is_dispute_impacted_by_local_law_or_regulation"
  }
};
const INITIATED_BY_PAYEE_FIELDS = {
  refund_conditions: {
    label: "Does the case meet the refund condition?",
    testId: "does_meet_refund_condition",
    groupName: "does-meet-refund"
  },
  regulation_conditions_met_date: {
    label: "Refund condition met date",
    testId: "regulation_conditions_met_date"
  }
};
const REFUND_CONDITIONS_ITEMS = [{
  label: "Yes",
  value: true
}, {
  label: "No",
  value: false
}];
const octoberNetworkMandate$2 = flipFlop.get("october-network-mandate", false);
const disputeReasonNetworkMap = {
  NO_AUTHORIZATION: {
    label: "No authorization",
    VISA: "11.3",
    MASTERCARD: "4808",
    MAESTRO: "74",
    PULSE: "4863"
  },
  SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED: {
    label: "Service not provided merchandise not received",
    VISA: "13.1",
    MASTERCARD: null,
    MAESTRO: "79",
    PULSE: "4555"
  },
  CANCELLED_RECURRING_TRANSACTION: {
    label: "Cancelled recurring transaction",
    VISA: "13.2",
    MASTERCARD: "4853",
    MAESTRO: "53",
    PULSE: "4541"
  },
  NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE: {
    label: "Not as described or defective merchandise",
    VISA: "13.3",
    MASTERCARD: null,
    PULSE: "4553"
  },
  LATE_PRESENTMENT: {
    label: "Late presentment",
    VISA: octoberNetworkMandate$2 ? null : "12.1",
    MASTERCARD: null,
    MAESTRO: "80",
    PULSE: "4542"
  },
  NOT_AUTHORIZED_CARD_PRESENT: {
    label: "Not authorized card present",
    VISA: "10.3",
    MASTERCARD: "4837",
    PULSE: "4537"
  },
  NOT_AUTHORIZED_CARD_ABSENT: {
    label: "Not authorized card absent",
    VISA: "10.4",
    MASTERCARD: "4837",
    PULSE: "4868"
  },
  CREDIT_NOT_PROCESSED: {
    label: "Credit not processed",
    VISA: "13.6",
    MASTERCARD: null,
    MAESTRO: "75",
    PULSE: "4560"
  },
  NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM: {
    label: "Non receipt of cash",
    VISA: "13.9",
    MASTERCARD: "4859",
    PULSE: "4590",
    MAESTRO: "17"
  },
  FRAUD_MULTIPLE_TRANSACTIONS: {
    label: "Fraud multiple transactions",
    VISA: null,
    MASTERCARD: null,
    DISCOVER: null
  },
  FRAUD_TRANSACTION: {
    label: "Fraud transaction",
    VISA: null,
    MASTERCARD: null,
    DISCOVER: "4540"
  },
  TRANSACTION_NOT_RECOGNIZED: {
    label: "Transaction not recognized",
    VISA: null,
    MASTERCARD: null,
    DISCOVER: "4752"
  },
  INCORRECT_CURRENCY: {
    label: "Incorrect currency",
    VISA: "12.3",
    MASTERCARD: null,
    DISCOVER: null
  },
  INCORRECT_TRANSACTION_CODE: {
    label: "Incorrect transaction code",
    VISA: "12.2",
    MASTERCARD: null,
    PULSE: "4550"
  },
  INCORRECT_CURRENCY_OR_TRANSACTION_CODE: {
    label: "Incorrect currency Europe",
    VISA: null,
    MASTERCARD: "4846",
    PULSE: null
  },
  INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER: {
    label: "Incorrect transaction amount or account number",
    VISA: null,
    MASTERCARD: null,
    PULSE: null
  },
  DUPLICATE_PROCESSING: {
    label: "Duplicate Processing",
    VISA: null,
    MASTERCARD: null,
    PULSE: "4534"
  },
  DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS: {
    label: "Duplicate Processing/Paid by Other Means",
    VISA: "12.6",
    MASTERCARD: null,
    PULSE: "4865",
    MAESTRO: "73"
  },
  INCORRECT_TRANSACTION_AMOUNT: {
    label: "Incorrect transaction amount",
    VISA: "12.5",
    MASTERCARD: null,
    MAESTRO: "71",
    PULSE: "4586"
  },
  //* Visa Specific reason Codes
  INCORRECT_ACCOUNT_NUMBER: {
    label: "Incorrect account number",
    VISA: "12.4",
    MASTERCARD: null,
    PULSE: "4512"
  },
  EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD: {
    label: "EMV liability shift counterfeit fraud",
    VISA: "10.1",
    MASTERCARD: null,
    PULSE: "4866"
  },
  EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD: {
    label: "EMV liability shift non counterfeit fraud",
    VISA: "10.2",
    MASTERCARD: null,
    PULSE: "4867"
  },
  CANCELLED_MERCHANDISE_OR_SERVICES: {
    label: "Cancelled merchandise or services",
    VISA: "13.7",
    MASTERCARD: null,
    PULSE: "4560"
  },
  INVALID_DATA: {
    label: "Invalid data",
    VISA: "12.7",
    MASTERCARD: null,
    PULSE: null
  },
  CARD_RECOVERY_BULLETIN: {
    label: "Card recovery bulletin",
    VISA: "11.1",
    MASTERCARD: null,
    PULSE: null
  },
  DECLINED_AUTH: {
    label: "Declined auth",
    VISA: "11.2",
    MASTERCARD: null,
    PULSE: null
  },
  COUNTERFEIT_MERCH: {
    label: "Counterfeit merch",
    VISA: "13.4",
    MASTERCARD: null,
    PULSE: null
  },
  MISREPRESENTATION: {
    label: "Misrepresentation",
    VISA: "13.5",
    MASTERCARD: null,
    PULSE: null
  },
  ORIGINAL_CREDIT_NOT_ACCEPTED: {
    label: "Original credit not accepted",
    VISA: "13.8",
    MASTERCARD: null,
    PULSE: null
  },
  //* Mastercard Specific Reason Codes
  WARNING_BULLETIN_FILE: {
    label: "Warning bulletin file",
    VISA: null,
    MASTERCARD: null,
    PULSE: null
  },
  CARDHOLDER_DISPUTE: {
    label: "Cardholder dispute",
    VISA: null,
    MASTERCARD: "4853",
    PULSE: null
  },
  AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM: {
    label: "Authorization related for dual message system",
    VISA: null,
    MASTERCARD: null,
    PULSE: null
  },
  ACCOUNT_NUMBER_NOT_ON_FILE: {
    label: "Account number not on file",
    VISA: null,
    MASTERCARD: null,
    PULSE: null
  },
  POINT_OF_INTERACTION_ERRORS: {
    label: "Point of interaction errors",
    VISA: null,
    MASTERCARD: "4834",
    PULSE: null
  },
  QUESTIONABLE_MERCHANT_ACTIVITY: {
    label: "Questionable merchant activity",
    VISA: null,
    MASTERCARD: "4849",
    PULSE: null
  },
  INSTALLMENT_BILLING_DISPUTE: {
    label: "Installment billing dispute",
    VISA: null,
    MASTERCARD: "4850",
    PULSE: null
  },
  CARDHOLDER_DISPUTE_US_ONLY: {
    label: "Cardholder dispute US only",
    VISA: null,
    MASTERCARD: "4854",
    PULSE: null
  },
  NO_SHOW_ADDENDUM_OR_ATM_DISPUTE: {
    label: "No show addendum or ATM dispute",
    VISA: null,
    MASTERCARD: null,
    PULSE: null
  },
  CHIP_LIABILITY_SHIFT: {
    label: "Chip liability shift",
    VISA: null,
    MASTERCARD: "4870",
    PULSE: null,
    MAESTRO: "70"
  },
  CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN: {
    label: "Chip PIN liability shift lost stolen",
    VISA: null,
    MASTERCARD: "4871",
    PULSE: null
  },
  CHIP_READ_POS_LATE_PRESENTMENT: {
    label: "Chip read POS late presentment",
    VISA: null,
    MASTERCARD: "4880",
    DISCOVER: null
  },
  DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE: {
    label: "Domestic chargeback intra European use",
    VISA: null,
    MASTERCARD: "4999",
    DISCOVER: null
  }
};
const LEGACY_DISPUTE_REASONS_BY_NETWORK = {
  ALWAYS: [OTHER_DISPUTES],
  DISCOVER: ["OTHER_PULSE_DISPUTES"],
  MASTERCARD: ["OTHER_MAESTRO_DISPUTES"],
  PULSE: ["OTHER_PULSE_DISPUTES"],
  VISA: []
};
const ONLY_WITH_SUB_NETWORK_DISPUTES = {
  MAESTRO: ["OTHER_MAESTRO_DISPUTES"]
};
const formattedDisputeReasonNetworkMap = Object.keys(disputeReasonNetworkMap).reduce((acc, curr) => {
  acc[curr] = formatReason(disputeReasonNetworkMap[curr]) || disputeReasonNetworkMap[curr];
  return acc;
}, {});
const formattedVisaSortedByCode = Object.keys(formattedDisputeReasonNetworkMap).filter((reason) => !!formattedDisputeReasonNetworkMap[reason]?.VISA).sort((reason, nextReason) => {
  const visaCode = formattedDisputeReasonNetworkMap[reason].VISA;
  const nextVisaCode = formattedDisputeReasonNetworkMap[nextReason].VISA;
  return parseFloat(visaCode) - parseFloat(nextVisaCode);
}).reduce((acc, curr) => {
  acc[curr] = formattedDisputeReasonNetworkMap[curr];
  return acc;
}, {});
const visaPhase2ReasonCodes = ["12.1", "12.2", "12.3", "12.4", "12.5", "12.6", "12.7", "13.1", "13.2", "13.3", "13.4", "13.5", "13.6", "13.7", "13.8", "13.9"];
const phase1DisputeReasons = Object.keys(formattedVisaSortedByCode).filter((reason) => {
  const visaCode = formattedVisaSortedByCode[reason]?.VISA;
  return visaCode.includes("10") || visaCode.includes("11") || visaPhase2ReasonCodes.includes(visaCode);
});
const phase1DisputeReasonNetworkMap = phase1DisputeReasons.reduce((acc, curr) => {
  acc[curr] = formattedDisputeReasonNetworkMap[curr];
  return acc;
}, {});
const sortReasonsByNetworkCode = (network, reasonsMap) => {
  return Object.keys(reasonsMap).filter((reason) => !!formattedDisputeReasonNetworkMap[reason][network]).sort((reason, nextReason) => {
    const code = formattedDisputeReasonNetworkMap[reason][network];
    const nextCode = formattedDisputeReasonNetworkMap[nextReason][network];
    return parseFloat(code) - parseFloat(nextCode);
  });
};
Object.keys(disputeReasonNetworkMap).filter((key) => {
  return disputeReasonNetworkMap[key]["MASTERCARD"] !== null;
});
const disputeReasonsPerNetwork = (network) => {
  if (["MASTERCARD", "PULSE"].includes(network)) {
    return sortReasonsByNetworkCode(network, disputeReasonNetworkMap);
  }
  return Object.keys(phase1DisputeReasonNetworkMap);
};
const disputeAmountChangeReasons = ["MERCHANT_ISSUED_PARTIAL_REFUND", "PARTIAL_DISPUTE", "NOT_AS_DESCRIBED_PARTIAL", "PARTIAL_SERVICE", "PRORATED_REFUND", "NOT_AUTHORIZED_FOR_FULL_AMOUNT"];
const FRUAD_TYPE_CLASSIFICATION_OPTIONS = ["PURCHASE_SCAM", "INVESTMENT_SCAM", "ROMANCE_SCAM", "ADVANCE_FEE_SCAM", "INVOICE_OR_MANDATE_SCAM", "CEO_FRAUD_SCAM", "IMPERSONATION_SCAM"];
const ACCOUNT_STATUS_OPTIONS = ["ACCOUNT_CLOSED", "CREDIT_PROBLEM", "FRAUD"];
const atrSelectionMessage = "Transactions have been found that look similar to the dispute information. If any transactions below represent a refund associated with this dispute, select those transactions and withdraw the dispute or continue to subtract the transactions from the dispute amount.";
const createATRSelectionStatuses = ["PENDING", "SUBMISSION_FAILED"];
const atrTransactionTypeMap = {
  TC05: "Sale/Acct Fnd Sale",
  TC06: "Credit/AcctFnd Credit/Orig Credit",
  TC07: "Cash",
  TC10: "Fee Collection",
  TC15: "Sales Draft Chargeback",
  TC16: "Credit Voucher Chargeback",
  TC17: "Cash Disbursement Chargeback",
  TC20: "Funds Disbursement",
  TC25: "Sale Rev/Acct Fnd Sale Rev",
  TC26: "Credit Rev/AcctFnd Credit Rev/Orig Credit Rev",
  TC27: "Cash Rev",
  TC35: "Sales Draft Chargeback Rev",
  TC36: "Credit Voucher Chargeback Rev",
  TC37: "Cash Disbursement",
  "0100": "Auth",
  "0400": "Auth Rev/Orig Rev/ATM Deposit Reversal",
  "0101": "Repeat Auth Req",
  "0110": "Auth Resp",
  "0120": "Auth Adv",
  "0201": "Repeat Fin Req",
  "0220": "Sale Representment",
  "0401": "Repeat Rev Req",
  "0410": "Rev Resp",
  "0422": "Chargeback Req & Chargeback Rev Req",
  "0480": "Chargeback Status Adv & Chargeback Rev Status Adv",
  "0600": "Admin",
  "0610": "Admin Resp",
  "0620": "CRIS Adv/RFC Advice/Admin Adv",
  9240: "Coll Only Req - Acqr",
  9620: "Fraud Notif Req",
  "0400/yy": "Original Auth Rev",
  "0200/26": "Orig Credit Rev",
  "0200/06": "Original Credit",
  "0200/16": "Credit Voucher Chargeback",
  "0200/36": "Credit Voucher Chargeback Rev"
};
const atrTransactionCustomTypeMap = [[/^0400/g, atrTransactionTypeMap["0400/yy"]]];
const atrCreditTransactionTypes = ["TC06", "TC16", "TC26", "TC36", "0200/26", "0200/06", "0200/16", "0200/36"];
const maxFileSize = 1572864;
const maxFileSizeInMB = maxFileSize / 1024 / 1024;
const VISA_ACCEPTED_FILE_TYPES = [".pdf", ".jpg", ".jpeg", ".tiff"];
const MASTERCARD_ACCEPTED_FILE_TYPES = [".pdf", ".jpg", ".jpeg", ".tiff", ".zip"];
const VISA_TEXT = "Ensure attached files are legible and less than 1.5 MB.";
const MC_TEXT = "Mastercard disputes are limited to one attachment. Ensure uploaded document is legible.";
const createFromTransactionsModalHeading = "Case created";
const createFromTransactionModalText = "This case has been created in Open state. To review this case and move to Ready state, select Continue.";
const editFromTransactionsModalHeading = "Case marked as Ready";
const editFromTransactionModalText = "This case has been moved to Ready state. To review this case and submit to the network, select Continue.";
const AMOUNT_REQUIRED_ERROR = "Dispute amount is required.";
const amountIncorrectFormatError = "Dispute amount is the wrong format.";
const reasonRequiredError = "Dispute reason is required.";
const CARDHOLDER_CONTACT_DATE_REQUIRED_ERROR = "Cardholder contact date is required.";
const REFUND_CONDITION_DATE_ERROR = "Refund condition met date is required.";
const CARDHOLDER_CONTACT_DATE_NOT_IN_FUTURE = "Cardholder contact date must not be in the future.";
const FRAUD_TYPE_REQUIRED_ERROR = "Fraud type is required.";
const AMOUNT_LIMIT_EXCEEDS_ERROR = "Dispute amount must be less than the original transaction amount.";
const ACCOUNT_STATUS_IS_REQUIRED = "Account status is required.";
const AMOUNT_LESS_THAN_MINIMUM_ERROR = "Dispute amount must be greater that 0.01";
const AMOUNT_LESS_THAN_DISPUTE_AMOUNT = "Amount must be less than the current dispute amount.";
const AMOUNT_CHANGE_REASON_REQUIRED_ERROR = "Dispute amount change reason is required for partial amount disputes.";
const transactionTokenRequiredError = "Transaction token is required.";
const questionnaireError = "Questionnaire entries are missing";
const DISPUTE_CATEGORY_ERROR = "Dispute category is required";
const REQUIRED_FIELD_ERROR = "This field is required.";
const ATR_VALIDATION_REQUIRED_ERROR = "Either select some associated transactions or mark that no transactions are associated.";
const ATTACHED_FILES_ARE_REQUIRED = "Attaching file(s) is mandatory for this type of dispute.";
const MEMO_FIELD_IS_REQUIRED_ERROR = "Reason for converting is required.";
const ZENDESK_TICKET_ID_VALIDATION = "Expected an ID with a minimum of 3 and maximum of 10 digits";
const CREATE_OR_ENTER_EXISTING_CRM_TICKET = "Please create or enter existing CRM ticket";
Object.keys(baseDisputeFormFields).reduce((acc, key) => {
  const testId = baseDisputeFormFields[key].testId;
  if (testId)
    acc[key] = testId;
  return acc;
}, {});
const formatDocumentError = (attribute2, condition) => `Please ensure that file ${attribute2} is ${condition}.`;
const RELATED_TRANSACTIONS$2 = "Related transactions";
const DISPUTE_CREATION = "Dispute creation";
const INTEGRATION_MESSAGES = {
  DISPUTE_TYPE: `This dispute is not integrated with the network and will be manually managed by the Marqeta team with the network.`,
  NETWORK: `This network is not integrated, the dispute will be manually managed by the Marqeta team with the network.`,
  REASON: `This reason code is not integrated with the network. This dispute will be manually managed by the Marqeta team with the network.`,
  TRANSACTION_TYPE: `This transaction type is not network integrated. This dispute will be manually managed by the Marqeta team with the network.`,
  TRANSITIONED_TO_LEGACY: `This was a previously integrated dispute that was converted to a non-integrated case. This dispute will be manually managed by the Marqeta team with the network.`
};
const FRAUD_ITEMS = [{
  label: "Yes",
  value: true
}, {
  label: "No",
  value: false
}];
const IMPACTED_BY_LOCAL_LAW_OR_REG_ITEMS = [{
  label: "Yes",
  value: true
}, {
  label: "No",
  value: false
}];
const FRAUD_TYPES = {
  LOST: "Lost",
  STOLEN: "Stolen",
  CARD_NOT_RECEIVED_AS_ISSUED: "Card not received as Issued (NRI)",
  FRAUDULENT_APPLICATION: "Fraudulent application (cardholder never applied for the card)",
  ISSUER_REPORTED_COUNTERFEIT: "Issuer-reported counterfeit",
  MISCELLANEOUS: "Miscellaneous",
  FRAUDULENT_USE_OF_ACCOUNT_NUMBER: "Fraudulent use of account number",
  INCORRECT_PROCESSING: "Incorrect Processing",
  ACCOUNT_OR_CREDENTIALS_TAKEOVER: "Account or Credentials Takeover",
  MERCHANT_MISREPRESENTATION: "Merchant Misrepresentation",
  MANIPULATION_OF_ACCOUNT_HOLDER: "Manipulation of Account Holder"
};
const FRAUD_TYPE_OPTIONS = Object.keys(FRAUD_TYPES).map((key) => ({
  id: key,
  val: key,
  render: FRAUD_TYPES[key]
}));
const FRAUD_REPORT_TEXT = "Fraud reason codes require a fraud report to be sent to the network for investigation purposes.";
const CASE_TYPES = {
  CHARGEBACK: "CHARGEBACK",
  FRAUD_REPORT: "FRAUD_REPORT"
};
const DISPUTE_CATEGORIES = {
  UNAUTHORIZED: "UNAUTHORIZED",
  INITIATED_BY_PAYEE: "INITIATED_BY_PAYEE",
  INCORRECTLY_EXECUTED: "INCORRECTLY_EXECUTED",
  OTHER: "OTHER",
  BNPL: "BNPL"
};
const DISPUTE_CATEGORIES_LABELS = {
  [DISPUTE_CATEGORIES.UNAUTHORIZED]: "Unauthorized dispute",
  [DISPUTE_CATEGORIES.INITIATED_BY_PAYEE]: "Initiated by payee",
  [DISPUTE_CATEGORIES.INCORRECTLY_EXECUTED]: "Incorrectly executed",
  [DISPUTE_CATEGORIES.OTHER]: "Other"
};
const DISPUTE_CATEGORY_RADIO_ITEMS = [{
  disabled: true,
  label: DISPUTE_CATEGORIES_LABELS[DISPUTE_CATEGORIES.UNAUTHORIZED],
  value: DISPUTE_CATEGORIES.UNAUTHORIZED
}, {
  label: DISPUTE_CATEGORIES_LABELS[DISPUTE_CATEGORIES.INITIATED_BY_PAYEE],
  value: DISPUTE_CATEGORIES.INITIATED_BY_PAYEE
}, {
  label: DISPUTE_CATEGORIES_LABELS[DISPUTE_CATEGORIES.INCORRECTLY_EXECUTED],
  value: DISPUTE_CATEGORIES.INCORRECTLY_EXECUTED
}, {
  label: DISPUTE_CATEGORIES_LABELS[DISPUTE_CATEGORIES.OTHER],
  value: DISPUTE_CATEGORIES.OTHER
}];
const EXCEPTION_REASON_APPLY = [{
  label: "Yes",
  value: true
}, {
  label: "No",
  value: false
}];
const DATE_TIME_INPUT_WIDTH = "540px";
const EXCEPTION_REASON_TOOLTIP = "Informational only. The selection does not impact workflow.";
const EXPLANATION_OF_CREDIT_SUB_LABEL = "Please provide ARN of the Sale (authorization.clearing or pindebit) transaction to which credit applies.";
const EXPLANATION_OF_CREDIT_WARNING = `If you select “These transactions are not associated” but you DO NOT provide an ARN and Date
 of an associated Sale to which the credit applies, we will have no choice but to apply the credit to the disputed transaction.`;
const SALESFORCE_RECORD_TYPE_MAP = {
  coin: "Coinbase US - Dispute Intake",
  coineu: "Coinbase EU/UK - Dispute Intake",
  coinuk: "Coinbase EU/UK - Dispute Intake"
};
const dig = (result, ...keys2) => {
  if (typeof result !== "object")
    return void 0;
  let digged = result;
  for (const key of keys2) {
    if (typeof digged === "undefined" || digged === null) {
      return void 0;
    }
    if (typeof key === "function") {
      digged = key(digged);
    } else {
      digged = digged[key];
    }
  }
  return digged;
};
const digIsPresent = (result, ...keys2) => {
  const dugValue = dig(result, ...keys2);
  return isPresent(dugValue);
};
const getKeyByValue = (object, value) => {
  try {
    return Object.keys(object).find((key) => object[key] === value);
  } catch (e) {
    return void 0;
  }
};
const toBase64 = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = async () => {
    try {
      const base64Data = reader.result.split("base64,")[1];
      resolve(base64Data);
    } catch (e) {
      reject(e);
    }
  };
  reader.onerror = (error) => reject(error);
  reader.readAsDataURL(file);
});
const isNotPresent = (val) => {
  return [null, void 0, ""].includes(val);
};
const isPresent = (val) => {
  return ![null, void 0, ""].includes(val);
};
const generateId = () => {
  let text = "";
  const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
  for (let i = 0; i < 16; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  return text;
};
const hasEnoughTimeTranspired = (timestamp, comparison, unit = "hour") => {
  const utcMoment = moment.utc(timestamp);
  const diff = utcMoment.diff(moment.utc(), unit);
  return Math.abs(diff) > comparison;
};
const isValidDate = (dateValue) => {
  try {
    const dateMoment = moment(dateValue, "YYYY-MM-DD", true);
    return dateMoment.isValid();
  } catch (err) {
    return false;
  }
};
const isParentNodeDateAfterChild = (child, parent) => {
  try {
    return isValidDate(parent) && moment(parent).isAfter(moment(child));
  } catch (err) {
    return false;
  }
};
const isValidTime = (timeValue) => {
  const time12formatRegex = /^(1[012]|(0?[1-9])):[0-5][0-9]( AM| PM)?$/i;
  return time12formatRegex.test(timeValue);
};
const numberOfDaysBetween = (date1, date2) => {
  const moment1 = moment(date1);
  const moment2 = moment(date2);
  const dateDiff = moment1.diff(moment2, "days");
  if (dateDiff === 0 && isOlderThanDate(date1, date2)) {
    return -1;
  }
  return dateDiff;
};
const evaluateBoolean = (value) => {
  if (typeof value === "boolean")
    return value;
  if (value === "true")
    return true;
  return Boolean(parseInt(value));
};
const anyNonEmptyParentValueAllowed = (nodeValue, parentRequirement) => {
  return isPresent(nodeValue) && Array.isArray(parentRequirement) && parentRequirement.length === 0;
};
const objectHasPresentValues = (obj) => {
  try {
    return Object.values(obj).some(isPresent);
  } catch (err) {
    return false;
  }
};
const parseAndGet = (strObject, key) => {
  try {
    const parsedObject = JSON.parse(strObject);
    return parsedObject[key];
  } catch (err) {
    return void 0;
  }
};
const amountValidation = (otherAmount, disputeAmount) => {
  const otherAmountExceedsDisputeAmount = parseFloat(otherAmount) > parseFloat(disputeAmount);
  const otherAmountTooSmall = parseFloat(otherAmount) < 0.01;
  const amountIsNotPresent = isNotPresent(otherAmount);
  if (otherAmountExceedsDisputeAmount) {
    return AMOUNT_LESS_THAN_DISPUTE_AMOUNT;
  }
  if (otherAmountTooSmall) {
    return AMOUNT_LESS_THAN_MINIMUM_ERROR;
  }
  if (amountIsNotPresent) {
    return AMOUNT_REQUIRED_ERROR;
  }
};
const noop = (..._args) => {
};
function ActionButton(props) {
  const {
    children,
    iconType,
    position,
    ...partialProps
  } = props;
  if (!children)
    return null;
  const icon = /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: iconType || "check", overrideColor: Colors.actionColor, noHoverEffects: true });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { type: "secondary", ...partialProps, children: [
    position === "left" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      icon,
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 0.5 })
    ] }),
    children,
    position === "right" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 0.5 }),
      icon
    ] })
  ] });
}
ActionButton.propTypes = {
  children: PropTypes.string,
  iconType: PropTypes.string,
  testId: PropTypes.string,
  onClick: PropTypes.func,
  position: PropTypes.oneOf(["left", "right"])
};
ActionButton.defaultProps = {
  children: null,
  iconType: "check",
  testId: "dispute-action-button",
  onClick: () => {
  },
  position: "left"
};
const ActionButton$1 = observer(ActionButton);
const attributeSection = "_attributeSection_uvf2r_1";
const inline = "_inline_uvf2r_6";
const attribute = "_attribute_uvf2r_1";
const attributeLabel = "_attributeLabel_uvf2r_14";
const inlineAttribute = "_inlineAttribute_uvf2r_22";
const leftWrap = "_leftWrap_uvf2r_31";
const s$o = {
  attributeSection,
  inline,
  attribute,
  attributeLabel,
  inlineAttribute,
  leftWrap
};
function Attribute({
  label,
  children,
  withSpacer,
  width,
  hidden,
  inline: inline2,
  noLabel,
  testId
}) {
  if (hidden || !children || !noLabel && !label)
    return null;
  const style = width && !inline2 ? {
    width
  } : {};
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style, className: classUtil(s$o.attribute, {
      [s$o.inlineAttribute]: inline2
    }), "data-testid": testId || `dispute-attribute_${label}`, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$o.attributeLabel, children: typeof label === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$o.attributeLabel, type: "h6", children: label }) : label }),
      typeof children === "string" ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children }) : children
    ] }),
    withSpacer && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
  ] });
}
Attribute.propTypes = {
  label: PropTypes.any,
  children: PropTypes.any,
  withSpacer: PropTypes.bool,
  width: PropTypes.any,
  hidden: PropTypes.bool,
  inline: PropTypes.bool,
  noLabel: PropTypes.bool,
  testId: PropTypes.string
};
Attribute.defaultProps = {
  label: null,
  children: null,
  withSpacer: true,
  width: "unset",
  hidden: false,
  inline: false,
  noLabel: false,
  testId: ""
};
const Attribute$1 = observer(Attribute);
function AttributeSection({
  label,
  children,
  hidden,
  inline: inline2
}) {
  if (hidden || !children || !label)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil(s$o.attributeSection, {
    [s$o.inline]: inline2
  }), "data-testid": `dispute-attribute-section_${label}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    children
  ] });
}
AttributeSection.propTypes = {
  label: PropTypes.any,
  children: PropTypes.any,
  hidden: PropTypes.bool,
  inline: PropTypes.bool
};
AttributeSection.defaultProps = {
  label: null,
  children: null,
  hidden: false,
  inline: false
};
observer(AttributeSection);
class AlertStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.action = "";
    this.actionHandler = () => {
    };
    this.alertType = ALERT;
    this.apiMessage = "";
    this.icon = "";
    this.message = "";
    this.modalHeading = "";
    this.type = "";
    this.visible = false;
    this.withSupportLink = false;
    this.buttonText = "";
    this.load(args);
  }
  // actions
  setAlert(message, options = {}) {
    if (!message)
      return;
    const {
      action: action2 = "",
      actionHandler = () => {
      },
      alertType = MODAL,
      apiMessage = "",
      icon,
      logMessage,
      modalHeading,
      showLog,
      withSupportLink = false,
      buttonText
    } = options;
    this.action = action2;
    this.actionHandler = actionHandler;
    this.alertType = alertType;
    this.apiMessage = apiMessage;
    this.buttonText = buttonText;
    this.message = message;
    this.modalHeading = modalHeading;
    this.type = "error";
    this.icon = icon;
    this.visible = true;
    this.withSupportLink = withSupportLink;
    if (showLog)
      this.logAlert(logMessage);
  }
  // TODO: import logger from parent app (i.e. AMC logger.js) (PS-18169)
  logAlert(logMessage) {
    switch (this.type) {
      case "error":
        console.error(`ERROR: ${logMessage || this.message}`);
        break;
      default:
        console.log(logMessage || this.message);
    }
  }
  hide() {
    this.visible = false;
    this.alertType = ALERT;
    this.modalHeading = "";
  }
  // computed
}
decorate(AlertStore, {
  // values
  action: observable,
  actionHandler: observable,
  alertType: observable,
  icon: observable,
  message: observable,
  modalHeading: observable,
  type: observable,
  visible: observable,
  // actions
  setAlert: action.bound,
  hide: action.bound,
  // helpers
  logAlert: action.bound
  // computed
});
const alertStore = new AlertStore();
const errorBlock = "_errorBlock_1hn7w_1";
const s$n = {
  errorBlock
};
const ErrorBlock = function({
  testId,
  children,
  className
}) {
  const styles2 = k$1.useMemo(() => ({
    backgroundColor: Colors.statusErrorWash,
    color: Colors.blackLighter3
  }), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("code", { style: styles2, "data-testid": testId, className: classUtil(s$n.errorBlock, className), children });
};
ErrorBlock.propTypes = {
  testId: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node
};
ErrorBlock.defaultProps = {
  testId: "alert-api-message",
  className: "",
  children: null
};
const alertText = "_alertText_aqdcl_1";
const alertHeight = "_alertHeight_aqdcl_5";
const s$m = {
  alertText,
  alertHeight
};
const SupportLink = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { testId: "support-email", inline: true, href: "mailto:support@marqeta.com", children: "Marqeta support" });
function DisputeAlert() {
  const {
    action: action2,
    actionHandler,
    alertType = ALERT,
    apiMessage,
    hide = () => {
    },
    icon = "success",
    message,
    modalHeading,
    type,
    visible,
    withSupportLink,
    buttonText
  } = alertStore || {};
  const isModal = alertType === MODAL;
  useEffect(() => {
    let timer;
    if (visible && alertType === ALERT) {
      timer = setTimeout(hide, 8e3);
    }
    return () => clearTimeout(timer);
  }, [visible, alertType, hide]);
  if (!visible || !message)
    return null;
  if (isModal) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorModal, { buttonText, heading: modalHeading || "Error", hideModal: hide, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { className: s$m.alertHeight, children: [
      apiMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(ErrorBlock, { children: apiMessage }),
      message,
      withSupportLink && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        message ? " " : "",
        "Please contact ",
        /* @__PURE__ */ jsxRuntimeExports.jsx(SupportLink, {}),
        "if you need additional support."
      ] })
    ] }) });
  }
  if (alertType === TOAST) {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ToastAlert, { action: action2, actionHandler, dismissTime: 8, icon, remove: hide, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$m.alertText, children: message }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type, children: message }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
DisputeAlert.propTypes = {};
DisputeAlert.defaultProps = {};
const DisputeAlert$1 = observer(DisputeAlert);
const ACCEPT_AND_CLOSE = "ACCEPT_AND_CLOSE";
const RESPOND_WITH_PREARB = "RESPOND_WITH_PREARB";
const RESPOND_WITH_ARB = "RESPOND_WITH_ARB";
const CLOSE_WITH_CASE_WON = "CLOSE_WITH_CASE_WON";
const REPRESENTMENT = "REPRESENTMENT";
const REPRESENTMENT_RECEIVED = "REPRESENTMENT_RECEIVED";
const RESPOND_WITH_PREARB_RESPONSE = "RESPOND_WITH_PREARB_RESPONSE";
const CLOSE_WITH_NETWORK_REJECTED = "CLOSE_WITH_NETWORK_REJECTED";
const PREARB_DECLINED = "PREARB_DECLINED";
const PREARB_ACCEPTED = "PREARB_ACCEPTED";
const ARB_DECLINED = "ARB_DECLINED";
const ARB_ACCEPTED = "ARB_ACCEPTED";
const WRITE_OFF = "WRITE_OFF";
const DISPUTE_TRANSITION_ACTIONS = {
  ACCEPT_AND_CLOSE: "ACCEPT_AND_CLOSE",
  ADJUSTMENT: "ADJUSTMENT",
  ALLOCATION_ACKNOWLEDGED: "ALLOCATION_ACKNOWLEDGED",
  CLOSE_WITH_CASE_WON: "CLOSE_WITH_CASE_WON",
  CLOSE_WITH_NETWORK_REJECTED: "CLOSE_WITH_NETWORK_REJECTED",
  PREARB_DECLINED: "PREARB_DECLINED",
  PREARB_RECEIVED: "PREARB_RECEIVED",
  PREARB_RESPONSE_DECLINED: "PREARB_RESPONSE_DECLINED",
  REPRESENTMENT_RECEIVED: "REPRESENTMENT_RECEIVED",
  RESPOND_WITH_ARB_RESPONSE: "RESPOND_WITH_ARB_RESPONSE",
  RESPOND_WITH_ARB: "RESPOND_WITH_ARB",
  RESPOND_WITH_PREARB_RESPONSE: "RESPOND_WITH_PREARB_RESPONSE",
  RESPOND_WITH_PREARB: "RESPOND_WITH_PREARB",
  SUBMIT: "SUBMIT",
  WAIT: "WAIT",
  REPRESENTMENT_EXPIRED: "REPRESENTMENT_EXPIRED",
  PREARB_ACCEPTED: "PREARB_ACCEPTED",
  PREARB_WITHDRAWN: "PREARB_WITHDRAWN",
  ARB_ACCEPTED: "ARB_ACCEPTED",
  ARB_DECLINED: "ARB_DECLINED"
};
const PREARB_WARNING_TEXT = "At this point you can decide to accept liability or submit a pre-arbitration request. Accepting liability will automatically close the case. Submitting a pre-arbitration request will continue representment of the case.";
const ARB_WARNING_TEXT = "At this point you can decide to accept liability or submit an arbitration request. Accepting liability will automatically close the case. Submitting an arbitration request will result in a final ruling from the network, there will be no further actions after the network’s decision.";
const CLOSE_WITH_WON_WARNING_TEXT = "The network has ruled this as case won in your favor. You can now accept this ruling and close the case.";
const ACCEPT_LIABILITY_WARNING_TEXT = "Accepting liability will end this case and the dispute will be automatically closed. This action will be final and there will be no reversal after this point. Are you sure you want to accept liability?";
const CLOSE_WITH_NETWORK_REJECTED_WARNING_TEXT = "Marking as network rejected will end this case and the dispute will be automatically closed. Are you sure you want to mark as network rejected?";
const ACTIONS_LABEL_MAP = {
  DISPUTE: {
    ACCEPT_AND_CLOSE: "Accept liability",
    CLOSE_WITH_CASE_WON: "Mark as won",
    RESPOND_WITH_ARB: "Submit arbitration request",
    RESPOND_WITH_PREARB_RESPONSE: "Submit pre-arbitration response",
    RESPOND_WITH_PREARB: "Submit pre-arbitration request"
  },
  LEGACY_DISPUTE: {
    [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: "Accept liability",
    [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]: "Mark as won",
    [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_NETWORK_REJECTED]: "Mark as network rejected",
    [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED]: "Add dispute response",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB]: "Add pre-arbitration request",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]: "Add pre-arbitration response",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB]: "Add arbitration request",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB_RESPONSE]: "Add arbitration response"
  }
};
const NETWORK_DETAILS_FIELD_BY_ACTION = {
  REPRESENTMENT_RECEIVED: "representment_details",
  RESPOND_WITH_PREARB: "prearbitration_details",
  RESPOND_WITH_PREARB_RESPONSE: "prearbitration_response_details",
  RESPOND_WITH_ARB: "arbitration_details"
};
const LEGACY_UPLOADABLE_ACTIONS = [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB];
const ACTION_SUBMITTED_LABEL_MAP = {
  [DISPUTES.DISPUTE]: {
    ACCEPT_AND_CLOSE: "Accepted liability",
    ARB_ACCEPTED: "Arbitration received",
    ARB_DECLINED: "Arbitration received",
    CLOSE_WITH_CASE_WON: "Case won",
    CLOSE_WITH_NETWORK_REJECTED: "Network rejected",
    PREARB_RECEIVED: "Pre-arbitration received",
    PREARB_ACCEPTED: "Pre-arbitration response received",
    PREARB_DECLINED: "Pre-arbitration response received",
    REPRESENTMENT_RECEIVED: "Dispute response received",
    RESPOND_WITH_ARB: "Arbitration request submitted",
    RESPOND_WITH_PREARB_RESPONSE: "Pre-arbitration response submitted",
    RESPOND_WITH_PREARB: "Pre-arbitration request submitted"
  },
  [DISPUTES.LEGACY_DISPUTE]: {
    [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED]: "Dispute response added",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB]: "Pre-arbitration request added",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]: "Pre-arbitration response added",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB]: "Arbitration request added",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB_RESPONSE]: "Arbitration response added",
    [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: "Accepted liability",
    [WRITE_OFF]: "Accepted liability with write off",
    [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]: "Case won",
    [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_NETWORK_REJECTED]: "Network rejected"
  }
};
const ACTION_SUBMITTED_WARNING_MAP = {
  RESPOND_WITH_PREARB: "No further action is needed at this point. After the acquirer reviews the request they will either accept the terms of the dispute or submit a pre-arbitration response.",
  RESPOND_WITH_ARB: "No further action is needed at this point. The network will review the case and provide final ruling."
};
const NETWORK_FORM_ACTIONS = {
  MASTERCARD: [RESPOND_WITH_PREARB, RESPOND_WITH_ARB, CLOSE_WITH_CASE_WON],
  VISA: [RESPOND_WITH_PREARB, RESPOND_WITH_PREARB_RESPONSE, CLOSE_WITH_CASE_WON],
  PULSE: [RESPOND_WITH_PREARB, RESPOND_WITH_PREARB_RESPONSE, CLOSE_WITH_CASE_WON]
};
const TRANSITION_LABELS = {
  DISPUTE: {
    MASTERCARD: {
      ARB_ACCEPTED: "Arbitration",
      ARB_DECLINED: "Arbitration",
      PREARB_ACCEPTED: "Pre-arbitration response",
      PREARB_DECLINED: "Pre-arbitration response",
      REPRESENTMENT_RECEIVED: "Dispute response",
      RESPOND_WITH_ARB: "Arbitration request",
      RESPOND_WITH_PREARB_RESPONSE: "Pre-arbitration response",
      RESPOND_WITH_PREARB: "Pre-arbitration request",
      CLOSE_REGE_WITH_NETWORK_REJECTED: "Network Rejected"
    },
    VISA: {
      REPRESENTMENT_RECEIVED: "Dispute response",
      RESPOND_WITH_PREARB: "Pre-arbitration request",
      PREARB_RECEIVED: "Pre-arbitration request",
      RESPOND_WITH_PREARB_RESPONSE: "Pre-arbitration response"
    },
    PULSE: {
      [DISPUTE_TRANSITION_ACTIONS.SUBMIT]: "Dispute Submitted",
      [REPRESENTMENT_RECEIVED]: "Dispute response",
      [RESPOND_WITH_PREARB]: "Pre-arbitration request",
      [DISPUTE_TRANSITION_ACTIONS.PREARB_RECEIVED]: "Pre-arbitration request",
      [RESPOND_WITH_PREARB_RESPONSE]: "Pre-arbitration response",
      [RESPOND_WITH_ARB]: "Arbitration request",
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB_RESPONSE]: "Arbitration response",
      [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_EXPIRED]: "Representment expired",
      [PREARB_ACCEPTED]: "Pre-arbitration accepted",
      [PREARB_DECLINED]: "Pre-arbitration declined",
      [DISPUTE_TRANSITION_ACTIONS.PREARB_WITHDRAWN]: "Pre-arbitration withdrawn",
      [ARB_ACCEPTED]: "Arbitration accepted",
      [ARB_DECLINED]: "Arbitration declined",
      [ACCEPT_AND_CLOSE]: "Case lost",
      [CLOSE_WITH_CASE_WON]: "Case won"
    }
  },
  LEGACY_DISPUTE: {
    [DISPUTE_TRANSITION_ACTIONS.SUBMIT]: "Dispute Submitted",
    [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED]: "Dispute response",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB]: "Pre-arbitration request",
    [DISPUTE_TRANSITION_ACTIONS.PREARB_RECEIVED]: "Pre-arbitration request",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]: "Pre-arbitration response",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB]: "Arbitration request",
    [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB_RESPONSE]: "Arbitration response",
    [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_EXPIRED]: "Representment expired",
    [DISPUTE_TRANSITION_ACTIONS.PREARB_ACCEPTED]: "Pre-arbitration accepted",
    [DISPUTE_TRANSITION_ACTIONS.PREARB_DECLINED]: "Pre-arbitration declined",
    [DISPUTE_TRANSITION_ACTIONS.PREARB_WITHDRAWN]: "Pre-arbitration withdrawn",
    [DISPUTE_TRANSITION_ACTIONS.ARB_ACCEPTED]: "Arbitration accepted",
    [DISPUTE_TRANSITION_ACTIONS.ARB_DECLINED]: "Arbitration declined",
    [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: "Case lost",
    [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]: "Case won"
  }
};
const ISSUER_ACTIONS_BY_NETWORK = {
  DISPUTE: {
    MASTERCARD: [ACCEPT_AND_CLOSE, CLOSE_WITH_CASE_WON, RESPOND_WITH_PREARB, RESPOND_WITH_ARB],
    VISA: [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE, DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON],
    PULSE: [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE, DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]
  },
  LEGACY_DISPUTE: [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE, DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON, DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB, DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]
};
const AUTOSUBMIT_FORM_ACTIONS = [CLOSE_WITH_CASE_WON];
const LEGACY_DISPUTE_TRANSITION_SEQUENCE = {
  DEFAULT: DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED,
  REPRESENTMENT_RECEIVED: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
  RESPOND_WITH_PREARB: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
  RESPOND_WITH_PREARB_RESPONSE: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB
};
const LEGACY_DISPUTE_TRANSITION_SEQUENCE_FOR_ALLOCATION = {
  DEFAULT: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
  RESPOND_WITH_PREARB: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
  PREARB_RECEIVED: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
  RESPOND_WITH_PREARB_RESPONSE: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB
};
const LAST_TRANSITION_ACTION = DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB;
const ACTION_WARNINGS_MAP = {
  DISPUTE: {
    ACCEPT_AND_CLOSE: ACCEPT_LIABILITY_WARNING_TEXT,
    RESPOND_WITH_PREARB: PREARB_WARNING_TEXT,
    RESPOND_WITH_PREARB_RESPONSE: "",
    RESPOND_WITH_ARB: ARB_WARNING_TEXT,
    CLOSE_WITH_CASE_WON: CLOSE_WITH_WON_WARNING_TEXT
  },
  LEGACY_DISPUTE: {
    ACCEPT_AND_CLOSE: ACCEPT_LIABILITY_WARNING_TEXT,
    CLOSE_WITH_WON: CLOSE_WITH_WON_WARNING_TEXT,
    CLOSE_WITH_NETWORK_REJECTED: CLOSE_WITH_NETWORK_REJECTED_WARNING_TEXT
  }
};
const CLOSE_WITH_CASE_WON_DESCRIPTION = `Marking dispute as won will automatically close the case.`;
const ACTION_DESCRIPTION_MAP = {
  LEGACY_DISPUTE: {
    CLOSE_WITH_CASE_WON: CLOSE_WITH_CASE_WON_DESCRIPTION
  },
  DISPUTE: {}
};
const PULSE_DETAILS_MAP_KEYS = [[RESPOND_WITH_PREARB, ["memo"]], [REPRESENTMENT_RECEIVED, ["memo"]], [RESPOND_WITH_PREARB_RESPONSE, ["memo"]]];
const MASTERCARD_DETAILS_MAP_KEYS = [[REPRESENTMENT_RECEIVED, ["reason_code", "member_message_text"]], [RESPOND_WITH_PREARB, ["amount", "filing_ica", "filed_against_ica", "network_memo", "memo", "case_filing_status"]], [RESPOND_WITH_PREARB_RESPONSE, ["case_filing_status"]], [RESPOND_WITH_ARB, ["case_filing_status", "memo"]], [PREARB_DECLINED, ["case_filing_status"]], [PREARB_ACCEPTED, ["case_filing_status"]], [ARB_DECLINED, ["case_filing_status"]], [ARB_ACCEPTED, ["case_filing_status"]]];
const VISA_ALLOCATION_KEYS = [[DISPUTE_TRANSITION_ACTIONS.PREARB_RECEIVED, ["disputeAmount", "formattedIpAddress", "formattedEmailAddress", "formattedPhysicalAddress", "formattedPhoneNumber", "formattedCustomerLogin", "formattedDeviceIdFingerprint"]], [RESPOND_WITH_PREARB_RESPONSE, ["formattedPreArbResponseDecision", "partial_acceptance_amount", "why_are_you_not_accepting_liability", "formattedCardholderContinuesDisputes", "explanation_cardholder_continues_dispute", "formattedCardholderDetailsDontMatch", "explanation_continuing_the_dispute", "merchandise_or_services", "merchandise_or_services_desc", "formattedShippingDeliveryStatus", "merchandise_or_services_provided_date", "formatDisputedTransactionTableProps", "formatUndisputedTransactionsTableProps"]]];
const VISA_COLLABORATION_KEYS = [[RESPOND_WITH_PREARB, ["amount", "why_are_you_initiating_prearbitration"]], [REPRESENTMENT_RECEIVED, ["disputeAmount"]], [RESPOND_WITH_PREARB_RESPONSE, []]];
const ACTION_ICONS = /* @__PURE__ */ new Map([[ACCEPT_AND_CLOSE, "minus16"], [CLOSE_WITH_CASE_WON, "confirmed"], [CLOSE_WITH_NETWORK_REJECTED, "clear"]]);
const MASTERCARD_DETAILS_MAP = new Map(MASTERCARD_DETAILS_MAP_KEYS);
const IGNORED_ACTIONS = [ACCEPT_AND_CLOSE, CLOSE_WITH_CASE_WON, CLOSE_WITH_NETWORK_REJECTED];
const MASTERCARD_LABELS_MAP = /* @__PURE__ */ new Map([["reason_code", "Reason code"], ["member_message_text", "Member message text"], ["filing_ica", "Filing ICA"], ["filed_against_ica", "Filing against ICA"], ["network_memo", "Explanation"], ["memo", "Internal note"], ["case_filing_status", "Status"]]);
const PULSE_LABELS_MAP = /* @__PURE__ */ new Map([["reason_code", "Reason code"], ["member_message_text", "Member message text"], ["network_memo", "Explanation"], ["memo", "Internal note"], ["case_filing_status", "Status"]]);
const VISA_LABELS_MAP = /* @__PURE__ */ new Map([["formattedPreArbResponseDecision", "Prearbitration response decision"], ["partial_acceptance_amount", "Partial acceptance amount"], ["partial_acceptance_amount_decline", "Amount"], ["why_are_you_not_accepting_liability", "Why are you not accepting liability"], ["why_are_you_initiating_prearbitration", "Why are you initiating prearbitration"], ["formattedCardholderContinuesDisputes", "Cardholder continues dispute"], ["explanation_cardholder_continues_dispute", "Explanation of why cardholder continues dispute"], ["formattedCardholderDetailsDontMatch", "Cardholder details do not match issuer records"], ["explanation_continuing_the_dispute", "Explanation of why you continue the dispute"], ["disputeAmount", "Dispute amount"], ["member_message_text", "Member message text"], ["case_filing_status", "Status"], ["merchandise_or_services", "What was provided"], ["merchandise_or_services_desc", "Description of merchandise"], ["formattedShippingDeliveryStatus", "Shipping delivery status"], ["merchandise_or_services_provided_date", "Date delivered/picked up by cardholder"], ["formatDisputedTransactionTableProps", "Disputed transaction info"], ["formatUndisputedTransactionsTableProps", "Undisputed transactions info"], ["formattedIpAddress", "IP address"], ["formattedEmailAddress", "Email address"], ["formattedPhysicalAddress", "Physical address"], ["formattedPhoneNumber", "Phone number"], ["formattedCustomerLogin", "Customer login ID"], ["formattedDeviceIdFingerprint", "Device ID/fingerprint "]]);
const MASTERCARD_PREARB_VALIDATION = {
  amount: {
    label: "Amount",
    formatValidations: [isValidMoneyAmount, "Amount is not the correct format."]
  },
  filed_against_ica: {
    label: "Field against ICA",
    formatValidations: [isValidFilingIca, "Filing against ICA must be an integer between 1 - 11 digits."]
  },
  filing_ica: {
    label: "Filing ICA",
    formatValidations: [isValidFilingIca, "Filing ICA must be an integer between 1 - 11 digits."]
  },
  network_memo: {
    label: "Explanation",
    formatValidations: [isValidNetworkMemo, "Explanation must be less than 1500 characters."]
  }
};
const NETWORK_MEMO_TOOLTIP = "Provide explanation for pre-arbitration";
const MEMO_TOOLTIP = "This message is for internal purposes only and will not be sent to the network";
const WRITE_OFF_TOOLTIP = "A write off  will credit the dispute amount from your funding account to the cardholder";
const WRITE_OFF_LABEL = "Do you want to write off this dispute?";
const WRITE_OFF_TEXT = "WITH WRITE OFF";
const RADIO_GROUP_ITEMS = [{
  label: "Yes",
  value: true
}, {
  label: "No",
  value: false
}];
const FULL_AMOUNT = "FULL_AMOUNT";
const OTHER_AMOUNT = "OTHER_AMOUNT";
const DISPUTE_AMOUNT_DEFAULT_LABELS = {
  fullLabel: "Full dispute amount",
  otherLabel: "Other amount"
};
const LEGACY_DEFAULT_DISPUTE_TRANSITION_ACTIONS = [ACCEPT_AND_CLOSE, CLOSE_WITH_CASE_WON, CLOSE_WITH_NETWORK_REJECTED];
const LEGACY_REPRESENTMENT_DISPUTE_TRANSITION_ACTIONS = [ACCEPT_AND_CLOSE, CLOSE_WITH_CASE_WON, CLOSE_WITH_NETWORK_REJECTED];
const WHY_ARE_YOU_NOT_ACCEPTING_FULL_LIABILITY = "Why are you not accepting full liability";
const ISSUER_CERTIFIES_THAT_THEY_HAVE_CONTACTED = `Issuer certifies that they have contacted their cardholder and reviewed the compelling evidence 
with them and cardholder continues to dispute`;
const ISSUER_CERTIFIES_THAT_THE_CARDHOLDER_NAME_AND_ADDRESS = `Issuer certifies that the cardholder name and address provided by the acquirer does not match 
the issuer's records`;
const EXPLANATION_OF_WHY_THE_CARDHOLDER_CONTINUES_DISPUTE = "Explanation of why the cardholder continues the dispute";
const EXPLANATION_OF_WHY_YOU_CONTINUE_DISPUTE = "Explanation of why you are continuing the dispute";
const WHY_ARE_YOU_INIT_PRE_ARB = "Why are you initiating pre-arbitration? (Please provide supporting evidence)";
const PREARB_RESPONSE_DECISIONS = {
  ACCEPT_PARTIAL_LIABILITY: "ACCEPT_PARTIAL",
  DECLINE: "DECLINE"
};
const PREARB_RESPONSE_DECISIONS_LABELS = {
  ACCEPT_PARTIAL: "Accept partial",
  DECLINE: "Decline"
};
const FIELD_IS_REQUIRED = "Field is required.";
const AMOUNT_LABELS = {
  fullLabel: "Decline",
  otherLabel: "Partial"
};
const formRadioInput$1 = "_formRadioInput_phrt6_1";
const s$l = {
  formRadioInput: formRadioInput$1
};
function DisputeAmount(props) {
  const {
    disputeAmount,
    disputeAmountError,
    isOtherAmount,
    onAmountGroupChange,
    onOtherAmountChange,
    otherAmount,
    labels,
    currencyCode
  } = props;
  const amountFieldWidth = 512;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Dispute amount" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: !isOtherAmount, onClick: () => onAmountGroupChange(FULL_AMOUNT), testId: "legacy-full-dispute-amount", children: labels?.fullLabel }),
    !isOtherAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$l.formRadioInput, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.5 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { testId: "full-amount-input", width: amountFieldWidth, value: disputeAmount, disabled: true, rightAddOn: {
        content: currencyCode || "USD"
      } })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: isOtherAmount, onClick: () => onAmountGroupChange(OTHER_AMOUNT), testId: "legacy-other-dispute-amount", children: labels?.otherLabel }),
    isOtherAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$l.formRadioInput, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.5 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: otherAmount, width: amountFieldWidth, testId: "other-amount-input", onChange: (e) => onOtherAmountChange(e.target.value), rightAddOn: {
        content: currencyCode || "USD"
      }, error: disputeAmountError }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] })
  ] });
}
DisputeAmount.propTypes = {
  disputeAmount: PropTypes.number,
  disputeAmountError: PropTypes.string,
  isOtherAmount: PropTypes.bool,
  onAmountGroupChange: PropTypes.func,
  onOtherAmountChange: PropTypes.func,
  otherAmount: PropTypes.string,
  labels: PropTypes.object,
  currencyCode: PropTypes.string
};
DisputeAmount.defaultProps = {
  disputeAmount: 0,
  disputeAmountError: "",
  isOtherAmount: false,
  onAmountGroupChange: () => {
  },
  onOtherAmountChange: () => {
  },
  otherAmount: "",
  labels: null
};
const DisputeAmount$1 = observer(DisputeAmount);
function EditNetworkCaseNumberModal({
  onSubmit,
  hide,
  networkCaseInput,
  handleNetworkCaseInputChange,
  errorText
}) {
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "edit-network-case-id-button", onClick: onSubmit, children: "Save" }, "edit-network-case-id-button")];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { type: "lg", heading: "Edit network case ID", description: "Enter the case ID provided by the network", hideModalButtonText: "Cancel", hideModal: hide, showHideModalButton: true, footerButtons, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Network case ID", value: networkCaseInput, onChange: (e) => handleNetworkCaseInputChange(e.target.value), width: 540, maxLength: 36, error: errorText }) });
}
EditNetworkCaseNumberModal.propTypes = {
  onSubmit: PropTypes.func,
  networkCaseInput: PropTypes.string,
  handleNetworkCaseInputChange: PropTypes.func,
  hide: PropTypes.func,
  errorText: PropTypes.string
};
EditNetworkCaseNumberModal.defaultProps = {
  onSubmit: () => {
  },
  networkCaseInput: "",
  handleNetworkCaseInputChange: () => {
  },
  hide: () => {
  },
  errorText: ""
};
const editButton = "_editButton_b6byv_1";
const s$k = {
  editButton
};
function LabelWithEditButton({
  text,
  showEditModal,
  isEditable
}) {
  if (!text)
    return null;
  const testId = text.split(/\s+/g).join("-").toLowerCase().concat("-link-id");
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { type: "h6", inline: true, children: [
    text,
    " ",
    isEditable && /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { testId, type: "primary", onClick: showEditModal, className: s$k.editButton, children: "Edit" })
  ] });
}
LabelWithEditButton.propTypes = {
  text: PropTypes.string,
  showEditModal: PropTypes.func,
  isEditable: PropTypes.bool
};
LabelWithEditButton.defaultProps = {
  text: "",
  showEditModal: () => {
  },
  isEditable: false
};
function LabelWithTooltip({
  text,
  tooltip,
  direction
}) {
  if (!text)
    return null;
  const iconStyle = {
    verticalAlign: "middle"
  };
  return tooltip ? /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { type: "h6", inline: true, children: [
    text,
    " ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { content: tooltip, direction, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { noHoverEffects: true, type: "info", style: iconStyle }) })
  ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: text });
}
LabelWithTooltip.propTypes = {
  text: PropTypes.string,
  tooltip: PropTypes.string,
  direction: PropTypes.string
};
LabelWithTooltip.defaultProps = {
  text: null,
  tooltip: null
};
const LabelWithTooltip$1 = observer(LabelWithTooltip);
function ResourceLink({
  name,
  token,
  goTo
}) {
  const content2 = name || token;
  const link = goTo instanceof Function ? /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: () => goTo(token), className: s$o.leftWrap, children: content2 }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { testId: `ResourceLink_${content2}`, children: content2 });
  return name ? link : /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { overrideValue: token, tooltipDirection: "topLeft", children: link });
}
ResourceLink.propTypes = {
  name: PropTypes.string,
  token: PropTypes.string,
  goTo: PropTypes.func
};
ResourceLink.defaultProps = {
  name: null,
  token: null,
  goTo: null
};
const ResourceLink$1 = observer(ResourceLink);
const stickyOverlay = "_stickyOverlay_116cn_1";
const sticky = "_sticky_116cn_1";
const activeOverlay = "_activeOverlay_116cn_23";
const activeSticky = "_activeSticky_116cn_27";
const s$j = {
  stickyOverlay,
  sticky,
  activeOverlay,
  activeSticky
};
function StickyLoadingOverlay({
  active,
  children
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil(s$j.stickyOverlay, {
    [s$j.activeOverlay]: active
  }), children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classUtil(s$j.sticky, {
      [s$j.activeSticky]: active
    }), children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active }) }),
    children
  ] });
}
StickyLoadingOverlay.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node
};
StickyLoadingOverlay.defaultProps = {
  active: false,
  children: null
};
function EditModal({
  onSubmit,
  hide,
  modelInputValue,
  handleInputChange,
  errorText,
  modelHeading,
  modelDescription,
  modelInputLabel
}) {
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "edit-model-button-id", onClick: onSubmit, children: "Save" }, "edit-model-button-id")];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { type: "lg", heading: modelHeading, description: modelDescription, hideModalButtonText: "Cancel", hideModal: hide, showHideModalButton: true, footerButtons, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: modelInputLabel, value: modelInputValue, onChange: (e) => handleInputChange(e.target.value), width: 540, maxLength: 36, error: errorText }) });
}
EditModal.propTypes = {
  onSubmit: PropTypes.func,
  modelInputValue: PropTypes.string,
  handleInputChange: PropTypes.func,
  modelHeading: PropTypes.string,
  modelDescription: PropTypes.string,
  modelInputLabel: PropTypes.string,
  hide: PropTypes.func,
  errorText: PropTypes.string
};
EditModal.defaultProps = {
  onSubmit: () => {
  },
  modelInputValue: "",
  handleInputChange: () => {
  },
  modelHeading: "",
  modelDescription: "",
  modelInputLabel: "",
  hide: () => {
  },
  errorText: ""
};
function DocumentModal({
  transitionToReady,
  hide,
  loading
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { type: "sm", heading: "This may require documentation", buttonText: "Mark as ready", hideModalButtonText: "Cancel", hideModal: hide, showHideModalButton: true, footerButtons: [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "mark-as-ready-modal-button", onClick: transitionToReady, disabled: loading, children: "Mark as ready" }, "mark-as-ready-modal-button")], children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "If this case is submitted without the required" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "documentation, the case could be lost." })
  ] });
}
DocumentModal.propTypes = {
  transitionToReady: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
  loading: PropTypes.bool
};
DocumentModal.defaultProps = {
  transitionToReady: () => {
  },
  hide: () => {
  },
  loading: false
};
const REASONS_TO_SHOW_MODAL = ["CANCELLED_MERCHANDISE_OR_SERVICES", "CANCELLED_RECURRING_TRANSACTION", "CREDIT_NOT_PROCESSED", "INCORRECT_ACCOUNT_NUMBER", "INCORRECT_CURRENCY", "INCORRECT_TRANSACTION_AMOUNT", "INCORRECT_TRANSACTION_CODE", "LATE_PRESENTMENT", "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM", "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE", "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED", "COUNTERFEIT_MERCH", "INVALID_DATA", "MISREPRESENTATION", "ORIGINAL_CREDIT_NOT_ACCEPTED"];
const useModalHandler = (dispute) => {
  const {
    dispute_details = {},
    documents: documents2 = {},
    isLegacyDisputeType,
    isMastercard = false,
    isVisa = false
  } = dispute || {};
  const isVisaModalVisible = documents2?.count === 0 && isVisa && REASONS_TO_SHOW_MODAL.includes(dispute_details?.dispute_reason);
  const isMCModalVisible = documents2?.count === 0 && isMastercard;
  const isModalVisible = isVisaModalVisible || isMCModalVisible;
  return {
    isModalVisible: isModalVisible && !isLegacyDisputeType
  };
};
const detailsCard = "_detailsCard_ktnow_1";
const withViewProfile = "_withViewProfile_ktnow_6";
const viewProfile = "_viewProfile_ktnow_10";
const styles$9 = {
  detailsCard,
  withViewProfile,
  viewProfile
};
function CardholderDetailsCard({
  cardholder,
  goTo
}) {
  const {
    fullName,
    token,
    address1,
    phone,
    email
  } = cardholder || {};
  const {
    first_name,
    last_name,
    ...partialCardholder
  } = cardholder || {};
  const showViewProfile = goTo instanceof Function;
  if (!showViewProfile && !address1)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil(styles$9.detailsCard, {
      [styles$9.withViewProfile]: showViewProfile
    }), children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: fullName || token }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Address", hidden: !address1, inline: true, withSpacer: false, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Address, { ...partialCardholder }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Email", inline: true, withSpacer: false, children: email }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Phone number", inline: true, withSpacer: false, children: phone })
    ] }),
    showViewProfile && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$9.viewProfile, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: () => goTo("User", token), children: "View profile" }) })
  ] });
}
CardholderDetailsCard.propTypes = {
  cardholder: PropTypes.any,
  goTo: PropTypes.func
};
CardholderDetailsCard.defaultProps = {
  cardholder: null,
  goTo: null
};
const CardholderDetailsCard$1 = observer(CardholderDetailsCard);
const copyToClipboard$1 = "_copyToClipboard_1wwls_1";
const styles$8 = {
  copyToClipboard: copyToClipboard$1
};
const CARD_LAST_FOUR_DIGITS = "Card last four digits";
const TRANSACTION_TYPE = "Transaction type";
function TransactionDisputeDetails({
  cardholder,
  goTo,
  parentCardholder,
  transaction
}) {
  const {
    token: cardholderToken,
    fullName
  } = cardholder || {};
  const {
    token: parentCardholderToken,
    fullName: parentFullName
  } = parentCardholder || {};
  const {
    clearingDetailsMap = /* @__PURE__ */ new Map(),
    token,
    business,
    card_acceptor,
    card_token,
    issuing_country,
    issuing_country_set
  } = transaction || {};
  const {
    name,
    address,
    street_address,
    formattedMccList,
    hasMccs
  } = card_acceptor || {};
  const cardAcceptorAddress = address || street_address;
  const {
    token: businessToken
  } = business || {};
  const lastFour = clearingDetailsMap.get(CARD_LAST_FOUR_DIGITS);
  const transactionType = clearingDetailsMap.get(TRANSACTION_TYPE);
  const handleLastFourClick = (token2) => goTo("/program/card", token2, {
    tab: "Card details"
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "dispute-transaction-details-accordion-section", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Business", hidden: !businessToken, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { name: business?.business_name_legal || business?.business_name_dba, token: businessToken, goTo: (token2) => goTo("Business", token2) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Parent cardholder", hidden: !(parentCardholderToken || parentFullName), children: /* @__PURE__ */ jsxRuntimeExports.jsx(HoverCard, { body: /* @__PURE__ */ jsxRuntimeExports.jsx(CardholderDetailsCard$1, { cardholder: parentCardholder, goTo }), fixedDirection: "right", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { name: parentFullName, token: parentCardholderToken, goTo: (token2) => goTo("User", token2) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Cardholder", hidden: !(fullName || cardholderToken), children: /* @__PURE__ */ jsxRuntimeExports.jsx(HoverCard, { body: /* @__PURE__ */ jsxRuntimeExports.jsx(CardholderDetailsCard$1, { cardholder, goTo }), fixedDirection: "right", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$8.copyToClipboard, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { name: fullName, token: cardholderToken, goTo: (token2) => goTo("User", token2) }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Transaction token", hidden: !token, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$8.copyToClipboard, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { fixOverflow: true, overrideValue: token, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { name: token, token }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: TRANSACTION_TYPE, hidden: isNotPresent(transactionType), children: transactionType }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: CARD_LAST_FOUR_DIGITS, hidden: isNotPresent(lastFour), children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { goTo: handleLastFourClick, name: lastFour, token: card_token }) }),
    Boolean(clearingDetailsMap.size) && Array.from(clearingDetailsMap.entries()).map(([key, val]) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: key, hidden: isNotPresent(val) || [CARD_LAST_FOUR_DIGITS, TRANSACTION_TYPE].includes(key), children: val }, key)),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Attribute$1, { label: "Merchant", hidden: !name && !cardAcceptorAddress, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: name }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Address, { ...card_acceptor, address1: cardAcceptorAddress, renderWithoutAddress: true })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Merchant category code", hidden: !hasMccs, children: formattedMccList }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Issuer jurisdiction", hidden: !(issuing_country || issuing_country_set), children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: issuing_country === "loading", size: 16, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: issuing_country, width: 240, onChange: (e) => transaction.setAttr("issuing_country", e.target.value), rightAddOn: {
      content: transaction.issuerJurisdiction
    } }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Attribute$1, { label: "Transaction jurisdiction", hidden: !(issuing_country || issuing_country_set), children: [
      transaction?.card_acceptor?.country_code,
      " - ",
      transaction.transactionJurisdiction
    ] })
  ] });
}
TransactionDisputeDetails.propTypes = {
  transaction: PropTypes.object,
  cardholder: PropTypes.object,
  parentCardholder: PropTypes.object,
  goTo: PropTypes.func
};
TransactionDisputeDetails.defaultProps = {
  transaction: {},
  cardholder: {},
  parentCardholder: {},
  goTo: () => {
  }
};
const TransactionDisputeDetails$1 = observer(TransactionDisputeDetails);
function AuxDisputeDetails({
  dispute,
  goTo
}) {
  const {
    transaction,
    cardholder,
    parentCardholder,
    dispute_details
  } = dispute || {};
  const {
    related_authorization
  } = transaction || {};
  const {
    partial_dispute_resolution
  } = dispute_details || {};
  const {
    hasContent: hasPartialContent,
    partialAmountDetails = {}
  } = partial_dispute_resolution || {};
  const {
    card_acceptor: authCardAcceptor,
    pos
  } = related_authorization || {};
  const {
    poi: authPoi
  } = authCardAcceptor || {};
  const {
    poiDetails = {},
    hasContent
  } = authPoi || {};
  const {
    posDetails = {},
    hasPosContent
  } = pos || {};
  const sections = useMemo(() => {
    return [{
      title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Transaction details" }),
      key: "transaction_details",
      defaultExpanded: true,
      content: /* @__PURE__ */ jsxRuntimeExports.jsx(TransactionDisputeDetails$1, { cardholder, goTo, parentCardholder, transaction })
    }];
  }, [transaction, cardholder, parentCardholder, goTo]);
  const poiSection = useMemo(() => ({
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Point of Interaction details" }),
    key: "poi_details",
    content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Object.keys(poiDetails).map((detailLabel, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: detailLabel, hidden: isNotPresent(poiDetails[detailLabel]), withSpacer: true, children: poiDetails[detailLabel]?.toString() }, `${detailLabel}${i}`)) })
  }), [poiDetails]);
  const posSection = useMemo(() => ({
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Point of Sale details" }),
    key: "pos_details",
    content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Object.keys(posDetails).map((detailLabel, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: detailLabel, hidden: isNotPresent(posDetails[detailLabel]), withSpacer: true, children: posDetails[detailLabel]?.toString() }, `${detailLabel}${i}`)) })
  }), [posDetails]);
  const partialDisputeResolutionSection = useMemo(() => ({
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Partial dispute details" }),
    key: "partial_details",
    defaultExpanded: true,
    content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: Object.keys(partialAmountDetails).map((detailLabel, i) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: detailLabel, hidden: isNotPresent(partialAmountDetails[detailLabel]), withSpacer: true, children: partialAmountDetails[detailLabel]?.toString() }, `${detailLabel}${i}`)) })
  }), [partialAmountDetails]);
  if (hasContent) {
    sections.push(poiSection);
  }
  if (hasPosContent) {
    sections.push(posSection);
  }
  if (hasPartialContent) {
    sections.push(partialDisputeResolutionSection);
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { testId: "auxDetails", width: "332px", sections, spaceBetween: "16px" });
}
AuxDisputeDetails.propTypes = {
  dispute: PropTypes.any,
  goTo: PropTypes.func
};
AuxDisputeDetails.defaultProps = {
  dispute: null,
  goTo: null
};
const AuxDisputeDetails$1 = observer(AuxDisputeDetails);
const content = "_content_m8tuc_1";
const disputeTransitionsContainer = "_disputeTransitionsContainer_m8tuc_5";
const styles$7 = {
  content,
  disputeTransitionsContainer
};
const disputeDetailsHeader = "_disputeDetailsHeader_1arc1_1";
const displayInlineFlex = "_displayInlineFlex_1arc1_6";
const displayCenteredInlineFlex = "_displayCenteredInlineFlex_1arc1_10";
const auxDisputeDetails = "_auxDisputeDetails_1arc1_15";
const atrRequired = "_atrRequired_1arc1_19";
const detailsCardBody = "_detailsCardBody_1arc1_27";
const disputeDetailsBody = "_disputeDetailsBody_1arc1_35";
const hiddenDisplay = "_hiddenDisplay_1arc1_41";
const auxDetailsContainer = "_auxDetailsContainer_1arc1_45";
const fullWidth$1 = "_fullWidth_1arc1_49";
const milestoneBannerAlert = "_milestoneBannerAlert_1arc1_53";
const networkDetailsItem = "_networkDetailsItem_1arc1_57";
const dds = {
  disputeDetailsHeader,
  displayInlineFlex,
  displayCenteredInlineFlex,
  auxDisputeDetails,
  atrRequired,
  detailsCardBody,
  disputeDetailsBody,
  hiddenDisplay,
  auxDetailsContainer,
  fullWidth: fullWidth$1,
  milestoneBannerAlert,
  networkDetailsItem
};
const CONTAINER_STYLE = {
  borderColor: Colors.blackLighter6
};
function NetworkDisputeTransitionsContainer({
  dispute,
  goTo
}) {
  const {
    dispute_details,
    dispute_transitions,
    documents: documents2,
    type,
    transaction,
    disputesAccess,
    disputeFileManager
  } = dispute || EMPTY_OBJECT;
  const {
    newDisputeTransitionStore
  } = dispute_transitions || EMPTY_OBJECT;
  const {
    action: action2,
    setAttr = () => {
    },
    withWriteOff
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    isRegE
  } = dispute_details || EMPTY_OBJECT;
  const {
    loading
  } = dispute_transitions || EMPTY_OBJECT;
  const {
    currency_code
  } = transaction || EMPTY_OBJECT;
  const setWriteOff = useCallback((value) => setAttr("withWriteOff", value), [setAttr]);
  const additionalSlots = {
    [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: isRegE ? /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledContent, { tooltip: WRITE_OFF_TOOLTIP, flexDirection: "column", label: WRITE_OFF_LABEL, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { groupItems: RADIO_GROUP_ITEMS, onChange: setWriteOff, value: withWriteOff }) }) : null
  };
  const {
    isAttachAvailable
  } = disputeFileManager || EMPTY_OBJECT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dds.disputeDetailsBody, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$7.content, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: CONTAINER_STYLE, className: styles$7.disputeTransitionsContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { size: 32, active: loading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionContainer$2, { additionalSlot: additionalSlots[action2], disputesAccess, disputeTransitions: dispute_transitions, documents: documents2, type, isRegE, isAttachAvailable, currencyCode: currency_code }) }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(AuxDisputeDetails$1, { dispute, goTo })
  ] });
}
NetworkDisputeTransitionsContainer.propTypes = {
  dispute: PropTypes.object,
  goTo: PropTypes.func
};
NetworkDisputeTransitionsContainer.defaultProps = {
  dispute: {},
  goTo: () => {
  }
};
const NetworkDisputeTransitionsContainer$1 = observer(NetworkDisputeTransitionsContainer);
const smallMarginRight = "_smallMarginRight_1lzkd_1";
const xsmallMarginLeft = "_xsmallMarginLeft_1lzkd_5";
const textAlignCenter = "_textAlignCenter_1lzkd_9";
const globalStyles = {
  smallMarginRight,
  xsmallMarginLeft,
  textAlignCenter
};
function ActionResponseSection({
  isResponseFormVisible,
  description,
  responseForm,
  children
}) {
  if (!children)
    return null;
  const noIcon = isResponseFormVisible || !description;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { noIcon, children: [
    isResponseFormVisible && responseForm,
    !isResponseFormVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      isPresent(description) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classUtil(globalStyles.smallMarginRight, globalStyles.xsmallMarginLeft), children: description }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "inline-flex", children })
    ] })
  ] });
}
ActionResponseSection.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isResponseFormVisible: PropTypes.bool.isRequired,
  responseForm: PropTypes.node
};
ActionResponseSection.defaultProps = {
  description: "",
  children: null,
  isResponseFormVisible: false,
  responseForm: null
};
const menuOption$1 = "_menuOption_12lrx_1";
const menuOptionWrapper$1 = "_menuOptionWrapper_12lrx_7";
const styles$6 = {
  menuOption: menuOption$1,
  menuOptionWrapper: menuOptionWrapper$1
};
const TransitionActions = (props) => {
  const {
    actions: actions2,
    disputeType,
    onShowActionForm,
    nextAction
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    nextAction && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { iconType: "edit", onClick: onShowActionForm, testId: `${ACTIONS_LABEL_MAP.LEGACY_DISPUTE[nextAction]}-open-button`, children: ACTIONS_LABEL_MAP.LEGACY_DISPUTE[nextAction] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {})
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RawDropdown, { contentPadding: 0, control: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { testId: "transition-legacy-dispute-action-button", iconType: "caret-down", position: "right", children: "Transition dispute" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: Object.entries(actions2).map(([key, action2]) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: styles$6.menuOptionWrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { className: styles$6.menuOption, iconType: ACTION_ICONS.get(key), onClick: action2, children: ACTIONS_LABEL_MAP[disputeType][key] }) }, key)) }) })
  ] });
};
TransitionActions.propTypes = {
  actions: PropTypes.object,
  disputeType: PropTypes.oneOf([DISPUTES.DISPUTE, DISPUTES.LEGACY_DISPUTE]),
  nextAction: PropTypes.string,
  onShowActionForm: PropTypes.func
};
TransitionActions.defaultProps = {
  actions: {},
  disputeType: DISPUTES.DISPUTE,
  nextAction: "",
  onShowActionForm: () => {
  }
};
function TransitionModal({
  action: action2,
  additionalSlot,
  disputeType,
  hideModal,
  memo,
  onSubmit,
  setMemo
}) {
  const alert = ACTION_WARNINGS_MAP[disputeType][action2];
  const label = ACTIONS_LABEL_MAP[disputeType][action2];
  const description = ACTION_DESCRIPTION_MAP[disputeType][action2];
  const footerButtons = useMemo(() => [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: onSubmit, children: label }, 1)], [label, onSubmit]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { description, disableOverFlow: true, footerButtons, heading: label, hideModal, children: [
    alert && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: globalStyles.xsmallMarginLeft, children: alert }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    additionalSlot && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      additionalSlot,
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: "Note", value: memo, onChange: setMemo, rows: 2, labelOptional: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.5 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
      fontWeight: "bold",
      color: memo.length > 1024 ? "red" : "inherit"
    }, children: [
      1024 - (memo ? memo.length : 0),
      "/1024"
    ] })
  ] });
}
TransitionModal.propTypes = {
  action: PropTypes.oneOf(Object.keys(DISPUTE_TRANSITION_ACTIONS)),
  additionalSlot: PropTypes.node,
  disputeType: PropTypes.oneOf([DISPUTES.DISPUTE, DISPUTES.LEGACY_DISPUTE]),
  hideModal: PropTypes.func,
  memo: PropTypes.string,
  onSubmit: PropTypes.func,
  setMemo: PropTypes.func
};
TransitionModal.defaultProps = {
  additionalSlot: null,
  disputeType: DISPUTES.DISPUTE,
  hideModal: () => {
  },
  memo: "",
  onSubmit: () => {
  },
  setMemo: () => {
  }
};
const TransitionModal$1 = observer(TransitionModal);
const LABELS$2 = {
  ATTACH_TO_FORM: "Attach to form",
  DELETE_FROM_CASE: "Delete from case",
  DETACH_FROM_FORM: "Detach from form",
  DOWNLOAD: "Download",
  EMPTY_STATE_SUB_TEXT: "Please click button below to upload files from your computer.",
  EMPTY_STATE_TEXT: "No file uploaded yet",
  FILE_MANAGEMENT: "File management",
  MANAGE_FILES: "Manage files",
  RETRIEVE_NETWORK_DOCUMENTS: "Retrieve Network Document(s)",
  UPLOAD_FROM_COMPUTER: "Upload from computer",
  VIEW_DETAILS: "View details"
};
const LABELS$1 = {
  NEWEST: "Newest",
  OLDEST: "Oldest",
  PLACEHOLDER: "Select option",
  SORT_BY: "Sort by:"
};
const WIDTH$1 = 128;
const DateSorter = ({
  onChange,
  value,
  width
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", flexDirection: "row", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: LABELS$1.SORT_BY }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 1 }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { value, onChange, width, placeholder: LABELS$1.PLACEHOLDER, options: [LABELS$1.NEWEST, LABELS$1.OLDEST] })
] });
DateSorter.propTypes = {
  onChange: PropTypes$1.func.isRequired,
  value: PropTypes$1.string,
  width: PropTypes$1.number
};
DateSorter.defaultProps = {
  value: "",
  width: WIDTH$1
};
const FILE_TYPES = {
  JPEG: "image/jpeg",
  PDF: "application/pdf",
  TIFF: "image/tiff",
  ZIP: "application/zip"
};
const FILE_EXTENSION_MAP = {
  "image/jpeg": "jpeg",
  "application/pdf": "pdf",
  "image/tiff": "tiff",
  "application/zip": "zip"
};
const FILE_TYPE_ICON_MAP = {
  [FILE_TYPES.PDF]: "file-pdf",
  [FILE_TYPES.JPEG]: "file-jpeg",
  [FILE_TYPES.TIFF]: "file-tiff",
  [FILE_TYPES.ZIP]: "file-zip"
};
const SUBMITTED_MESSAGE = {
  LAST_SUBMITTED_ON: "Last submitted on",
  NO_NETWORK_SUBMISSION_RECORD: "No network submission record"
};
class DocumentStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.token = "";
    this.document_category = "";
    this.document_name = "";
    this.case_token = "";
    this.document_content_type = "";
    this.network_process_type = "";
    this.network_process_phase = "";
    this.network_process_time = "";
    this.created_time = "";
    this.last_modified_time = "";
    this.download_link = "";
    this.load(args);
  }
  // Computeds
  get formattedCreatedTime() {
    return formatUTCMoment(this.created_time);
  }
  get formattedLastModifiedTime() {
    const isLegacy = this.constructedBy?.constructedBy?.isLegacyDisputeType;
    const associatedTo = this.constructedBy?.constructedBy?.disputeFileManager?.getAssociatedTo(this);
    const shouldShowDate = isLegacy ? associatedTo : isPresent(this.network_process_phase);
    return shouldShowDate ? formatUTCMoment(this.last_modified_time) : "";
  }
  get formattedDocumentExtension() {
    try {
      return FILE_EXTENSION_MAP[this.document_content_type];
    } catch (e) {
      return "";
    }
  }
  get extensionWithDot() {
    return this.formattedDocumentExtension ? `.${this.formattedDocumentExtension}` : "";
  }
  get formattedDocumentName() {
    return this.document_name.replace(this.extensionWithDot, "");
  }
  get isAttached() {
    return this.constructedBy?.constructedBy?.disputeFileManager?.isAttached(this) || false;
  }
  get isPreviouslyAttached() {
    return this.constructedBy?.constructedBy?.allPreviouslyAttachedFiles.has(this.token);
  }
  get isSelected() {
    return this.constructedBy?.constructedBy?.disputeFileManager?.isSelected(this);
  }
  get submittedBy() {
    if (!this.network_process_phase) {
      return "";
    }
    return this.constructedBy?.constructedBy?.disputeFileManager?.getSubmittedBy(this);
  }
  get associatedTo() {
    return sentenceCase(this.constructedBy?.constructedBy?.disputeFileManager?.getAssociatedTo(this));
  }
  get canBeEdited() {
    const isLegacy = this.constructedBy?.constructedBy?.isLegacyDisputeType;
    const associatedTo = this.constructedBy?.constructedBy?.disputeFileManager?.getAssociatedTo(this);
    return isLegacy ? !associatedTo : !isPresent(this.network_process_phase);
  }
  get canBeDeleted() {
    const fileIsSentToNetwork = isPresent(this.network_process_phase);
    const isLegacy = this.constructedBy?.constructedBy?.isLegacyDisputeType;
    const associatedTo = this.constructedBy?.constructedBy?.disputeFileManager?.getAssociatedTo(this);
    const canBeDeletedForLegacy = isLegacy ? !associatedTo : !fileIsSentToNetwork;
    return !this.isAttached && this.constructedBy?.constructedBy?.fileCanBeDeleted && canBeDeletedForLegacy;
  }
  // Actions
  detach() {
    this.constructedBy?.constructedBy?.disputeFileManager.detachFile(this);
  }
  updateDocCategory(newCategory) {
    this.document_category = newCategory;
  }
  updateDocName(name) {
    this.document_name = `${name}${this.extensionWithDot}`;
  }
}
decorate(DocumentStore, {
  case_token: observable,
  created_time: observable,
  document_category: observable,
  document_name: observable,
  token: observable,
  last_modified_time: observable,
  //actions
  detach: action.bound,
  updateDocCategory: action.bound,
  updateDocName: action.bound,
  // computed
  canBeEdited: computed,
  canBeDeleted: computed,
  formattedCreatedTime: computed,
  formattedDocumentExtension: computed,
  formattedDocumentName: computed,
  formattedLastModifiedTime: computed,
  extensionWithDot: computed,
  isAttached: computed,
  isSelected: computed,
  associatedTo: computed,
  isPreviouslyAttached: computed
});
const LABELS = {
  FILE_DETAILS: "File details",
  FILE_NAME: "File name",
  FILE_CATEGORY: "File category",
  DATE_FILE_UPLOADED: "Date file uploaded",
  STATE_THE_FILE_ASSOCIATED_TO: "States the file associated to",
  LAST_TIME_SUBMITTED_TO_NETWORK: "Last time submitted to network",
  PERSON_SUBMITTED_THE_FILE: "Person submitted the file",
  ATTACHED_TO_CURRENT_FORM: "Attached to current form",
  NONE: "None",
  EDIT: "Edit",
  CLOSE: "Close",
  SAVE: "Save",
  ATTACHED: "Attached",
  UNATTACHED: "Unattached",
  VIEW_DETAILS: "View details"
};
const FILE_CATEGORIES = {
  RECEIPT: "Receipt",
  CARDHOLDER_LETTER: "Cardholder letter",
  MERCHANT_LETTER: "Merchant letter",
  SALES_DRAFT: "Sales draft",
  CREDIT_VOUCHER: "Credit voucher",
  BANK_STATEMENT: "Bank statement",
  CANCELLED_CHECK: "Cancelled check",
  SECOND_OPTION: "Second option",
  FULFILLMENT: "Fullfillment",
  AUTHORIZATION_RECORD: "Authorization record",
  NETWORK_DOCUMENT: "Network document",
  UPDATED_CARDHOLDER_LETTER: "Updated cardholder letter",
  UPDATED_MERCHANT_LETTER: "Updated Merchant letter",
  AFFIDAVIT_FRAUD: "Affidavit fraud",
  OTHERS: "Other",
  NETWORK_EXHIBIT: "Network exhibit",
  ISSUER_CERTIFICATION: "Issuer certification",
  CUSTOMER_COMMUNICATION: "Customer communication",
  CUSTOMER_SIGNATURE: "Customer signature",
  CUSTOMER_DL: "Customer DL",
  CUSTOMER_SSN: "Customer SSN",
  CUSTOMER_PASSPORT: "Customer passport",
  UTILITY_BILL: "Utility bill",
  DISPUTE_FORM: "Dispute form",
  TAX_DOCUMENTS: "Tax documents",
  INCORPORATION_CERTIFICATE: "Incorporation certificate",
  LEASE_AGREEMENT: "Lease agreement"
};
const AVAILABLE_FILE_CATEGORIES = Object.keys(FILE_CATEGORIES);
const FILE_CATEGORIES_OPTIONS = AVAILABLE_FILE_CATEGORIES.map((val) => ({
  val,
  render: FILE_CATEGORIES[val]
}));
const FileDetailsModal = observer(({
  children,
  canBeEdited,
  isEditMode,
  onSave,
  onEdit,
  onClose,
  hideModal,
  isDocumentsLoading
}) => {
  const footerButtons = useMemo(() => isEditMode ? [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "file-details-modal-save", type: "primary", onClick: onSave, loading: isDocumentsLoading, children: LABELS.SAVE }, "button-save")] : [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "file-details-modal-edit", type: "secondary", onClick: onEdit, disabled: !canBeEdited, children: LABELS.EDIT }, "button-edit"), /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "file-details-modal-close", type: "primary", onClick: onClose, children: LABELS.CLOSE }, "button-close")], [isEditMode, onSave, onEdit, onClose, isDocumentsLoading, canBeEdited]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { type: "lg", heading: LABELS.FILE_DETAILS, showHideModalButton: false, hideModal, footerButtons, children });
});
FileDetailsModal.propTypes = {
  children: PropTypes.node.isRequired,
  canBeEdited: PropTypes.bool,
  isEditMode: PropTypes.bool,
  hideModal: PropTypes.func,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onEdit: PropTypes.func,
  isDocumentsLoading: PropTypes.bool
};
FileDetailsModal.defaultProps = {
  isModalVisible: false,
  canBeEdited: false,
  isEditMode: false,
  isDocumentsLoading: false,
  hideModal: () => {
  },
  onClose: () => {
  },
  onSave: () => {
  },
  onEdit: () => {
  }
};
const cell = "_cell_4vxxn_1";
const s$i = {
  cell
};
const FileDetails = ({
  isEditMode,
  fileName,
  fileCategory,
  dateUpload,
  statesAssociatedTo,
  networkProcessPhase,
  lastTimeSubmittedToNetwork,
  submittedBy,
  isAttached,
  onChangeFileName,
  onChangeFileCategory
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.FILE_NAME }),
    isEditMode ? /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { className: s$i.cell, onChange: onChangeFileName, value: fileName }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: fileName })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.FILE_CATEGORY }),
    isEditMode ? /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$i.cell, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { value: fileCategory, onChange: onChangeFileCategory, options: FILE_CATEGORIES_OPTIONS, numOptions: 5 }) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: FILE_CATEGORIES[fileCategory] })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.DATE_FILE_UPLOADED }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: dateUpload })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.STATE_THE_FILE_ASSOCIATED_TO }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: networkProcessPhase || statesAssociatedTo || LABELS.NONE })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.LAST_TIME_SUBMITTED_TO_NETWORK }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: lastTimeSubmittedToNetwork || LABELS.NONE })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.PERSON_SUBMITTED_THE_FILE }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: submittedBy || LABELS.NONE })
  ] }),
  /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
  /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", className: s$i.cell, children: LABELS.ATTACHED_TO_CURRENT_FORM }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: s$i.cell, children: isAttached ? LABELS.ATTACHED : LABELS.UNATTACHED })
  ] })
] });
FileDetails.propTypes = {
  fileName: PropTypes$1.string.isRequired,
  fileCategory: PropTypes$1.oneOf(AVAILABLE_FILE_CATEGORIES).isRequired,
  dateUpload: PropTypes$1.string.isRequired,
  lastTimeSubmittedToNetwork: PropTypes$1.string,
  networkProcessPhase: PropTypes$1.string,
  isEditMode: PropTypes$1.bool,
  statesAssociatedTo: PropTypes$1.string,
  submittedBy: PropTypes$1.string,
  isAttached: PropTypes$1.bool,
  onChangeFileName: PropTypes$1.func,
  onChangeFileCategory: PropTypes$1.func
};
FileDetails.defaultProps = {
  isEditMode: false,
  isAttached: false,
  statesAssociatedTo: "",
  networkProcessPhase: "",
  submittedBy: "",
  lastTimeSubmittedToNetwork: "",
  onChangeFileName: () => {
  },
  onChangeFileCategory: () => {
  }
};
const HEADER$2 = "Are you sure you want to delete this file?";
function DeleteFileModal({
  onConfirm,
  hideModal
}) {
  const deleteFooterButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: () => {
    onConfirm();
    hideModal();
  }, children: "Delete" }, 1)];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { description: HEADER$2, footerButtons: deleteFooterButtons, heading: "Delete file", hideModal, hideModalButtonText: "Cancel", testId: "delete-dispute-document-modal", type: "sm" });
}
DeleteFileModal.propTypes = {
  onConfirm: PropTypes.func,
  hideModal: PropTypes.func
};
DeleteFileModal.defaultProps = {
  onConfirm: () => {
  },
  hideModal: () => {
  }
};
const DeleteFileModal$1 = observer(DeleteFileModal);
const HEADER$1 = "Replace the existing attachment";
const ALERT_MESSAGE$1 = "Mastercard only accepts one attachment per dispute case.";
const BODY_MESSAGE$1 = "You are only able to attach one file to this dispute case, confirm to replace the existing attached file.";
function AttachFileForMastercardModal({
  onConfirm,
  hideModal
}) {
  const deleteFooterButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: () => {
    onConfirm();
    hideModal();
  }, children: "Replace" }, 1)];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { footerButtons: deleteFooterButtons, heading: HEADER$1, hideModal, hideModalButtonText: "Cancel", testId: "delete-dispute-document-modal", type: "sm", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: ALERT_MESSAGE$1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: BODY_MESSAGE$1 })
  ] });
}
AttachFileForMastercardModal.propTypes = {
  onConfirm: PropTypes.func,
  hideModal: PropTypes.func
};
AttachFileForMastercardModal.defaultProps = {
  onConfirm: () => {
  },
  hideModal: () => {
  }
};
const AttachFileForMastercardModal$1 = observer(AttachFileForMastercardModal);
const HEADER = "Please attach only one file";
const ALERT_MESSAGE = "Mastercard only accepts one attachment per dispute case.";
const BODY_MESSAGE = "You are only able to attach one file to this dispute case.";
function MastercardLimitSelectionModal({
  hideModal
}) {
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: hideModal, children: "Confirm" }, 1)];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { footerButtons, showHideModalButton: false, heading: HEADER, hideModal, testId: "delete-dispute-document-modal", type: "sm", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: ALERT_MESSAGE }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: BODY_MESSAGE })
  ] });
}
MastercardLimitSelectionModal.propTypes = {
  onConfirm: PropTypes.func,
  hideModal: PropTypes.func
};
MastercardLimitSelectionModal.defaultProps = {
  onConfirm: () => {
  },
  hideModal: () => {
  }
};
const MastercardLimitSelectionModal$1 = observer(MastercardLimitSelectionModal);
const KEY_PREFIX = "disputes-";
const CREATION_ORIGIN_KEY = `${KEY_PREFIX}creationOrigin`;
const FILTER_KEY_BASE = `${KEY_PREFIX}filters-`;
const SELECTED_ACTIVE_PROGRAM_KEY = "selectedActiveProgram";
const CASE_SERVICE_INTEGRATIONS = `${KEY_PREFIX}caseServiceIntegrations`;
const APPLICATION_PROPERTIES_COUNTRY_CODE = "application_properties_country_code";
const disputeStorage = {
  ...secureStorage,
  setCreationOrigin: (value) => {
    secureStorage.setItem(CREATION_ORIGIN_KEY, value);
  },
  getCreationOrigin: () => {
    return secureStorage.getItem(CREATION_ORIGIN_KEY);
  },
  removeCreationOrigin: () => {
    secureStorage.removeItem(CREATION_ORIGIN_KEY);
  },
  setFilter: (attr, value) => {
    if (value === void 0)
      return;
    secureStorage.setItem(`${FILTER_KEY_BASE}${attr}`, value);
  },
  getFilter: (attr) => {
    return secureStorage.getItem(`${FILTER_KEY_BASE}${attr}`);
  },
  clearFilters: () => {
    secureStorage.clearByMatch(FILTER_KEY_BASE);
  },
  getActiveProgram: () => {
    return secureStorage.getItem(SELECTED_ACTIVE_PROGRAM_KEY);
  },
  getApplicationPropertyCountryCode: () => {
    return secureStorage.getItem(APPLICATION_PROPERTIES_COUNTRY_CODE);
  },
  setCaseServiceIntegration: (data) => {
    secureStorage.setItem(CASE_SERVICE_INTEGRATIONS, JSON.stringify(data));
  },
  getCaseServiceIntegration: () => {
    try {
      return JSON.parse(secureStorage.getItem(CASE_SERVICE_INTEGRATIONS) || null);
    } catch (error) {
      return null;
    }
  },
  removeCaseServiceIntegration: () => {
    secureStorage.removeItem(CASE_SERVICE_INTEGRATIONS);
  }
};
const isFileManagementViewMode = (state, dispute_state) => {
  return [STATE_MAP.READY, STATE_MAP.CLOSED].includes(state) || state === STATE_MAP.CHARGEBACK_INITIATED && dispute_state !== DISPUTE_STATE_MAP.INITIATED;
};
const formatDisputeReasonOption = (reason) => {
  const label = dig(formattedDisputeReasonNetworkMap, reason, "label") || sentenceCase(reason);
  const visaCode = dig(formattedDisputeReasonNetworkMap, reason, "VISA");
  const mastercardCode = dig(formattedDisputeReasonNetworkMap, reason, "MASTERCARD");
  return {
    id: reason,
    val: reason,
    render: label,
    searchString: label,
    VISA: visaCode,
    MASTERCARD: mastercardCode
  };
};
const currentUserFromStorage = () => {
  try {
    const storage = window.localStorage;
    const {
      redsea_first_name,
      redsea_last_name,
      redsea_email
    } = storage;
    if (redsea_first_name && redsea_last_name) {
      return [redsea_first_name, redsea_last_name].join(" ");
    } else {
      return redsea_email;
    }
  } catch (err) {
    console.error("Error fetching Redsea user info from localStorage;");
    return null;
  }
};
const getFieldsFromStorage = (requestedFields) => {
  try {
    const storage = window.localStorage;
    return requestedFields.reduce((acc, cur) => ({
      ...acc,
      [cur]: storage[cur]
    }), {});
  } catch (err) {
    console.error("Error fetching Redsea user info from localStorage;");
    return null;
  }
};
const getOptions = (options) => {
  try {
    return Object.entries(options).map(([label, value]) => ({
      value,
      label
    }));
  } catch (err) {
    console.error(err);
    return [];
  }
};
const formatDisputeReasonsForFilter = () => {
  const legacyOptions = Array.from(LEGACY_DISPUTE_REASONS_MAP).map(([key, value]) => ({
    id: key,
    val: key,
    render: value.label,
    searchString: value.label,
    MASTERCARD: null,
    VISA: null
  }));
  const sortedDisputeResonKeys = Object.keys(formattedDisputeReasonNetworkMap).sort((a, b) => {
    if (a < b)
      return -1;
    if (a > b)
      return 1;
    return 0;
  });
  const formattedReasonOptions = sortedDisputeResonKeys.reduce((acc, currKey) => {
    const currOption = formattedDisputeReasonNetworkMap[currKey];
    acc.push({
      id: currKey,
      val: currKey,
      render: currOption.label,
      searchString: currOption.label
    });
    return acc;
  }, []);
  return [...formattedReasonOptions, ...legacyOptions];
};
const contextProps$2 = {
  isModalVisible: false,
  setIsModalVisible: () => {
  },
  isEditMode: false,
  isViewDetailsAvailable: false,
  setIsEditMode: () => {
  },
  hideModal: () => {
  },
  setFile: () => {
  },
  setDeleteFile: () => {
  },
  setModalReplaceVisibleForMastercard: () => {
  },
  setModalLimitVisibleForMastercard: () => {
  }
};
const FileModalsContext = createContext(contextProps$2);
const FileModalsContextWrapper = observer(({
  replaceAllByFirstSelected,
  children,
  defaultIsModalVisible,
  defaultIsEditMode,
  case_token,
  updateDocument,
  deleteDocumentByToken,
  isDocumentsLoading,
  state,
  disputeState
}) => {
  const [isModalVisible, setIsModalVisible] = useState(defaultIsModalVisible);
  const [isEditMode, setIsEditMode] = useState(defaultIsEditMode);
  const [deleteFile, setDeleteFile] = useState(null);
  const [isModalReplaceVisibleForMastercard, setModalReplaceVisibleForMastercard] = useState(false);
  const hideReplaceForMastercardModal = useCallback(() => setModalReplaceVisibleForMastercard(false), []);
  const [isModalLimitVisibleForMastercard, setModalLimitVisibleForMastercard] = useState(false);
  const hideLimitForMastercardModal = useCallback(() => setModalLimitVisibleForMastercard(false), []);
  const hideDeleteDocModal = () => setDeleteFile(null);
  const hideModal = useCallback(() => {
    setIsModalVisible(false);
    setIsEditMode(false);
  }, [setIsModalVisible]);
  const [file, setFile] = useState({});
  const onSave = useCallback(async () => {
    await updateDocument({
      case_token,
      document_category: file.document_category,
      document_name: file.document_name,
      document_token: file.token
    });
    hideModal();
    setIsEditMode(false);
  }, [file, file.document_category, file.document_name, file.token, case_token, updateDocument, hideModal, setIsEditMode]);
  const onEdit = useCallback(() => setIsEditMode(true), [setIsEditMode]);
  const onClose = useCallback(() => {
    hideModal();
    setIsEditMode(false);
  }, [setIsEditMode]);
  const onChangeFileCategory = useCallback(({
    val
  }) => {
    file.updateDocCategory?.(val);
  }, [file]);
  const onChangeFileName = useCallback((e) => {
    file.updateDocName?.(e.target.value);
  }, [file]);
  const isViewDetailsAvailable = useMemo(() => !isFileManagementViewMode(state, disputeState), [state, disputeState]);
  const {
    canBeEdited
  } = file;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FileModalsContext.Provider, { value: {
    isModalVisible,
    setIsModalVisible,
    isEditMode,
    setIsEditMode,
    hideModal,
    setFile,
    setDeleteFile,
    setModalReplaceVisibleForMastercard,
    setModalLimitVisibleForMastercard,
    isViewDetailsAvailable
  }, children: [
    children,
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(FileDetailsModal, { isEditMode, canBeEdited, onSave, onEdit, onClose, hideModal, isDocumentsLoading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FileDetails, { isEditMode, fileName: file.formattedDocumentName, networkProcessPhase: file.network_process_phase, fileCategory: file.document_category, dateUpload: file.formattedCreatedTime, lastTimeSubmittedToNetwork: file.formattedLastModifiedTime, submittedBy: file.submittedBy, statesAssociatedTo: file.associatedTo, isAttached: file.isAttached, onChangeFileName, onChangeFileCategory }) }),
    deleteFile && /* @__PURE__ */ jsxRuntimeExports.jsx(DeleteFileModal$1, { onConfirm: () => deleteDocumentByToken(deleteFile), hideModal: hideDeleteDocModal }),
    isModalReplaceVisibleForMastercard && /* @__PURE__ */ jsxRuntimeExports.jsx(AttachFileForMastercardModal$1, { onConfirm: replaceAllByFirstSelected, hideModal: hideReplaceForMastercardModal }),
    isModalLimitVisibleForMastercard && /* @__PURE__ */ jsxRuntimeExports.jsx(MastercardLimitSelectionModal$1, { hideModal: hideLimitForMastercardModal })
  ] });
});
FileModalsContextWrapper.propTypes = {
  replaceAllByFirstSelected: PropTypes$1.func,
  case_token: PropTypes$1.string.isRequired,
  defaultIsModalVisible: PropTypes$1.bool,
  defaultIsEditMode: PropTypes$1.bool,
  deleteDocumentByToken: PropTypes$1.func,
  updateDocument: PropTypes$1.func.isRequired,
  state: PropTypes$1.string.isRequired,
  disputeState: PropTypes$1.string.isRequired,
  isDocumentsLoading: PropTypes$1.bool
};
FileModalsContextWrapper.defaultProps = {
  replaceAllByFirstSelected: () => {
  },
  defaultIsModalVisible: false,
  defaultIsEditMode: false,
  deleteDocumentByToken: () => {
  },
  isDocumentsLoading: false
};
const useFileAttachForMastercardModal = () => {
  const {
    setModalReplaceVisibleForMastercard
  } = useContext(FileModalsContext);
  const openModal = useCallback(() => {
    setModalReplaceVisibleForMastercard(true);
  }, [setModalReplaceVisibleForMastercard]);
  return {
    openModal
  };
};
const OPTIONS$1 = {
  DOWNLOAD: {
    val: "DOWNLOAD",
    render: "Download"
  },
  DELETE_FROM_CASE: {
    val: "DELETE_FROM_CASE",
    render: "Delete from case"
  }
};
const PLACEHOLDER = "Bulk action";
const BULK_SELECT_WIDTH = 132;
const FileBulkActions = ({
  onChange,
  width,
  bulkCheckboxState,
  onBulkClick,
  bulkSelectIsDisabled,
  deleteOptionIsShown
}) => {
  const defaultActions = [OPTIONS$1.DOWNLOAD];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", flexDirection: "row", testId: "file-drawer-bulk", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: bulkCheckboxState, onClick: onBulkClick, testId: "bulk-checkbox" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2.5 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { testId: "bulk-select", onChange, width, placeholder: PLACEHOLDER, options: deleteOptionIsShown ? [...defaultActions, OPTIONS$1.DELETE_FROM_CASE] : defaultActions, disabled: bulkSelectIsDisabled })
  ] });
};
FileBulkActions.propTypes = {
  onChange: PropTypes$1.func.isRequired,
  width: PropTypes$1.number,
  bulkCheckboxState: PropTypes$1.oneOfType([PropTypes$1.bool, PropTypes$1.string]),
  onBulkClick: PropTypes$1.func,
  bulkSelectIsDisabled: PropTypes$1.bool,
  deleteOptionIsShown: PropTypes$1.bool
};
FileBulkActions.defaultProps = {
  width: BULK_SELECT_WIDTH,
  bulkCheckboxState: false,
  onBulkClick: () => {
  },
  bulkSelectIsDisabled: false,
  deleteOptionIsShown: true
};
const useLimitSelectionMastercardModal = () => {
  const {
    setModalLimitVisibleForMastercard
  } = useContext(FileModalsContext);
  const openModal = useCallback(() => {
    setModalLimitVisibleForMastercard(true);
  }, [setModalLimitVisibleForMastercard]);
  return {
    openModal
  };
};
const fileDrawerEmptyState = "_fileDrawerEmptyState_12lca_1";
const footer = "_footer_12lca_5";
const button = "_button_12lca_9";
const line = "_line_12lca_13";
const retrieveButton = "_retrieveButton_12lca_19";
const s$h = {
  fileDrawerEmptyState,
  footer,
  button,
  line,
  retrieveButton
};
const FileDrawerEmptyState = () => /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { testId: "file-drawer-empty-state", direction: "column", justifyContent: "center", className: s$h.fileDrawerEmptyState, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { type: "large", text: LABELS$2.EMPTY_STATE_TEXT, subText: LABELS$2.EMPTY_STATE_SUB_TEXT }) });
const filePreviewContainer = "_filePreviewContainer_1bv86_1";
const descriptionContainer = "_descriptionContainer_1bv86_4";
const descriptionRow = "_descriptionRow_1bv86_7";
const attachedRow = "_attachedRow_1bv86_10";
const actions = "_actions_1bv86_13";
const iconAction = "_iconAction_1bv86_17";
const truncated = "_truncated_1bv86_20";
const s$g = {
  filePreviewContainer,
  descriptionContainer,
  descriptionRow,
  attachedRow,
  actions,
  iconAction,
  truncated
};
const Actions = ({
  actions: actions2
}) => {
  const stopPropagationHandler = useCallback((e) => e.stopPropagation(), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "file-preview-actions", onClick: stopPropagationHandler, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawDropdown, { control: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { className: s$g.iconAction, type: "view-more-vertical" }), contentPadding: 0, anchor: "right", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Actions$1, { actions: actions2 }) }) });
};
Actions.propTypes = {
  actions: PropTypes.oneOfType([PropTypes.array, PropTypes.arrayOf(PropTypes.objectOf({
    onClick: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  }))])
};
const FilePreview = ({
  actions: actions2,
  downloadAction,
  fileName,
  fileType,
  isAttached,
  lastSubmittedDate,
  onClick,
  submittedBy
}) => {
  const submittedMessage = useMemo(() => lastSubmittedDate ? `${SUBMITTED_MESSAGE.LAST_SUBMITTED_ON} ${lastSubmittedDate}${submittedBy ? ` by ${submittedBy}` : ""}` : SUBMITTED_MESSAGE.NO_NETWORK_SUBMISSION_RECORD, [lastSubmittedDate, submittedBy]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { testId: "file-preview-container", onClick, className: s$g.filePreviewContainer, flexDirection: "row", alignItems: "center", justifyContent: "flex-start", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { factor: 8, type: FILE_TYPE_ICON_MAP[fileType] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { className: s$g.descriptionContainer, flexDirection: "column", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { testId: "file-preview-file-name", type: "h6", className: `${s$g.descriptionRow} ${s$g.truncated}`, children: fileName }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { className: `${s$g.descriptionRow} ${s$g.attachedRow}`, flexDirection: "row", justifyContent: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Pill, { testId: "file-preview-pill", size: "footnote", type: isAttached ? "dark" : "light", children: isAttached ? "Attached" : "Unattached" }),
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", className: s$g.actions, justifyContent: "space-between", children: [
          downloadAction && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "file-preview-download", onClick: (e) => {
            e.stopPropagation();
            downloadAction();
          }, className: s$g.iconAction, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "download" }) }),
          actions2?.length ? /* @__PURE__ */ jsxRuntimeExports.jsx(Actions, { actions: actions2 }) : null
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "footnote", className: s$g.truncated, testId: "file-preview-submit-description", children: submittedMessage })
    ] })
  ] });
};
FilePreview.propTypes = {
  actions: Actions.propTypes.actions,
  downloadAction: PropTypes.func,
  fileName: PropTypes.string.isRequired,
  fileType: PropTypes.oneOf(Object.values(FILE_TYPES)).isRequired,
  isAttached: PropTypes.bool,
  lastSubmittedDate: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  submittedBy: PropTypes.string.isRequired
};
FilePreview.defaultProps = {
  isAttached: false
};
const useFileDetailsModal = () => {
  const {
    setIsModalVisible,
    setFile,
    isViewDetailsAvailable
  } = useContext(FileModalsContext);
  const openModal = useCallback((file) => {
    setFile(file);
    setIsModalVisible(true);
  }, [setFile, setIsModalVisible]);
  return {
    openModal,
    isViewDetailsAvailable
  };
};
const useFileDeleteModal = () => {
  const {
    setDeleteFile
  } = useContext(FileModalsContext);
  const openModal = useCallback((file) => {
    setDeleteFile(file);
  }, [setDeleteFile]);
  return {
    openModal
  };
};
const FileDrawerItem = observer(({
  file,
  select,
  downloadFile,
  isAttachDetachAvailable,
  onAttachClick,
  detachFile
}) => {
  const {
    openModal: openDetailsModal
  } = useFileDetailsModal();
  const {
    openModal: openDeleteModal
  } = useFileDeleteModal();
  const viewDetails = useCallback(() => {
    openDetailsModal(file);
  }, [file, openDetailsModal]);
  const {
    canBeDeleted
  } = file;
  const {
    downloadAction,
    actions: actions2
  } = useMemo(() => {
    const viewDetailsAction = {
      onClick: viewDetails,
      text: LABELS$2.VIEW_DETAILS
    };
    const deleteAction = {
      onClick: () => openDeleteModal(file),
      text: LABELS$2.DELETE_FROM_CASE
    };
    const attachAction = {
      onClick: () => onAttachClick(file),
      text: LABELS$2.ATTACH_TO_FORM
    };
    const detachAction = {
      onClick: () => detachFile(file),
      text: LABELS$2.DETACH_FROM_FORM
    };
    const availableActions = [viewDetailsAction];
    if (canBeDeleted) {
      availableActions.push(deleteAction);
    }
    if (isAttachDetachAvailable && !file.isAttached) {
      availableActions.push(attachAction);
    }
    if (isAttachDetachAvailable && file.isAttached) {
      availableActions.push(detachAction);
    }
    return {
      actions: availableActions,
      downloadAction: () => downloadFile(file)
    };
  }, [file, downloadFile, openDeleteModal, viewDetails, canBeDeleted]);
  const onSelect = useCallback(() => select(file), [file, select]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { id: file.token, testId: `file-preview-checkbox_${file.document_name}`, active: file.isSelected, onClick: onSelect }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(FilePreview, { fileName: file.formattedDocumentName, fileType: file.document_content_type, lastSubmittedDate: file.formattedLastModifiedTime, isAttached: file.isAttached, downloadAction, actions: actions2, submittedBy: file.submittedBy, onClick: viewDetails })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
  ] });
});
FileDrawerItem.propTypes = {
  downloadFile: PropTypes.func,
  file: PropTypes.instanceOf(DocumentStore).isRequired,
  select: PropTypes.func,
  deleteDocument: PropTypes.func
};
FileDrawerItem.defaultProps = {
  downloadFile: () => {
  },
  select: () => {
  },
  deleteDocument: () => {
  }
};
const FooterButtons = observer(({
  acceptedFileTypes,
  isAttachAvailable,
  isDocRetrievalAvailable,
  isDocumentsLoading,
  isUploadAvailable,
  onAttachClick,
  onRetrieveCaseDocuments,
  onUploadClick
}) => {
  const fileInputRef = useRef(null);
  const acceptedFileTypesProp = useMemo(() => acceptedFileTypes.join(", "), [acceptedFileTypes]);
  const upload = useCallback((file) => {
    if (file && onUploadClick instanceof Function) {
      onUploadClick(file);
      fileInputRef.current.resetFile();
    }
  }, [onUploadClick]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$h.line }),
    isDocRetrievalAvailable && /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flexDirection: "row", className: s$h.footer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { className: s$h.retrieveButton, loading: isDocumentsLoading, type: "tertiary", testId: "file-drawer-retrieve-docs-button", onClick: onRetrieveCaseDocuments, children: LABELS$2.RETRIEVE_NETWORK_DOCUMENTS }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", className: s$h.footer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FileUpload$1, { acceptedFileTypes: acceptedFileTypesProp, handleFiles: upload, ref: fileInputRef, disabled: !isUploadAvailable, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { loading: isDocumentsLoading, className: s$h.button, disabled: !isUploadAvailable, type: "tertiary", testId: "file-drawer-upload-button", children: LABELS$2.UPLOAD_FROM_COMPUTER }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { loading: isDocumentsLoading, className: s$h.button, type: "primary", testId: "file-drawer-attach-button", disabled: !isAttachAvailable, onClick: onAttachClick, children: LABELS$2.ATTACH_TO_FORM })
    ] })
  ] });
});
FooterButtons.propTypes = {
  acceptedFileTypes: PropTypes.arrayOf(PropTypes.string),
  isAttachAvailable: PropTypes.bool.isRequired,
  isDocRetrievalAvailable: PropTypes.bool,
  isDocumentsLoading: PropTypes.bool,
  isUploadAvailable: PropTypes.bool.isRequired,
  onAttachClick: PropTypes.func.isRequired,
  onRetrieveCaseDocuments: PropTypes.func.isRequired,
  onUploadClick: PropTypes.func.isRequired
};
FooterButtons.defaultProps = {
  acceptedFileTypes: [],
  isDocumentsLoading: false
};
const downloadDocumentAutomate = (url, documentName2) => {
  const linkEl = document.createElement("a");
  linkEl.href = url;
  linkEl.target = "_blank";
  linkEl.download = documentName2;
  document.body.appendChild(linkEl);
  linkEl.click();
  document.body.removeChild(linkEl);
};
const getActions = (permissions, config) => {
  const {
    isEditing,
    isViewDetailsAvailable
  } = permissions;
  const {
    getDocumentUrl,
    viewDetails
  } = config;
  const keys2 = ["default", isViewDetailsAvailable && "viewDetails", isEditing && "editing"].filter(Boolean);
  const actions2 = {
    default: {
      text: "Download",
      onClick: ({
        token
      }) => {
        getDocumentUrl(token).then((url) => {
          if (url) {
            downloadDocumentAutomate(url);
          }
        });
      }
    },
    viewDetails: {
      text: LABELS.VIEW_DETAILS,
      onClick: viewDetails
    },
    editing: {
      text: "Detach from form",
      onClick: (file) => file.detach()
    }
  };
  return keys2.map((key) => actions2[key]);
};
const useBulkActions = ({
  getDocumentUrl,
  setBulkActionType,
  selected,
  items,
  deleteDocumentByToken
}) => {
  const downloadFile = useCallback((file) => {
    getDocumentUrl(file?.token).then((url) => {
      if (url) {
        downloadDocumentAutomate(url);
      }
    });
  }, [getDocumentUrl]);
  const ACTION_MAP = useMemo(() => {
    return {
      DOWNLOAD: downloadFile,
      DELETE_FROM_CASE: deleteDocumentByToken
    };
  }, [downloadFile, deleteDocumentByToken]);
  const onBulkActionClick = useCallback((action2) => {
    setBulkActionType(action2);
    const {
      val
    } = action2;
    if (ACTION_MAP[val]) {
      [...selected.values()].forEach((file) => ACTION_MAP[val](file));
    }
  }, [selected, setBulkActionType, ACTION_MAP]);
  const allFilesAreSelected = items.length === selected.size;
  const noFilesAreSelected = !selected.size;
  const bulkCheckboxState = !allFilesAreSelected && !noFilesAreSelected ? "indeterminate" : allFilesAreSelected;
  return [onBulkActionClick, downloadFile, bulkCheckboxState, noFilesAreSelected];
};
const contextProps$1 = {
  isFormAvailable: false,
  isOpened: false,
  setIsFormAvailable: () => {
  },
  setIsOpened: () => {
  }
};
const FileDrawerContext = createContext(contextProps$1);
const FileDrawerContextWrapper = observer(({
  attachSelected,
  attachFile,
  detachFile,
  bulkActionType,
  acceptedFileTypes,
  children,
  deselectAll,
  getDocumentUrl,
  isAttachAvailable,
  attachedSize,
  isMastercard,
  items,
  selected,
  select,
  setSortBy,
  setBulkActionType,
  selectAll,
  sortBy,
  onUploadClick,
  deleteDocumentByToken,
  deleteOptionIsShown,
  replaceAllByFirstSelected,
  isDocumentsLoading,
  onRetrieveCaseDocuments,
  isDocRetrievalAvailable
}) => {
  const [onBulkActionClick, downloadFile, bulkCheckboxState, noFilesAreSelected] = useBulkActions({
    getDocumentUrl,
    setBulkActionType,
    selected,
    items,
    deleteDocumentByToken
  });
  const {
    openModal: openModalReplaceForMastercard
  } = useFileAttachForMastercardModal();
  const {
    openModal: openModalLimitForMastercard
  } = useLimitSelectionMastercardModal();
  const [isOpened, setIsOpened] = useState(false);
  const [isFormAvailable, setIsFormAvailable] = useState(false);
  const closeDrawer = useCallback(() => setIsOpened(false), []);
  const onAttachClick = useCallback(async () => {
    if (isMastercard) {
      if (selected.size > 1) {
        openModalLimitForMastercard();
      } else if (attachedSize > 0) {
        openModalReplaceForMastercard();
      } else {
        replaceAllByFirstSelected();
      }
    } else {
      await attachSelected();
    }
    closeDrawer();
  }, [attachSelected, closeDrawer, attachedSize]);
  const onAttachSingleFile = useCallback((file) => {
    if (isMastercard) {
      if (attachedSize > 0) {
        openModalReplaceForMastercard();
      } else {
        replaceAllByFirstSelected();
      }
    } else {
      attachFile(file);
    }
    closeDrawer();
  }, [attachFile, closeDrawer, attachedSize]);
  const onBulkClick = useCallback(() => {
    noFilesAreSelected ? selectAll(items) : deselectAll();
  }, [items, noFilesAreSelected, selectAll, deselectAll]);
  const footerButtons = /* @__PURE__ */ jsxRuntimeExports.jsx(FooterButtons, { acceptedFileTypes, isAttachAvailable: (isAttachAvailable || isFormAvailable) && selected.size, isDocRetrievalAvailable, isDocumentsLoading, isUploadAvailable: isAttachAvailable || isFormAvailable, onAttachClick, onRetrieveCaseDocuments, onUploadClick });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(FileDrawerContext.Provider, { value: {
    isFormAvailable,
    isOpened,
    setIsFormAvailable,
    setIsOpened
  }, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Drawer, { showCloseButton: true, dynamicWidth: true, testId: "dispute-details-drawer", header: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: LABELS$2.FILE_MANAGEMENT }), footer: footerButtons, closeDrawer, isOpened, children: items?.length ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", alignItems: "center", justifyContent: "space-between", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FileBulkActions, { bulkActionType, onChange: onBulkActionClick, bulkCheckboxState, onBulkClick, bulkSelectIsDisabled: !selected.size, deleteOptionIsShown }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DateSorter, { value: sortBy, onChange: setSortBy })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      items.map((file) => /* @__PURE__ */ jsxRuntimeExports.jsx(FileDrawerItem, { file, select, downloadFile, isAttachDetachAvailable: isAttachAvailable || isFormAvailable, onAttachClick: onAttachSingleFile, detachFile }, file.token))
    ] }) : /* @__PURE__ */ jsxRuntimeExports.jsx(FileDrawerEmptyState, {}) }),
    children
  ] });
});
FileDrawerContextWrapper.propTypes = {
  attachSelected: PropTypes.func,
  attachedSize: PropTypes.number,
  deleteDocumentByToken: PropTypes.func,
  deleteOptionIsShown: PropTypes.bool,
  isAttachAvailable: PropTypes.bool,
  isMastercard: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.instanceOf(DocumentStore)),
  onUploadClick: PropTypes.func,
  replaceAllByFirstSelected: PropTypes.func,
  select: FileDrawerItem.propTypes.select,
  selected: PropTypes.instanceOf(ObservableSet),
  setSortBy: PropTypes.func,
  sortBy: PropTypes.string.isRequired,
  getDocumentUrl: PropTypes.func,
  isDocumentsLoading: PropTypes.bool,
  acceptedFileTypes: FooterButtons.propTypes.acceptedFileTypes,
  onRetrieveCaseDocuments: PropTypes.func,
  isDocRetrievalAvailable: PropTypes.bool
};
FileDrawerContextWrapper.defaultProps = {
  attachSelected: () => {
  },
  attachedSize: 0,
  deleteDocumentByToken: () => {
  },
  deleteOptionIsShown: false,
  isAttachAvailable: false,
  isMastercard: false,
  onUploadClick: () => {
  },
  replaceAllByFirstSelected: () => {
  },
  select: FileDrawerItem.defaultProps.select,
  selected: [],
  setSortBy: () => {
  },
  getDocumentUrl: () => {
  },
  acceptedFileTypes: FooterButtons.defaultProps.acceptedFileTypes,
  isDocumentsLoading: false,
  onRetrieveCaseDocuments: () => {
  },
  isDocRetrievalAvailable: false
};
const useFileDrawerContext = () => {
  const {
    isOpened,
    setIsOpened,
    setIsFormAvailable
  } = useContext(FileDrawerContext);
  const open = useCallback(() => {
    setIsOpened(true);
  }, [setIsOpened]);
  const close = useCallback(() => {
    setIsOpened(false);
  }, [setIsOpened]);
  const showInActionsCell = useCallback((state) => state === STATE_MAP.READY, []);
  const manageFilesButton = useMemo(() => ({
    icon: "doc",
    onClick: open,
    text: LABELS$2.MANAGE_FILES,
    showInActionsCell
  }), [open, showInActionsCell]);
  return {
    close,
    isOpened,
    manageFilesButton,
    open,
    setIsFormAvailable
  };
};
const document$1 = "_document_xcm8q_1";
const documentInfo = "_documentInfo_xcm8q_17";
const documentName = "_documentName_xcm8q_23";
const documentIcon = "_documentIcon_xcm8q_29";
const s$f = {
  document: document$1,
  documentInfo,
  documentName,
  documentIcon
};
function DisputeDocument({
  document: document2,
  actions: actions2,
  showDocumentType
}) {
  const {
    document_category = "",
    document_name,
    formattedDocumentExtension,
    formattedDocumentName
  } = document2;
  const filePreviewClasses = useMemo(() => ({
    container: s$f.document
  }), []);
  const boundActions = useMemo(() => actions2.map((action2) => ({
    ...action2,
    onClick: () => action2.onClick(document2)
  })), [actions2, document2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FilePreview$1, { testId: document_name, classes: filePreviewClasses, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FilePreviewFooter, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FilePreviewName, { icon: /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { noHoverEffects: true, type: "doc", factor: 1 }), name: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$f.documentInfo, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { className: s$f.documentName, children: [
        formattedDocumentName,
        "."
      ] }),
      formattedDocumentExtension && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: formattedDocumentExtension })
    ] }), children: showDocumentType && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "small", mod: "light", children: FILE_CATEGORIES[document_category] }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FilePreviewActions, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Actions$1, { actions: boundActions }) })
  ] }) });
}
DisputeDocument.propTypes = {
  actions: PropTypes.array,
  document: PropTypes.object,
  showDocumentType: PropTypes.bool
};
DisputeDocument.defaultProps = {
  actions: [],
  document: {},
  showDocumentType: true
};
const DisputeDocument$1 = observer(DisputeDocument);
const documents = "_documents_14a9p_1";
const fullWidth = "_fullWidth_14a9p_13";
const disputeDocuments = "_disputeDocuments_14a9p_17";
const s$e = {
  documents,
  fullWidth,
  disputeDocuments
};
function DisputeDocuments({
  customFilter,
  documentsStore,
  fullWidth: fullWidth2,
  isEditing,
  detachFile,
  showDocumentType
}) {
  const {
    getDocumentUrl,
    items = []
  } = documentsStore || {};
  const {
    openModal: viewDetails,
    isViewDetailsAvailable
  } = useFileDetailsModal();
  const documentActions = getActions({
    isEditing,
    isViewDetailsAvailable
  }, {
    getDocumentUrl,
    viewDetails,
    detachFile
  });
  const filteredItems = customFilter instanceof Function ? items.filter(customFilter) : items;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: classUtil(s$e.documents, fullWidth2 && s$e.fullWidth), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "flex", flexDirection: "row", flexWrap: "wrap", className: s$e.disputeDocuments, children: filteredItems?.map((document2) => /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocument$1, { actions: documentActions, document: document2, showDocumentType }, document2.document_name)) }) });
}
DisputeDocuments.propTypes = {
  customFilter: PropTypes.func,
  documentsStore: PropTypes.object,
  fullWidth: PropTypes.bool,
  isEditing: PropTypes.bool,
  isVisa: PropTypes.bool,
  detachFile: PropTypes.func,
  showDocumentType: PropTypes.bool
};
DisputeDocuments.defaultProps = {
  customFilter: null,
  documentsStore: {},
  fullWidth: false,
  isEditing: false,
  isVisa: false,
  detachFile: () => {
  },
  showDocumentType: true
};
const DisputeDocuments$1 = observer(DisputeDocuments);
const uploadButtonWrap = "_uploadButtonWrap_ujh7c_1";
const s$d = {
  uploadButtonWrap
};
function NetworkTransitionDocumentsForm({
  documentsStore,
  fullWidth: fullWidth2,
  showDocumentType,
  transitionDetails,
  isAttachAvailable
}) {
  const fileInputRef = useRef(null);
  const {
    open,
    setIsFormAvailable
  } = useFileDrawerContext();
  useEffect(() => {
    setIsFormAvailable(true);
    return () => setIsFormAvailable(false);
  }, []);
  const removeAttachedContent = (deleteDocumentToken) => {
    transitionDetails.removeAttachedContent(deleteDocumentToken);
    fileInputRef.current.resetFile();
  };
  const {
    loading = false,
    items = []
  } = documentsStore || {};
  const contentsCount = useMemo(() => items.filter((document2) => document2.isAttached).length, [items]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loading, transparentBackground: true, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$d.uploadButtonWrap, children: isAttachAvailable && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: open, testId: "upload-document", type: "tertiary", children: "Attach files" }) }),
      Boolean(contentsCount) && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocuments$1, { documentsStore, fullWidth: fullWidth2, isEditing: true, isVisa: false, removeAttachedContent, showDocumentType, customFilter: (file) => file.isAttached }),
      Boolean(contentsCount) && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] })
  ] });
}
NetworkTransitionDocumentsForm.propTypes = {
  aggregateAttachedContents: PropTypes.array,
  documentsStore: PropTypes.object,
  fullWidth: PropTypes.bool,
  showDocumentType: PropTypes.bool,
  transitionDetails: PropTypes.object,
  isAttachAvailable: PropTypes.bool
};
NetworkTransitionDocumentsForm.defaultProps = {
  aggregateAttachedContents: [],
  documentsStore: {},
  fullWidth: false,
  showDocumentType: true,
  transitionDetails: {},
  isAttachAvailable: false
};
const NetworkTransitionDocumentsForm$1 = observer(NetworkTransitionDocumentsForm);
const TEXTAREA_WIDTH = 540;
function DisputeTransitionForm(props) {
  const {
    addToLocalList,
    disputeAmountComponent,
    documentsStore,
    memo,
    newDisputeTransitionStore,
    nextAction,
    onCancelClick,
    onMemoChange,
    onSubmit,
    shouldShowAmountField,
    isAttachAvailable
  } = props;
  const {
    network_details
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    aggregateAttachedContents
  } = network_details || EMPTY_OBJECT;
  const transitionDetailsFieldName = NETWORK_DETAILS_FIELD_BY_ACTION[nextAction];
  const transitionDetails = network_details[transitionDetailsFieldName];
  const shouldAllowUploadDocs = LEGACY_UPLOADABLE_ACTIONS.includes(nextAction);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxContainer, { testId: "legacy-transition-form", paddingTop: 1, paddingBottom: 1, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { testId: "transition-form-header", type: "h5", children: TRANSITION_LABELS.LEGACY_DISPUTE[nextAction] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    shouldShowAmountField && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "add-dispute-amount-container", children: [
      disputeAmountComponent,
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: "Notes", labelOptional: true, noResize: true, onChange: (e) => onMemoChange(e.target.value), rows: 2, testId: "legacy-transition-form-note-textarea", value: memo, width: TEXTAREA_WIDTH }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    shouldAllowUploadDocs && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Upload related files" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkTransitionDocumentsForm$1, { isAttachAvailable, addToLocalList, aggregateAttachedContents, documentsStore, fullWidth: true, showDocumentType: false, transitionDetails }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flex: "1 1 100%", display: "flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: onCancelClick, testId: "cancel-legacy-transition-btn", children: "Cancel" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: `${ACTIONS_LABEL_MAP.LEGACY_DISPUTE[nextAction]}-submit-button`, onClick: onSubmit, children: ACTIONS_LABEL_MAP.LEGACY_DISPUTE[nextAction] })
    ] })
  ] });
}
DisputeTransitionForm.propTypes = {
  addToLocalList: PropTypes.func,
  disputeAmountComponent: PropTypes.node,
  documentsStore: PropTypes.object,
  memo: PropTypes.string,
  newDisputeTransitionStore: PropTypes.object,
  nextAction: PropTypes.string,
  onCancelClick: PropTypes.func,
  onMemoChange: PropTypes.func,
  onSubmit: PropTypes.func,
  shouldShowAmountField: PropTypes.bool,
  isAttachAvailable: PropTypes.bool
};
DisputeTransitionForm.defaultProps = {
  addToLocalList: null,
  disputeAmountComponent: null,
  documentsStore: {},
  memo: "",
  newDisputeTransitionStore: {
    network_details: {}
  },
  nextAction: "",
  onCancelClick: () => {
  },
  onMemoChange: () => {
  },
  onSubmit: () => {
  },
  shouldShowAmountField: false,
  isAttachAvailable: false
};
const DisputeTransitionForm$1 = observer(DisputeTransitionForm);
const useAccordion = (lastItem) => {
  const [expanded, setExpanded] = useState(/* @__PURE__ */ new Set([lastItem]));
  useEffect(() => {
    setExpanded(/* @__PURE__ */ new Set([lastItem]));
  }, [lastItem]);
  const handleExpand = useCallback((index) => {
    setExpanded((prevState) => {
      if (prevState.has(index)) {
        const newState = new Set(prevState);
        newState.delete(index);
        return newState;
      }
      return new Set(prevState).add(index);
    });
  }, []);
  return [expanded, handleExpand];
};
const inlineFlexBetween = "_inlineFlexBetween_hgotj_1";
const largeLineHeight = "_largeLineHeight_hgotj_8";
const accordionContent = "_accordionContent_hgotj_12";
const formPadding = "_formPadding_hgotj_17";
const enclosedField = "_enclosedField_hgotj_21";
const styles$5 = {
  inlineFlexBetween,
  largeLineHeight,
  accordionContent,
  formPadding,
  enclosedField
};
function DisputeTransitionHeader({
  label,
  time,
  participantName
}) {
  const timeAndParticipant = useMemo(() => [time, participantName].filter(Boolean), [time, participantName]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$5.inlineFlexBetween, "data-testid": `accordion-section_${label}`, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: label }),
    timeAndParticipant.length && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "footnote", children: timeAndParticipant.join(" • ") })
  ] });
}
DisputeTransitionHeader.propTypes = {
  label: PropTypes.string,
  time: PropTypes.string,
  participantName: PropTypes.string
};
DisputeTransitionHeader.defaultProps = {
  label: "",
  time: "",
  participantName: ""
};
const DisputeTransitionHeader$1 = observer(DisputeTransitionHeader);
const TransitionsContent = (props) => {
  const {
    memo,
    aggregateAttachedContents,
    documentsStore,
    amount
  } = props;
  const showDocumentsList = Boolean(aggregateAttachedContents?.length);
  if (isNotPresent(memo) && !aggregateAttachedContents.length && isNotPresent(amount)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
    isPresent(amount) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "1 1 100%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledContent, { flexDirection: "column", tooltip: false, label: "Dispute amount", testId: "transition-amount", children: amount }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    isPresent(memo) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "1 1 100%", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledContent, { flexDirection: "column", tooltip: false, label: "Note", testId: "transition-memo", children: memo }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    showDocumentsList && /* @__PURE__ */ jsxRuntimeExports.jsxs(LabeledContent, { flexDirection: "column", tooltip: false, label: "Attachments", testId: "transition-attachments", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "1 1 100%", style: {
        maxWidth: "550px"
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocuments$1, { customFilter: (doc) => aggregateAttachedContents?.includes(doc.token), documentsStore, fullWidth: true, isEditing: false, isVisa: false, showDocumentType: false }) })
    ] })
  ] });
};
TransitionsContent.propTypes = {
  aggregateAttachedContents: PropTypes.array,
  amount: PropTypes.string,
  documentsStore: PropTypes.object,
  memo: PropTypes.string
};
TransitionsContent.defaultProps = {
  aggregateAttachedContents: [],
  amount: "",
  documentsStore: {},
  memo: ""
};
const getAccordionItems = (expanded, handleExpand, items, lastItem, documents2) => items.map((transition, index) => {
  const {
    header,
    details,
    aggregateAttachedContents,
    amount
  } = transition;
  const {
    formattedLabel,
    formattedTime,
    key
  } = header;
  const [memo] = details;
  const isLast = lastItem === index;
  return {
    key,
    expand: expanded.has(index),
    defaultExpanded: isLast,
    onToggleExpansion: () => handleExpand(index),
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionHeader$1, { label: formattedLabel, time: formattedTime }),
    content: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionsContent, { memo, amount: isPresent(amount) ? String(amount) : "", aggregateAttachedContents, documentsStore: documents2 }),
    overrideDivider: isLast
  };
});
const TransitionsAccordion = (props) => {
  const {
    items,
    toggleSectionVisibility,
    documents: documents2
  } = props;
  const lastItem = items.length - 1;
  const [expanded, expand] = useAccordion(lastItem);
  const handleExpand = useCallback((index) => {
    if (lastItem === index) {
      toggleSectionVisibility();
    }
    expand(index);
  }, [expand, lastItem, toggleSectionVisibility]);
  const sections = useMemo(() => getAccordionItems(expanded, handleExpand, items, lastItem, documents2), [expanded, handleExpand, items, lastItem, documents2]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { divideSections: true, sections, testId: "legacy-transitions-accordion" });
};
TransitionsAccordion.defaultProps = {
  items: [],
  documents: {},
  toggleSectionVisibility: () => {
  }
};
TransitionsAccordion.propTypes = {
  items: PropTypes.array,
  documents: PropTypes.object,
  toggleSectionVisibility: PropTypes.func
};
const useDocuments = (documents2) => {
  const [list, setList] = useState([]);
  const addToList = useCallback((token) => {
    setList([...list, token]);
  }, [list]);
  const resetList = useCallback(() => {
    setList([]);
  }, []);
  const deleteList = useCallback(async () => {
    const docsToDelete = documents2.items.filter((item) => list.includes(item.token));
    await Promise.all(docsToDelete.map(async (store) => await documents2.deleteDocument(store.token)));
    setList([]);
  }, [documents2, list]);
  const controls = useMemo(() => ({
    addToList,
    resetList,
    deleteList
  }), [addToList, deleteList, resetList]);
  return controls;
};
const boxContainer = "_boxContainer_1apuv_1";
const styles$4 = {
  boxContainer
};
const {
  CASE_LOST,
  CASE_WON,
  CLOSED: CLOSED$2,
  NETWORK_REJECTED
} = DISPUTE_STATE_MAP;
const VIEW_ONLY_STATES = [CASE_LOST, CASE_WON, CLOSED$2, NETWORK_REJECTED];
const DisputeTransitions = ({
  dispute,
  goTo
}) => {
  const {
    dispute_details,
    dispute_transitions,
    type,
    documents: documents2,
    disputesAccess,
    disputeFileManager
  } = dispute || EMPTY_OBJECT;
  const {
    dispute_amount,
    dispute_state
  } = dispute_details || EMPTY_OBJECT;
  const {
    createDisputeTransition,
    itemsForRender,
    loading,
    newDisputeTransitionStore = EMPTY_OBJECT,
    nextLegacyTransitionAction,
    shouldShowAmountField
  } = dispute_transitions || EMPTY_OBJECT;
  const {
    action: action2,
    memo,
    otherAmount,
    otherLegacyAmountValidation,
    setAction = () => EMPTY_OBJECT,
    setAttr,
    withWriteOff,
    setDigDetails
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    addToList,
    resetList,
    deleteList
  } = useDocuments(documents2);
  const TRANSITION_ACTIONS2 = dispute_state === DISPUTE_STATE_MAP.REPRESENTMENT ? LEGACY_REPRESENTMENT_DISPUTE_TRANSITION_ACTIONS : LEGACY_DEFAULT_DISPUTE_TRANSITION_ACTIONS;
  const [isModalVisible, setModalVisibility] = useState(false);
  const [isFormSubmitted, setFormSubmission] = useState(false);
  const [isResponseFormVisible, setResponseFormVisibility] = useState(false);
  const [isResponseSectionVisible, setResponseSectionVisible] = useState(true);
  const [amountGroupValue, setAmountGroupValue] = useState(FULL_AMOUNT);
  const disputeAmountError = isFormSubmitted ? otherLegacyAmountValidation : "";
  useLayoutEffect(() => {
    if (VIEW_ONLY_STATES.includes(dispute_state)) {
      setResponseSectionVisible(false);
    }
  }, [dispute_state, isResponseSectionVisible]);
  const setMemo = (e) => setAttr("memo", e.target.value);
  const setWriteOff = (value) => setAttr("withWriteOff", value);
  const handleMemoChange = (value) => setDigDetails("memo", value);
  const handleOtherAmountChange = useCallback((value) => {
    setAttr("otherAmount", value);
    setFormSubmission(false);
  }, [setAttr]);
  const toggleModalVisibility = useCallback(() => setModalVisibility((state) => !state), []);
  const toggleFormVisibility = useCallback(() => {
    setResponseFormVisibility((state) => !state);
    setAttr("memo", "");
  }, [setAttr]);
  const toggleSectionVisibility = useCallback(() => setResponseSectionVisible((state) => !state), []);
  const handleTransitionCreation = useCallback(async () => {
    setFormSubmission(true);
    const formIsValid = amountGroupValue === FULL_AMOUNT || !otherLegacyAmountValidation;
    if (!formIsValid) {
      return;
    }
    setAction(nextLegacyTransitionAction);
    await createDisputeTransition();
    setFormSubmission(false);
    setAmountGroupValue(FULL_AMOUNT);
    toggleFormVisibility();
    resetList();
  }, [amountGroupValue, createDisputeTransition, nextLegacyTransitionAction, resetList, setAction, toggleFormVisibility, otherLegacyAmountValidation]);
  const handleSubmitFromModal = useCallback(() => {
    createDisputeTransition();
    toggleModalVisibility();
    resetList();
  }, [createDisputeTransition, resetList, toggleModalVisibility]);
  const handleActionClick = useCallback((action22) => {
    setAction(action22);
    toggleModalVisibility();
  }, [setAction, toggleModalVisibility]);
  const handleCancelClick = async () => {
    setAction(nextLegacyTransitionAction);
    toggleModalVisibility();
  };
  const handleCancelActionClick = useCallback(async () => {
    await deleteList();
    toggleFormVisibility();
  }, [deleteList, toggleFormVisibility]);
  const actions2 = useMemo(() => TRANSITION_ACTIONS2.reduce((acc, action22) => ({
    ...acc,
    [action22]: () => handleActionClick(action22)
  }), []), [handleActionClick]);
  const additionalSlots = {
    [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledContent, { tooltip: WRITE_OFF_TOOLTIP, flexDirection: "column", label: WRITE_OFF_LABEL, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { groupItems: RADIO_GROUP_ITEMS, onChange: setWriteOff, value: withWriteOff }) })
  };
  const isEmptyStateVisible = !itemsForRender.length && dispute_state === DISPUTE_STATE_MAP.INITIATED && !isResponseFormVisible;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { gutter: 24, padding: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Row, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Col, { span: 9, children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { size: 32, active: loading, children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$4.boxContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxContainer, { paddingBottom: 3, paddingLeft: 3, paddingRight: 3, paddingTop: isEmptyStateVisible ? 5 : 3, children: [
        isEmptyStateVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { type: "large", text: "No responses yet", testId: "sections-empty", iconType: "empty-state-folder" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
        ] }),
        Boolean(itemsForRender.length) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionsAccordion, { documents: documents2, items: itemsForRender, toggleSectionVisibility }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
        ] }),
        isResponseSectionVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionResponseSection, { isResponseFormVisible, responseForm: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionForm$1, { addToLocalList: addToList, isAttachAvailable: disputeFileManager?.isAttachAvailable, disputeAmountComponent: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAmount$1, { disputeAmount: dispute_amount, disputeAmountError, onAmountGroupChange: setAmountGroupValue, onOtherAmountChange: handleOtherAmountChange, otherAmount, isOtherAmount: amountGroupValue === OTHER_AMOUNT, labels: DISPUTE_AMOUNT_DEFAULT_LABELS }), documentsStore: documents2, memo, newDisputeTransitionStore, nextAction: nextLegacyTransitionAction, onCancelClick: handleCancelActionClick, onMemoChange: handleMemoChange, onSubmit: handleTransitionCreation, shouldShowAmountField, testId: "legacy-transitions-form" }), children: disputesAccess.hasRiskInternalRole && /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "inline-flex", children: /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionActions, { actions: actions2, disputeType: DISPUTES.LEGACY_DISPUTE, nextAction: nextLegacyTransitionAction, onShowActionForm: toggleFormVisibility }) }) })
      ] }) }) }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Col, { span: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AuxDisputeDetails$1, { dispute, goTo }) })
    ] }) }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionModal$1, { action: action2, additionalSlot: additionalSlots[action2], disputeType: type, hideModal: handleCancelClick, memo, onSubmit: handleSubmitFromModal, setMemo })
  ] });
};
DisputeTransitions.propTypes = {
  dispute: PropTypes.object,
  goTo: PropTypes.func
};
DisputeTransitions.defaultProps = {
  dispute: {},
  goTo: () => {
  }
};
const LegacyDisputeTransitions = observer(DisputeTransitions);
const useShowEntity = (setAction = () => {
}, defaultAction) => {
  const [showEntity, setShowEntity] = useState(false);
  const showActionEntity = (action2) => {
    setShowEntity(true);
    setAction(defaultAction || action2);
  };
  const hideActionEntity = (action2) => {
    setShowEntity(false);
    setAction(null);
  };
  return [showEntity, showActionEntity, hideActionEntity];
};
function AcceptLiability({
  additionalSlot,
  hideModal,
  memo,
  onSubmit,
  setMemo
}) {
  const actionWarning = ACTION_WARNINGS_MAP.DISPUTE[ACCEPT_AND_CLOSE];
  const acceptLabel = ACTIONS_LABEL_MAP.DISPUTE[ACCEPT_AND_CLOSE];
  const handleSubmit = useCallback(() => {
    onSubmit();
    hideModal();
  }, [hideModal, onSubmit]);
  const footerButtons = useMemo(() => [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: acceptLabel }, 1)], [acceptLabel, handleSubmit]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { heading: acceptLabel, hideModal, footerButtons, disableOverFlow: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: globalStyles.xsmallMarginLeft, children: actionWarning }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    additionalSlot && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      additionalSlot,
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: "Note", value: memo, onChange: setMemo, rows: 2, labelOptional: true })
  ] });
}
AcceptLiability.propTypes = {
  additionalSlot: PropTypes.node,
  hideModal: PropTypes.func,
  memo: PropTypes.string,
  onSubmit: PropTypes.func,
  setMemo: PropTypes.func
};
AcceptLiability.defaultProps = {
  additionalSlot: null,
  hideModal: () => {
  },
  memo: "",
  onSubmit: () => {
  },
  setMemo: () => {
  }
};
const AcceptLiability$1 = observer(AcceptLiability);
function MastercardArbRequestForm({
  createDisputeTransition,
  hideForm,
  newDisputeTransitionStore
}) {
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_ARB];
  const {
    memo,
    setDigDetails
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const handleSubmit = () => {
    createDisputeTransition();
    hideForm();
  };
  const memoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Internal note (optional)", tooltip: MEMO_TOOLTIP });
  const fullFieldWidth = 540;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "mc-arb-request-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Arbitration request" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: memoLabel, value: memo, onChange: (e) => setDigDetails("memo", e.target.value), width: fullFieldWidth, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: actionLabel })
    ] })
  ] });
}
MastercardArbRequestForm.propTypes = {
  createDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object
};
MastercardArbRequestForm.defaultProps = {
  createDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {}
};
const MastercardArbRequestForm$1 = observer(MastercardArbRequestForm);
const disputeDetailsFormBody = "_disputeDetailsFormBody_185td_1";
const formRadioInput = "_formRadioInput_185td_7";
const reasonWrap = "_reasonWrap_185td_11";
const s$c = {
  disputeDetailsFormBody,
  formRadioInput,
  reasonWrap
};
function MastercardPreArbRequestForm({
  createDisputeTransition,
  hideForm,
  newDisputeTransitionStore,
  documentsStore,
  isAttachAvailable
}) {
  const [submitted, setSubmitted] = useState(false);
  const {
    disputeCurrencyCode,
    mastercardPreArbValidation,
    memo,
    network_details,
    setDigDetails,
    dispute_amount,
    fullDisputeAmountSelected,
    setAttr: setTransitionStoreDetails
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    prearbitration_details = {},
    aggregateAttachedContents
  } = network_details || EMPTY_OBJECT;
  const {
    amount,
    filing_ica,
    filed_against_ica,
    network_memo,
    setAttr: setPreArbDetails = () => {
    }
  } = prearbitration_details || EMPTY_OBJECT;
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_PREARB];
  const fullFieldWidth = 540;
  const secondFieldWidth = fullFieldWidth - 28;
  const hasErrors = useMemo(() => {
    return Boolean(mastercardPreArbValidation && Object.keys(mastercardPreArbValidation).length);
  }, [mastercardPreArbValidation]);
  const errors = submitted ? mastercardPreArbValidation : {};
  useEffect(() => {
    if (fullDisputeAmountSelected) {
      setTransitionStoreDetails("dispute_amount", formatMoneyAmount(dispute_amount));
    } else {
      setPreArbDetails("amount", formatMoneyAmount(amount));
    }
  }, []);
  const handleRadioChange = useCallback((option) => {
    const amountValue = option ? dispute_amount : null;
    setDigDetails("fullDisputeAmountSelected", option);
    setPreArbDetails("amount", amountValue);
  }, [setDigDetails, dispute_amount, setPreArbDetails]);
  const handleSubmit = async () => {
    setSubmitted(true);
    if (!hasErrors) {
      const success = await createDisputeTransition();
      if (success) {
        hideForm();
      }
    }
  };
  useEffect(() => {
    const amountValue = fullDisputeAmountSelected ? dispute_amount : amount;
    setPreArbDetails && setPreArbDetails("amount", amountValue);
  }, [amount, dispute_amount, fullDisputeAmountSelected, setPreArbDetails]);
  const networkMemoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Explanation", tooltip: NETWORK_MEMO_TOOLTIP });
  const memoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Internal note (optional)", tooltip: MEMO_TOOLTIP });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "mc-prearb-request-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Pre-arbitration request" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Filing ICA", value: filing_ica, onChange: (e) => setPreArbDetails("filing_ica", e.target.value), width: fullFieldWidth, error: errors.filing_ica }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { error: errors.filed_against_ica, label: "Filing against ICA", onChange: (e) => setPreArbDetails("filed_against_ica", e.target.value), value: filed_against_ica, width: fullFieldWidth }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: fullDisputeAmountSelected, label: "Dispute amount", groupItems: [{
      label: "Full dispute amount",
      value: true
    }, {
      label: "Other amount",
      value: false
    }], renderRadioItem: (itemProps) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$c.customRadioInput, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupItem, { ...itemProps, testId: "dispute-transition-amount-radio" }),
      itemProps?.active && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$c.formRadioInput, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: fullDisputeAmountSelected ? dispute_amount : amount, rightAddOn: {
        content: disputeCurrencyCode
      }, width: secondFieldWidth, testId: "dispute-transition-amount-radio-active-input", disabled: fullDisputeAmountSelected, onChange: (e) => setPreArbDetails("amount", e.target.value), onBlur: (e) => setPreArbDetails("amount", formatMoneyAmount(amount)) }) })
    ] }), onChange: handleRadioChange, error: errors.amount }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: networkMemoLabel, value: network_memo, onChange: (e) => setPreArbDetails("network_memo", e.target.value), width: fullFieldWidth, error: errors.network_memo, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Upload related files" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkTransitionDocumentsForm$1, { documentsStore, transitionDetails: prearbitration_details, aggregateAttachedContents, isAttachAvailable })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: memoLabel, value: memo, onChange: (e) => setDigDetails("memo", e.target.value), width: fullFieldWidth, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: actionLabel })
    ] })
  ] });
}
MastercardPreArbRequestForm.propTypes = {
  createDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object,
  documentsStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool
};
MastercardPreArbRequestForm.defaultProps = {
  createDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {},
  documentsStore: {},
  isAttachAvailable: false
};
const MastercardPreArbRequestForm$1 = observer(MastercardPreArbRequestForm);
function VisaPreArbResponseForm({
  onCreateDisputeTransition,
  hideForm,
  newDisputeTransitionStore,
  isAttachAvailable,
  documentsStore,
  currencyCode,
  disputeReason
}) {
  const [submitted, setSubmitted] = useState(false);
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_PREARB_RESPONSE];
  const {
    visaPreArbResponseValidation,
    network_details,
    dispute_amount
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    prearbitration_response_details = {},
    aggregateAttachedContents
  } = network_details || EMPTY_OBJECT;
  const {
    prearb_response_decision,
    partial_acceptance_amount,
    why_are_you_not_accepting_liability,
    certify_that_cardholder_continues_dispute,
    explanation_cardholder_continues_dispute,
    certify_cardholder_details_dont_match_issuer_records,
    explanation_continuing_the_dispute,
    setAttr: setPreArbResponseDetails
  } = prearbitration_response_details;
  const fieldWidth = 540;
  const reasonCode = disputeReasonNetworkMap[disputeReason]?.VISA || "";
  const showExplanationOfCardholderContinuesDispute = certify_that_cardholder_continues_dispute === true;
  const showExplanationOfWhyYouContinueDispute = certify_cardholder_details_dont_match_issuer_records === false;
  const handleOtherAmountChange = useCallback((value) => {
    setPreArbResponseDetails("partial_acceptance_amount", value);
  }, [setPreArbResponseDetails]);
  const handleGroupChange = useCallback((value) => {
    const {
      DECLINE,
      ACCEPT_PARTIAL_LIABILITY
    } = PREARB_RESPONSE_DECISIONS;
    setPreArbResponseDetails("prearb_response_decision", value === FULL_AMOUNT ? DECLINE : ACCEPT_PARTIAL_LIABILITY);
  }, [setPreArbResponseDetails]);
  const showPartialAmount = prearb_response_decision === PREARB_RESPONSE_DECISIONS.ACCEPT_PARTIAL_LIABILITY;
  const errors = submitted ? visaPreArbResponseValidation : {};
  const handleSubmit = async () => {
    setSubmitted(true);
    if (!Object.keys(visaPreArbResponseValidation).length) {
      const success = await onCreateDisputeTransition();
      if (success) {
        hideForm();
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "visa-prearb-response-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Prearbitration response" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAmount$1, { disputeAmount: dispute_amount, disputeAmountError: errors.partial_acceptance_amount, onAmountGroupChange: handleGroupChange, onOtherAmountChange: handleOtherAmountChange, otherAmount: partial_acceptance_amount, isOtherAmount: showPartialAmount, labels: AMOUNT_LABELS, currencyCode }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: WHY_ARE_YOU_NOT_ACCEPTING_FULL_LIABILITY, value: why_are_you_not_accepting_liability, onChange: (e) => setPreArbResponseDetails("why_are_you_not_accepting_liability", e.target.value), width: fieldWidth, rows: 2, error: errors.why_are_you_not_accepting_liability, testId: "why_are_you_not_accepting_liability" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    reasonCode.includes("10") && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: certify_that_cardholder_continues_dispute, label: ISSUER_CERTIFIES_THAT_THEY_HAVE_CONTACTED, groupItems: RADIO_GROUP_ITEMS, onChange: (value) => setPreArbResponseDetails("certify_that_cardholder_continues_dispute", value), error: errors.certify_that_cardholder_continues_dispute, testId: "certify_that_cardholder_continues_dispute" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    showExplanationOfCardholderContinuesDispute && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$5.enclosedField, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: EXPLANATION_OF_WHY_THE_CARDHOLDER_CONTINUES_DISPUTE, value: explanation_cardholder_continues_dispute, onChange: (e) => setPreArbResponseDetails("explanation_cardholder_continues_dispute", e.target.value), width: fieldWidth, rows: 2, error: errors.explanation_cardholder_continues_dispute, testId: "explanation_cardholder_continues_dispute" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    reasonCode.includes("10") && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: certify_cardholder_details_dont_match_issuer_records, label: ISSUER_CERTIFIES_THAT_THE_CARDHOLDER_NAME_AND_ADDRESS, groupItems: RADIO_GROUP_ITEMS, onChange: (value) => setPreArbResponseDetails("certify_cardholder_details_dont_match_issuer_records", value), error: errors.certify_cardholder_details_dont_match_issuer_records, testId: "certify_cardholder_details_dont_match_issuer_records" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    showExplanationOfWhyYouContinueDispute && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles$5.enclosedField, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: EXPLANATION_OF_WHY_YOU_CONTINUE_DISPUTE, value: explanation_continuing_the_dispute, onChange: (e) => setPreArbResponseDetails("explanation_continuing_the_dispute", e.target.value), width: fieldWidth, rows: 2, error: errors.explanation_continuing_the_dispute, testId: "explanation_continuing_the_dispute" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Upload related files" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkTransitionDocumentsForm$1, { documentsStore, transitionDetails: prearbitration_response_details, aggregateAttachedContents, isAttachAvailable })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, testId: `action-button-${actionLabel}`, children: actionLabel })
    ] })
  ] });
}
VisaPreArbResponseForm.propTypes = {
  onCreateDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  documentsStore: PropTypes.object,
  currencyCode: PropTypes.string,
  disputeReason: PropTypes.string
};
VisaPreArbResponseForm.defaultProps = {
  onCreateDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {},
  documentsStore: {},
  isAttachAvailable: false
};
const VisaPreArbResponseForm$1 = observer(VisaPreArbResponseForm);
function VisaPreArbRequestForm({
  onCreateDisputeTransition,
  hideForm,
  newDisputeTransitionStore,
  documentsStore,
  isAttachAvailable,
  disputeReason,
  currencyCode
}) {
  const [submitted, setSubmitted] = useState(false);
  const [amountGroupValue, setAmountGroupValue] = useState(FULL_AMOUNT);
  const {
    visaPreArbRequestValidation,
    prearbAmountValidation,
    network_details,
    dispute_amount
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const {
    prearbitration_details = {},
    aggregateAttachedContents
  } = network_details || EMPTY_OBJECT;
  const {
    amount,
    why_are_you_initiating_prearbitration,
    setAttr: setPreArbDetails
  } = prearbitration_details || EMPTY_OBJECT;
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_PREARB];
  const errors = submitted ? visaPreArbRequestValidation : {};
  const handleOtherAmountChange = useCallback((value) => {
    setPreArbDetails("amount", value);
    setSubmitted(false);
  }, [setPreArbDetails, setSubmitted]);
  const handleSubmit = async () => {
    setSubmitted(true);
    const amountIsValid = amountGroupValue === FULL_AMOUNT || !prearbAmountValidation;
    if (!Object.keys(visaPreArbRequestValidation).length && amountIsValid) {
      let success = await onCreateDisputeTransition();
      if (success) {
        hideForm();
      }
    }
  };
  const reasonCode = disputeReasonNetworkMap[disputeReason]?.VISA;
  const reasonCodeLabel = `${reasonCode} ${sentenceCase(disputeReason)}`;
  const fieldWidth = 540;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "visa-prearb-request-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Pre-arbitration request" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAmount$1, { disputeAmount: dispute_amount, disputeAmountError: submitted ? prearbAmountValidation : "", onAmountGroupChange: setAmountGroupValue, onOtherAmountChange: handleOtherAmountChange, otherAmount: amount, isOtherAmount: amountGroupValue === OTHER_AMOUNT, labels: DISPUTE_AMOUNT_DEFAULT_LABELS, currencyCode }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Dispute reason:", withSpacer: true, children: reasonCodeLabel }, 1),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: WHY_ARE_YOU_INIT_PRE_ARB, value: why_are_you_initiating_prearbitration, onChange: (e) => setPreArbDetails("why_are_you_initiating_prearbitration", e.target.value), width: fieldWidth, rows: 2, error: errors.why_are_you_initiating_prearbitration, testId: "why_are_you_initiating_prearbitration" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Upload related files" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkTransitionDocumentsForm$1, { documentsStore, transitionDetails: prearbitration_details, aggregateAttachedContents, isAttachAvailable })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: actionLabel })
    ] })
  ] });
}
VisaPreArbRequestForm.propTypes = {
  onCreateDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object,
  documentsStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  disputeReason: PropTypes.string,
  currencyCode: PropTypes.string
};
VisaPreArbRequestForm.defaultProps = {
  onCreateDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {},
  documentsStore: {},
  isAttachAvailable: false,
  disputeReason: ""
};
const VisaPreArbRequestForm$1 = observer(VisaPreArbRequestForm);
function VisaArbRequestForm({
  createDisputeTransition,
  hideForm,
  newDisputeTransitionStore
}) {
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_ARB];
  const {
    memo,
    setDigDetails
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const handleSubmit = () => {
    createDisputeTransition();
    hideForm();
  };
  const memoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Internal note (optional)", tooltip: MEMO_TOOLTIP });
  const fullFieldWidth = 540;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "visa-arb-request-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Arbitration request" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: memoLabel, value: memo, onChange: (e) => setDigDetails("memo", e.target.value), width: fullFieldWidth, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: actionLabel })
    ] })
  ] });
}
VisaArbRequestForm.propTypes = {
  createDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object
};
VisaArbRequestForm.defaultProps = {
  createDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {}
};
observer(VisaArbRequestForm);
function PulsePreArbRequestForm({
  onCreateDisputeTransition,
  hideForm,
  newDisputeTransitionStore,
  disputeReason
}) {
  const [submitted, setSubmitted] = useState(false);
  const {
    setDigDetails,
    memo
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_PREARB];
  const errors = submitted ? [] : {};
  const handleSubmit = async () => {
    setSubmitted(true);
    if (!errors.length) {
      let success = await onCreateDisputeTransition();
      if (success) {
        hideForm();
      }
    }
  };
  const reasonCode = disputeReasonNetworkMap[disputeReason]?.PULSE;
  const reasonCodeLabel = `${reasonCode} ${sentenceCase(disputeReason)}`;
  const fieldWidth = 540;
  const memoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Internal note (optional)", tooltip: MEMO_TOOLTIP });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "pulse-prearb-request-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Pre-arbitration request" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Dispute reason:", withSpacer: true, children: reasonCodeLabel }, 1),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: memoLabel, value: memo, onChange: (e) => setDigDetails("memo", e.target.value), width: fieldWidth, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, children: actionLabel })
    ] })
  ] });
}
PulsePreArbRequestForm.propTypes = {
  onCreateDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object,
  documentsStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  disputeReason: PropTypes.string,
  currencyCode: PropTypes.string
};
PulsePreArbRequestForm.defaultProps = {
  onCreateDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {},
  documentsStore: {},
  isAttachAvailable: false,
  disputeReason: ""
};
const PulsePreArbRequestForm$1 = observer(PulsePreArbRequestForm);
function PulsePreArbResponseForm({
  onCreateDisputeTransition,
  hideForm,
  newDisputeTransitionStore,
  disputeReason
}) {
  const [submitted, setSubmitted] = useState(false);
  const actionLabel = ACTIONS_LABEL_MAP.DISPUTE[RESPOND_WITH_PREARB_RESPONSE];
  const {
    setDigDetails,
    memo
  } = newDisputeTransitionStore || EMPTY_OBJECT;
  const fieldWidth = 540;
  const memoLabel = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Internal note (optional)", tooltip: MEMO_TOOLTIP });
  const reasonCode = disputeReasonNetworkMap[disputeReason]?.PULSE;
  const reasonCodeLabel = `${reasonCode} ${sentenceCase(disputeReason)}`;
  const errors = submitted ? [] : {};
  const handleSubmit = async () => {
    setSubmitted(true);
    if (!errors.length) {
      const success = await onCreateDisputeTransition();
      if (success) {
        hideForm();
      }
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "pulse-prearb-response-form", className: styles$5.formPadding, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Prearbitration response" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: "Dispute reason:", withSpacer: true, children: reasonCodeLabel }, 1),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: memoLabel, value: memo, onChange: (e) => setDigDetails("memo", e.target.value), width: fieldWidth, rows: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { onClick: hideForm, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "link", className: styles$5.largeLineHeight, children: "Cancel" }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, testId: `action-button-${actionLabel}`, children: actionLabel })
    ] })
  ] });
}
PulsePreArbResponseForm.propTypes = {
  onCreateDisputeTransition: PropTypes.func,
  hideForm: PropTypes.func,
  newDisputeTransitionStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  documentsStore: PropTypes.object,
  currencyCode: PropTypes.string,
  disputeReason: PropTypes.string
};
PulsePreArbResponseForm.defaultProps = {
  onCreateDisputeTransition: () => {
  },
  hideForm: () => {
  },
  newDisputeTransitionStore: {},
  documentsStore: {},
  isAttachAvailable: false
};
const PulsePreArbResponseForm$1 = observer(PulsePreArbResponseForm);
function DisputeTransitionFormContainer({
  additionalSlot,
  allowableActions,
  createDisputeTransition,
  disputeType,
  documentsStore,
  newDisputeTransitionStore,
  isAttachAvailable,
  isVisa,
  disputeReason,
  isRegE,
  currencyCode
}) {
  const {
    action: action2,
    setAttr,
    setAction = () => {
    },
    memo,
    network
  } = newDisputeTransitionStore || {};
  const [isResponseFormVisible, showActionForm, hideActionForm] = useShowEntity(setAction);
  const [showModal, revealModal, hideModal] = useShowEntity(setAction, ACCEPT_AND_CLOSE);
  const setMemo = useCallback((e) => setAttr("memo", e.target.value), [setAttr]);
  const showAcceptLiability = useMemo(() => {
    const includesAcceptAndClose = allowableActions?.includes(ACCEPT_AND_CLOSE);
    return isRegE ? includesAcceptAndClose : includesAcceptAndClose && !allowableActions?.includes(CLOSE_WITH_CASE_WON);
  }, [allowableActions, isRegE]);
  const networkActions = NETWORK_FORM_ACTIONS[network];
  const formAction = networkActions?.find((action22) => allowableActions.includes(action22));
  const actionLabel = ACTIONS_LABEL_MAP[disputeType][formAction];
  const handleShowActionForm = () => {
    if (AUTOSUBMIT_FORM_ACTIONS.includes(formAction)) {
      setAction(formAction);
      createDisputeTransition();
    } else {
      showActionForm(formAction);
    }
  };
  const MastercardActionsMap = /* @__PURE__ */ new Map([[RESPOND_WITH_PREARB, /* @__PURE__ */ jsxRuntimeExports.jsx(MastercardPreArbRequestForm$1, { createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore, documentsStore, isAttachAvailable }, 1)], [RESPOND_WITH_ARB, /* @__PURE__ */ jsxRuntimeExports.jsx(MastercardArbRequestForm$1, { createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore }, 2)]]);
  const PulseActionsMap = /* @__PURE__ */ new Map([[RESPOND_WITH_PREARB_RESPONSE, /* @__PURE__ */ jsxRuntimeExports.jsx(PulsePreArbResponseForm$1, { onCreateDisputeTransition: createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore, isAttachAvailable, documentsStore, currencyCode, disputeReason }, 3)], [RESPOND_WITH_PREARB, /* @__PURE__ */ jsxRuntimeExports.jsx(PulsePreArbRequestForm$1, { onCreateDisputeTransition: createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore, isAttachAvailable, documentsStore, disputeReason, currencyCode }, 4)]]);
  const VisaActionsMap = /* @__PURE__ */ new Map([[RESPOND_WITH_PREARB_RESPONSE, /* @__PURE__ */ jsxRuntimeExports.jsx(VisaPreArbResponseForm$1, { onCreateDisputeTransition: createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore, isAttachAvailable, documentsStore, currencyCode, disputeReason }, 3)], [RESPOND_WITH_PREARB, /* @__PURE__ */ jsxRuntimeExports.jsx(VisaPreArbRequestForm$1, { onCreateDisputeTransition: createDisputeTransition, hideForm: hideActionForm, newDisputeTransitionStore, isAttachAvailable, documentsStore, disputeReason, currencyCode }, 4)]]);
  const responseForm = network === "VISA" ? VisaActionsMap.get(action2) : network === "MASTERCARD" ? MastercardActionsMap.get(action2) : network === "PULSE" ? PulseActionsMap.get(action2) : null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionResponseSection, { description: ACTION_WARNINGS_MAP.DISPUTE[formAction], isResponseFormVisible, responseForm, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "inline-flex", children: [
    showAcceptLiability && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { onClick: revealModal, testId: "accept-liability-button", children: ACTIONS_LABEL_MAP[disputeType][ACCEPT_AND_CLOSE] }),
      showModal && /* @__PURE__ */ jsxRuntimeExports.jsx(AcceptLiability$1, { additionalSlot, hideModal, memo, onSubmit: createDisputeTransition, setMemo, showModal }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 })
    ] }),
    Boolean(formAction) && /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { onClick: handleShowActionForm, iconType: "edit", testId: `dispute-transition_action-${formAction}`, children: actionLabel })
  ] }) });
}
DisputeTransitionFormContainer.propTypes = {
  additionalSlot: PropTypes.node,
  allowableActions: PropTypes.array,
  createDisputeTransition: PropTypes.func,
  disputeType: PropTypes.oneOf([DISPUTES.DISPUTE, DISPUTES.LEGACY_DISPUTE]),
  documentsStore: PropTypes.object,
  newDisputeTransitionStore: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  isVisa: PropTypes.bool,
  disputeReason: PropTypes.string,
  isRegE: PropTypes.bool,
  currencyCode: PropTypes.string
};
DisputeTransitionFormContainer.defaultProps = {
  additionalSlot: null,
  allowableActions: [],
  createDisputeTransition: () => {
  },
  disputeType: DISPUTES.DISPUTE,
  documentsStore: {},
  newDisputeTransitionStore: {},
  isAttachAvailable: false,
  isVisa: false,
  disputeReason: "",
  isRegE: false
};
const DisputeTransitionFormContainer$1 = observer(DisputeTransitionFormContainer);
const disputeTransitionDetails = "_disputeTransitionDetails_1pyou_1";
const s$b = {
  disputeTransitionDetails
};
function NetworkDisputeTransition({
  additionalSlot,
  aggregateAttachedContents,
  allowableActions,
  createDisputeTransition,
  disputesAccess,
  disputeType,
  documentsStore,
  isMostRecentTransition,
  newDisputeTransitionStore,
  transitionDetails = [],
  isAttachAvailable,
  isRegE,
  disputeReason,
  currencyCode
}) {
  const {
    network
  } = newDisputeTransitionStore || {};
  const showAcceptLiability = useMemo(() => allowableActions?.includes("ACCEPT_AND_CLOSE"), [allowableActions]);
  const networkActions = NETWORK_FORM_ACTIONS[network];
  const hasFormAction = networkActions?.some((action2) => allowableActions.includes(action2));
  const showActionAlertSection = hasFormAction || showAcceptLiability;
  const showResponseFormsContainer = isMostRecentTransition && newDisputeTransitionStore && showActionAlertSection && disputesAccess.hasRiskInternalRole;
  const showDocumentsList = Boolean(aggregateAttachedContents?.length);
  const hasDetails = transitionDetails?.some((data) => isPresent(data.get("value")));
  const hasDetailsAndDocuments = hasDetails || showDocumentsList;
  const isVisa = network === "VISA";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$b.disputeTransitionDetails, children: transitionDetails?.map((dataMap, i) => {
      const isLast = i === transitionDetails.length - 1;
      const label = dataMap.get("label");
      const val = dataMap.get("value");
      if (typeof val === "object") {
        const {
          columns: columns2,
          data
        } = val;
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label, withSpacer: !isLast, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { height: 200, defaultWidth: 100, maxColumnWidth: 1e4, minWidth: 8, automaticallySizeColumnWidth: true, testId: "volt-table", columns: columns2, data }) }, label);
      }
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label, withSpacer: !isLast, children: dataMap.get("value") }, label);
    }) }),
    showDocumentsList && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$b.disputeTransitionDetails, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Attachments" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocuments$1, { customFilter: (doc) => aggregateAttachedContents?.includes(doc.token), isEditing: false, isVisa: false, documentsStore })
    ] }),
    showResponseFormsContainer && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      hasDetailsAndDocuments && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionFormContainer$1, { additionalSlot, allowableActions, createDisputeTransition, disputeType, documentsStore, newDisputeTransitionStore, isAttachAvailable, isVisa, disputeReason, isRegE, currencyCode })
    ] })
  ] });
}
NetworkDisputeTransition.propTypes = {
  additionalSlot: PropTypes.node,
  aggregateAttachedContents: PropTypes.array,
  allowableActions: PropTypes.array,
  createDisputeTransition: PropTypes.func,
  disputesAccess: PropTypes.object,
  disputeType: PropTypes.oneOf([DISPUTES.DISPUTE, DISPUTES.LEGACY_DISPUTE]),
  documentsStore: PropTypes.object,
  isMostRecentTransition: PropTypes.bool,
  newDisputeTransitionStore: PropTypes.object,
  transitionDetails: PropTypes.array,
  isAttachAvailable: PropTypes.bool,
  disputeReason: PropTypes.string,
  isRegE: PropTypes.bool,
  currencyCode: PropTypes.string
};
NetworkDisputeTransition.defaultProps = {
  additionalSlot: null,
  aggregateAttachedContents: [],
  allowableActions: [],
  createDisputeTransition: () => {
  },
  disputesAccess: {},
  disputeType: DISPUTES.DISPUTE,
  documentsStore: {},
  isMostRecentTransition: false,
  newDisputeTransitionStore: {},
  transitionDetails: [],
  isAttachAvailable: false,
  disputeReason: "",
  isRegE: false
};
const NetworkDisputeTransition$1 = observer(NetworkDisputeTransition);
function TransitionContainer$1({
  additionalSlot,
  disputesAccess,
  disputeTransitions,
  documents: documents2,
  type,
  isAttachAvailable,
  isRegE,
  currencyCode
}) {
  const {
    allowableActions = [],
    createDisputeTransition,
    isActionable,
    itemsForRender = [],
    newDisputeTransitionStore = {}
  } = disputeTransitions || {};
  const lastItem = itemsForRender.length - 1;
  const [expanded, expand] = useAccordion(lastItem);
  if (!itemsForRender.length) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { type: "large", text: "No responses yet", testId: "sections-empty", iconType: "empty-state-folder" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] });
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { spaceBetween: "24px", contentInset: "-4px", divideSections: true, resetSectionsState: true, sections: itemsForRender?.map((transition, i) => {
    const {
      aggregateAttachedContents,
      details,
      hasSectionContent,
      header,
      disputeReason
    } = transition;
    const {
      formattedLabel,
      formattedTime,
      key,
      participantName
    } = header;
    const isMostRecentTransition = itemsForRender?.length - 1 === i;
    const hideContent = !isActionable && !hasSectionContent;
    return {
      expand: expanded.has(i),
      title: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionHeader$1, { time: formattedTime, label: formattedLabel, participantName }),
      key,
      hideContent,
      defaultExpanded: isMostRecentTransition,
      onToggleExpansion: () => expand(i),
      content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$5.accordionContent, children: /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkDisputeTransition$1, { additionalSlot, disputesAccess, aggregateAttachedContents, allowableActions: Array.from(allowableActions), createDisputeTransition, disputeType: type, documentsStore: documents2, isMostRecentTransition, newDisputeTransitionStore, transitionDetails: details, isAttachAvailable, disputeReason, isRegE, currencyCode }) }),
      overrideDivider: isMostRecentTransition
    };
  }) });
}
TransitionContainer$1.propTypes = {
  additionalSlot: PropTypes.node,
  disputesAccess: PropTypes.object,
  disputeTransitions: PropTypes.object,
  type: PropTypes.string,
  documents: PropTypes.object,
  isAttachAvailable: PropTypes.bool,
  isRegE: PropTypes.bool,
  currencyCode: PropTypes.string
};
TransitionContainer$1.defaultProps = {
  additionalSlot: null,
  disputesAccess: {},
  disputeTransitions: {},
  type: DISPUTES.DISPUTE,
  documents: {},
  isAttachAvailable: false,
  isRegE: false
};
const TransitionContainer$2 = observer(TransitionContainer$1);
const menuOption = "_menuOption_g9io7_1";
const menuOptionWrapper = "_menuOptionWrapper_g9io7_7";
const styles$3 = {
  menuOption,
  menuOptionWrapper
};
const TEXT = "No Visa responses captured here";
const SUBTEXT = "All Visa backend responses are managed in VROL, transition this dispute after the case has been resolved in VROL.";
function TransitionContainer({
  additionalSlot,
  disputesAccess,
  dispute_transitions,
  type
}) {
  const {
    allowableActions = [],
    createDisputeTransition,
    newDisputeTransitionStore
  } = dispute_transitions || EMPTY_OBJECT;
  const {
    action: action2,
    memo,
    setAction = () => {
    },
    setAttr = () => {
    }
  } = newDisputeTransitionStore || {};
  const [isModalVisible, setIsModalVisible] = useState(false);
  const toggleModalVisibility = useCallback(() => {
    setIsModalVisible((state) => !state);
    setAttr("memo", "");
  }, [setAttr]);
  const handleSubmitFromModal = useCallback(() => {
    createDisputeTransition();
    toggleModalVisibility();
  }, [createDisputeTransition, toggleModalVisibility]);
  const handleActionClick = useCallback((action22) => {
    setAction(action22);
    toggleModalVisibility();
  }, [setAction, toggleModalVisibility]);
  const setMemo = (e) => setAttr("memo", e.target.value);
  const allowableRelatedActions = useMemo(() => [ACCEPT_AND_CLOSE, CLOSE_WITH_CASE_WON].filter((action22) => allowableActions.includes(action22)), [allowableActions]);
  const isActionable = useMemo(() => Boolean(allowableRelatedActions.length) && disputesAccess.hasRiskInternalRole, [allowableRelatedActions.length, disputesAccess.hasRiskInternalRole]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: globalStyles.textAlignCenter, children: /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { type: "large", text: TEXT, subText: SUBTEXT, testId: "sections-empty", iconType: "empty-state-folder" }) }),
    isActionable && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { noIcon: true, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RawDropdown, { contentPadding: 0, control: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { testId: "transition-legacy-dispute-action-button", iconType: "caret-down", position: "right", children: "Transition dispute" }), children: /* @__PURE__ */ jsxRuntimeExports.jsx("ul", { children: allowableRelatedActions.map((action22) => /* @__PURE__ */ jsxRuntimeExports.jsx("li", { className: styles$3.menuOptionWrapper, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ActionButton$1, { className: styles$3.menuOption, onClick: () => handleActionClick(action22), iconType: ACTION_ICONS.get(action22), children: ACTIONS_LABEL_MAP.DISPUTE[action22] }) }, action22)) }) }) })
    ] }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionModal$1, { action: action2, additionalSlot, disputeType: type, hideModal: toggleModalVisibility, memo, onSubmit: handleSubmitFromModal, setMemo })
  ] });
}
TransitionContainer.propTypes = {
  additionalSlot: PropTypes.node,
  disputesAccess: PropTypes.object,
  dispute_transitions: PropTypes.object,
  type: PropTypes.string
};
TransitionContainer.defaultProps = {
  additionalSlot: null,
  disputesAccess: {},
  dispute_transitions: {},
  type: "DISPUTE"
};
observer(TransitionContainer);
function DisputeDocumentsForm({
  documentsStore = {},
  isAttachAvailable,
  isVisa,
  isMastercard,
  onAttachClick,
  detachFile,
  error
}) {
  const {
    loading = false,
    count
  } = documentsStore;
  const text = isMastercard ? MC_TEXT : VISA_TEXT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", children: text }),
    isAttachAvailable && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loading, children: [
      isAttachAvailable && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$d.uploadButtonWrap, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: onAttachClick, testId: "upload-document", type: "tertiary", children: "Attach files" }),
        !!error && /* @__PURE__ */ jsxRuntimeExports.jsx(FormError, { children: error })
      ] }),
      !!count && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: isAttachAvailable ? 3 : 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocuments$1, { isEditing: true, customFilter: (file) => file.isAttached, detachFile, isVisa, documentsStore })
      ] })
    ] })
  ] });
}
DisputeDocumentsForm.propTypes = {
  onAttachClick: PropTypes.func.isRequired,
  detachFile: PropTypes.func,
  documentsStore: PropTypes.object,
  isVisa: PropTypes.bool,
  isMastercard: PropTypes.bool,
  isAttachAvailable: PropTypes.bool,
  error: PropTypes.string
};
DisputeDocumentsForm.defaultProps = {
  detachFile: () => {
  },
  documentsStore: {},
  isVisa: false,
  isMastercard: false,
  isAttachAvailable: false,
  error: ""
};
const DisputeDocumentsForm$1 = observer(DisputeDocumentsForm);
function DisputeFromTransactionModal({
  transactionOrigin,
  hideModal,
  disputeState
}) {
  const wasCreated = disputeState ? allCaps(disputeState).includes("OPEN") : true;
  const {
    removeCreationOrigin
  } = disputeStorage || {};
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: hideModal, children: "Continue" }, "continue-btn")];
  const backToTransactions = () => {
    removeCreationOrigin();
    window.location.href = transactionOrigin;
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { heading: wasCreated ? createFromTransactionsModalHeading : editFromTransactionsModalHeading, hideModal: backToTransactions, hideModalButtonText: "Return to transactions", footerButtons, width: "400px", testId: "dispute-creation-origin-redirect-modal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: wasCreated ? createFromTransactionModalText : editFromTransactionModalText }) });
}
DisputeFromTransactionModal.propTypes = {
  transactionOrigin: PropTypes.func,
  hideModal: PropTypes.func,
  disputeState: PropTypes.string
};
DisputeFromTransactionModal.defaultProps = {
  transactionOrigin: null,
  hideModal: null,
  disputeState: "OPEN"
};
const DisputeFromTransactionModal$1 = observer(DisputeFromTransactionModal);
const DISPUTE_DETAILS_MAP = {
  assignee: "Case assignee",
  formattedCardholderContactDate: "Cardholder contact date",
  formattedDisputeAmountWithCurrency: "Dispute amount",
  formattedDisputeAmountChangeReason: "Dispute amount change reason",
  formattedDisputeReason: "Dispute reason",
  dispute_reason_code: "Dispute reason code",
  formattedFraudTypeClassification: "Fraud Type Classification",
  formattedDisputeCategory: "Dispute category",
  formattedExceptionReasonApply: "Does any exception or good reason apply?",
  formattedRefundConditions: "Does the case meet the refund condition?",
  memo: "Notes",
  network_comment: "Comments",
  formattedChipOnCard: "Does the card have a chip?",
  formattedRegulationConditionsMetDate: "Refund conditions met date"
};
const BACKEND_RESOLUTION$2 = "Backend resolution";
const SUBMISSION_DETAILS$1 = "Submission details";
const TRANSITION_HISTORY$1 = "Transition history";
const RELATED_TRANSACTIONS$1 = "Related transactions";
const COMMUNICATION_HISTORY$1 = "Communication history";
const DISPUTE_DETAILS_TABS = {
  BACKEND_RESOLUTION: BACKEND_RESOLUTION$2,
  SUBMISSION_DETAILS: SUBMISSION_DETAILS$1,
  TRANSITION_HISTORY: TRANSITION_HISTORY$1,
  RELATED_TRANSACTIONS: RELATED_TRANSACTIONS$1,
  COMMUNICATION_HISTORY: COMMUNICATION_HISTORY$1
};
const ORDERED_DISPUTE_DETAILS_TABS = [BACKEND_RESOLUTION$2, SUBMISSION_DETAILS$1, RELATED_TRANSACTIONS$1, TRANSITION_HISTORY$1, COMMUNICATION_HISTORY$1];
const DEFAULT_DISPUTE_DETAILS_TABS = [SUBMISSION_DETAILS$1, TRANSITION_HISTORY$1];
if (flipFlop.get("create-salesforce-ticket-email-communication", false)) {
  DEFAULT_DISPUTE_DETAILS_TABS.push(COMMUNICATION_HISTORY$1);
}
const TRANSITION_NOTE_MODAL_TYPES = {
  CLOSE: {
    action: TRANSITION_ACTIONS.CLOSE,
    heading: "Close case",
    buttonText: "Close case",
    isOptional: true,
    withAlert: true,
    testId: "close-case"
  },
  REVIEW: {
    action: TRANSITION_ACTIONS.REVIEW,
    heading: "Mark as ready",
    buttonText: "Mark as ready",
    isOptional: false,
    withAlert: false,
    testId: "mark-as-ready-case"
  },
  RE_OPEN: {
    action: TRANSITION_ACTIONS.RE_OPEN,
    heading: "Reopen case",
    buttonText: "Reopen",
    isOptional: false,
    withAlert: false,
    testId: "reopen-case"
  },
  WITHDRAW_AND_CLOSE: {
    action: TRANSITION_ACTIONS.WITHDRAW_AND_CLOSE,
    heading: "Close case",
    buttonText: "Close case",
    isOptional: true,
    withAlert: true,
    testId: "close-case"
  }
};
const PROVISIONAL_CREDIT_STATUSES = {
  PENDING_PC_GRANTED: "Not granted",
  PC_GRANTED: "Granted",
  PENDING_PC_REVERSAL: "Pending reversal",
  PC_PERM: "Permanent",
  PC_REVERSED: "Reversed"
};
const ACTION_TYPES = {
  GRANT_PROVISIONAL_CREDIT: "GRANT_PROVISIONAL_CREDIT"
};
const ACTION_TYPES_MESSAGES = {
  GRANT_PROVISIONAL_CREDIT: "Provisional credit granted",
  DEFAULT: "Case action submitted"
};
const EVENT_TYPES = {
  CASE_LOST_NOTIFICATION_SENT: "CaseLostNotificationSent",
  PC_GRANTED_EVENT_NAME: "ProvisionalCreditGranted"
};
const EVENT_TYPES_MESSAGES = {
  CaseLostNotificationSent: "Communication date submitted",
  DEFAULT: "Case event submitted"
};
const ENTER_COMMUNICATION_DATE_CTA = "Click here to enter communication date";
const ENTER_COMMUNICATION_DATE_MODAL_TEXT = `Confirm the date and time that you notified the cardholder of
 the network decision to close the case.`;
const CARDHOLDER_COMMUNICATION_TIME_LABEL = "Cardholder communication time";
const CLOSE_CASE_TRANSITION_NOTE_MODAL_TEXT = "A case cannot be reopened once it has been closed. Are you sure you want to proceed?";
const REQUIRED_DOCUMENTATION_TEXT = "Please note, if this case is submitted without the required documentation the case could be lost.";
const CONVERT_TO_NON_INTEGRATED_TEXT = "If updates are not syncing correctly with the network then this dispute can be converted to a non-integrated case.";
const CONVERT_TO_NON_INTEGRATED_MODAL_ALERT = "Once this dispute is converted to a non integrated case this action cannot be undone.";
const CONVERTED_TO_NON_INTEGRATED_HISTORY = "Converted to non-integrated case";
const ATTR_WIDTH$1 = "33.3%";
const COMMUNICATION_TIME_IS_REQUIRED = "Cardholder communication time is required";
const COMMUNICATION_TIME_IN_FUTURE = "Cardholder contact date must not be in the future.";
const formatPCBannerCTAText = (str, creditType) => `You are about to issue a ${str} ${creditType} credit for this case. Ensure that the credit amount is correct.`;
const formatPCSubmitNetworkText = (str, creditType) => `A ${str} ${creditType} credit must be issued for this case before submitting to the network. Ensure that the credit amount is correct.`;
const DISPUTE_OTHER_AMOUNT_NOT_EQUAL_TO_ATR_SUM = "The dispute amount entered is inconsistent with the ATR selection. Please review before network submission.";
const pcIssuanceErrorText = (creditType) => `Either Mark as ready to save the changes made on this page, or reload the page to reset them before issuing a ${creditType} credit.`;
const NETWORK_RULES_FAILURE_REASONS = {
  "Dispute is invalid under Dispute Condition 10.4 for a Visa Secure transaction.": "Dispute is invalid (10.4): Visa Secure transaction.",
  "Dispute is invalid under Dispute Condition 10.4, as more than 35 disputes were processed within 120 calendar days of this dispute.": "Dispute is invalid (10.4): More than 35 disputes were processed within 120 calendar days of this dispute."
};
const SALESFORCE_CASE_RECORD_TYPE = "Dispute Intake";
const SALESFORCE_CONTACT_TYPES = {
  PRIMARY: "Primary Disputes Contact",
  SECONDARY: "Secondary Disputes Contact"
};
function TransitionCaseWithNoteModal(props) {
  const {
    transitionCase,
    hide,
    memo,
    onMemoChange,
    heading,
    buttonText,
    isOptional,
    withAlert,
    testId,
    withRequiredDocumentationAlert
  } = props;
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: `${heading}-transition-button`, onClick: transitionCase, children: buttonText }, `${heading}-transition-button`)];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { heading, buttonText, hideModalButtonText: "Cancel", hideModal: hide, testId: `${testId}-transition-modal`, showHideModalButton: true, footerButtons, children: [
    withAlert && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: CLOSE_CASE_TRANSITION_NOTE_MODAL_TEXT }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    withRequiredDocumentationAlert && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: REQUIRED_DOCUMENTATION_TEXT }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: "Transition note", labelOptional: isOptional, onChange: (e) => onMemoChange(e.target.value), value: memo, width: 540 })
  ] });
}
TransitionCaseWithNoteModal.propTypes = {
  memo: PropTypes.string,
  onMemoChange: PropTypes.func,
  transitionCase: PropTypes.func,
  hide: PropTypes.func,
  heading: PropTypes.string,
  buttonText: PropTypes.string,
  isOptional: PropTypes.bool,
  withAlert: PropTypes.bool,
  withRequiredDocumentationAlert: PropTypes.bool,
  testId: PropTypes.string
};
TransitionCaseWithNoteModal.defaultProps = {
  memo: "",
  onMemoChange: () => {
  },
  transitionCase: () => {
  },
  hide: () => {
  },
  heading: "",
  buttonText: "",
  isOptional: false,
  withAlert: false,
  withRequiredDocumentationAlert: false,
  testId: ""
};
const dateTimeInput = "_dateTimeInput_106vg_1";
const dateTimeInputError = "_dateTimeInputError_106vg_39";
const s$a = {
  dateTimeInput,
  dateTimeInputError
};
function DateTimeInput({
  formLabel,
  testId,
  inputId,
  value,
  onChange,
  error,
  disabled,
  customStyles,
  max,
  min
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { disabled: false, labelFor: inputId, size: "small", children: formLabel }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "datetime-local", "data-testid": testId, className: classUtil(s$a.dateTimeInput, !!error && s$a.dateTimeInputError), style: customStyles, id: inputId, value, onChange: (e) => onChange(e.target.value), disabled, max: formatDateForDateTimeInput(max), min: formatDateForDateTimeInput(min) }),
    error && /* @__PURE__ */ jsxRuntimeExports.jsx(FormError, { children: error }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
DateTimeInput.propTypes = {
  formLabel: PropTypes.string,
  testId: PropTypes.string,
  inputId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  customStyles: PropTypes.object,
  min: PropTypes.string,
  max: PropTypes.string
};
DateTimeInput.defaultProps = {
  formLabel: "",
  testId: "",
  value: "",
  inputId: "",
  onChange: () => {
  },
  error: "",
  disabled: false,
  customStyles: {},
  min: "",
  max: ""
};
const formatProcessingType = (type) => {
  const messages = /* @__PURE__ */ new Map([["MAGSTRIPE", "Stripe"], ["CHIP", "Chip"], ["CHIP FALLBACK", "Chip Fallback"], ["UNKNOWN", "Other"]]);
  return messages.get(type) || "";
};
const formatDisputeSubject = ({
  caseToken,
  currency_code,
  reason = "",
  request_amount,
  token
}) => `Service Dispute: ${reason} | ${token} | ${caseToken} (${convertNumberToCurrency(request_amount, currency_code)})`;
const formatDisputeBody = (data) => {
  const {
    card,
    cardAcceptor,
    cardholder,
    disputeAmount,
    memo = "",
    processingType,
    program,
    reason,
    token,
    transactionAmount,
    transactionDate,
    user
  } = data;
  const {
    email,
    firstName,
    lastName
  } = user;
  const disputeDate = formatDateAsUTCString(/* @__PURE__ */ new Date());
  return `${program} would like to file a Service Dispute for ${reason}.
        Program: ${program}
        Submitter Name: ${firstName} ${lastName}
        Submitter Email: ${email}
        Submission Date: ${disputeDate}
        Customer Notification Date: ${disputeDate}

        Name on Card: ${cardholder}
        Card Number: **${card.last_four}
        Card Expiration: ${card.expiration.slice(0, 2)}/${card.expiration.slice(-2)}
        Card State: ${card.state}

        Merchant: ${cardAcceptor}
        Transaction Amount: ${transactionAmount}
        Transaction Date: ${transactionDate}
        Processing Type: ${processingType}
        Transaction ID: ${token}

        Dispute Amount: ${disputeAmount}
        Dispute Reason: ${reason}
        ${memo ? `Dispute Note: ${memo}` : ""}
      `;
};
const getLegacyOptionsFromReasonMap = (key) => LEGACY_DISPUTE_REASONS_MAP.get(key);
const getLegacyDisputeReasons = (network, subNetwork) => {
  const alwaysReasons = LEGACY_DISPUTE_REASONS_BY_NETWORK.ALWAYS;
  if (!network) {
    return alwaysReasons;
  }
  if (network === "MASTERCARD" && subNetwork !== "MAESTRO") {
    return alwaysReasons;
  }
  const networkReasons = LEGACY_DISPUTE_REASONS_BY_NETWORK[network];
  const subNetworkReasons = ONLY_WITH_SUB_NETWORK_DISPUTES[subNetwork] || [];
  if (subNetworkReasons.length === 0) {
    return [...alwaysReasons, ...networkReasons];
  }
  const includingSubNetworkOptions = networkReasons.filter((reason) => subNetworkReasons.includes(reason));
  return [...alwaysReasons, ...includingSubNetworkOptions];
};
const getZendeskData = ({
  amount,
  card,
  cardAcceptor,
  cardholder_transaction_time,
  cardholder,
  currency_code,
  memo,
  program_short_code,
  reason = "",
  transaction
}) => {
  const {
    redsea_first_name,
    redsea_last_name,
    redsea_email
  } = getFieldsFromStorage(["redsea_first_name", "redsea_last_name", "redsea_email"]);
  const userInfo = {
    email: redsea_email,
    firstName: redsea_first_name,
    lastName: redsea_last_name
  };
  const disputeBody = {
    card,
    cardAcceptor,
    cardholder: cardholder?.fullName ?? "",
    memo,
    processingType: formatProcessingType(transaction?.cardAcceptorType),
    program: program_short_code,
    reason,
    transactionAmount: convertNumberToCurrency(transaction?.request_amount, transaction?.currency_code),
    disputeAmount: convertNumberToCurrency(amount, currency_code),
    transactionDate: formatDateAsUTCString(cardholder_transaction_time),
    token: transaction?.token ?? "",
    user: userInfo
  };
  return {
    disputeBody,
    userInfo
  };
};
const findByNetworkAndCode = (network, reasonCode) => {
  return Object.values(disputeReasonNetworkMap).find((value) => value[network] === reasonCode);
};
const container = "_container_1octk_1";
const s$9 = {
  container
};
function FraudReportForm({
  fraudType,
  onFraudTypeChange,
  dispute
}) {
  const {
    formSubmitted,
    formValidation
  } = dispute || EMPTY_OBJECT;
  const {
    fraud_type
  } = baseDisputeFormFields || EMPTY_OBJECT;
  const {
    label,
    testId
  } = fraud_type;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$9.container, "data-testid": "fraud-report-form", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Fraud report" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.5 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "footnote", children: FRAUD_REPORT_TEXT }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label, value: fraudType, placeholder: "Select type", options: FRAUD_TYPE_OPTIONS, onChange: onFraudTypeChange, error: formSubmitted ? formValidation["fraud_type"] : "", testId })
  ] });
}
FraudReportForm.propTypes = {
  dispute: PropTypes.object,
  fraudType: PropTypes.string,
  onFraudTypeChange: PropTypes.func
};
FraudReportForm.defaultProps = {
  dispute: {},
  fraudType: "",
  onFraudTypeChange: () => {
  }
};
const FraudReportForm$1 = observer(FraudReportForm);
const root$9 = "_root_1t4gl_1";
const selectGroup = "_selectGroup_1t4gl_6";
const s$8 = {
  root: root$9,
  selectGroup
};
const SPACE_KEY_CODE = 32;
const timeStructureRegex = /^([01]?[0-9]|2[0123])(:[0-5][0-9])?/i;
function InputTime({
  label,
  error,
  testId = "time",
  value,
  onChange,
  width
}) {
  const [inputError, setInputError] = k$1.useState("");
  const timeFormatWidth = 142;
  const inputWidth = width ? width - timeFormatWidth : 540 - timeFormatWidth;
  const [comingTime, comingPeriod] = k$1.useMemo(() => {
    let currentPeriod = "AM";
    let currentTime = "";
    if (timeStructureRegex.test(value)) {
      const [time, period = "AM"] = value.split(" ");
      currentPeriod = period;
      currentTime = time;
    }
    return [currentTime, currentPeriod];
  }, [value]);
  const handleChange = k$1.useCallback((e) => {
    const newTime = e.target.value.replace(/ /g, "");
    if (isPresent(newTime)) {
      onChange(`${newTime} ${comingPeriod}`);
    } else {
      onChange(null);
    }
  }, [onChange, comingPeriod, setInputError]);
  const handleSpacePress = k$1.useCallback((e) => {
    if (e.keyCode === SPACE_KEY_CODE) {
      e.preventDefault();
    }
  });
  const handleChangePeriod = k$1.useCallback((newPeriod) => {
    onChange(`${comingTime} ${newPeriod}`);
  }, [onChange, comingTime]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": testId, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { testId: `${testId}-label`, children: label }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$8.root, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { width: inputWidth, placeholder: "HH:MM", value: comingTime, onChange: handleChange, error: error ? error : inputError, onKeyDown: handleSpacePress }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$8.selectGroup, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { width: "60px", value: comingPeriod, options: ["AM", "PM"], onChange: handleChangePeriod }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", children: "local time" })
      ] })
    ] })
  ] });
}
InputTime.propTypes = {
  label: PropTypes.string,
  error: PropTypes.string,
  testId: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  width: PropTypes.any
};
InputTime.defaultProps = {
  label: "input-time",
  error: "",
  testId: "time",
  value: "",
  onChange: () => {
  },
  width: void 0
};
const TYPE_OPTIONS$1 = {
  HIDDEN: "Hidden",
  INPUT: "Input",
  MESSAGE: "Message",
  NUMBER: "Number",
  RADIO_GROUP: "RadioGroup",
  SELECT: "Select",
  TEXTAREA: "Textarea",
  DATE: "Date",
  TIME: "Time",
  CHECKBOX: "Checkbox"
};
const {
  HIDDEN: HIDDEN$1,
  INPUT,
  MESSAGE,
  NUMBER,
  RADIO_GROUP: RADIO_GROUP$1,
  SELECT,
  TEXTAREA,
  DATE,
  TIME,
  CHECKBOX
} = TYPE_OPTIONS$1;
const RETURN_METHOD_OPTIONS = [{
  val: "FACE_TO_FACE",
  render: "Face to face"
}, {
  val: "FED_EX",
  render: "FedEx"
}, {
  val: "DHL",
  render: "DHL"
}, {
  val: "UPS",
  render: "UPS"
}, {
  val: "POSTAL_SERVICE",
  render: "Postal service"
}, {
  val: "OTHER",
  render: "Other"
}];
const timeError = "Time entry is not in the correct 12 hour format.";
const timeValidation = (value) => isValidTime(value) ? "" : timeError;
const truthyValidation = (value) => value ? "" : REQUIRED_FIELD_ERROR;
const currencies = [{
  code: "CAD",
  number: "124"
}, {
  code: "EUR",
  number: "978"
}, {
  code: "GBP",
  number: "826"
}, {
  code: "USD",
  number: "840"
}];
const FIELDS_KEY_MAP = {
  INCORRECT_TRANSACTION_AMOUNT_DETAILS_CONTAINER: "incorrect_transaction_amount_details_container",
  INCORRECT_TRANSACTION_AMOUNT_DETAILS: "incorrect_transaction_amount_details",
  NONAPI_WHAT_IS_THE_AMOUNT_ON_THE_CARDHOLDERS_RECEIPT: "nonAPI_what_is_the_amount_on_the_cardholders_receipt",
  WHAT_IS_THE_AMOUNT_ON_THE_CARDHOLDERS_RECEIPT: "what_is_the_amount_on_the_cardholders_receipt",
  WHAT_IS_THE_CURRENCY_ON_THE_CARDHOLDERS_RECEIPT: "what_is_the_currency_on_the_cardholders_receipt",
  IS_DIFFERENCE_BETWEEN_PRICES: "is_the_dispute_due_to_the_difference_between_quoted_price_and_actual_charges_made_by_the_merchant"
};
const CARDHOLDER_DID_NOT_ATTEMPT_LABEL = "Cardholder did not attempt to return purchase";
const hasOctoberNetworkMandate = flipFlop.get("october-network-mandate", false);
const MERCHANT_REFUSED_SERVICES_ADDITIONAL_FIELDS = [{
  val: "MERCHANT_NO_LONGER_EXISTS_OR_IS_NOT_RESPONDING",
  render: "Merchant no longer exists or is not responding"
}, {
  val: "MERCHANT_DID_NOT_PROVIDE_CLEAR_INSTRUCTION_ON_HOW_TO_RETURN",
  render: "Merchant did not provide clear instruction on how to return"
}];
const DID_THE_CARDHOLDER_ATTEMPT_TO_RESOLVE_THE_DISPUTE_WITH_THE_MERCHANT = {
  label: "Did the cardholder attempt to resolve the dispute with the merchant?",
  field: "did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant",
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  children: [{
    field: "is_attempt_to_resolve_prohibited_by_local_law_or_regulations",
    type: HIDDEN$1,
    key: generateId(),
    parentRequirement: [false],
    initValue: true
  }]
};
const octoberNetworkMandate$1 = flipFlop.get("october-network-mandate", false);
const ATTEMPT_AND_DISPOSITION_OF_MERCHANDISE = [{
  label: "Provide a detailed description of how the cardholder attempted to return merchandise",
  field: "provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise",
  type: TEXTAREA,
  parentRequirement: [true],
  key: generateId()
}, {
  label: "What is the disposition of the merchandise",
  field: "what_is_the_disposition_of_the_merchandise",
  type: TEXTAREA,
  parentRequirement: [true],
  key: generateId()
}];
const COMBINED_ATTEMPT_AND_DISPOSITION_OF_MERCHANDISE = [{
  label: "Provide a detailed description of how the cardholder attempted to return and the disposition of the merchandise",
  field: "provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise",
  type: TEXTAREA,
  parentRequirement: [true],
  key: generateId()
}];
const DID_THE_CARDHOLDER_RETURN_THE_MERCHANDISE = {
  label: "Did the cardholder return the merchandise?",
  field: "did_the_cardholder_return_the_merchandise",
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  children: [{
    label: "Date the cardholder returned the merchandise",
    field: "date_cardholder_returned_the_merchandise",
    type: DATE,
    key: generateId(),
    parentRequirement: [true]
  }, {
    label: "Date merchant received the returned merchandise",
    field: "date_merchant_received_the_returned_merchandise",
    type: DATE,
    key: generateId(),
    parentRequirement: [true]
  }, {
    label: "Return method",
    field: "return_method",
    key: generateId(),
    type: SELECT,
    parentRequirement: [true],
    options: [{
      val: "FACE_TO_FACE",
      render: "Face to Face"
    }, {
      val: "FED_EX",
      render: "Fed Ex"
    }, {
      val: "DHL",
      render: "DHL"
    }, {
      val: "UPS",
      render: "UPS"
    }, {
      val: "POSTAL_SERVICE",
      render: "Postal Service"
    }, {
      val: "OTHER",
      render: "Other"
    }],
    children: [{
      field: "tracking_number",
      label: "Tracking number",
      type: INPUT,
      optional: true,
      key: generateId(),
      parentRequirement: ["FED_EX", "DHL", "UPS", "POSTAL_SERVICE"]
    }, {
      field: "explain_how_the_merchandise_was_returned",
      label: "Explain how the merchandise was returned",
      type: INPUT,
      parentRequirement: ["OTHER"],
      key: generateId()
    }]
  }, {
    label: "Did the cardholder attempt to return the merchandise?",
    field: "did_the_cardholder_attempt_to_return_the_merchandise",
    type: RADIO_GROUP$1,
    key: generateId(),
    parentRequirement: [false],
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    children: [{
      label: "Date of attempted return",
      field: "date_of_attempted_return",
      type: DATE,
      key: generateId(),
      parentRequirement: [true]
    }, ...octoberNetworkMandate$1 ? ATTEMPT_AND_DISPOSITION_OF_MERCHANDISE : COMBINED_ATTEMPT_AND_DISPOSITION_OF_MERCHANDISE, {
      label: "Provide certification of one of the following",
      field: "merchant_refuse_advise",
      type: SELECT,
      parentRequirement: [true],
      options: [{
        val: "MERCHANT_REFUSED_RETURN_AUTHORIZATION",
        render: "Merchant refused to provide return authorization"
      }, {
        val: "MERCHANT_REFUSED_TO_ACCEPT_RETURNED_MERCHANDISE",
        render: "Merchant refused to accept returned merchandise"
      }, {
        val: "MERCHANT_INFORMED_CARDHOLDER_NOT_TO_RETURN_MERCHANDISE",
        render: "Merchant informed cardholder not to return the merchandise"
      }, ...hasOctoberNetworkMandate ? MERCHANT_REFUSED_SERVICES_ADDITIONAL_FIELDS : []],
      key: generateId()
    }, {
      type: MESSAGE,
      field: "return_attemp_error",
      validation: truthyValidation,
      format: "error",
      key: generateId(),
      label: `Dispute is invalid as the cardholder failed to make a valid attempt to return the merchandise`,
      parentRequirement: [false]
    }]
  }]
};
const EVIDENCE_FIELDS = {
  children: [{
    label: "Is there evidence of previous ongoing negotiations between the cardholder and merchant?",
    field: "cardholder_merchant_previous_negotiation_evidence",
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    children: [{
      label: "When did the negotiations begin?",
      field: "when_negotiations_begin",
      type: DATE,
      key: generateId(),
      parentRequirement: [true]
    }, {
      label: "Explain the previous ongoing negotiation between the cardholder and merchant",
      field: "explain_prev_negotiation",
      type: TEXTAREA,
      key: generateId(),
      parentRequirement: [true]
    }],
    /**
     * check if date_merchandise_or_service_was_received
     * AND transactionCreatedAt is 120 days ago
     **/
    shouldDisplayField: (parentValue, settlementDate) => {
      if (!isValidDate(parentValue)) {
        return false;
      }
      const transactionDate = new Date(settlementDate);
      if (!isValidDate(transactionDate)) {
        return false;
      }
      const daysAgo120 = /* @__PURE__ */ new Date();
      daysAgo120.setDate(daysAgo120.getDate() - 120);
      const merchOrServiceReceivedDate = new Date(parentValue);
      if (merchOrServiceReceivedDate < daysAgo120 && transactionDate < daysAgo120) {
        return true;
      }
      return false;
    }
  }]
};
const DEFECTIVE_FIELDS = [{
  field: "what_was_ordered_and_how_it_was_damaged_or_defective",
  label: "What was ordered and how it was damaged or defective?",
  type: TEXTAREA,
  key: generateId(),
  parentRequirement: ["DEFECTIVE"]
}, {
  field: "date_merchandise_was_received",
  label: "Date merchandise was received",
  type: DATE,
  parentRequirement: ["DEFECTIVE"],
  ...EVIDENCE_FIELDS
}, {
  ...DID_THE_CARDHOLDER_ATTEMPT_TO_RESOLVE_THE_DISPUTE_WITH_THE_MERCHANT,
  parentRequirement: ["DEFECTIVE"]
}, {
  ...DID_THE_CARDHOLDER_RETURN_THE_MERCHANDISE,
  parentRequirement: ["DEFECTIVE"]
}];
const NOT_AS_DESCRIBED_FIELDS = [{
  field: "merchandise_or_services",
  label: "Purchase type",
  type: HIDDEN$1,
  key: generateId(),
  parentRequirement: ["NOT_AS_DESCRIBED"],
  initValue: "MERCHANDISE",
  // TODO: Remove comment when beck-end will be ready for Services flow
  // https://marqeta.atlassian.net/browse/PS-23938
  // type: INPUT,
  // options: [
  //   { val: 'MERCHANDISE', render: 'Merchandise' },
  //   { val: 'SERVICES', render: 'Services' },
  // ],
  children: [
    // Merchandise & Services children
    {
      label: "Date merchandise or service was received",
      field: "date_merchandise_or_service_was_received",
      type: DATE,
      key: generateId(),
      parentRequirement: ["MERCHANDISE", "SERVICES"],
      ...EVIDENCE_FIELDS
    },
    {
      label: "Provide details of what was ordered and not as described",
      field: "provide_details_of_what_was_ordered_and_not_as_described",
      type: TEXTAREA,
      key: generateId(),
      parentRequirement: ["MERCHANDISE", "SERVICES"]
    },
    {
      ...DID_THE_CARDHOLDER_ATTEMPT_TO_RESOLVE_THE_DISPUTE_WITH_THE_MERCHANT,
      parentRequirement: ["MERCHANDISE", "SERVICES"]
    },
    {
      ...DID_THE_CARDHOLDER_RETURN_THE_MERCHANDISE,
      parentRequirement: ["MERCHANDISE"]
    },
    // Services children
    {
      label: "Did cardholder cancel the services",
      field: "did_the_cardholder_cancel_the_services",
      type: RADIO_GROUP$1,
      key: generateId(),
      parentRequirement: ["SERVICES"],
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      children: [{
        label: "Cancellation date",
        field: "cancellation_date",
        type: DATE,
        key: generateId(),
        parentRequirement: [true]
      }, {
        label: "Cancellation reason",
        field: "cancellation_reason",
        type: TEXTAREA,
        key: generateId(),
        parentRequirement: [true]
      }]
    }
  ]
}];
const NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE$1 = {
  label: "Not as Described or defective merchandise",
  field: "not_as_described_or_defective_merchandise_details",
  children: [{
    field: "not_as_described_or_defective",
    label: "Not as described or defective",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "NOT_AS_DESCRIBED",
      render: "Not as described"
    }, {
      val: "DEFECTIVE",
      render: "Defective"
    }],
    children: [{
      label: "Date the cardholder first notified the issuer of the dispute",
      field: "date_the_cardholder_first_notified_the_issuer_of_the_dispute",
      type: DATE,
      key: generateId()
    }, ...DEFECTIVE_FIELDS, ...NOT_AS_DESCRIBED_FIELDS]
  }]
};
const didTheCardholderAttemptToResolve = {
  field: "did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant",
  label: "Cardholder attempted to resolve the dispute with the merchant",
  type: RADIO_GROUP$1,
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  key: generateId(),
  children: [{
    field: "is_attempt_to_resolve_prohibited_by_local_law_or_regulations",
    label: "Attempt to resolve prohibited by local law or regulations",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId(),
    parentRequirement: [false],
    children: [{
      type: MESSAGE,
      label: `Cardholder must attempt to resolve the dispute with the merchant unless it's prohibited by local law or regulations`,
      parentRequirement: [false]
    }]
  }]
};
const cancellation_reason = {
  field: "did_cardholder_cancel",
  label: "Did the cardholder cancel",
  parentRequirement: ["MERCHANDISE"],
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  children: [{
    field: "cancellation_date",
    label: "Cancellation date",
    type: DATE,
    parentRequirement: [true],
    key: generateId()
  }, {
    field: "cancellation_reason",
    label: "Cancellation reason",
    type: TEXTAREA,
    parentRequirement: [true],
    key: generateId()
  }, {
    field: "was_cancellation_policy_provided",
    label: "Cancellation policy provided",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId()
  }]
};
const merchandiseOptionEnabled = flipFlop.get("disputes-visa-cancelled-merch", false);
const CANCELLED_MERCHANDISE_OR_SERVICES = (_flags) => ({
  label: "What was purchased -  Merchandise / Services",
  field: "cancelled_merchandise_or_services_details",
  children: [{
    field: "merchandise_or_services",
    label: "Purchase type",
    type: SELECT,
    key: generateId(),
    options: merchandiseOptionEnabled ? [{
      val: "MERCHANDISE",
      render: "Merchandise"
    }, {
      val: "SERVICES",
      render: "Services"
    }] : [{
      val: "SERVICES",
      render: "Services"
    }],
    children: [
      // Merchandise Children
      {
        field: "describe_what_was_purchased",
        label: "Describe what was purchased",
        type: TEXTAREA,
        key: generateId(),
        parentRequirement: ["MERCHANDISE"]
      },
      {
        field: "nonAPI_did_cardholder_receive_merchandise",
        label: "Cardholder received merchandise",
        parentRequirement: ["MERCHANDISE"],
        key: generateId(),
        type: RADIO_GROUP$1,
        options: [{
          val: true,
          render: "Yes"
        }, {
          val: false,
          render: "No"
        }],
        children: [
          //Yes - Received the merchandise
          {
            field: "date_cardholder_received_or_expected_to_receive_merchandise",
            label: "Date cardholder received the merchandise",
            type: DATE,
            key: generateId(),
            parentRequirement: [true]
          },
          {
            field: "did_the_cardholder_return_the_merchandise",
            label: "Cardholder returned the merchandise",
            type: RADIO_GROUP$1,
            options: [{
              val: true,
              render: "Yes"
            }, {
              val: false,
              render: "No"
            }],
            key: generateId(),
            parentRequirement: [true],
            children: [
              // Yes - Cardholder returned the merchandise
              {
                field: "date_of_return",
                label: "Date cardholder returned the merchandise",
                type: DATE,
                parentRequirement: [true],
                key: generateId()
              },
              {
                field: "date_merchant_received_returned_merchandise",
                label: "Date merchant received returned merchandise",
                type: DATE,
                parentRequirement: [true],
                key: generateId()
              },
              {
                type: SELECT,
                key: generateId(),
                label: "Return method",
                field: "return_method",
                options: RETURN_METHOD_OPTIONS,
                parentRequirement: [true],
                children: [{
                  field: "tracking_number",
                  label: "Tracking Number",
                  type: INPUT,
                  parentRequirement: ["FED_EX", "DHL", "UPS", "POSTAL_SERVICE"],
                  key: generateId()
                }, {
                  field: "explain_how_the_merchandise_was_returned",
                  label: "Explain how the merchandise was returned",
                  type: INPUT,
                  parentRequirement: ["OTHER"],
                  key: generateId()
                }]
              },
              // No - Cardholder did not return the merchandise
              {
                label: "Cardholder attempted to return the merchandise",
                field: "did_the_cardholder_attempt_to_return_the_merchandise",
                type: RADIO_GROUP$1,
                options: [{
                  val: true,
                  render: "Yes"
                }, {
                  val: false,
                  render: "No"
                }],
                parentRequirement: [false],
                key: generateId(),
                autoFill: {
                  false: {
                    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: true
                  },
                  true: {
                    is_attempt_to_resolve_prohibited_by_local_law_or_regulations: null
                  }
                },
                children: [
                  //  Yes - Cardholder attempt to return the merchandise
                  {
                    field: "date_of_attempted_return",
                    label: "Date of attempted return",
                    type: DATE,
                    parentRequirement: [true],
                    key: generateId()
                  },
                  {
                    field: "detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise",
                    label: "Provide a detailed description of how the cardholder attempted to return the merchandise",
                    type: TEXTAREA,
                    parentRequirement: [true],
                    key: generateId()
                  },
                  {
                    label: "What is the disposition of the merchandise",
                    field: "what_is_the_disposition_of_the_merchandise",
                    type: TEXTAREA,
                    parentRequirement: [true],
                    key: generateId()
                  },
                  {
                    label: "Choose one of the following that describes merchant response",
                    field: "merchant_refuse_advise",
                    type: SELECT,
                    parentRequirement: [true],
                    options: [{
                      val: "MERCHANT_REFUSED_RETURN_AUTHORIZATION",
                      render: "Merchant refused to provide return authorization"
                    }, {
                      val: "MERCHANT_REFUSED_TO_ACCEPT_RETURNED_MERCHANDISE",
                      render: "Merchant refused to accept returned merchandise"
                    }, {
                      val: "MERCHANT_INFORMED_CARDHOLDER_NOT_TO_RETURN_MERCHANDISE",
                      render: "Merchant informed cardholder not to return the merchandise"
                    }, {
                      val: "MERCHANT_NO_LONGER_EXISTS_OR_IS_NOT_RESPONDING",
                      render: "Merchant no longer exists or is not responding"
                    }, {
                      val: "MERCHANT_DID_NOT_PROVIDE_CLEAR_INSTRUCTION_ON_HOW_TO_RETURN",
                      render: "Merchant did not provide clear instruction on how to return"
                    }],
                    key: generateId()
                  }
                  // No - Cardholder did not attempt to return the merchandise
                  // Jump to cancelled questions
                ]
              }
            ]
          },
          //No - Cardholder did not receive the merchandise
          {
            field: "date_cardholder_received_or_expected_to_receive_merchandise",
            label: "Date cardholder expected to receive the merchandise",
            type: DATE,
            key: generateId(),
            parentRequirement: [false]
          }
        ]
      },
      cancellation_reason,
      // Services Children
      {
        field: "type_of_service",
        label: "Type of service",
        type: RADIO_GROUP$1,
        options: [{
          val: "TIMESHARE",
          render: "Timeshare"
        }, {
          val: "GUARANTEED_RESERVATION",
          render: "Guaranteed Reservation"
        }, {
          val: "OTHER",
          render: "Other"
        }],
        key: generateId(),
        parentRequirement: ["SERVICES"],
        children: [
          // Timeshare Children
          {
            // dup
            field: "did_cardholder_cancel",
            label: "Cardholder cancelled timeshare",
            type: RADIO_GROUP$1,
            options: [{
              val: true,
              render: "Yes"
            }, {
              val: false,
              render: "No"
            }],
            key: generateId(),
            parentRequirement: ["TIMESHARE"],
            children: [{
              field: "date_of_service_or_expected_service",
              label: "Date of the timeshare, or the date the contract or related documents were received",
              type: DATE,
              parentRequirement: ["TIMESHARE", true, false],
              key: generateId()
            }, {
              field: "cancellation_date",
              label: "Cancellation date",
              type: DATE,
              parentRequirement: [true],
              key: generateId()
            }, {
              // dup
              field: "cancellation_reason",
              label: "Cancellation reason",
              type: TEXTAREA,
              parentRequirement: [true],
              key: generateId()
            }]
          },
          {
            ...didTheCardholderAttemptToResolve,
            parentRequirement: ["TIMESHARE"]
          },
          // Guaranteed Reservation Children
          {
            field: "date_of_service_or_expected_service",
            label: "Date of service or expected service",
            type: DATE,
            parentRequirement: ["GUARANTEED_RESERVATION"],
            key: generateId()
          },
          {
            ...didTheCardholderAttemptToResolve,
            parentRequirement: ["GUARANTEED_RESERVATION"]
          },
          {
            // dup
            field: "was_cancellation_policy_provided",
            label: "Cancellation policy provided",
            type: RADIO_GROUP$1,
            options: [{
              val: true,
              render: "Yes"
            }, {
              val: false,
              render: "No"
            }],
            key: generateId(),
            parentRequirement: ["GUARANTEED_RESERVATION"]
          },
          {
            field: "cancelled_guaranteed_reservation_certification_selection",
            label: "Certification of one of the following",
            key: generateId(),
            parentRequirement: ["GUARANTEED_RESERVATION"],
            type: RADIO_GROUP$1,
            options: [{
              val: "CARDHOLDER_PROPERLY_CANCELLED",
              render: "The cardholder properly cancelled the guaranteed reservation"
            }, {
              val: "CARDHOLDER_ATTEMPTED_TO_CANCEL_WITHIN_24_HOURS_OF_CONFIRMATION",
              render: "The cardholder attempted to cancel within 24 hours of delivery of the reservation confirmation"
            }, {
              val: "MERCHANT_BILLED_A_NO_SHOW_TRANSACTION_FOR_MORE_THAN_ONE_DAYS_ACCOMODATION",
              render: "The merchant billed a no show transaction for more than one day’s accommodation or rental"
            }],
            children: [{
              field: "cancellation_date",
              label: "Cancellation date",
              type: DATE,
              parentRequirement: ["CARDHOLDER_PROPERLY_CANCELLED", "CARDHOLDER_ATTEMPTED_TO_CANCEL_WITHIN_24_HOURS_OF_CONFIRMATION"],
              key: generateId()
            }]
          },
          // Other Children
          {
            // dup
            field: "describe_what_was_purchased",
            label: "Describe what was purchased",
            type: TEXTAREA,
            parentRequirement: ["OTHER"],
            key: generateId()
          },
          {
            field: "did_cardholder_cancel",
            initValue: true,
            key: generateId(),
            options: [{
              val: true,
              render: "Yes"
            }],
            parentRequirement: ["SERVICES", "OTHER"],
            type: HIDDEN$1,
            children: [{
              field: "cancellation_date",
              label: "Cancellation date",
              type: DATE,
              parentRequirement: [true],
              key: generateId()
            }, {
              // dup
              field: "cancellation_reason",
              label: "Cancellation reason",
              type: TEXTAREA,
              parentRequirement: [true],
              key: generateId()
            }]
          },
          {
            field: "date_of_service_or_expected_service",
            label: "Date of service or expected service",
            type: DATE,
            parentRequirement: ["OTHER"],
            key: generateId()
          },
          {
            ...didTheCardholderAttemptToResolve,
            parentRequirement: ["OTHER"]
          },
          {
            // dup
            field: "was_cancellation_policy_provided",
            label: "Cancellation policy provided",
            type: RADIO_GROUP$1,
            options: [{
              val: true,
              render: "Yes"
            }, {
              val: false,
              render: "No"
            }],
            key: generateId(),
            parentRequirement: ["OTHER"],
            optional: true
          }
        ]
      }
    ]
  }]
});
const contactMethodWithMerchantValidation = (fieldsMap) => {
  const {
    contact_method_with_merchant_ind,
    contact_method_merchant_email_ind,
    contact_method_merchant_call_center_ind,
    contact_method_merchant_mail_ind,
    contact_method_merchant_SMS_ind,
    contact_method_merchant_in_person_ind,
    contact_method_merchant_webform_ind
  } = fieldsMap;
  if (contact_method_with_merchant_ind && !contact_method_merchant_email_ind && !contact_method_merchant_call_center_ind && !contact_method_merchant_mail_ind && !contact_method_merchant_SMS_ind && !contact_method_merchant_in_person_ind && !contact_method_merchant_webform_ind)
    return "Please select atleast one of the below methods.";
  return "";
};
const validateCheckedCheckbox = (val) => {
  if (val === true)
    return "";
  return REQUIRED_FIELD_ERROR;
};
const EMAIL_VALIDATION_ERROR = "Please enter a valid email address.";
const validateEmail = (email) => {
  if (!email) {
    return EMAIL_VALIDATION_ERROR;
  }
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return EMAIL_VALIDATION_ERROR;
  }
  return "";
};
const visaNetworkMandateH12025$1 = flipFlop.get("visa-network-mandate-H1-2025", false);
const COUNTERFEIT_MERCH = {
  label: "Counterfeit Merch",
  field: "counterfeit_merch_details",
  children: [{
    label: "What was ordered",
    field: "what_was_ordered",
    type: TEXTAREA,
    key: generateId()
  }, {
    label: "Date the cardholder received the merchandise or received notification that the merchandise was counterfeit",
    field: "date_the_cardholder_received_the_merchandise_or_notification",
    type: DATE,
    key: generateId()
  }, {
    label: "Describe the counterfeit merchandise",
    field: "describe_the_counterfeit_merchandise",
    type: TEXTAREA,
    key: generateId()
  }, {
    label: "Describe the disposition of the counterfeit merchandise",
    field: "describe_the_disposition_of_counterfeit_merchandise",
    type: TEXTAREA,
    key: generateId()
  }, visaNetworkMandateH12025$1 ? {} : {
    label: "Provide information about the entity that indicated the merchandise to be counterfeit",
    field: "provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit",
    type: TEXTAREA,
    key: generateId()
  }, visaNetworkMandateH12025$1 ? {} : {
    label: "Certification the merchandise was identified as counterfeit by one of the following",
    field: "certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following",
    type: SELECT,
    options: [{
      val: "THE_OWNER_OF_THE_INTELLECTUAL_PROPETY_OR_ITS_AUTHORIZED_REPRESENTATIVE",
      render: "The owner of the intellectual property or its authorized representative"
    }, {
      val: "CUSTOMS_AGENCY_LAW_ENFORCEMENT_AGENCY_OR_OTHER_GOVERNMENT_AGENCY",
      render: "Customs agency, law enforcement agency or other government agency"
    }, {
      val: "THIRD_PARTY_EXPERT",
      render: "A third-party expert"
    }],
    key: generateId()
  }]
};
const isMisrepresentationEnabled = flipFlop.get("disputes-visa-misrepresentation", false);
const CERTIFICATION_QUESTIONNAIRE = {
  label: "Provide certification of one of the following",
  field: "merchant_refuse_ind",
  type: SELECT,
  parentRequirement: [true],
  options: [{
    val: "MERCHANT_REFUSED_TO_ACCEPT_RETURNED_MERCHANDISE",
    render: "Merchant refused to accept returned merchandise"
  }, {
    val: "MERCHANT_REFUSED_RETURN_AUTHORIZATION",
    render: "Merchant refused to provide return authorization"
  }, {
    val: "MERCHANT_INFORMED_CARDHOLDER_NOT_TO_RETURN_MERCHANDISE",
    render: "Merchant informed cardholder not to return the merchandise"
  }, {
    val: "MERCHANT_DID_NOT_PROVIDE_CLEAR_INSTRUCTION_ON_HOW_TO_RETURN",
    render: "Merchant did not provide clear instruction on how to return"
  }, {
    val: "MERCHANT_NO_LONGER_EXISTS_OR_IS_NOT_RESPONDING",
    render: "Merchant no longer exists or is not responding"
  }],
  key: generateId()
};
const MISREPRESENTATION = {
  label: "Misrepresentation",
  field: "misrepresentation_details",
  children: [isMisrepresentationEnabled ? {
    field: "merchandise_or_services",
    label: "What was purchased?",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "MERCHANDISE",
      render: "Merchandise"
    }, {
      val: "SERVICES",
      render: "Services"
    }],
    children: [{
      field: "service_received_date",
      label: "Date services were received",
      type: DATE,
      parentRequirement: ["SERVICES"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "SERVICES"
    }, {
      field: "describe_what_was_purchased",
      label: "Provide details of what was purchased",
      type: TEXTAREA,
      parentRequirement: ["SERVICES"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "SERVICES"
    }, {
      field: "how_merchandise_service_misrepresented",
      label: "How was the merchandise or service misrepresented",
      type: TEXTAREA,
      parentRequirement: ["SERVICES"],
      shouldDisplayField: (parentVal) => parentVal === "SERVICES",
      key: generateId()
    }, {
      field: "did_cardholder_cancel",
      label: "Did the cardholder cancel the services",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["SERVICES"],
      key: generateId()
    }, {
      field: "cancellation_date",
      label: "Cancellation Date",
      type: DATE,
      parentRequirement: ["SERVICES"],
      key: generateId()
    }, {
      field: "cancellation_reason",
      label: "Cancellation Reason",
      type: TEXTAREA,
      parentRequirement: ["SERVICES"],
      key: generateId()
    }, {
      field: "cardholder_attempt_to_resolve",
      label: "Did the cardholder attempt to resolve the dispute with the merchant",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["SERVICES"],
      key: generateId()
    }, {
      field: "attempt_to_resolve_proh_local_law",
      label: "Is attempt to resolve prohibited by local law or regulations",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["SERVICES"],
      key: generateId()
    }, {
      field: "merchandise_received_date",
      label: "Date merchandise were received",
      type: DATE,
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "MERCHANDISE"
    }, {
      field: "describe_what_was_purchased",
      label: "Provide details of what was purchased",
      type: TEXTAREA,
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "MERCHANDISE"
    }, {
      field: "how_merchandise_service_misrepresented",
      label: "How was the merchandise or service misrepresented",
      type: TEXTAREA,
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "MERCHANDISE"
    }, {
      field: "cardholder_attempt_to_resolve",
      label: "Did the cardholder attempt to resolve the dispute with the merchant",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      shouldDisplayField: (parentVal) => parentVal === "MERCHANDISE"
    }, {
      field: "cardholder_return_merchandise_ind",
      label: "Did the cardholder return the merchandise",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      children: [{
        field: "cardholder_returned_merchandise_date",
        label: "Date cardholder returned the merchandise",
        type: DATE,
        parentRequirement: [true],
        key: generateId()
      }, {
        field: "cardholder_attempt_return_merchandise",
        label: "Did the cardholder attempt to return the merchandise",
        type: RADIO_GROUP$1,
        options: [{
          val: true,
          render: "Yes"
        }, {
          val: false,
          render: "No"
        }],
        parentRequirement: [false],
        key: generateId(),
        children: [{
          field: "attempted_return_date",
          label: "Date of attempted return",
          type: DATE,
          parentRequirement: [true],
          key: generateId()
        }, {
          field: "how_ch_attempt_return_and_disp_of_merchandise",
          label: "Provide a detailed description of how the cardholder attempted to return merchandise",
          type: TEXTAREA,
          parentRequirement: [true],
          key: generateId()
        }, CERTIFICATION_QUESTIONNAIRE]
      }, {
        field: "merchant_received_returned_merchandise_date",
        label: "Date merchant received returned merchandise",
        type: DATE,
        parentRequirement: [true],
        key: generateId()
      }, {
        field: "return_method",
        label: "Return Method",
        type: SELECT,
        parentRequirement: [true],
        options: [{
          val: "FACE_TO_FACE",
          render: "Face to Face"
        }, {
          val: "FED_EX",
          render: "Fed Ex"
        }, {
          val: "DHL",
          render: "DHL"
        }, {
          val: "UPS",
          render: "UPS"
        }, {
          val: "POSTAL_SERVICE",
          render: "Postal Service"
        }, {
          val: "OTHER",
          render: "Other"
        }],
        key: generateId(),
        children: [{
          field: "shipping_tracking_number",
          label: "Tracking number",
          type: INPUT,
          optional: true,
          key: generateId(),
          parentRequirement: ["FED_EX", "DHL", "UPS", "POSTAL_SERVICE"]
        }, {
          field: "how_merchandise_returned",
          label: "Explain how the merchandise was returned",
          type: INPUT,
          parentRequirement: ["OTHER"],
          key: generateId()
        }]
      }]
    }]
  } : {}]
};
const isOriginalCreditNotAcceptedEnabled = flipFlop.get("disputes-visa-original-credit-not-accepted", false);
const ORIGINAL_CREDIT_NOT_ACCEPTED = {
  label: "Original Credit Not Accepted",
  field: "original_credit_not_accepted_details",
  children: [isOriginalCreditNotAcceptedEnabled ? {
    field: "explain_reason",
    label: "Explain why credit presented does not apply",
    type: TEXTAREA,
    key: generateId()
  } : {}]
};
const SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED$1 = ({
  nw_mandates_oct_2023,
  nw_mandates_april_2024,
  nw_mandates_oct_2024
}) => ({
  label: "Merchandise or Services Not Received",
  field: "service_not_provided_merchandise_not_received_details",
  children: [{
    type: "Message",
    label: "Provide a detailed description of the merchandise or services purchased unless prohibited by applicable laws or regulations."
  }, {
    field: "detailed_description_of_what_was_purchased_and_explanation_of_the_dispute",
    label: "Purchase description and dispute explanation",
    type: TEXTAREA,
    key: generateId()
  }, nw_mandates_oct_2024 ? {
    field: "is_merchant_in_bankruptcy_liquidation",
    label: "Is merchant in bankruptcy/liquidation",
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      render: "Yes",
      val: true
    }, {
      render: "No",
      val: false
    }]
  } : {}, {
    field: "expected_receipt_date",
    label: "Expected receipt date",
    type: DATE,
    key: generateId(),
    children: [{
      field: "explanation_dispute_prior_expected_delivery_date",
      label: "Explanation of dispute initiated prior to the expected delivery date",
      type: TEXTAREA,
      key: generateId(),
      shouldDisplayField: (parentVal) => isParentNodeDateAfterChild(/* @__PURE__ */ new Date(), parentVal)
    }]
  }, {
    field: "expected_receipt_time",
    optional: true,
    type: HIDDEN$1,
    key: generateId()
  }, {
    field: "nonAPI_receipt_time_12_format",
    label: "Expected receipt time",
    type: TIME,
    optional: true,
    key: generateId(),
    validation: timeValidation
  }, {
    field: "did_cardholder_cancel_prior_to_the_expected_date",
    label: "Cardholder canceled prior to the expected date",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId(),
    children: [{
      field: "cancellation_date",
      label: "Cancellation Date",
      type: DATE,
      key: generateId(),
      parentRequirement: [true]
    }, {
      field: "cancellation_reason",
      label: "Cancellation reason",
      type: INPUT,
      key: generateId(),
      parentRequirement: [true],
      optional: true
    }]
  }, {
    type: RADIO_GROUP$1,
    label: "Cardholder attempted to resolve dispute with merchant",
    field: "did_cardholder_attempt_to_resolve_dispute_with_merchant",
    key: generateId(),
    options: [{
      render: "Yes",
      val: true
    }, {
      render: "No, attempt to resolve is prohibited by local laws or regulations",
      val: false
    }],
    autoFill: {
      false: {
        is_attempt_to_resolve_prohibited_by_local_law_or_regulations: true
      },
      true: {
        is_attempt_to_resolve_prohibited_by_local_law_or_regulations: null
      }
    }
  }, {
    type: RADIO_GROUP$1,
    label: "Is the purchase a third-party gift card without an expiration date, where the merchandise or services were not provided by the third party due to insolvency or bankruptcy?",
    field: "third_party_gift_card_indicator",
    key: generateId(),
    options: [{
      render: "Yes",
      val: true
    }, {
      render: "No",
      val: false
    }]
  }, {
    field: "merchandise_or_services",
    label: "Purchase type",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "MERCHANDISE",
      render: "Merchandise"
    }, {
      val: "SERVICES",
      render: "Services"
    }],
    children: [nw_mandates_oct_2024 ? {
      field: "merchandise_delivered_late",
      label: "Was the merchandise delivered late?",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      children: [DID_CARDHOLDER_RETURN_THE_MERCHANDISE]
    } : {}, nw_mandates_oct_2024 ? {
      field: "non_fiat_currency_not_delivered",
      label: "Was non-fiat currency or non-fungible token(s) not successfully delivered to the destination wallet address supplied by the Cardholder at the time of the Transaction",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["SERVICES"],
      key: generateId()
    } : {}, {
      field: "was_merchandise_delivered_to_wrong_location",
      label: nw_mandates_oct_2024 ? "Was the merchandise delivered to the incorrect location" : "Merchandise delivered to wrong location",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: ["MERCHANDISE"],
      key: generateId(),
      children: [ADDRESS_OF_AGREED_LOCATION, nw_mandates_oct_2024 ? {} : DID_CARDHOLDER_RETURN_THE_MERCHANDISE]
    }, {
      type: RADIO_GROUP$1,
      label: "Does the dispute involve a Visa Commercial Card Virtual Account?",
      field: "visa_commercial_card_virtual_account_indicator",
      key: generateId(),
      parentRequirement: ["SERVICES"],
      optional: nw_mandates_april_2024,
      options: [{
        render: "Yes",
        val: true
      }, {
        render: "No",
        val: false
      }],
      children: [{
        type: RADIO_GROUP$1,
        label: "Did virtual account holder suffer a financial loss?",
        field: "did_virtual_account_holder_suffer_financial_loss",
        key: generateId(),
        parentRequirement: [true],
        options: [{
          render: "Yes",
          val: true
        }, {
          render: "No",
          val: false
        }]
      }]
    }, {
      type: RADIO_GROUP$1,
      label: nw_mandates_oct_2023 ? "Did merchant cancel services?" : "Did merchant/travel provider cancel services?",
      field: "did_merchant_cancel_services",
      key: generateId(),
      parentRequirement: ["SERVICES"],
      options: [{
        render: "Yes",
        val: true
      }, {
        render: "No",
        val: false
      }],
      children: [{
        type: DATE,
        label: nw_mandates_oct_2023 ? "Date merchant cancelled services" : "Date merchant/travel provider cancelled services",
        field: "date_merchant_cancelled_services",
        key: generateId(),
        parentRequirement: [true]
      }]
    }, ...nw_mandates_oct_2023 ? [{
      type: RADIO_GROUP$1,
      label: "Did merchant cancel merchandise?",
      field: "did_merchant_cancel_merchandise",
      key: generateId(),
      parentRequirement: ["MERCHANDISE"],
      options: [{
        render: "Yes",
        val: true
      }, {
        render: "No",
        val: false
      }],
      children: [{
        type: DATE,
        label: "Date merchant cancelled merchandise",
        field: "date_merchant_cancelled_merchandise",
        key: generateId(),
        parentRequirement: [true]
      }]
    }] : []]
  }]
});
const CREDIT_NOT_PROCESSED$1 = {
  label: "Credit not Processed",
  field: "credit_not_processed_details",
  key: generateId(),
  children: [{
    field: "was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given",
    type: HIDDEN$1,
    key: generateId(),
    initValue: true,
    options: [{
      val: true,
      render: "Yes"
    }],
    children: [{
      label: "Date provided for credit voucher, transaction receipt, or refund acknowledgement",
      field: "is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: [true],
      key: generateId(),
      children: [{
        field: "credit_voucher_transaction_receipt_or_refund_acknowledgement_date",
        label: "Date of credit voucher, transaction receipt or refund acknowledgement",
        type: DATE,
        key: generateId(),
        parentRequirement: [true]
      }, {
        field: "date_cardholder_returned_cancelled_merchandise",
        label: "Date the cardholder cancelled the service or returned the merchandise",
        type: DATE,
        key: generateId(),
        parentRequirement: [false]
      }]
    }]
  }]
};
const CANCELLED_RECURRING_TRANSACTION$1 = ({
  nw_mandates_april_2024
}) => ({
  label: "Cancelled recurring transaction",
  field: "cancelled_recurring_transaction_details",
  key: generateId(),
  children: [{
    field: "cancellation_date",
    label: "Date cardholder withdrew permission to charge the Payment Credential",
    type: DATE,
    optional: nw_mandates_april_2024,
    key: generateId(),
    children: [{
      field: "contact_method_with_merchant_ind",
      label: "Contact method with merchant",
      type: CHECKBOX,
      key: generateId(),
      parentRequirement: [],
      validation: validateCheckedCheckbox,
      dependencyValidation: contactMethodWithMerchantValidation,
      children: [{
        field: "contact_method_merchant_email_ind",
        label: "Email",
        type: CHECKBOX,
        key: generateId(),
        parentRequirement: [true],
        optional: true,
        children: [{
          field: "contact_merchant_details_email_address",
          label: "Email Address",
          type: INPUT,
          key: generateId(),
          validation: validateEmail,
          parentRequirement: [true]
        }]
      }, {
        field: "contact_method_merchant_call_center_ind",
        label: "Call Center",
        type: CHECKBOX,
        key: generateId(),
        optional: true,
        parentRequirement: [true],
        children: [{
          field: "contact_merchant_details_phone_number",
          label: "Phone number",
          type: INPUT,
          key: generateId(),
          parentRequirement: [true]
        }]
      }, {
        field: "contact_method_merchant_mail_ind",
        label: "Mail",
        type: CHECKBOX,
        key: generateId(),
        optional: true,
        parentRequirement: [true],
        children: [{
          field: "contact_merchant_details_physical_address",
          label: "Physical Address",
          type: INPUT,
          key: generateId(),
          parentRequirement: [true]
        }]
      }, {
        field: "contact_method_merchant_SMS_ind",
        label: "SMS/Text Message",
        type: CHECKBOX,
        key: generateId(),
        optional: true,
        parentRequirement: [true],
        children: [{
          field: "contact_merchant_details_phone_number",
          label: "Phone number",
          type: INPUT,
          key: generateId(),
          parentRequirement: [true]
        }]
      }, {
        field: "contact_method_merchant_in_person_ind",
        label: "In-person",
        type: CHECKBOX,
        key: generateId(),
        optional: true,
        parentRequirement: [true],
        children: [{
          field: "contact_merchant_details_physical_address",
          label: "Physical Address",
          type: INPUT,
          key: generateId(),
          parentRequirement: [true]
        }]
      }, {
        field: "contact_method_merchant_webform_ind",
        label: "Webform / Application Name",
        type: CHECKBOX,
        key: generateId(),
        optional: true,
        parentRequirement: [true],
        children: [{
          field: "contact_merchant_details_application_name",
          label: "Application name",
          type: INPUT,
          key: generateId(),
          parentRequirement: [true]
        }]
      }]
    }, {
      field: "contact_merchant_details",
      label: "Contact merchant details",
      type: INPUT,
      key: generateId(),
      parentRequirement: []
    }, {
      field: "other_form_of_payment_ind",
      label: "Other form of payment",
      type: RADIO_GROUP$1,
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      key: generateId(),
      parentRequirement: [],
      children: [{
        field: "other_form_of_payment_desc",
        label: "Describe other form of payment",
        type: TEXTAREA,
        key: generateId(),
        parentRequirement: [true]
      }]
    }, {
      field: "cancellation_reason",
      label: "Cancellation reason",
      type: TEXTAREA,
      key: generateId(),
      parentRequirement: []
    }]
  }, {
    field: "date_issuer_informed_merchant_of_account_closure",
    label: "Date issuer informed merchant of account closure",
    optional: true,
    type: DATE,
    key: generateId()
  }]
});
const INVALID_DATA = {
  label: "Invalid data",
  field: "invalid_data_details",
  children: [{
    field: "authorization_request_declined_valid_data",
    label: "Certification that the authorization request would have been declined if valid data had been provided",
    type: CHECKBOX,
    key: generateId()
  }, {
    field: "explain_why_valid_data_inclusion_reason",
    label: "Explain why the inclusion of valid data would have caused the Authorization request to be declined",
    type: TEXTAREA,
    key: generateId()
  }]
};
const INCORRECT_TRANSACTION_CODE$1 = {
  label: "Incorrect transaction code",
  field: "incorrect_transaction_code_details",
  children: [{
    label: "How is transaction code incorrect?",
    field: "how_is_transaction_code_incorrect",
    type: HIDDEN$1,
    key: generateId(),
    initValue: "DEBIT_POSTED_AS_CREDIT",
    options: [
      // uncomment this option when backend will be ready https://marqeta.atlassian.net/browse/PS-24202
      // {
      //   val: 'CREDIT_INSTEAD_OF_REVERSAL_OR_ADJUSTMENT',
      //   render: 'Credit instead of reversal or adjustment',
      // },
      // uncomment this option when backend will be ready https://marqeta.atlassian.net/browse/PS-24203
      // { val: 'CREDIT_POSTED_AS_DEBIT', render: 'Credit posted as a debit' },
      {
        val: "DEBIT_POSTED_AS_CREDIT",
        render: "Debit posted as a credit"
      }
    ],
    children: [{
      label: "Explain why the credit refund was processed in error",
      field: "explain_why_the_credit_refund_was_processed_in_error",
      type: TEXTAREA,
      key: generateId(),
      parentRequirement: ["CREDIT_INSTEAD_OF_REVERSAL_OR_ADJUSTMENT"]
    }]
  }]
};
const LATE_PRESENTMENT$1 = {
  label: "Late presentment",
  field: "late_presentment_details",
  children: [{
    field: "account_status",
    label: "Account status",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "ACCOUNT_CLOSED",
      render: "Account closed"
    }, {
      val: "CREDIT_PROBLEM",
      render: "Credit problem"
    }, {
      val: "FRAUD",
      render: "Fraud"
    }]
  }]
};
const currencyOptions = currencies.map((currency) => ({
  val: parseInt(currency.number),
  render: currency.code,
  searchString: `${currency.number} ${currency.code}`
}));
const INCORRECT_TRANSACTION_AMOUNT$1 = {
  field: FIELDS_KEY_MAP.INCORRECT_TRANSACTION_AMOUNT_DETAILS,
  label: "What is the amount on the cardholder’s receipt?",
  key: generateId(),
  children: [{
    field: FIELDS_KEY_MAP.WHAT_IS_THE_AMOUNT_ON_THE_CARDHOLDERS_RECEIPT,
    key: generateId(),
    type: HIDDEN$1
  }, {
    field: FIELDS_KEY_MAP.NONAPI_WHAT_IS_THE_AMOUNT_ON_THE_CARDHOLDERS_RECEIPT,
    key: generateId(),
    label: "Amount on the cardholder’s receipt",
    type: INPUT
  }, {
    field: FIELDS_KEY_MAP.WHAT_IS_THE_CURRENCY_ON_THE_CARDHOLDERS_RECEIPT,
    key: generateId(),
    label: "Currency",
    options: currencies.map((currency) => ({
      val: currency.number,
      render: currency.code,
      searchString: `${currency.number} ${currency.code}`
    })),
    type: SELECT
  }, {
    field: FIELDS_KEY_MAP.IS_DIFFERENCE_BETWEEN_PRICES,
    label: "Is the dispute due to the difference between the quoted price of an Airline, Cruise Line, Lodging Merchant, Passenger Railway, Travel Agency, or Vehicle Rental transaction and actual charges made by the merchant?",
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }]
  }]
};
const INCORRECT_CURRENCY = {
  label: "Incorrect currency",
  field: "incorrect_currency_details",
  children: [{
    field: "incorrect_currency_reason",
    label: "Incorrect currency reason",
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      val: "CURRENCY_DIFFERENCE",
      render: "Currency Difference"
    }, {
      val: "DCC_DISPUTE",
      render: "DCC Dispute"
    }],
    children: [{
      field: "certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice",
      label: "Certification that the cardholder did not agree to dynamic currency conversion and did not make an active choice",
      type: RADIO_GROUP$1,
      key: generateId(),
      parentRequirement: ["DCC_DISPUTE"],
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }]
    }, {
      field: "what_was_the_correct_currency",
      label: "What was the correct currency?",
      type: SELECT,
      key: generateId(),
      showSearch: true,
      parentRequirement: ["CURRENCY_DIFFERENCE"],
      options: currencyOptions
    }]
  }]
};
const INCORRECT_ACCOUNT_NUMBER = {
  label: "Incorrect account number",
  field: "incorrect_account_number_details",
  children: [{
    field: "is_the_account_number_on_the_issuers_master_file",
    label: "Is the account number on the issuer’s master file",
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    children: [{
      field: "does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token",
      label: "Does the account number on the receipt match the cardholder’s account number or token?",
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: [true]
    }]
  }]
};
const PROOF_OF_PAYMENT = {
  label: "Provide proof of payment by other means",
  field: "provided_proof_of_other_means_type",
  parentRequirement: [false],
  type: SELECT,
  options: [{
    val: "OTHER_TRANSACTION_ARN",
    render: "ARN from other transactions if paid with Visa Card"
  }, {
    val: "OTHER_TRANSACTION_INFORMATION",
    render: "Transaction information from other transaction, if paid with Visa card"
  }, {
    val: "CASH_RECEIPT",
    render: "Cash receipt"
  }, {
    val: "COPY_OF_CHECK",
    render: "Copy of the front and back of a canceled check"
  }, {
    val: "THIRD_PARTY_VOUCHER",
    render: "Voucher from the third party"
  }, {
    val: "OTHER_CARD_STATEMENT",
    render: "Statement from other card"
  }, {
    val: "OTHER",
    render: "Other"
  }],
  children: [{
    label: "Acquirer reference Number",
    field: "other_visa_transaction_arn",
    parentRequirement: ["OTHER_TRANSACTION_ARN"],
    type: INPUT,
    key: generateId()
  }, {
    label: "Transaction identifier",
    field: "other_visa_transaction_information",
    parentRequirement: ["OTHER_TRANSACTION_INFORMATION"],
    type: INPUT,
    key: generateId()
  }, {
    label: "Does the issuer have evidence that the first merchant passed on the funds to the second merchant?",
    field: "is_evidence_of_merchant_passed_funds_provided",
    parentRequirement: ["THIRD_PARTY_VOUCHER"],
    type: RADIO_GROUP$1,
    key: generateId(),
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }]
  }]
};
const PAID_BY_OTHER_MEANS = [{
  field: "cardholder_attempted_to_resolve",
  label: "Did the cardholder attempt to resolve the dispute with the merchant?",
  type: RADIO_GROUP$1,
  key: generateId(),
  optional: false,
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  parentRequirement: ["PAID_BY_OTHER_MEANS"],
  autoFill: {
    false: {
      is_attempt_to_resolve_prohibited_by_local_law: true
    },
    true: {
      is_attempt_to_resolve_prohibited_by_local_law: null
    }
  },
  children: [{
    field: "is_attempt_to_resolve_prohibited_by_local_law",
    label: "Is attempt to resolve prohibited by local law or regulations?",
    parentRequirement: [false],
    type: RADIO_GROUP$1,
    key: generateId(),
    disabled: true,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }]
  }]
}, {
  field: "both_transactions_in_same_account",
  label: "Are both transactions for the same merchant and on the same card?",
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  parentRequirement: ["PAID_BY_OTHER_MEANS"],
  children: [{
    field: "other_transaction_reference_token",
    label: "Transaction token",
    type: INPUT,
    key: generateId(),
    parentRequirement: [true]
  }, {
    field: "transaction_in_different_visa_account",
    label: "Is the other transaction for the same merchant and on a different Visa card owned by the same Issuer/Cardholder",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId(),
    parentRequirement: [false],
    autoFill: {
      false: {
        is_other_transaction_with_same_merchant: true
      },
      true: {
        is_other_transaction_with_same_merchant: null
      }
    },
    children: [{
      label: "Is the other transaction paid by other means?",
      field: "is_other_transaction_with_same_merchant",
      parentRequirement: [false],
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      disabled: true
    }, {
      field: "other_transaction_reference_token",
      label: "Transaction token",
      type: INPUT,
      key: generateId(),
      parentRequirement: [true]
    }, PROOF_OF_PAYMENT]
  }]
}];
const DUPLICATE = [{
  field: "both_transactions_in_same_account",
  label: "Are both transactions for the same merchant and on the same card?",
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  parentRequirement: ["DUPLICATE"],
  // same workflow for 2 options
  children: [{
    field: "other_transaction_reference_token",
    label: "Transaction token",
    type: INPUT,
    key: generateId(),
    parentRequirement: [true]
  }, {
    field: "transaction_in_different_visa_account",
    label: "Is the other transaction for the same merchant and on a different Visa card owned by the same Issuer/Cardholder",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId(),
    parentRequirement: [false],
    autoFill: {
      false: {
        is_other_transaction_with_same_merchant: true
      },
      true: {
        is_other_transaction_with_same_merchant: null
      }
    },
    children: [{
      label: "Is the other transaction paid by other means?",
      field: "is_other_transaction_with_same_merchant",
      parentRequirement: [false],
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      disabled: true
    }, {
      field: "other_transaction_reference_token",
      label: "Transaction token",
      type: INPUT,
      key: generateId(),
      parentRequirement: [true]
    }, PROOF_OF_PAYMENT, {
      field: "cardholder_attempted_to_resolve",
      label: "Did the cardholder attempt to resolve the dispute with the merchant?",
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: [false],
      autoFill: {
        false: {
          is_attempt_to_resolve_prohibited_by_local_law: true
        },
        true: {
          is_attempt_to_resolve_prohibited_by_local_law: null
        }
      },
      children: [{
        field: "is_attempt_to_resolve_prohibited_by_local_law",
        label: "Is attempt to resolve prohibited by local law or regulations?",
        parentRequirement: [false],
        type: RADIO_GROUP$1,
        key: generateId(),
        disabled: true,
        options: [{
          val: true,
          render: "Yes"
        }, {
          val: false,
          render: "No"
        }]
      }]
    }]
  }]
}];
const COMBINED_PAID_BY_OTHER_MEANS_AND_DUPLICATE = {
  field: "both_transactions_in_same_account",
  label: "Are both transactions for the same merchant and on the same card?",
  type: RADIO_GROUP$1,
  key: generateId(),
  options: [{
    val: true,
    render: "Yes"
  }, {
    val: false,
    render: "No"
  }],
  parentRequirement: ["DUPLICATE", "PAID_BY_OTHER_MEANS"],
  // same workflow for 2 options
  children: [{
    field: "other_transaction_reference_token",
    label: "Transaction token",
    type: INPUT,
    key: generateId(),
    parentRequirement: [true]
  }, {
    field: "transaction_in_different_visa_account",
    label: "Is the other transaction for the same merchant and on a different Visa card owned by the same Issuer/Cardholder",
    type: RADIO_GROUP$1,
    options: [{
      val: true,
      render: "Yes"
    }, {
      val: false,
      render: "No"
    }],
    key: generateId(),
    parentRequirement: [false],
    autoFill: {
      false: {
        is_other_transaction_with_same_merchant: true
      },
      true: {
        is_other_transaction_with_same_merchant: null
      }
    },
    children: [{
      label: "Is the other transaction paid by other means?",
      field: "is_other_transaction_with_same_merchant",
      parentRequirement: [false],
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      disabled: true
    }, {
      field: "other_transaction_reference_token",
      label: "Transaction token",
      type: INPUT,
      key: generateId(),
      parentRequirement: [true]
    }, {
      field: "cardholder_attempted_to_resolve",
      label: "Did the cardholder attempt to resolve the dispute with the merchant?",
      type: RADIO_GROUP$1,
      key: generateId(),
      options: [{
        val: true,
        render: "Yes"
      }, {
        val: false,
        render: "No"
      }],
      parentRequirement: [false],
      autoFill: {
        false: {
          is_attempt_to_resolve_prohibited_by_local_law: true
        },
        true: {
          is_attempt_to_resolve_prohibited_by_local_law: null
        }
      },
      children: [{
        field: "is_attempt_to_resolve_prohibited_by_local_law",
        label: "Is attempt to resolve prohibited by local law or regulations?",
        parentRequirement: [false],
        type: RADIO_GROUP$1,
        key: generateId(),
        disabled: true,
        options: [{
          val: true,
          render: "Yes"
        }, {
          val: false,
          render: "No"
        }]
      }]
    }, {
      label: "Provide proof of payment by other means",
      field: "provided_proof_of_other_means_type",
      parentRequirement: [false],
      type: SELECT,
      options: [{
        val: "OTHER_TRANSACTION_ARN",
        render: "ARN from other transactions if paid with Visa Card"
      }, {
        val: "OTHER_TRANSACTION_INFORMATION",
        render: "Transaction information from other transaction, if paid with Visa card"
      }, {
        val: "CASH_RECEIPT",
        render: "Cash receipt"
      }, {
        val: "COPY_OF_CHECK",
        render: "Copy of the front and back of a canceled check"
      }, {
        val: "THIRD_PARTY_VOUCHER",
        render: "Voucher from the third party"
      }, {
        val: "OTHER_CARD_STATEMENT",
        render: "Statement from other card"
      }, {
        val: "OTHER",
        render: "Other"
      }],
      children: [{
        label: "Acquirer reference Number",
        field: "other_visa_transaction_arn",
        parentRequirement: ["OTHER_TRANSACTION_ARN"],
        type: INPUT,
        key: generateId()
      }, {
        label: "Transaction identifier",
        field: "other_visa_transaction_information",
        parentRequirement: ["OTHER_TRANSACTION_INFORMATION"],
        type: INPUT,
        key: generateId()
      }, {
        label: "Does the issuer have evidence that the first merchant passed on the funds to the second merchant?",
        field: "is_evidence_of_merchant_passed_funds_provided",
        parentRequirement: ["THIRD_PARTY_VOUCHER"],
        type: RADIO_GROUP$1,
        key: generateId(),
        options: [{
          val: true,
          render: "Yes"
        }, {
          val: false,
          render: "No"
        }]
      }]
    }]
  }]
};
const octoberNetworkMandate = flipFlop.get("october-network-mandate", false);
const DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS = {
  label: "Duplicate processing or paid by other means",
  field: "duplicate_processing_or_paid_by_other_means_details",
  children: [{
    field: "error_type",
    label: "What is incorrect about this transaction",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "DUPLICATE",
      render: "Duplicate"
    }, {
      val: "PAID_BY_OTHER_MEANS",
      render: "Paid by other means"
    }],
    ...octoberNetworkMandate ? {
      children: [...PAID_BY_OTHER_MEANS, ...DUPLICATE]
    } : {
      children: [COMBINED_PAID_BY_OTHER_MEANS_AND_DUPLICATE]
    }
  }]
};
const ADDRESS_OF_AGREED_LOCATION = {
  type: TEXTAREA,
  label: "Provide address of the agreed location or details of late delivery",
  field: "address_of_agreed_location",
  parentRequirement: [true],
  key: generateId()
};
const DID_CARDHOLDER_RETURN_THE_MERCHANDISE = {
  field: "nonAPI_not_provided_cardholder_returned_and_attempted_return_status",
  label: "Return status",
  type: RADIO_GROUP$1,
  parentRequirement: [true],
  key: generateId(),
  options: [{
    val: "Cardholder returned purchase",
    render: "Cardholder returned purchase"
  }, {
    val: "Cardholder attempted to return purchase",
    render: "Cardholder attempted to return purchase"
  }, {
    val: "Cardholder did not attempt to return purchase",
    render: "Cardholder did not attempt to return purchase"
  }],
  autoFill: {
    "Cardholder returned purchase": {
      did_cardholder_return_merchandise: true,
      did_cardholder_attempt_to_return_merchandise: null
    },
    "Cardholder attempted to return purchase": {
      did_cardholder_attempt_to_return_merchandise: true,
      did_cardholder_return_merchandise: false
    },
    "Cardholder did not attempt to return purchase": {
      did_cardholder_attempt_to_return_merchandise: false,
      did_cardholder_return_merchandise: false
    }
  },
  children: [{
    field: "date_cardholder_returned_merchandise",
    label: "Date returned",
    type: DATE,
    key: generateId(),
    parentRequirement: ["Cardholder returned purchase"]
  }, {
    field: "date_merchant_received_returned_merchandise",
    label: "Date merchant received",
    type: DATE,
    key: generateId(),
    parentRequirement: ["Cardholder returned purchase"]
  }, {
    field: "date_of_attempted_return",
    label: "Date of attempted return",
    type: DATE,
    key: generateId(),
    parentRequirement: ["Cardholder attempted to return purchase"]
  }, {
    // Note: may not be required - ship to production and potentially
    // remove during the 21.1 VROL release.
    type: SELECT,
    key: generateId(),
    label: "Return method",
    field: "explain_how_merchandise_was_returned",
    options: RETURN_METHOD_OPTIONS,
    parentRequirement: ["Cardholder returned purchase", "Cardholder attempted to return purchase"],
    optional: true
  }]
};
const QUESTIONNAIRE_FLOWS = {
  CANCELLED_MERCHANDISE_OR_SERVICES,
  CANCELLED_RECURRING_TRANSACTION: CANCELLED_RECURRING_TRANSACTION$1,
  CREDIT_NOT_PROCESSED: CREDIT_NOT_PROCESSED$1,
  DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS,
  INCORRECT_ACCOUNT_NUMBER,
  INCORRECT_CURRENCY,
  INCORRECT_TRANSACTION_AMOUNT: INCORRECT_TRANSACTION_AMOUNT$1,
  INCORRECT_TRANSACTION_CODE: INCORRECT_TRANSACTION_CODE$1,
  LATE_PRESENTMENT: LATE_PRESENTMENT$1,
  NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE: NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE$1,
  SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED: SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED$1,
  INVALID_DATA,
  MISREPRESENTATION,
  ORIGINAL_CREDIT_NOT_ACCEPTED,
  COUNTERFEIT_MERCH
};
const questionnaireNode = "_questionnaireNode_1602b_1";
const customRadioInput = "_customRadioInput_1602b_6";
const questionnaireRadioNode = "_questionnaireRadioNode_1602b_15";
const questionnaireRadioNodeField = "_questionnaireRadioNodeField_1602b_15";
const flexBetween = "_flexBetween_1602b_23";
const s$7 = {
  questionnaireNode,
  customRadioInput,
  questionnaireRadioNode,
  questionnaireRadioNodeField,
  flexBetween
};
function QuestionnaireFormField(props) {
  const {
    getError,
    handleChange,
    node,
    nodeValue,
    radioChildren
  } = props;
  const {
    label,
    field,
    type,
    options,
    format,
    optional,
    disabled = false
  } = node || {};
  const formattedLabel = optional ? `${label} (optional)` : label;
  const error = getError(field, format, nodeValue);
  const testId = `${field}-${nodeValue}`;
  const sharedProps = {
    label: formattedLabel,
    error,
    testId
  };
  const {
    MESSAGE: MESSAGE2,
    SELECT: SELECT2,
    RADIO_GROUP: RADIO_GROUP2,
    INPUT: INPUT2,
    DATE: DATE2,
    TIME: TIME2,
    TEXTAREA: TEXTAREA2,
    NUMBER: NUMBER2,
    CHECKBOX: CHECKBOX2
  } = TYPE_OPTIONS$1;
  const isError = format === "error";
  if (format === Date) {
    sharedProps.placeholder = "YYYY-MM-DD";
  }
  const COMPONENTS_MAP = {
    [TIME2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(InputTime, { ...sharedProps, value: nodeValue, onChange: (value) => handleChange(field, value) }),
    [INPUT2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { ...sharedProps, value: nodeValue, onChange: (e) => handleChange(field, e.target.value) }),
    [DATE2]: () => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": testId, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: formattedLabel }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DatePicker, { error, from: nodeValue ? moment(nodeValue.substr(0, 10)).toDate() : null, to: nodeValue ? moment(nodeValue.substr(0, 10)).toDate() : null, singleDate: true, showSingleMonth: true, singleDateFrom: true, onChange: (from, to2) => {
        handleChange(field, moment(from).format("YYYY-MM-DD"));
      } })
    ] }),
    [NUMBER2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(MaskedInput, { ...sharedProps, value: nodeValue, onChange: (e) => handleChange(field, e.target.value), decimalScale: 0, thousandSeparator: false, isAllowed: (val) => val >= 0 }),
    [SELECT2]: () => {
      const value = options.find((o) => o.val === nodeValue)?.render;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { ...sharedProps, showSearch: true, value, options, onChange: (selection) => handleChange(field, selection.val) });
    },
    [RADIO_GROUP2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { label: formattedLabel, groupName: field, value: nodeValue, groupItems: options.map((option) => ({
      value: option.val,
      label: option.render
    })), disabled, onChange: (value) => {
      handleChange(field, value);
    }, renderRadioItem: (props2) => /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$7.customRadioInput, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupItem, { ...props2, testId: `${field}-${props2.label}` }),
      nodeValue === props2.value && radioChildren
    ] }), error: getError(field) }),
    [TEXTAREA2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { ...sharedProps, value: nodeValue, rows: 3, onChange: (e) => handleChange(field, e.target.value) }),
    [MESSAGE2]: () => /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { type: isError ? "error" : "info", children: [
      !isError && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$7.flexBetween, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Submission tip" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { overrideValue: label })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: label })
    ] }),
    [CHECKBOX2]: () => /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: Boolean(nodeValue), onClick: () => handleChange(field, !nodeValue), disabled, ...sharedProps })
  };
  if (!COMPONENTS_MAP[type]) {
    return null;
  }
  return COMPONENTS_MAP[type]();
}
QuestionnaireFormField.propTypes = {
  getError: PropTypes.func,
  handleChange: PropTypes.func,
  node: PropTypes.object,
  nodeValue: PropTypes.any
};
QuestionnaireFormField.defaultProps = {
  getError: () => {
  },
  handleChange: () => {
  },
  node: {},
  nodeValue: void 0
};
const QuestionnaireFormField$1 = observer(QuestionnaireFormField);
const {
  RADIO_GROUP,
  HIDDEN
} = TYPE_OPTIONS$1;
function QuestionnaireNode({
  node,
  store,
  getError,
  setQuestionnaireEdit,
  managePresentFields,
  settlementDate
}) {
  const {
    setAttr,
    getAttr
  } = store || {};
  const {
    children,
    field,
    autoFill,
    initValue
  } = node || {};
  const testId = `node-${field}`;
  const nodeValue = getAttr(field);
  const setValueForField = k$1.useCallback((field2, value) => {
    try {
      setAttr(field2, value);
    } catch (e) {
    }
    setQuestionnaireEdit(field2, value);
  }, [setAttr, setQuestionnaireEdit]);
  k$1.useEffect(() => {
    managePresentFields(field);
    if (initValue !== void 0) {
      setValueForField(field, initValue);
    }
    store.domSettingsStore.setNode(field, node);
    return () => {
      setValueForField(field, null);
      managePresentFields(field, false);
      store.domSettingsStore.unsetNode(field);
    };
  }, [setValueForField, managePresentFields, field, initValue, node]);
  const handleAutoFill = k$1.useCallback((newValue) => {
    const autoFillOption = autoFill?.[newValue];
    const autoFillEntries = autoFillOption ? Object.entries(autoFillOption) : [];
    autoFillEntries.forEach((entry) => {
      const [autoFillField, autoFillValue] = entry;
      setAttr(autoFillField, autoFillValue);
      managePresentFields(autoFillField, isPresent(autoFillValue));
    });
  }, [autoFill, setAttr, managePresentFields]);
  const handleChange = k$1.useCallback((field2, value) => {
    if (autoFill) {
      handleAutoFill(value);
    }
    setValueForField(field2, value);
  }, [autoFill, handleAutoFill, setValueForField]);
  const baseProps = {
    store,
    getError,
    setQuestionnaireEdit,
    managePresentFields,
    parentValue: nodeValue,
    settlementDate
  };
  const isRadioNode = node.type === RADIO_GROUP;
  const isHidden = node.type === HIDDEN;
  const childrenArray = Array.isArray(children) && children.map((node2) => {
    const {
      key,
      parentRequirement = [],
      shouldDisplayField
    } = node2;
    if (shouldDisplayField instanceof Function && !shouldDisplayField(nodeValue, settlementDate)) {
      return null;
    }
    if (!parentRequirement.includes(nodeValue) && !anyNonEmptyParentValueAllowed(nodeValue, parentRequirement)) {
      return null;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionnaireNode, { node: node2, ...baseProps }, key);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil({
    [s$7.questionnaireNode]: !isHidden
  }), "data-testid": testId, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionnaireFormField$1, { getError, handleChange, node, nodeValue, radioChildren: isRadioNode ? childrenArray : null }),
    !isRadioNode && childrenArray
  ] });
}
QuestionnaireNode.propTypes = {
  node: PropTypes.object,
  parentValue: PropTypes.any,
  store: PropTypes.any,
  setQuestionnaireEdit: PropTypes.func,
  managePresentFields: PropTypes.func,
  getError: PropTypes.func,
  settlementDate: PropTypes.string
};
QuestionnaireNode.defaultProps = {
  node: {},
  parentValue: null,
  store: {},
  setQuestionnaireEdit: () => {
  },
  managePresentFields: () => {
  },
  getError: () => {
  },
  settlementDate: ""
};
const QuestionnaireNode$1 = observer(QuestionnaireNode);
function QuestionnaireContainer({
  questionnaire,
  questionnaireStore,
  setQuestionnaireEdit,
  managePresentFields,
  missingQuestionnaireFields,
  invalidFieldsMap,
  formSubmitted,
  settlementDate
}) {
  const {
    label,
    children
  } = questionnaire || {};
  const getError = (field) => {
    if (!formSubmitted)
      return;
    const invalidError = invalidFieldsMap?.[field];
    if (missingQuestionnaireFields.includes(field)) {
      return REQUIRED_FIELD_ERROR;
    } else if (invalidError) {
      return invalidError;
    }
  };
  const baseProps = {
    store: questionnaireStore,
    setQuestionnaireEdit,
    managePresentFields,
    getError,
    settlementDate
  };
  if (!label || !(children && children.length))
    return null;
  try {
    Object.keys(questionnaireStore).forEach((field) => questionnaireStore[field]);
  } catch (err) {
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$7.questionnaireContainer, children: children.map((node) => {
    const nodeProps = {
      node,
      ...baseProps,
      ...node && node.key && {
        key: node.key
      }
    };
    return /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionnaireNode$1, { ...nodeProps }, node?.key);
  }) });
}
QuestionnaireContainer.propTypes = {
  questionnaire: PropTypes.object,
  questionnaireStore: PropTypes.object,
  setQuestionnaireEdit: PropTypes.func,
  managePresentFields: PropTypes.func,
  missingQuestionnaireFields: PropTypes.array,
  invalidFieldsMap: PropTypes.object,
  formSubmitted: PropTypes.bool,
  settlementDate: PropTypes.string
};
QuestionnaireContainer.defaultProps = {
  questionnaire: null,
  questionnaireStore: null,
  setQuestionnaireEdit: () => {
  },
  managePresentFields: () => {
  },
  missingQuestionnaireFields: [],
  invalidFieldsMap: {},
  formSubmitted: false,
  settlementDate: ""
};
const QuestionnaireContainer$1 = observer(QuestionnaireContainer);
function EUUKForm({
  disputeCategory,
  exceptionReasonApply,
  setAdditionalDetails,
  isCreateForm,
  formSubmitted,
  formValidation,
  meetsRegECriteria,
  regulationConditionsMetDate,
  computedRefundConditions,
  cardholderContactDate,
  isInitiatedByPayee
}) {
  const {
    INCORRECTLY_EXECUTED,
    UNAUTHORIZED
  } = DISPUTE_CATEGORIES;
  const showExceptionReasonCreateForm = meetsRegECriteria && [INCORRECTLY_EXECUTED, UNAUTHORIZED].includes(disputeCategory);
  const showExceptionReasonReadOnly = !isCreateForm && isPresent(exceptionReasonApply);
  const showExceptionReason = showExceptionReasonCreateForm || showExceptionReasonReadOnly;
  const regulationConditionsMetDateIsVisible = useMemo(() => {
    return isInitiatedByPayee && meetsRegECriteria && computedRefundConditions;
  }, [isInitiatedByPayee, computedRefundConditions, meetsRegECriteria]);
  const handleRegulationSubcategoryChange = useCallback((value) => {
    setAdditionalDetails("refund_conditions", "");
    setAdditionalDetails("regulation_conditions_met_date", "");
    setAdditionalDetails("regulation_subcategory", value);
    setAdditionalDetails("exception_reason_apply", "");
  }, [setAdditionalDetails]);
  const handleInitiatedByPayeeChange = useCallback((value) => setAdditionalDetails("refund_conditions", value), [setAdditionalDetails]);
  const handleRegulationConditionMetDateChange = useCallback((value) => setAdditionalDetails("regulation_conditions_met_date", value), [setAdditionalDetails]);
  const handleExceptionReasonApplyChange = useCallback((value) => setAdditionalDetails("exception_reason_apply", value), [setAdditionalDetails]);
  const readOnlyRefundConditions = useMemo(() => !isCreateForm && isPresent(regulationConditionsMetDate), [isCreateForm, regulationConditionsMetDate]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { testId: baseDisputeFormFields?.regulation_subcategory?.testId, disabled: !isCreateForm || disputeCategory === UNAUTHORIZED, label: baseDisputeFormFields?.regulation_subcategory?.label, groupItems: DISPUTE_CATEGORY_RADIO_ITEMS, value: disputeCategory, onChange: handleRegulationSubcategoryChange, error: formSubmitted && formValidation["regulation_subcategory"] }),
    (isInitiatedByPayee || readOnlyRefundConditions) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { testId: INITIATED_BY_PAYEE_FIELDS.refund_conditions.testId, label: INITIATED_BY_PAYEE_FIELDS.refund_conditions.label, groupItems: REFUND_CONDITIONS_ITEMS, groupName: INITIATED_BY_PAYEE_FIELDS.refund_conditions.groupName, value: computedRefundConditions, onChange: handleInitiatedByPayeeChange, error: formSubmitted && formValidation["refund_conditions"], disabled: !isCreateForm })
    ] }),
    (regulationConditionsMetDateIsVisible || readOnlyRefundConditions) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { formLabel: INITIATED_BY_PAYEE_FIELDS.regulation_conditions_met_date.label, testId: INITIATED_BY_PAYEE_FIELDS.regulation_conditions_met_date.testId, inputId: "regulation-conditions-met-date-input", value: formatDateForDateTimeInput(regulationConditionsMetDate), onChange: handleRegulationConditionMetDateChange, customStyles: {
        width: DATE_TIME_INPUT_WIDTH
      }, max: moment(), min: cardholderContactDate, disabled: !isCreateForm, error: formSubmitted && formValidation["regulation_conditions_met_date"] })
    ] }),
    showExceptionReason && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { testId: baseDisputeFormFields?.exception_reason_apply?.testId, label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: baseDisputeFormFields?.exception_reason_apply?.label, tooltip: EXCEPTION_REASON_TOOLTIP, direction: "top" }), groupItems: EXCEPTION_REASON_APPLY, value: exceptionReasonApply, disabled: !isCreateForm, onChange: handleExceptionReasonApplyChange, error: formSubmitted && formValidation["exception_reason_apply"] })
    ] })
  ] });
}
EUUKForm.propTypes = {
  disputeCategory: PropTypes.string,
  exceptionReasonApply: PropTypes.bool,
  setAdditionalDetails: PropTypes.func,
  isCreateForm: PropTypes.bool,
  formSubmitted: PropTypes.bool,
  formValidation: PropTypes.object,
  meetsRegECriteria: PropTypes.bool,
  regulationConditionsMetDate: PropTypes.string,
  computedRefundConditions: PropTypes.bool,
  cardholderContactDate: PropTypes.string,
  isInitiatedByPayee: PropTypes.bool
};
EUUKForm.defaultProps = {
  disputeCategory: "",
  setAdditionalDetails: () => {
  },
  isCreateForm: false,
  formSubmitted: false,
  formValidation: null,
  meetsRegECriteria: false,
  regulationConditionsMetDate: "",
  computedRefundConditions: false,
  cardholderContactDate: "",
  isInitiatedByPayee: false
};
const EUUKForm$1 = observer(EUUKForm);
function DisabledSubmitButton({
  isVisible
}) {
  if (!isVisible)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: {
      background: "#FFEAED",
      borderRadius: "4px"
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", flexDirection: "row", alignItems: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2, inline: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "warning", mod: "error", factor: 1, noHoverEffects: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 1, inline: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body", inline: true, id: "does_meet_conditions_error", children: "The case cannot be created. Please ensure that refund conditions are met." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2, inline: true })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "primary", disabled: true, children: "Create dispute" })
  ] });
}
DisabledSubmitButton.propTypes = {
  isVisible: PropTypes.bool
};
DisabledSubmitButton.defaultProps = {
  isVisible: false
};
const REFRESH_APPLICATION_PROPERTIES = gql`
query RefreshApplicationProperties {
  refreshApplicationProperties {
    allowable_dispute_itc
    invalid_transaction_states
    api_enabled_program_short_codes
    programs_required_crm_ticket_input
  }
}
`;
const useRefreshApplicationProperties = () => {
  const [refreshApplicationPropertiesQuery, {
    data,
    loading,
    error
  }] = useLazyQuery(REFRESH_APPLICATION_PROPERTIES);
  const refreshApplicationProperties = async () => {
    const variables = {
      "x-marqeta-program-short-code": "marqeta"
    };
    return await refreshApplicationPropertiesQuery({
      variables
    });
  };
  return {
    refreshApplicationProperties,
    data,
    loading,
    error
  };
};
const helpText = "_helpText_1lrbw_1";
const s$6 = {
  helpText
};
function DisputeForm({
  dispute,
  getAttr,
  handleChange,
  isCreateForm,
  submitButtons,
  showZendesk
}) {
  const {
    assignee,
    dispute_details,
    formSubmitted,
    formValidation,
    isEditing,
    isFullAmount,
    isLegacyDisputeType,
    isMastercard,
    isNetworkIntegrated,
    isReasonIntegrated,
    isTransactionIntegrated,
    isVisa,
    isVisaDisputeReasonSelected,
    isFraudDisputeReason,
    isVisaFraudReasonCode,
    isPulse,
    isPulseDisputeReasonSelected,
    isAuthorizationReasonCode,
    isAFTTransaction,
    memo,
    network_comment,
    meetsRegECriteria,
    transaction,
    isChargebackCase,
    isFraudCase,
    isEUUKProgram,
    // ATR functions and attributes
    partialDisputeAmountFromATR,
    selectedCaseType,
    shouldUseATRPartialAmount,
    toggleATRBasedDisputeAmount,
    shouldCalculateDisputeAmount,
    otherDisputeAmountErrorMessage,
    cardholder: {
      email: cardholderEmail
    } = {},
    is_dispute_impacted_by_local_law_or_regulation
  } = dispute || EMPTY_OBJECT;
  const {
    amount: transactionAmount,
    currency_code,
    formattedSettlementDate,
    formattedRequestAmount: formattedTransactionAmount,
    network,
    subnetwork,
    euCardOutOfJurisdictionTransaction
  } = transaction || EMPTY_OBJECT;
  const {
    additional_dispute_details,
    cardholder_contact_date,
    currentQuestionnaire,
    currentQuestionnaireStore,
    dispute_amount,
    dispute_reason,
    dispute_reason_code,
    fraud_dispute_type_details,
    fraud_category_type_dispute_details,
    fraud_classification_type_dispute_details,
    invalidFieldsMap,
    isRegE,
    managePresentFields,
    missingQuestionnaireFields,
    questionnaireEdits,
    zendesk_mapping,
    zendesk_mapping_id,
    account_status,
    cardholder_email_override,
    collaborationDetailsStore,
    setAttr: setDetailsAttr
  } = dispute_details || EMPTY_OBJECT;
  const {
    general_fraud_type_dispute_details
  } = fraud_dispute_type_details || EMPTY_OBJECT;
  const {
    setAttr: setChipOnCard,
    chip_on_card
  } = general_fraud_type_dispute_details || EMPTY_OBJECT;
  const {
    fraud_type: fraudType,
    setAttr: setFraudCategoryType
  } = fraud_category_type_dispute_details || EMPTY_OBJECT;
  const {
    setAttr: setFraudTypeClassification,
    fraud_type_classification: fraudTypeClassification
  } = fraud_classification_type_dispute_details || EMPTY_OBJECT;
  const {
    setEdit: setQuestionnaireEdit
  } = questionnaireEdits || EMPTY_OBJECT;
  const {
    regulation_subcategory: disputeCategory,
    setAttr: setAdditionalDetails,
    exception_reason_apply: exceptionReasonApply,
    regulation_conditions_met_date,
    computedRefundConditions
  } = additional_dispute_details || EMPTY_OBJECT;
  const rightAddOn = {
    content: currency_code
  };
  const DATE_TIME_INPUT_STYLES = {
    width: DATE_TIME_INPUT_WIDTH
  };
  const readableDisputeReason = useMemo(() => {
    let readableDisputeReason2 = "";
    if (isPresent(dispute_reason)) {
      const disputeReasonFieldLabel = dig(formattedDisputeReasonNetworkMap, dispute_reason, "label");
      readableDisputeReason2 = disputeReasonFieldLabel || sentenceCase(dispute_reason);
    } else if (isPresent(dispute_reason_code) && isEditing) {
      readableDisputeReason2 = dig(findByNetworkAndCode(network, dispute_reason_code), "label");
    }
    if (isNotPresent(readableDisputeReason2) && isEditing) {
      readableDisputeReason2 = getLegacyOptionsFromReasonMap(OTHER_DISPUTES).label;
    }
    return readableDisputeReason2;
  }, [dispute_reason, dispute_reason_code, network]);
  const fieldWidth = 540;
  const indentedFieldWidth = fieldWidth - 28;
  const isQuestionnaireVisible = !isLegacyDisputeType && currentQuestionnaire && currentQuestionnaireStore && isNetworkIntegrated && isReasonIntegrated && isTransactionIntegrated && isVisa || isPulse;
  const isReasonDisabled = !(isEditing || isCreateForm);
  const isFraudTypeClassificationDisabled = !isCreateForm || isEditing;
  const showReasonIntegrationMessage = dispute_reason && isNetworkIntegrated && !isReasonIntegrated && isTransactionIntegrated;
  const shouldShowDisputeCategory = isPresent(dispute_reason) && isEUUKProgram;
  const isAccountStatusValid = isAuthorizationReasonCode && flipFlop.get("october-network-mandate", false) && isVisa;
  const {
    isModalVisible
  } = useModalHandler(dispute);
  if ([void 0, null].includes(dispute_amount)) {
    setDetailsAttr && setDetailsAttr("dispute_amount", transactionAmount);
  }
  const reasons = useMemo(() => {
    const integratedReasons = disputeReasonsPerNetwork(network).map(formatDisputeReasonOption);
    const nonIntegratedReasons = getLegacyDisputeReasons(network, subnetwork).map((reason) => {
      const {
        label
      } = getLegacyOptionsFromReasonMap(reason);
      return {
        id: reason,
        isLegacy: true,
        render: label,
        searchString: label,
        val: reason
      };
    });
    return [...integratedReasons, ...nonIntegratedReasons];
  }, [network, subnetwork]);
  const handleChipOnCardChange = useCallback((value) => {
    setChipOnCard("chip_on_card", value);
  }, [setChipOnCard]);
  const handleFraudTypeClassificationChange = useCallback((option) => {
    setFraudTypeClassification("fraud_type_classification", option?.val);
  }, [setFraudTypeClassification]);
  const handleAccountStatusChange = useCallback((option) => {
    setDetailsAttr("account_status", option?.val);
  }, [setDetailsAttr]);
  const handleImpactedByLocalLawOrRegChange = useCallback((value) => {
    dispute.setAttr("is_dispute_impacted_by_local_law_or_regulation", value);
  }, [dispute?.setAttr]);
  const hideDocumentModal = useCallback(() => dispute.setAttr("documentModalVisible", false), [dispute?.setAttr]);
  const isAmountEditingDisabled = !isCreateForm && isRegE;
  const partialAmountDisabled = useMemo(() => isFullAmount || isAmountEditingDisabled, [isAmountEditingDisabled, isFullAmount]);
  const isFullAmountDisabled = useMemo(() => isAmountEditingDisabled || !isCreateForm && shouldCalculateDisputeAmount, [isAmountEditingDisabled, isCreateForm, shouldCalculateDisputeAmount]);
  const handleFraudTypeChange = useCallback((option) => {
    setFraudCategoryType("fraud_type", option?.val);
  }, [setFraudCategoryType]);
  const {
    getActiveProgram
  } = disputeStorage || EMPTY_OBJECT;
  const activeProgramShortCode = parseAndGet(getActiveProgram(), "short_name");
  const isAFFCONProgram = activeProgramShortCode === "affcon";
  const enableZendeskCreation = LEGACY_ZENDESK_PROGRAM_SHORTCODES.includes(activeProgramShortCode);
  const programsRequiredCRMFlag = flipFlop.get("programs-required-crm-input", false);
  const shouldValidateCRM = programsRequiredCRMFlag ? ["coineu", "coin", "coinuk"].includes(activeProgramShortCode) : false;
  if (dispute_details) {
    setDetailsAttr("isProgramRequiredCRM", shouldValidateCRM);
  }
  const shouldShowCreateCRM = isCreateForm && showZendesk?.create && enableZendeskCreation && flipFlop.get("create-salesforce-ticket", false) || flipFlop.get("force-show-create-salesforce-ticket", false);
  const shouldShowZendeskCreate = isCreateForm && showZendesk?.create && enableZendeskCreation && !flipFlop.get("create-salesforce-ticket", false) && !flipFlop.get("hide-create-zendesk", false);
  const memoField = useMemo(() => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { value: memo, label: baseDisputeFormFields?.memo?.label, rows: 2, width: fieldWidth, onChange: (e) => handleChange("memo", e.target.value), testId: baseDisputeFormFields?.memo?.testId })
    ] });
  }, [memo, baseDisputeFormFields, fieldWidth, handleChange]);
  const showChargebackForm = useMemo(() => {
    const shouldShowChargebackForNetwork = isVisa ? isChargebackCase : true;
    return isCreateForm && shouldShowChargebackForNetwork || !isCreateForm;
  }, [isCreateForm, isVisa, isChargebackCase]);
  const showFraudForm = useMemo(() => isFraudCase && isCreateForm, [isFraudCase, isCreateForm]);
  const commentsField = useMemo(() => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { value: network_comment, label: baseDisputeFormFields?.network_comment?.label, rows: 2, width: fieldWidth, disabled: !isCreateForm, onChange: (e) => handleChange("network_comment", e.target.value), testId: baseDisputeFormFields?.network_comment?.testId })
    ] });
  }, [network_comment, baseDisputeFormFields, fieldWidth, handleChange]);
  useEffect(() => {
    if (isCreateForm && isNotPresent(assignee)) {
      dispute.setAttr("assignee", currentUserFromStorage());
    }
  }, [assignee, dispute, isCreateForm]);
  useEffect(() => {
    if (isCreateForm) {
      const newCategory = isFraudDisputeReason ? DISPUTE_CATEGORIES.UNAUTHORIZED : "";
      setAdditionalDetails && setAdditionalDetails("regulation_subcategory", newCategory);
    }
  }, [isCreateForm, isFraudDisputeReason, setAdditionalDetails]);
  useEffect(() => {
    if (dispute_reason === "CANCELLED_RECURRING_TRANSACTION") {
      transaction && transaction.hydrateIssuingCountry();
      let value = collaborationDetailsStore?.cancelled_recurring_transaction_details?.is_dispute_impacted_by_local_law_or_regulation;
      if (isPresent(value)) {
        dispute.setAttr("is_dispute_impacted_by_local_law_or_regulation", value);
      }
    }
  }, [dispute_reason]);
  const isInitiatedByPayee = useMemo(() => meetsRegECriteria && disputeCategory === DISPUTE_CATEGORIES.INITIATED_BY_PAYEE, [disputeCategory, meetsRegECriteria]);
  const showAfterCaseTypeIsSelected = useMemo(() => (isVisa ? selectedCaseType : true) || !isCreateForm, [isVisa, selectedCaseType, isCreateForm]);
  const submitButtonsAreVisible = useMemo(() => submitButtons?.length && showAfterCaseTypeIsSelected && (!meetsRegECriteria || !isInitiatedByPayee || computedRefundConditions !== false), [isInitiatedByPayee, computedRefundConditions, submitButtons?.length, meetsRegECriteria, showAfterCaseTypeIsSelected]);
  const refundConditionsNotMet = useMemo(() => isInitiatedByPayee && computedRefundConditions === false, [isInitiatedByPayee, computedRefundConditions]);
  const zendeskToCRMSwitchOver = flipFlop.get("zendesk-to-crm-switch-over", false);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    showChargebackForm && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: baseDisputeFormFields?.assignee?.label, onChange: (e) => handleChange("assignee", e.target.value), value: assignee, width: fieldWidth, testId: baseDisputeFormFields?.assignee?.testId }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: baseDisputeFormFields?.dispute_amount?.label }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: isFullAmount, onClick: () => {
          handleChange("dispute_amount", transactionAmount);
          handleChange("dispute_amount_change_reason", null);
        }, disabled: isFullAmountDisabled, testId: baseDisputeFormFields?.full_dispute_amount_radio?.testId, children: baseDisputeFormFields?.full_dispute_amount_radio?.label }),
        isFullAmount && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$c.formRadioInput, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: formattedTransactionAmount, rightAddOn, width: indentedFieldWidth, testId: baseDisputeFormFields?.disabled_dispute_amount_input?.testId, disabled: true }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: !isFullAmount, onClick: () => handleChange("dispute_amount", 0), testId: baseDisputeFormFields?.partial_dispute_amount_radio?.testId, disabled: isAmountEditingDisabled, children: "Other amount" }),
        !isFullAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$c.formRadioInput, "data-testid": "other-amount-section", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { value: shouldUseATRPartialAmount ? partialDisputeAmountFromATR : getAttr("dispute_amount"), width: indentedFieldWidth, disabled: partialAmountDisabled, onChange: (e) => {
            toggleATRBasedDisputeAmount(false);
            handleChange("dispute_amount", e.target.value);
          }, rightAddOn, error: formSubmitted ? formValidation["dispute_amount"] : "", testId: baseDisputeFormFields?.dispute_amount?.testId }),
          otherDisputeAmountErrorMessage ? /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: otherDisputeAmountErrorMessage })
          ] }) : null,
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: baseDisputeFormFields?.dispute_amount_change_reason?.label, value: getAttr("dispute_amount_change_reason", sentenceCase), options: disputeAmountChangeReasons.map((reason) => ({
            id: reason,
            val: reason,
            render: sentenceCase(reason)
          })), onChange: (value) => handleChange("dispute_amount_change_reason", value.val), error: formSubmitted ? formValidation["dispute_amount_change_reason"] : "", width: indentedFieldWidth, disabled: isFullAmount, rightAddOn, testId: baseDisputeFormFields?.dispute_amount_change_reason?.testId })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { formLabel: baseDisputeFormFields?.cardholder_contact_date?.label, testId: baseDisputeFormFields?.cardholder_contact_date?.testId, inputId: "cardholder-contact-date", value: formatDateForDateTimeInput(cardholder_contact_date), error: formSubmitted && formValidation["cardholder_contact_date"], onChange: (val) => {
        if (isInitiatedByPayee) {
          setAdditionalDetails("regulation_conditions_met_date", "");
        }
        handleChange("cardholder_contact_date", val);
      }, disabled: !isCreateForm, customStyles: DATE_TIME_INPUT_STYLES, max: moment() }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil(s$c.reasonWrap, {
        [s$6.helpText]: showReasonIntegrationMessage
      }), children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: baseDisputeFormFields?.dispute_reason?.label, value: readableDisputeReason, placeholder: "Select reason or enter reason code", options: reasons, onChange: (value) => {
          handleChange("dispute_reason", value.val);
          if (!isModalVisible) {
            hideDocumentModal();
          }
        }, error: formSubmitted ? formValidation.dispute_reason : "", showSearch: true, disabled: isReasonDisabled, width: fieldWidth, testId: baseDisputeFormFields?.dispute_reason?.testId }),
        shouldShowDisputeCategory && /* @__PURE__ */ jsxRuntimeExports.jsx(EUUKForm$1, { disputeCategory, exceptionReasonApply, setAdditionalDetails, isCreateForm, formSubmitted, formValidation, meetsRegECriteria, regulationConditionsMetDate: regulation_conditions_met_date, computedRefundConditions, cardholderContactDate: cardholder_contact_date, isInitiatedByPayee }),
        showReasonIntegrationMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "footnote", testId: "disputeReasonNotIntegrated", className: s$6.helpText, children: INTEGRATION_MESSAGES.REASON })
      ] }),
      isAccountStatusValid && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: baseDisputeFormFields?.account_status?.label, value: account_status, options: ACCOUNT_STATUS_OPTIONS.map((classification) => ({
          id: classification,
          val: classification,
          render: sentenceCase(classification)
        })), onChange: handleAccountStatusChange, error: formSubmitted ? formValidation["account_status"] : "", width: indentedFieldWidth, rightAddOn, testId: baseDisputeFormFields?.account_status?.testId })
      ] }),
      isVisaFraudReasonCode && flipFlop.get("disputes-nw-mandates-april-2024", false) && isAFTTransaction && isVisa && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: baseDisputeFormFields?.fraud_type_classification_select?.label, value: fraudTypeClassification, options: FRUAD_TYPE_CLASSIFICATION_OPTIONS.map((classification) => ({
          id: classification,
          val: classification,
          render: sentenceCase(classification)
        })), onChange: handleFraudTypeClassificationChange, error: formSubmitted ? formValidation["fraud_type_classification"] : "", width: indentedFieldWidth, disabled: isFraudTypeClassificationDisabled, rightAddOn, testId: baseDisputeFormFields?.fraud_type_classification_select?.testId })
      ] }),
      isVisaFraudReasonCode && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { testId: baseDisputeFormFields?.chip_on_card?.testId, disabled: isReasonDisabled, label: baseDisputeFormFields?.chip_on_card?.label, groupItems: FRAUD_ITEMS, groupName: baseDisputeFormFields?.chip_on_card?.groupName, value: chip_on_card, onChange: handleChipOnCardChange, error: formSubmitted ? formValidation["fraud_dispute_type_details"] : "" })
      ] }),
      is_dispute_impacted_by_local_law_or_regulation && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "dispute-impacted-by-local-law-or-reg", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: 'Visa requires documenation or notes to be sent for disputes that are impacted by local law or regulation. You can add this content in the "Comments sent to Visa" field.' }) })
      ] }),
      flipFlop.get("disputes-nw-mandates-april-2024", false) && euCardOutOfJurisdictionTransaction && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { testId: baseDisputeFormFields?.is_dispute_impacted_by_local_law_or_regulation?.testId, label: baseDisputeFormFields?.is_dispute_impacted_by_local_law_or_regulation?.label, groupItems: IMPACTED_BY_LOCAL_LAW_OR_REG_ITEMS, groupName: baseDisputeFormFields?.is_dispute_impacted_by_local_law_or_regulation?.groupName, value: is_dispute_impacted_by_local_law_or_regulation, onChange: handleImpactedByLocalLawOrRegChange, error: formSubmitted ? formValidation["dispute_impacted_by_local_law_or_reg"] : "" })
      ] }),
      isQuestionnaireVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(QuestionnaireContainer$1, { formSubmitted, invalidFieldsMap, managePresentFields, missingQuestionnaireFields, questionnaire: currentQuestionnaire, questionnaireStore: currentQuestionnaireStore, setQuestionnaireEdit, settlementDate: transaction?.settlement_date }),
      (isVisaDisputeReasonSelected || isPulseDisputeReasonSelected) && commentsField,
      memoField,
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
        (shouldShowCreateCRM || shouldValidateCRM) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: zendesk_mapping === "create", id: "createZendeskTicket", label: "Create CRM ticket for communication with Marqeta", onClick: () => {
            setDetailsAttr("zendesk_mapping", zendesk_mapping === "create" ? null : "create");
          }, error: formSubmitted ? formValidation["createOrEnterCRM"] : null }),
          zendesk_mapping === "create" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: `Cardholder email${cardholderEmail ? ` - ${cardholderEmail}` : ""}`, placeholder: cardholderEmail ? `Override ${cardholderEmail}` : "cardholder@example.com", value: cardholder_email_override, onChange: (e) => setDetailsAttr("cardholder_email_override", e.target.value), error: formSubmitted ? formValidation["email_is_required"] : "" }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
          ] })
        ] }),
        shouldShowZendeskCreate && /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: zendesk_mapping === "create", id: "createZendeskTicket", label: "Create Zendesk ticket for communication with Marqeta", onClick: () => {
          setDetailsAttr("zendesk_mapping", zendesk_mapping === "create" ? null : "create");
        }, error: formSubmitted ? formValidation["zendesk_mapping_id"] : "" }),
        isCreateForm && (showZendesk?.update || shouldValidateCRM) && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { active: zendesk_mapping === "update", id: "createZendeskTicket", label: zendeskToCRMSwitchOver ? "Enter an existing CRM ticket ID" : "Enter an existing Zendesk ticket ID", onClick: () => {
            setDetailsAttr("zendesk_mapping", zendesk_mapping === "update" ? null : "update");
          }, error: formSubmitted ? formValidation["createOrEnterCRM"] : "" }),
          zendesk_mapping === "update" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { type: "number", onChange: (e) => {
              setDetailsAttr("zendesk_mapping_id", e.target.value);
            }, value: zendesk_mapping_id, error: formSubmitted ? formValidation["zendesk_mapping_id"] : "", placeholder: zendeskToCRMSwitchOver ? "Enter an existing CRM ticket ID" : "Enter an existing Zendesk ticket ID" })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
      isAFFCONProgram && /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: disputeCategory === DISPUTE_CATEGORIES.BNPL, id: "bnplFundedTransaction", label: "BNPL funded transaction", onClick: () => {
        setAdditionalDetails("regulation_subcategory", disputeCategory === DISPUTE_CATEGORIES.BNPL ? null : DISPUTE_CATEGORIES.BNPL);
      } })
    ] }),
    showFraudForm && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: baseDisputeFormFields?.assignee?.label, onChange: (e) => handleChange("assignee", e.target.value), value: assignee, width: fieldWidth, testId: baseDisputeFormFields?.assignee?.testId }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        width: fieldWidth
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FraudReportForm$1, { fraudType, onFraudTypeChange: handleFraudTypeChange, dispute }) }),
      memoField
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisabledSubmitButton, { isVisible: refundConditionsNotMet }),
    submitButtonsAreVisible && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "inline-flex", children: submitButtons.map((button2, i) => {
        const isLast = submitButtons.length - 1 === i;
        return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
          button2,
          !isLast && /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 })
        ] }, i);
      }) })
    ] })
  ] });
}
DisputeForm.propTypes = {
  dispute: PropTypes.any,
  handleChange: PropTypes.func,
  getAttr: PropTypes.func,
  submitButtons: PropTypes.array,
  isCreateForm: PropTypes.bool,
  showZendesk: PropTypes.shape({
    create: PropTypes.bool,
    update: PropTypes.bool
  })
};
DisputeForm.defaultProps = {
  dispute: null,
  handleChange: PropTypes.func,
  getAttr: () => {
  },
  submitButtons: null,
  isCreateForm: false,
  showZendesk: {
    create: false,
    update: false
  }
};
const DisputeForm$1 = observer(DisputeForm);
function EditDisputeForm({
  dispute,
  atrFlow = false
}) {
  const {
    atrRequired: atrRequired2,
    digDetails,
    disputeFormIsValid,
    hydrate,
    setDigDetails,
    state,
    submitATRAndTransition,
    updateCase,
    setAttr,
    // Destructure these attributes to force a rerender on update
    dispute_details,
    edits,
    isDisputeLegacy,
    isVisa,
    preventReload,
    transitions,
    showCaseTransitionNoteModal,
    hideCaseTransitionNoteModal,
    caseTransitionModalConfig,
    loading,
    isNegativePartialDisputeAmount,
    formValidation,
    skipAutoLoad
  } = dispute || {};
  const {
    questionnaireIsEdited,
    presentQuestionnaireStoreFields
  } = dispute_details || {};
  const {
    transitionToReady,
    memo,
    setAttr: setTransitionsAttr
  } = transitions || {};
  const {
    setEdit,
    getHasEdits
  } = edits || {};
  const {
    getCreationOrigin
  } = disputeStorage || {};
  const origin = getCreationOrigin();
  const {
    heading,
    buttonText,
    testId,
    action: action2
  } = caseTransitionModalConfig || {};
  const {
    isModalVisible
  } = useModalHandler(dispute);
  const hideDocumentModal = useCallback(() => setAttr("documentModalVisible", false), [setAttr]);
  const shouldReloadDispute = !presentQuestionnaireStoreFields.length && isVisa && !isDisputeLegacy && !atrRequired2 && !preventReload && !skipAutoLoad;
  useEffect(() => {
    if (shouldReloadDispute) {
      dispute.hydrate();
    }
  }, [shouldReloadDispute, dispute]);
  const onMemoChange = (value) => {
    setTransitionsAttr("memo", value);
  };
  const handleTransitionToReadyWithNote = async () => {
    hideCaseTransitionNoteModal();
    if (atrFlow) {
      return await submitATRAndTransition(hydrate);
    }
    await transitionToReady();
  };
  const saveAndTransition = async () => {
    if (getHasEdits() || questionnaireIsEdited) {
      await updateCase();
    }
    await transitionToReady(!origin);
  };
  const saveDoTransitionAndHideModal = async () => {
    await handleEditSubmission();
    hideDocumentModal();
  };
  const handleMarkAsReadyClick = async () => {
    setAttr("formSubmitted", true);
    if (!disputeFormIsValid) {
      return;
    }
    if (isModalVisible) {
      return setAttr("documentModalVisible", true);
    }
    await handleEditSubmission();
  };
  const handleEditSubmission = async () => {
    if (atrFlow) {
      return await submitATRAndTransition(hydrate);
    }
    await saveAndTransition();
  };
  const handleSave = async () => {
    setAttr("formSubmitted", true);
    if (disputeFormIsValid) {
      await updateCase(hydrate);
    }
  };
  const handleChange = (attr, val) => {
    setEdit(attr, val);
    setDigDetails(attr, val);
  };
  const getAttr = (attr, formatter) => {
    const value = edits[attr] || digDetails(attr);
    if (formatter instanceof Function) {
      return formatter(value);
    }
    return value;
  };
  const isMarkAsReadyDisabled = useMemo(() => {
    const invalidAmount = isNegativePartialDisputeAmount;
    return loading || invalidAmount || formValidation["attached_documents"];
  }, [loading, isNegativePartialDisputeAmount, formValidation]);
  const getSubmitButtons = () => {
    const buttons = [/* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
      isNegativePartialDisputeAmount && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: "Marking as ready is not available. To continue the cases workflow, please edit the associated transactions selection or edit the dispute amount to be greater than zero. Otherwise please withdraw and close the case." }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(SplitButton, { dropdownPosition: "above", onClick: handleMarkAsReadyClick, disabled: isMarkAsReadyDisabled, options: [{
        text: "Mark as ready with note",
        onOptionClick: () => showCaseTransitionNoteModal(TRANSITION_NOTE_MODAL_TYPES.REVIEW)
      }], testId: "dispute-form-mark-ready-button", type: atrFlow ? "tertiary" : "primary", children: "Mark as ready" }, "dispute-form-mark-ready-button")
    ] }, "dispute-form-mark-buttons")];
    if (state === "OPEN" && !atrFlow) {
      return [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "tertiary", onClick: handleSave, children: "Save" }, "dispute-form-save-btn"), ...buttons];
    }
    return buttons;
  };
  const isDocumentModalVisible = isModalVisible && dispute.documentModalVisible;
  const isTransitionMemoModalVisible = action2 === "REVIEW";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    !atrFlow && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: "Confirm dispute details" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    isDocumentModalVisible && !isTransitionMemoModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentModal, { transitionToReady: saveDoTransitionAndHideModal, hide: hideDocumentModal, loading }),
    isTransitionMemoModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionCaseWithNoteModal, { transitionCase: handleTransitionToReadyWithNote, hide: hideCaseTransitionNoteModal, memo, onMemoChange, heading, buttonText, testId, withRequiredDocumentationAlert: isModalVisible }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeForm$1, { dispute, handleChange, getAttr, submitButtons: getSubmitButtons(), isCreateForm: false })
  ] });
}
EditDisputeForm.propTypes = {
  dispute: PropTypes.any,
  atrFlow: PropTypes.bool
};
EditDisputeForm.defaultProps = {
  dispute: null,
  atrFlow: false
};
const EditDisputeForm$1 = observer(EditDisputeForm);
const integrationMessage = "_integrationMessage_8f64a_1";
const styles$2 = {
  integrationMessage
};
const IntegrationMessage = ({
  isLegacyDispute,
  isNetworkIntegrated,
  isReasonIntegrated,
  isTransactionIntegrated,
  isTransitionedToLegacy,
  extraSpacing
}) => {
  if (!isLegacyDispute) {
    return null;
  }
  const {
    DISPUTE_TYPE,
    NETWORK,
    REASON,
    TRANSACTION_TYPE: TRANSACTION_TYPE2,
    TRANSITIONED_TO_LEGACY
  } = INTEGRATION_MESSAGES;
  //! order here is crucial since every non-integrated dispute has "LEGACY_DISPUTE".
  const [messageKey] = [!isNetworkIntegrated && "network", !isTransactionIntegrated && "transaction", !isReasonIntegrated && "reason", isTransitionedToLegacy && "isTransitionedToLegacy", isLegacyDispute && "dispute"].filter(Boolean);
  const messages = {
    dispute: {
      text: DISPUTE_TYPE,
      testId: "dispute"
    },
    network: {
      text: NETWORK,
      testId: "disputeNetwork"
    },
    reason: {
      text: REASON,
      testId: "disputeReason"
    },
    transaction: {
      text: TRANSACTION_TYPE2,
      testId: "disputeTransactionType"
    },
    isTransitionedToLegacy: {
      text: TRANSITIONED_TO_LEGACY,
      testId: "isTransitionedToLegacy"
    }
  };
  const message = messages[messageKey];
  if (!message) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    extraSpacing && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { className: classUtil(s$6.helpText, styles$2.integrationMessage), testId: `${message.testId}NotIntegrated`, children: message.text })
  ] });
};
IntegrationMessage.propTypes = {
  isNetworkIntegrated: PropTypes.bool,
  isTransactionIntegrated: PropTypes.bool,
  isReasonIntegrated: PropTypes.bool,
  isLegacyDispute: PropTypes.bool,
  isTransitionedToLegacy: PropTypes.bool,
  extraSpacing: PropTypes.bool
};
IntegrationMessage.defaultProps = {
  isNetworkIntegrated: true,
  isTransactionIntegrated: true,
  isReasonIntegrated: true,
  isLegacyDispute: false,
  isTransitionedToLegacy: false,
  extraSpacing: false
};
const formatToken = (rawString) => `•••${rawString.slice(-4)}`;
const copyToClipboard = "_copyToClipboard_1wwls_1";
const styles$1 = {
  copyToClipboard
};
const columns$1 = [{
  key: "created_time",
  accessor: "created_time",
  header: "Created time"
}, {
  key: "token",
  accessor: "token",
  header: "Token",
  renderer: ({
    cellValue
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: styles$1.copyToClipboard, children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { fixOverflow: true, overrideValue: cellValue, children: /* @__PURE__ */ jsxRuntimeExports.jsx(ResourceLink$1, { name: formatToken(cellValue), token: cellValue }) }) })
}, {
  key: "type",
  accessor: "type",
  header: "Type"
}, {
  key: "state",
  accessor: "state",
  header: "State",
  renderer: ({
    cellValue
  }) => /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
    textTransform: "capitalize"
  }, children: cellValue.toLowerCase() })
}, {
  key: "amount",
  accessor: "amount",
  header: "Amount",
  renderer: ({
    cellValue,
    row
  }) => `${row.currency_code} ${cellValue}`
}];
const RelatedTransactionsTable = (props) => {
  const {
    loading,
    data
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { columns: columns$1, data, inlineStyle: {
    border: "none"
  }, loading, minWidth: 100 });
};
RelatedTransactionsTable.propTypes = {
  loading: PropTypes.bool,
  data: PropTypes.array
};
RelatedTransactionsTable.defaultProps = {
  loading: false,
  data: []
};
const GET_RELATED_TRANSACTIONS_QUERY = gql`
  query relatedTransactions(
    $count: Int
    $end_date: String
    $sort_by: String
    $start_date: String
    $start_index: Int
    $state: String
    $token: ID!
    $type: String
  ) {
    relatedTransactions(
      count: $count
      end_date: $end_date
      sort_by: $sort_by
      start_date: $start_date
      start_index: $start_index
      state: $state
      token: $token
      type: $type
    ) {
      count
      data {
        amount
        card {
          last_four
        }
        created_time
        currency_code
        state
        token
        type
      }
      end_index
      is_more
      start_index
    }
  }
`;
const useRelatedTransactions = (options) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_RELATED_TRANSACTIONS_QUERY, options);
  return {
    data: data?.relatedTransactions,
    loading,
    error
  };
};
const RelatedTransactions = (props) => {
  const {
    goTo,
    dispute
  } = props;
  const {
    data,
    loading
  } = useRelatedTransactions({
    variables: {
      token: dispute.dispute_details.original_transaction_token
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Container, { gutter: 24, padding: 0, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Row, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Col, { span: 9, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: "Related transactions" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(RelatedTransactionsTable, { loading, data: data?.data })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Col, { span: 3, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AuxDisputeDetails$1, { dispute, goTo }) })
  ] }) });
};
RelatedTransactions.propTypes = {
  goTo: PropTypes.func,
  dispute: PropTypes.object
};
RelatedTransactions.defaultProps = {
  goTo: () => {
  },
  dispute: {}
};
const atrTableCheckbox = "_atrTableCheckbox_1nrvz_1";
const s$5 = {
  atrTableCheckbox
};
class ATRSelectionTable extends ParentTable {
  constructor(props) {
    super(props);
    this.state = {
      ...this.colEditState(props, this.columns())
    };
  }
  columns() {
    return [{
      header: "Settled date",
      accessor: "formattedTransactionDate",
      key: "formattedTransactionDate"
    }, {
      header: "Transaction type",
      accessor: "formattedTransactionType",
      key: "formattedTransactionType"
    }, {
      header: "Total amount",
      accessor: "formattedAmountWithCurrency",
      key: "formattedAmountWithCurrency",
      renderer: ({
        cellValue
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx("span", { children: cellValue }),
      headerStyle: {
        flexDirection: "row-reverse"
      },
      rendererContainerStyle: {
        marginLeft: "auto"
      }
    }, {
      header: "Authorization code",
      accessor: "auth_code",
      key: "auth_code"
    }, {
      header: "Merchant",
      accessor: "formattedMerchant",
      key: "formattedMerchant"
    }];
  }
  actionColumn() {
    return {
      header: this.rightColumnHeader(),
      accessor: "token",
      key: "token",
      primaryKey: true,
      renderer: () => null,
      noPadding: true,
      noResize: true,
      noRowClick: true,
      noSort: true,
      noEdit: true,
      width: 40,
      deferRenderPlaceholder: () => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionPlaceholder, { width: 32 }),
      customFilter: null
    };
  }
  selectColumn() {
    const {
      atrList,
      toggleATRBasedDisputeAmount,
      viewOnly
    } = this.props;
    const {
      allSelected,
      toggleAllSelected,
      notAssociated,
      setAttr,
      filterBySelect,
      allColumnsIsUnavailable
    } = atrList || {};
    const toggleFilter = () => {
      setAttr("filterBySelect", !filterBySelect);
    };
    const handleClickAndSetDisputeAmount = (onClickHandler) => {
      onClickHandler && onClickHandler();
      toggleATRBasedDisputeAmount(true);
    };
    return {
      header: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$5.atrTableCheckbox, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: allSelected, onClick: () => handleClickAndSetDisputeAmount(toggleAllSelected), disabled: viewOnly || allColumnsIsUnavailable, testId: "atr-table-select-all-checkbox" }) }),
      accessor: "selected",
      key: "selected",
      renderer: ({
        row
      }) => {
        const {
          selected,
          toggleSelected,
          token,
          isCustomTransaction
        } = row || {};
        if (isCustomTransaction)
          return null;
        return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$5.atrTableCheckbox, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: selected, onClick: () => handleClickAndSetDisputeAmount(toggleSelected), testId: `atr-cell-checkbox_${token}`, disabled: viewOnly || notAssociated }) });
      },
      noPadding: true,
      noResize: true,
      noRowClick: true,
      noSort: true,
      noEdit: true,
      width: "40px",
      customFilter: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$5.atrTableCheckbox, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active: filterBySelect, onClick: toggleFilter, disabled: viewOnly || notAssociated }) })
    };
  }
  rightColumnHeader() {
    const {
      localStorageKey,
      atrList
    } = this.props;
    const {
      handleClear
    } = atrList || {};
    return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionsHeader, { actions: [{
      text: "Modify columns",
      onClick: () => this.setState({
        showColumnEditor: true
      })
    }, {
      text: "Reset table to default",
      onClick: () => {
        handleClear();
        clearColumnConfig(localStorageKey);
        this.setState({
          columns: this.columns()
        });
      }
    }] });
  }
  render() {
    const {
      tableKey,
      columns: columns2
    } = this.state;
    const {
      atrList
    } = this.props;
    const {
      currentList,
      activeSort,
      updateKey,
      atrTableHeight,
      tableFilters,
      modifyFilter,
      activeFilters,
      setAttr
    } = atrList || {};
    const allColumns = [this.actionColumn(), this.selectColumn(), ...columns2];
    try {
      atrList.currentList.forEach((item) => (item.state, item.selected));
    } catch (err) {
      console.error(err);
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "atr-selection-table", children: [
      this.renderColEditTableHeader({
        filterOptions: tableFilters,
        tableFilterTestId: "atr-table-header-buttons"
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { height: atrTableHeight, data: currentList, columns: allColumns, fixedColumnCount: 1, rightAlignFixedColumns: true, sort: activeSort, onSort: (newSort) => setAttr("activeSort", newSort), scrollToTopUpdateKey: updateKey, deferRenderTimeout: 500, handleColSizeChange: this.handleColSizeChange.bind(this), handleResetTable: this.clearFilterFunc, filterable: true, filters: activeFilters, onFilter: modifyFilter }, tableKey)
    ] });
  }
}
ATRSelectionTable.propTypes = {
  viewOnly: PropTypes.bool,
  atrList: PropTypes.any,
  height: PropTypes.number,
  toggleATRBasedDisputeAmount: PropTypes.func,
  localStorageKey: PropTypes.string,
  skipStoreConstruction: PropTypes.bool
};
ATRSelectionTable.defaultProps = {
  viewOnly: false,
  atrList: null,
  toggleATRBasedDisputeAmount: null,
  localStorageKey: "ATRSelectionTable",
  skipStoreConstruction: true
};
const ATRSelectionTable$1 = observer(ATRSelectionTable);
const CLOSE_CASE_AS_CASE_LOST = "CLOSE_CASE_AS_CASE_LOST";
const CLOSE_CASE_AS_WRITE_OFF = "CLOSE_CASE_AS_WRITE_OFF";
const NONE = "NONE";
const CLOSE_ACTIONS = {
  [CLOSE_CASE_AS_WRITE_OFF]: "Close case as write off",
  [CLOSE_CASE_AS_CASE_LOST]: "Close case as case lost"
};
const CLOSE_ACTIONS_OPTIONS = Object.keys(CLOSE_ACTIONS).reduce((acc, curr) => {
  acc.push({
    value: curr,
    label: CLOSE_ACTIONS[curr]
  });
  return acc;
}, []);
const CANCEL = "Cancel";
const CONFIRM_BUTTON_TEXT = "Confirm";
const SUBMIT_BUTTON_TEXT = "Submit";
const CASE_LOST_TITLE = "Mark case lost";
const CLOSE_ACTION_RADIO_TITLE = "Close case";
const WRITE_OFF_TITLE = "Write off the case";
const CLOSE_ACTION_RADIO_TEXT = "You are about to close the case. Choose a resolution state:";
const DEFAULT_CASE_LOST_TEXT = "Notify the cardholder of the network decision before marking the case as lost.";
const DEFAULT_WRITE_OFF_TEXT = "You are attempting to write off this case. This will impact the program funding source.";
const CLOSE_TRANSITION_REASON_CODES = {
  [CLOSE_CASE_AS_WRITE_OFF]: "45",
  [CLOSE_CASE_AS_CASE_LOST]: "42"
};
const CLOSE_CASE_AS_WRITE_OFF_V2 = "CLOSE_CASE_AS_WRITE_OFF_V2";
const writeoffWihCreditMessage = (amountStr, writeoffActor) => `A ${amountStr} provisional credit will be issued and become permanent before the case is closed as ${writeoffActor} write-off. This will impact the ${writeoffActor} funding source.`;
const CLOSE_CASE_WITHDRAW = "CLOSE_CASE_WITHDRAW";
const CLOSE_CASE_PROGRAM_WRITEOFF = "CLOSE_CASE_PROGRAM_WRITEOFF";
const CLOSE_CASE_ISSUER_WRITEOFF = "CLOSE_CASE_ISSUER_WRITEOFF";
const CLOSE_CASE_ACTIONS_CONFIG = {
  [CLOSE_CASE_WITHDRAW]: {
    label: "Close case as withdraw",
    value: CLOSE_CASE_WITHDRAW,
    code: "40"
  },
  [CLOSE_CASE_PROGRAM_WRITEOFF]: {
    label: "Close case as program write-off",
    value: [CLOSE_CASE_PROGRAM_WRITEOFF],
    code: "45",
    actor: "Program"
  },
  [CLOSE_CASE_ISSUER_WRITEOFF]: {
    label: "Close case as Marqeta write-off",
    value: CLOSE_CASE_ISSUER_WRITEOFF,
    code: "44",
    actor: "Marqeta"
  }
};
function CloseCaseLostModal({
  handleConfirm,
  hideModal
}) {
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleConfirm, testId: "select-close-action-btn", children: CONFIRM_BUTTON_TEXT }, "select-close-action")];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { buttonText: CONFIRM_BUTTON_TEXT, footerButtons, heading: CASE_LOST_TITLE, description: DEFAULT_CASE_LOST_TEXT, hideModal, hideModalButtonText: CANCEL, showHideModalButton: true, testId: "close-write-off-modal", type: "sm" });
}
CloseCaseLostModal.propTypes = {
  handleConfirm: PropTypes.func,
  hideModal: PropTypes.func
};
CloseCaseLostModal.defaultProps = {
  handleConfirm: () => {
  },
  hideModal: () => {
  }
};
const CloseCaseLostModal$1 = observer(CloseCaseLostModal);
function CloseActionRadioModal({
  setActiveCloseAction,
  hideModal,
  memo,
  setMemo
}) {
  const [selectedAction, selectAction] = useState();
  const isSubmitDisabled = useMemo(() => isNotPresent(CLOSE_ACTIONS[selectedAction]), [selectedAction]);
  const handleSubmit = useCallback(() => setActiveCloseAction(selectedAction), [selectedAction]);
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { disabled: isSubmitDisabled, onClick: handleSubmit, testId: "select-close-action-btn", children: SUBMIT_BUTTON_TEXT }, "select-close-action")];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { buttonText: SUBMIT_BUTTON_TEXT, footerButtons, heading: CLOSE_ACTION_RADIO_TITLE, description: CLOSE_ACTION_RADIO_TEXT, hideModal, hideModalButtonText: CANCEL, showHideModalButton: true, testId: "close-action-radio-modal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: selectedAction, groupItems: CLOSE_ACTIONS_OPTIONS, inline: false, onChange: selectAction }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: "Note", value: memo, onChange: (e) => setMemo(e.target.value), rows: 2, labelOptional: true })
  ] });
}
CloseActionRadioModal.propTypes = {
  setActiveCloseAction: PropTypes.func,
  hideModal: PropTypes.func,
  setMemo: PropTypes.func,
  memo: PropTypes.string
};
CloseActionRadioModal.defaultProps = {
  setActiveCloseAction: () => {
  },
  hideModal: () => {
  },
  setMemo: () => {
  },
  memo: ""
};
const CloseActionRadioModal$1 = observer(CloseActionRadioModal);
function CloseWriteOffModal({
  handleConfirm,
  hideModal,
  isPCTimeframeExpired,
  numOfDays,
  isEUUKProgram
}) {
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleConfirm, testId: "select-close-action-btn", children: CONFIRM_BUTTON_TEXT }, "select-close-action")];
  const TIME_LIMIT_TEXT = isEUUKProgram ? "" : `The ${numOfDays}-day time limit to resolve this case has expired. `;
  const OVERDUE_WRITE_OFF_TEXT = `${TIME_LIMIT_TEXT}
   The provisional credit will be made permanent, with funds transferred from the program funding source.`;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { buttonText: CONFIRM_BUTTON_TEXT, footerButtons, heading: WRITE_OFF_TITLE, description: isPCTimeframeExpired ? OVERDUE_WRITE_OFF_TEXT : DEFAULT_WRITE_OFF_TEXT, hideModal, hideModalButtonText: CANCEL, showHideModalButton: true, testId: "close-write-off-modal", type: "sm" });
}
CloseWriteOffModal.propTypes = {
  handleConfirm: PropTypes.func,
  hideModal: PropTypes.func,
  isPCTimeframeExpired: PropTypes.bool,
  numOfDays: PropTypes.number,
  isEUUKProgram: PropTypes.bool
};
CloseWriteOffModal.defaultProps = {
  handleConfirm: () => {
  },
  hideModal: () => {
  },
  isPCTimeframeExpired: false,
  isEUUKProgram: false
};
const CloseWriteOffModal$1 = observer(CloseWriteOffModal);
function CloseCaseWriteOffModal({
  writeoffAndClose,
  hideModal,
  transitionToWithdrawnAndClosed,
  formattedDisputeAmountWithCurrency,
  canPerformIssuerWriteOff
}) {
  const issuerWriteoffEnabled = flipFlop.get("marqeta-writeoff", false);
  const writeOffOptions = useMemo(() => {
    const baseWriteOffOptions = [CLOSE_CASE_WITHDRAW, CLOSE_CASE_PROGRAM_WRITEOFF];
    if (canPerformIssuerWriteOff && issuerWriteoffEnabled) {
      baseWriteOffOptions.push(CLOSE_CASE_ISSUER_WRITEOFF);
    }
    return baseWriteOffOptions.map((key) => {
      const {
        label,
        value
      } = CLOSE_CASE_ACTIONS_CONFIG[key];
      return {
        label,
        value
      };
    });
  }, [canPerformIssuerWriteOff, issuerWriteoffEnabled]);
  const [selectedAction, selectAction] = useState(CLOSE_CASE_WITHDRAW);
  const isCreditIssuanceApplicable = selectedAction !== CLOSE_CASE_WITHDRAW && Boolean(formattedDisputeAmountWithCurrency);
  const handleSubmit = useCallback(() => {
    if (selectedAction === CLOSE_CASE_WITHDRAW) {
      transitionToWithdrawnAndClosed();
    } else {
      writeoffAndClose(CLOSE_CASE_ACTIONS_CONFIG[selectedAction].code);
    }
    hideModal();
  }, [hideModal, selectedAction, writeoffAndClose, transitionToWithdrawnAndClosed]);
  const alertMessage = writeoffWihCreditMessage(formattedDisputeAmountWithCurrency, CLOSE_CASE_ACTIONS_CONFIG[selectedAction].actor);
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, testId: "select-close-action-v2-btn", children: CLOSE_ACTION_RADIO_TITLE }, "select-close-action-v2")];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { footerButtons, heading: CLOSE_ACTION_RADIO_TITLE, description: CLOSE_ACTION_RADIO_TEXT, hideModal, hideModalButtonText: CANCEL, showHideModalButton: true, testId: "close-action-v2-radio-modal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: selectedAction, groupItems: writeOffOptions, inline: false, onChange: selectAction }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    isCreditIssuanceApplicable && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: alertMessage })
  ] });
}
CloseCaseWriteOffModal.propTypes = {
  transitionToWithdrawnAndClosed: PropTypes.func.isRequired,
  writeoffAndClose: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  formattedDisputeAmountWithCurrency: PropTypes.string.isRequired,
  canPerformIssuerWriteOff: PropTypes.bool.isRequired
};
const CloseCaseWriteOffModal$1 = observer(CloseCaseWriteOffModal);
const contextProps = {
  isModalVisible: false,
  setIsModalVisible: () => {
  }
};
const CloseCaseModalContext = createContext(contextProps);
const CloseCaseModalContextWrapper = observer(({
  isPCTimeframeExpired,
  transitionToClosed,
  children,
  numOfDays,
  isEUUKProgram,
  transitionToWithdrawnAndClosed,
  formattedDisputeAmountWithCurrency,
  useWriteOffV2,
  canPerformIssuerWriteOff,
  writeoffAndClose,
  memo,
  setMemo
}) => {
  const enableCaseClosed = flipFlop.get("enable-case-closed-without-writeoff-rege", false);
  const [isModalVisible, setIsModalVisible] = useState();
  const [activeCloseAction, setActiveCloseAction] = useState();
  let defaultCloseAction = NONE;
  if (useWriteOffV2)
    defaultCloseAction = CLOSE_CASE_AS_WRITE_OFF_V2;
  else if (isPCTimeframeExpired && enableCaseClosed)
    defaultCloseAction = NONE;
  else if (isPCTimeframeExpired)
    defaultCloseAction = CLOSE_CASE_AS_WRITE_OFF;
  const currentReasonCode = CLOSE_TRANSITION_REASON_CODES[activeCloseAction || defaultCloseAction];
  useEffect(() => {
    if (isModalVisible) {
      setActiveCloseAction(defaultCloseAction);
    }
  }, [isModalVisible, defaultCloseAction]);
  const hideModal = useCallback(() => {
    setIsModalVisible(false);
    setActiveCloseAction(defaultCloseAction);
  }, [defaultCloseAction]);
  const handleConfirm = useCallback(async () => {
    hideModal();
    await transitionToClosed(currentReasonCode);
  }, [currentReasonCode, hideModal, transitionToClosed]);
  const ModalsMap = useMemo(() => /* @__PURE__ */ new Map([[CLOSE_CASE_AS_WRITE_OFF, /* @__PURE__ */ jsxRuntimeExports.jsx(CloseWriteOffModal$1, { hideModal, isPCTimeframeExpired, handleConfirm, numOfDays, isEUUKProgram }, CLOSE_CASE_AS_WRITE_OFF)], [CLOSE_CASE_AS_CASE_LOST, /* @__PURE__ */ jsxRuntimeExports.jsx(CloseCaseLostModal$1, { hideModal, isPCTimeframeExpired, handleConfirm }, CLOSE_CASE_AS_CASE_LOST)], [NONE, /* @__PURE__ */ jsxRuntimeExports.jsx(CloseActionRadioModal$1, { setActiveCloseAction, hideModal, isPCTimeframeExpired, memo, setMemo }, NONE)], [CLOSE_CASE_AS_WRITE_OFF_V2, /* @__PURE__ */ jsxRuntimeExports.jsx(CloseCaseWriteOffModal$1, { hideModal, transitionToWithdrawnAndClosed, writeoffAndClose, formattedDisputeAmountWithCurrency, canPerformIssuerWriteOff }, CLOSE_CASE_AS_WRITE_OFF_V2)]]), [canPerformIssuerWriteOff, formattedDisputeAmountWithCurrency, handleConfirm, hideModal, isEUUKProgram, isPCTimeframeExpired, numOfDays, transitionToWithdrawnAndClosed, writeoffAndClose, memo]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(CloseCaseModalContext.Provider, { value: {
    isModalVisible,
    setIsModalVisible
  }, children: [
    isModalVisible && ModalsMap.get(activeCloseAction),
    children
  ] });
});
CloseCaseModalContextWrapper.propTypes = {
  isPCTimeframeExpired: PropTypes$1.string,
  transitionToClosed: PropTypes$1.func,
  numOfDays: PropTypes$1.number,
  isEUUKProgram: PropTypes$1.bool,
  transitionToWithdrawnAndClosed: PropTypes$1.func.isRequired,
  formattedDisputeAmountWithCurrency: PropTypes$1.string.isRequired,
  useWriteOffV2: PropTypes$1.bool.isRequired,
  canPerformIssuerWriteOff: PropTypes$1.bool,
  writeoffAndClose: PropTypes$1.func.isRequired
};
CloseCaseModalContextWrapper.defaultProps = {
  isPCTimeframeExpired: null,
  transitionToClosed: () => {
  },
  isEUUKProgram: false,
  canPerformIssuerWriteOff: false
};
function ATRSelection({
  dispute
}) {
  const {
    associated_transactions,
    dispute_details,
    edits,
    formSubmitted,
    formValidation,
    setDigDetails,
    submitATRAndWithdraw,
    toggleATRBasedDisputeAmount,
    isViewOnly
  } = dispute || EMPTY_OBJECT;
  const {
    setIsModalVisible
  } = useContext(CloseCaseModalContext);
  const {
    explanationOfCreditRequired,
    invalid,
    notAssociated,
    selectedCount,
    setAttr
  } = associated_transactions || EMPTY_OBJECT;
  const {
    isRegEWithPCGranted,
    additional_dispute_details: {
      explanation_of_credit
    } = EMPTY_OBJECT
  } = dispute_details || EMPTY_OBJECT;
  const {
    setEdit
  } = edits || EMPTY_OBJECT;
  const handleCaseClose = useCallback(() => {
    isRegEWithPCGranted ? setIsModalVisible(true) : submitATRAndWithdraw();
  }, [setIsModalVisible, isRegEWithPCGranted, submitATRAndWithdraw]);
  const handleChange = (attr, val) => {
    setEdit(attr, val);
    setDigDetails(attr, val);
  };
  const style = {
    width: "100%"
  };
  const alertWidth = "728px";
  const fieldWidth = 731;
  const explanationOfCreditViewOnly = notAssociated && isViewOnly && explanation_of_credit;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      width: alertWidth
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { maxTextWidth: alertWidth, children: atrSelectionMessage }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(ATRSelectionTable$1, { viewOnly: isViewOnly, atrList: associated_transactions, toggleATRBasedDisputeAmount }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Checkbox, { active: notAssociated, onClick: () => setAttr("notAssociated", !notAssociated), disabled: isViewOnly || selectedCount > 0, error: formSubmitted && formValidation["notAssociated"] || null, testId: "atr-txns-not-associated-checkbox", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "These transactions are not associated." }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "I have reviewed the transactions above and determined that none of them are associated with the dispute." })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    notAssociated && !isViewOnly && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { value: explanation_of_credit, label: `Explanation of credit${explanationOfCreditRequired ? "" : " (optional)"}`, rows: 2, width: fieldWidth, sublabel: EXPLANATION_OF_CREDIT_SUB_LABEL, disabled: selectedCount > 0, error: formSubmitted ? formValidation["explanation_of_credit"] : "", onChange: (e) => handleChange("explanation_of_credit", e.target.value), testId: "atr-selection-explanation-of-credit" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        width: alertWidth
      }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { maxTextWidth: alertWidth, children: EXPLANATION_OF_CREDIT_WARNING }) })
    ] }),
    explanationOfCreditViewOnly && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: `Explanation of credit` }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { testId: "explanation-of-credit-view-only", children: explanation_of_credit })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    !isViewOnly && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "withdraw-and-close-atr-btn", type: "tertiary", onClick: handleCaseClose, disabled: invalid, children: "Withdraw and close" })
  ] });
}
ATRSelection.propTypes = {
  dispute: PropTypes.any
};
ATRSelection.defaultProps = {
  dispute: null
};
const ATRSelection$1 = observer(ATRSelection);
function ReviewATRDispute({
  dispute,
  isAttachAvailable,
  isMastercard,
  isVisa,
  onAttachClick
}) {
  const {
    disputeFilemanager,
    formValidation = {}
  } = dispute || EMPTY_OBJECT;
  const {
    detachFile
  } = disputeFilemanager || EMPTY_OBJECT;
  const noAttachedDocumentsError = formValidation?.["attached_documents"];
  const sections = useMemo(() => [{
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: "Review associated transactions" }),
    key: "associated_transactions",
    defaultExpanded: true,
    content: /* @__PURE__ */ jsxRuntimeExports.jsx(ATRSelection$1, { state: dispute.state, dispute })
  }, {
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", testId: "upload-related-documents-tab", children: "Upload related files" }),
    key: "related_documents",
    defaultExpanded: !!noAttachedDocumentsError,
    content: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocumentsForm$1, { isAttachAvailable, documentsStore: dispute?.documents, isMastercard, isVisa, onAttachClick, detachFile, error: noAttachedDocumentsError }) })
  }, {
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", testId: "confirm-dispute-details-tab", children: "Confirm dispute details" }),
    key: "review_details",
    content: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditDisputeForm$1, { dispute, atrFlow: true })
    ] })
  }], [dispute, isMastercard, isVisa, noAttachedDocumentsError]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { contentInset: "0px", divideSections: true, sections, spaceBetween: "24px", width: "100%", testId: "atr-accordion" });
}
ReviewATRDispute.propTypes = {
  dispute: PropTypes.object,
  isMastercard: PropTypes.bool,
  isVisa: PropTypes.bool,
  onAttachClick: PropTypes.func,
  isAttachAvailable: PropTypes.bool
};
ReviewATRDispute.defaultProps = {
  dispute: {},
  onAttachClick: () => {
  },
  isAttachAvailable: false
};
const ReviewATRDispute$1 = observer(ReviewATRDispute);
const BULK_FILE_UPLOADED_EVENT = "Bulk File Uploaded";
const DISPUTE_CREATION_VIA_TOKEN_INITIATED = "Dispute Creation via Token Initiated";
const EDIT_CASE_EVENT = "Dispute Edited";
const NETWORK_CASE_ID_UPDATED_EVENT = "Network Case ID Updated";
const NEW_DISPUTE_CREATED_EVENT = "New Dispute Case Created";
const SINGLE_FILE_UPLOADED_EVENT = "Single Dispute File Uploaded";
const BULK_REJECT_FILE_DOWNLOAD_EVENT = "Bulk Reject File Download";
const DISPUTES_QUEUE_FILTERED = "Disputes Queue Filtered";
const PROVISIONAL_CREDIT_GRANTED_EVENT = "Provisional credit granted";
const CREATED_CASE_EVENT = "Created case event";
const CASE_TRANSITION_EVENTS = {
  REVIEW: "Dispute Marked Ready",
  CLOSE: "Dispute Case Closed",
  RE_OPEN: "Dispute Reopened",
  CHANGE_CASE_TYPE: "Change Case Type",
  CHARGEBACK_CREDIT: "Dispute Submitted to Network",
  CHARGEBACK_NO_CREDIT: "Dispute Submitted to Network (No credit)"
};
const DISPUTE_TRANSITION_EVENTS = {
  REPRESENTMENT_RECEIVED: "Dispute Response Submitted",
  RESPOND_WITH_PREARB: "Pre-arbitration Request Added",
  RESPOND_WITH_PREARB_RESPONSE: "Pre-arbitration Response Added",
  RESPOND_WITH_ARB: "Arbitration Request Added",
  ACCEPT_AND_CLOSE: "Dispute Liability Accepted",
  CLOSE_WITH_CASE_WON: "Dispute Marked as Won",
  CLOSE_WITH_NETWORK_REJECTED: "Dispute Marked as Network Rejected"
};
const getProgramShortCode = () => {
  const {
    getActiveProgram
  } = disputeStorage || {};
  return parseAndGet(getActiveProgram(), "short_name");
};
const disputesSegmentTrackEvent = (eventName, eventProperties) => {
  eventName && segmentTrackEvent(eventName, {
    ...eventProperties,
    programShortCode: getProgramShortCode()
  });
};
function DisputeSegmentTrackHOC(props) {
  const {
    children,
    eventName,
    eventProperties
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(SegmentTrackHOC, { eventName, eventProperties: {
    ...eventProperties,
    programShortCode: getProgramShortCode()
  }, children });
}
DisputeSegmentTrackHOC.propTypes = {
  children: PropTypes.any,
  eventName: PropTypes.string,
  eventProperties: PropTypes.object
};
DisputeSegmentTrackHOC.defaultProps = {
  children: null,
  eventName: "",
  eventProperties: null
};
function TransactionTokenInputModal({
  verifyTransaction,
  goToNewDispute,
  hide
}) {
  const [loading, setLoading] = useState(false);
  const [transactionToken, setTransactionToken] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      document.querySelector('input[data-testid="transaction-token-input"]').focus();
    }, 0);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  const handleContinue = async () => {
    setLoading(true);
    try {
      const error2 = await verifyTransaction(transactionToken);
      if (error2) {
        disputesSegmentTrackEvent(DISPUTE_CREATION_VIA_TOKEN_INITIATED, {
          errorStatus: true
        });
        setError(error2 || `Transaction token invalid.`);
      } else {
        disputesSegmentTrackEvent(DISPUTE_CREATION_VIA_TOKEN_INITIATED, {
          errorStatus: false
        });
        setError(null);
        goToNewDispute(transactionToken);
      }
    } catch (err) {
      disputesSegmentTrackEvent(DISPUTE_CREATION_VIA_TOKEN_INITIATED, {
        errorStatus: true
      });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleContinue, disabled: loading, testId: "create-dispute-transaction-modal-button", children: /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { transparentBackground: true, borderRadius: "extra-small", active: loading, children: "Continue" }) }, "create-dispute-transaction-modal-button")];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FocusTrap, { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { footerButtons, heading: "Create manual case", hideModal: hide, testId: "create-dispute-transaction-modal", width: "588px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { error, label: "Transaction token", onChange: (e) => setTransactionToken(e.target.value), sublabel: "Enter the token for the transaction you would like to dispute.", testId: "transaction-token-input", value: transactionToken }) }) });
}
TransactionTokenInputModal.propTypes = {
  verifyTransaction: PropTypes.func,
  goToNewDispute: PropTypes.func,
  hide: PropTypes.func
};
TransactionTokenInputModal.defaultProps = {
  verifyTransaction: null,
  goToNewDispute: null,
  hide: null
};
const TransactionTokenInputModal$1 = observer(TransactionTokenInputModal);
const {
  OPEN,
  OPEN_WITH_ACTION_REQUIRED,
  READY,
  CHARGEBACK_INITIATED,
  CLOSED: CLOSED$1,
  PENDING_CLOSE
} = STATE_MAP;
const DISPUTES_TABS = {
  ALL_DISPUTES: "All disputes",
  FRONTEND_INTAKE: "Frontend intake",
  BACKEND_RESOLUTION: "Backend resolution",
  CLOSED: "Closed",
  PENDING_CLOSE: "Pending Close"
};
const DISPUTES_TABS_FILTER_MAP = {
  [DISPUTES_TABS.ALL_DISPUTES]: [],
  [DISPUTES_TABS.FRONTEND_INTAKE]: [OPEN, OPEN_WITH_ACTION_REQUIRED, READY],
  [DISPUTES_TABS.BACKEND_RESOLUTION]: [CHARGEBACK_INITIATED],
  [DISPUTES_TABS.CLOSED]: [CLOSED$1],
  [DISPUTES_TABS.PENDING_CLOSE]: [PENDING_CLOSE]
};
const DISPUTES_FILTERS_SUB_STATES = {
  [DISPUTES_TABS.ALL_DISPUTES]: [],
  [DISPUTES_TABS.FRONTEND_INTAKE]: [OPEN, OPEN_WITH_ACTION_REQUIRED, READY],
  [DISPUTES_TABS.BACKEND_RESOLUTION]: [DISPUTE_STATE_MAP.INITIATED, DISPUTE_STATE_MAP.REPRESENTMENT, DISPUTE_STATE_MAP.PRE_ARBITRATION, DISPUTE_STATE_MAP.PREARB_RESPONDED, DISPUTE_STATE_MAP.ARBITRATION, DISPUTE_STATE_MAP.NETWORK_REJECTED],
  [DISPUTES_TABS.CLOSED]: [DISPUTE_STATE_MAP.CASE_WON, DISPUTE_STATE_MAP.CASE_LOST, DISPUTE_STATE_MAP.NETWORK_REJECTED, DISPUTE_STATE_MAP.CLOSED],
  [DISPUTES_TABS.PENDING_CLOSE]: []
};
const STATE_OPTIONS = {
  Open: OPEN,
  "Open action required": OPEN_WITH_ACTION_REQUIRED,
  Ready: READY,
  Initiated: CHARGEBACK_INITIATED,
  Closed: CLOSED$1,
  "Pending close": PENDING_CLOSE
};
const CASE_TRANSITION_ACTION_OPTIONS = {
  OPEN_WITH_ACTION_REQUIRED: ["41"],
  REVIEW: ["05"],
  RE_OPEN: ["23", "24"],
  ASSIGN: ["22"],
  NON_CHARGEBACK_CREDIT: ["14", "27"],
  CHARGEBACK_CREDIT: ["28"],
  CHARGEBACK_NO_CREDIT: ["29"],
  WITHDRAW_AND_CLOSE: ["40"],
  CLOSE: ["14", "42", "45"],
  CHANGE_CASE_TYPE: ["50"],
  CHARGEBACK_SUBMIT: ["51"],
  WRITE_OFF: ["45"]
};
const SUBMISSION_ACTION_OPTIONS = ["CHARGEBACK_CREDIT", "CHARGEBACK_NO_CREDIT", "CHARGEBACK_SUBMIT"];
const reroutableStates = ["READY", "OPEN", "OPEN_WITH_ACTION_REQUIRED"];
const READABLE_STATE_MAP = {
  CLOSED: "closed",
  PENDING_CLOSE: "pending close",
  CHARGEBACK_INITIATED: "initiated",
  READY: "ready",
  OPEN: "open",
  OPEN_WITH_ACTION_REQUIRED: "open action required"
};
const getStateMessage = (newState) => `Dispute moved to ${READABLE_STATE_MAP[newState]} state`;
const CONVERTED_STATE_TEXT = "Converted successfully";
const transitionReasonCodeFailures = {
  34: "Chargeback initiation failed",
  35: "Chargeback initiation network failed",
  36: "KYC Override Fail",
  37: "User Reinstatement Fail",
  38: "Business Reinstatement Fail",
  48: "Review Fails"
};
const REASON_OPTIONS = {
  "Account number not on file": "ACCOUNT_NUMBER_NOT_ON_FILE",
  "Authorization related for dual message system": "AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM",
  "Cancelled merchandise or services": "CANCELLED_MERCHANDISE_OR_SERVICES",
  "Cancelled recurring transaction": "CANCELLED_RECURRING_TRANSACTION",
  "Cardholder dispute US only": "CARDHOLDER_DISPUTE_US_ONLY",
  "Cardholder dispute": "CARDHOLDER_DISPUTE",
  "Chip liability shift": "CHIP_LIABILITY_SHIFT",
  "Chip PIN liability shift lost stolen": "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN",
  "Chip read POS late presentment": "CHIP_READ_POS_LATE_PRESENTMENT",
  "Credit not processed": "CREDIT_NOT_PROCESSED",
  "Domestic chargeback intra European use": "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE",
  "EMV liability shift counterfeit fraud": "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD",
  "EMV liability shift non counterfeit fraud": "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD",
  "Fraud multiple transactions": "FRAUD_MULTIPLE_TRANSACTIONS",
  "Fraud transaction": "FRAUD_TRANSACTION",
  "Incorrect account number": "INCORRECT_ACCOUNT_NUMBER",
  "Incorrect currency or transaction code": "INCORRECT_CURRENCY_OR_TRANSACTION_CODE",
  "Incorrect currency": "INCORRECT_CURRENCY",
  "Incorrect transaction amount or account number": "INCORRECT_TRANSACTION_AMOUNT_OR_ACCOUNT_NUMBER",
  "Incorrect transaction amount": "INCORRECT_TRANSACTION_AMOUNT",
  "Incorrect transaction code": "INCORRECT_TRANSACTION_CODE",
  "Installment billing dispute": "INSTALLMENT_BILLING_DISPUTE",
  "Late presentment": "LATE_PRESENTMENT",
  "No authorization": "NO_AUTHORIZATION",
  "No show addendum or ATM dispute": "NO_SHOW_ADDENDUM_OR_ATM_DISPUTE",
  "Non receipt of cash": "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
  "Not as described or defective merchandise": "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
  "Not authorized card absent": "NOT_AUTHORIZED_CARD_ABSENT",
  "Not authorized card present": "NOT_AUTHORIZED_CARD_PRESENT",
  "Other disputes": OTHER_DISPUTES,
  "Other maestro disputes": "OTHER_MAESTRO_DISPUTES",
  "Other pulse disputes": "OTHER_PULSE_DISPUTES",
  "Point of interaction errors": "POINT_OF_INTERACTION_ERRORS",
  "Questionable merchant activity": "QUESTIONABLE_MERCHANT_ACTIVITY",
  "Service not provided merchandise not received": "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
  "Transaction not recognized": "TRANSACTION_NOT_RECOGNIZED",
  "Warning bulletin file": "WARNING_BULLETIN_FILE",
  "Duplicate Processing/Paid by Other Means": "DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS",
  "Invalid data": "INVALID_DATA",
  "Card recovery bulletin": "CARD_RECOVERY_BULLETIN",
  "Declined auth": "DECLINED_AUTH",
  "Counterfeit merch": "COUNTERFEIT_MERCH",
  Misrepresentation: "MISREPRESENTATION",
  "Original credit not accepted": "ORIGINAL_CREDIT_NOT_ACCEPTED"
};
const ACTOR_OPTIONS = {
  All: "",
  "Dispute completed": "DISPUTE_COMPLETED",
  Acquirer: "ACQUIRER",
  Issuer: "ISSUER",
  Unknown: "UNKNOWN"
};
const DISPUTE_STATE_OPTIONS = {
  "Case lost": DISPUTE_STATE_MAP.CASE_LOST,
  "Case won": DISPUTE_STATE_MAP.CASE_WON,
  "Dispute response": DISPUTE_STATE_MAP.REPRESENTMENT,
  "Network rejected": DISPUTE_STATE_MAP.NETWORK_REJECTED,
  "Pre-arbitration": DISPUTE_STATE_MAP.PRE_ARBITRATION,
  "Pre-arbitration responded": DISPUTE_STATE_MAP.PREARB_RESPONDED,
  Arbitration: DISPUTE_STATE_MAP.ARBITRATION,
  Closed: DISPUTE_STATE_MAP.CLOSED,
  Initiated: DISPUTE_STATE_MAP.INITIATED,
  Open: OPEN,
  "Open action required": OPEN_WITH_ACTION_REQUIRED,
  Ready: READY,
  "Pending close": PENDING_CLOSE
};
const TYPE_OPTIONS = {
  All: "",
  Integrated: "DISPUTE",
  "Non integrated": "LEGACY_DISPUTE"
};
function DisputeTokenHeader({
  children,
  actionIsRequired,
  state
}) {
  const {
    Closed
  } = STATE_OPTIONS;
  const showPill = isPresent(actionIsRequired) && state !== Closed;
  const WAIT = "Awaiting response";
  const ACT = "Action required";
  const PILL_OPTIONS = {
    [WAIT]: "draft",
    [ACT]: "error"
  };
  const requiredState = useMemo(() => {
    if (showPill) {
      return actionIsRequired ? ACT : WAIT;
    }
    return null;
  }, [actionIsRequired, showPill]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dds.displayCenteredInlineFlex, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", children }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { overrideValue: children }),
    showPill && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Pill, { type: PILL_OPTIONS[requiredState], children: requiredState })
    ] })
  ] });
}
DisputeTokenHeader.propTypes = {
  children: PropTypes.string.isRequired,
  actionIsRequired: PropTypes.any,
  state: PropTypes.string
};
DisputeTokenHeader.defaultProps = {
  children: "",
  actionIsRequired: null,
  state: ""
};
const DisputeTokenHeader$1 = observer(DisputeTokenHeader);
const actionWarningContainer = "_actionWarningContainer_1mf4p_1";
const actionWarningText = "_actionWarningText_1mf4p_5";
const s$4 = {
  actionWarningContainer,
  actionWarningText
};
function DisputeTransitionWarning({
  previousActionWarning
}) {
  if (isNotPresent(previousActionWarning)) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$4.actionWarningContainer, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: s$4.actionWarningText, children: previousActionWarning }) })
  ] });
}
DisputeTransitionWarning.propTypes = {
  previousActionWarning: PropTypes.string
};
DisputeTransitionWarning.defaultProps = {
  previousActionWarning: ""
};
const DisputeTransitionWarning$1 = observer(DisputeTransitionWarning);
const NETWORK_STATUS_ATTRIBUTES = {
  case_status: {
    text: "Network case status",
    tooltip: "Current state/event of the case."
  },
  network_case_number: {
    text: "Network case ID"
  },
  provisional_credit_status: {
    text: "Provisional credit status"
  },
  permanent_credit_status: {
    text: "Permanent credit status"
  }
};
const PARTIAL_NETWORK_ATTRIBUTES_MAP = {
  formattedNextActor: {
    text: "Next actor",
    tooltip: "Party responsible for taking the next action."
  },
  formattedDaysToAct: {
    text: "Days to act",
    tooltip: "Remaining days for a customer to act before losing the capability to act or certain rights related to the transaction."
  }
};
const NETWORK_SUBMISSION_MODAL_TEXT = `You are about to submit the case, please make sure all information is correct.`;
const NETWORK_SUBMISSION_SUBMIT_TEST = "Submit to network";
const NETWORK_SUBMISSION_MEMO_ERROR = "Transition note is required.";
const NETWORK_SUBMISSION_RADIO_ERROR = "Please make a selection above to Initiate Chargeback with Provisional Credit or Initiate Chargeback.";
function NetworkSubmissionModal({
  submitToNetwork,
  hide,
  isLegacyDisputeType,
  isRegE,
  issuePCreditAndSubmit,
  setIssuePCreditAndSubmit,
  error
}) {
  const initialState = isRegE ? "CHARGEBACK_SUBMIT" : "";
  const [submitted, setSubmitted] = useState(false);
  const [submissionAction, setSubmissionAction] = useState(initialState);
  const [memo, setMemo] = useState("");
  const hasError = !!error;
  const shouldShowError = useMemo(() => isLegacyDisputeType && submitted && isNotPresent(memo), [submitted, memo, isLegacyDisputeType]);
  const MEMO_LABEL = isLegacyDisputeType ? "Transition note" : "Transition note (Optional)";
  const handleClick = () => {
    setSubmitted(true);
    if (!isLegacyDisputeType || isPresent(memo)) {
      submitToNetwork(submissionAction, memo);
    }
  };
  const handleHide = () => {
    issuePCreditAndSubmit && setIssuePCreditAndSubmit(false);
    hide();
  };
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { testId: "confirm-modal-submit-to-network", onClick: handleClick, disabled: hasError, children: NETWORK_SUBMISSION_SUBMIT_TEST }, `${NETWORK_SUBMISSION_SUBMIT_TEST}-test-id`)];
  const issuePCModalBody = /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", children: NETWORK_SUBMISSION_MODAL_TEXT });
  const chargebackTypeSelectModalBody = /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "Select the correct chargeback type below" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { groupItems: [{
      label: "Initiate Chargeback with Provisional Credit",
      value: "CHARGEBACK_CREDIT"
    }, {
      label: "Initiate Chargeback",
      value: "CHARGEBACK_NO_CREDIT"
    }], value: submissionAction, onChange: setSubmissionAction, error: submitted && !submissionAction ? NETWORK_SUBMISSION_RADIO_ERROR : "" })
  ] });
  const modalBody = isRegE ? issuePCModalBody : chargebackTypeSelectModalBody;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { heading: NETWORK_SUBMISSION_SUBMIT_TEST, hideModal: handleHide, footerButtons, width: "400px", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("input", { type: "text", readOnly: true, style: {
      display: "none"
    } }),
    hasError && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: error }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    modalBody,
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: MEMO_LABEL, value: memo, onChange: (e) => setMemo(e.target.value), rows: 2, error: shouldShowError ? NETWORK_SUBMISSION_MEMO_ERROR : null })
  ] });
}
NetworkSubmissionModal.propTypes = {
  submitToNetwork: PropTypes.func,
  hide: PropTypes.func,
  isLegacyDisputeType: PropTypes.bool,
  isRegE: PropTypes.bool,
  issuePCreditAndSubmit: PropTypes.bool,
  setIssuePCreditAndSubmit: PropTypes.func,
  error: PropTypes.string
};
NetworkSubmissionModal.defaultProps = {
  submitToNetwork: null,
  hide: null,
  isLegacyDisputeType: null,
  isRegE: false,
  issuePCreditAndSubmit: false,
  setIssuePCreditAndSubmit: () => {
  },
  error: ""
};
const NetworkSubmissionModal$1 = observer(NetworkSubmissionModal);
class DocumentModalHandler {
  constructor(dispute) {
    this.dispute = dispute;
    const {
      isVisa,
      isMastercard
    } = dispute || {};
    this.isVisa = isVisa;
    this.isMastercard = isMastercard;
  }
  get shouldShowModalForVisa() {
    const reasonsToShowModal = ["SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED", "INVALID_DATA", "CANCELLED_RECURRING_TRANSACTION", "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE", "LATE_PRESENTMENT", "CREDIT_NOT_PROCESSED", "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM", "INCORRECT_CURRENCY", "INCORRECT_TRANSACTION_CODE", "INCORRECT_TRANSACTION_AMOUNT", "INCORRECT_ACCOUNT_NUMBER", "CANCELLED_MERCHANDISE_OR_SERVICES", "COUNTERFEIT_MERCH", "MISREPRESENTATION", "ORIGINAL_CREDIT_NOT_ACCEPTED"];
    return this.dispute.documents.count === 0 && this.isVisa && reasonsToShowModal.includes(this.dispute.dispute_details.dispute_reason);
  }
  get shouldShowModal() {
    if (this.isMastercard || this.shouldShowModalForVisa) {
      return true;
    }
    return false;
  }
}
const {
  templates: templates$8
} = gqlUtils;
class NetworkCaseStatusDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.allowable_actions = "";
    this.network = "";
    this.case_status = "";
    this.current_case_amount = "";
    this.next_actor = "";
    this.days_to_act = "";
    this.last_action_date = "";
    this.case_opened_date = "";
    this.last_refresh_date = "";
    this.created_time = "";
    this.last_modified_time = "";
    this.loading = false;
    this.skipAutoLoad = true;
    this.load(args);
  }
  // actions
  async refreshNetworkData() {
    const {
      setAlert: setAlert2
    } = alertStore || {};
    if (!this.case_token)
      return;
    try {
      this.loading = true;
      const result = await this.gqlQuery(templates$8.refreshNetworkCaseStatus, {
        case_token: this.case_token
      }, void 0, void 0, "all");
      runInAction(() => {
        const data = this.extract(result, "networkCaseStatusDetails");
        if (!data || Boolean(result.errors)) {
          throw result.errors;
        }
        if (data) {
          this.load(data);
        }
      });
    } catch (err) {
      const options = this.handleResultsError(err);
      console.error(`ERROR (refreshNetworkData): ${err}`);
      setAlert2("Unable to refresh the network data", options);
    } finally {
      this.loading = false;
    }
  }
  handleResultsError(error) {
    const alertOptions = {};
    if (Array.isArray(error)) {
      const errorMessage = error[0]?.message;
      alertOptions.apiMessage = errorMessage;
    }
    return alertOptions;
  }
  // computed
  get formattedDaysToAct() {
    if (isPresent(this.days_to_act)) {
      const formatted = `${this.days_to_act} day`;
      if (this.days_to_act !== 1) {
        return formatted + "s";
      }
      return formatted;
    }
    return null;
  }
  get formattedNextActor() {
    return sentenceCase(this.next_actor);
  }
  get presentationalAttributesCount() {
    try {
      const networkAttrsMap = {
        ...NETWORK_STATUS_ATTRIBUTES,
        ...PARTIAL_NETWORK_ATTRIBUTES_MAP
      };
      const presentValues = Object.keys(networkAttrsMap).filter((attr) => isPresent(this[attr]));
      return presentValues.length;
    } catch (e) {
      return 0;
    }
  }
  get nextIsIssuer() {
    return this.next_actor === "ISSUER";
  }
  get networkDetailsForRender() {
    return Object.keys(PARTIAL_NETWORK_ATTRIBUTES_MAP).reduce((obj, key) => {
      obj[key] = {
        ...PARTIAL_NETWORK_ATTRIBUTES_MAP[key],
        value: this[key]
      };
      return obj;
    }, {});
  }
}
decorate(NetworkCaseStatusDetailsStore, {
  // values
  // customer info
  allowable_actions: observable,
  network: observable,
  case_status: observable,
  current_case_amount: observable,
  next_actor: observable,
  days_to_act: observable,
  last_action_date: observable,
  case_opened_date: observable,
  last_refresh_date: observable,
  created_time: observable,
  last_modified_time: observable,
  skipAutoLoad: observable,
  // actions
  refreshNetworkData: action.bound,
  handleResultsError: action.bound,
  // computed
  formattedDaysToAct: computed,
  formattedNextActor: computed,
  presentationalAttributesCount: computed,
  networkDetailsForRender: computed,
  nextIsIssuer: computed
});
class AdditionalDisputeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.regulation_subcategory = "";
    this.exception_reason_apply = "";
    this.explanation_of_credit = "";
    this.skipAutoLoad = true;
    this.regulation_conditions_met_date = "";
    this.refund_conditions = "";
    this.reject_reason = "";
    this.load(args);
  }
  get formattedDisputeCategory() {
    const defaultSubCategoryLabel = sentenceCase(this.regulation_subcategory);
    return DISPUTE_CATEGORIES_LABELS[this.regulation_subcategory] || defaultSubCategoryLabel;
  }
  get formattedExceptionReasonApply() {
    if (this.exception_reason_apply)
      return "Yes";
    if (this.exception_reason_apply === false)
      return "No";
    return null;
  }
  get formattedRefundConditions() {
    if (isPresent(this.regulation_conditions_met_date)) {
      return "Yes";
    }
    return null;
  }
  get formattedRegulationConditionsMetDate() {
    if (isPresent(this.regulation_conditions_met_date)) {
      return convertDateFromUTCToLocal(this.regulation_conditions_met_date);
    }
    return "";
  }
  get additionalDetailsPayload() {
    const {
      regulation_subcategory,
      exception_reason_apply,
      regulation_conditions_met_date
    } = this;
    const result = {};
    if (isPresent(regulation_subcategory)) {
      result.regulation_subcategory = regulation_subcategory;
    }
    if (isPresent(exception_reason_apply)) {
      result.exception_reason_apply = exception_reason_apply;
    }
    if (isPresent(regulation_conditions_met_date)) {
      result.regulation_conditions_met_date = convertDateToUTC(regulation_conditions_met_date);
    }
    return result;
  }
  get computedRefundConditions() {
    if (isPresent(this.refund_conditions)) {
      return this.refund_conditions;
    } else if (isPresent(this.regulation_conditions_met_date)) {
      return Boolean(this.regulation_conditions_met_date);
    }
    return null;
  }
}
decorate(AdditionalDisputeDetailsStore, {
  // values
  regulation_subcategory: observable,
  exception_reason_apply: observable,
  explanation_of_credit: observable,
  skipAutoLoad: observable,
  regulation_conditions_met_date: observable,
  refund_conditions: observable,
  reject_reason: observable,
  //computed
  additionalDetailsPayload: computed,
  formattedDisputeCategory: computed,
  formattedExceptionReasonApply: computed,
  formattedRefundConditions: computed,
  computedRefundConditions: computed,
  formattedRegulationConditionsMetDate: computed
});
class DomSettingsStore {
  constructor() {
    this.fields = {};
  }
  setNode(field, settings) {
    this.fields[field] = settings;
  }
  getNode(field) {
    return this.fields[field];
  }
  unsetNode(field) {
    delete this.fields[field];
  }
}
decorate(DomSettingsStore, {
  setNode: action.bound,
  getNode: action.bound
});
class ServiceNotProvidedMerchandiseNotReceivedDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.what_is_the_amount_on_the_cardholders_receipt = "";
    this.does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token = "";
    this.what_is_the_currency_on_the_cardholders_receipt = "";
    this.detailed_description_of_what_was_purchased_and_explanation_of_the_dispute = "";
    this.is_merchant_in_bankruptcy_liquidation = "";
    this.merchandise_delivered_late = "";
    this.non_fiat_currency_not_delivered = "";
    this.did_the_cardholder_return_the_merchandise = "";
    this.expected_receipt_date = "";
    this.nonAPI_receipt_time_12_format = "";
    this.did_cardholder_cancel_prior_to_the_expected_date = "";
    this.cancellation_date = "";
    this.cancellation_reason = "";
    this.did_cardholder_attempt_to_resolve_dispute_with_merchant = "";
    this.is_attempt_to_resolve_prohibited_by_local_law_or_regulations = "";
    this.merchandise_or_services = "";
    this.was_merchandise_delivered_to_wrong_location = "";
    this.address_of_agreed_location = "";
    this.did_cardholder_return_merchandise = "";
    this.date_cardholder_returned_merchandise = "";
    this.date_merchant_received_returned_merchandise = "";
    this.did_cardholder_attempt_to_return_merchandise = "";
    this.date_of_attempted_return = "";
    this.explain_how_merchandise_was_returned = "";
    this.third_party_gift_card_indicator = "";
    this.visa_commercial_card_virtual_account_indicator = "";
    this.did_virtual_account_holder_suffer_financial_loss = "";
    this.did_merchant_cancel_services = "";
    this.date_merchant_cancelled_services = "";
    this.did_merchant_cancel_merchandise = "";
    this.date_merchant_cancelled_merchandise = "";
    this.explanation_dispute_prior_expected_delivery_date = "";
    this.nonAPI_not_provided_cardholder_returned_and_attempted_return_status = "";
    this.agreed_delivery_date_or_service_date = "";
    this.date_of_return = "";
    this.cash_over_indicator = "";
    this.customLoad(args);
  }
  get expected_receipt_time() {
    if (!this.nonAPI_receipt_time_12_format)
      return "";
    return formatHour(this.nonAPI_receipt_time_12_format, true);
  }
  setupDidNotAttemptOption(data) {
    const {
      date_cardholder_returned_merchandise,
      date_of_attempted_return
    } = data;
    if (
      // check that the store is persisted
      isPresent(this.constructedBy) && // and the other two options were not selected
      isNotPresent(date_cardholder_returned_merchandise) && isNotPresent(date_of_attempted_return)
    ) {
      this.nonAPI_not_provided_cardholder_returned_and_attempted_return_status = CARDHOLDER_DID_NOT_ATTEMPT_LABEL;
    }
  }
  customLoad(data) {
    const {
      expected_receipt_time = ""
    } = data;
    delete data.expected_receipt_time;
    this.load(data);
    this.nonAPI_receipt_time_12_format = formatHour(expected_receipt_time);
    this.setupDidNotAttemptOption(data);
  }
}
decorate(ServiceNotProvidedMerchandiseNotReceivedDetailsStore, {
  // values
  what_is_the_amount_on_the_cardholders_receipt: observable,
  does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: observable,
  what_is_the_currency_on_the_cardholders_receipt: observable,
  detailed_description_of_what_was_purchased_and_explanation_of_the_dispute: observable,
  is_merchant_in_bankruptcy_liquidation: observable,
  merchandise_delivered_late: observable,
  non_fiat_currency_not_delivered: observable,
  did_the_cardholder_return_the_merchandise: observable,
  late_delivery_wrong_location: observable,
  expected_receipt_date: observable,
  nonAPI_receipt_time_12_format: observable,
  did_cardholder_cancel_prior_to_the_expected_date: observable,
  cancellation_date: observable,
  cancellation_reason: observable,
  did_cardholder_attempt_to_resolve_dispute_with_merchant: observable,
  is_attempt_to_resolve_prohibited_by_local_law_or_regulations: observable,
  merchandise_or_services: observable,
  was_merchandise_delivered_to_wrong_location: observable,
  address_of_agreed_location: observable,
  did_cardholder_return_merchandise: observable,
  date_cardholder_returned_merchandise: observable,
  date_merchant_received_returned_merchandise: observable,
  did_cardholder_attempt_to_return_merchandise: observable,
  date_of_attempted_return: observable,
  explain_how_merchandise_was_returned: observable,
  third_party_gift_card_indicator: observable,
  visa_commercial_card_virtual_account_indicator: observable,
  did_virtual_account_holder_suffer_financial_loss: observable,
  did_merchant_cancel_services: observable,
  date_merchant_cancelled_services: observable,
  did_merchant_cancel_merchandise: observable,
  date_merchant_cancelled_merchandise: observable,
  explanation_dispute_prior_expected_delivery_date: observable,
  nonAPI_not_provided_cardholder_returned_and_attempted_return_status: observable,
  agreed_delivery_date_or_service_date: observable,
  date_of_return: observable,
  cash_over_indicator: observable,
  expected_receipt_time: computed,
  customLoad: action.bound,
  setupDidNotAttemptOption: action.bound
});
let NotAsDescribedOrDefectiveMerchandise$1 = class NotAsDescribedOrDefectiveMerchandise extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.cancellation_date = null;
    this.cancellation_reason = null;
    this.cardholder_merchant_previous_negotiation_evidence = null;
    this.date_cardholder_returned_the_merchandise = null;
    this.date_merchandise_or_service_was_received = null;
    this.date_merchandise_was_received = null;
    this.date_merchant_received_the_returned_merchandise = null;
    this.date_of_attempted_return = null;
    this.date_the_cardholder_first_notified_the_issuer_of_the_dispute = null;
    this.did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant = null;
    this.did_the_cardholder_attempt_to_return_the_merchandise = null;
    this.did_the_cardholder_cancel_the_services = null;
    this.did_the_cardholder_return_the_merchandise = null;
    this.explain_how_the_merchandise_was_returned = null;
    this.explain_prev_negotiation = null;
    this.is_attempt_to_resolve_prohibited_by_local_law_or_regulations = null;
    this.merchandise_or_services = null;
    this.merchant_refuse_advise = null;
    this.not_as_described_or_defective = null;
    this.provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise = null;
    this.what_is_the_disposition_of_the_merchandise = null;
    this.provide_details_of_what_was_ordered_and_not_as_described = null;
    this.return_method = null;
    this.tracking_number = null;
    this.what_was_ordered_and_how_it_was_damaged_or_defective = null;
    this.when_negotiations_begin = null;
    this.motive_code = null;
    this.merchandise_counterfeit_confirmation_date = null;
    this.promised_delivery_date = null;
    this.cash_over_indicator = null;
    this.load(args);
  }
};
decorate(NotAsDescribedOrDefectiveMerchandise$1, {
  domSettingsStore: observable,
  // values
  cancellation_date: observable,
  cancellation_reason: observable,
  cardholder_merchant_previous_negotiation_evidence: observable,
  date_cardholder_returned_the_merchandise: observable,
  date_merchandise_or_service_was_received: observable,
  date_merchandise_was_received: observable,
  date_merchant_received_the_returned_merchandise: observable,
  date_of_attempted_return: observable,
  date_the_cardholder_first_notified_the_issuer_of_the_dispute: observable,
  did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: observable,
  did_the_cardholder_attempt_to_return_the_merchandise: observable,
  did_the_cardholder_cancel_the_services: observable,
  did_the_cardholder_return_the_merchandise: observable,
  explain_how_the_merchandise_was_returned: observable,
  explain_prev_negotiation: observable,
  is_attempt_to_resolve_prohibited_by_local_law_or_regulations: observable,
  merchandise_or_services: observable,
  merchant_refuse_advise: observable,
  not_as_described_or_defective: observable,
  //visa 24_2 mandate
  what_is_the_disposition_of_the_merchandise: observable,
  provide_a_detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: observable,
  provide_details_of_what_was_ordered_and_not_as_described: observable,
  return_method: observable,
  tracking_number: observable,
  what_was_ordered_and_how_it_was_damaged_or_defective: observable,
  when_negotiations_begin: observable,
  motive_code: observable,
  merchandise_counterfeit_confirmation_date: observable,
  promised_delivery_date: observable,
  cash_over_indicator: observable
});
class CancelledMerchandizeOrServicesDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.merchandise_or_services = "";
    this.describe_what_was_purchased = "";
    this.date_cardholder_received_or_expected_to_receive_merchandise = "";
    this.did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant = null;
    this.is_attempt_to_resolve_prohibited_by_local_law_or_regulations = null;
    this.did_the_cardholder_return_the_merchandise = null;
    this.date_of_return = "";
    this.date_merchant_received_returned_merchandise = "";
    this.return_method = "";
    this.tracking_number = "";
    this.explain_how_the_merchandise_was_returned = "";
    this.did_the_cardholder_attempt_to_return_the_merchandise = null;
    this.date_of_attempted_return = "";
    this.merchant_refuse_advise = "";
    this.detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise = "";
    this.what_is_the_disposition_of_the_merchandise = "";
    this.did_cardholder_cancel = null;
    this.cancellation_date = "";
    this.cancellation_reason = "";
    this.was_cancellation_policy_provided = null;
    this.type_of_service = "";
    this.date_of_service_or_expected_service = "";
    this.cancelled_guaranteed_reservation_certification_selection = "";
    this.nonAPI_did_cardholder_receive_merchandise = null;
    this.customLoad(args);
  }
  customLoad(data) {
    this.load(data);
    this.setCardholderReceivedMerchandise();
  }
  setCardholderReceivedMerchandise() {
    if (isPresent(this.date_cardholder_received_or_expected_to_receive_merchandise) && isPresent(this.did_the_cardholder_return_the_merchandise)) {
      this.nonAPI_did_cardholder_receive_merchandise = true;
    } else {
      this.nonAPI_did_cardholder_receive_merchandise = false;
    }
  }
}
decorate(CancelledMerchandizeOrServicesDetailsStore, {
  cancellation_date: observable,
  cancellation_reason: observable,
  cancelled_guaranteed_reservation_certification_selection: observable,
  date_cardholder_received_or_expected_to_receive_merchandise: observable,
  date_merchant_received_returned_merchandise: observable,
  date_of_attempted_return: observable,
  merchant_refuse_advise: observable,
  date_of_return: observable,
  date_of_service_or_expected_service: observable,
  describe_what_was_purchased: observable,
  //visa 24_2 mandate
  what_is_the_disposition_of_the_merchandise: observable,
  detailed_description_of_how_the_cardholder_attempted_to_return_and_the_disposition_of_the_merchandise: observable,
  did_cardholder_cancel: observable,
  did_the_cardholder_attempt_to_resolve_the_dispute_with_the_merchant: observable,
  did_the_cardholder_attempt_to_return_the_merchandise: observable,
  did_the_cardholder_return_the_merchandise: observable,
  explain_how_the_merchandise_was_returned: observable,
  merchandise_or_services: observable,
  nonAPI_did_cardholder_receive_merchandise: observable,
  is_attempt_to_resolve_prohibited_by_local_law_or_regulations: observable,
  return_method: observable,
  tracking_number: observable,
  type_of_service: observable,
  was_cancellation_policy_provided: observable,
  customLoad: action.bound,
  setCardholderReceivedMerchandise: action.bound
});
class CreditNotProcessedDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.credit_voucher_transaction_receipt_or_refund_acknowledgement_date = "";
    this.date_cardholder_returned_cancelled_merchandise = "";
    this.is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated = "";
    this.was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given = "";
    this.date_of_cancellation = "";
    this.date_of_return = "";
    this.cash_over_indicator = "";
    this.load(args);
  }
}
decorate(CreditNotProcessedDetailsStore, {
  // values
  credit_voucher_transaction_receipt_or_refund_acknowledgement_date: observable,
  date_cardholder_returned_cancelled_merchandise: observable,
  is_the_credit_voucher_transaction_receipt_or_refund_acknowledgement_dated: observable,
  was_a_credit_voucher_voided_transaction_receipt_or_refund_acknowledgement_given: observable,
  date_of_cancellation: observable,
  date_of_return: observable,
  cash_over_indicator: observable
});
class CancelledRecurringTransactionDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.cancellation_date = "";
    this.cancellation_reason = "";
    this.date_issuer_informed_merchant_of_account_closure = "";
    this.contact_method_with_merchant_ind = false;
    this.contact_method_merchant_email_ind = false;
    this.contact_merchant_details_email_address = "";
    this.contact_method_merchant_call_center_ind = false;
    this.contact_method_merchant_mail_ind = false;
    this.contact_method_merchant_SMS_ind = false;
    this.contact_merchant_details_phone_number = "";
    this.contact_method_merchant_in_person_ind = false;
    this.contact_merchant_details_physical_address = "";
    this.contact_method_merchant_webform_ind = false;
    this.contact_merchant_details_application_name = "";
    this.other_form_of_payment_ind = false;
    this.contact_merchant_details = "";
    this.other_form_of_payment_desc = "";
    this.cancelled_recurring_payment_date = "";
    this.recurring_payment_plan_expiry_date = "";
    this.is_dispute_impacted_by_local_law_or_regulation = null;
    this.load(args);
  }
}
decorate(CancelledRecurringTransactionDetailsStore, {
  // values
  cancellation_date: observable,
  cancellation_reason: observable,
  date_issuer_informed_merchant_of_account_closure: observable,
  contact_merchant_details: observable,
  other_form_of_payment_ind: observable,
  other_form_of_payment_desc: observable,
  contact_method_with_merchant_ind: observable,
  contact_method_merchant_email_ind: observable,
  contact_merchant_details_email_address: observable,
  contact_method_merchant_call_center_ind: observable,
  contact_method_merchant_mail_ind: observable,
  contact_method_merchant_SMS_ind: observable,
  contact_merchant_details_phone_number: observable,
  contact_method_merchant_in_person_ind: observable,
  contact_merchant_details_physical_address: observable,
  contact_method_merchant_webform_ind: observable,
  contact_merchant_details_application_name: observable,
  cancelled_recurring_payment_date: observable,
  recurring_payment_plan_expiry_date: observable,
  is_dispute_impacted_by_local_law_or_regulation: observable
});
class NotAsDescribedOrDefectiveMerchandise2 extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.how_is_transaction_code_incorrect = null;
    this.explain_why_the_credit_refund_was_processed_in_error = null;
    this.credit_confirmation_number = null;
    this.date_of_return = null;
    this.return_method = null;
    this.load(args);
  }
}
decorate(NotAsDescribedOrDefectiveMerchandise2, {
  domSettingsStore: observable,
  // values
  how_is_transaction_code_incorrect: observable,
  explain_why_the_credit_refund_was_processed_in_error: observable,
  credit_confirmation_number: observable,
  date_of_return: observable,
  return_method: observable
});
class IncorrectCurrencyDetails extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.incorrect_currency_reason = null;
    this.what_was_the_correct_currency = null;
    this.certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice = null;
    this.cash_over_indicator = null;
    this.load(args);
  }
}
decorate(IncorrectCurrencyDetails, {
  domSettingsStore: observable,
  // values
  incorrect_currency_reason: observable,
  what_was_the_correct_currency: observable,
  certification_that_the_cardholder_did_not_agree_to_dynamic_currency_conversion_and_did_not_make_an_active_choice: observable,
  cash_over_indicator: observable
});
class LatePresentmentDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.account_status = "";
    this.cash_over_indicator = "";
    this.load(args);
  }
}
decorate(LatePresentmentDetailsStore, {
  domSettingsStore: observable,
  // values
  account_status: observable,
  cash_over_indicator: observable
});
class IncorrectAccountNumberStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.is_the_account_number_on_the_issuers_master_file = null;
    this.does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token = null;
    this.load(args);
  }
}
decorate(IncorrectAccountNumberStore, {
  domSettingsStore: observable,
  // values
  is_the_account_number_on_the_issuers_master_file: observable,
  does_the_account_number_on_the_receipt_match_the_cardholders_account_number_or_token: observable
});
class IncorrectTransactionAmountStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.nonAPI_what_is_the_amount_on_the_cardholders_receipt = "";
    this.what_is_the_currency_on_the_cardholders_receipt = "";
    this.is_the_dispute_due_to_the_difference_between_quoted_price_and_actual_charges_made_by_the_merchant = "";
    this.cash_over_indicator = "";
    this.customLoad(args);
  }
  get what_is_the_amount_on_the_cardholders_receipt() {
    if (!this.nonAPI_what_is_the_amount_on_the_cardholders_receipt) {
      return 0;
    }
    return Number(this.nonAPI_what_is_the_amount_on_the_cardholders_receipt);
  }
  customLoad(data) {
    const {
      what_is_the_amount_on_the_cardholders_receipt = 0,
      ...rest
    } = data;
    this.load({
      ...rest
    });
    this.nonAPI_what_is_the_amount_on_the_cardholders_receipt = what_is_the_amount_on_the_cardholders_receipt;
  }
}
decorate(IncorrectTransactionAmountStore, {
  domSettingsStore: observable,
  // values
  [FIELDS_KEY_MAP.NONAPI_WHAT_IS_THE_AMOUNT_ON_THE_CARDHOLDERS_RECEIPT]: observable,
  [FIELDS_KEY_MAP.WHAT_IS_THE_CURRENCY_ON_THE_CARDHOLDERS_RECEIPT]: observable,
  [FIELDS_KEY_MAP.IS_DIFFERENCE_BETWEEN_PRICES]: observable,
  // computed
  what_is_the_amount_on_the_cardholders_receipt: computed,
  cash_over_indicator: observable
});
class DuplicateProcessingDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.error_type = "";
    this.both_transactions_in_same_account = null;
    this.other_transaction_reference_token = "";
    this.other_visa_transaction_reference_id = "";
    this.other_visa_transaction_mcsn = "";
    this.transaction_in_different_visa_account = null;
    this.is_other_transaction_with_same_merchant = null;
    this.provided_proof_of_other_means_type = "";
    this.is_evidence_of_merchant_passed_funds_provided = null;
    this.cardholder_attempted_to_resolve = null;
    this.is_attempt_to_resolve_prohibited_by_local_law = null;
    this.other_visa_transaction_arn = "";
    this.other_visa_transaction_information = "";
    this.load(args);
  }
}
decorate(DuplicateProcessingDetailsStore, {
  // values
  error_type: observable,
  both_transactions_in_same_account: observable,
  other_transaction_reference_token: observable,
  other_visa_transaction_reference_id: observable,
  other_visa_transaction_mcsn: observable,
  transaction_in_different_visa_account: observable,
  is_other_transaction_with_same_merchant: observable,
  provided_proof_of_other_means_type: observable,
  is_evidence_of_merchant_passed_funds_provided: observable,
  cardholder_attempted_to_resolve: observable,
  is_attempt_to_resolve_prohibited_by_local_law: observable,
  other_visa_transaction_arn: observable,
  other_visa_transaction_information: observable
});
class NoAuthorizationDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.cash_over_indicator = "";
    this.load(args);
  }
}
decorate(NoAuthorizationDetailsStore, {
  domSettingsStore: observable,
  // values
  cash_over_indicator: observable
});
const visaNetworkMandateH12025 = flipFlop.get("visa-network-mandate-H1-2025", false);
class CounterfeitMerch extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.what_was_ordered = "";
    this.date_the_cardholder_received_the_merchandise_or_notification = "";
    this.describe_the_counterfeit_merchandise = "";
    this.describe_the_disposition_of_counterfeit_merchandise = "";
    this.provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit = "";
    this.certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following = "";
    this.load(args);
  }
}
const decorationConfig = {
  domSettingsStore: observable,
  // values
  what_was_ordered: observable,
  date_the_cardholder_received_the_merchandise_or_notification: observable,
  describe_the_counterfeit_merchandise: observable,
  describe_the_disposition_of_counterfeit_merchandise: observable
};
if (!visaNetworkMandateH12025) {
  Object.assign(decorationConfig, {
    certification_the_merchandise_was_identified_as_counterfeit_by_one_of_the_following: observable,
    provide_information_about_the_entity_that_indicated_the_merchandise_to_be_counterfeit: observable
  });
}
decorate(CounterfeitMerch, decorationConfig);
class InvalidDataDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.authorization_request_declined_valid_data = null;
    this.explain_why_valid_data_inclusion_reason = "";
    this.load(args);
  }
}
decorate(InvalidDataDetailsStore, {
  // values
  authorization_request_declined_valid_data: observable,
  explain_why_valid_data_inclusion_reason: observable
});
class MisrepresentationDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.did_cardholder_cancel = null;
    this.cancellation_date = null;
    this.cancellation_reason = "";
    this.cardholder_attempt_to_resolve = null;
    this.attempt_to_resolve_proh_local_law = null;
    this.merchandise_or_services = null;
    this.how_merchandise_service_misrepresented = "";
    this.describe_what_was_purchased = "";
    this.cardholder_return_merchandise_ind = null;
    this.merchandise_received_date = null;
    this.service_received_date = null;
    this.shipping_tracking_number = "";
    this.cardholder_attempt_return_merchandise = null;
    this.attempted_return_date = null;
    this.how_ch_attempt_return_and_disp_of_merchandise = "";
    this.merchant_refuse_ind = null;
    this.cardholder_returned_merchandise_date = null;
    this.merchant_received_returned_merchandise_date = null;
    this.return_method = null;
    this.how_merchandise_returned = null;
    this.load(args);
  }
}
decorate(MisrepresentationDetailsStore, {
  // values
  did_cardholder_cancel: observable,
  cancellation_date: observable,
  cancellation_reason: observable,
  cardholder_attempt_to_resolve: observable,
  attempt_to_resolve_proh_local_law: observable,
  merchandise_or_services: observable,
  merchandise_received_date: observable,
  service_received_date: observable,
  describe_what_was_purchased: observable,
  how_merchandise_service_misrepresented: observable,
  cardholder_return_merchandise_ind: observable,
  shipping_tracking_number: observable,
  cardholder_attempt_return_merchandise: observable,
  attempted_return_date: observable,
  how_ch_attempt_return_and_disp_of_merchandise: observable,
  merchant_refuse_ind: observable,
  cardholder_returned_merchandise_date: observable,
  merchant_received_returned_merchandise_date: observable,
  return_method: observable,
  how_merchandise_returned: observable
});
class OriginalCreditNotAcceptedDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.domSettingsStore = new DomSettingsStore();
    this.explain_reason = "";
    this.load(args);
  }
}
decorate(OriginalCreditNotAcceptedDetailsStore, {
  // values
  explain_reason: observable
});
class CollaborationDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.late_presentment_details = new LatePresentmentDetailsStore();
    this.no_authorization_details = new NoAuthorizationDetailsStore();
    this.incorrect_transaction_code = new NotAsDescribedOrDefectiveMerchandise2();
    this.incorrect_currency_details = new IncorrectCurrencyDetails();
    this.incorrect_account_number_details = new IncorrectAccountNumberStore();
    this.incorrect_transaction_amount_details = new IncorrectTransactionAmountStore();
    this.invalid_data_details = new InvalidDataDetailsStore();
    this.original_credit_not_accepted_details = new OriginalCreditNotAcceptedDetailsStore();
    this.misrepresentation_details = new MisrepresentationDetailsStore();
    this.cancelled_recurring_transaction_details = new CancelledRecurringTransactionDetailsStore();
    this.service_not_provided_merchandise_not_received_details = new ServiceNotProvidedMerchandiseNotReceivedDetailsStore();
    this.not_as_described_or_defective_merchandise_details = new NotAsDescribedOrDefectiveMerchandise$1();
    this.counterfeit_merch_details = new CounterfeitMerch();
    this.cancelled_merchandise_or_services_details = new CancelledMerchandizeOrServicesDetailsStore();
    this.credit_not_processed_details = new CreditNotProcessedDetailsStore();
    this.duplicate_processing_or_paid_by_other_means_details = new DuplicateProcessingDetailsStore();
    this.loadFullInfoResult(args);
  }
  // actions
  loadFullInfoResult(data) {
    const {
      cancelled_merchandise_or_services_details,
      cancelled_recurring_transaction_details,
      credit_not_processed_details,
      duplicate_processing_or_paid_by_other_means_details,
      incorrect_account_number_details,
      incorrect_currency_details,
      incorrect_transaction_amount_details,
      incorrect_transaction_code_details,
      late_presentment_details,
      no_authorization_details,
      not_as_described_or_defective_merchandise_details,
      service_not_provided_merchandise_not_received_details,
      invalid_data_details,
      misrepresentation_details,
      original_credit_not_accepted_details,
      counterfeit_merch_details
    } = data || {};
    const items = [{
      element: "late_presentment_details",
      value: late_presentment_details,
      store: LatePresentmentDetailsStore
    }, {
      element: "no_authorization_details",
      value: no_authorization_details,
      store: NoAuthorizationDetailsStore
    }, {
      element: "incorrect_transaction_code_details",
      value: incorrect_transaction_code_details,
      store: NotAsDescribedOrDefectiveMerchandise2
    }, {
      element: "service_not_provided_merchandise_not_received_details",
      value: service_not_provided_merchandise_not_received_details,
      store: ServiceNotProvidedMerchandiseNotReceivedDetailsStore
    }, {
      element: "invalid_data_details",
      value: invalid_data_details,
      store: InvalidDataDetailsStore
    }, {
      element: "misrepresentation_details",
      value: misrepresentation_details,
      store: MisrepresentationDetailsStore
    }, {
      element: "original_credit_not_accepted_details",
      value: original_credit_not_accepted_details,
      store: OriginalCreditNotAcceptedDetailsStore
    }, {
      element: "not_as_described_or_defective_merchandise_details",
      value: not_as_described_or_defective_merchandise_details,
      store: NotAsDescribedOrDefectiveMerchandise$1
    }, {
      element: "counterfeit_merch_details",
      value: counterfeit_merch_details,
      store: CounterfeitMerch
    }, {
      element: "cancelled_merchandise_or_services_details",
      value: cancelled_merchandise_or_services_details,
      store: CancelledMerchandizeOrServicesDetailsStore
    }, {
      element: "cancelled_recurring_transaction_details",
      value: cancelled_recurring_transaction_details,
      store: CancelledRecurringTransactionDetailsStore
    }, {
      element: "credit_not_processed_details",
      value: credit_not_processed_details,
      store: CreditNotProcessedDetailsStore
    }, {
      element: "incorrect_currency_details",
      value: incorrect_currency_details,
      store: IncorrectCurrencyDetails
    }, {
      element: "incorrect_account_number_details",
      value: incorrect_account_number_details,
      store: IncorrectAccountNumberStore
    }, {
      element: FIELDS_KEY_MAP.INCORRECT_TRANSACTION_AMOUNT_DETAILS,
      value: incorrect_transaction_amount_details,
      store: IncorrectTransactionAmountStore
    }, {
      element: "duplicate_processing_or_paid_by_other_means_details",
      value: duplicate_processing_or_paid_by_other_means_details,
      store: DuplicateProcessingDetailsStore
    }];
    items.forEach((item) => {
      const {
        element,
        value,
        store
      } = item;
      this.loadAndConstructItem(element, value, store);
    });
  }
}
decorate(CollaborationDetailsStore, {
  // values
  // Processing Errors (Visa 12.X)
  incorrect_account_number_details: observable,
  incorrect_currency_details: observable,
  incorrect_transaction_amount_details: observable,
  incorrect_transaction_code: observable,
  late_presentment_details: observable,
  invalid_data_details: observable,
  // Consumer Dispute (Visa 13.X)
  original_credit_not_accepted_details: observable,
  misrepresentation_details: observable,
  cancelled_merchandise_or_services_details: observable,
  cancelled_recurring_transaction_details: observable,
  credit_not_processed_details: observable,
  duplicate_processing_or_paid_by_other_means_details: observable,
  not_as_described_or_defective_merchandise_details: observable,
  service_not_provided_merchandise_not_received_details: observable,
  counterfeit_merch_details: observable,
  no_authorization_details: observable,
  // actions
  loadFullInfoResult: action.bound
});
class GeneralFraudTypeDisputeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.chip_on_card = null;
    this.load(args);
  }
}
decorate(GeneralFraudTypeDisputeDetailsStore, {
  chip_on_card: observable
});
class FraudDisputeTypeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.general_fraud_type_dispute_details = {};
    this.loadFullInfoResult(args);
  }
  // actions
  loadFullInfoResult(data) {
    const {
      general_fraud_type_dispute_details = {}
    } = data;
    this.loadAndConstructItem("general_fraud_type_dispute_details", general_fraud_type_dispute_details, GeneralFraudTypeDisputeDetailsStore);
  }
}
decorate(FraudDisputeTypeDetailsStore, {
  // values
  general_fraud_type_dispute_details: observable,
  // actions
  loadFullInfoResult: action.bound
});
class RegulationDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.pc_grant_days_to_act = null;
    this.pc_perm_days_to_act = null;
    this.pc_reversed_coms_days_to_act = null;
    this.pc_reversed_days_to_act = null;
    this.load(args);
  }
}
decorate(RegulationDetailsStore, {
  pc_grant_days_to_act: observable,
  pc_perm_days_to_act: observable,
  pc_reversed_coms_days_to_act: observable,
  pc_reversed_days_to_act: observable
  //computed
});
class FraudCategoryTypeDisputeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.fraud_type = "";
    this.load(args);
  }
}
decorate(FraudCategoryTypeDisputeDetailsStore, {
  // values
  fraud_type: observable
});
class FraudClassificationTypeDisputeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.fraud_type_classification = "";
    this.load(args);
  }
}
decorate(FraudClassificationTypeDisputeDetailsStore, {
  // values
  fraud_type_classification: observable
});
class PartialDisputeResolutionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.final_resolution_type = "";
    this.final_cardholder_resolution_amount = null;
    this.amount_reversed = null;
    this.currency_code = "";
    this.load(args);
  }
  get partialAmountDetails() {
    return {
      "Final resolution type": sentenceCase(this.final_resolution_type),
      "Final cardholder resolution Amount": this.amountWithCurrency(this.final_cardholder_resolution_amount),
      "Amount Reversed": this.amountWithCurrency(this.amount_reversed)
    };
  }
  get hasContent() {
    const presentDetails = Object.values(this.partialAmountDetails).filter((d) => isPresent(d));
    return Boolean(presentDetails?.length);
  }
  // helpers
  amountWithCurrency(amount) {
    try {
      if (isNotPresent(amount))
        return null;
      return [amount, this.currency_code].join(" ").trim();
    } catch (err) {
      return amount;
    }
  }
}
decorate(PartialDisputeResolutionStore, {
  // values
  final_resolution_type: observable,
  final_cardholder_resolution_amount: observable,
  amount_reversed: observable,
  currency_code: observable,
  // computed
  partialAmountDetails: computed,
  hasContent: computed
});
class EditStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.editedKeyArray = [];
    this.edited = {};
  }
  // actions
  setEdit(attr, val) {
    if (typeof attr === "string" && val !== void 0) {
      if (!this.editedKeyArray.includes(attr)) {
        this.editedKeyArray.push(attr);
      }
      this.edited[attr] = val;
    }
    return this[attr];
  }
  clearEdited() {
    this.editedKeyArray = [];
    this.edited = {};
  }
  // helper
  isEdited(attr) {
    return this.edited[attr] !== void 0;
  }
  // Observed object doesn't update when key/val changes so cannot be computed.
  getEditedKeys() {
    const editObjectKeys = Object.keys(this.edited);
    return editObjectKeys ? toJS(editObjectKeys) : [];
  }
  getHasEdits() {
    return Boolean(this.getEditedKeys().length);
  }
  // computed
  get presentEditedKeys() {
    return this.editedKeyArray.filter((key) => {
      return isPresent(this.edited[key]);
    });
  }
}
decorate(EditStore, {
  // values
  edited: observable.deep,
  editedKeyArray: observable,
  // actions
  setEdit: action.bound,
  clearEdited: action.bound,
  // computed
  presentEditedKeys: computed,
  // helpers
  isEdited: action.bound,
  getEditedKeys: action.bound,
  getHasEdits: action.bound
});
const CASH_OVER_INDICATOR = [{
  field: "cash_over_indicator",
  label: "Indicate which portion of the transaction will be disputed",
  type: SELECT,
  key: generateId(),
  optional: true,
  options: [{
    val: "M",
    render: "Merchandise only"
  }, {
    val: "C",
    render: "Cash over only"
  }, {
    val: "B",
    render: "Both Merchandise and cash"
  }]
}];
const DATE_OF_RETURN = [{
  field: "date_of_return",
  label: "Date purchase was returned to the merchant",
  type: DATE,
  key: generateId(),
  optional: true
}];
const CREDIT_NOT_PROCESSED = {
  label: "Credit not Processed",
  field: "credit_not_processed_details",
  key: generateId(),
  children: [{
    field: "date_of_cancellation",
    label: "Date the order or service was canceled",
    type: DATE,
    key: generateId(),
    optional: true
  }, ...DATE_OF_RETURN, ...CASH_OVER_INDICATOR]
};
const LATE_PRESENTMENT = {
  label: "Late presentment",
  field: "late_presentment_details",
  key: generateId(),
  children: [...CASH_OVER_INDICATOR]
};
const NO_AUTHORIZATION = {
  label: "No Authorization",
  field: "no_authorization_details",
  key: generateId(),
  children: [...CASH_OVER_INDICATOR]
};
const CANCELLED_RECURRING_TRANSACTION = {
  label: "Cancelled recurring transaction",
  field: "cancelled_recurring_transaction_details",
  key: generateId(),
  children: [{
    field: "cancelled_recurring_payment_date",
    label: "Date recurring transaction was canceled",
    type: DATE,
    key: generateId(),
    optional: true
  }, {
    field: "recurring_payment_plan_expiry_date",
    label: "Date recurring payment plan expired",
    type: DATE,
    key: generateId(),
    optional: true
  }]
};
const INCORRECT_TRANSACTION_AMOUNT = {
  field: FIELDS_KEY_MAP.INCORRECT_TRANSACTION_AMOUNT_DETAILS,
  label: "What is the amount on the cardholder’s receipt?",
  key: generateId(),
  children: [...CASH_OVER_INDICATOR]
};
const INCORRECT_TRANSACTION_CODE = {
  label: "Incorrect transaction code",
  field: "incorrect_transaction_code_details",
  children: [
    /*{
      field: 'comments',
      label: 'Comments',
      type: TEXTAREA,
      key: generateId(),
    },*/
    {
      field: "credit_confirmation_number",
      label: "Reference number for the credit that was provided to the cardholder",
      type: INPUT,
      key: generateId(),
      optional: true
    },
    ...DATE_OF_RETURN,
    {
      field: "return_method",
      label: "Indicate how the merchandise was returned",
      type: SELECT,
      key: generateId(),
      optional: true,
      options: RETURN_METHOD_OPTIONS
    }
  ]
};
const NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE = {
  label: "Not as Described or defective merchandise",
  field: "not_as_described_or_defective_merchandise_details",
  children: [{
    field: "motive_code",
    label: "Motive codes are used to further define the reason for an item",
    type: SELECT,
    key: generateId(),
    options: [{
      val: "TERMS_OF_SALE_OR_COUNTERFEIT_MERCHANDISE",
      render: "Cardholder disputes terms of sale or counterfeit merchandise"
    }, {
      val: "QUALITY_OF_GOODS_OR_SERVICES",
      render: "Cardholder disputes quality of goods or services"
    }]
  }, {
    field: "merchandise_counterfeit_confirmation_date",
    label: "Date counterfeit transaction was confirmed",
    type: DATE,
    key: generateId(),
    optional: true
  }, {
    field: "promised_delivery_date",
    label: "When merchandise was supposed to be delivered or a service was to be performed",
    type: DATE,
    key: generateId(),
    optional: true
  }, ...CASH_OVER_INDICATOR]
};
const SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED = {
  label: "Merchandise or Services Not Received",
  field: "service_not_provided_merchandise_not_received_details",
  children: [{
    field: "agreed_delivery_date_or_service_date",
    label: "Promised delivery date for good and /or serviced to be delivered in non receipt of goods or services disputed. The cardholder and the merchant agreed to the delivery or service date.",
    type: DATE,
    key: generateId()
  }, ...DATE_OF_RETURN, ...CASH_OVER_INDICATOR]
};
const PULSE_QUESTIONNAIRE_FLOWS = {
  CREDIT_NOT_PROCESSED,
  NO_AUTHORIZATION,
  CANCELLED_RECURRING_TRANSACTION,
  INCORRECT_TRANSACTION_AMOUNT,
  INCORRECT_TRANSACTION_CODE,
  LATE_PRESENTMENT,
  NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE,
  SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED
};
const AVAILABLE_DISPUTE_STATE_AND_ACTION_FOR_ATTACH = {
  [DISPUTE_STATE_MAP.INITIATED]: {
    [REPRESENTMENT]: true,
    [REPRESENTMENT_RECEIVED]: true,
    [RESPOND_WITH_PREARB]: true
  },
  [DISPUTE_STATE_MAP.REPRESENTMENT]: {
    [RESPOND_WITH_PREARB]: true
  },
  [DISPUTE_STATE_MAP.PRE_ARBITRATION]: {
    [RESPOND_WITH_PREARB_RESPONSE]: true
  }
};
const AVAILABLE_DISPUTE_STATE_FOR_DOC_RETRIEVAL = {
  [DISPUTE_STATE_MAP.REPRESENTMENT]: true,
  [DISPUTE_STATE_MAP.PRE_ARBITRATION]: true
};
const TRANSITION_DETAILS_NAMES = {
  CHARGEBACK: "chargeback_details",
  REVIEW: "review_details"
};
const DISPUTE_TRANSITION_DETAILS_NAMES = {
  REPRESENTMENT: "representment_details",
  PRE_ARB: "prearbitration_details"
};
const FRAUD_REASON_CODES = {
  EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD: "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD",
  EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD: "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD",
  NOT_AUTHORIZED_CARD_PRESENT: "NOT_AUTHORIZED_CARD_PRESENT",
  NOT_AUTHORIZED_CARD_ABSENT: "NOT_AUTHORIZED_CARD_ABSENT",
  CHIP_LIABILITY_SHIFT: "CHIP_LIABILITY_SHIFT",
  CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN: "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN",
  QUESTIONABLE_MERCHANT_ACTIVITY: "QUESTIONABLE_MERCHANT_ACTIVITY",
  FRAUD_TRANSACTION: "FRAUD_TRANSACTION"
};
const AUTHORIZATION_REASON_CODES = {
  NO_AUTHORIZATION: "NO_AUTHORIZATION",
  CARD_RECOVERY_BULLETIN: "CARD_RECOVERY_BULLETIN",
  DECLINED_AUTH: "DECLINED_AUTH"
};
const EU_UK_REG_E_COUNTRY_CODES = {
  EU: "EU",
  UK: "UK"
};
const CREDIT_TYPES = {
  PERMANENT: "permanent",
  PROVISIONAL: "provisional"
};
const SHIPPING_DELIVERY_STATUS = {
  NS: "Not Shipped",
  B: "Backordered",
  IT: "In transit",
  PS: "Partial Shipped",
  S: "Shipped",
  C: "Cancelled",
  SE: "Shipping Exception",
  P: "Picked Up by customer",
  O: "Other",
  D: "Delivered"
};
const UNDISPUTED_TRANSACTION_COLUMNS = [{
  header: "Historical transaction amount",
  accessor: "historical_tran_amount",
  key: "historical_tran_amount"
}, {
  header: "Historical transaction date",
  accessor: "historical_tran_date",
  key: "historical_tran_date"
}, {
  header: "Historical transaction id",
  accessor: "historical_transaction_id",
  key: "historical_transaction_id"
}, {
  header: "Historical transaction ARN",
  accessor: "historical_ARN",
  key: "historical_ARN"
}, {
  header: "Rol transaction id",
  accessor: "rol_transaction_id",
  key: "rol_transaction_id"
}, {
  header: "Description of merchandise",
  accessor: "merchandise_or_services_desc",
  key: "merchandise_or_services_desc"
}, {
  header: "Device id details",
  accessor: "device_id_details",
  key: "device_id_details"
}, {
  header: "Device fingerprinting details",
  accessor: "device_fingerprinting_details",
  key: "device_fingerprinting_details"
}, {
  header: "Device type details",
  accessor: "device_type_details",
  key: "device_type_details"
}, {
  header: "Ip address details",
  accessor: "ip_address_details",
  key: "ip_address_details"
}, {
  header: "Formatted customer account login id details",
  accessor: "formattedCustomerAccountLoginIdDetails",
  key: "formattedCustomerAccountLoginIdDetails"
}, {
  header: "Address",
  accessor: "address",
  key: "address"
}, {
  header: "Address 2",
  accessor: "address2",
  key: "address2"
}, {
  header: "City",
  accessor: "city",
  key: "city"
}, {
  header: "State/Region",
  accessor: "state_region",
  key: "state_region"
}, {
  header: "Postal code",
  accessor: "postal_code",
  key: "postal_code"
}, {
  header: "Country",
  accessor: "country",
  key: "country"
}];
const DISPUTED_TRANSACTION_COLUMNS = [{
  header: "Device id details",
  accessor: "device_id_details",
  key: "device_id_details"
}, {
  header: "Device fingerprinting details",
  accessor: "device_fingerprinting_details",
  key: "device_fingerprinting_details"
}, {
  header: "Device type details",
  accessor: "device_type_details",
  key: "device_type_details"
}, {
  header: "Ip address details",
  accessor: "ip_address_details",
  key: "ip_address_details"
}, {
  header: "Customer account login id details",
  accessor: "customer_account_login_id_details",
  key: "customer_account_login_id_details"
}];
const EU_COUNTRY_CODES = ["040", "AUSTRIA", "AT", "AUT", "056", "BELGIUM", "BE", "BEL", "100", "BULGARIA", "BG", "BGR", "191", "CROATIA", "HR", "HRV", "196", "CYPRUS", "CY", "CYP", "203", "CZECH REPUBLIC", "CZ", "CZE", "208", "DENMARK", "DK", "DNK", "233", "ESTONIA", "EE", "EST", "246", "FINLAND", "FI", "FIN", "250", "FRANCE", "FR", "FRA", "276", "GERMANY", "DE", "DEU", "300", "GREECE", "GR", "GRC", "348", "HUNGARY", "HU", "HUN", "372", "IRELAND", "IRELAND, REPUBLIC OF (EIRE)", "IE", "IRL", "380", "ITALY", "IT", "ITA", "428", "LATVIA", "LV", "LVA", "440", "LITHUANIA", "LT", "LTU", "442", "LUXEMBOURG", "LU", "LUX", "470", "MALTA", "MT", "MLT", "528", "NETHERLANDS", "NL", "NLD", "616", "POLAND", "PL", "POL", "620", "PORTUGAL", "PT", "PRT", "642", "ROMANIA", "RO", "ROU", "703", "SLOVAKIA", "SK", "SVK", "705", "SLOVENIA", "SI", "SVN", "724", "SPAIN", "ES", "ESP", "752", "SWEDEN", "SE", "SWE", "826", "UNITED KINGDOM", "GB", "GBR"];
class DisputeDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.case_token = "";
    this.cardholder_contact_date = "";
    this.additional_dispute_details = new AdditionalDisputeDetailsStore();
    this.associated_transaction_selection_required = false;
    this.currency_code = "";
    this.dispute_amount_change_reason = "";
    this.dispute_amount = "";
    this.dispute_reason = "";
    this.dispute_reason_code = "";
    this.dispute_state = "";
    this.network_case_number = "";
    this.network_failure_response = "";
    this.original_transaction_token = "";
    this.original_transaction_type = "";
    this.account_status = "";
    this.provisional_credit_granted = false;
    this.regulation_details = [];
    this.regulation_type = "";
    this.cardholder_email_override = null;
    this.collaborationDetailsStore = new CollaborationDetailsStore();
    this.fraud_dispute_type_details = null;
    this.fraud_category_type_dispute_details = null;
    this.fraud_classification_type_dispute_details = null;
    this.partial_dispute_resolution = null;
    this.network_case_status_details = {};
    this.presentQuestionnaireFields = [];
    this.questionnaireEdits = new EditStore();
    this.zendesk_mapping = null;
    this.zendesk_mapping_id = "";
    this.isProgramRequiredCRM = false;
    this.loading = false;
    this.skipAutoLoad = true;
    this.loadFullInfoResult(args);
    reaction(() => this.dispute_reason, () => this.resetQuestionnaire());
  }
  // actions
  loadFullInfoResult(data) {
    const {
      network_case_status_details,
      additional_dispute_details,
      processing_error_type_dispute_details,
      consumer_dispute_type_dispute_details,
      fraud_dispute_type_details,
      partial_dispute_resolution,
      regulation_details,
      fraud_category_type_dispute_details,
      fraud_classification_type_dispute_details,
      ...partialData
    } = data;
    this.load(partialData);
    const augmentedNetworkDetails = {
      gqlClient: this.gqlClient,
      case_token: this.case_token,
      ...network_case_status_details
    };
    const augmentedPartialDisputeResolution = {
      currency_code: this.currency_code,
      ...partial_dispute_resolution
    };
    this.loadAndConstructItem("network_case_status_details", augmentedNetworkDetails, NetworkCaseStatusDetailsStore);
    this.loadAndConstructItem("additional_dispute_details", additional_dispute_details, AdditionalDisputeDetailsStore);
    this.loadAndConstructItem("fraud_dispute_type_details", fraud_dispute_type_details, FraudDisputeTypeDetailsStore);
    this.loadAndConstructItem("partial_dispute_resolution", augmentedPartialDisputeResolution, PartialDisputeResolutionStore);
    this.loadAndConstructItem("regulation_details", regulation_details, RegulationDetailsStore);
    this.loadAndConstructItem("fraud_category_type_dispute_details", fraud_category_type_dispute_details, FraudCategoryTypeDisputeDetailsStore);
    this.loadAndConstructItem("fraud_classification_type_dispute_details", fraud_classification_type_dispute_details, FraudClassificationTypeDisputeDetailsStore);
    this.reconcileAndLoadQuestionnaireDetails(processing_error_type_dispute_details || consumer_dispute_type_dispute_details);
  }
  /*
   * NOTE: all of reconcile* and associated functions format and reconcile
   * the response data before loading onto the questionnaire stores.
   */
  reconcileAndLoadQuestionnaireDetails(collaborationDetails) {
    if (!collaborationDetails)
      return;
    const detailsBody = collaborationDetails[this.currentQuestionnaire?.field];
    const autoFillDetails = this.reconcileAutoFillFields(detailsBody);
    const formattedDateFields = this.reconcileDateFields(detailsBody);
    const reconciledDetails = {
      [this.currentQuestionnaire?.field]: {
        ...detailsBody,
        ...autoFillDetails,
        ...formattedDateFields
      }
    };
    this.loadAndConstructItem("collaborationDetailsStore", reconciledDetails, CollaborationDetailsStore);
  }
  // This method takes the response body and reverse engineers any nodes
  // with an `autoFill` attribute. This ensures that the form is
  // reconstructed the same way it was previously submitted.
  reconcileAutoFillFields(detailsBody) {
    if (!this.aggregatedNonApiAutoFills)
      return {};
    const autoFillDetails = {};
    Object.keys(this.aggregatedNonApiAutoFills).forEach((autoFillField) => {
      const autoFillOptions = this.aggregatedNonApiAutoFills[autoFillField];
      const matchingAutoFill = this.findMatchingAutoFill(autoFillOptions, detailsBody);
      if (matchingAutoFill) {
        autoFillDetails[autoFillField] = matchingAutoFill;
      }
    });
    return autoFillDetails;
  }
  findMatchingAutoFill(autoFillOptions, detailsBody) {
    const autoFillConditions = Object.keys(autoFillOptions || {});
    return autoFillConditions.find((condition) => {
      const conditionOptions = autoFillOptions[condition];
      return Object.keys(conditionOptions).every((optionField) => {
        const conditionReq = conditionOptions[optionField];
        const existingValue = detailsBody[optionField];
        if (conditionReq === existingValue) {
          return true;
        }
      });
    });
  }
  reconcileDateFields(detailsBody) {
    const formattedDates = {};
    const dateFields = this.aggregatedDateFormats;
    dateFields.forEach((field) => {
      const dateValue = detailsBody && detailsBody[field];
      if (isPresent(dateValue)) {
        const formattedDate = formatUTCMoment(dateValue, {
          showTime: false
        });
        formattedDates[field] = formattedDate;
      }
    });
    return formattedDates;
  }
  resetQuestionnaire() {
    const generalFraudStore = this.fraud_dispute_type_details?.general_fraud_type_dispute_details;
    const {
      setAttr: setFraudAttr
    } = generalFraudStore || {};
    this.questionnaireEdits = new EditStore();
    this.presentQuestionnaireFields = [];
    if (this.currentQuestionnaireStore.domSettingsStore) {
      this.currentQuestionnaireStore.domSettingsStore.fields = {};
    }
    setFraudAttr && setFraudAttr("chip_on_card", null);
  }
  managePresentFields(field, isPresent2 = true) {
    const markedAsVisible = this.presentQuestionnaireFields.includes(field);
    if (isPresent2 && field && !markedAsVisible) {
      this.presentQuestionnaireFields.push(field);
    } else if (!isPresent2 && field && markedAsVisible) {
      const index = this.presentQuestionnaireFields.indexOf(field);
      if (index > -1) {
        this.presentQuestionnaireFields.splice(index, 1);
        this.markChildrenNotPresentByField(field);
      }
    }
  }
  markChildrenNotPresentByField(field) {
    const presentChildren = this.fetchPresentChildrenByField(field);
    presentChildren.forEach((childField) => {
      const index = this.presentQuestionnaireFields.indexOf(childField);
      if (index > -1) {
        this.presentQuestionnaireFields.splice(index, 1);
      }
    });
  }
  // computed
  get baseDisputeFormValidation() {
    const {
      isEditing
    } = this.constructedBy;
    const zendeskMappingValidation = {};
    if (!isEditing && this.zendesk_mapping === "update") {
      if (!this.zendesk_mapping_id) {
        zendeskMappingValidation.zendesk_mapping_id = REQUIRED_FIELD_ERROR;
      } else if (!/^\d{3,10}$/.test(this.zendesk_mapping_id)) {
        zendeskMappingValidation.zendesk_mapping_id = ZENDESK_TICKET_ID_VALIDATION;
      }
    }
    const programCRMValidation = {};
    if (this.isProgramRequiredCRM) {
      if (!isEditing && this.zendesk_mapping === null) {
        programCRMValidation.createOrEnterCRM = CREATE_OR_ENTER_EXISTING_CRM_TICKET;
      }
      if (!isEditing && this.zendesk_mapping === "create" && this.cardholder_email_override === null) {
        programCRMValidation.email_is_required = REQUIRED_FIELD_ERROR;
      }
    }
    const cardholderContactDateIsInFuture = isDateInFuture(this.cardholder_contact_date);
    return {
      ...cardholderContactDateIsInFuture && {
        cardholder_contact_date: CARDHOLDER_CONTACT_DATE_NOT_IN_FUTURE
      },
      ...!isNumeric(this.dispute_amount) && {
        dispute_amount: amountIncorrectFormatError
      },
      ...!this.dispute_amount && {
        dispute_amount: AMOUNT_REQUIRED_ERROR
      },
      ...!this.dispute_reason && !this.dispute_reason_code && {
        dispute_reason: reasonRequiredError
      },
      ...!this.original_transaction_token && {
        original_transaction_token: transactionTokenRequiredError
      },
      ...!this.questionnaireIsValid && {
        questionnaireError
      },
      ...zendeskMappingValidation,
      ...programCRMValidation
    };
  }
  get questionnaireIsValid() {
    const fieldsAreMissing = Boolean(this.missingQuestionnaireFields.length);
    const invalidFields = Object.keys(this.invalidFieldsMap);
    return !(fieldsAreMissing || invalidFields?.length);
  }
  get invalidFieldsMap() {
    const invalidMap = {};
    Object.keys(this.aggregatedValidationFields).forEach((field) => {
      const validation = this.aggregatedValidationFields?.[field];
      const nodeIsPresent = this.presentQuestionnaireFields.includes(field);
      const value = this.currentQuestionnaireStore?.[field];
      const invalidity = validation(value);
      const isOptional = this.aggregatedOptionalFields[field];
      if (isOptional && isNotPresent(value)) {
        return delete invalidMap[field];
      }
      if (nodeIsPresent && isPresent(value) && invalidity) {
        return invalidMap[field] = invalidity;
      }
      delete invalidMap[field];
    });
    return Object.keys(this.aggregatedDependencyValidationFields).reduce((invalidMap2, field) => {
      const dependencyValidation = this.aggregatedDependencyValidationFields?.[field];
      const nodeIsPresent = this.presentQuestionnaireFields.includes(field);
      const value = this.currentQuestionnaireStore?.[field];
      const presentFields = this.presentQuestionnaireFields.reduce((fieldMap, field2) => {
        return {
          ...fieldMap,
          [field2]: this.currentQuestionnaireStore?.[field2]
        };
      }, {});
      const invalidity = dependencyValidation(presentFields);
      const isOptional = this.aggregatedOptionalFields[field];
      if (!isOptional && nodeIsPresent && isPresent(value) && invalidity && !invalidMap2[field]) {
        invalidMap2[field] = invalidity;
      }
      return invalidMap2;
    }, invalidMap);
  }
  get currentQuestionnaire() {
    const nw_mandates_oct_2023 = flipFlop.get("disputes-nw-mandates-oct-2023", false);
    const nw_mandates_april_2024 = flipFlop.get("disputes-nw-mandates-april-2024", false);
    const nw_mandates_oct_2024 = flipFlop.get("october-network-mandate", false);
    if (this.constructedBy?.isPulse) {
      return PULSE_QUESTIONNAIRE_FLOWS ? PULSE_QUESTIONNAIRE_FLOWS[this.dispute_reason] : null;
    }
    if (QUESTIONNAIRE_FLOWS && QUESTIONNAIRE_FLOWS[this.dispute_reason] instanceof Function) {
      return QUESTIONNAIRE_FLOWS[this.dispute_reason]({
        nw_mandates_oct_2023,
        nw_mandates_april_2024,
        nw_mandates_oct_2024
      });
    }
    return QUESTIONNAIRE_FLOWS ? QUESTIONNAIRE_FLOWS[this.dispute_reason] : null;
  }
  get disputeReasonData() {
    return disputeReasonNetworkMap ? disputeReasonNetworkMap[this.dispute_reason] : null;
  }
  get isConsumerDisputeType() {
    return Boolean(this.disputeReasonData?.VISA?.includes("13"));
  }
  get isProcessingErrorDisputeType() {
    return Boolean(this.disputeReasonData?.VISA?.includes("12") || this.disputeReasonData?.PULSE === "4863");
  }
  get isAllocationFlow() {
    const visaAllocationRegex = /^(10|11)/;
    return visaAllocationRegex.test(this.disputeReasonData?.VISA);
  }
  get isPulseAllocationFlow() {
    return this.disputeReasonData?.PULSE === "4868";
  }
  get currentQuestionnaireStore() {
    const questionnaireKey = this.dispute_reason?.toLowerCase() + "_details";
    const questionnaireStore = this.collaborationDetailsStore?.[questionnaireKey];
    return questionnaireStore || {};
  }
  get missingQuestionnaireFields() {
    const missing = [];
    this.presentQuestionnaireFields.forEach((field) => {
      const value = this.currentQuestionnaireStore?.[field];
      const isOptional = this.aggregatedOptionalFields[field];
      if (field === "agreed_delivery_date_or_service_date") {
        if (isWithinXDays(this.transaction?.settlement_date, 16) && isNotPresent(value)) {
          missing.push(field);
          return;
        }
      }
      if (isNotPresent(value) && !isOptional) {
        missing.push(field);
      }
    });
    return missing;
  }
  get questionnairePayload() {
    const rootField = this.currentQuestionnaire?.field;
    const payload = {};
    this.presentQuestionnaireFields?.forEach((field) => {
      const value = this.currentQuestionnaireStore[field];
      if (isPresent(value) && !field.startsWith("nonAPI_")) {
        payload[field] = value;
      }
    });
    const {
      isMastercard
    } = this.constructedBy || EMPTY_OBJECT;
    if (isMastercard)
      return null;
    if (this.isConsumerDisputeType && rootField) {
      return {
        consumer_dispute_type_dispute_details: {
          [rootField]: payload
        }
      };
    } else if (this.isProcessingErrorDisputeType && rootField) {
      return {
        processing_error_type_dispute_details: {
          [rootField]: payload
        }
      };
    } else {
      return null;
    }
  }
  aggregateOrderedFields(nodeList, parentVal) {
    let orderedFields = [];
    if (!Array.isArray(nodeList))
      return [];
    if (nodeList[0] === void 0)
      return [];
    nodeList.forEach((node) => {
      if (!(node instanceof Object))
        return;
      const value = this.currentQuestionnaireStore[node.field];
      const {
        parentRequirement,
        shouldDisplayField
      } = node;
      if (shouldDisplayField instanceof Function && !shouldDisplayField(parentVal, this.settlementDate)) {
        return;
      }
      if (parentRequirement && !parentRequirement.includes(parentVal) && !anyNonEmptyParentValueAllowed(value, node.parentRequirement)) {
        return;
      }
      if (isPresent(value)) {
        if (isPresent(node.label)) {
          const optionRender = this.fetchNodeOptionRenderByField(node.field);
          orderedFields.push({
            label: node.label,
            value: optionRender || value.toString()
          });
        }
        if (node.children instanceof Array) {
          orderedFields = [...orderedFields, ...this.aggregateOrderedFields(node.children, value)];
        }
      }
    });
    return orderedFields;
  }
  get settlementDate() {
    return this.constructedBy?.transaction?.settlement_date;
  }
  get formattedCardholderContactDate() {
    return this.cardholder_contact_date && convertDateFromUTCToLocal(this.cardholder_contact_date);
  }
  get presentQuestionnaireStoreFields() {
    if (!this.currentQuestionnaireStore)
      return {};
    let fields = [];
    try {
      fields = this.aggregateOrderedFields(this.currentQuestionnaire?.children);
    } catch (err) {
      console.error(err);
      return [];
    }
    return fields;
  }
  get aggregatedLabels() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "label", false);
  }
  get aggregatedOptionalFields() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "optional", false);
  }
  get aggregatedOptions() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "options", false);
  }
  get aggregatedDateFormats() {
    const formatsMap = this.aggregateQuestionnaireField([this.currentQuestionnaire], "format", false);
    return Object.keys(formatsMap).filter((format) => formatsMap[format] === Date);
  }
  get aggregatedValidationFields() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "validation", false);
  }
  get aggregatedDependencyValidationFields() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "dependencyValidation", false);
  }
  get aggregatedNonApiAutoFills() {
    return this.aggregateQuestionnaireField([this.currentQuestionnaire], "autoFill");
  }
  get aggregatedNonApiFields() {
    const rootChildren = this.currentQuestionnaire?.children;
    const allFields = [];
    const fieldCollector = (node) => {
      const {
        field
      } = node || {};
      if (field && !field.startsWith("nonAPI_") && !allFields.includes(field)) {
        allFields.push(field);
      }
    };
    this.aggregator(rootChildren, fieldCollector);
    return allFields;
  }
  get questionnaireIsEdited() {
    const editsList = this.questionnaireEdits?.editedKeyArray;
    return Boolean(editsList?.length);
  }
  get isRegE() {
    return this.regulation_type === "REG_E";
  }
  get provisionalCreditNotIssuedYet() {
    const {
      provisionalCreditMilestone
    } = this.constructedBy.milestones;
    return Boolean(this.isRegE && provisionalCreditMilestone);
  }
  get creditType() {
    const {
      regulation_subcategory
    } = this.additional_dispute_details || EMPTY_OBJECT;
    const {
      pc_perm_days_to_act
    } = this.regulation_details;
    const shouldGrantPermanentCredit = Boolean(this.isRegE && pc_perm_days_to_act === 0 && regulation_subcategory === DISPUTE_CATEGORIES.INITIATED_BY_PAYEE);
    return shouldGrantPermanentCredit ? CREDIT_TYPES.PERMANENT : CREDIT_TYPES.PROVISIONAL;
  }
  get isPCGranted() {
    const {
      isProvisionalCreditGranted
    } = this.constructedBy.events || EMPTY_OBJECT;
    const isPCGranted = isProvisionalCreditGranted === void 0 ? this.provisional_credit_granted : isProvisionalCreditGranted;
    return isPCGranted;
  }
  get isRegEWithPCGranted() {
    return Boolean(this.isRegE && this.isPCGranted);
  }
  get cardholderComsNotSentYet() {
    const {
      state,
      milestones
    } = this.constructedBy;
    const {
      caseLostCommunicationMilestone
    } = milestones || EMPTY_OBJECT;
    return Boolean(this.isRegE && caseLostCommunicationMilestone && state === STATE_MAP.PENDING_CLOSE);
  }
  get isPCTimeframeExpired() {
    const {
      pc_perm_days_to_act: numDays
    } = this.regulation_details || EMPTY_OBJECT;
    return !isWithinXDays(this.cardholder_contact_date, numDays);
  }
  // HELPERS
  aggregateQuestionnaireField(siblings, attribute2, nonAPIOnly = true) {
    const aggregate = {};
    const aggregateCallback = (node) => {
      if (node.field && isPresent(node[attribute2])) {
        if (!nonAPIOnly || node.field.startsWith("nonAPI_")) {
          aggregate[node.field] = node[attribute2];
        }
      }
    };
    this.aggregator(siblings, aggregateCallback);
    return aggregate;
  }
  fetchAllChildrenByField(field) {
    const fieldNode = this.findNodeByField(field);
    const fieldChildren = [];
    const aggregateCallback = (node) => {
      if (node && typeof node.field === "string") {
        fieldChildren.push(node.field);
      }
    };
    if (fieldNode && Array.isArray(fieldNode.children)) {
      this.aggregator(fieldNode.children, aggregateCallback);
    }
    return fieldChildren;
  }
  aggregator(nodeList, callback) {
    if (!Array.isArray(nodeList))
      return;
    nodeList.forEach((node) => {
      if (node instanceof Object) {
        callback && callback(node);
        if (node.children instanceof Array) {
          this.aggregator(node.children, callback);
        }
      }
    });
  }
  findNodeByField(field) {
    const firstChildren = this.currentQuestionnaire?.children;
    let searchNode;
    const searchChildren = (siblings) => {
      siblings.forEach((node) => {
        if (node && node.field === field) {
          searchNode = node;
          return;
        } else if (node && node.children) {
          return searchChildren(node.children);
        }
      });
    };
    if (Array.isArray(firstChildren) && typeof field === "string") {
      searchChildren(firstChildren);
    }
    return searchNode;
  }
  fetchPresentChildrenByField(field) {
    const fieldChildren = this.fetchAllChildrenByField(field);
    return fieldChildren.filter((childField) => this.presentQuestionnaireFields.includes(childField));
  }
  fetchNodeOptionRenderByField(field) {
    const nodeHasOptions = Object.keys(this.aggregatedOptions).includes(field);
    const nodeValue = this.currentQuestionnaireStore?.[field];
    const nodeOptions = this.aggregatedOptions[field];
    if (nodeHasOptions) {
      const matchingOption = nodeOptions.find((option) => option.val === nodeValue);
      return matchingOption?.render;
    }
  }
}
decorate(DisputeDetailsStore, {
  // values
  associated_transaction_selection_required: observable,
  cardholder_contact_date: observable,
  case_token: observable,
  currency_code: observable,
  dispute_amount: observable,
  dispute_amount_change_reason: observable,
  dispute_reason: observable,
  dispute_state: observable,
  fraud_dispute_type_details: observable,
  network_case_number: observable,
  network_case_status_details: observable,
  network_failure_response: observable,
  original_transaction_token: observable,
  account_status: observable,
  partial_dispute_resolution: observable,
  provisional_credit_granted: observable,
  regulation_details: observable,
  regulation_type: observable,
  fraud_category_type_dispute_details: observable,
  cardholder_email_override: observable,
  fraud_classification_type_dispute_details: observable,
  // objects and misc
  collaborationDetailsStore: observable,
  questionnaireEdits: observable,
  presentQuestionnaireFields: observable,
  skipAutoLoad: observable,
  zendesk_mapping: observable,
  zendesk_mapping_id: observable,
  isProgramRequiredCRM: observable,
  // actions
  loadFullInfoResult: action.bound,
  reconcileAndLoadQuestionnaireDetails: action.bound,
  reconcileAutoFillFields: action.bound,
  findMatchingAutoFill: action.bound,
  reconcileDateFields: action.bound,
  resetQuestionnaire: action.bound,
  managePresentFields: action.bound,
  markChildrenNotPresentByField: action.bound,
  // computed
  aggregatedOptionalFields: computed,
  aggregatedDateFormats: computed,
  aggregatedLabels: computed,
  aggregatedNonApiAutoFills: computed,
  aggregatedNonApiFields: computed,
  aggregatedOptions: computed,
  aggregatedValidationFields: computed,
  baseDisputeFormValidation: computed,
  cardholderComsNotSentYet: computed,
  creditType: computed,
  currentQuestionnaire: computed,
  currentQuestionnaireStore: computed,
  disputeReasonData: computed,
  formattedCardholderContactDate: computed,
  invalidFieldsMap: computed,
  isAllocationFlow: computed,
  isPulseAllocationFlow: computed,
  isConsumerDisputeType: computed,
  isPCTimeframeExpired: computed,
  isProcessingErrorDisputeType: computed,
  isRegE: computed,
  missingQuestionnaireFields: computed,
  presentQuestionnaireStoreFields: computed,
  questionnaireIsEdited: computed,
  questionnaireIsValid: computed,
  questionnairePayload: computed,
  settlementDate: computed,
  provisionalCreditNotIssuedYet: computed,
  isRegEWithPCGranted: computed,
  aggregatedDependencyValidationFields: computed,
  isPCGranted: computed,
  // helpers
  aggregator: action.bound,
  aggregateQuestionnaireField: action.bound,
  findNodeByField: action.bound,
  fetchAllChildrenByField: action.bound,
  fetchPresentChildrenByField: action.bound,
  fetchNodeOptionRenderByField: action.bound
});
class DisputeTransitionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.action = "";
    this.assignee = "";
    this.case_token = "";
    this.created_by = "";
    this.errorText = "";
    this.failure_reason = "";
    this.memo = "";
    this.reason_code = "";
    this.reason_description = "";
    this.state = "";
    this.token = "";
    this.created_date = "";
    this.transition_details = {
      review_details: {
        attached_contents: []
      },
      chargeback_details: {
        attached_contents: []
      }
    };
    this.load(args);
  }
  // computed
  get hasError() {
    return transitionReasonCodeFailures[this.reason_code] !== void 0;
  }
}
decorate(DisputeTransitionStore, {
  token: observable,
  case_token: observable,
  action: observable,
  reason_code: observable,
  failure_reason: observable,
  created_by: observable,
  memo: observable,
  assignee: observable,
  reason_description: observable,
  state: observable,
  errorText: observable,
  created_date: observable,
  transition_details: observable
});
const {
  templates: templates$7
} = gqlUtils;
class DisputeTransitionsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.case_token = "";
    this.count = 0;
    this.items = [];
    this.currentState = "";
    this.showNetworkSubmissionModal = false;
    this.transitionWrap = null;
    this.showAndLogAlert = () => {
    };
    this.disputesAccess = {};
    this.action = "";
    this.reason_code = "";
    this.failure_reason = "";
    this.created_by = "";
    this.memo = "";
    this.skipAutoLoad = true;
    this.loadData(args);
    this.created_by = currentUserFromStorage();
  }
  // actions
  loadData(transitionsData) {
    const {
      data
    } = transitionsData || {};
    this.load(transitionsData);
    this.loadAndConstructList("items", data, DisputeTransitionStore);
  }
  async createTransition() {
    const payload = this.createTransitionPayload;
    const mutation = templates$7.caseTransitionCreationMutation;
    await this.transitionWrap(this.validateTransition(), mutation, payload);
  }
  async transitionToOpen() {
    if (this.currentState !== STATE_MAP.READY)
      return;
    const action2 = TRANSITION_ACTIONS.RE_OPEN;
    const memo = this.memo || "Reopened for editing";
    await this.defaultTransitionByAction(action2, {
      memo
    });
  }
  async transitionToReady() {
    if (![STATE_MAP.OPEN, STATE_MAP.OPEN_WITH_ACTION_REQUIRED].includes(this.currentState))
      return;
    this.setMarkAsReadyPayload();
    await this.createTransition();
  }
  async transitionToInitiated(submissionAction, memo) {
    if (!(this.disputesAccess.hasRiskInternalRole || this.disputesAccess.hasAuxRiskExternalRole)) {
      this.showAndLogAlert("This action is currently accessible to Marqeta employees only.");
      return;
    }
    if (!SUBMISSION_ACTION_OPTIONS.includes(submissionAction))
      return;
    if (this.currentState !== STATE_MAP.READY)
      return;
    this.showNetworkSubmissionModal = false;
    const reason_code = CASE_TRANSITION_ACTION_OPTIONS[submissionAction][0];
    const attached_contents = this.previousReviewTransitionAttachedContents;
    await this.defaultTransitionByAction(submissionAction, {
      reason_code,
      memo,
      transition_details: {
        chargeback_details: {
          attached_contents
        }
      }
    });
  }
  async transitionToClosed(reasonCodeOverride = null) {
    const action2 = TRANSITION_ACTIONS.CLOSE;
    const options = reasonCodeOverride ? {
      reason_code: reasonCodeOverride
    } : EMPTY_OBJECT;
    await this.defaultTransitionByAction(action2, options);
  }
  async writeoffAndClose(reasonCodeOverride = null) {
    const action2 = TRANSITION_ACTIONS.WRITE_OFF;
    const options = reasonCodeOverride ? {
      reason_code: reasonCodeOverride
    } : EMPTY_OBJECT;
    await this.defaultTransitionByAction(action2, options);
  }
  async transitionToWithdrawnAndClosed() {
    const action2 = TRANSITION_ACTIONS.WITHDRAW_AND_CLOSE;
    await this.defaultTransitionByAction(action2);
  }
  async transitionToNonIntegrated() {
    await this.defaultTransitionByAction(CHANGE_CASE_TYPE);
  }
  async defaultTransitionByAction(action2, options = {}) {
    if (!action2)
      return;
    const reason_code = CASE_TRANSITION_ACTION_OPTIONS[action2][0];
    const payload = {
      action: action2,
      reason_code,
      ...options
    };
    this.setTransitionPayload(payload);
    await this.createTransition();
  }
  toggleSubmissionModal() {
    this.showNetworkSubmissionModal = !this.showNetworkSubmissionModal;
  }
  validateTransition() {
    const requiredFields = ["action", "reason_code", "case_token"];
    const missing = requiredFields.filter((attr) => !this[attr]);
    if (missing.length > 0) {
      this.showAndLogAlert(`Invalid dispute transition.`, `ERROR (invalid dispute transition): Missing request arguments (${missing}).`);
      return false;
    }
    return true;
  }
  setTransitionPayload({
    action: action2,
    reason_code,
    memo,
    transition_details
  }) {
    this.action = action2;
    this.reason_code = reason_code;
    if (memo) {
      this.memo = memo;
    }
    if (transition_details) {
      this.transition_details = transition_details;
    }
  }
  setMarkAsReadyPayload() {
    const action2 = TRANSITION_ACTIONS.REVIEW;
    const reason_code = CASE_TRANSITION_ACTION_OPTIONS[action2][0];
    const attached_contents = this.attachedContents;
    const payload = {
      action: action2,
      reason_code,
      transition_details: {
        review_details: {
          attached_contents
        }
      }
    };
    this.setTransitionPayload(payload);
  }
  // computed
  get attachedContents() {
    const attachedToForm = this.constructedBy?.disputeFileManager?.attachedToForm;
    const tokenList = [...attachedToForm.values()].map(({
      token
    }) => token);
    const attached_contents = attachedToForm ? tokenList : [];
    return attached_contents;
  }
  get convertToNonIntegratedFormValidation() {
    const errors = {};
    if (this.memo === "") {
      errors.memo_error = MEMO_FIELD_IS_REQUIRED_ERROR;
    }
    return errors;
  }
  get lastReviewTransition() {
    for (let i = this.count - 1; i >= 0; i--) {
      if (this.items[i].action === TRANSITION_ACTIONS.REVIEW) {
        return this.items[i];
      }
    }
    return void 0;
  }
  get lastTransition() {
    if (!this.items.length) {
      return null;
    }
    return this.items[this.items.length - 1];
  }
  get sortedTransitions() {
    return this.items.reverse().map((item) => {
      const {
        state,
        created_by,
        memo,
        failure_reason,
        reason_description,
        action: action2,
        created_date
      } = item;
      return {
        state,
        created_by,
        memo,
        failure_reason,
        reason_description,
        action: action2,
        created_date
      };
    });
  }
  get hasMultipleTransitions() {
    return Boolean(this.items && this.items.length > 1);
  }
  get createTransitionPayload() {
    const {
      action: action2,
      reason_code,
      created_by,
      case_token,
      memo,
      transition_details,
      created_date
    } = this;
    return {
      action: action2,
      created_by,
      case_token,
      reason_code,
      memo,
      created_date,
      transition_details: {
        ...transition_details
      }
    };
  }
  get previousReviewTransitionAttachedContents() {
    const reviewTransitions = this.items?.filter((t) => t.action === TRANSITION_ACTIONS.REVIEW) || [];
    const lastReviewTransition = reviewTransitions[reviewTransitions.length - 1];
    const {
      attached_contents
    } = lastReviewTransition?.transition_details?.review_details || EMPTY_OBJECT;
    return attached_contents;
  }
  get writeOffText() {
    return this.sortedTransitions[0]?.action === WRITE_OFF ? WRITE_OFF_TEXT : "";
  }
  get lastTransitionFailure() {
    return this.lastTransition?.failure_reason;
  }
}
decorate(DisputeTransitionsStore, {
  // values
  case_token: observable,
  count: observable,
  items: observable,
  currentState: observable,
  action: observable,
  reason_code: observable,
  failure_reason: observable,
  created_by: observable,
  memo: observable,
  showNetworkSubmissionModal: observable,
  disputesAccess: observable,
  skipAutoLoad: observable,
  transition_details: observable,
  // actions
  loadData: action.bound,
  createTransition: action.bound,
  defaultTransitionByAction: action.bound,
  transitionToOpen: action.bound,
  transitionToReady: action.bound,
  transitionToInitiated: action.bound,
  transitionToClosed: action.bound,
  transitionToWithdrawnAndClosed: action.bound,
  writeoffAndClose: action.bound,
  transitionToNonIntegrated: action.bound,
  validateTransition: action.bound,
  setTransitionPayload: action.bound,
  setMarkAsReadyPayload: action.bound,
  toggleSubmissionModal: action.bound,
  // Configurable actions
  transitionWrap: observable,
  showAndLogAlert: observable,
  // computed
  attachedContents: computed,
  convertToNonIntegratedFormValidation: computed,
  createTransitionPayload: computed,
  hasMultipleTransitions: computed,
  lastReviewTransition: computed,
  previousReviewTransitionAttachedContents: computed,
  sortedTransitions: computed,
  writeOffText: computed
});
const {
  fragments: fragments$3
} = gqlUtils;
class CardholderStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.active = false;
    this.status = "";
    this.token = "";
    this.first_name = "";
    this.middle_name = "";
    this.last_name = "";
    this.email = "";
    this.phone = "";
    this.address1 = "";
    this.address2 = "";
    this.city = "";
    this.state = "";
    this.postal_code = "";
    this.country = "";
    this.gender = "";
    this.honorific = "";
    this.birth_date = "";
    this.uses_parent_account = false;
    this.parent_token = "";
    this.corporate_card_holder = false;
    this.company = "";
    this.nationality = "";
    this.ip_address = "";
    this.notes_string = "";
    this.business_token = "";
    this.account_holder_group_token = "";
    this.created_time = "";
    this.last_modified_time = "";
    this.ssn = "";
    this.loading = false;
    this.load(args);
  }
  // actions
  async hydrate(token) {
    try {
      this.loading = true;
      const tokenParam = token || this.token;
      const result = await this.gqlQuery(`
          query cardholder${this.outerQueryParams || "($token: ID!)"} {
            cardholder${this.innerQueryParams || "(token: $token)"} {
              ...cardholderBaseInfo
            }
          }
          ${fragments$3.cardholderBaseInfo}
        `, {
        token: tokenParam,
        ...this.hydrateParams
      });
      runInAction(() => {
        if (result) {
          this.load(this.extract(result, "cardholder"));
          return true;
        } else {
          return false;
        }
      });
    } catch (e) {
      console.error("Error fetching cardholder: ", e);
    } finally {
      this.loading = false;
    }
  }
  // computed
  get fullName() {
    if (!this.first_name && !this.middle_name && !this.last_name)
      return "";
    return `${this.first_name || ""} ${this.middle_name ? `${this.middle_name} ` : ""}${this.last_name || ""}`;
  }
}
decorate(CardholderStore, {
  // values
  // customer info
  active: observable,
  status: observable,
  token: observable,
  first_name: observable,
  middle_name: observable,
  last_name: observable,
  email: observable,
  phone: observable,
  address1: observable,
  address2: observable,
  city: observable,
  state: observable,
  postal_code: observable,
  country: observable,
  gender: observable,
  honorific: observable,
  birth_date: observable,
  uses_parent_account: observable,
  parent_token: observable,
  corporate_card_holder: observable,
  company: observable,
  nationality: observable,
  ip_address: observable,
  notes_string: observable,
  business_token: observable,
  account_holder_group_token: observable,
  created_time: observable,
  last_modified_time: observable,
  ssn: observable,
  loading: observable,
  // computed
  fullName: computed
});
class BusinessStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.token = "";
    this.business_name_legal = "";
    this.business_name_dba = "";
    this.load(args);
  }
  // objects
  // actions
}
decorate(BusinessStore, {
  // values
  token: observable,
  business_name_legal: observable,
  business_name_dba: observable
  // actions
  // computed
});
class CardStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.expiration = "";
    this.last_four = "";
    this.state = "";
    this.load(args);
  }
}
decorate(CardStore, {
  last_four: observable,
  state: observable,
  expiration: observable
});
class PoiStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.tid = "";
    this.partial_approval_capable = "";
    this.cardholder_presence = "";
    this.card_presence = "";
    this.channel = "";
    this.processing_type = "";
    this.pin_present = "";
    this.load(args);
  }
  // computed
  get poiDetails() {
    return {
      TID: sentenceCase(this.tid),
      "Partial approval capable": this.formatPoiBooleanField(this.partial_approval_capable),
      "Cardholder presence": this.formatPoiBooleanField(this.cardholder_presence),
      "Card presence": this.formatPoiBooleanField(this.card_presence),
      Channel: sentenceCase(this.channel),
      "Processing type": sentenceCase(this.processing_type),
      "PIN present": this.formatPoiBooleanField(this.pin_present)
    };
  }
  get hasContent() {
    const presentDetails = Object.values(this.poiDetails).filter((d) => Boolean(d));
    return Boolean(presentDetails?.length);
  }
  // helpers
  formatPoiBooleanField(value) {
    try {
      if (isNotPresent(value)) {
        return null;
      }
      const stringBool = evaluateBoolean(value)?.toString();
      return sentenceCase(stringBool);
    } catch (err) {
      return value;
    }
  }
}
decorate(PoiStore, {
  // values
  tid: observable,
  partial_approval_capable: observable,
  cardholder_presence: observable,
  card_presence: observable,
  channel: observable,
  processing_type: observable,
  pin_present: observable,
  // computed
  poiDetails: computed,
  hasContent: computed,
  // helpers
  formatPoiBooleanField: action.bound
});
class CardAcceptorStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.name = "";
    this.poi = {};
    this.mcc = "";
    this.mcc_name = "";
    this.mcc_group_data = {};
    this.address = "";
    this.street_address = "";
    this.city = "";
    this.country = "";
    this.country_code = "";
    this.state = "";
    this.postal_code = "";
    this.zip = "";
    this.loadAndConstruct(args);
  }
  loadAndConstruct(args) {
    const {
      poi
    } = args || {};
    this.load(args);
    this.loadAndConstructItem("poi", poi, PoiStore);
  }
  get formattedMccList() {
    try {
      const {
        mcc_names
      } = this.mcc_group_data;
      const mccNameList = [this.mcc_name, ...mcc_names];
      const filteredList = mccNameList.filter((val, index) => {
        const only = mccNameList.indexOf(val) === index;
        return only && isPresent(val);
      });
      return filteredList.sort().join(", ");
    } catch (err) {
      return this.mcc_name;
    }
  }
  get hasMccs() {
    return Boolean(this.formattedMccList && this.formattedMccList.length);
  }
}
decorate(CardAcceptorStore, {
  // values
  name: observable,
  poi: observable,
  mcc: observable,
  mcc_name: observable,
  mcc_group_data: observable,
  address: observable,
  street_address: observable,
  city: observable,
  country: observable,
  country_code: observable,
  state: observable,
  postal_code: observable,
  zip: observable,
  // actions
  loadAndConstruct: action.bound,
  // computed
  formattedMccList: computed,
  hasMccs: computed
});
class PosStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.pan_entry_mode = "";
    this.pin_entry_mode = "";
    this.pin_present = "";
    this.terminal_id = "";
    this.terminal_attendance = "";
    this.terminal_location = "";
    this.card_holder_presence = "";
    this.cardholder_authentication_method = "";
    this.card_presence = "";
    this.terminal_type = "";
    this.card_data_input_capability = "";
    this.country_code = "";
    this.zip = "";
    this.partial_approval_capable = "";
    this.purchase_amount_only = "";
    this.is_recurring = "";
    this.is_installment = "";
    this.load(args);
  }
  // computed
  get posDetails() {
    return {
      "PAN entry mode": sentenceCase(this.pan_entry_mode),
      "PIN entry mode": sentenceCase(this.pin_entry_mode),
      "PIN present": sentenceCase(this.pin_present),
      "Terminal ID": sentenceCase(this.terminal_id),
      "Terminal attendance": sentenceCase(this.terminal_attendance),
      "Terminal location": sentenceCase(this.terminal_location),
      "Cardholder presence": this.formatPosBooleanField(this.card_holder_presence),
      "Cardholder authentication method": sentenceCase(this.cardholder_authentication_method),
      "Card presence": this.formatPosBooleanField(this.card_presence),
      "Terminal type": sentenceCase(this.terminal_type),
      "Card data input capability": sentenceCase(this.card_data_input_capability),
      "Country code": sentenceCase(this.country_code),
      Zip: sentenceCase(this.zip),
      "Partial approval capable": this.formatPosBooleanField(this.partial_approval_capable),
      "Purchase amount only": this.formatPosBooleanField(this.purchase_amount_only),
      "Is recurring": this.formatPosBooleanField(this.is_recurring),
      "Is installment": this.formatPosBooleanField(this.is_installment)
    };
  }
  get hasPosContent() {
    const presentDetails = Object.values(this.posDetails).filter((d) => isPresent(d));
    return Boolean(presentDetails?.length);
  }
  // helpers
  formatPosBooleanField(value) {
    try {
      if (isNotPresent(value)) {
        return null;
      }
      const stringBool = evaluateBoolean(value)?.toString();
      return sentenceCase(stringBool);
    } catch (err) {
      return value;
    }
  }
}
decorate(PosStore, {
  // values
  pan_entry_mode: observable,
  pin_entry_mode: observable,
  pin_present: observable,
  terminal_id: observable,
  terminal_attendance: observable,
  terminal_location: observable,
  card_holder_presence: observable,
  cardholder_authentication_method: observable,
  card_presence: observable,
  terminal_type: observable,
  card_data_input_capability: observable,
  country_code: observable,
  zip: observable,
  partial_approval_capable: observable,
  purchase_amount_only: observable,
  is_recurring: observable,
  is_installment: observable,
  // computed
  posDetails: computed,
  hasPosContent: computed,
  // helpers
  formatPosBooleanField: action.bound
});
const {
  fragments: fragments$2
} = gqlUtils;
const disputableTransactionTypes = TRANSACTION_TYPES.DISPUTABLE_TRANSACTION_TYPES;
const disputableStates = [TRANSACTION_STATES.CLEARED, TRANSACTION_STATES.COMPLETION];
class TransactionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.acquirer_fee_amount = "";
    this.acquirer = {};
    this.acting_cardholder_token = "";
    this.amount = "";
    this.approval_code = "";
    this.avs = "";
    this.business_token = "";
    this.business = {};
    this.card_acceptor = {};
    this.card_token = "";
    this.card = {};
    this.cardholder_token = "";
    this.cardholder_transaction_time = "";
    this.created_time = "";
    this.currency_code = "";
    this.duration = "";
    this.electronic_commerce_indicator = "";
    this.fee_transfer = "";
    this.incremental_authorization_transaction_tokens = "";
    this.issuerInterchangeAmount = "";
    this.network = "";
    this.offer_orders = "";
    this.peer_transfer = "";
    this.polarity = "";
    this.pos = {};
    this.preceding_related_transaction_token = "";
    this.program_transfer = "";
    this.real_time_fee_group = "";
    this.related_authorization = {};
    this.request_amount = "";
    this.rewards = "";
    this.settlement_date = "";
    this.skipAutoLoad = true;
    this.standin_approved_by = "";
    this.state = "";
    this.subnetwork = "";
    this.token = "";
    this.transaction_metadata = "";
    this.type = "";
    this.verification_result = "";
    this.verification_value_created_by = "";
    this.issuing_country = "";
    this.issuing_country_set = false;
    this.loadAndConstruct(args);
  }
  // actions
  async hydrate(token) {
    const result = await this.gqlQuery(`query transaction($token: ID!) {
        transaction(token: $token) {
          ...transactionBaseInfo
          business {
            business_name_dba
            business_name_legal
            token
          }
          direct_deposit {
            state
            token
          }
          card {
            expiration
            last_four
            state
          }
          related_authorization {
            ...transactionBaseInfo
          }
        }
      }
      ${fragments$2.transactionBaseInfo}`, {
      token,
      ...this.hydrateParams
    });
    runInAction(() => {
      if (result) {
        const transactionData = this.extract(result, "transaction");
        this.loadAndConstruct(transactionData);
        return true;
      } else {
        return false;
      }
    });
  }
  loadAndConstruct(args) {
    this.load(args);
    const loadIfKeysPresent = [{
      key: "card",
      store: CardStore
    }, {
      key: "card_acceptor",
      store: CardAcceptorStore
    }, {
      key: "business",
      store: BusinessStore
    }, {
      key: "related_authorization",
      store: TransactionStore
    }, {
      key: "pos",
      store: PosStore
    }];
    loadIfKeysPresent.forEach(({
      key,
      store
    }) => {
      const value = args[key];
      if (value)
        this.loadAndConstructItem(key, value, store);
    });
  }
  // This is split out into a different call than hydrate becuase this value requires multiple calls to resolve
  // and is only used for Visa 13.2. Dont want to slow down the rest of transaction store calls just for this.
  async hydrateIssuingCountry() {
    this.setAttr("issuing_country_set", true);
    if (!this.token) {
      console.log("this.token not set in TransactionStore so cannot run hydrateIssuerJurisdiction");
      this.setAttr("issuing_country", "Not set");
      return false;
    }
    this.setAttr("issuing_country", "loading");
    const result = await this.gqlQuery(`query transaction($token: ID!) {
        transaction(token: $token) {
          issuing_country
        }
      }`, {
      token: this.token
    });
    runInAction(() => {
      if (result) {
        const transactionData = this.extract(result, "transaction");
        this.load(transactionData);
        return true;
      } else {
        this.setAttr("issuing_country", "Not set");
        return false;
      }
    });
  }
  // computed
  get cardAcceptor() {
    return this.card_acceptor && this.card_acceptor.name;
  }
  get isDisputable() {
    return disputableStates.includes(this.state) && disputableTransactionTypes.includes(this.type);
  }
  get cardAcceptorType() {
    return this.dig(this.card_acceptor, "poi", "processing_type");
  }
  get formattedAmount() {
    try {
      if (isNotPresent(this.amount))
        return null;
      return Number.parseFloat(this.amount).toFixed(2);
    } catch (err) {
      return this.amount;
    }
  }
  get formattedAmountWithCurrency() {
    try {
      if (isNotPresent(this.amount))
        return null;
      return [this.formattedRequestAmount, this.currency_code].join(" ").trim();
    } catch (err) {
      return this.amount;
    }
  }
  get formattedRequestAmount() {
    try {
      if (isNotPresent(this.request_amount))
        return null;
      return Number.parseFloat(this.request_amount).toFixed(2);
    } catch (err) {
      return this.request_amount;
    }
  }
  get formattedRequestAmountWithCurrency() {
    try {
      if (isNotPresent(this.request_amount))
        return null;
      return [this.formattedRequestAmount, this.currency_code].join(" ").trim();
    } catch (err) {
      return this.request_amount;
    }
  }
  get clearingDetailsMap() {
    if (this.type === "authorization") {
      return /* @__PURE__ */ new Map();
    }
    return /* @__PURE__ */ new Map([["Authorization amount", dig(this.related_authorization, "formattedAmountWithCurrency")], ["Authorization date", dig(this.related_authorization, "formattedSettlementDate")], ["Authorization state", sentenceCase(dig(this.related_authorization, "state"))], ["Card last four digits", dig(this.card, "last_four")], ["Network/Subnetwork", this.formattedNetworks], ["Retrieval reference number", dig(this.acquirer, "retrieval_reference_number")], ["Settlement amount", this.formattedRequestAmountWithCurrency], ["Settlement date", /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { content: "Presented in UTC", children: this.settlement_date })], ["Transaction type", this.constructedBy?.dispute_details?.original_transaction_type || this.type]]);
  }
  get formattedNetworks() {
    const networks = [this.network, this.subnetwork];
    const filtered = networks.filter((n) => Boolean(n));
    return filtered.map(sentenceCase).join("/");
  }
  get formattedSettlementDate() {
    return convertDateFromUTCToLocal(this.settlement_date);
  }
  get transactionJurisdiction() {
    const transactionCountryCode = typeof this?.cardAcceptor?.country_code === "string" ? this?.cardAcceptor?.country_code.toUpperCase() : "";
    return EU_COUNTRY_CODES.includes(transactionCountryCode) ? "EU" : "Non-EU";
  }
  get issuerJurisdiction() {
    const issuingCountry = typeof this.issuing_country === "string" ? this.issuing_country.toUpperCase() : "";
    return EU_COUNTRY_CODES.includes(issuingCountry) ? "EU" : "Non-EU";
  }
  get euCardOutOfJurisdictionTransaction() {
    return this.issuerJurisdiction === "EU" && this.transactionJurisdiction === "Non-EU";
  }
}
decorate(TransactionStore, {
  // values
  acquirer_fee_amount: observable,
  acquirer: observable,
  acting_cardholder_token: observable,
  amount: observable,
  approval_code: observable,
  avs: observable,
  card_acceptor: observable,
  card_token: observable,
  card: observable,
  cardholder_token: observable,
  cardholder_transaction_time: observable,
  created_time: observable,
  currency_code: observable,
  duration: observable,
  electronic_commerce_indicator: observable,
  fee_transfer: observable,
  incremental_authorization_transaction_tokens: observable,
  issuerInterchangeAmount: observable,
  network: observable,
  offer_orders: observable,
  peer_transfer: observable,
  polarity: observable,
  pos: observable,
  preceding_related_transaction_token: observable,
  program_transfer: observable,
  real_time_fee_group: observable,
  related_authorization: observable,
  request_amount: observable,
  rewards: observable,
  settlement_date: observable,
  standin_approved_by: observable,
  state: observable,
  subnetwork: observable,
  token: observable,
  transaction_metadata: observable,
  type: observable,
  verification_result: observable,
  verification_value_created_by: observable,
  issuing_country: observable,
  issuing_country_set: observable,
  // actions
  loadAndConstruct: action.bound,
  hydrate: action.bound,
  hydrateIssuingCountry: action.bound,
  // computed
  cardAcceptor: computed,
  isDisputable: computed,
  cardAcceptorType: computed,
  formattedRequestAmount: computed,
  formattedRequestAmountWithCurrency: computed,
  clearingDetailsMap: computed,
  formattedNetworks: computed,
  formattedSettlementDate: computed,
  transactionJurisdiction: computed,
  issuerJurisdiction: computed,
  euCardOutOfJurisdictionTransaction: computed
});
const {
  templates: templates$6
} = gqlUtils;
const {
  setAlert = (err) => window.alert(err)
} = alertStore || {};
class DisputeDocumentsStore extends PaginationStore {
  constructor(args = {}) {
    super(args);
    this.case_token = "";
    this.items = [];
    this.count = 0;
    this.isVisa = false;
    this.loading = false;
    this.loadFullInfoResult(args);
  }
  // computed
  get tokens() {
    return this.items.map((item) => item.token);
  }
  get acceptedFileTypes() {
    if (this.constructedBy?.isMastercard) {
      return MASTERCARD_ACCEPTED_FILE_TYPES;
    }
    return VISA_ACCEPTED_FILE_TYPES;
  }
  get documentError() {
    return `Please ensure the file size is under ${maxFileSizeInMB}MB and
    ${this.acceptedDocumentTypes.length > 1 ? "is in one of the following file types:" : "file type is"} ${this.acceptedDocumentTypes.join(", ")}.`;
  }
  // Actions
  loadFullInfoResult(documentsData) {
    this.load(documentsData);
    const {
      count = 0,
      data = []
    } = documentsData || {};
    this.count = count;
    this.loadAndConstructList("items", data, DocumentStore);
  }
  async uploadDocument(uploadedFile) {
    const {
      dispute_details,
      type: disputeType
    } = this.constructedBy;
    const {
      dispute_reason: disputeReason
    } = dispute_details || EMPTY_OBJECT;
    const {
      type: fileType,
      size
    } = uploadedFile || EMPTY_OBJECT;
    const eventProperties = {
      disputeReason,
      disputeType,
      fileType,
      size
    };
    try {
      this.validateDocument(uploadedFile);
      this.loading = true;
      const uploadFile = await this.prepareFileToUpload(uploadedFile);
      const mutation = `${templates$6.uploadDisputeDocument}`;
      const payload = {
        file: uploadFile,
        case_token: this.case_token,
        document_category: this.isVisa ? "OTHERS" : "RECEIPT"
      };
      const response = await this.gqlMutation(mutation, payload, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "createCaseDocument");
      if (errors || !success) {
        throw errors;
      }
      if (success && success.document_name) {
        await this.hydrate();
        disputesSegmentTrackEvent(SINGLE_FILE_UPLOADED_EVENT, {
          ...eventProperties,
          errorStatus: false
        });
        return success.token;
      }
    } catch (err) {
      if (typeof err === "string") {
        this.showUploadError(err);
      } else {
        const formattedErrors = formatNetworkError(err);
        setAlert("Document upload failed.", {
          modalHeading: "Unable to upload file",
          apiMessage: formattedErrors,
          withSupportLink: true
        });
      }
      disputesSegmentTrackEvent(SINGLE_FILE_UPLOADED_EVENT, {
        ...eventProperties,
        errorStatus: true
      });
    } finally {
      this.loading = false;
    }
  }
  async getDocumentUrl(documentToken) {
    try {
      this.loading = true;
      const parameters = {
        caseToken: this.case_token,
        contentToken: documentToken
      };
      const result = await this.gqlQuery(`query caseDocumentDetail($caseToken: ID!, $contentToken: ID!) {
            caseDocumentDetail(case_token: $caseToken, content_token: $contentToken) {
              download_link
            }
          }
        `, parameters);
      if (result) {
        const {
          download_link
        } = this.extract(result, "caseDocumentDetail") || {};
        return download_link;
      }
    } catch (err) {
      setAlert("There was a problem with uploading the documents.");
    } finally {
      this.loading = false;
    }
  }
  async deleteDocument(document_token) {
    try {
      this.loading = true;
      const mutation = `${templates$6.deleteDisputeDocument}`;
      await this.gqlMutation(mutation, {
        document_token,
        case_token: this.case_token
      });
      await this.hydrate();
    } catch (err) {
      setAlert("There was a problem deleting the document.");
    } finally {
      this.loading = false;
    }
  }
  async updateDocument(params) {
    const modalHeading = "There was a problem updating the document.";
    try {
      this.loading = true;
      const mutation = `${templates$6.updateDisputeDocumentMutation}`;
      await this.gqlMutation(mutation, params);
      if (this.error) {
        setAlert(this.error, {
          modalHeading,
          buttonText: "Confirm"
        });
      } else {
        await this.hydrate();
      }
    } catch (err) {
      setAlert(modalHeading);
    } finally {
      this.loading = false;
    }
  }
  async hydrate() {
    try {
      const result = await this.gqlQuery(templates$6.disputeDocuments, {
        case_token: this.case_token
      });
      const response = this.dig(result, "data", "caseDocuments");
      this.loadFullInfoResult({
        ...response,
        case_token: this.case_token
      });
    } catch (err) {
      setAlert("There was a problem loading the documents.");
    }
  }
  editDocumentType(token, docCategory) {
    const document2 = this.items.find((item) => item.token === token);
    document2.updateDocCategory(docCategory);
  }
  // helpers
  showUploadError(message) {
    const errorMessage = `We were not able to upload the document. ${message ? message : this.documentError}`;
    setAlert(errorMessage);
  }
  showDocRetrievalError(message) {
    const errorMessage = `We were not able to retrieve the documents. ${message ? message : this.documentError}`;
    setAlert(errorMessage);
  }
  validateDocument(document2) {
    if (!document2)
      throw "Please select a file to continue.";
    const typesLength = this.acceptedFileTypes.length;
    const documentTypes = this.acceptedFileTypes.join(", ");
    const acceptedType = this.acceptedFileTypes.find((type) => document2.name.includes(type));
    if (!acceptedType) {
      throw formatDocumentError("type", `${typesLength > 1 ? "in one of the following file types:" : ""} ${documentTypes}`);
    }
    if (document2.size >= maxFileSize) {
      throw formatDocumentError("size", `under ${maxFileSizeInMB}MB`);
    }
    if (this.items.find((item) => item.document_name === document2.name)) {
      throw formatDocumentError("name", "not duplicated");
    }
  }
  async prepareFileToUpload(file) {
    const {
      name,
      type
    } = file;
    const base64File = await toBase64(file);
    return {
      filename: name,
      mimetype: type,
      file: base64File
    };
  }
  findMatchingTokensCount(tokens = []) {
    const filteredItems = this.items.filter((item) => tokens.includes(item.token));
    return filteredItems.length;
  }
  get attachedDocs() {
    return this.items.filter((item) => item.isAttached);
  }
  async retrieveCaseDocuments() {
    try {
      this.loading = true;
      const mutation = `${templates$6.retrieveCaseDocuments}`;
      const payload = {
        case_token: this.case_token
      };
      const response = await this.gqlMutation(mutation, payload, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "retrieveCaseDocuments");
      if (errors || !success) {
        throw errors;
      }
      if (success) {
        await this.hydrate();
        return success;
      }
    } catch (err) {
      if (typeof err === "string") {
        this.showDocRetrievalError(err);
      } else {
        const formattedErrors = formatNetworkError(err);
        setAlert("Document retrieval failed.", {
          modalHeading: "Unable to retrieve documents",
          apiMessage: formattedErrors,
          withSupportLink: true
        });
      }
    } finally {
      this.loading = false;
    }
  }
}
decorate(DisputeDocumentsStore, {
  // values
  case_token: observable,
  count: observable,
  items: observable,
  gqlClient: observable,
  isVisa: observable,
  // actions
  deleteDocument: action.bound,
  editDocumentType: action.bound,
  getDocumentUrl: action.bound,
  loadFullInfoResult: action.bound,
  updateDocument: action.bound,
  updateDocuments: action.bound,
  uploadDocument: action.bound,
  retrieveCaseDocuments: action.bound,
  // helpers
  showUploadError: action.bound,
  validateDocument: action.bound,
  findMatchingTokensCount: action.bound,
  // computed
  acceptedFileTypes: computed,
  documentError: computed,
  tokens: computed,
  attachedDocs: computed
});
class EventStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.category = "";
    this.created_by = "";
    this.event_date = "";
    this.name = "";
    this.created_time = "";
    this.load(args);
  }
}
decorate(EventStore, {
  category: observable,
  created_by: observable,
  event_date: observable,
  name: observable,
  created_time: observable
  //computed
});
class EventsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.items = [];
    this.count = 0;
    this.loading = false;
    this.loadFullInfoResult(args);
  }
  loadFullInfoResult(eventsData) {
    this.load(eventsData);
    const {
      count = 0,
      data = []
    } = eventsData || {};
    this.count = count;
    this.loadAndConstructList("items", data, EventStore);
  }
  get sortedEvents() {
    return this.items.sort((a, b) => a.created_time - b.created_time);
  }
  get isProvisionalCreditGranted() {
    return Boolean(this.sortedEvents.find((item) => item.name === EVENT_TYPES.PC_GRANTED_EVENT_NAME));
  }
}
decorate(EventsStore, {
  items: observable,
  count: observable,
  //computed
  isProvisionalCreditGranted: computed,
  sortedEvents: computed
});
class ChargebackStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.load(args);
  }
}
decorate(ChargebackStore, {
  token: observable,
  transaction_token: observable,
  amount: observable,
  reason_code: observable,
  state: observable,
  channel: observable,
  network: observable,
  network_case_id: observable,
  credit_user: observable,
  created_time: observable,
  last_modified_time: observable
});
class ChargeBackTransitionListStore extends ParentTableStore {
  constructor(args) {
    super(args);
    this.items = [];
    this.loadFullInfoResult(args);
  }
  // actions
  loadFullInfoResult(chargebackData) {
    this.load(chargebackData);
    const {
      count = 0,
      data = []
    } = chargebackData || EMPTY_OBJECT;
    this.count = count;
    this.loadAndConstructList("items", data, ChargebackStore);
  }
  // computed
  get lastTransitionState() {
    const sortedItems = this.items.sort((a, b) => {
      const dateA = new Date(a.created_time);
      const dateB = new Date(b.created_time);
      return dateA - dateB;
    });
    if (!sortedItems.length)
      return null;
    return sortedItems[sortedItems.length - 1].state;
  }
}
decorate(ChargeBackTransitionListStore, {
  // values
  items: observable,
  // actions
  loadFullInfoResult: action.bound,
  // computed
  lastTransitionState: computed
});
class MilestoneStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.case_token = "";
    this.category = "";
    this.sub_category = "";
    this.milestone = "";
    this.next_milestone_due_date = "";
    this.created_time = "";
    this.last_modified_time = "";
    this.load(args);
  }
  get creditType() {
    const {
      dispute_details
    } = this.constructedBy?.constructedBy || EMPTY_OBJECT;
    const {
      creditType
    } = dispute_details || EMPTY_OBJECT;
    return creditType;
  }
  get provisionalCreditBanner() {
    const days = this.amountOfDaysTillDueDate === 1 ? "day" : "days";
    if (this.dateIsExpired) {
      return `The ${this.daysToAct}-day time limit to grant ${this.creditType} credit has expired on ${formatDate(this.next_milestone_due_date)} and
      no ${this.creditType} credit has been issued yet. `;
    }
    if (this.todayIsDueDate) {
      return `The ${this.daysToAct}-day time limit to grant ${this.creditType} credit is due today. `;
    }
    return `You have ${this.amountOfDaysTillDueDate} ${days} left to issue a ${this.creditType} credit for this case. `;
  }
  get dateIsExpired() {
    const provisionalCreditDueDate = moment(this.next_milestone_due_date).local();
    const now = moment();
    return now.isAfter(provisionalCreditDueDate);
  }
  get amountOfDaysTillDueDate() {
    const today = moment().startOf("day");
    return moment(this.next_milestone_due_date).local().startOf("day").diff(today, "days");
  }
  get todayIsDueDate() {
    return moment(this.next_milestone_due_date).local().isSame(moment.now(), "day");
  }
  get daysToAct() {
    const {
      dispute_details
    } = this.constructedBy?.constructedBy || EMPTY_OBJECT;
    const {
      pc_grant_days_to_act
    } = dispute_details?.regulation_details || EMPTY_OBJECT;
    return pc_grant_days_to_act || 10;
  }
  get communicationDateBanner() {
    const remain = this.amountOfDaysTillDueDate === 1 ? "day remains" : "days remain";
    if (this.dateIsExpired) {
      return `The time frame to notify the cardholder expired on ${formatDate(this.next_milestone_due_date)}.
       Have you already notified the cardholder? `;
    }
    return `${this.amountOfDaysTillDueDate} ${remain} to notify the cardholder of the network decision. Have you already 
    notified the cardholder? `;
  }
}
decorate(MilestoneStore, {
  case_token: observable,
  category: observable,
  sub_category: observable,
  milestone: observable,
  next_milestone_due_date: observable,
  created_time: observable,
  last_modified_time: observable,
  //computed
  amountOfDaysTillDueDate: computed,
  creditType: computed,
  daysToAct: computed,
  communicationDateBanner: computed,
  provisionalCreditBanner: computed,
  dateIsExpired: computed
});
class MilestonesStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.items = [];
    this.count = 0;
    this.loading = false;
    this.loadFullInfoResult(args);
  }
  loadFullInfoResult(milestonesData) {
    this.load(milestonesData);
    const {
      count = 0,
      data = []
    } = milestonesData || {};
    this.count = count;
    this.loadAndConstructList("items", data, MilestoneStore);
  }
  get sortedMilestones() {
    return this.items.sort((a, b) => a.created_time - b.created_time);
  }
  get provisionalCreditMilestone() {
    const pcAlreadyGranted = this.sortedMilestones.find((item) => item.milestone === "PC_GRANTED");
    if (!pcAlreadyGranted) {
      return this.sortedMilestones.find((item) => item.milestone === "PENDING_PC_GRANTED");
    }
    return void 0;
  }
  get latestPCRegEMilestone() {
    return this.sortedMilestones.find((item) => item.category === "REG_E" && item.sub_category === "PROVISIONAL_CREDIT");
  }
  get caseLostCommunicationMilestone() {
    const cardholderComsAlreadySent = this.sortedMilestones.find((item) => item.milestone === "CASE_LOST_COMMS_SENT");
    if (!cardholderComsAlreadySent) {
      return this.sortedMilestones.find((item) => item.milestone === "CASE_LOST_PENDING_COMMS");
    }
    return void 0;
  }
  get provisionalCreditStatus() {
    return this.latestPCRegEMilestone?.milestone;
  }
}
decorate(MilestonesStore, {
  items: observable,
  count: observable,
  //computed
  caseLostCommunicationMilestone: computed,
  provisionalCreditMilestone: computed,
  sortedMilestones: computed,
  latestPCRegEMilestone: computed,
  provisionalCreditStatus: computed
});
class AmountObjectStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.value = "";
    this.currency = "";
    this.load(args);
  }
}
decorate(AmountObjectStore, {
  value: observable,
  currency: observable
});
class IssuerAcquirerContactInfoStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.contact_name = "";
    this.contact_phone = "";
    this.contact_other = "";
    this.contact_email = "";
    this.load(args);
  }
}
decorate(IssuerAcquirerContactInfoStore, {
  contact_name: observable,
  contact_phone: observable,
  contact_other: observable,
  contact_email: observable
});
class DeliveryAddressDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.address = "";
    this.address2 = "";
    this.city = "";
    this.state_region = "";
    this.postal_code = "";
    this.country = "";
    this.load(args);
  }
  get formatAddressTableProps() {
    return {
      columns: [{
        header: "Address",
        accessor: "address",
        key: "address"
      }, {
        header: "Address 2",
        accessor: "address2",
        key: "address2"
      }, {
        header: "City",
        accessor: "city",
        key: "city"
      }, {
        header: "State/Region",
        accessor: "state_region",
        key: "state_region"
      }, {
        header: "Postal code",
        accessor: "postal_code",
        key: "postal_code"
      }, {
        header: "Country",
        accessor: "country",
        key: "country"
      }],
      data: [{
        address: this.address,
        address2: this.address2,
        city: this.city,
        state_region: this.state_region,
        postal_code: this.postal_code,
        country: this.country
      }]
    };
  }
}
decorate(DeliveryAddressDetailsStore, {
  address: observable,
  address2: observable,
  city: observable,
  state_region: observable,
  postal_code: observable,
  country: observable,
  formatAddressTableProps: computed
});
class DisputedTransactionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.device_id_details = "";
    this.device_fingerprinting_details = "";
    this.device_type_details = "";
    this.ip_address_details = "";
    this.customer_account_login_id_details = "";
    this.delivery_address_details = {};
    this.loadData(args);
  }
  get formattedCustomerAccountLoginIdDetails() {
    const val = this.customer_account_login_id_details;
    return convertBoolValues(val);
  }
  get formatDisputedTransactionTableProps() {
    const {
      columns: columns2,
      data
    } = this.delivery_address_details.formatAddressTableProps;
    return {
      columns: [...DISPUTED_TRANSACTION_COLUMNS, ...columns2],
      data: [{
        device_id_details: this.device_id_details,
        device_fingerprinting_details: this.device_fingerprinting_details,
        device_type_details: this.device_type_details,
        ip_address_details: this.ip_address_details,
        customer_account_login_id_details: this.customer_account_login_id_details,
        ...data[0]
      }]
    };
  }
  loadData(data) {
    this.load(data);
    this.loadAndConstructItem("delivery_address_details", this.delivery_address_details, DeliveryAddressDetailsStore);
  }
}
decorate(DisputedTransactionStore, {
  device_id_details: observable,
  device_fingerprinting_details: observable,
  device_type_details: observable,
  ip_address_details: observable,
  delivery_address_details: observable,
  formattedCustomerAccountLoginIdDetails: computed,
  formatDisputedTransactionTableProps: computed
});
class UndisputedTransactionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.historical_tran_amount = "";
    this.historical_tran_date = "";
    this.historical_transaction_id = "";
    this.historical_ARN = "";
    this.rol_transaction_id = "";
    this.merchandise_or_services_desc = "";
    this.device_id_details = "";
    this.device_fingerprinting_details = "";
    this.device_type_details = "";
    this.ip_address_details = "";
    this.customer_account_login_id_details = "";
    this.delivery_address_details = new DeliveryAddressDetailsStore();
    this.loadData(args);
  }
  get formattedCustomerAccountLoginIdDetails() {
    const val = this.customer_account_login_id_details;
    return convertBoolValues(val);
  }
  loadData(data) {
    this.load(data);
    this.loadAndConstructItem("delivery_address_details", this.delivery_address_details, DeliveryAddressDetailsStore);
  }
  get formatUndisputedTransactionTableProps() {
    return {
      historical_tran_amount: this.historical_tran_amount,
      historical_tran_date: this.historical_tran_date,
      historical_transaction_id: this.historical_transaction_id,
      historical_ARN: this.historical_ARN,
      rol_transaction_id: this.rol_transaction_id,
      merchandise_or_services_desc: this.merchandise_or_services_desc,
      device_id_details: this.device_id_details,
      device_fingerprinting_details: this.device_fingerprinting_details,
      device_type_details: this.device_type_details,
      ip_address_details: this.ip_address_details,
      formattedCustomerAccountLoginIdDetails: this.formattedCustomerAccountLoginIdDetails
    };
  }
}
decorate(UndisputedTransactionStore, {
  historical_tran_amount: observable,
  historical_tran_date: observable,
  historical_transaction_id: observable,
  historical_ARN: observable,
  rol_transaction_id: observable,
  merchandise_or_services_desc: observable,
  device_id_details: observable,
  device_fingerprinting_details: observable,
  device_type_details: observable,
  ip_address_details: observable,
  delivery_address_details: observable,
  formattedCustomerAccountLoginIdDetails: computed,
  formatUndisputedTransactionTableProps: computed
});
class UndisputedTransactionsListStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.items = [];
    this.loadData(args);
  }
  loadData(data) {
    this.load(data);
    this.loadAndConstructList("items", data, UndisputedTransactionStore);
  }
  get formatUndisputedTransactionsTableProps() {
    const data = this.items.reduce((list, transaction) => {
      return [...list, {
        ...transaction.formatUndisputedTransactionTableProps,
        ...transaction.delivery_address_details
      }];
    }, []);
    return {
      data,
      columns: UNDISPUTED_TRANSACTION_COLUMNS
    };
  }
}
decorate(UndisputedTransactionsListStore, {
  items: observable,
  formatUndisputedTransactionsTableProps: computed
});
class NetworkStateDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.attached_contents = [];
    this.issuer_acquirer_contact_info = {};
    this.recall_ind = null;
    this.liability_not_accepted_fully = "";
    this.dispute_amount = {};
    this.dispute_amount_change_ind = "";
    this.initiate_pre_arb_reason = "";
    this.dispute_invalid_reason = "";
    this.not_listed_dispute_invalid_reason = "";
    this.requesting_member_bin = "";
    this.requestor_name = "";
    this.opposer_member_bin = "";
    this.opposer_name = "";
    this.case_filing_amount = {};
    this.comments = "";
    this.appeal_ind = null;
    this.filing_reason = "";
    this.exception_cpd = "";
    this.dispute_response = "";
    this.acceptance_amount = {};
    this.dispute_response_reason = "";
    this.pre_arb_response = "";
    this.comp_evidence_ip_address_ind = null;
    this.comp_evidence_email_address_ind = null;
    this.comp_evidence_physical_address_ind = null;
    this.comp_evidence_phone_number_ind = null;
    this.comp_evidence_cust_acc_login_id_ind = null;
    this.comp_evidence_device_id_fingerprinting_ind = null;
    this.merchandise_or_services = "";
    this.merchandise_or_services_desc = "";
    this.shipping_delivery_status = "";
    this.merchandise_or_services_provided_date = "";
    this.disputed_transaction = {};
    this.undisputed_transactions = [];
    this.reason_code = "";
    this.member_message_text = "";
    this.status = "";
    this.creation_date = "";
    this.source_amount = "";
    this.currency_conversion_assessment_cca_included = "";
    this.currency_conversion_assessment_cca_amount = "";
    this.document_indicator = "";
    this.chargeback_reference_number = "";
    this.reject_reason = "";
    this.case_filing_id = "";
    this.case_type = "";
    this.case_status = "";
    this.filling_ica = "";
    this.filed_against_ica = "";
    this.case_filing_status = "";
    this.merchant_name = "";
    this.loadData(args);
  }
  get formattedShippingDeliveryStatus() {
    return SHIPPING_DELIVERY_STATUS[this.shipping_delivery_status];
  }
  // actions
  loadData(data) {
    const {
      issuer_acquirer_contact_info,
      dispute_amount,
      case_filing_amount,
      acceptance_amount,
      disputed_transaction,
      undisputed_transactions
    } = data || {};
    this.load(data);
    this.loadAndConstructItem("issuer_acquirer_contact_info", issuer_acquirer_contact_info, IssuerAcquirerContactInfoStore);
    this.loadAndConstructItem("dispute_amount", dispute_amount, AmountObjectStore);
    this.loadAndConstructItem("case_filing_amount", case_filing_amount, AmountObjectStore);
    this.loadAndConstructItem("acceptance_amount", acceptance_amount, AmountObjectStore);
    this.loadAndConstructItem("disputed_transaction", disputed_transaction, DisputedTransactionStore);
    this.loadAndConstructItem("undisputed_transactions", undisputed_transactions, UndisputedTransactionsListStore);
  }
  get disputeAmount() {
    return this.dispute_amount.value;
  }
  get formattedIpAddress() {
    const val = this.comp_evidence_ip_address_ind;
    return convertBoolValues(val);
  }
  get formattedEmailAddress() {
    const val = this.comp_evidence_email_address_ind;
    return convertBoolValues(val);
  }
  get formattedPhysicalAddress() {
    const val = this.comp_evidence_physical_address_ind;
    return convertBoolValues(val);
  }
  get formattedPhoneNumber() {
    const val = this.comp_evidence_phone_number_ind;
    return convertBoolValues(val);
  }
  get formattedCustomerLogin() {
    const val = this.comp_evidence_cust_acc_login_id_ind;
    return convertBoolValues(val);
  }
  get formattedDeviceIdFingerprint() {
    const val = this.comp_evidence_device_id_fingerprinting_ind;
    return convertBoolValues(val);
  }
}
decorate(NetworkStateDetailsStore, {
  // values
  // GENERAL OR RE-USED
  attached_contents: observable,
  issuer_acquirer_contact_info: observable,
  recall_ind: observable,
  liability_not_accepted_fully: observable,
  dispute_amount: observable,
  // VISA PRE-ARB
  dispute_amount_change_ind: observable,
  initiate_pre_arb_reason: observable,
  dispute_invalid_reason: observable,
  not_listed_dispute_invalid_reason: observable,
  // VISA ARB
  requesting_member_bin: observable,
  requestor_name: observable,
  opposer_member_bin: observable,
  opposer_name: observable,
  case_filing_amount: observable,
  comments: observable,
  appeal_ind: observable,
  filing_reason: observable,
  // VISA REPRESENTMENT
  exception_cpd: observable,
  dispute_response: observable,
  acceptance_amount: observable,
  dispute_response_reason: observable,
  // VISA PRE-ARB RESPONSE
  pre_arb_response: observable,
  comp_evidence_ip_address_ind: observable,
  comp_evidence_email_address_ind: observable,
  comp_evidence_physical_address_ind: observable,
  comp_evidence_phone_number_ind: observable,
  comp_evidence_cust_acc_login_id_ind: observable,
  comp_evidence_device_id_fingerprinting_ind: observable,
  merchandise_or_services: observable,
  merchandise_or_services_desc: observable,
  shipping_delivery_status: observable,
  merchandise_or_services_provided_date: observable,
  disputed_transaction: observable,
  undisputed_transactions: observable,
  // MASTERCARD SECOND PRESENTMENT
  reason_code: observable,
  member_message_text: observable,
  status: observable,
  creation_date: observable,
  source_amount: observable,
  currency_conversion_assessment_cca_included: observable,
  currency_conversion_assessment_cca_amount: observable,
  document_indicator: observable,
  chargeback_reference_number: observable,
  reject_reason: observable,
  // MASTERCARD CASE FILING
  case_filing_id: observable,
  case_type: observable,
  case_status: observable,
  filling_ica: observable,
  filed_against_ica: observable,
  merchant_name: observable,
  case_filing_status: observable,
  // actions
  // computed
  disputeAmount: computed,
  formattedIpAddress: computed,
  formattedEmailAddress: computed,
  formattedPhysicalAddress: computed,
  formattedPhoneNumber: computed,
  formattedCustomerLogin: computed,
  formattedDeviceIdFingerprint: computed
});
class BaseDisputeTransitionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.attached_contents = [];
    this.load(args);
  }
  // actions
  addAttachedContent(contentToken) {
    if (isNotPresent(contentToken))
      return;
    if (!this.attached_contents.includes(contentToken)) {
      this.attached_contents.push(contentToken);
    }
  }
  removeAttachedContent(tokenToDelete) {
    if (isNotPresent(tokenToDelete))
      return;
    this.attached_contents = this.attached_contents.filter((token) => token !== tokenToDelete);
  }
  // helpers
  validatePayload(VALIDATION) {
    const requiredFields = Object.keys(VALIDATION);
    return requiredFields.reduce((acc, field) => {
      const {
        label,
        formatValidations
      } = VALIDATION[field];
      const [validator, formatError] = formatValidations || [];
      if (isNotPresent(this[field])) {
        acc[field] = `${label} is required.`;
      } else if (validator && !validator(this[field])) {
        acc[field] = formatError;
      }
      return acc;
    }, {});
  }
}
decorate(BaseDisputeTransitionStore, {
  // values
  attached_contents: observable,
  // actions
  addAttachedContent: action.bound,
  removeAttachedContent: action.bound,
  // helpers
  validatePayload: action.bound
});
class PrearbitrationDetailsStore extends BaseDisputeTransitionStore {
  constructor(args = {}) {
    super(args);
    this.amount = "";
    this.why_are_you_initiating_prearbitration = "";
    this.are_you_providing_new_information = null;
    this.summary_of_new_information = "";
    this.filed_against_ica = "";
    this.filing_ica = "";
    this.network_memo = "";
    this.merchant_name = "";
    this.comment = "";
    this.prearbitration_response_decision = "";
    this.why_are_you_not_accepting_liability = "";
    this.certify_that_you_have_contacted_cardholder_and_reviewed_the_compelling_evidence_with_them_and_cardholder_continues_dispute = null;
    this.explanation_of_why_cardholder_continues_dispute = "";
    this.certify_that_cardholder_name_and_address_provided_by_acquirer_does_not_match_issuer_records = null;
    this.explanation_of_why_you_are_continuing_the_dispute = "";
    this.attached_contents = [];
    this.load(args);
  }
}
decorate(PrearbitrationDetailsStore, {
  // values
  amount: observable,
  attached_contents: observable,
  why_are_you_initiating_prearbitration: observable,
  are_you_providing_new_information: observable,
  summary_of_new_information: observable,
  filed_against_ica: observable,
  filing_ica: observable,
  network_memo: observable,
  merchant_name: observable,
  comment: observable,
  prearbitration_response_decision: observable,
  why_are_you_not_accepting_liability: observable,
  certify_that_you_have_contacted_cardholder_and_reviewed_the_compelling_evidence_with_them_and_cardholder_continues_dispute: observable,
  explanation_of_why_cardholder_continues_dispute: observable,
  certify_that_cardholder_name_and_address_provided_by_acquirer_does_not_match_issuer_records: observable,
  explanation_of_why_you_are_continuing_the_dispute: observable
  // computed
});
class RepresentmentDetailsStore extends BaseDisputeTransitionStore {
  constructor(args = {}) {
    super(args);
    this.amount = "";
    this.attached_contents = [];
    this.load(args);
  }
}
decorate(RepresentmentDetailsStore, {
  // values
  amount: observable,
  attached_contents: observable
});
class PrearbitrationResponseDetailsStore extends BaseDisputeTransitionStore {
  constructor(args = {}) {
    super(args);
    this.amount = "";
    this.prearb_response_decision = PREARB_RESPONSE_DECISIONS.DECLINE;
    this.partial_acceptance_amount = null;
    this.why_are_you_not_accepting_liability = "";
    this.certify_that_cardholder_continues_dispute = null;
    this.explanation_cardholder_continues_dispute = "";
    this.certify_cardholder_details_dont_match_issuer_records = null;
    this.explanation_continuing_the_dispute = "";
    this.attached_contents = [];
    this.load(args);
  }
  get formattedCardholderContinuesDisputes() {
    const val = this.certify_that_cardholder_continues_dispute;
    return convertBoolValues(val);
  }
  get formattedCardholderDetailsDontMatch() {
    const val = this.certify_cardholder_details_dont_match_issuer_records;
    return convertBoolValues(val);
  }
  get formattedPreArbResponseDecision() {
    return PREARB_RESPONSE_DECISIONS_LABELS[this.prearb_response_decision];
  }
  get isDeclinedLiability() {
    return this.prearb_response_decision === PREARB_RESPONSE_DECISIONS.DECLINE;
  }
}
decorate(PrearbitrationResponseDetailsStore, {
  // values
  amount: observable,
  prearb_response_decision: observable,
  partial_acceptance_amount: observable,
  why_are_you_not_accepting_liability: observable,
  certify_that_cardholder_continues_dispute: observable,
  explanation_cardholder_continues_dispute: observable,
  certify_cardholder_details_dont_match_issuer_records: observable,
  explanation_continuing_the_dispute: observable,
  attached_contents: observable,
  //actions
  //computed
  formattedCardholderContinuesDisputes: computed,
  formattedCardholderDetailsDontMatch: computed,
  formattedPreArbResponseDecision: computed,
  isDeclinedLiability: computed
});
class NetworkDetailsStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.dispute_transition_token = "";
    this.arbitration_details = {};
    this.prearbitration_details = {};
    this.prearbitration_response_details = {};
    this.representment_details = {};
    this.network_state_details = {};
    this.network_attached_contents = [];
    this.dispute_state = "";
    this.loadData(args);
  }
  // actions
  loadData(data) {
    const {
      arbitration_details,
      prearbitration_details,
      representment_details,
      prearbitration_response_details,
      network_state_details,
      ...partialData
    } = data || {};
    this.load(partialData);
    this.loadAndConstructItem("arbitration_details", arbitration_details, PrearbitrationDetailsStore);
    this.loadAndConstructItem("prearbitration_details", prearbitration_details, PrearbitrationDetailsStore);
    this.loadAndConstructItem("representment_details", representment_details, RepresentmentDetailsStore);
    this.loadAndConstructItem("prearbitration_response_details", prearbitration_response_details, PrearbitrationResponseDetailsStore);
    this.loadAndConstructItem("network_state_details", network_state_details, NetworkStateDetailsStore);
  }
  // computed
  get aggregateAttachedContents() {
    let docTokens = [];
    if (this.arbitration_details?.attached_contents?.length) {
      docTokens = docTokens.concat(...this.arbitration_details.attached_contents);
    }
    if (this.prearbitration_details?.attached_contents?.length) {
      docTokens = docTokens.concat(...this.prearbitration_details.attached_contents);
    }
    if (this.prearbitration_response_details?.attached_contents?.length) {
      docTokens = docTokens.concat(...this.prearbitration_response_details.attached_contents);
    }
    if (this.representment_details?.attached_contents?.length) {
      docTokens = docTokens.concat(...this.representment_details.attached_contents);
    }
    if (this.network_state_details?.attached_contents?.length) {
      docTokens = docTokens.concat(...this.network_state_details.attached_contents);
    }
    if (this.network_attached_contents?.length) {
      docTokens = docTokens.concat(...this.network_attached_contents);
    }
    return docTokens;
  }
}
decorate(NetworkDetailsStore, {
  // values
  arbitration_details: observable,
  dispute_state: observable,
  dispute_transition_token: observable,
  network_state_details: observable,
  network_attached_contents: observable,
  prearbitration_details: observable,
  prearbitration_response_details: observable,
  representment_details: observable,
  // actions
  loadData: action.bound,
  // computed
  aggregateAttachedContents: computed
});
class NetworkDisputeTransitionStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.action = "";
    this.case_token = "";
    this.created_by = "";
    this.created_time = "";
    this.dispute_amount = "";
    this.disputeReason = "";
    this.disputeCurrencyCode = "";
    this.disputeType = DISPUTES.DISPUTE;
    this.from_network_status = "";
    this.isAllocationFlow = false;
    this.isRegE = false;
    this.memo = "";
    this.merchantName = "";
    this.network_details = {};
    this.network_dispute_id = "";
    this.network_error_message = "";
    this.network = "";
    this.otherAmount = "";
    this.system_error_message = "";
    this.to_network_status = "";
    this.fullDisputeAmountSelected = true;
    this.withWriteOff = false;
    this.skipAutoLoad = true;
    this.loadData(args);
    this.created_by = currentUserFromStorage();
  }
  // actions
  loadData(data) {
    const {
      network_details,
      ...partialData
    } = data || {};
    this.load(partialData);
    this.loadAndConstructItem("network_details", network_details, NetworkDetailsStore);
  }
  setAction(action2) {
    if (typeof action2 === "string") {
      this.action = action2;
      return;
    }
    this.action = null;
  }
  // Safely set a dispute (or descendent) attribute's value
  setDigDetails(attr, val) {
    if (typeof attr !== "string" || val === void 0)
      return null;
    if (this[attr] !== void 0) {
      return this[attr] = val;
    }
    if (dig(this.network_details, "prearbitration_response_details", attr) !== void 0) {
      return this.network_details.prearbitration_response_details[attr] = val;
    }
    if (dig(this.network_details, "prearbitration_details", attr) !== void 0) {
      return this.network_details.prearbitration_details[attr] = val;
    }
    if (dig(this.network_details, "representment_details", attr) !== void 0) {
      return this.network_details.representment_details[attr] = val;
    }
    if (dig(this.network_details, "arbitration_details", attr) !== void 0) {
      return this.network_details.arbitration_details[attr] = val;
    }
    if (dig(this.network_details, attr) !== void 0) {
      return this.network_details[attr] = val;
    }
    if (dig(this.network_details, "arbitration_details", attr) !== void 0) {
      return this.network_details.arbitration_details[attr] = val;
    }
    if (dig(this.network_details, attr) !== void 0) {
      return this.network_details[attr] = val;
    }
  }
  // helpers
  digDetails(attr) {
    if (typeof attr !== "string") {
      return null;
    }
    if (digIsPresent(this, attr)) {
      return this[attr];
    }
    if (digIsPresent(this.network_details, attr)) {
      return this.network_details[attr];
    }
    if (digIsPresent(this.network_details, "prearbitration_details", attr)) {
      return this.network_details.prearbitration_details[attr];
    }
    if (digIsPresent(this.network_details, "representment_details", attr)) {
      return this.network_details.representment_details[attr];
    }
    if (digIsPresent(this.network_details, "prearbitration_response_details", attr)) {
      return this.network_details.prearbitration_response_details[attr];
    }
    if (digIsPresent(this.network_details, "arbitration_details", attr)) {
      return this.network_details.arbitration_details[attr];
    }
    if (digIsPresent(this.network_details, "network_state_details", attr)) {
      return this.network_details.network_state_details[attr];
    }
    if (digIsPresent(this.network_details, "network_state_details", "disputed_transaction", attr)) {
      return this.network_details.network_state_details.disputed_transaction[attr];
    }
    if (digIsPresent(this.network_details, "network_state_details", "undisputed_transactions", attr)) {
      return this.network_details.network_state_details.undisputed_transactions[attr];
    }
  }
  // computed
  get attachedContents() {
    const attachedToForm = this.constructedBy?.constructedBy?.disputeFileManager?.attachedToForm;
    const tokenList = [...attachedToForm.values()].map(({
      token
    }) => token);
    const attached_contents = attachedToForm ? tokenList : [];
    return attached_contents;
  }
  // VALIDATIONS
  get mastercardPreArbValidation() {
    const fields = Object.keys(MASTERCARD_PREARB_VALIDATION);
    fields.forEach((field) => this.network_details?.prearbitration_details?.[field]);
    return this.network_details?.prearbitration_details?.validatePayload(MASTERCARD_PREARB_VALIDATION);
  }
  get visaPreArbRequestValidation() {
    const errors = {};
    const {
      why_are_you_initiating_prearbitration
    } = this.network_details?.prearbitration_details || {};
    if (!isPresent(why_are_you_initiating_prearbitration)) {
      errors.why_are_you_initiating_prearbitration = FIELD_IS_REQUIRED;
    }
    return errors;
  }
  get visaPreArbResponseValidation() {
    const errors = {};
    const {
      prearb_response_decision,
      why_are_you_not_accepting_liability,
      certify_that_cardholder_continues_dispute,
      explanation_cardholder_continues_dispute,
      certify_cardholder_details_dont_match_issuer_records,
      explanation_continuing_the_dispute
    } = this.network_details?.prearbitration_response_details || {};
    const reasonCode = disputeReasonNetworkMap[this.disputeReason]?.VISA || "";
    if (prearb_response_decision === PREARB_RESPONSE_DECISIONS.ACCEPT_PARTIAL_LIABILITY && isPresent(this.partialAmountValidation)) {
      errors.partial_acceptance_amount = this.partialAmountValidation;
    }
    if (!isPresent(why_are_you_not_accepting_liability)) {
      errors.why_are_you_not_accepting_liability = FIELD_IS_REQUIRED;
    }
    if (reasonCode.includes("10")) {
      if (!isPresent(certify_that_cardholder_continues_dispute)) {
        errors.certify_that_cardholder_continues_dispute = FIELD_IS_REQUIRED;
      }
      if (certify_that_cardholder_continues_dispute === true && !isPresent(explanation_cardholder_continues_dispute)) {
        errors.explanation_cardholder_continues_dispute = FIELD_IS_REQUIRED;
      }
      if (!isPresent(certify_cardholder_details_dont_match_issuer_records)) {
        errors.certify_cardholder_details_dont_match_issuer_records = FIELD_IS_REQUIRED;
      }
      if (certify_cardholder_details_dont_match_issuer_records === false && !isPresent(explanation_continuing_the_dispute)) {
        errors.explanation_continuing_the_dispute = FIELD_IS_REQUIRED;
      }
    }
    return errors;
  }
  // PAYLOADS (MASTERCARD)
  get mastercardPrearbPayload() {
    const {
      prearbitration_details
    } = this.network_details || {};
    const {
      amount,
      filed_against_ica,
      filing_ica,
      network_memo
    } = prearbitration_details || {};
    const attached_contents = this.attachedContents;
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
      ...this.basePayload,
      network_details: {
        prearbitration_details: {
          attached_contents,
          amount: amount?.toString(),
          filed_against_ica,
          filing_ica,
          network_memo,
          merchant_name: this.merchantName
        }
      }
    };
  }
  get mastercardArbPayload() {
    const attached_contents = this.attachedContents;
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB,
      ...this.basePayload,
      network_details: {
        arbitration_details: {
          attached_contents
        }
      }
    };
  }
  get pulsePrearbPayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
      ...this.basePayload
    };
  }
  get pulsePreArbResponsePayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
      ...this.basePayload
    };
  }
  get visaPrearbPayload() {
    const {
      prearbitration_details
    } = this.network_details || {};
    const {
      amount,
      why_are_you_initiating_prearbitration
    } = prearbitration_details || {};
    const attached_contents = this.attachedContents;
    const amountToSend = amount || this.dispute_amount;
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
      ...this.basePayload,
      network_details: {
        prearbitration_details: {
          attached_contents,
          amount: amountToSend?.toString(),
          why_are_you_initiating_prearbitration
        }
      }
    };
  }
  get visaPreArbResponsePayload() {
    const {
      prearbitration_response_details
    } = this.network_details || {};
    const {
      prearb_response_decision,
      partial_acceptance_amount,
      why_are_you_not_accepting_liability,
      certify_that_cardholder_continues_dispute,
      explanation_cardholder_continues_dispute,
      certify_cardholder_details_dont_match_issuer_records,
      explanation_continuing_the_dispute
    } = prearbitration_response_details || EMPTY_OBJECT;
    const amountToSend = prearb_response_decision === PREARB_RESPONSE_DECISIONS.ACCEPT_PARTIAL_LIABILITY ? partial_acceptance_amount : this.dispute_amount;
    const reasonCode = disputeReasonNetworkMap[this.disputeReason]?.VISA || "";
    const attached_contents = this.attachedContents;
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
      ...this.basePayload,
      network_details: {
        prearbitration_response_details: {
          attached_contents,
          prearb_response_decision,
          partial_acceptance_amount: Number(amountToSend),
          why_are_you_not_accepting_liability,
          ...reasonCode.includes("10") && {
            certify_that_cardholder_continues_dispute,
            explanation_cardholder_continues_dispute,
            certify_cardholder_details_dont_match_issuer_records,
            explanation_continuing_the_dispute
          }
        }
      }
    };
  }
  get arbitrationPayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB,
      ...this.basePayload
    };
  }
  get representmentPayload() {
    const attached_contents = this.attachedContents;
    const amount = this.otherAmount || this.dispute_amount;
    return {
      action: this.action,
      ...this.basePayload,
      network_details: {
        representment_details: {
          attached_contents,
          amount: Number(amount)
        }
      }
    };
  }
  get acceptAndClosePayload() {
    const acceptAndCloseBase = {
      action: DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE,
      ...this.basePayload
    };
    const regEPayload = {
      network_details: {
        case_close_details: {
          write_off: true,
          write_off_actor: "PROGRAM"
        }
      }
    };
    if (this.withWriteOff) {
      if (this.isRegE) {
        return {
          ...acceptAndCloseBase,
          ...regEPayload
        };
      }
      return {
        withWriteOff: this.withWriteOff,
        ...acceptAndCloseBase
      };
    }
    return acceptAndCloseBase;
  }
  get partialAmountValidation() {
    const {
      partial_acceptance_amount
    } = this.network_details.prearbitration_response_details || {};
    return amountValidation(partial_acceptance_amount, this.dispute_amount);
  }
  get prearbAmountValidation() {
    const {
      amount
    } = this.network_details.prearbitration_details || {};
    return amountValidation(amount, this.dispute_amount);
  }
  get closeWithCaseWonPayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON,
      ...this.basePayload
    };
  }
  get respondWithPrearbPayload() {
    const attached_contents = this.attachedContents;
    const amountToSend = this.otherAmount || this.dispute_amount;
    const amount = amountToSend?.toString();
    const amountObj = this.isAllocationFlow ? {
      amount
    } : {};
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB,
      ...this.basePayload,
      network_details: {
        prearbitration_details: {
          attached_contents,
          ...amountObj
        }
      }
    };
  }
  get respondWithPrearbResponsePayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE,
      ...this.basePayload,
      network_details: {
        prearbitration_response_details: {}
      }
    };
  }
  get closeWithNetworkRejectedPayload() {
    return {
      action: DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_NETWORK_REJECTED,
      ...this.basePayload
    };
  }
  get basePayload() {
    return {
      created_by: this.created_by,
      memo: this.memo
    };
  }
  // RENDER FORMATTING
  get relatedTransitionFields() {
    return MASTERCARD_DETAILS_MAP.get(this.action);
  }
  get mastercardTransitionDetails() {
    if (!this.action || !this.relatedTransitionFields) {
      return [];
    }
    return this.relatedTransitionFields?.reduce((acc, field) => {
      let value = this.digDetails(field);
      if (field === "amount") {
        value = formatMoneyAmount(value);
      }
      if (isPresent(value)) {
        const label = MASTERCARD_LABELS_MAP.get(field) || sentenceCase(field);
        const fieldData = /* @__PURE__ */ new Map([["label", label], ["value", value]]);
        acc.push(fieldData);
      }
      return acc;
    }, []);
  }
  get pulseTransitionDetails() {
    const details = new Map(PULSE_DETAILS_MAP_KEYS).get(this.action);
    if (!this.action || !details) {
      return [];
    }
    return details.reduce((acc, field) => {
      let value = this.digDetails(field);
      if (isPresent(value)) {
        const label = PULSE_LABELS_MAP.get(field) || sentenceCase(field);
        const fieldData = /* @__PURE__ */ new Map([["label", label], ["value", value]]);
        acc.push(fieldData);
      }
      return acc;
    }, []);
  }
  get visaTransitionDetails() {
    const visaFlowKeys = this.isAllocationFlow ? VISA_ALLOCATION_KEYS : VISA_COLLABORATION_KEYS;
    const details = new Map(visaFlowKeys).get(this.action);
    if (!this.action || !details) {
      return [];
    }
    const {
      isDeclinedLiability
    } = this.network_details?.prearbitration_response_details || EMPTY_OBJECT;
    return details.reduce((acc, field) => {
      let value = this.digDetails(field);
      if (isPresent(value)) {
        if (field === "partial_acceptance_amount" || field === "disputeAmount") {
          value = formatMoneyAmount(value);
        }
        const isPartialAcceptanceAmount = isDeclinedLiability && field === "partial_acceptance_amount";
        const label = isPartialAcceptanceAmount ? VISA_LABELS_MAP.get("partial_acceptance_amount_decline") : VISA_LABELS_MAP.get(field) || sentenceCase(field);
        const fieldData = /* @__PURE__ */ new Map([["label", label], ["value", value]]);
        acc.push(fieldData);
      }
      return acc;
    }, []);
  }
  get networkTransitionDetails() {
    if (this.network === "VISA") {
      return this.visaTransitionDetails;
    } else if (this.network === "MASTERCARD") {
      return this.mastercardTransitionDetails;
    } else if (this.network === "PULSE") {
      return this.pulseTransitionDetails;
    } else {
      return [];
    }
  }
  get transitionDetailsForRender() {
    const {
      aggregateAttachedContents
    } = this.network_details || {};
    const details = this.disputeType === DISPUTES.LEGACY_DISPUTE ? [this.memo] : this.networkTransitionDetails;
    const transitionFieldName = NETWORK_DETAILS_FIELD_BY_ACTION[this.action];
    const amount = this.disputeType === DISPUTES.LEGACY_DISPUTE ? this.network_details[transitionFieldName]?.amount : "";
    return {
      header: this.transitionHeader,
      details,
      amount,
      aggregateAttachedContents,
      hasSectionContent: this.hasSectionContent,
      disputeReason: this.disputeReason
    };
  }
  get participantName() {
    const issuerActions = this.disputeType === DISPUTES.DISPUTE ? ISSUER_ACTIONS_BY_NETWORK[this.disputeType][this.network] : ISSUER_ACTIONS_BY_NETWORK[this.disputeType];
    const isCreatedByIssuer = issuerActions?.includes(this.action);
    const activeProgram = disputeStorage?.getActiveProgram();
    const programName = safeParse(activeProgram)?.program || "Marqeta program";
    return isCreatedByIssuer ? programName : this.merchantName;
  }
  //TODO: private
  get transitionHeader() {
    const label = this.disputeType === DISPUTES.DISPUTE ? dig(TRANSITION_LABELS, this.disputeType, this.network, this.action) : dig(TRANSITION_LABELS, this.disputeType, this.action);
    const formattedLabel = sentenceCase(label);
    const formattedTime = formatUTCMoment(this.created_time);
    return {
      formattedLabel,
      formattedTime,
      key: [formattedLabel, this.created_time].join("_"),
      participantName: this.participantName
    };
  }
  get hasSectionContent() {
    const {
      aggregateAttachedContents
    } = this.network_details || {};
    const hasDocuments = Boolean(aggregateAttachedContents?.length);
    const hasDetails = objectHasPresentValues(this.networkTransitionDetails);
    return hasDocuments || hasDetails;
  }
  get otherLegacyAmountValidation() {
    return amountValidation(this.otherAmount, this.dispute_amount);
  }
}
decorate(NetworkDisputeTransitionStore, {
  // values
  action: observable,
  case_token: observable,
  created_by: observable,
  created_time: observable,
  dispute_amount: observable,
  disputeReason: observable,
  disputeCurrencyCode: observable,
  disputeType: observable,
  from_network_status: observable,
  memo: observable,
  merchantName: observable,
  network_details: observable,
  network_dispute_id: observable,
  network_error_message: observable,
  network: observable,
  otherAmount: observable,
  skipAutoLoad: observable,
  system_error_message: observable,
  to_network_status: observable,
  fullDisputeAmountSelected: observable,
  withWriteOff: observable,
  isAllocationFlow: observable,
  isRegE: observable,
  // actions
  loadData: action.bound,
  setAction: action.bound,
  setDigDetails: action.bound,
  // helpers
  digDetails: action.bound,
  // computed
  acceptAndClosePayload: computed,
  arbitrationPayload: computed,
  attachedContents: computed,
  basePayload: computed,
  closeWithCaseWonPayload: computed,
  hasSectionContent: computed,
  representmentPayload: computed,
  respondWithPrearbPayload: computed,
  mastercardArbPayload: computed,
  mastercardPrearbPayload: computed,
  mastercardPreArbValidation: computed,
  mastercardTransitionDetails: computed,
  networkTransitionDetails: computed,
  otherLegacyAmountValidation: computed,
  visaTransitionDetails: computed,
  visaPreArbRequestValidation: computed,
  visaPreArbResponseValidation: computed,
  visaPrearbPayload: computed,
  visaPreArbResponsePayload: computed,
  pulsePrearbPayload: computed,
  pulsePreArbResponsePayload: computed,
  prearbAmountValidation: computed,
  partialAmountValidation: computed,
  participantName: computed,
  relatedTransitionFields: computed,
  respondWithPrearbResponsePayload: computed,
  transitionDetailsForRender: computed,
  transitionHeader: computed
});
const {
  templates: templates$5
} = gqlUtils;
class NetworkDisputeTransitionListStore extends ParentTableStore {
  constructor(args = {}) {
    super(args);
    this.allowableActions = [];
    this.case_token = "";
    this.dispute_amount = "";
    this.dispute_reason = "";
    this.disputeCurrencyCode = "";
    this.isAllocationFlow = false;
    this.isPulseAllocationFlow = false;
    this.isLegacyDisputeType = false;
    this.isRegE = false;
    this.merchantName = "";
    this.network = "";
    this.newDisputeTransitionStore = new NetworkDisputeTransitionStore();
    this.type = "";
    this.showAndLogAlert = () => {
    };
    this.handleSuccess = () => {
    };
    this.hydrate = () => {
    };
    this.loadData(args);
    this.newDisputeTransitionStore.constructedBy = this;
  }
  // actions
  loadData(initialState) {
    const {
      data = [],
      disputeCurrencyCode,
      merchantName,
      network,
      type,
      isLegacyDisputeType,
      isRegE,
      dispute_reason,
      isAllocationFlow
    } = initialState || {};
    const enhancedData = data.map((obj) => ({
      ...obj,
      merchantName,
      network,
      disputeType: type,
      disputeReason: dispute_reason,
      isAllocationFlow
    }));
    this.load(initialState);
    this.loadAndConstructList("items", enhancedData, NetworkDisputeTransitionStore);
    this.newDisputeTransitionStore = new NetworkDisputeTransitionStore({
      disputeCurrencyCode,
      disputeType: type,
      merchantName,
      network: this.network,
      dispute_amount: this.dispute_amount,
      type: this.type,
      isAllocationFlow: this.isAllocationFlow,
      isLegacyDisputeType,
      isRegE: isRegE || this.isRegE,
      disputeReason: dispute_reason
    });
  }
  // State transition functions
  async createDisputeTransition() {
    let success = false;
    let data = null;
    const {
      eventProperties,
      eventName
    } = this.currentEventInfo;
    const {
      clearAttachedContents
    } = this.constructedBy?.disputeFileManager || EMPTY_OBJECT;
    try {
      if (this.isInvalid) {
        const missing = Object.keys(this.formValidation);
        console.error(`Form is invalid. Required: ${missing.join(", ")}.`);
        return;
      }
      this.loading = true;
      const mutation = templates$5.createDisputeTransitionMutation;
      const payload = {
        case_token: this.case_token,
        ...this.currentPayload
      };
      const response = await this.gqlMutation(mutation, payload, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      data = this.dig(response, "data", "createDisputeTransition");
      success = this.handleTransitionResponse(data, errors, payload);
      clearAttachedContents();
    } catch (err) {
      this.handleError(err);
      success = false;
    } finally {
      disputesSegmentTrackEvent(eventName, {
        ...eventProperties,
        errorStatus: !success
      });
      data && this.hydrate && this.hydrate();
      this.loading = false;
      return success;
    }
  }
  handleError(err) {
    const message = "There was an issue transitioning the dispute.";
    const apiMessage = err instanceof Array ? err[0]?.message : err?.message;
    if (this.showAndLogAlert) {
      this.showAndLogAlert(message, {
        apiMessage,
        logMessage: `${err} (dispute_transitions)`,
        withSupportLink: true
      });
    } else {
      console.error(apiMessage || message);
    }
  }
  // The API currently returns a 2xx status code even if the network rejects the request.
  // Check for the presence of network_error_message in the response to see if it failed.
  handleTransitionResponse(data, errors, payload) {
    const networkError = data?.network_error_message;
    const systemError = data?.system_error_message;
    if (errors || !data) {
      this.handleError(errors);
      return false;
    } else if (isPresent(networkError)) {
      this.handleError({
        message: networkError
      });
      return false;
    } else if (isPresent(systemError)) {
      this.handleError({
        message: systemError
      });
      return false;
    } else {
      this.handleTransitionSuccess(data, payload);
      return true;
    }
  }
  handleTransitionSuccess(data, payload) {
    const defaultMessage = "Dispute transition submitted";
    const action2 = data ? data.action : payload.action;
    const actionSubmittedLabel = ACTION_SUBMITTED_LABEL_MAP[this.type][action2];
    this.handleSuccess(actionSubmittedLabel || defaultMessage);
  }
  // computed
  // eslint-disable-next-line getter-return
  get currentPayload() {
    const {
      action: action2
    } = this.newDisputeTransitionStore || {};
    if (this.type === DISPUTES.LEGACY_DISPUTE) {
      return this.legacyTransitionAction;
    }
    if (action2 && this.network) {
      return dig(this.payloadByNetworkAndAction, this.network, action2);
    }
  }
  get currentEventInfo() {
    const {
      action: action2,
      network_details
    } = this.newDisputeTransitionStore || EMPTY_OBJECT;
    const {
      aggregateAttachedContents
    } = network_details || EMPTY_OBJECT;
    const numberOfDocumentsAttached = aggregateAttachedContents?.length;
    const baseEventProperties = {
      transitionAction: action2
    };
    const eventPropertiesByAction = {
      [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED]: {
        ...baseEventProperties,
        ...numberOfDocumentsAttached && {
          numberOfDocumentsAttached
        }
      },
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB]: {
        ...baseEventProperties,
        ...numberOfDocumentsAttached && {
          numberOfDocumentsAttached
        }
      },
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]: baseEventProperties,
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB]: baseEventProperties,
      [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: baseEventProperties,
      [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]: baseEventProperties,
      [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_NETWORK_REJECTED]: baseEventProperties
    };
    return {
      eventProperties: eventPropertiesByAction[action2],
      eventName: DISPUTE_TRANSITION_EVENTS[action2]
    };
  }
  //TODO: private
  get legacyTransitionAction() {
    const {
      acceptAndClosePayload,
      action: action2,
      arbitrationPayload,
      closeWithCaseWonPayload,
      closeWithNetworkRejectedPayload,
      representmentPayload,
      respondWithPrearbPayload,
      respondWithPrearbResponsePayload
    } = this.newDisputeTransitionStore;
    const computedPayload = {
      [DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE]: acceptAndClosePayload,
      [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_CASE_WON]: closeWithCaseWonPayload,
      [DISPUTE_TRANSITION_ACTIONS.CLOSE_WITH_NETWORK_REJECTED]: closeWithNetworkRejectedPayload,
      [DISPUTE_TRANSITION_ACTIONS.REPRESENTMENT_RECEIVED]: representmentPayload,
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB]: respondWithPrearbPayload,
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_PREARB_RESPONSE]: respondWithPrearbResponsePayload,
      [DISPUTE_TRANSITION_ACTIONS.RESPOND_WITH_ARB]: arbitrationPayload
    };
    if (!action2) {
      throw new Error("No action field in request");
    }
    if (!computedPayload[action2]) {
      throw new Error("No payload for the request");
    }
    return computedPayload[action2];
  }
  get payloadByNetworkAndAction() {
    const {
      acceptAndClosePayload,
      closeWithCaseWonPayload,
      mastercardPrearbPayload,
      mastercardArbPayload,
      visaPrearbPayload,
      visaPreArbResponsePayload,
      pulsePrearbPayload,
      pulsePreArbResponsePayload
    } = this.newDisputeTransitionStore;
    return {
      MASTERCARD: {
        ACCEPT_AND_CLOSE: acceptAndClosePayload,
        CLOSE_WITH_CASE_WON: closeWithCaseWonPayload,
        RESPOND_WITH_PREARB: mastercardPrearbPayload,
        RESPOND_WITH_ARB: mastercardArbPayload
      },
      VISA: {
        RESPOND_WITH_PREARB: visaPrearbPayload,
        RESPOND_WITH_PREARB_RESPONSE: visaPreArbResponsePayload,
        ACCEPT_AND_CLOSE: acceptAndClosePayload,
        CLOSE_WITH_CASE_WON: closeWithCaseWonPayload
      },
      PULSE: {
        RESPOND_WITH_PREARB: pulsePrearbPayload,
        RESPOND_WITH_PREARB_RESPONSE: pulsePreArbResponsePayload,
        ACCEPT_AND_CLOSE: acceptAndClosePayload,
        CLOSE_WITH_CASE_WON: closeWithCaseWonPayload
      }
    };
  }
  get nextLegacyTransitionAction() {
    if (this.previousAction === LAST_TRANSITION_ACTION) {
      return "";
    }
    const ACTIONS_SEQUENCE = this.network == "VISA" && this.isAllocationFlow || this.network == "PULSE" && this.isPulseAllocationFlow ? LEGACY_DISPUTE_TRANSITION_SEQUENCE_FOR_ALLOCATION : LEGACY_DISPUTE_TRANSITION_SEQUENCE;
    return ACTIONS_SEQUENCE[this.previousAction] ?? ACTIONS_SEQUENCE.DEFAULT;
  }
  get shouldShowAmountField() {
    return this.nextLegacyTransitionAction === REPRESENTMENT_RECEIVED || this.nextLegacyTransitionAction === RESPOND_WITH_PREARB && this.isAllocationFlow;
  }
  get formValidation() {
    const {
      action: action2
    } = this.newDisputeTransitionStore || {};
    return dig(this.validationByNetworkAndAction, this.network, action2);
  }
  get isInvalid() {
    return Boolean(this.formValidation && Object.keys(this.formValidation).length);
  }
  get validationByNetworkAndAction() {
    const {
      mastercardPreArbValidation,
      visaPreArbValidation,
      visaPreArbResponseValidation
    } = this.newDisputeTransitionStore;
    if (this.isLegacyDisputeType) {
      return {};
    }
    return {
      MASTERCARD: {
        ACCEPT_AND_CLOSE: {},
        CLOSE_WITH_CASE_WON: {},
        RESPOND_WITH_PREARB: mastercardPreArbValidation,
        RESPOND_WITH_ARB: {}
      },
      VISA: {
        RESPOND_WITH_PREARB: visaPreArbValidation,
        RESPOND_WITH_PREARB_RESPONSE: visaPreArbResponseValidation
      }
    };
  }
  get itemsWithIgnoredActions() {
    return this.items?.filter((item) => isPresent(item.action) && isNotPresent(item.network_error_message));
  }
  get nonIgnoredItems() {
    return this.itemsWithIgnoredActions?.filter((item) => !IGNORED_ACTIONS.includes(item.action));
  }
  get itemsForRender() {
    return this.nonIgnoredItems?.map((item) => item.transitionDetailsForRender);
  }
  get previousAction() {
    if (!Array.isArray(this.itemsWithIgnoredActions)) {
      return void 0;
    }
    const lastTransition = this.itemsWithIgnoredActions?.[this.itemsWithIgnoredActions?.length - 1];
    return lastTransition?.action;
  }
  get actionIsRequired() {
    if (!this.hasPresentableTransitions || this.type || this.network) {
      return null;
    }
    const issuerActions = this.type === DISPUTES.DISPUTE ? ISSUER_ACTIONS_BY_NETWORK[this.type][this.network] : ISSUER_ACTIONS_BY_NETWORK[this.type];
    const allowableList = Array.from(this.allowableActions);
    if (Array.isArray(allowableList) && Array.isArray(issuerActions)) {
      return allowableList.some((action2) => issuerActions?.includes(action2));
    }
    return false;
  }
  get isActionable() {
    const networkActions = NETWORK_FORM_ACTIONS[this.network] || [];
    const allNetworkActions = [...networkActions, DISPUTE_TRANSITION_ACTIONS.ACCEPT_AND_CLOSE];
    return allNetworkActions?.some((action2) => this.allowableActions.includes(action2));
  }
  get hasPresentableTransitions() {
    return Boolean(this.nonIgnoredItems.length);
  }
  get previousActionLabel() {
    const initiatedLabel = "Dispute submitted";
    const label = dig(ACTION_SUBMITTED_LABEL_MAP, this.type, this.previousAction);
    if (!label && this.items.length) {
      return initiatedLabel;
    }
    return label;
  }
  get previousActionWarning() {
    return ACTION_SUBMITTED_WARNING_MAP[this.previousAction];
  }
}
decorate(NetworkDisputeTransitionListStore, {
  // values
  allowableActions: observable,
  case_token: observable,
  disputeCurrencyCode: observable,
  dispute_amount: observable,
  dispute_reason: observable,
  loading: observable,
  merchantName: observable,
  network: observable,
  newDisputeTransitionStore: observable,
  type: observable,
  isLegacyDisputeType: observable,
  isRegE: observable,
  isAllocationFlow: observable,
  // actions
  loadData: action.bound,
  createDisputeTransition: action.bound,
  hydrate: action.bound,
  showAndLogAlert: action.bound,
  handleSuccess: action.bound,
  handleTransitionResponse: action.bound,
  handleTransitionSuccess: action.bound,
  handleError: action.bound,
  // computed
  actionIsRequired: computed,
  currentEventInfo: computed,
  currentPayload: computed,
  legacyTransitionAction: computed,
  formValidation: computed,
  hasPresentableTransitions: computed,
  isActionable: computed,
  isInvalid: computed,
  itemsForRender: computed,
  itemsWithIgnoredActions: computed,
  nextLegacyTransitionAction: computed,
  nonIgnoredItems: computed,
  payloadByNetworkAndAction: computed,
  previousAction: computed,
  previousActionLabel: computed,
  previousActionWarning: computed,
  shouldShowAmountField: computed,
  validationByNetworkAndAction: computed
});
class FilterConstraintStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.category = "";
    this.values = {};
    this.load(args);
  }
}
decorate(FilterConstraintStore, {
  category: observable,
  values: observable
  //computed
});
class TemplateCriteriaStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.dispute_reason = "";
    this.country_code = "";
    this.load(args);
  }
}
decorate(TemplateCriteriaStore, {
  dispute_reason: observable,
  country_code: observable
  //computed
});
class ProgramConfigStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.type = "";
    this.enabled = false;
    this.filter_constraint = new FilterConstraintStore();
    this.template_criteria = new TemplateCriteriaStore();
    this.loadData(args);
  }
  // actions
  loadData(args) {
    const {
      filter_constraint,
      template_criteria
    } = args || EMPTY_OBJECT;
    this.loadAndConstructItem("filter_constraint", filter_constraint, FilterConstraintStore);
    this.loadAndConstructItem("template_criteria", template_criteria, TemplateCriteriaStore);
  }
}
decorate(ProgramConfigStore, {
  // values
  type: observable,
  enabled: observable,
  filter_constraint: observable,
  template_criteria: observable,
  // actions
  loadData: action.bound
});
const {
  templates: templates$4
} = gqlUtils;
class ProgramConfigsListStore extends ParentTableStore {
  constructor(args = {}) {
    super(args);
    this.count = 50;
    this.items = [];
    this.activeProgramShortCode = "";
    this.loadData(args);
  }
  // actions
  loadData(args) {
    const {
      data
    } = args || EMPTY_OBJECT;
    this.loadAndConstructList("items", data, ProgramConfigStore);
  }
  async hydrate(activeProgramShortCode = "") {
    const HYDRATE_COUNT = 200;
    const params = {
      count: HYDRATE_COUNT
    };
    if (this.activeProgramShortCode === activeProgramShortCode) {
      return;
    }
    try {
      this.activeProgramShortCode = activeProgramShortCode;
      const result = await this.gqlQuery(templates$4.caseProgramConfigsQuery, params);
      runInAction(() => {
        const items = this.extract(result, "caseProgramConfigs");
        this.processPaginationResponse(items, ProgramConfigStore);
      });
    } catch (err) {
      this.activeProgramShortCode = "";
      console.error(`ERROR (CaseProgramConfigs): ${err}`);
    }
  }
  // computed
  get enabledRegEItems() {
    return this.items.filter((item) => Boolean(item.enabled && item.type === "REG_E"));
  }
  get isWriteOfV2FlagEnabled() {
    return this.items.some((item) => {
      if (item.type === "UN_REGULATED") {
        const {
          on_board_date
        } = item.template_values;
        const flagEnabledDate = moment(on_board_date, "MM/DD/YYYY");
        return item.enabled && moment().utc() > flagEnabledDate;
      }
      return false;
    });
  }
}
decorate(ProgramConfigsListStore, {
  // values
  items: observable,
  activeProgramShortCode: observable,
  // actions
  hydrate: action.bound,
  loadData: action.bound,
  // computed
  enabledRegEItems: computed,
  isWriteOfV2FlagEnabled: computed
});
class ATRStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.network_type = "";
    this.token = "";
    this.case_token = "";
    this.transaction_date = "";
    this.transaction_amount = "";
    this.transaction_currency = "";
    this.transaction_currency_alpha = "";
    this.merchant_name = "";
    this.network_associated_transaction_group_id = "";
    this.transaction_type = "";
    this.transaction_id = "";
    this.auth_code = "";
    this.arn = "";
    this.retrieval_reference_number = "";
    this.matching_pass = "";
    this.matching_score = "";
    this.network_submission_status = "";
    this.network_reject_reason = "";
    this.first_network_submission_time = "";
    this.last_network_submission_time = "";
    this.network_selection_form = {};
    this.created_time = "";
    this.last_modified_time = "";
    this.network_submission_failure_reason = "";
    this.associated = false;
    this.selected = false;
    this.toggleSelected = () => {
      this.selected = !this.selected;
    };
    this.load({
      ...args,
      selected: Boolean(args.associated)
    });
  }
  // computed
  get formattedTransactionDate() {
    return formatUTCMoment(this.transaction_date, {
      showTime: false
    });
  }
  get isCustomTransaction() {
    return this.transaction_type === "0100";
  }
  get formattedTransactionType() {
    try {
      const transactionDescription = atrTransactionTypeMap[this.transaction_type];
      if (transactionDescription)
        return transactionDescription;
      const customType = atrTransactionCustomTypeMap.find(([regexp]) => this.transaction_type.search(regexp) >= 0) || [this.transaction_type];
      return customType[1];
    } catch (err) {
      return this.transaction_type;
    }
  }
  get formattedAmount() {
    try {
      if (isNotPresent(this.transaction_amount))
        return null;
      return Number.parseFloat(this.transaction_amount).toFixed(2);
    } catch (err) {
      return this.transaction_amount;
    }
  }
  get formattedAmountWithCurrency() {
    try {
      if (isNotPresent(this.transaction_amount))
        return null;
      return [this.formattedAmount, this.transaction_currency_alpha].join(" ").trim();
    } catch (err) {
      return this.transaction_amount;
    }
  }
  get formattedMerchant() {
    return titleCase(this.merchant_name);
  }
  get isCredit() {
    return atrCreditTransactionTypes.includes(this.transaction_type);
  }
}
decorate(ATRStore, {
  // values
  network_type: observable,
  token: observable,
  case_token: observable,
  transaction_date: observable,
  transaction_amount: observable,
  transaction_currency: observable,
  transaction_currency_alpha: observable,
  merchant_name: observable,
  network_associated_transaction_group_id: observable,
  transaction_type: observable,
  transaction_id: observable,
  auth_code: observable,
  arn: observable,
  retrieval_reference_number: observable,
  matching_pass: observable,
  matching_score: observable,
  network_submission_status: observable,
  network_reject_reason: observable,
  first_network_submission_time: observable,
  last_network_submission_time: observable,
  network_selection_form: observable,
  created_time: observable,
  last_modified_time: observable,
  network_submission_failure_reason: observable,
  associated: observable,
  selected: observable,
  // actions
  toggleSelected: action.bound,
  // computed
  formattedTransactionDate: computed,
  formattedAmount: computed,
  formattedAmountWithCurrency: computed,
  formattedMerchant: computed,
  formattedTransactionType: computed,
  isCredit: computed
});
const {
  templates: templates$3
} = gqlUtils;
class ATRListStore extends ParentTableStore {
  constructor(args = {}) {
    super(args);
    this.activeFilters = {};
    this.allSelected = false;
    this.count = 50;
    this.filterBySelect = false;
    this.items = [];
    this.notAssociated = false;
    this.loadData(args);
    reaction(() => this.allSelected, () => {
      this.items && this.items.forEach((atr) => {
        const {
          setAttr,
          isCustomTransaction
        } = atr || {};
        !isCustomTransaction && setAttr && setAttr("selected", this.allSelected);
      });
    });
  }
  // actions
  loadData(atrData) {
    const {
      data = []
    } = atrData || {};
    this.load(atrData);
    this.loadAndConstructList("items", data, ATRStore);
  }
  async submitATR(throwError = false) {
    try {
      if (!this.atrsChanged)
        return;
      const payload = {};
      const {
        createATRPayload,
        updateATRPayload
      } = this.atrSelectionPayload;
      if (createATRPayload) {
        payload["createAssociatedTransactionsSelection"] = createATRPayload;
      }
      if (updateATRPayload) {
        payload["updateAssociatedTransactionsSelection"] = updateATRPayload;
      }
      const mutation = templates$3.submitATR;
      const result = await this.gqlMutation(mutation, payload);
      if (!result)
        throw "Dispute ATR selection failed";
      return runInAction(async () => {
        const {
          errors
        } = result || {};
        if (errors) {
          throw errors;
        }
      });
    } catch (err) {
      const error = `ERROR (submitATR): ${err}`;
      if (throwError)
        throw error;
      console.error(error);
    }
  }
  toggleAllSelected() {
    this.allSelected = !this.allSelected;
  }
  handleClear() {
    this.activeFilters = {};
    this.filterBySelect = false;
  }
  // computed
  get atrSelectionPayload() {
    const payload = {};
    const createATRPayload = {
      network_type: "VISA",
      associated_transactions: []
    };
    const updateATRPayload = {
      network_type: "VISA",
      associated_transactions: []
    };
    if (this.items && this.items.length) {
      createATRPayload["case_token"] = this.items[0].case_token;
      updateATRPayload["case_token"] = this.items[0].case_token;
    }
    this.items.forEach((atr) => {
      const {
        token,
        selected,
        network_submission_status,
        isCustomTransaction
      } = atr || {};
      if (isCustomTransaction)
        return;
      const atrSelection = {
        associated_transaction_token: token,
        associated: this.notAssociated ? false : selected
      };
      if (createATRSelectionStatuses.includes(network_submission_status)) {
        createATRPayload.associated_transactions.push(atrSelection);
      } else {
        updateATRPayload.associated_transactions.push(atrSelection);
      }
    });
    if (createATRPayload.associated_transactions.length) {
      payload["createATRPayload"] = createATRPayload;
    }
    if (updateATRPayload.associated_transactions.length) {
      payload["updateATRPayload"] = updateATRPayload;
    }
    return payload;
  }
  get atrTableHeight() {
    if (!(this.items && this.items.length))
      return 360;
    const max = 480;
    const rowsHeight = this.items ? this.items.length * 40 : 0;
    const dynamicMin = Math.max(200, rowsHeight);
    return Math.min(max, dynamicMin);
  }
  get selectedCount() {
    try {
      const selectedATRs = this.items.filter((atr) => atr.selected && !atr.isCustomTransaction);
      return selectedATRs.length;
    } catch (err) {
      return 0;
    }
  }
  get cumulativeSelectedAmount() {
    try {
      return this.items.reduce((sumAmount, atr) => {
        if (!atr.isCustomTransaction) {
          const atrAmt = parseFloat(atr.transaction_amount);
          if (atr.selected) {
            return sumAmount + (atr.associated ? 0 : atrAmt);
          } else {
            return sumAmount - (atr.associated ? atrAmt : 0);
          }
        }
        return sumAmount;
      }, 0);
    } catch (err) {
      return 0;
    }
  }
  get invalid() {
    return Boolean(this.selectedCount === 0 || this.notAssociated);
  }
  get atrsChanged() {
    return this.items.some((atr) => Boolean(atr.associated) !== atr.selected && !atr.isCustomTransaction);
  }
  // Overrides ParentTableStore.currentList
  get currentList() {
    if (this.filterBySelect) {
      return this.sortedItems.filter((item) => item.selected);
    } else {
      return this.sortedItems;
    }
  }
  get allColumnsIsUnavailable() {
    if (this.notAssociated || !this.currentList.length)
      return this.notAssociated;
    return this.currentList.every((atr) => atr.isCustomTransaction);
  }
  get noTransactionsAreAssociated() {
    return this.items.every((atr) => !atr.associated && isPresent(atr.associated));
  }
  get hasAssociatedATRs() {
    return this.items.some((atr) => Boolean(atr.associated) && !atr.isCustomTransaction);
  }
  get atrSelectionIsValid() {
    const someATRselected = this.selectedCount !== 0;
    return someATRselected || this.notAssociated || this.allColumnsIsUnavailable;
  }
  get hasCreditTransactionTypes() {
    return this.items.some((atr) => atr.isCredit);
  }
  get explanationOfCreditRequired() {
    return this.notAssociated && this.hasCreditTransactionTypes;
  }
}
decorate(ATRListStore, {
  // values
  activeFilters: observable,
  allSelected: observable,
  filterBySelect: observable,
  items: observable,
  notAssociated: observable,
  sort_by: observable,
  // actions
  handleClear: action.bound,
  loadData: action.bound,
  submitATR: action.bound,
  toggleAllSelected: action.bound,
  // computed
  atrSelectionPayload: computed,
  atrTableHeight: computed,
  cumulativeSelectedAmount: computed,
  currentList: computed,
  explanationOfCreditRequired: computed,
  hasCreditTransactionTypes: computed,
  invalid: computed,
  atrsChanged: computed,
  noTransactionsAreAssociated: computed,
  selectedCount: computed,
  hasAssociatedATRs: computed,
  atrSelectionIsValid: computed
});
class DisputeFileManagerStore extends ParentStore {
  constructor(...args) {
    super(...args);
    this.bulkActionType = "";
    this.sortBy = LABELS$1.NEWEST;
    this.attachedToForm = observable.map();
    this.selected = observable.map();
    this.attachFilesAfterReopen = () => {
      if (this.constructedBy?.isEditing) {
        const documents2 = this.dig(this.constructedBy, "documents", "items") || [];
        const attachedContents = this.dig(this.constructedBy?.transitions.lastReviewTransition, "transition_details", "review_details", "attached_contents") || [];
        if (attachedContents?.length) {
          documents2.forEach((document2) => {
            if (attachedContents.includes(document2.token)) {
              this.attachedToForm.set(document2.token, document2);
            }
          });
        }
      }
    };
    this.attachSelected = () => {
      [...this.selected.values()].map((file) => this.attachedToForm.set(file.token, file));
      this.selected.clear();
    };
    this.replaceAllByFirstSelected = () => {
      this.attachedToForm.clear();
      const file = [...this.selected.values()].shift();
      if (file) {
        this.attachedToForm.set(file.token, file);
      }
      this.selected.clear();
    };
    this.findLastTransitionByFile = (file) => {
      const {
        transitions,
        dispute_transitions
      } = this.constructedBy || EMPTY_OBJECT;
      const {
        items: caseTransitions = []
      } = transitions || EMPTY_OBJECT;
      const {
        data: disputeTransitions = []
      } = dispute_transitions || EMPTY_OBJECT;
      return this.findLastTransition(disputeTransitions, "network_details", Object.values(DISPUTE_TRANSITION_DETAILS_NAMES), file.token) || this.findLastTransition(caseTransitions, "transition_details", Object.values(TRANSITION_DETAILS_NAMES), file.token);
    };
    this.clearAttachedContents = () => {
      this.attachedToForm.clear();
    };
    this.isPresentInAttachedContent = (file, name) => {
      const lastTransition = this.constructedBy?.transitions?.items[this.constructedBy?.transitions.count - 1];
      const {
        attached_contents
      } = lastTransition?.transition_details?.[name] || EMPTY_OBJECT;
      return attached_contents?.some((id) => id === file.token);
    };
    this.isAttached = (file) => {
      const state = this.constructedBy?.state;
      if (state === STATE_MAP.READY) {
        return this.isPresentInAttachedContent(file, TRANSITION_DETAILS_NAMES.REVIEW);
      }
      return this.attachedToForm.has(file.token);
    };
    this.isSelected = (file) => {
      return this.selected.has(file.token);
    };
    this.select = (file) => {
      if (this.isSelected(file)) {
        this.selected.delete(file.token);
        if (this.selected.size === 0) {
          this.bulkActionType = "";
        }
        return this.selected;
      }
      return this.selected.set(file.token, file);
    };
    this.selectAll = (files) => {
      return files.forEach((file) => this.selected.set(file.token, file));
    };
    this.deselectAll = () => {
      this.selected.clear();
      if (this.selected.size === 0) {
        this.bulkActionType = "";
      }
      return this.selected;
    };
    this.setBulkActionType = (action2) => {
      this.bulkActionType = action2;
    };
    this.setSortBy = (sortBy) => {
      this.sortBy = sortBy;
    };
    this.detachFile = (file) => {
      this.attachedToForm.delete(file.token);
    };
    this.attachFile = (file) => {
      this.attachedToForm.set(file.token, file);
    };
  }
  getSubmittedBy(file) {
    const createdBy = this.findLastTransitionByFile(file)?.created_by;
    if (createdBy === "Automated By System") {
      return "Network";
    }
    return createdBy || "";
  }
  getAssociatedTo(file) {
    const transition = this.findLastTransitionByFile(file);
    return transition?.state || transition?.action || "";
  }
  // Helper, find last transition or dispute_transition by token and keys
  findLastTransition(items = [], mainKey = "", keys2 = [], token = "") {
    const transitions = items.reduce((prev, cur) => {
      const isPresentInContents = keys2.some((name) => {
        const attachedContents = this.dig(cur, mainKey, name, "attached_contents") || [];
        return attachedContents.some((id) => id === token);
      });
      const isSubmittedByNetwork = this.dig(cur, mainKey, "network_state_details");
      if (isPresentInContents || isSubmittedByNetwork) {
        return [...prev, cur];
      }
      return prev;
    }, []);
    return transitions[transitions.length - 1];
  }
  get isAttachAvailable() {
    const disputeState = this.constructedBy?.dispute_details?.dispute_state;
    const action2 = this.constructedBy?.dispute_transitions?.nextLegacyTransitionAction;
    return this.constructedBy?.isEditing || AVAILABLE_DISPUTE_STATE_AND_ACTION_FOR_ATTACH[disputeState] && AVAILABLE_DISPUTE_STATE_AND_ACTION_FOR_ATTACH[disputeState][action2];
  }
  get sortedItems() {
    const items = this.constructedBy?.documents?.items || [];
    return items.sort((a, b) => {
      const aCreated = new Date(a.created_time);
      const bCreated = new Date(b.created_time);
      return this.sortBy === LABELS$1.NEWEST ? bCreated - aCreated : aCreated - bCreated;
    });
  }
  get deleteOptionIsShown() {
    return [...this.selected.values()].every((file) => file.canBeDeleted);
  }
  get attachedContents() {
    return [...this.attachedToForm.values()].map(({
      token
    }) => token);
  }
  get isDocRetrievalAvailable() {
    const disputeState = this.constructedBy?.dispute_details?.dispute_state;
    const isMastercard = this.constructedBy?.isMastercard;
    return flipFlop.get("disputes-mc-doc-retrieval-enabled", false) && isMastercard && AVAILABLE_DISPUTE_STATE_FOR_DOC_RETRIEVAL[disputeState];
  }
}
decorate(DisputeFileManagerStore, {
  // observables
  bulkActionType: observable,
  sortBy: observable,
  // actions
  attachFilesAfterReopen: action.bound,
  attachSelected: action.bound,
  clearAttachedContents: action.bound,
  getSubmittedBy: action.bound,
  findLastTransitionByFile: action.bound,
  replaceAllByFirstSelected: action.bound,
  select: action.bound,
  setSortBy: action.bound,
  attachFile: action.bound,
  detachFile: action.bound,
  setBulkActionType: action.bound,
  selectAll: action.bound,
  deselectAll: action.bound,
  getAssociatedTo: action.bound,
  // computed
  attachedContents: computed,
  deleteOptionIsShown: computed,
  isAttachAvailable: computed,
  sortedItems: computed,
  isDocRetrievalAvailable: computed
});
const {
  fragments: fragments$1,
  templates: templates$2
} = gqlUtils;
const allowConvertToNonIntegratedForNewStatesAndAllNetworks = flipFlop.get("allow-convert-to-non-integrated", false);
class DisputeStore extends ParentStore {
  constructor(args = {}) {
    super(args);
    this.assignee = "";
    this.business_token = "";
    this.cardholder_token = "";
    this.caseTransitionModalConfig = {};
    this.created_time = "";
    this.dispute_details = {};
    this.expand = EXPAND_PARAMS.REGULATION_DETAILS;
    this.last_modified_time = "";
    this.memo = "";
    this.network_comment = "";
    this.milestones = {};
    this.preventReload = false;
    this.program_short_code = "";
    this.serviceIntegrations = {};
    this.selectedCaseType = "";
    this.state = "";
    this.token = "";
    this.type = "";
    this.type_change_time = "";
    this.is_dispute_impacted_by_local_law_or_regulation = null;
    this.notes = [];
    this.alertStore = alertStore;
    this.associated_transactions = {};
    this.cardholder = {};
    this.disputesAccess = {};
    this.documents = {};
    this.edits = new EditStore();
    this.parentCardholder = null;
    this.transaction = {};
    this.transitions = {};
    this.disputeFileManager = null;
    this.programConfigs = {};
    this.chargeback = {};
    this.chargeback_transitions = {};
    this.documentModalVisible = false;
    this.formSubmitted = false;
    this.loading = false;
    this.originIsTransactions = false;
    this.skipAutoLoad = true;
    this.useATRBasedDisputeAmount = false;
    this.showProvisionalCreditModal = false;
    this.showCommunicationDateModal = false;
    this.issuePCreditAndSubmit = false;
    this.originalDisputeAmount = "";
    this.loadFullInfoResult(args);
  }
  // actions
  loadFullInfoResult(data) {
    const {
      dispute_details,
      cardholder,
      transaction,
      associated_transactions,
      transitions,
      dispute_transitions,
      documents: documents2,
      events,
      milestones,
      ...partialData
    } = data;
    this.load({
      ...partialData,
      originalDisputeAmount: dispute_details?.dispute_amount || ""
    });
    const augmentedDisputeDetails = {
      gqlClient: this.gqlClient,
      case_token: this.token,
      ...dispute_details
    };
    this.loadAndConstructItem("dispute_details", augmentedDisputeDetails, DisputeDetailsStore);
    this.loadOrHydrateCardholder(cardholder, transaction?.acting_cardholder_token);
    this.loadAndConstructItem("transaction", transaction, TransactionStore);
    this.loadAndConstructItem("documents", {
      ...documents2,
      isVisa: this.isVisa
    }, DisputeDocumentsStore);
    events && this.loadAndConstructItem("events", events, EventsStore);
    milestones && this.loadAndConstructItem("milestones", milestones, MilestonesStore);
    this.documents.load({
      case_token: this.token
    });
    this.setTransitionsStore(transitions);
    this.loadAssociatedTransactions(associated_transactions);
    this.setDisputeTransitionsStore(dispute_transitions);
    if (!this.disputeFileManager) {
      this.loadAndConstructItem("disputeFileManager", {}, DisputeFileManagerStore);
    }
    this.disputeFileManager.attachFilesAfterReopen();
  }
  // Cardholder data may not be present if the cardholder is the acting user
  // and has a parent. If so, find the user token and hydrate.
  // Do not do this on a disputes list view.
  async loadOrHydrateCardholder(cardholder, acting_cardholder_token) {
    if (cardholder?.token) {
      this.loadAndConstructItem("cardholder", cardholder, CardholderStore);
      if (cardholder?.token !== acting_cardholder_token && !this.currentRouteIsQueue) {
        this.parentCardholder = new CardholderStore({
          gqlClient: this.gqlClient,
          token: cardholder?.token
        });
        await this.parentCardholder.hydrate();
      }
    } else if (acting_cardholder_token && !this.currentRouteIsQueue) {
      this.cardholder = new CardholderStore({
        gqlClient: this.gqlClient,
        token: acting_cardholder_token
      });
      await this.cardholder.hydrate();
    }
  }
  setTransitionsStore(transitions = {}) {
    const transitionsWithErrors = transitions || EMPTY_OBJECT;
    const errorText = this?.dispute_details?.network_failure_response;
    transitionsWithErrors.data = transitions?.data?.map((transition) => ({
      errorText,
      ...transition
    }));
    const {
      showNetworkSubmissionModal
    } = this.transitions || EMPTY_OBJECT;
    const augmentedTransitions = {
      case_token: this.token,
      currentState: this.state,
      transitionWrap: this.transitionWrap,
      showAndLogAlert: this.showAndLogAlert,
      disputesAccess: this.disputesAccess,
      ...isPresent(showNetworkSubmissionModal) ? {
        showNetworkSubmissionModal
      } : {},
      ...transitionsWithErrors
    };
    this.loadAndConstructItem("transitions", augmentedTransitions, DisputeTransitionsStore);
  }
  setDisputeTransitionsStore(dispute_transitions = {}) {
    const {
      currency_code,
      dispute_amount,
      dispute_state,
      isAllocationFlow,
      isPulseAllocationFlow,
      isRegE,
      dispute_reason
    } = this.dispute_details || {};
    const {
      cardAcceptor,
      network
    } = this.transaction || {};
    const augmentedTransitions = {
      case_token: this.token,
      disputeCurrencyCode: currency_code,
      gqlClient: this.gqlClient,
      handleSuccess: this.handleSuccess,
      hydrate: this.hydrate,
      merchantName: cardAcceptor,
      network: this.network || network,
      showAndLogAlert: this.showAndLogAlert,
      type: this.type,
      dispute_amount,
      dispute_state,
      dispute_reason,
      ...dispute_transitions,
      allowableActions: this.fetchNetworkAttr("allowable_actions") || [],
      isAllocationFlow,
      isPulseAllocationFlow,
      isLegacyDisputeType: this.isLegacyDisputeType,
      isRegE
    };
    this.dispute_transitions = new NetworkDisputeTransitionListStore(augmentedTransitions);
    this.dispute_transitions.constructedBy = this;
  }
  async constructAndHydrateTransaction(transactionTokenQuery, shouldHydrateCardholders) {
    const transactionToken = transactionTokenQuery ? transactionTokenQuery : dig(this.dispute_details, "original_transaction_token");
    if (!transactionToken)
      return;
    try {
      this.loading = true;
      this.transaction = new TransactionStore({
        gqlClient: this.gqlClient
      });
      await this.transaction.hydrate(transactionToken);
      if (shouldHydrateCardholders) {
        const {
          cardholder_token,
          acting_cardholder_token
        } = this.transaction;
        await this.hydrateCardholders(cardholder_token, acting_cardholder_token);
      }
      return this.transaction;
    } catch (err) {
      console.error(`Error fetching aux transaction data.`);
      console.error(err);
    } finally {
      this.loading = false;
    }
  }
  async hydrateCardholders(cardholder_token, acting_cardholder_token) {
    this.cardholder = new CardholderStore({
      gqlClient: this.gqlClient
    });
    await this.cardholder.hydrate(cardholder_token);
    if (cardholder_token !== acting_cardholder_token) {
      this.parentCardholder = new CardholderStore({
        gqlClient: this.gqlClient
      });
      await this.parentCardholder.hydrate(acting_cardholder_token);
    }
  }
  async hydrate() {
    if (!this.token)
      return;
    try {
      this.loading = true;
      const result = await this.gqlQuery(`
          query case($token: ID! $expand: String) {
            case(token: $token expand: $expand) {
              ${templates$2.expandedCompleteDisputeInfo}
              serviceIntegrations {
                ...serviceIntegrations
              }
            }
          }
          ${fragments$1.amountObjectInfo}
          ${fragments$1.arbitrationDetailsInfo}
          ${fragments$1.associatedTransactionInfo}
          ${fragments$1.businessBaseInfo}
          ${fragments$1.caseCloseDetailsInfo}
          ${fragments$1.cancelledMerchandiseOrServicesDetailsInfo}
          ${fragments$1.counterfeitMerchDetailsInfo}
          ${fragments$1.cancelledRecurringTransactionDetailsInfo}
          ${fragments$1.caseDocumentInfo}
          ${fragments$1.creditNotProcessedDetailsInfo}
          ${fragments$1.disputeDetailsInfo}
          ${fragments$1.duplicateProcessingDetailsInfo}
          ${fragments$1.disputeTransitionDetailsInfo}
          ${fragments$1.incorrectAccountNumberDetailsInfo}
          ${fragments$1.incorrectCurrencyDetailsInfo}
          ${fragments$1.incorrectTransactionAmountDetailsInfo}
          ${fragments$1.incorrectTransactionCodeDetailsInfo}
          ${fragments$1.issuerAcquirerContactInfo}
          ${fragments$1.latePresentmentDetailsInfo}
          ${fragments$1.noAuthorizationDetailsInfo}
          ${fragments$1.invalidDataDetailsInfo}
          ${fragments$1.misrepresentationDetailsInfo}
          ${fragments$1.originalCreditNotAcceptedDetailsInfo}
          ${fragments$1.networkCaseStatusDetailsInfo}
          ${fragments$1.networkDetailsInfo}
          ${fragments$1.networkSelectionFormInfo}
          ${fragments$1.networkStateDetailsInfo}
          ${fragments$1.notAsDecribedOrDefectiveMerchandiseDetailsInfo}
          ${fragments$1.prearbitrationDetailsInfo}
          ${fragments$1.representmentDetailsInfo}
          ${fragments$1.prearbitrationResponseDetailsInfo}
          ${fragments$1.serviceIntegrations}
          ${fragments$1.serviceNotProvidedMerchandiseNotReceivedDetailsInfo}
          ${fragments$1.transactionBaseInfo}
        `, {
        token: this.token,
        expand: this.expand
      }, void 0, void 0, "all");
      runInAction(async () => {
        if (result) {
          const caseData = this.extract(result, "case");
          const regType = dig(caseData, "dispute_details", "regulation_type");
          const pcGranted = dig(caseData, "dispute_details", "provisional_credit_granted");
          if (regType === "REG_E") {
            await this.hydrateRegEData();
          } else if (pcGranted) {
            await this.getRegECaseEvents();
          }
          this.loadFullInfoResult(caseData);
          this.loading = false;
        }
      });
    } catch (err) {
      console.error(`ERROR (dispute hydrate): ${err}`);
      this.loading = false;
    }
  }
  async createCase(successCallback) {
    if (!this.disputeFormIsValid)
      return;
    const {
      getCreationOrigin
    } = disputeStorage || EMPTY_OBJECT;
    const origin = getCreationOrigin();
    const {
      dispute_reason
    } = this.dispute_details || EMPTY_OBJECT;
    const eventProperties = {
      disputeReason: dispute_reason,
      origin: origin && !origin.includes("/risk/disputes") ? "Transactions" : "Disputes"
    };
    const payload = this.createCasePayload;
    try {
      this.loading = true;
      const mutation = this.isFraudCase ? templates$2.createAndWithdrawCaseMutation : templates$2.createAndAssignCaseMutation;
      const payload2 = this.createCasePayload;
      const response = await this.gqlMutation(mutation, payload2, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.isFraudCase ? this.dig(response, "data", "createAndWithdrawCase") : this.dig(response, "data", "createAndAssignCase");
      if (errors)
        throw errors;
      if (!success)
        throw "Dispute creation failed";
      return runInAction(() => {
        const {
          token
        } = success;
        this.loadFullInfoResult(success);
        disputesSegmentTrackEvent(NEW_DISPUTE_CREATED_EVENT, {
          ...eventProperties,
          errorStatus: false,
          type: payload2.type
        });
        const successMessage = this.isFraudCase ? "Fraud report created" : "Dispute created";
        this.handleSuccess(successMessage, successCallback({
          token
        }));
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(NEW_DISPUTE_CREATED_EVENT, {
        ...eventProperties,
        errorStatus: true,
        type: payload.type
      });
      this.showAndLogAlert("There was an issue creating the dispute.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (dispute creation): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.loading = false;
    }
  }
  async updateZendeskId(zendeskId, caseToken) {
    try {
      this.loading = true;
      const payload = {
        token: caseToken,
        type: this.type,
        zendesk_ticket_id: zendeskId
      };
      const mutation = templates$2.updateZendeskTicketIdMutation;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "updateCase");
      if (errors)
        throw errors;
      if (!success)
        throw "Dispute update failed";
      return runInAction(() => {
        this.loadFullInfoResult(success);
        this.handleSuccess("Dispute updated");
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      this.showAndLogAlert("There was an issue updating zendesk id.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (dispute update): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.loading = false;
    }
  }
  async updateCase(successCallback, throwError = false, updateAmount = false) {
    const {
      getHasEdits
    } = this.edits;
    const {
      questionnaireIsEdited
    } = this.dispute_details;
    const formHasEdits = getHasEdits() || questionnaireIsEdited;
    if (!formHasEdits)
      return;
    if (!this.disputeFormIsValid) {
      const invalidFields = Object.keys(this.formValidation);
      const otherErrorsExists = invalidFields.some((key) => key != "dispute_amount_change_reason");
      if (updateAmount && otherErrorsExists || !updateAmount)
        return;
    }
    const eventProperties = {
      change: this.changedFields
    };
    const payload = this.updateCasePayload;
    try {
      this.setAttr("documentModalVisible", false);
      this.loading = true;
      const mutation = templates$2.updateAndAssignCaseMutation;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "updateAndAssignCase");
      if (errors)
        throw errors;
      if (!success)
        throw "Dispute update failed";
      return runInAction(async () => {
        this.loadFullInfoResult(success);
        disputesSegmentTrackEvent(EDIT_CASE_EVENT, {
          ...eventProperties,
          errorStatus: false,
          type: this.type
        });
        this.handleSuccess("Dispute saved", successCallback);
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(EDIT_CASE_EVENT, {
        ...eventProperties,
        errorStatus: true,
        type: payload.type
      });
      this.showAndLogAlert("There was an issue updating the dispute.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (dispute update): ${err}`,
        withSupportLink: true
      });
      if (throwError)
        throw errorMessage;
    } finally {
      this.loading = false;
    }
  }
  async updateNetworkCaseNumber(networkCaseNumber) {
    const {
      token,
      type
    } = this;
    const eventProperties = {
      caseToken: token
    };
    try {
      this.loading = true;
      const payload = {
        token,
        type,
        dispute_details: {
          network_case_number: networkCaseNumber
        }
      };
      const mutation = templates$2.updateNetworkCaseNumberMutation;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "updateCase");
      if (errors)
        throw errors;
      if (!success)
        throw "Dispute update failed";
      return runInAction(async () => {
        const {
          network_case_number
        } = success.dispute_details;
        this.dispute_details.network_case_number = network_case_number;
        disputesSegmentTrackEvent(NETWORK_CASE_ID_UPDATED_EVENT, {
          ...eventProperties,
          errorStatus: false
        });
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(NETWORK_CASE_ID_UPDATED_EVENT, {
        ...eventProperties,
        errorStatus: true
      });
      this.showAndLogAlert("There was an issue updating the dispute.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (dispute update): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.loading = false;
    }
  }
  async hydrateRegEData() {
    await this.getRegECaseEvents();
    await this.getRegECaseMilestones();
  }
  async getChargeback() {
    if (!this.dispute_details.chargeback_token)
      return;
    try {
      const response = await this.gqlQuery(templates$2.chargebackQuery, {
        token: this.dispute_details.chargeback_token
      }, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      const chargeback = this.dig(response, "data", "chargeback");
      const chargebackTransitions = this.dig(response, "data", "chargebackTransitions");
      if (errors)
        throw errors;
      if (!chargeback)
        throw "Getting case chargeback failed";
      if (!chargebackTransitions)
        throw "Getting case chargeback transitions failed";
      return runInAction(async () => {
        this.loadAndConstructItem("chargeback", chargeback, ChargebackStore);
        this.loadAndConstructItem("chargeback_transitions", chargebackTransitions, ChargeBackTransitionListStore);
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      this.showAndLogAlert("There was a problem getting case chargeback.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (events): ${err}`,
        withSupportLink: true
      });
    }
  }
  async getRegECaseEvents() {
    try {
      const response = await this.gqlQuery(templates$2.eventsQuery, {
        case_token: this.token
      }, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "events");
      if (errors)
        throw errors;
      if (!success)
        throw "Getting case events failed";
      return runInAction(async () => {
        this.loadAndConstructItem("events", success, EventsStore);
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      this.showAndLogAlert("There was a problem getting case events.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (events): ${err}`,
        withSupportLink: true
      });
    }
  }
  async getRegECaseMilestones() {
    try {
      const response = await this.gqlQuery(templates$2.milestones, {
        case_token: this.token
      }, void 0, void 0, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "milestones");
      if (errors)
        throw errors;
      if (!success)
        throw "Getting case milestones failed";
      return runInAction(async () => {
        this.loadAndConstructItem("milestones", success, MilestonesStore);
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      this.showAndLogAlert("There was a problem getting case milestones.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (milestones): ${err}`,
        withSupportLink: true
      });
    }
  }
  async createCaseAction(action2) {
    const {
      token
    } = this;
    const {
      created_by
    } = this.transitions || EMPTY_OBJECT;
    const {
      toggleSubmissionModal
    } = this.transitions;
    const eventProperties = {
      action_type: action2
    };
    try {
      this.loading = true;
      const payload = {
        case_token: token,
        created_by,
        action_type: action2
      };
      const mutation = templates$2.createCaseActionMutation;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "createCaseAction");
      if (errors)
        throw errors;
      if (!success)
        throw "Issuing provisional failed";
      const successMessage = ACTION_TYPES_MESSAGES[action2] || ACTION_TYPES_MESSAGES.DEFAULT;
      this.handleSuccess(successMessage);
      return runInAction(async () => {
        disputesSegmentTrackEvent(PROVISIONAL_CREDIT_GRANTED_EVENT, {
          ...eventProperties,
          errorStatus: false
        });
        this.issuePCreditAndSubmit && toggleSubmissionModal(true);
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(PROVISIONAL_CREDIT_GRANTED_EVENT, {
        ...eventProperties,
        errorStatus: true
      });
      this.showAndLogAlert("There was a problem with issuing provisional credit.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (issue provisional credit): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.preventReload = true;
      await this.hydrate();
    }
  }
  async createCaseEvent(event, eventDate) {
    const {
      token
    } = this;
    const {
      created_by
    } = this.transitions || EMPTY_OBJECT;
    const eventProperties = {
      event_name: event
    };
    try {
      this.loading = true;
      const payload = {
        case_token: token,
        created_by,
        name: event,
        event_date: convertDateToUTC(eventDate)
      };
      const mutation = templates$2.createCaseEventMutation;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "createCaseEvent");
      if (errors)
        throw errors;
      if (!success)
        throw "Creating case event failed";
      const successMessage = EVENT_TYPES_MESSAGES[event] || EVENT_TYPES_MESSAGES.DEFAULT;
      this.handleSuccess(successMessage);
      return runInAction(async () => {
        disputesSegmentTrackEvent(CREATED_CASE_EVENT, {
          ...eventProperties,
          errorStatus: false
        });
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(CREATED_CASE_EVENT, {
        ...eventProperties,
        errorStatus: true
      });
      this.showAndLogAlert("There was a problem with creating case event.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (create case event): ${err}`,
        withSupportLink: true
      });
    } finally {
      await this.hydrateRegEData();
      this.loading = false;
    }
  }
  async transitionWrap(valid = false, mutation, payload) {
    if (!valid || !mutation)
      return;
    const {
      attachedContents,
      clearAttachedContents
    } = this.disputeFileManager || EMPTY_OBJECT;
    if (this.includeAttachedContents) {
      payload.transition_details = {
        chargeback_details: {
          attached_contents: attachedContents
        }
      };
    }
    const {
      eventProperties,
      eventName
    } = this.currentEventInfo(payload);
    try {
      this.loading = true;
      const response = await this.gqlMutation(mutation, payload, null, null, "all");
      const errors = this.dig(response, "errors");
      const success = this.dig(response, "data", "createCaseTransition");
      if (errors)
        throw errors;
      if (!success)
        throw "Dispute transition failed";
      return runInAction(() => {
        const {
          state: newState,
          reason_code: reasonCode,
          failure_reason: failureReason,
          reason_description: reasonDescription,
          action: newAction
        } = success || {};
        clearAttachedContents();
        this.handleTransitionSuccess({
          newState,
          reasonCode,
          failureReason,
          reasonDescription,
          newAction,
          payload
        });
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err, false);
      disputesSegmentTrackEvent(eventName, {
        ...eventProperties,
        errorStatus: true
      });
      this.showAndLogAlert("There was an issue transitioning the dispute.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (dispute transition): ${err}`,
        withSupportLink: true
      });
    } finally {
      const {
        hydrate
      } = this.constructedBy || {};
      if (this.currentRouteIsQueue && hydrate instanceof Function) {
        hydrate();
      } else {
        await this.hydrate();
      }
      this.loading = false;
    }
  }
  async submitATRAndTransition(successCallback) {
    if (!this.associated_transactions.notAssociated) {
      this.setDigDetails("explanation_of_credit", "");
    }
    const {
      setMarkAsReadyPayload,
      validateTransition
    } = this.transitions;
    setMarkAsReadyPayload && setMarkAsReadyPayload();
    const isValid = this.disputeFormIsValid && validateTransition();
    if (!isValid)
      return;
    const payload = this.updateWithATRPayload;
    const {
      eventProperties,
      eventName
    } = this.currentEventInfo(payload?.createCaseTransition);
    try {
      this.loading = true;
      const mutation = templates$2.submitATRAndTransitionMutation;
      const result = await this.gqlMutation(mutation, payload);
      if (!result)
        throw "Dispute ATR selection failed";
      return runInAction(async () => {
        const {
          data,
          errors
        } = result || {};
        const hasErrors = isNotPresent(data) && errors;
        this.handleATRSuccess(data, payload, successCallback);
        disputesSegmentTrackEvent(eventName, {
          ...eventProperties,
          errorStatus: false
        });
        if (hasErrors)
          throw errors;
      });
    } catch (err) {
      const errorMessage = formatNetworkError(err);
      disputesSegmentTrackEvent(eventName, {
        ...eventProperties,
        errorStatus: true
      });
      this.showAndLogAlert("There was an issue with ATR selection.", {
        apiMessage: errorMessage,
        logMessage: `ERROR (submitATRAndTransition): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.loading = false;
    }
  }
  async submitATRAndWithdraw() {
    const {
      transitionToWithdrawnAndClosed
    } = this.transitions || {};
    try {
      this.loading = true;
      if (this.atrRequired) {
        await this.associated_transactions.submitATR(true);
      }
      await this.updateCase(() => {
      }, true, true);
      await transitionToWithdrawnAndClosed();
    } catch (err) {
      this.showAndLogAlert("Dispute withdrawal failed.", {
        apiMessage: err,
        logMessage: `ERROR (submitATRAndWithdraw): ${err}`,
        withSupportLink: true
      });
    } finally {
      this.loading = false;
    }
  }
  async verifyAndLoadAuxDetails(transactionTokenQuery, shouldHydrateCardholders = false) {
    await this.constructAndHydrateTransaction(transactionTokenQuery, shouldHydrateCardholders);
    const {
      state,
      isDisputable
    } = this.transaction || {};
    if (state && isDisputable) {
      const {
        setAttr: setDetailsAttr
      } = this.dispute_details || {};
      const {
        request_amount
      } = this.transaction;
      if (setDetailsAttr) {
        setDetailsAttr("original_transaction_token", transactionTokenQuery);
        request_amount && setDetailsAttr("dispute_amount", request_amount);
      }
      return null;
    } else if (state && !isDisputable) {
      return "This transaction type is not disputable";
    } else {
      return "Transaction not found";
    }
  }
  currentEventInfo(payload) {
    const {
      dispute_reason
    } = this.dispute_details || EMPTY_OBJECT;
    const {
      action: action2
    } = payload || EMPTY_OBJECT;
    const documentsNumber = this.documents.tokens?.length || 0;
    const {
      network
    } = this.transaction || {};
    const baseEventProperties = {
      disputeReason: dispute_reason
    };
    const eventPropertiesByAction = {
      REVIEW: {
        ...baseEventProperties,
        atrRequired: this.atrRequired
      },
      CLOSE: {
        ...baseEventProperties,
        currentCaseState: this.state
      },
      RE_OPEN: {
        ...baseEventProperties,
        atrRequired: this.atrRequired
      },
      CHANGE_CASE_TYPE: {
        ...baseEventProperties,
        network
      },
      CHARGEBACK_CREDIT: {
        ...baseEventProperties,
        documentsNumber
      },
      CHARGEBACK_NO_CREDIT: {
        ...baseEventProperties,
        documentsNumber
      }
    };
    return {
      eventProperties: eventPropertiesByAction[action2],
      eventName: CASE_TRANSITION_EVENTS[action2]
    };
  }
  // Safely set a dispute (or descendent) attribute's value
  setDigDetails(attr, val) {
    if (typeof attr !== "string" || val === void 0)
      return null;
    if (this[attr] !== void 0) {
      return this[attr] = val;
    }
    if (dig(this.dispute_details, attr) !== void 0) {
      return this.dispute_details[attr] = val;
    }
    if (dig(this.dispute_details, "network_case_status_details", attr) !== void 0) {
      return this.dispute_details.network_case_status_details[attr] = val;
    }
    if (dig(this.dispute_details, "additional_dispute_details", attr) !== void 0) {
      return this.dispute_details.additional_dispute_details[attr] = val;
    }
  }
  toggleATRBasedDisputeAmount(boolValue) {
    if (this.atrRequired) {
      const isOriginalDisputeAmount = this.partialDisputeAmountFromATR === parseFloat(this.originalDisputeAmount);
      this.useATRBasedDisputeAmount = isOriginalDisputeAmount ? false : boolValue;
      if (boolValue) {
        this.edits.setEdit("dispute_amount", this.formattedDisputeAmountWithATR);
      }
    } else {
      this.useATRBasedDisputeAmount = false;
    }
  }
  showCaseTransitionNoteModal(caseTransitionModalConfig) {
    const {
      setAttr: setTransitionsAttr
    } = this.transitions || {};
    setTransitionsAttr && setTransitionsAttr("memo", "");
    this.setAttr("caseTransitionModalConfig", caseTransitionModalConfig);
    this.constructedBy?.setSelectedDispute?.(this);
  }
  showCloseRegECaseModal() {
    this.constructedBy?.setSelectedDispute?.(this);
  }
  hideCaseTransitionNoteModal() {
    this.setAttr("caseTransitionModalConfig", {});
  }
  toggleProvisionalCreditModal(value) {
    this.showProvisionalCreditModal = value;
  }
  toggleCommunicationDateModal(value) {
    this.showCommunicationDateModal = value;
  }
  setIssuePCreditAndSubmit(value) {
    this.issuePCreditAndSubmit = value;
  }
  markAsReadyCallback(documentsCount) {
    const {
      transitionToReady
    } = this.transitions;
    const modalHandler = new DocumentModalHandler(this);
    if (this.isLegacyDisputeType) {
      return transitionToReady();
    }
    if (modalHandler.shouldShowModal && documentsCount === 0) {
      this.constructedBy?.setAttr("documentModalVisible", true);
      this.constructedBy?.setAttr("transitionToReady", transitionToReady);
      return;
    }
    transitionToReady();
  }
  submitToNetworkHandler() {
    const {
      toggleSubmissionModal
    } = this.transitions;
    const {
      provisionalCreditNotIssuedYet
    } = this.dispute_details;
    provisionalCreditNotIssuedYet && this.setIssuePCreditAndSubmit(true);
    provisionalCreditNotIssuedYet ? this.toggleProvisionalCreditModal(true) : toggleSubmissionModal(true);
  }
  // computed
  get changedFields() {
    const {
      getEditedKeys = []
    } = this.edits;
    const edits = getEditedKeys() || [];
    const {
      questionnairePayload
    } = this.dispute_details || {};
    return [...edits, questionnairePayload];
  }
  get hasFullDisputesAccess() {
    return this.disputesAccess.hasRiskInternalRole || this.disputesAccess.hasAuxRiskExternalRole;
  }
  get isVisa() {
    const {
      network
    } = this.transaction || EMPTY_OBJECT;
    return network === "VISA";
  }
  get isVisaDisputeReasonSelected() {
    const {
      dispute_reason
    } = this.dispute_details || EMPTY_OBJECT;
    return isPresent(disputeReasonNetworkMap[dispute_reason]?.VISA);
  }
  get isMastercard() {
    const {
      network
    } = this.transaction || EMPTY_OBJECT;
    return network === "MASTERCARD";
  }
  get isPulse() {
    const {
      network
    } = this.transaction || EMPTY_OBJECT;
    return network === "PULSE";
  }
  get isPulseDisputeReasonSelected() {
    const {
      dispute_reason
    } = this.dispute_details || EMPTY_OBJECT;
    return isPresent(disputeReasonNetworkMap[dispute_reason]?.PULSE);
  }
  get isDisputeLegacy() {
    return this.isLegacyDisputeType || !this.isNetworkIntegrated || !this.isReasonIntegrated || !this.isTransactionIntegrated;
  }
  get shouldShowConvertToNonIntegrated() {
    if (allowConvertToNonIntegratedForNewStatesAndAllNetworks) {
      return this.type === DISPUTES.DISPUTE && [STATE_MAP.CHARGEBACK_INITIATED, STATE_MAP.OPEN_WITH_ACTION_REQUIRED, STATE_MAP.OPEN, STATE_MAP.READY].includes(this.state) && this.disputesAccess.hasRiskInternalRole;
    } else {
      return this.type === DISPUTES.DISPUTE && this.isVisa && this.disputesAccess.hasRiskInternalRole && this.state === STATE_MAP.CHARGEBACK_INITIATED;
    }
  }
  get isFraudCase() {
    return this.selectedCaseType === CASE_TYPES.FRAUD_REPORT;
  }
  get isChargebackCase() {
    return this.selectedCaseType === CASE_TYPES.CHARGEBACK;
  }
  get isAFTTransaction() {
    return this.transaction.type == "account.funding.authorization.clearing" || this.transaction.type == "account.funding.auth_plus_capture";
  }
  get createCasePayload() {
    const {
      additional_dispute_details,
      cardholder_contact_date,
      dispute_amount,
      dispute_amount_change_reason,
      dispute_reason,
      original_transaction_token,
      account_status,
      questionnairePayload: initialQuestionnairePayload,
      fraud_dispute_type_details,
      fraud_category_type_dispute_details,
      fraud_classification_type_dispute_details,
      zendesk_mapping,
      zendesk_mapping_id
    } = this.dispute_details || EMPTY_OBJECT;
    const {
      created_by
    } = this.transitions || EMPTY_OBJECT;
    const {
      fraud_type
    } = fraud_category_type_dispute_details || EMPTY_OBJECT;
    const {
      fraud_type_classification
    } = fraud_classification_type_dispute_details || EMPTY_OBJECT;
    const {
      additionalDetailsPayload
    } = additional_dispute_details || EMPTY_OBJECT;
    const {
      regulation_subcategory
    } = additionalDetailsPayload || EMPTY_OBJECT;
    const questionnairePayload = this.addIsDisputeImpactedByRegToQuestionnairePayload(Object.assign({}, initialQuestionnairePayload));
    const dispute_details = {
      dispute_amount: parseFloat(dispute_amount),
      dispute_reason,
      original_transaction_token,
      account_status,
      ...questionnairePayload
    };
    const fraudReportDetails = {
      dispute_amount: parseFloat(dispute_amount),
      dispute_reason: "FRAUD_REPORT",
      original_transaction_token,
      fraud_category_type_dispute_details: {
        fraud_type
      }
    };
    if (isPresent(cardholder_contact_date)) {
      dispute_details.cardholder_contact_date = convertDateToUTC(cardholder_contact_date);
    }
    if ((this.isEUUKProgram || flipFlop.get("regulation-subcategory-bnpl", false)) && regulation_subcategory) {
      dispute_details.additional_dispute_details = {
        regulation_subcategory
      };
    }
    if (this.meetsRegECriteria && Object.keys(additionalDetailsPayload).length) {
      dispute_details.additional_dispute_details = {
        ...additionalDetailsPayload
      };
    }
    if (!this.isFullAmount && isPresent(dispute_amount_change_reason)) {
      dispute_details.dispute_amount_change_reason = dispute_amount_change_reason;
    }
    if (this.isVisaFraudReasonCode) {
      const {
        general_fraud_type_dispute_details
      } = fraud_dispute_type_details;
      const {
        chip_on_card
      } = general_fraud_type_dispute_details;
      dispute_details.fraud_dispute_type_details = {
        general_fraud_type_dispute_details: {
          chip_on_card
        }
      };
      dispute_details.fraud_classification_type_dispute_details = {
        fraud_type_classification
      };
    }
    const basePayload = {
      assignee: this.assignee,
      memo: this.memo,
      ...(this.isVisaDisputeReasonSelected || this.isPulseDisputeReasonSelected) && {
        network_comment: this.network_comment
      },
      created_by,
      type: this.isReasonIntegrated && this.isTransactionIntegrated ? DISPUTES.DISPUTE : DISPUTES.LEGACY_DISPUTE
    };
    if (zendesk_mapping === "update" && !!zendesk_mapping_id) {
      basePayload.zendesk_ticket_id = zendesk_mapping_id;
    }
    const chargebackPayload = {
      ...basePayload,
      dispute_details
    };
    const fraudReportPayload = {
      ...basePayload,
      dispute_details: fraudReportDetails
    };
    return this.isFraudCase ? fraudReportPayload : chargebackPayload;
  }
  get updateCasePayload() {
    const {
      token
    } = this;
    const {
      created_by
    } = this.transitions || {};
    const {
      questionnaireIsEdited,
      questionnairePayload: initialQuestionnairePayload
    } = this.dispute_details;
    const questionnairePayload = this.addIsDisputeImpactedByRegToQuestionnairePayload(Object.assign({}, initialQuestionnairePayload));
    const type = this.isReasonIntegrated && this.isTransactionIntegrated && this.type !== DISPUTES.LEGACY_DISPUTE ? DISPUTES.DISPUTE : DISPUTES.LEGACY_DISPUTE;
    const payload = {
      assignee: this.assignee,
      created_by,
      memo: this.memo,
      token,
      type
    };
    const {
      getEditedKeys = []
    } = this.edits;
    const edits = getEditedKeys() || [];
    edits.forEach((attr) => {
      const value = attr === "dispute_amount" ? this.formattedDisputeAmountWithATR : this.digDetails(attr);
      if (this[attr]) {
        payload[attr] = value;
      } else if (this.dispute_details[attr]) {
        if (!payload.dispute_details) {
          payload.dispute_details = {};
        }
        payload.dispute_details[attr] = value;
      } else if (this.dispute_details.additional_dispute_details[attr]) {
        if (!payload.dispute_details) {
          payload.dispute_details = {
            additional_dispute_details: {}
          };
        }
        if (!payload.dispute_details.additional_dispute_details) {
          payload.dispute_details.additional_dispute_details = {};
        }
        payload.dispute_details.additional_dispute_details[attr] = value;
      }
    });
    if (questionnaireIsEdited) {
      payload.replace_questionnaire = true;
      if (!payload.dispute_details) {
        payload.dispute_details = {};
      }
      payload.dispute_details = {
        ...payload.dispute_details,
        ...questionnairePayload
      };
    }
    return payload;
  }
  get updateWithATRPayload() {
    const payload = {};
    const {
      getHasEdits
    } = this.edits;
    const {
      questionnaireIsEdited
    } = this.dispute_details;
    const {
      createTransitionPayload
    } = this.transitions;
    const {
      atrSelectionPayload
    } = this.associated_transactions;
    const {
      createATRPayload,
      updateATRPayload
    } = atrSelectionPayload || {};
    if (!this.isEditing)
      return payload;
    if (this.disputeFormIsValid && getHasEdits() || questionnaireIsEdited) {
      payload["updateCase"] = this.updateCasePayload;
    }
    if (createATRPayload && this.atrRequired) {
      payload["createAssociatedTransactionsSelection"] = createATRPayload;
    }
    if (updateATRPayload && this.atrRequired) {
      payload["updateAssociatedTransactionsSelection"] = updateATRPayload;
    }
    payload["createCaseTransition"] = createTransitionPayload;
    return payload;
  }
  get disputeFormIsValid() {
    try {
      const invalidFields = Object.keys(this.formValidation);
      return !invalidFields.length;
    } catch (err) {
      return false;
    }
  }
  get isEditWithATR() {
    return this.isEditing && Boolean(this.associated_transactions.items.length);
  }
  get formValidation() {
    const {
      baseDisputeFormValidation: formErrors = {},
      cardholder_contact_date,
      dispute_amount,
      dispute_amount_change_reason,
      fraud_dispute_type_details,
      additional_dispute_details: {
        regulation_conditions_met_date,
        refund_conditions,
        exception_reason_apply,
        regulation_subcategory
      },
      dispute_reason,
      account_status
    } = this.dispute_details || {};
    const {
      request_amount,
      settlement_date,
      euCardOutOfJurisdictionTransaction
    } = this.transaction || {};
    const currentDisputeAmount = this.shouldUseATRPartialAmount ? this.partialDisputeAmountFromATR : dispute_amount;
    const amountExceedsTxnAmount = parseFloat(request_amount) < parseFloat(currentDisputeAmount);
    const showAmountExceedsError = !formErrors["dispute_amount"] && amountExceedsTxnAmount;
    const {
      general_fraud_type_dispute_details
    } = fraud_dispute_type_details;
    const {
      chip_on_card = null
    } = general_fraud_type_dispute_details || {};
    const validationForEUUK = this.meetsRegECriteria && !this.isEditing;
    isOlderThanDate(cardholder_contact_date, settlement_date);
    const isIncorrectTransactionAmountReason = dispute_reason === "INCORRECT_TRANSACTION_AMOUNT";
    const errors = {
      ...this.atrValidation,
      ...formErrors
    };
    if (showAmountExceedsError) {
      errors.dispute_amount = AMOUNT_LIMIT_EXCEEDS_ERROR;
    }
    if (this.isAccountStatusInvalid(account_status)) {
      errors.account_status = ACCOUNT_STATUS_IS_REQUIRED;
    }
    if (this.isVisaFraudReasonCode && isNotPresent(chip_on_card) && !this.isEditing) {
      errors.fraud_dispute_type_details = REQUIRED_FIELD_ERROR;
    }
    if (!this.isFullAmount && !dispute_amount_change_reason) {
      errors.dispute_amount_change_reason = AMOUNT_CHANGE_REASON_REQUIRED_ERROR;
    }
    if (this.isEUUKProgram && isNotPresent(regulation_subcategory) && !this.isEditing) {
      errors.regulation_subcategory = DISPUTE_CATEGORY_ERROR;
    }
    if (validationForEUUK) {
      if (regulation_subcategory === DISPUTE_CATEGORIES.INCORRECTLY_EXECUTED && isNotPresent(exception_reason_apply)) {
        errors.exception_reason_apply = REQUIRED_FIELD_ERROR;
      }
      if (regulation_subcategory === DISPUTE_CATEGORIES.INITIATED_BY_PAYEE) {
        if (isNotPresent(refund_conditions)) {
          errors.refund_conditions = REQUIRED_FIELD_ERROR;
        }
        if (isNotPresent(regulation_conditions_met_date)) {
          errors.regulation_conditions_met_date = REFUND_CONDITION_DATE_ERROR;
        }
      }
    }
    if (isNotPresent(cardholder_contact_date) && !this.isEditing) {
      errors.cardholder_contact_date = CARDHOLDER_CONTACT_DATE_REQUIRED_ERROR;
    }
    if (flipFlop.get("disputes-nw-mandates-oct-2023", false) && isIncorrectTransactionAmountReason && (this.state === STATE_MAP.OPEN || this.state === STATE_MAP.OPEN_WITH_ACTION_REQUIRED) && !this.disputeFileManager.attachedToForm.size) {
      errors.attached_documents = ATTACHED_FILES_ARE_REQUIRED;
    }
    if (flipFlop.get("disputes-nw-mandates-april-2024", false) && dispute_reason === "CANCELLED_RECURRING_TRANSACTION" && typeof this.is_dispute_impacted_by_local_law_or_regulation !== "boolean" && euCardOutOfJurisdictionTransaction) {
      errors.dispute_impacted_by_local_law_or_reg = REQUIRED_FIELD_ERROR;
    }
    if (errors && typeof errors === "object" && !Array.isArray(errors) && Object.getOwnPropertyNames(errors).length > 0) {
      console.error("form validation error", errors);
    }
    return this.isFraudCase ? this.fraudReportValidation : errors;
  }
  isAccountStatusInvalid(account_status) {
    const octoberNetworkMandate2 = flipFlop.get("october-network-mandate", false);
    return octoberNetworkMandate2 && this.isVisa && this.isAuthorizationReasonCode && isNotPresent(account_status) && !this.isEditing;
  }
  get fraudReportValidation() {
    const {
      fraud_category_type_dispute_details
    } = this.dispute_details || {};
    const {
      fraud_type = ""
    } = fraud_category_type_dispute_details || {};
    const errors = {};
    if (this.isFraudCase && isNotPresent(fraud_type)) {
      errors.fraud_type = FRAUD_TYPE_REQUIRED_ERROR;
    }
    return errors;
  }
  get atrValidation() {
    const formErrors = {};
    const {
      additional_dispute_details
    } = this.dispute_details || {};
    const {
      explanation_of_credit
    } = additional_dispute_details || {};
    const {
      explanationOfCreditRequired,
      atrSelectionIsValid
    } = this.associated_transactions || {};
    const isRequired = explanationOfCreditRequired && this.atrRequired;
    if (this.atrRequired && !atrSelectionIsValid) {
      formErrors["notAssociated"] = ATR_VALIDATION_REQUIRED_ERROR;
    }
    if (isRequired && !explanation_of_credit) {
      formErrors["explanation_of_credit"] = "Explanation of credit is required.";
    }
    return formErrors;
  }
  get atrRequired() {
    const atrFlag = dig(this.dispute_details, "associated_transaction_selection_required");
    return Boolean(this.state === "OPEN_WITH_ACTION_REQUIRED" && atrFlag);
  }
  get isVisaFraudReasonCode() {
    const {
      disputeReasonData
    } = this.dispute_details || {};
    return this.isVisa && Boolean(disputeReasonData?.VISA?.includes("10"));
  }
  get isAuthorizationReasonCode() {
    const {
      dispute_reason
    } = this.dispute_details || {};
    return Boolean(AUTHORIZATION_REASON_CODES[dispute_reason]);
  }
  get isFraudDisputeReason() {
    const {
      dispute_reason
    } = this.dispute_details;
    return Boolean(FRAUD_REASON_CODES[dispute_reason]);
  }
  get shouldCalculateDisputeAmount() {
    if (!this.atrRequired)
      return false;
    const {
      hasAssociatedATRs,
      atrsChanged
    } = this.associated_transactions;
    return atrsChanged || hasAssociatedATRs;
  }
  get isFullAmount() {
    try {
      const {
        request_amount
      } = this.transaction;
      if (this.isEditWithATR && this.shouldCalculateDisputeAmount)
        return false;
      return parseFloat(request_amount) === parseFloat(this.otherAmount) && !this.shouldUseATRPartialAmount;
    } catch (err) {
      return false;
    }
  }
  get shouldUseATRPartialAmount() {
    return this.useATRBasedDisputeAmount && this.atrRequired;
  }
  get isNegativePartialDisputeAmount() {
    return this.otherAmount <= 0;
  }
  get formattedState() {
    if (this.disputeState) {
      return this.disputeState;
    }
    return getKeyByValue(STATE_OPTIONS, this.state);
  }
  get formattedLastModified() {
    return formatUTCMoment(this.last_modified_time);
  }
  get formattedCreatedTime() {
    return formatUTCMoment(this.created_time);
  }
  get basicFormattedDisputeReason() {
    const {
      dispute_reason
    } = this.dispute_details;
    try {
      return getKeyByValue(REASON_OPTIONS, dispute_reason);
    } catch {
      return sentenceCase(dispute_reason);
    }
  }
  get formattedDisputeReason() {
    const {
      dispute_reason
    } = this.dispute_details;
    try {
      const formattedObject = formattedDisputeReasonNetworkMap[dispute_reason] ?? LEGACY_DISPUTE_REASONS_MAP.get(dispute_reason);
      return formattedObject.label;
    } catch {
      return this.basicFormattedDisputeReason;
    }
  }
  get formattedDisputeAmountChangeReason() {
    const {
      dispute_amount_change_reason
    } = this.dispute_details;
    return sentenceCase(dispute_amount_change_reason);
  }
  get formattedDisputeAmount() {
    const {
      dispute_amount
    } = this.dispute_details;
    if (dispute_amount) {
      return formatMoneyAmount(dispute_amount);
    }
    return dispute_amount;
  }
  get formattedDisputeAmountWithCurrency() {
    const {
      currency_code
    } = this.dispute_details;
    return [formatMoneyAmount(this.formattedDisputeAmountWithATR), currency_code].join(" ").trim();
  }
  get formattedDisputeAmountWithATR() {
    const {
      dispute_amount
    } = this.dispute_details;
    const disputeAmount = this.shouldUseATRPartialAmount ? this.partialDisputeAmountFromATR : dispute_amount;
    return parseFloat(disputeAmount);
  }
  get formattedCardholder() {
    if (this.cardholder instanceof CardholderStore) {
      const {
        fullName
      } = this.cardholder;
      return fullName || this.cardholder_token;
    }
    return this.cardholder_token;
  }
  // All caseTransitionActions, what can be used in DisputeDetail page and DisputeTable
  get caseTransitionActions() {
    const {
      transitionToOpen
    } = this.transitions;
    const {
      isRegEWithPCGranted
    } = this.dispute_details;
    const {
      useWriteOffV2
    } = this;
    return {
      readyBaseBtn: {
        text: "Reopen",
        onClick: transitionToOpen,
        isSplitButton: true,
        dropdownCustomStyle: {
          marginTop: "-5px",
          right: 0
        },
        options: [{
          text: "Reopen with note",
          onOptionClick: () => this.showCaseTransitionNoteModal(TRANSITION_NOTE_MODAL_TYPES.RE_OPEN)
        }]
      },
      submitToNetwork: {
        text: "Submit to network",
        onClick: this.submitToNetworkHandler
      },
      markAsReady: {
        text: "Mark as ready",
        onClick: this.markAsReadyCallback
      },
      withdrawAndClose: {
        isRegEWithPCGranted,
        text: "Withdraw and close",
        networkRulesActionText: "Please withdraw and close the case.",
        shouldShowModal: isRegEWithPCGranted,
        onClick: () => isRegEWithPCGranted ? this.showCloseRegECaseModal() : this.showCaseTransitionNoteModal(TRANSITION_NOTE_MODAL_TYPES.WITHDRAW_AND_CLOSE)
      },
      withdrawCloseCase: {
        text: "Close case",
        networkRulesActionText: "Please close the case.",
        onClick: () => this.showCaseTransitionNoteModal(TRANSITION_NOTE_MODAL_TYPES.WITHDRAW_AND_CLOSE),
        showInActionsCell: isFileManagementViewMode
      },
      close: {
        isRegEWithPCGranted,
        useWriteOffV2,
        shouldShowModal: isRegEWithPCGranted || useWriteOffV2,
        text: "Close case",
        networkRulesActionText: "Please close the case.",
        onClick: () => isRegEWithPCGranted || useWriteOffV2 ? this.showCloseRegECaseModal() : this.showCaseTransitionNoteModal(TRANSITION_NOTE_MODAL_TYPES.CLOSE),
        showInActionsCell: isFileManagementViewMode
      }
    };
  }
  // Mapped actions by access, type and state of dispute
  get caseTransitionActionsMap() {
    const legacySubmitNetworkActions = this.isLegacyDisputeType && this.disputesAccess.hasRiskInternalRole ? [this.caseTransitionActions.submitToNetwork] : [];
    const {
      useWriteOffV2
    } = this;
    return {
      base: {
        [DISPUTES.DISPUTE]: {
          [STATE_MAP.CLOSED]: [],
          [STATE_MAP.READY]: [this.caseTransitionActions.readyBaseBtn, this.caseTransitionActions.close],
          [STATE_MAP.OPEN]: [this.caseTransitionActions.markAsReady, this.caseTransitionActions.close],
          [STATE_MAP.OPEN_WITH_ACTION_REQUIRED]: [useWriteOffV2 ? this.caseTransitionActions.close : this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.CHARGEBACK_INITIATED]: []
        },
        [DISPUTES.LEGACY_DISPUTE]: {
          [STATE_MAP.CLOSED]: [],
          [STATE_MAP.READY]: [this.caseTransitionActions.readyBaseBtn, this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.OPEN]: [this.caseTransitionActions.markAsReady, this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.OPEN_WITH_ACTION_REQUIRED]: [this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.CHARGEBACK_INITIATED]: []
        }
      },
      fullAccess: {
        [DISPUTES.DISPUTE]: {
          [STATE_MAP.CLOSED]: [],
          [STATE_MAP.READY]: [this.caseTransitionActions.submitToNetwork, this.caseTransitionActions.readyBaseBtn, this.caseTransitionActions.close],
          [STATE_MAP.OPEN]: [this.caseTransitionActions.markAsReady, this.caseTransitionActions.close],
          [STATE_MAP.OPEN_WITH_ACTION_REQUIRED]: [useWriteOffV2 ? this.caseTransitionActions.close : this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.CHARGEBACK_INITIATED]: []
        },
        [DISPUTES.LEGACY_DISPUTE]: {
          [STATE_MAP.CLOSED]: [],
          [STATE_MAP.READY]: [...legacySubmitNetworkActions, this.caseTransitionActions.readyBaseBtn, this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.OPEN]: [this.caseTransitionActions.markAsReady, this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.OPEN_WITH_ACTION_REQUIRED]: [this.caseTransitionActions.withdrawAndClose],
          [STATE_MAP.CHARGEBACK_INITIATED]: []
        }
      }
    };
  }
  // Available case transitions(Array) by access, type and state of dispute.
  get availableCaseTransitions() {
    if (!this.transitions)
      return [];
    const actions2 = this.hasFullDisputesAccess ? this.caseTransitionActionsMap.fullAccess : this.caseTransitionActionsMap.base;
    return actions2[this.type] && actions2[this.type][this.state] ? actions2[this.type][this.state] : [];
  }
  get filteredProgramConfigs() {
    const {
      additional_dispute_details,
      cardholder_contact_date,
      dispute_reason
    } = this.dispute_details || EMPTY_OBJECT;
    const {
      settlement_date
    } = this.transaction || EMPTY_OBJECT;
    const {
      regulation_subcategory
    } = additional_dispute_details;
    const localSettlementDate = toLocal(settlement_date);
    const dateDelta = numberOfDaysBetween(cardholder_contact_date, localSettlementDate);
    if (isNotPresent(dispute_reason) || isNotPresent(cardholder_contact_date) || isNotPresent(regulation_subcategory)) {
      return [];
    }
    try {
      return this.programConfigs.enabledRegEItems.filter(({
        template_criteria,
        filter_constraint
      }) => {
        const {
          category,
          values
        } = filter_constraint || EMPTY_OBJECT;
        const hasDisputeReason = template_criteria?.dispute_reason === dispute_reason;
        const hasDeltaWithinDates = values?.min_days <= dateDelta && values?.max_days > dateDelta;
        const hasCountryCode = template_criteria?.country_code === this.applicationPropertiesCountryCode;
        const hasCategory = category === regulation_subcategory;
        return hasDisputeReason && hasDeltaWithinDates && hasCountryCode && hasCategory;
      });
    } catch (err) {
      console.error(err);
      return [];
    }
  }
  get applicationPropertiesCountryCode() {
    const {
      getApplicationPropertyCountryCode
    } = disputeStorage || EMPTY_OBJECT;
    return getApplicationPropertyCountryCode && getApplicationPropertyCountryCode();
  }
  get isEUUKProgram() {
    return Boolean(EU_UK_REG_E_COUNTRY_CODES[this.applicationPropertiesCountryCode]);
  }
  get meetsRegECriteria() {
    return this.filteredProgramConfigs.length > 0;
  }
  get isEditing() {
    return [STATE_MAP.OPEN, STATE_MAP.OPEN_WITH_ACTION_REQUIRED].includes(this.state);
  }
  get fileCanBeDeleted() {
    const {
      dispute_state
    } = this.dispute_details || {};
    return this.isEditing || [DISPUTE_STATE_MAP.INITIATED, DISPUTE_STATE_MAP.REPRESENTMENT].includes(dispute_state);
  }
  get initiatedWithResponse() {
    return this.isInitiated && this.next_actor === "ISSUER";
  }
  get isInitiated() {
    return this.state === STATE_MAP.CHARGEBACK_INITIATED;
  }
  get actionableState() {
    if (this.isEditing || this.initiatedWithResponse) {
      return "Action required";
    } else if (this.state === STATE_MAP.CLOSED) {
      return "Complete";
    } else {
      return "Awaiting response";
    }
  }
  get partialDisputeAmountFromATR() {
    const {
      cumulativeSelectedAmount
    } = this.associated_transactions || {};
    const atrDifference = parseFloat(this.originalDisputeAmount) - parseFloat(cumulativeSelectedAmount);
    return parseFloat(formatMoneyAmount(atrDifference));
  }
  get showNetworkDetails() {
    const hasMinRequiredAttrs = dig(this.dispute_details, "network_case_status_details", "presentationalAttributesCount");
    return Boolean([STATE_MAP.CHARGEBACK_INITIATED, STATE_MAP.CLOSED].includes(this.state) && hasMinRequiredAttrs);
  }
  get shouldBlockReturnToTransactions() {
    return !reroutableStates.includes(this.state);
  }
  // eslint-disable-next-line getter-return
  get formattedChipOnCard() {
    const chipOnCard = this.digDetails("chip_on_card");
    if (chipOnCard) {
      return "Yes";
    } else if (chipOnCard === false) {
      return "No";
    }
  }
  get currentRouteIsQueue() {
    const path = window.location.pathname;
    const queuePath = "/risk/disputes";
    return path === queuePath;
  }
  get includeAttachedContents() {
    const hasDocuments = Boolean(this.disputeFileManager.attachedToForm.size);
    const isCorrectAction = SUBMISSION_ACTION_OPTIONS.includes(this.transitions.action);
    return hasDocuments && isCorrectAction;
  }
  get isViewOnly() {
    return [STATE_MAP.READY, STATE_MAP.CHARGEBACK_INITIATED, STATE_MAP.CLOSED].includes(this.state);
  }
  get disputeState() {
    try {
      this.dispute_transitions.items.sort((a, b) => {
        return new Date(b.network_details.created_time) - new Date(a.network_details.created_time);
      });
      return this.dispute_transitions.items[0].network_details.dispute_state;
    } catch (e) {
      return null;
    }
  }
  get networkIntegrations() {
    const {
      getCaseServiceIntegration
    } = disputeStorage || {};
    const caseServiceIntegrations = getCaseServiceIntegration();
    [this.serviceIntegrations, caseServiceIntegrations].forEach((item) => item);
    if (!caseServiceIntegrations || typeof caseServiceIntegrations !== "object" || !this.serviceIntegrations) {
      return null;
    }
    const integrations = caseServiceIntegrations[this.transaction.network] || this.serviceIntegrations[this.transaction.network];
    return integrations || null;
  }
  get reasonIntegrations() {
    if (this.isNetworkIntegrated) {
      return this.networkIntegrations.dispute_reasons;
    }
    return null;
  }
  get isNetworkIntegrated() {
    if (this.transaction.network === "MASTERCARD" && this.transaction.subnetwork === "MAESTRO") {
      return false;
    }
    if (this.transaction.network === "PULSE" && flipFlop.get("pulse-integration-enabled", false) === false) {
      return false;
    }
    return Boolean(this.networkIntegrations);
  }
  get isReasonIntegrated() {
    if (!this.reasonIntegrations) {
      return false;
    }
    const {
      dispute_reason
    } = this.dispute_details;
    if (dispute_reason === "") {
      return true;
    }
    return this.reasonIntegrations.includes(dispute_reason);
  }
  get isTransactionIntegrated() {
    if (!this.isNetworkIntegrated) {
      return false;
    }
    const {
      transaction_types = []
    } = this.networkIntegrations;
    const {
      type
    } = this.transaction;
    return transaction_types.includes(type);
  }
  get isLegacyDisputeType() {
    return this.type === DISPUTES.LEGACY_DISPUTE;
  }
  get allPreviouslyAttachedFiles() {
    const attached = /* @__PURE__ */ new Set();
    [...this.getAttachedContents(this.dispute_transitions?.items, "network_details", Object.values(DISPUTE_TRANSITION_DETAILS_NAMES))].forEach((item) => attached.add(item));
    return attached;
  }
  // helpers
  getAttachedContents(items = [], mainKey = "", keys2 = []) {
    let attachedContents = [];
    items.forEach((item) => {
      keys2.forEach((key) => {
        const attached = this.dig(item, mainKey, key, "attached_contents");
        if (attached) {
          attachedContents = [...attachedContents, ...attached];
        }
      });
    });
    return attachedContents;
  }
  handleATRSuccess(data, payload = {}, successCallback, successMessage = "Dispute moved to ready state") {
    const partialErrors = [];
    const {
      submitATRAndTransition
    } = data || {};
    const {
      updateCase,
      createAssociatedTransactionsSelection,
      updateAssociatedTransactionsSelection,
      createCaseTransition
    } = submitATRAndTransition || {};
    if (payload.updateCase) {
      if (!updateCase)
        partialErrors.push("updateCase");
    }
    if (payload.createAssociatedTransactionsSelection) {
      if (!createAssociatedTransactionsSelection)
        partialErrors.push("createAssociatedTransactionsSelection");
    }
    if (payload.updateAssociatedTransactionsSelection) {
      if (!updateAssociatedTransactionsSelection)
        partialErrors.push("updateAssociatedTransactionsSelection");
    }
    if (payload.createCaseTransition) {
      if (!createCaseTransition)
        partialErrors.push("createCaseTransition");
      else {
        const {
          state: newState,
          reason_code: reasonCode,
          failure_reason: failureReason,
          reason_description: reasonDescription = "",
          action: newAction
        } = createCaseTransition || {};
        const hasError = Boolean(transitionReasonCodeFailures[reasonCode]) || Boolean(reasonCode) && Boolean(failureReason);
        if (hasError) {
          const message = newAction === CHANGE_CASE_TYPE ? CONVERTED_STATE_TEXT : newState ? getStateMessage(newState) : "";
          this.showAndLogAlert(`${message}. ${reasonDescription}. `, {
            modalHeading: "Unable to transition the case",
            withSupportLink: true,
            apiMessage: failureReason
          });
          return;
        }
      }
    }
    if (partialErrors.length === Object.keys(payload).length) {
      this.showAndLogAlert(`There was an issue with ATR selection, please wait a few minutes and try again.`);
    } else {
      this.handleSuccess(successMessage, successCallback);
    }
  }
  handleSuccess(message, successCallback) {
    const {
      setAlert: setAlert2
    } = alertStore || {};
    if (successCallback instanceof Function) {
      successCallback(setAlert2);
    }
    if (!message || !(setAlert2 instanceof Function))
      return;
    const options = {
      alertType: TOAST,
      type: "success"
    };
    setAlert2(message, options);
  }
  handleTransitionSuccess({
    newState,
    reasonCode,
    reasonDescription,
    failureReason,
    newAction,
    payload
  }) {
    const {
      removeCreationOrigin
    } = disputeStorage || {};
    let message = "";
    if (newState) {
      this.state = newState;
      message = getStateMessage(newState);
    }
    if (newAction === CHANGE_CASE_TYPE) {
      message = CONVERTED_STATE_TEXT;
    }
    const {
      eventProperties,
      eventName
    } = this.currentEventInfo(payload);
    const hasError = Boolean(transitionReasonCodeFailures[reasonCode]) || Boolean(reasonCode) && Boolean(failureReason);
    if (hasError) {
      removeCreationOrigin();
      let failureMessage = `${message}.`;
      if (reasonDescription) {
        failureMessage = `${failureMessage} ${reasonDescription}.`;
      }
      this.showAndLogAlert(failureMessage, {
        modalHeading: "Unable to submit to network",
        withSupportLink: true,
        apiMessage: failureReason
      });
      disputesSegmentTrackEvent(eventName, {
        ...eventProperties,
        errorStatus: true
      });
      return;
    }
    disputesSegmentTrackEvent(eventName, {
      ...eventProperties,
      errorStatus: false
    });
    this.handleSuccess(message || "Dispute moved to new state");
  }
  setServiceIntegrations(integrations) {
    this.serviceIntegrations = integrations;
  }
  showAndLogAlert(alertMessage, options = {}) {
    const {
      setAlert: setAlert2
    } = alertStore || {};
    if (setAlert2) {
      setAlert2(alertMessage, {
        ...options,
        showLog: true
      });
    }
  }
  fetchNetworkAttr(attr) {
    try {
      const {
        network_case_status_details
      } = this.dispute_details;
      if (network_case_status_details && network_case_status_details[attr]) {
        const value = network_case_status_details[attr];
        if (attr === "next_actor") {
          return getKeyByValue(ACTOR_OPTIONS, value);
        }
        return value;
      }
      throw `${attr} not found.`;
    } catch {
      return "";
    }
  }
  digDetails(attr) {
    if (typeof attr !== "string") {
      return null;
    }
    if (this[attr]) {
      return this[attr];
    }
    if (digIsPresent(this.dispute_details, attr)) {
      return this.dispute_details[attr];
    }
    if (digIsPresent(this.dispute_details, "network_case_status_details", attr)) {
      return this.dispute_details.network_case_status_details[attr];
    }
    if (digIsPresent(this.dispute_details, "additional_dispute_details", attr)) {
      return this.dispute_details.additional_dispute_details[attr];
    }
    if (digIsPresent(this.dispute_details, "fraud_dispute_type_details", "general_fraud_type_dispute_details", attr)) {
      return this.dispute_details.fraud_dispute_type_details.general_fraud_type_dispute_details[attr];
    }
  }
  loadAssociatedTransactions(associatedTransactions) {
    this.loadAndConstructItem("associated_transactions", associatedTransactions, ATRListStore);
    const {
      items: transitionItems = []
    } = this.transitions;
    const hasTransition = transitionItems.length > 1;
    const {
      setAttr,
      noTransactionsAreAssociated
    } = this.associated_transactions;
    if (this.isViewOnly || hasTransition) {
      setAttr("notAssociated", noTransactionsAreAssociated);
    }
  }
  addIsDisputeImpactedByRegToQuestionnairePayload(questionnairePayload) {
    try {
      if (flipFlop.get("disputes-nw-mandates-april-2024", false) && this?.dispute_details?.dispute_reason === "CANCELLED_RECURRING_TRANSACTION" && typeof questionnairePayload?.consumer_dispute_type_dispute_details?.cancelled_recurring_transaction_details === "object") {
        questionnairePayload.consumer_dispute_type_dispute_details.cancelled_recurring_transaction_details.is_dispute_impacted_by_local_law_or_regulation = this.is_dispute_impacted_by_local_law_or_regulation;
      }
    } catch (error) {
      console.error("unable to add is_dispute_impacted_by_local_law_or_regulation to payload", error);
    } finally {
      return questionnairePayload;
    }
  }
  get otherAmount() {
    const {
      dispute_amount
    } = this.dispute_details || EMPTY_OBJECT;
    return this.shouldUseATRPartialAmount ? this.partialDisputeAmountFromATR : parseFloat(dispute_amount);
  }
  get otherDisputeAmountErrorMessage() {
    const {
      selectedCount
    } = this.associated_transactions || EMPTY_OBJECT;
    const amountIsChanged = this.partialDisputeAmountFromATR !== this.otherAmount;
    const hasATRs = !this.shouldUseATRPartialAmount && selectedCount;
    if (this.atrRequired) {
      if (hasATRs && amountIsChanged)
        return DISPUTE_OTHER_AMOUNT_NOT_EQUAL_TO_ATR_SUM;
    }
    return "";
  }
  get showPCGrantError() {
    return this.isEditing ? this.otherAmount != this.originalDisputeAmount : false;
  }
  get useWriteOffV2() {
    const {
      dispute_state,
      isRegE,
      isPCGranted
    } = this.dispute_details;
    return !isRegE && !dispute_state && !isPCGranted && this.programConfigs && this.programConfigs.isWriteOfV2FlagEnabled;
  }
}
decorate(DisputeStore, {
  // values
  alertStore: observable,
  assignee: observable,
  associated_transactions: observable,
  business_token: observable,
  cardholder_token: observable,
  cardholder: observable,
  created_time: observable,
  disputesAccess: observable,
  dispute_details: observable,
  dispute_transitions: observable,
  documentModalVisible: observable,
  documents: observable,
  edits: observable,
  formSubmitted: observable,
  last_modified_time: observable,
  loading: observable,
  memo: observable,
  network_comment: observable,
  milestones: observable,
  originIsTransactions: observable,
  parentCardholder: observable,
  preventReload: observable,
  program_short_code: observable,
  serviceIntegrations: observable,
  skipAutoLoad: observable,
  state: observable,
  token: observable,
  transaction: observable,
  transitions: observable,
  type: observable,
  type_change_time: observable,
  useATRBasedDisputeAmount: observable,
  caseTransitionModalConfig: observable,
  selectedCaseType: observable,
  showProvisionalCreditModal: observable,
  showCommunicationDateModal: observable,
  issuePCreditAndSubmit: observable,
  disputeFileManager: observable,
  programConfigs: observable,
  originalDisputeAmount: observable,
  chargeback: observable,
  chargeback_transitions: observable,
  is_dispute_impacted_by_local_law_or_regulation: observable,
  notes: observable,
  // actions
  constructAndHydrateTransaction: action.bound,
  createCase: action.bound,
  hydrate: action.bound,
  hydrateCardholders: action.bound,
  hydrateRegEData: action.bound,
  getRegECaseEvents: action.bound,
  getChargeback: action.bound,
  getRegECaseMilestones: action.bound,
  loadFullInfoResult: action.bound,
  loadOrHydrateCardholder: action.bound,
  markAsReadyCallback: action.bound,
  setDigDetails: action.bound,
  setDisputeTransitionsStore: action.bound,
  setServiceIntegrations: action.bound,
  setTransitionsStore: action.bound,
  submitATRAndTransition: action.bound,
  submitATRAndWithdraw: action.bound,
  toggleATRBasedDisputeAmount: action.bound,
  transitionWrap: action.bound,
  updateCase: action.bound,
  updateNetworkCaseNumber: action.bound,
  updateZendeskId: action.bound,
  verifyAndLoadAuxDetails: action.bound,
  // helpers
  digDetails: action.bound,
  fetchNetworkAttr: action.bound,
  handleATRSuccess: action.bound,
  handleSuccess: action.bound,
  handleTransitionSuccess: action.bound,
  createCaseAction: action.bound,
  createCaseEvent: action.bound,
  loadAssociatedTransactions: action.bound,
  showAndLogAlert: action.bound,
  showCaseTransitionNoteModal: action.bound,
  toggleProvisionalCreditModal: action.bound,
  toggleCommunicationDateModal: action.bound,
  submitToNetworkHandler: action.bound,
  setIssuePCreditAndSubmit: action.bound,
  hideCaseTransitionNoteModal: action.bound,
  // computed
  actionableState: computed,
  applicationPropertiesCountryCode: computed,
  atrRequired: computed,
  atrValidation: computed,
  availableCaseTransitions: computed,
  basicFormattedDisputeReason: computed,
  changedFields: computed,
  createCasePayload: computed,
  currentRouteIsQueue: computed,
  disputeFormIsValid: computed,
  disputeState: computed,
  fileCanBeDeleted: computed,
  formattedCardholder: computed,
  formattedChipOnCard: computed,
  formattedCreatedTime: computed,
  formattedDisputeAmount: computed,
  formattedDisputeAmountChangeReason: computed,
  formattedDisputeAmountWithATR: computed,
  formattedDisputeAmountWithCurrency: computed,
  formattedDisputeReason: computed,
  formattedLastModified: computed,
  formattedState: computed,
  formValidation: computed,
  fraudReportValidation: computed,
  hasFullDisputesAccess: computed,
  includeAttachedContents: computed,
  initiatedWithResponse: computed,
  isInitiated: computed,
  isDisputeLegacy: computed,
  isEditing: computed,
  isEUUKProgram: computed,
  isFullAmount: computed,
  isLegacyDisputeType: computed,
  isMastercard: computed,
  isNetworkIntegrated: computed,
  isReasonIntegrated: computed,
  meetsRegECriteria: computed,
  isTransactionIntegrated: computed,
  isViewOnly: computed,
  isVisa: computed,
  isVisaDisputeReasonSelected: computed,
  isPulse: computed,
  isPulseDisputeReasonSelected: computed,
  isFraudDisputeReason: computed,
  isVisaFraudReasonCode: computed,
  isFraudCase: computed,
  networkIntegrations: computed,
  partialDisputeAmountFromATR: computed,
  shouldBlockReturnToTransactions: computed,
  shouldUseATRPartialAmount: computed,
  shouldShowConvertToNonIntegrated: computed,
  showNetworkDetails: computed,
  updateCasePayload: computed,
  updateWithATRPayload: computed,
  allPreviouslyAttachedFiles: computed,
  filteredProgramConfigs: computed,
  shouldCalculateDisputeAmount: computed,
  showPCGrantError: computed,
  useWriteOffV2: computed,
  isAFTTransaction: computed,
  isAuthorizationReasonCode: computed
});
const transtionCaseWithNoteModal = (dispute) => {
  const {
    transitions,
    caseTransitionModalConfig,
    hideCaseTransitionNoteModal,
    dispute_details: {
      isRegEWithPCGranted,
      isRegE
    } = EMPTY_OBJECT,
    submitATRAndWithdraw
  } = dispute || EMPTY_OBJECT;
  const isRegEWithPCNotGranted = isRegE && !isRegEWithPCGranted;
  const {
    setAttr,
    transitionToClosed,
    transitionToOpen,
    transitionToWithdrawnAndClosed
  } = transitions || EMPTY_OBJECT;
  const {
    action: action2
  } = caseTransitionModalConfig || EMPTY_OBJECT;
  const onMemoChange = (value) => setAttr("memo", value);
  const handleTransitionSubmit = (action22) => {
    const disputeTransitions = {
      [TRANSITION_ACTIONS.CLOSE]: isRegEWithPCNotGranted ? transitionToWithdrawnAndClosed : transitionToClosed,
      [TRANSITION_ACTIONS.RE_OPEN]: transitionToOpen,
      [TRANSITION_ACTIONS.WITHDRAW_AND_CLOSE]: submitATRAndWithdraw
    };
    hideCaseTransitionNoteModal();
    disputeTransitions[action22] && disputeTransitions[action22]();
  };
  return {
    ...transitions || EMPTY_OBJECT,
    ...caseTransitionModalConfig || EMPTY_OBJECT,
    onMemoChange,
    transitionCase: () => handleTransitionSubmit(action2),
    hide: hideCaseTransitionNoteModal,
    isModalVisible: Boolean(action2)
  };
};
const useManualTransition = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);
  return {
    isModalOpen,
    openModal,
    closeModal
  };
};
const fraudReportContainer = "_fraudReportContainer_1g7w9_1";
const fraudStatusText = "_fraudStatusText_1g7w9_9";
const s$3 = {
  fraudReportContainer,
  fraudStatusText
};
const FraudReport = ({
  fraudType
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$3.fraudReportContainer, "data-testid": "fraud-report", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Fraud report" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", className: s$3.fraudStatusText, children: "Sent to network" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "confirmed", overrideColor: Colors.statusSuccessColor })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", children: "Fraud type" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", testId: "fraud-report-category", children: FRAUD_TYPES[fraudType] })
  ] });
};
FraudReport.propTypes = {
  fraudType: PropTypes.string
};
FraudReport.defaultProps = {
  fraudType: ""
};
const DisputeDetailsViewOnly = ({
  disputeDetails = [],
  questionnaireDetails = [],
  documents: documents2 = [],
  state
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    disputeDetails.map(({
      label,
      value
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label, children: value }, label)),
    questionnaireDetails.map(({
      label,
      value
    }) => /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label, children: value }, label)),
    state !== STATE_MAP.CHARGEBACK_INITIATED && /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocuments$1, { customFilter: (file) => file.isAttached, documentsStore: documents2, isEditing: false })
  ] });
};
DisputeDetailsViewOnly.propTypes = {
  disputeDetails: PropTypes.array,
  questionnaireDetails: PropTypes.array,
  documents: PropTypes.array,
  state: PropTypes.string
};
DisputeDetailsViewOnly.defaultProps = {
  disputeDetails: [],
  questionnaireDetails: [],
  documents: [],
  state: ""
};
const DisputeDetailsWithATRViewOnly = ({
  disputeDetails = [],
  questionnaireDetails = [],
  documents: documents2 = [],
  dispute
}) => {
  const sections = [{
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Creation form" }),
    key: "creation_form",
    defaultExpanded: true,
    content: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDetailsViewOnly, { disputeDetails, questionnaireDetails, documents: documents2 })
  }, {
    title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", children: "Associated transactions selections" }),
    key: "atr_selections",
    content: /* @__PURE__ */ jsxRuntimeExports.jsx(ATRSelection$1, { dispute })
  }];
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: dds.fullWidth, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { sections, testId: "atr-view-only-accordion" }) });
};
DisputeDetailsWithATRViewOnly.propTypes = {
  disputeDetails: PropTypes.array,
  questionnaireDetails: PropTypes.array,
  documents: PropTypes.array,
  dispute: PropTypes.object
};
DisputeDetailsWithATRViewOnly.defaultProps = {
  disputeDetails: [],
  questionnaireDetails: [],
  documents: [],
  dispute: null
};
const SubmissionDetails = (props) => {
  const {
    dispute = {},
    goTo
  } = props;
  const {
    open
  } = useFileDrawerContext();
  const {
    associated_transactions,
    atrRequired: atrRequired2,
    digDetails = () => {
    },
    dispute_details = {},
    documents: documents2,
    isEditing,
    isMastercard,
    isVisa,
    disputeFileManager,
    state,
    formValidation
  } = dispute;
  const {
    presentQuestionnaireStoreFields,
    dispute_reason,
    fraud_category_type_dispute_details
  } = dispute_details;
  const {
    fraud_type: fraudType
  } = fraud_category_type_dispute_details || EMPTY_OBJECT;
  const {
    isAttachAvailable,
    detachFile
  } = disputeFileManager || EMPTY_OBJECT;
  if (isPresent(dispute_reason)) {
    delete DISPUTE_DETAILS_MAP["dispute_reason_code"];
  }
  const disputeDetails = Object.keys(DISPUTE_DETAILS_MAP).map((item) => ({
    label: DISPUTE_DETAILS_MAP[item],
    value: digDetails(item)
  }));
  const ComponentToShow = associated_transactions.count ? DisputeDetailsWithATRViewOnly : DisputeDetailsViewOnly;
  const noAttachedDocumentsError = formValidation["attached_documents"];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: classUtil(dds.disputeDetailsBody), children: [
    isVisa && isEditing && atrRequired2 && /* @__PURE__ */ jsxRuntimeExports.jsx(ReviewATRDispute$1, { isAttachAvailable, onAttachClick: open, dispute, isVisa }),
    isEditing && !atrRequired2 && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: "Attach related files" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDocumentsForm$1, { isAttachAvailable: disputeFileManager?.isAttachAvailable, documentsStore: documents2, isMastercard, isVisa, onAttachClick: open, detachFile, error: noAttachedDocumentsError }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 4 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(EditDisputeForm$1, { dispute, goTo })
    ] }),
    !isEditing && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(ComponentToShow, { dispute, disputeDetails, documents: documents2, questionnaireDetails: presentQuestionnaireStoreFields, state }),
      fraudType && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(FraudReport, { fraudType })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: dds.auxDetailsContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AuxDisputeDetails$1, { dispute, goTo }) })
  ] });
};
SubmissionDetails.propTypes = {
  dispute: PropTypes.object,
  goTo: PropTypes.func
};
SubmissionDetails.defaultProps = {
  dispute: {},
  goTo: () => {
  }
};
const SubmissionDetails$1 = observer(SubmissionDetails);
function ConvertToNonIntegratedModal(props) {
  const {
    handleSubmit,
    errors,
    hide,
    isFormSubmitted,
    memo,
    onMemoChange,
    setFormSubmission
  } = props;
  const {
    memo_error
  } = errors;
  const onConvertToNonIntegratedMemoChange = (e) => {
    setFormSubmission(false);
    onMemoChange(e.target.value);
  };
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSubmit, testId: "convert-to-non-integrated-modal-btn", type: "danger", children: "Convert case" }, "convert-to-non-integrated-modal-btn")];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { buttonText: "Convert case", footerButtons, heading: "Convert to non-integrated case", hideModal: hide, hideModalButtonText: "Cancel", showHideModalButton: true, testId: "convert-to-non-integrated-modal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: CONVERT_TO_NON_INTEGRATED_MODAL_ALERT }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { error: isFormSubmitted && memo_error, label: "Reason for converting", onChange: onConvertToNonIntegratedMemoChange, value: memo, width: 540, testId: "convert-to-non-integrated-modal-textarea" })
  ] });
}
ConvertToNonIntegratedModal.propTypes = {
  errors: PropTypes.object,
  handleSubmit: PropTypes.func,
  hide: PropTypes.func,
  isFormSubmitted: PropTypes.bool,
  memo: PropTypes.string,
  onMemoChange: PropTypes.func,
  setFormSubmission: PropTypes.func
};
ConvertToNonIntegratedModal.defaultProps = {
  errors: {},
  handleSubmit: () => {
  },
  hide: () => {
  },
  isFormSubmitted: false,
  memo: "",
  onMemoChange: () => {
  },
  setFormSubmission: () => {
  }
};
const ConvertToNonIntegratedModal$1 = observer(ConvertToNonIntegratedModal);
const convertToNonIntegratedTextContainer = "_convertToNonIntegratedTextContainer_bd6tu_1";
const s$2 = {
  convertToNonIntegratedTextContainer
};
const ConvertToNonIntegrated = ({
  errors,
  memo,
  onMemoChange,
  setTransitionsAttr,
  transitionToNonIntegrated
}) => {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [isFormSubmitted, setFormSubmission] = useState(false);
  const onSubmit = () => {
    setFormSubmission(true);
    if (Object.keys(errors).length) {
      return;
    }
    transitionToNonIntegrated();
    setModalVisibility(false);
  };
  const openModal = () => {
    setFormSubmission(false);
    setTransitionsAttr("memo", "");
    setModalVisibility(true);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$2.convertToNonIntegratedTextContainer, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { testId: "convert-to-non-integrated-text", children: [
        `${CONVERT_TO_NON_INTEGRATED_TEXT} `,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { inline: true, onClick: openModal, testId: "open-convert-modal", children: "Convert to non-integrated case" })
      ] })
    ] }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "convert-modal", children: /* @__PURE__ */ jsxRuntimeExports.jsx(ConvertToNonIntegratedModal$1, { errors, handleSubmit: onSubmit, hide: () => setModalVisibility(false), isFormSubmitted, memo, onMemoChange, setFormSubmission }) })
  ] });
};
ConvertToNonIntegrated.propTypes = {
  errors: PropTypes.object,
  memo: PropTypes.string,
  onMemoChange: PropTypes.func,
  setTransitionsAttr: PropTypes.func,
  transitionToNonIntegrated: PropTypes.func
};
ConvertToNonIntegrated.defaultProps = {
  errors: {},
  memo: "",
  onMemoChange: () => {
  },
  setTransitionsAttr: () => {
  },
  transitionToNonIntegrated: () => {
  }
};
const ConvertToNonIntegrated$1 = observer(ConvertToNonIntegrated);
const DisputesDescriptionNote = ({
  children
}) => /* @__PURE__ */ jsxRuntimeExports.jsx("pre", { style: {
  whiteSpace: "pre-line",
  wordBreak: "break-word",
  fontFamily: "Source Sans Pro"
}, children });
DisputesDescriptionNote.propTypes = {
  children: PropTypes.node.isRequired
};
const ADD_NOTES = gql`
    mutation addCaseNote($case_token: String!, $created_by: String!, $content: String) {
        addCaseNote(case_token: $case_token, created_by: $created_by, content: $content) {
            token
            createdBy
            content
            created_time
        }
    }
`;
const GET_NOTES = gql`
    query caseNotes($case_token: String!, $count: Int, $start_index: Int) {
        caseNotes(case_token: $case_token, count: $count, start_index: $start_index) {
            data {
                token
                createdBy
                content
                created_time
            }
            count
            start_index
            end_index
            is_more
        }
    }
`;
function AddDisputeNote({
  caseToken,
  dispute
}) {
  const [content2, setContent] = useState("");
  const [mutation, {
    loading: mutateLoading,
    error: mutateError
  }] = useMutation(ADD_NOTES);
  const {
    data: notesData,
    loading: notesLoading,
    refetch: refetchNotes
  } = useQuery(GET_NOTES, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
    variables: {
      case_token: caseToken
    },
    onCompleted: (notes) => {
      const notesResult = notes?.caseNotes?.data;
      if (notesResult) {
        dispute.setAttr("notes", notesResult);
      }
    }
  });
  const [notesModalVisible, showNotesModal, hideNotesModal] = useShowEntity(() => {
  }, "Notes");
  const existingNotes = notesData?.caseNotes?.data;
  const isExistingNotes = existingNotes?.length;
  const modal = /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { heading: "Notes", hideModal: hideNotesModal, showHideModalButton: false, children: [
    mutateError && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: JSON.stringify(mutateError) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
    ] }),
    isExistingNotes ? /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: notesLoading, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(History, { mode: "large", hideHeader: true, data: existingNotes ? existingNotes.map(({
        content: content22,
        createdBy,
        created_time
      }) => {
        return {
          description: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputesDescriptionNote, { children: content22 }),
          email: createdBy,
          timestamp: created_time
        };
      }) : [] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 })
    ] }) : null,
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { value: content2, onChange: (evt) => setContent(evt.target.value), rows: 2, placeholder: "Add note" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { loading: mutateLoading, onClick: async () => {
      if (!content2) {
        return;
      }
      await mutation({
        variables: {
          case_token: caseToken,
          created_by: currentUserFromStorage(),
          content: content2
        }
      });
      setContent("");
      refetchNotes();
    }, children: "Add" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 })
  ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "dispute-notes", children: [
    notesModalVisible && modal,
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { onClick: showNotesModal, type: "tertiary", children: [
      "Notes",
      isExistingNotes ? ` (${existingNotes.length})` : ""
    ] })
  ] });
}
AddDisputeNote.propTypes = {
  caseToken: PropTypes.string,
  dispute: PropTypes.any
};
AddDisputeNote.defaultProps = {
  caseToken: ""
};
const ACTIONS_ITEMS_MAX_COUNT = 3;
function DisputeDetailsHeader({
  caseToken,
  formattedState,
  availableCaseTransitions,
  goToDisputesQueue,
  previousActionLabel,
  writeOffText,
  state,
  disputeState,
  openManualTransitionModal,
  disputeTransitions,
  isRegE,
  dispute
}) {
  const {
    allowableActions = [],
    createDisputeTransition,
    newDisputeTransitionStore
  } = disputeTransitions || {};
  const {
    memo,
    setAttr,
    setAction = () => {
    },
    withWriteOff
  } = newDisputeTransitionStore || {};
  const manualTransitionButton = {
    onClick: openManualTransitionModal,
    text: "Manual Transition",
    showInActionsCell: () => false
  };
  const [showAcceptModal, triggerAcceptModal, hideAcceptModal] = useShowEntity(setAction, ACCEPT_AND_CLOSE);
  const showAcceptLiability = Array.from(allowableActions)?.includes(ACCEPT_AND_CLOSE);
  const acceptLiabilityButton = {
    onClick: triggerAcceptModal,
    text: ACTIONS_LABEL_MAP["DISPUTE"][ACCEPT_AND_CLOSE],
    showInActionsCell: () => false
  };
  const {
    manageFilesButton
  } = useFileDrawerContext();
  const transitionActions = availableCaseTransitions.filter((transition) => transition.text !== "Mark as ready");
  const disputeHeaderButtons = [...openManualTransitionModal ? [manualTransitionButton] : [], ...showAcceptLiability ? [acceptLiabilityButton] : [], manageFilesButton, ...transitionActions];
  const postfixButtons = flipFlop.get("dispute-notes", false) ? [/* @__PURE__ */ jsxRuntimeExports.jsx(AddDisputeNote, { caseToken, dispute }, "add-dispute-note")] : [];
  const setMemo = useCallback((e) => setAttr("memo", e.target.value), [setAttr]);
  const setWriteOff = useCallback((value) => setAttr("withWriteOff", value), [setAttr]);
  const formattedStateLabel = isPresent(previousActionLabel) ? `${formattedState}: ${previousActionLabel} ${writeOffText}` : formattedState;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dds.disputeDetailsHeader, "data-testid": "dispute-details-header", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Breadcrumbs, { crumbs: [{
        children: "Dispute queue",
        onClick: goToDisputesQueue
      }, {
        children: caseToken
      }] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "label", testId: "dispute-state-label", children: allCaps(formattedStateLabel) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDetailsHeaderActions, { actions: disputeHeaderButtons, state, disputeState, postfixButtons }),
    showAcceptModal && /* @__PURE__ */ jsxRuntimeExports.jsx(AcceptLiability$1, { additionalSlot: isRegE ? /* @__PURE__ */ jsxRuntimeExports.jsx(LabeledContent, { tooltip: WRITE_OFF_TOOLTIP, flexDirection: "column", label: WRITE_OFF_LABEL, children: /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { groupItems: RADIO_GROUP_ITEMS, onChange: setWriteOff, value: withWriteOff }) }) : null, hideModal: hideAcceptModal, memo, onSubmit: createDisputeTransition, setMemo, showModal: showAcceptModal })
  ] });
}
function DisputeDetailsHeaderActions({
  actions: actions2,
  state,
  disputeState,
  postfixButtons
}) {
  const {
    setIsModalVisible
  } = useContext(CloseCaseModalContext);
  const showModal = useCallback(() => {
    setIsModalVisible(true);
  }, [setIsModalVisible]);
  const buttonTestId = (text) => `dispute-details-header-action_${text}`;
  const {
    actionCells,
    buttons,
    showActionsCell
  } = useMemo(() => {
    const actionsByWorkflow = actions2?.map((action2) => {
      const {
        onClick,
        shouldShowModal
      } = action2 || EMPTY_OBJECT;
      return {
        ...action2,
        onClick: shouldShowModal ? showModal : onClick
      };
    });
    const {
      actionCells: actionCells2,
      buttons: buttons2
    } = actionsByWorkflow.reduce((memo, a) => {
      if (a.showInActionsCell && a.showInActionsCell(state, disputeState)) {
        memo.actionCells.push(a);
      } else {
        memo.buttons.push(a);
      }
      return memo;
    }, {
      actionCells: [],
      buttons: []
    });
    const showActionsCell2 = actionsByWorkflow.length > ACTIONS_ITEMS_MAX_COUNT || actionCells2.length > 0;
    return {
      actionCells: actionCells2,
      buttons: buttons2,
      showActionsCell: showActionsCell2
    };
  }, [actions2, showModal, state, disputeState]);
  const buttonList = buttons.slice(0, ACTIONS_ITEMS_MAX_COUNT).map((action2, i) => {
    const {
      text,
      onClick,
      isSplitButton,
      options,
      dropdownCustomStyle
    } = action2 || {};
    const withSpacer = actions2.length - 2 >= i && actions2.length > 1;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(Fragment, { children: [
      isSplitButton ? /* @__PURE__ */ jsxRuntimeExports.jsx(SplitButton, { testId: buttonTestId(text), options, onClick, type: "tertiary", dropdownCustomStyle, style: {
        height: "40px"
      }, children: text }) : /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { onClick, type: "tertiary", testId: buttonTestId(text), children: [
        action2.icon && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: action2.icon }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 1 })
        ] }),
        text
      ] }),
      withSpacer && /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 })
    ] }, `${text}_${i}`);
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dds.displayInlineFlex, children: [
    buttonList,
    showActionsCell && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(ActionsCell, { actions: [...actionCells, ...buttons.slice(ACTIONS_ITEMS_MAX_COUNT)] })
    ] }),
    postfixButtons ? postfixButtons.map((button2) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
      button2
    ] })) : ""
  ] });
}
DisputeDetailsHeader.propTypes = {
  caseToken: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  formattedState: PropTypes.string,
  availableCaseTransitions: PropTypes.any,
  goToDisputesQueue: PropTypes.func,
  actionIsRequired: PropTypes.bool,
  previousActionLabel: PropTypes.string,
  writeOffText: PropTypes.string,
  disputeState: PropTypes.string,
  dispute: PropTypes.any,
  openManualTransitionModal: PropTypes.func
};
DisputeDetailsHeader.defaultProps = {
  formattedState: null,
  availableCaseTransitions: [],
  goToDisputesQueue: null,
  actionIsRequired: null,
  previousActionLabel: "",
  writeOffText: ""
};
DisputeDetailsHeaderActions.propTypes = {
  state: PropTypes.string.isRequired,
  actions: PropTypes.array,
  disputeState: PropTypes.string,
  postfixButtons: PropTypes.any
};
DisputeDetailsHeaderActions.defaultProps = {
  actions: []
};
const DisputeDetailsHeader$1 = observer(DisputeDetailsHeader);
const LABEL_TEXT = "Last network refresh";
const LABEL_TOOLTIP = "The last time information on this page was synced with the network.";
function LastRefreshAttribute({
  attrWidth,
  canRefresh,
  lastRefreshDate,
  refreshNetworkData
}) {
  if (isNotPresent(lastRefreshDate)) {
    return null;
  }
  const formattedDate = relativeUpdatedTime(lastRefreshDate);
  const iconStyle = {
    cursor: "pointer"
  };
  const isRefreshAvailable = hasEnoughTimeTranspired(lastRefreshDate, 6, "hour");
  const shouldShowRefresh = canRefresh && isRefreshAvailable && typeof refreshNetworkData === "function";
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: LABEL_TEXT, tooltip: LABEL_TOOLTIP }), withSpacer: false, width: attrWidth, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", display: "inline-flex", children: [
    formattedDate,
    shouldShowRefresh && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 0.5 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { factor: 0.5, onClick: refreshNetworkData, style: iconStyle, type: "refresh" })
    ] })
  ] }) }, "lastRefreshDate");
}
LastRefreshAttribute.propTypes = {
  attrWidth: PropTypes.string,
  canRefresh: PropTypes.bool,
  lastRefreshDate: PropTypes.string,
  refreshNetworkData: PropTypes.func
};
LastRefreshAttribute.defaultProps = {
  attrWidth: "unset",
  canRefresh: false,
  lastRefreshDate: "",
  refreshNetworkData: null
};
const LastRefreshAttribute$1 = observer(LastRefreshAttribute);
function DisputeCRMDetails({
  isInternalUser,
  state,
  zendeskTicketId,
  updateZendeskId,
  caseToken,
  isLegacyDispute
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [zendeskTicketInput, setZendeskTicketInput] = useState(zendeskTicketId);
  const [errorText, setErrorText] = useState("");
  const zendeskToCRMSwitchOver = flipFlop.get("zendesk-to-crm-switch-over", false);
  const isCRMNumberEditable = isInternalUser;
  const zendeskTicketIdValue = isPresent(zendeskTicketId) ? /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { children: zendeskTicketId }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "--" });
  useEffect(() => {
    setZendeskTicketInput(zendeskTicketId);
  }, [zendeskTicketId]);
  const zendeskIdLabel = useMemo(() => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithEditButton, { text: zendeskToCRMSwitchOver ? "CRM ticket" : "Zendesk ticket", showEditModal: () => setIsModalVisible(true), isEditable: isCRMNumberEditable });
  }, [isCRMNumberEditable]);
  const handleInputChange = (val) => {
    setErrorText("");
    setZendeskTicketInput(val);
  };
  const handleSubmit = async () => {
    setIsModalVisible(false);
    setZendeskTicketInput(zendeskTicketId);
    await updateZendeskId(zendeskTicketInput, caseToken);
  };
  const handleCancelClick = () => {
    setIsModalVisible(false);
    setZendeskTicketInput(zendeskTicketId);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { width: ATTR_WIDTH$1, label: zendeskIdLabel, withSpacer: false, children: zendeskTicketIdValue }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(EditModal, { modelInputValue: zendeskTicketInput, handleInputChange, hide: handleCancelClick, onSubmit: handleSubmit, errorText, modelHeading: "Edit CRM Ticket", modelDescription: "Enter the CRM Ticket", modelInputLabel: "CRM Ticket" })
  ] });
}
DisputeCRMDetails.propTypes = {
  isInternalUser: PropTypes.bool,
  state: PropTypes.string,
  zendeskTicketId: PropTypes.string,
  updateZendeskId: PropTypes.func,
  caseToken: PropTypes.string,
  isLegacyDispute: PropTypes.bool
};
DisputeCRMDetails.defaultProps = {
  isInternalUser: false,
  state: "",
  zendeskTicketId: "",
  updateZendeskId: () => {
  },
  caseToken: "",
  isLegacyDispute: false
};
const DisputeCRMDetails$1 = observer(DisputeCRMDetails);
const ATTR_WIDTH = "33.3%";
function DisputeNetworkDetails({
  canAccessNetworkRefresh,
  caseStatus,
  isAdminUser,
  isRegE,
  lastRefreshDate,
  loading,
  networkDetailsForRender,
  network_case_number,
  presentationalAttributesCount,
  provisionalCreditStatus,
  refreshNetworkData,
  state,
  zendeskTicketId,
  updateZendeskId,
  caseToken,
  isInternalUser,
  creditType,
  rejectReason
}) {
  const {
    Initiated
  } = STATE_OPTIONS;
  const {
    permanent_credit_status,
    provisional_credit_status
  } = NETWORK_STATUS_ATTRIBUTES;
  const formattedPCStatus = useMemo(() => PROVISIONAL_CREDIT_STATUSES[provisionalCreditStatus], [provisionalCreditStatus]);
  if (!presentationalAttributesCount && !network_case_number && !zendeskTicketId && !formattedPCStatus)
    return null;
  const isChargebackInitiated = state === Initiated;
  const creditDetails = creditType === CREDIT_TYPES.PERMANENT ? permanent_credit_status : provisional_credit_status;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loading, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", flexWrap: "wrap", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeCRMDetails$1, { isInternalUser, state, zendeskTicketId, updateZendeskId, caseToken, isLegacyDispute: false }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: dds.networkDetailsItem, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { ...NETWORK_STATUS_ATTRIBUTES.network_case_number }), withSpacer: false, width: ATTR_WIDTH, hidden: isNotPresent(network_case_number), children: /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { children: network_case_number }) }, "networkCaseId") }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { ...NETWORK_STATUS_ATTRIBUTES.case_status }), withSpacer: false, width: ATTR_WIDTH, children: caseStatus }, "caseStatus"),
      isRegE && provisionalCreditStatus && /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { ...creditDetails }), withSpacer: false, width: ATTR_WIDTH, testId: "creditStatus", children: formattedPCStatus }, "provisionalCreditStatus"),
      isChargebackInitiated && Object.keys(networkDetailsForRender).map((key) => {
        const attrObject = networkDetailsForRender[key];
        const label = /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { ...attrObject });
        return /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label, withSpacer: false, width: ATTR_WIDTH, children: networkDetailsForRender[key]?.value }, key);
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(LastRefreshAttribute$1, { attrWidth: ATTR_WIDTH, canRefresh: canAccessNetworkRefresh && isAdminUser, lastRefreshDate, refreshNetworkData }),
      !!rejectReason && /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { text: "Reject Reason", tooltip: "Network reject reason" }), withSpacer: false, width: ATTR_WIDTH, children: rejectReason }, "rejectReason")
    ] }),
    (isChargebackInitiated || isPresent(lastRefreshDate)) && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
DisputeNetworkDetails.propTypes = {
  canAccessNetworkRefresh: PropTypes.bool,
  caseStatus: PropTypes.string,
  isAdminUser: PropTypes.bool,
  isRegE: PropTypes.bool,
  lastRefreshDate: PropTypes.string,
  loading: PropTypes.bool,
  networkDetailsForRender: PropTypes.object,
  network_case_number: PropTypes.string,
  presentationalAttributesCount: PropTypes.number,
  provisionalCreditStatus: PropTypes.string,
  refreshNetworkData: PropTypes.func,
  state: PropTypes.string,
  zendeskTicketId: PropTypes.string,
  updateZendeskId: PropTypes.func,
  caseToken: PropTypes.string,
  isInternalUser: PropTypes.bool,
  creditType: PropTypes.string,
  rejectReason: PropTypes.string
};
DisputeNetworkDetails.defaultProps = {
  canAccessNetworkRefresh: false,
  caseStatus: null,
  lastRefreshDate: "",
  loading: false,
  isRegE: false,
  networkDetailsForRender: {},
  network_case_number: null,
  presentationalAttributesCount: 0,
  provisionalCreditStatus: "",
  refreshNetworkData: null,
  state: null,
  zendeskTicketId: "",
  updateZendeskId: null,
  caseToken: PropTypes.string,
  isInternalUser: PropTypes.bool,
  creditType: "",
  rejectReason: ""
};
const DisputeNetworkDetails$1 = observer(DisputeNetworkDetails);
const getFailureMassageWithIcon = (message) => {
  const iconStyle = {
    marginRight: "5px"
  };
  const failureItemStyle = {
    marginTop: "4px"
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", display: "flex", style: failureItemStyle, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { style: iconStyle, type: "warning" }),
    message
  ] }) });
};
const getDescription = (transition) => {
  const hasMemo = Boolean(transition.memo);
  const hasFailure = Boolean(transition.failure_reason);
  const failureMessage = getFailureMassageWithIcon(sentenceCase(transition.failure_reason));
  if (hasMemo && !hasFailure) {
    return transition.memo;
  }
  if (hasMemo && hasFailure) {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", children: transition.memo }),
      failureMessage
    ] });
  }
  if (hasFailure && !hasMemo) {
    return failureMessage;
  }
  return `${sentenceCase(transition.reason_description)}. `;
};
const getLabel = (transition) => {
  const isTransitionedToNonIntegrated = transition.action === CHANGE_CASE_TYPE;
  if (isTransitionedToNonIntegrated) {
    return CONVERTED_TO_NON_INTEGRATED_HISTORY;
  }
  return sentenceCase(transition.state);
};
const formatTransitionNode = (transition) => {
  return {
    label: getLabel(transition),
    email: transition.action === "MANUAL_TRANSITION" ? "" : transition.created_by,
    description: getDescription(transition),
    timestamp: transition.created_date
  };
};
const transitionActionMappingToLabel = {
  PREARB_RECEIVED: "Pre-arbitration received",
  REPRESENTMENT_RECEIVED: "Representment received",
  ACCEPT_AND_CLOSE: "Accepted and closed",
  PREARB_DECLINED: "Pre-arbitration declined",
  CLOSE_WITH_CASE_WON: "Closed with case won",
  RESPOND_WITH_PREARB: "Responded with pre-arbitration",
  PREARB_ACCEPTED: "Pre-arbitration accepted",
  CLOSE_WITH_NETWORK_REJECTED: "Closed ; Network rejected",
  RESPOND_WITH_ARB: "Responded with arbitration",
  RESPOND_WITH_PREARB_RESPONSE: "Responded to pre-arbitration",
  WRITTEN_OFF_ISSUER: "Marqeta write-off",
  WITHDRAW_AND_CLOSE: "Withdrawn and closed",
  WRITTEN_OFF_PROGRAM: "Program write-off"
};
const eventNameMappingToLabel = {
  ProvisionalCreditGranted: "Provisional credit granted",
  ProvisionalCreditPerm: "Provisional credit made permanent",
  CaseLostNotificationSent: "Card holder communication sent",
  ProvisionalCreditReverted: "Provisional credit reverted"
};
const formatNetworkTransitions = (transitions) => {
  return transitions.reverse().reduce((acc, transition) => {
    const {
      created_by,
      memo,
      from_network_status,
      to_network_status,
      network_error_message,
      system_error_message,
      action: action2,
      created_time
    } = transition;
    const transitionNode = {
      memo,
      failure_reason: network_error_message || system_error_message || ""
    };
    if (from_network_status)
      transitionNode.reason_description = `${from_network_status} → ${to_network_status || from_network_status}`;
    const label = transitionActionMappingToLabel[action2];
    if (label) {
      const description = memo || transitionNode.failure_reason ? getDescription(transitionNode) : void 0;
      acc.push({
        label,
        email: created_by,
        description,
        timestamp: created_time
      });
    }
    return acc;
  }, []);
};
const formatNetworkEvents = (events) => {
  return events.reverse().reduce((acc, event) => {
    const {
      created_by,
      name,
      created_time
    } = event;
    const label = eventNameMappingToLabel[name];
    if (label) {
      acc.push({
        label,
        email: created_by,
        timestamp: created_time
      });
    }
    return acc;
  }, []);
};
const formatNotes = (notes) => {
  if (!notes) {
    return [];
  }
  return notes.map(({
    content: content2,
    createdBy,
    created_time
  }) => {
    return {
      label: "Note",
      description: /* @__PURE__ */ jsxRuntimeExports.jsx(DisputesDescriptionNote, { children: content2 }),
      email: createdBy,
      timestamp: created_time
    };
  });
};
const sortByTimestamp = (a, b) => {
  if (moment(a.timestamp) <= moment(b.timestamp))
    return 1;
  return -1;
};
function DisputeTransitionHistory({
  sortedTransitions,
  disputeTransitions,
  events,
  notes
}) {
  const formattedTransitions = sortedTransitions.map(formatTransitionNode);
  const formattedNetworkTransitions = formatNetworkTransitions(disputeTransitions);
  const formattedNetworkEvents = formatNetworkEvents(events);
  const formattedNotes = formatNotes(notes);
  const showAdditionalEvents = flipFlop.get("dispute-transition-history-enhanced", false);
  const sortedEntries = [...formattedTransitions, ...formattedNotes, ...showAdditionalEvents ? [...formattedNetworkTransitions, ...formattedNetworkEvents] : []].sort(sortByTimestamp);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(History, { data: sortedEntries, mode: "large" });
}
DisputeTransitionHistory.propTypes = {
  sortedTransitions: PropTypes.array,
  disputeTransitions: PropTypes.array,
  events: PropTypes.array,
  notes: PropTypes.any
};
DisputeTransitionHistory.defaultProps = {
  sortedTransitions: null,
  disputeTransitions: [],
  events: []
};
const DisputeTransitionHistory$1 = observer(DisputeTransitionHistory);
function LegacyDisputeNetworkDetails({
  isInternalUser,
  isRegE,
  networkCaseNumber,
  updateNetworkCaseNumber,
  provisionalCreditStatus,
  state,
  zendeskTicketId,
  updateZendeskId,
  creditType,
  caseToken
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [networkCaseInput, setNetworkCaseInput] = useState(networkCaseNumber);
  const [errorText, setErrorText] = useState("");
  const isNetworkCaseNumberEditable = state !== STATE_MAP.CLOSED && networkCaseNumber?.length === 0 && isInternalUser;
  const alphanumericRegex = /[^A-Za-z0-9]/g;
  const hasError = alphanumericRegex.test(networkCaseInput);
  const {
    permanent_credit_status,
    provisional_credit_status
  } = NETWORK_STATUS_ATTRIBUTES;
  const creditDetails = creditType === CREDIT_TYPES.PERMANENT ? permanent_credit_status : provisional_credit_status;
  useEffect(() => {
    setNetworkCaseInput(networkCaseNumber);
  }, [networkCaseNumber]);
  const networkCaseNumberLabel = useMemo(() => {
    return /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithEditButton, { text: "Network Case ID", showEditModal: () => setIsModalVisible(true), isEditable: isNetworkCaseNumberEditable });
  }, [isNetworkCaseNumberEditable]);
  const handleNetworkCaseInputChange = (val) => {
    setErrorText("");
    setNetworkCaseInput(val);
  };
  const handleSubmit = async () => {
    if (hasError) {
      setErrorText("Should contain only alphanumerical values");
      return;
    }
    setIsModalVisible(false);
    setNetworkCaseInput(networkCaseNumber);
    await updateNetworkCaseNumber(networkCaseInput);
  };
  const handleCancelClick = () => {
    setIsModalVisible(false);
    setNetworkCaseInput(networkCaseNumber);
  };
  const networkCaseNumberValue = isPresent(networkCaseNumber) ? /* @__PURE__ */ jsxRuntimeExports.jsx(CopyToClipboard, { children: networkCaseNumber }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: "--" });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "legacy-dispute-network-details", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeCRMDetails$1, { isInternalUser, state, zendeskTicketId, updateZendeskId, caseToken, isLegacyDispute: true }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { width: ATTR_WIDTH$1, label: networkCaseNumberLabel, withSpacer: false, children: networkCaseNumberValue }),
      isRegE && provisionalCreditStatus && /* @__PURE__ */ jsxRuntimeExports.jsx(Attribute$1, { label: /* @__PURE__ */ jsxRuntimeExports.jsx(LabelWithTooltip$1, { ...creditDetails }), withSpacer: false, width: ATTR_WIDTH$1, testId: "creditStatus", children: PROVISIONAL_CREDIT_STATUSES[provisionalCreditStatus] }, "provisionalCreditStatus")
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(EditNetworkCaseNumberModal, { networkCaseInput, handleNetworkCaseInputChange, hide: handleCancelClick, onSubmit: handleSubmit, errorText })
  ] });
}
LegacyDisputeNetworkDetails.propTypes = {
  isInternalUser: PropTypes.bool,
  isRegE: PropTypes.bool,
  networkCaseNumber: PropTypes.string,
  updateNetworkCaseNumber: PropTypes.func,
  provisionalCreditStatus: PropTypes.string,
  state: PropTypes.string,
  zendeskTicketId: PropTypes.string,
  updateZendeskId: PropTypes.func,
  creditType: PropTypes.string,
  caseToken: PropTypes.string
};
LegacyDisputeNetworkDetails.defaultProps = {
  isInternalUser: false,
  isRegE: PropTypes.bool,
  networkCaseNumber: "",
  updateNetworkCaseNumber: () => {
  },
  provisionalCreditStatus: "",
  state: "",
  zendeskTicketId: "",
  updateZendeskId: () => {
  },
  creditType: "",
  caseToken: ""
};
const LegacyDisputeNetworkDetails$1 = observer(LegacyDisputeNetworkDetails);
function IssueProvisionalCreditModal(props) {
  const {
    formattedDisputeAmountWithCurrency,
    handleSubmit,
    hide,
    isSourceBanner,
    creditType,
    errors
  } = props;
  const TEXT2 = isSourceBanner ? formatPCBannerCTAText(formattedDisputeAmountWithCurrency, creditType) : formatPCSubmitNetworkText(formattedDisputeAmountWithCurrency, creditType);
  const handleClick = () => {
    const action_type = ACTION_TYPES.GRANT_PROVISIONAL_CREDIT;
    handleSubmit(action_type);
    hide();
  };
  const errorsExists = Boolean(errors?.length);
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleClick, testId: "issue-provisional-credit-modal-btn", type: "primary", disabled: errorsExists, children: "Confirm" }, "issue-provisional-credit-modal-btn")];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { type: "sm", buttonText: "Confirm", footerButtons, heading: `Issue the ${creditType} credit`, hideModal: hide, hideModalButtonText: "Cancel", testId: "issue-provisional-credit-modal", children: [
    errorsExists && errors.map((error) => /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { type: "error", children: [
        " ",
        error
      ] }, error),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] })),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: TEXT2 })
  ] });
}
IssueProvisionalCreditModal.propTypes = {
  formattedDisputeAmountWithCurrency: PropTypes.string,
  isSourceBanner: PropTypes.bool,
  handleSubmit: PropTypes.func,
  hide: PropTypes.func,
  creditType: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string)
};
IssueProvisionalCreditModal.defaultProps = {
  formattedDisputeAmountWithCurrency: "",
  isSourceBanner: true,
  handleSubmit: () => {
  },
  hide: () => {
  },
  creditType: "",
  errors: []
};
function IssueProvisionalCreditBanner(props) {
  const {
    banner,
    showModal
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "issue-provisional-credit-banner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { children: [
      banner,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { inline: true, testId: "issue-provisional-credit-btn", onClick: () => showModal(true), children: "Click here to issue" })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
IssueProvisionalCreditBanner.propTypes = {
  banner: PropTypes.string,
  showModal: PropTypes.func
};
IssueProvisionalCreditBanner.defaultProps = {
  banner: "",
  showModal: () => {
  }
};
function CommunicationDateBanner(props) {
  const {
    banner,
    showModal
  } = props;
  const handleClick = useCallback(() => showModal(true), [showModal]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: dds.milestoneBannerAlert, "data-testid": "communication-date-banner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { children: [
      banner,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { inline: true, testId: "communication-date-btn", onClick: handleClick, children: ENTER_COMMUNICATION_DATE_CTA })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
CommunicationDateBanner.propTypes = {
  banner: PropTypes.string,
  showModal: PropTypes.func
};
CommunicationDateBanner.defaultProps = {
  banner: "",
  showModal: () => {
  }
};
const DATE_TIME_CUSTOM_STYLE = {
  width: "100%"
};
function CommunicationDateModal(props) {
  const {
    handleSubmit,
    minDate,
    hide
  } = props;
  const [eventDate, setEventDate] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const handleConfirm = () => {
    const name = EVENT_TYPES.CASE_LOST_NOTIFICATION_SENT;
    setFormSubmitted(true);
    if (!getFormErrors()) {
      handleSubmit(name, eventDate);
      hide();
    }
  };
  const handleDateChange = (value) => {
    setFormSubmitted(false);
    setEventDate(value);
  };
  const getFormErrors = () => {
    const dateIsInFuture = isDateInFuture(eventDate);
    if (!eventDate) {
      return COMMUNICATION_TIME_IS_REQUIRED;
    }
    if (dateIsInFuture) {
      return COMMUNICATION_TIME_IN_FUTURE;
    }
  };
  const formErrors = useMemo(() => formSubmitted && getFormErrors(), [formSubmitted, getFormErrors]);
  const footerButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleConfirm, testId: "enter-communication-date-modal-btn", type: "primary", children: "Confirm" }, "enter-communication-date-modal-btn")];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { type: "sm", buttonText: "Confirm", footerButtons, heading: "Enter communication time", hideModal: hide, hideModalButtonText: "Cancel", testId: "enter-communication-date-modal", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: ENTER_COMMUNICATION_DATE_MODAL_TEXT }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DateTimeInput, { formLabel: CARDHOLDER_COMMUNICATION_TIME_LABEL, testId: "enter-communication-date-input", inputId: "enter-communication-date-input", value: formatDateForDateTimeInput(eventDate), error: formErrors, onChange: handleDateChange, customStyles: DATE_TIME_CUSTOM_STYLE, max: moment(), min: minDate })
  ] });
}
CommunicationDateModal.propTypes = {
  handleSubmit: PropTypes.func,
  minDate: PropTypes.string,
  hide: PropTypes.func
};
CommunicationDateModal.defaultProps = {
  handleSubmit: () => {
  },
  minDate: "",
  hide: () => {
  }
};
const formatNetworkRuleAction = (availableCaseTransitions) => {
  if (!availableCaseTransitions && availableCaseTransitions.length) {
    return "";
  }
  const closeActions = availableCaseTransitions.filter((transition) => transition.networkRulesActionText);
  return closeActions[0]?.networkRulesActionText || "";
};
const formatFailureReason = (reason) => {
  return NETWORK_RULES_FAILURE_REASONS[reason] || `${reason}.`;
};
const NetworkRulesBanner = ({
  failureReason,
  availableCaseTransitions
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "network-rules-banner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { type: "error", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", inline: false, children: formatNetworkRuleAction(availableCaseTransitions) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body-sm", inline: false, children: formatFailureReason(failureReason) })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
};
NetworkRulesBanner.propTypes = {
  failureReason: PropTypes.string,
  availableCaseTransitions: PropTypes.array
};
NetworkRulesBanner.defaultProps = {
  failureReason: "",
  availableCaseTransitions: []
};
const ERROR_OPTIONS = {
  alertType: MODAL,
  withSupportLink: true
};
const SUCCESS_OPTIONS = {
  alertType: TOAST,
  type: "success"
};
const useAlertStore = () => {
  const {
    setAlert: setAlert2
  } = alertStore || {};
  const setError = useCallback((rawError, defaultMessage, OPTION_OVERRIDE = {}) => {
    const message = rawError && formatNetworkError(rawError) || "";
    if (/409|item_name_in_use/gi.test(message)) {
      return setAlert2("Item with the same name already exists.", ERROR_OPTIONS);
    }
    return setAlert2(defaultMessage, {
      ...ERROR_OPTIONS,
      apiMessage: message,
      ...OPTION_OVERRIDE
    });
  }, [setAlert2]);
  const setSuccess = useCallback((message) => {
    setAlert2(message, SUCCESS_OPTIONS);
  }, [setAlert2]);
  return {
    setError,
    setSuccess
  };
};
const MANUAL_TRANSITION_LABEL = "Manual State Transition";
const caseStates = ["NONE", "OPEN", "OPEN_WITH_ACTION_REQUIRED", "READY", "CHARGEBACK_INITIATED", "PENDING_CLOSE", "CLOSED"];
const disputeStates = ["INITIATED", "REPRESENTMENT", "PRE_ARBITRATION", "PREARB_RESPONDED", "ARBITRATION", "CASE_WON", "CLOSED", "NETWORK_REJECTED", "CASE_LOST", "WRITTEN_OFF_ISSUER", "WRITTEN_OFF_PROGRAM"];
const chargebackStates = ["PRE_INITIATED", "INITIATED", "REPRESENTMENT", "PREARBITRATION", "PREARB_RESPONDED", "ARBITRATION", "CASE_WON", "CASE_LOST", "NETWORK_REJECTED", "WRITTEN_OFF_ISSUER", "WRITTEN_OFF_MARQETA", "WRITTEN_OFF_PROGRAM", "WITHDRAWN"];
const makeOptions = (arr) => arr.map((val) => ({
  id: val,
  val,
  render: val
}));
const caseStateOptions = makeOptions(caseStates);
const chargeBackStateOptions = makeOptions(chargebackStates);
const disputeStateOptions = makeOptions(disputeStates);
const manualTransitionFieldConfig = {
  case_state: {
    label: "Case State (Cases)",
    options: caseStateOptions,
    placeholder: "Select Case State"
  },
  dispute_state: {
    label: "Dispute State (Cases)",
    options: disputeStateOptions,
    placeholder: "Select Dispute State"
  },
  network_case_state: {
    label: "Network case State (Cases)",
    placeholder: "Enter network case state"
  },
  dispute_transition_state: {
    label: "Dispute transition state (Cases)",
    options: disputeStateOptions,
    placeholder: "Select Dispute transition state"
  },
  case_transition_state: {
    label: "Case transition state (Cases)",
    options: caseStateOptions,
    placeholder: "Select Case transition state"
  },
  chargeback_state: {
    label: "Chargeback state (Jcard)",
    options: chargeBackStateOptions,
    placeholder: "Select Chargeback state"
  },
  chargeback_transition_state: {
    label: "Chargeback transition state (Jcard)",
    options: chargeBackStateOptions,
    placeholder: "Select Chargeback transition state"
  },
  memo: {
    label: "Transition note",
    placeholder: "Enter notes"
  }
};
const MANUAL_TRANSITION_MUTATION = gql`
  mutation manualTransition($case_token: ID!, $payload: ManualTransitionPayload) {
    manualTransition(case_token: $case_token, payload: $payload) {
      case_state
      dispute_state
      network_case_state
      dispute_transition_state
      case_transition_state
      chargeback_state
      chargeback_transition_state
      memo
    }
  }
`;
const StateChangeAndError = ({
  from,
  to: to2,
  error
}) => {
  if (from === to2)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Pill, { type: "pending", size: "footnote", withIcon: "true", className: "mt-1 mb-1", children: [
      from,
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { className: "pl-1 pr-1", type: "arrow-right", mod: "default", factor: 1 }),
      to2
    ] }),
    !!error && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: error })
  ] });
};
const ManualTransitionModal = ({
  case_state: curCaseState,
  case_transition_state: curCaseTransitionState,
  caseToken,
  chargeback_state: curChargebackState,
  chargeback_transition_state: curChargebackTransitionState,
  closeModal,
  dispute_state: curDisputeState,
  dispute_transition_state: curDisputeTransitionState,
  hydrateChargebacks,
  hydrateDispute,
  network_case_state: curNetworkCaseState
}) => {
  const [case_state, updateCaseState] = useState("");
  const [case_transition_state, updateCaseTransitionState] = useState("");
  const [chargeback_state, updateChargebackState] = useState("");
  const [chargeback_transition_state, updateChargebackTransitionState] = useState("");
  const [dispute_state, updateDisputeState] = useState("");
  const [dispute_transition_state, updateDisputeTransitionState] = useState("");
  const [memo, updateMemo] = useState("");
  const [network_case_state, updateNetworkCaseState] = useState("");
  const [partialErrors, updatePartialErrors] = useState({});
  const {
    setError,
    setSuccess
  } = useAlertStore();
  useEffect(() => {
    updateCaseState(curCaseState);
  }, [curCaseState]);
  useEffect(() => {
    updateDisputeState(curDisputeState);
  }, [curDisputeState]);
  useEffect(() => {
    updateNetworkCaseState(curNetworkCaseState);
  }, [curNetworkCaseState]);
  useEffect(() => {
    updateDisputeTransitionState(curDisputeTransitionState);
  }, [curDisputeTransitionState]);
  useEffect(() => {
    updateCaseTransitionState(curCaseTransitionState);
  }, [curCaseTransitionState]);
  useEffect(() => {
    updateChargebackState(curChargebackState);
  }, [curChargebackState]);
  useEffect(() => {
    updateChargebackTransitionState(curChargebackTransitionState);
  }, [curChargebackTransitionState]);
  const effectiveChange = useMemo(() => {
    const change = {};
    if (curCaseState !== case_state)
      change.to_case_state = case_state;
    if (curDisputeState !== dispute_state)
      change.to_dispute_state = dispute_state;
    if (curNetworkCaseState !== network_case_state)
      change.to_network_case_state = network_case_state;
    if (curCaseTransitionState !== case_transition_state)
      change.to_case_transition_state = case_transition_state;
    if (curChargebackState !== chargeback_state)
      change.to_chargeback_state = chargeback_state;
    if (!!memo)
      change.memo = memo;
    if (!Object.keys(change).length)
      return null;
    return change;
  }, [case_state, case_transition_state, chargeback_state, curCaseState, curCaseTransitionState, curChargebackState, curDisputeState, curNetworkCaseState, dispute_state, memo, network_case_state]);
  const onCompleted = useCallback((resp) => {
    const partialErrors2 = {};
    for (const key in effectiveChange) {
      if (key === "memo")
        continue;
      const fieldName = key.substring(3);
      if (resp.manualTransition[fieldName] !== effectiveChange[key])
        partialErrors2[fieldName] = resp.manualTransition[fieldName];
    }
    updatePartialErrors(partialErrors2);
    hydrateDispute();
    hydrateChargebacks();
    if (!Object.keys(partialErrors2).length) {
      setSuccess("The transition was successful.");
      closeModal();
    }
  }, [closeModal, effectiveChange, hydrateChargebacks, hydrateDispute, setSuccess]);
  const [mutation, {
    loading
  }] = useMutation(MANUAL_TRANSITION_MUTATION, {
    onError: (err) => {
      setError(err, err?.message || "There was an issue with the transition.", {
        alertType: TOAST,
        icon: "error"
      });
    },
    onCompleted
  });
  const manualTransition = useCallback(() => {
    if (!effectiveChange)
      return;
    mutation({
      variables: {
        case_token: caseToken,
        payload: effectiveChange
      }
    });
  }, [caseToken, effectiveChange, mutation]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { type: "lg", heading: MANUAL_TRANSITION_LABEL, hideModal: closeModal, footerButtons: [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: manualTransition, loading, type: "primary", disabled: true, children: "Confirm" })], children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.case_state.label, value: case_state, options: manualTransitionFieldConfig.case_state.options, onChange: (value) => updateCaseState(value.val), placeholder: manualTransitionFieldConfig.case_state.placeholder, showSearch: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StateChangeAndError, { from: curCaseState, to: case_state, error: partialErrors.case_state }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.dispute_state.label, value: dispute_state, options: manualTransitionFieldConfig.dispute_state.options, onChange: (value) => updateDisputeState(value.val), placeholder: manualTransitionFieldConfig.dispute_state.placeholder, showSearch: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StateChangeAndError, { from: curDisputeState, to: dispute_state, error: partialErrors.dispute_state }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: manualTransitionFieldConfig.network_case_state.label, onChange: (e) => updateNetworkCaseState(e.target.value), value: network_case_state, placeholder: manualTransitionFieldConfig.network_case_state.placeholder }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StateChangeAndError, { from: curNetworkCaseState, to: network_case_state, error: partialErrors.network_case_state }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.dispute_transition_state.label, value: dispute_transition_state, options: manualTransitionFieldConfig.dispute_transition_state.options, placeholder: manualTransitionFieldConfig.dispute_transition_state.placeholder, disabled: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.case_transition_state.label, value: case_transition_state, options: manualTransitionFieldConfig.case_transition_state.options, onChange: (value) => updateCaseTransitionState(value.val), placeholder: manualTransitionFieldConfig.case_transition_state.placeholder, showSearch: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StateChangeAndError, { from: curCaseTransitionState, to: case_transition_state, error: partialErrors.case_transition_state }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.chargeback_state.label, value: chargeback_state, options: manualTransitionFieldConfig.chargeback_state.options, onChange: (value) => updateChargebackState(value.val), placeholder: manualTransitionFieldConfig.chargeback_state.placeholder, showSearch: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StateChangeAndError, { from: curChargebackState, to: chargeback_state, error: partialErrors.chargeback_state }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label: manualTransitionFieldConfig.chargeback_transition_state.label, value: chargeback_transition_state, options: manualTransitionFieldConfig.chargeback_transition_state.options, disabled: true, placeholder: manualTransitionFieldConfig.chargeback_transition_state.placeholder }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Textarea, { label: manualTransitionFieldConfig.memo.label, onChange: (e) => updateMemo(e.target.value), value: memo, placeholder: manualTransitionFieldConfig.memo.placeholder })
  ] });
};
ManualTransitionModal.propTypes = {
  case_state: PropTypes.string,
  case_transition_state: PropTypes.string,
  caseToken: PropTypes.string.isRequired,
  chargeback_state: PropTypes.string,
  chargeback_transition_state: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  dispute_state: PropTypes.string,
  dispute_transition_state: PropTypes.string,
  hydrateChargebacks: PropTypes.func,
  hydrateDispute: PropTypes.func.isRequired,
  network_case_state: PropTypes.string
};
ManualTransitionModal.defaultProps = {
  case_state: "",
  case_transition_state: "",
  chargeback_state: "",
  chargeback_transition_state: "",
  dispute_state: "",
  dispute_transition_state: "",
  hydrateChargebacks: NO_OP,
  network_case_state: ""
};
const CREATE_TICKET$1 = gql`
  mutation createSalesforceTicket(
    $email: String!
    $firstName: String
    $lastName: String!
    $subject: String
    $description: String
    $recordTypeName: String
    $accountName: String
    $isNMI: Boolean!
  ) {
    createSalesforceTicket(
      email: $email
      firstName: $firstName
      lastName: $lastName
      subject: $subject
      description: $description
      recordTypeName: $recordTypeName
      accountName: $accountName
      isNMI: $isNMI
    ) {
      id
      case_number
      success
    }
  }
`;
const CREATE_NMI_TICKET = gql`
  mutation createNMISalesforceTicket(
    $email: String!
    $firstName: String
    $lastName: String!
    $subject: String
    $description: String
    $recordTypeName: String
    $accountId: String
    $isNMI: Boolean!
  ) {
    createNMISalesforceTicket(
      email: $email
      firstName: $firstName
      lastName: $lastName
      subject: $subject
      description: $description
      recordTypeName: $recordTypeName
      accountId: $accountId
      isNMI: $isNMI
    ) {
      id
      case_number
      success
    }
  }
`;
const SEND_MAIL = gql`
  mutation sendEmail(
    $emailBody: String!
    $emailBodyType: String!
    $caseId: ID!
    $toEmailAddress: String
    $ccEmailAddress: String
    $emailSubject: String
  ) {
    sendEmail(
      caseId: $caseId
      toEmailAddress: $toEmailAddress
      ccEmailAddress: $ccEmailAddress
      emailSubject: $emailSubject
      emailBody: $emailBody
      emailBodyType: $emailBodyType
    ) {
      id
      success
    }
  }
`;
const GET_TICKET = gql`
  query getSalesforceCase($CaseNumber: String!) {
    getSalesforceCase(CaseNumber: $CaseNumber) {
      Id
      CaseNumber
      Subject
      Description
      RecordTypeId
      AccountId
    }
  }
`;
const GET_SALESFORCE_MAIL = gql`
  query getEmailMessagesByCaseId($salesforceCaseId: ID!) {
    getEmailMessagesByCaseId(salesforceCaseId: $salesforceCaseId) {
      FromAddress
      Id
      Subject
      HtmlBody
      ToAddress
      CcAddress
    }
  }
`;
const SALESFORCE_CONTACT = gql`
  query GetContactByProgramShortCode($programShortCode: String!,$contactRole: String!) {
    getContactByProgramShortCode(programShortCode: $programShortCode, contactRole: $contactRole) {
      Id
      Name
      Email
      Contact_Role__c
      AccountId
      Program_Short_Code__c
    }
  }
`;
const useMutationWithRequest = (mutationQuery) => {
  const [mutation, {
    data,
    loading,
    error
  }] = useMutation(mutationQuery);
  const sendRequest = async (variables) => await mutation({
    variables
  });
  return {
    sendRequest,
    data,
    loading,
    error
  };
};
const useSalesforceApi = () => {
  const {
    sendRequest,
    data,
    loading,
    error
  } = useMutationWithRequest(CREATE_TICKET$1);
  return {
    createSalesforceTicket: sendRequest,
    data,
    loading,
    error
  };
};
const useNMISalesforceApi = () => {
  const {
    sendRequest,
    data,
    loading,
    error
  } = useMutationWithRequest(CREATE_NMI_TICKET);
  return {
    createNMISalesforceTicket: sendRequest,
    data,
    loading,
    error
  };
};
const useSalesforceMailApi = () => {
  const {
    sendRequest,
    data,
    loading,
    error
  } = useMutationWithRequest(SEND_MAIL);
  return {
    sendEmail: sendRequest,
    data,
    loading,
    error
  };
};
const useGetSalesforceCase = (variables) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_TICKET, {
    variables
  });
  return {
    data: data?.getSalesforceCase,
    loading,
    error
  };
};
const useGetEmailMessage = ({
  salesforceCaseId
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_SALESFORCE_MAIL, {
    variables: {
      salesforceCaseId
    },
    skip: !salesforceCaseId,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true
  });
  return {
    data: data?.getEmailMessagesByCaseId,
    loading,
    error,
    refetch
  };
};
const useSalesforceContact = ({
  programShortCode,
  contactRole
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(SALESFORCE_CONTACT, {
    variables: {
      programShortCode,
      contactRole
    },
    skip: !programShortCode,
    fetchPolicy: "network-only",
    nextFetchPolicy: "cache-first",
    notifyOnNetworkStatusChange: true
  });
  return {
    data: data?.getContactByProgramShortCode,
    loading,
    error,
    refetch
  };
};
function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}
var _listCacheClear = listCacheClear$1;
function eq$2(value, other) {
  return value === other || value !== value && other !== other;
}
var eq_1 = eq$2;
var eq$1 = eq_1;
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}
var _assocIndexOf = assocIndexOf$4;
var assocIndexOf$3 = _assocIndexOf;
var arrayProto = Array.prototype;
var splice = arrayProto.splice;
function listCacheDelete$1(key) {
  var data = this.__data__, index = assocIndexOf$3(data, key);
  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}
var _listCacheDelete = listCacheDelete$1;
var assocIndexOf$2 = _assocIndexOf;
function listCacheGet$1(key) {
  var data = this.__data__, index = assocIndexOf$2(data, key);
  return index < 0 ? void 0 : data[index][1];
}
var _listCacheGet = listCacheGet$1;
var assocIndexOf$1 = _assocIndexOf;
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}
var _listCacheHas = listCacheHas$1;
var assocIndexOf = _assocIndexOf;
function listCacheSet$1(key, value) {
  var data = this.__data__, index = assocIndexOf(data, key);
  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}
var _listCacheSet = listCacheSet$1;
var listCacheClear = _listCacheClear, listCacheDelete = _listCacheDelete, listCacheGet = _listCacheGet, listCacheHas = _listCacheHas, listCacheSet = _listCacheSet;
function ListCache$4(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype["delete"] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;
var _ListCache = ListCache$4;
var ListCache$3 = _ListCache;
function stackClear$1() {
  this.__data__ = new ListCache$3();
  this.size = 0;
}
var _stackClear = stackClear$1;
function stackDelete$1(key) {
  var data = this.__data__, result = data["delete"](key);
  this.size = data.size;
  return result;
}
var _stackDelete = stackDelete$1;
function stackGet$1(key) {
  return this.__data__.get(key);
}
var _stackGet = stackGet$1;
function stackHas$1(key) {
  return this.__data__.has(key);
}
var _stackHas = stackHas$1;
var freeGlobal$1 = typeof commonjsGlobal == "object" && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
var _freeGlobal = freeGlobal$1;
var freeGlobal = _freeGlobal;
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
var root$8 = freeGlobal || freeSelf || Function("return this")();
var _root = root$8;
var root$7 = _root;
var Symbol$4 = root$7.Symbol;
var _Symbol = Symbol$4;
var Symbol$3 = _Symbol;
var objectProto$b = Object.prototype;
var hasOwnProperty$8 = objectProto$b.hasOwnProperty;
var nativeObjectToString$1 = objectProto$b.toString;
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : void 0;
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$8.call(value, symToStringTag$1), tag = value[symToStringTag$1];
  try {
    value[symToStringTag$1] = void 0;
    var unmasked = true;
  } catch (e) {
  }
  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}
var _getRawTag = getRawTag$1;
var objectProto$a = Object.prototype;
var nativeObjectToString = objectProto$a.toString;
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}
var _objectToString = objectToString$1;
var Symbol$2 = _Symbol, getRawTag = _getRawTag, objectToString = _objectToString;
var nullTag = "[object Null]", undefinedTag = "[object Undefined]";
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : void 0;
function baseGetTag$4(value) {
  if (value == null) {
    return value === void 0 ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
var _baseGetTag = baseGetTag$4;
function isObject$2(value) {
  var type = typeof value;
  return value != null && (type == "object" || type == "function");
}
var isObject_1 = isObject$2;
var baseGetTag$3 = _baseGetTag, isObject$1 = isObject_1;
var asyncTag = "[object AsyncFunction]", funcTag$1 = "[object Function]", genTag = "[object GeneratorFunction]", proxyTag = "[object Proxy]";
function isFunction$2(value) {
  if (!isObject$1(value)) {
    return false;
  }
  var tag = baseGetTag$3(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}
var isFunction_1 = isFunction$2;
var root$6 = _root;
var coreJsData$1 = root$6["__core-js_shared__"];
var _coreJsData = coreJsData$1;
var coreJsData = _coreJsData;
var maskSrcKey = function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
  return uid ? "Symbol(src)_1." + uid : "";
}();
function isMasked$1(func) {
  return !!maskSrcKey && maskSrcKey in func;
}
var _isMasked = isMasked$1;
var funcProto$1 = Function.prototype;
var funcToString$1 = funcProto$1.toString;
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {
    }
    try {
      return func + "";
    } catch (e) {
    }
  }
  return "";
}
var _toSource = toSource$2;
var isFunction$1 = isFunction_1, isMasked = _isMasked, isObject = isObject_1, toSource$1 = _toSource;
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
var reIsHostCtor = /^\[object .+?Constructor\]$/;
var funcProto = Function.prototype, objectProto$9 = Object.prototype;
var funcToString = funcProto.toString;
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
var reIsNative = RegExp(
  "^" + funcToString.call(hasOwnProperty$7).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function baseIsNative$1(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}
var _baseIsNative = baseIsNative$1;
function getValue$1(object, key) {
  return object == null ? void 0 : object[key];
}
var _getValue = getValue$1;
var baseIsNative = _baseIsNative, getValue = _getValue;
function getNative$6(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : void 0;
}
var _getNative = getNative$6;
var getNative$5 = _getNative, root$5 = _root;
var Map$4 = getNative$5(root$5, "Map");
var _Map = Map$4;
var getNative$4 = _getNative;
var nativeCreate$4 = getNative$4(Object, "create");
var _nativeCreate = nativeCreate$4;
var nativeCreate$3 = _nativeCreate;
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}
var _hashClear = hashClear$1;
function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}
var _hashDelete = hashDelete$1;
var nativeCreate$2 = _nativeCreate;
var HASH_UNDEFINED$2 = "__lodash_hash_undefined__";
var objectProto$8 = Object.prototype;
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? void 0 : result;
  }
  return hasOwnProperty$6.call(data, key) ? data[key] : void 0;
}
var _hashGet = hashGet$1;
var nativeCreate$1 = _nativeCreate;
var objectProto$7 = Object.prototype;
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? data[key] !== void 0 : hasOwnProperty$5.call(data, key);
}
var _hashHas = hashHas$1;
var nativeCreate = _nativeCreate;
var HASH_UNDEFINED$1 = "__lodash_hash_undefined__";
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED$1 : value;
  return this;
}
var _hashSet = hashSet$1;
var hashClear = _hashClear, hashDelete = _hashDelete, hashGet = _hashGet, hashHas = _hashHas, hashSet = _hashSet;
function Hash$1(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
Hash$1.prototype.clear = hashClear;
Hash$1.prototype["delete"] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;
var _Hash = Hash$1;
var Hash = _Hash, ListCache$2 = _ListCache, Map$3 = _Map;
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    "hash": new Hash(),
    "map": new (Map$3 || ListCache$2)(),
    "string": new Hash()
  };
}
var _mapCacheClear = mapCacheClear$1;
function isKeyable$1(value) {
  var type = typeof value;
  return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var _isKeyable = isKeyable$1;
var isKeyable = _isKeyable;
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var _getMapData = getMapData$4;
var getMapData$3 = _getMapData;
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)["delete"](key);
  this.size -= result ? 1 : 0;
  return result;
}
var _mapCacheDelete = mapCacheDelete$1;
var getMapData$2 = _getMapData;
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}
var _mapCacheGet = mapCacheGet$1;
var getMapData$1 = _getMapData;
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}
var _mapCacheHas = mapCacheHas$1;
var getMapData = _getMapData;
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key), size = data.size;
  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}
var _mapCacheSet = mapCacheSet$1;
var mapCacheClear = _mapCacheClear, mapCacheDelete = _mapCacheDelete, mapCacheGet = _mapCacheGet, mapCacheHas = _mapCacheHas, mapCacheSet = _mapCacheSet;
function MapCache$2(entries) {
  var index = -1, length = entries == null ? 0 : entries.length;
  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}
MapCache$2.prototype.clear = mapCacheClear;
MapCache$2.prototype["delete"] = mapCacheDelete;
MapCache$2.prototype.get = mapCacheGet;
MapCache$2.prototype.has = mapCacheHas;
MapCache$2.prototype.set = mapCacheSet;
var _MapCache = MapCache$2;
var ListCache$1 = _ListCache, Map$2 = _Map, MapCache$1 = _MapCache;
var LARGE_ARRAY_SIZE = 200;
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$1(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}
var _stackSet = stackSet$1;
var ListCache = _ListCache, stackClear = _stackClear, stackDelete = _stackDelete, stackGet = _stackGet, stackHas = _stackHas, stackSet = _stackSet;
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}
Stack$1.prototype.clear = stackClear;
Stack$1.prototype["delete"] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;
var _Stack = Stack$1;
var HASH_UNDEFINED = "__lodash_hash_undefined__";
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}
var _setCacheAdd = setCacheAdd$1;
function setCacheHas$1(value) {
  return this.__data__.has(value);
}
var _setCacheHas = setCacheHas$1;
var MapCache = _MapCache, setCacheAdd = _setCacheAdd, setCacheHas = _setCacheHas;
function SetCache$1(values) {
  var index = -1, length = values == null ? 0 : values.length;
  this.__data__ = new MapCache();
  while (++index < length) {
    this.add(values[index]);
  }
}
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;
var _SetCache = SetCache$1;
function arraySome$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length;
  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}
var _arraySome = arraySome$1;
function cacheHas$1(cache, key) {
  return cache.has(key);
}
var _cacheHas = cacheHas$1;
var SetCache = _SetCache, arraySome = _arraySome, cacheHas = _cacheHas;
var COMPARE_PARTIAL_FLAG$3 = 1, COMPARE_UNORDERED_FLAG$1 = 2;
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG$1 ? new SetCache() : void 0;
  stack.set(array, other);
  stack.set(other, array);
  while (++index < arrLength) {
    var arrValue = array[index], othValue = other[index];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== void 0) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack["delete"](array);
  stack["delete"](other);
  return result;
}
var _equalArrays = equalArrays$2;
var root$4 = _root;
var Uint8Array$1 = root$4.Uint8Array;
var _Uint8Array = Uint8Array$1;
function mapToArray$1(map) {
  var index = -1, result = Array(map.size);
  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}
var _mapToArray = mapToArray$1;
function setToArray$1(set) {
  var index = -1, result = Array(set.size);
  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}
var _setToArray = setToArray$1;
var Symbol$1 = _Symbol, Uint8Array = _Uint8Array, eq = eq_1, equalArrays$1 = _equalArrays, mapToArray = _mapToArray, setToArray = _setToArray;
var COMPARE_PARTIAL_FLAG$2 = 1, COMPARE_UNORDERED_FLAG = 2;
var boolTag$1 = "[object Boolean]", dateTag$1 = "[object Date]", errorTag$1 = "[object Error]", mapTag$2 = "[object Map]", numberTag$1 = "[object Number]", regexpTag$1 = "[object RegExp]", setTag$2 = "[object Set]", stringTag$1 = "[object String]", symbolTag = "[object Symbol]";
var arrayBufferTag$1 = "[object ArrayBuffer]", dataViewTag$2 = "[object DataView]";
var symbolProto = Symbol$1 ? Symbol$1.prototype : void 0, symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;
    case arrayBufferTag$1:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;
    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      return eq(+object, +other);
    case errorTag$1:
      return object.name == other.name && object.message == other.message;
    case regexpTag$1:
    case stringTag$1:
      return object == other + "";
    case mapTag$2:
      var convert = mapToArray;
    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2;
      convert || (convert = setToArray);
      if (object.size != other.size && !isPartial) {
        return false;
      }
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack["delete"](object);
      return result;
    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}
var _equalByTag = equalByTag$1;
function arrayPush$1(array, values) {
  var index = -1, length = values.length, offset = array.length;
  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}
var _arrayPush = arrayPush$1;
var isArray$3 = Array.isArray;
var isArray_1 = isArray$3;
var arrayPush = _arrayPush, isArray$2 = isArray_1;
function baseGetAllKeys$1(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$2(object) ? result : arrayPush(result, symbolsFunc(object));
}
var _baseGetAllKeys = baseGetAllKeys$1;
function arrayFilter$1(array, predicate) {
  var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}
var _arrayFilter = arrayFilter$1;
function stubArray$1() {
  return [];
}
var stubArray_1 = stubArray$1;
var arrayFilter = _arrayFilter, stubArray = stubArray_1;
var objectProto$6 = Object.prototype;
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbols$1 = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};
var _getSymbols = getSymbols$1;
function baseTimes$1(n, iteratee) {
  var index = -1, result = Array(n);
  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}
var _baseTimes = baseTimes$1;
function isObjectLike$4(value) {
  return value != null && typeof value == "object";
}
var isObjectLike_1 = isObjectLike$4;
var baseGetTag$2 = _baseGetTag, isObjectLike$3 = isObjectLike_1;
var argsTag$2 = "[object Arguments]";
function baseIsArguments$1(value) {
  return isObjectLike$3(value) && baseGetTag$2(value) == argsTag$2;
}
var _baseIsArguments = baseIsArguments$1;
var baseIsArguments = _baseIsArguments, isObjectLike$2 = isObjectLike_1;
var objectProto$5 = Object.prototype;
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;
var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
var isArguments$1 = baseIsArguments(/* @__PURE__ */ function() {
  return arguments;
}()) ? baseIsArguments : function(value) {
  return isObjectLike$2(value) && hasOwnProperty$4.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
};
var isArguments_1 = isArguments$1;
var isBuffer$2 = { exports: {} };
function stubFalse() {
  return false;
}
var stubFalse_1 = stubFalse;
isBuffer$2.exports;
(function(module, exports) {
  var root2 = _root, stubFalse2 = stubFalse_1;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var Buffer2 = moduleExports ? root2.Buffer : void 0;
  var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
  var isBuffer2 = nativeIsBuffer || stubFalse2;
  module.exports = isBuffer2;
})(isBuffer$2, isBuffer$2.exports);
var isBufferExports = isBuffer$2.exports;
var MAX_SAFE_INTEGER$1 = 9007199254740991;
var reIsUint = /^(?:0|[1-9]\d*)$/;
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
}
var _isIndex = isIndex$1;
var MAX_SAFE_INTEGER = 9007199254740991;
function isLength$2(value) {
  return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
var isLength_1 = isLength$2;
var baseGetTag$1 = _baseGetTag, isLength$1 = isLength_1, isObjectLike$1 = isObjectLike_1;
var argsTag$1 = "[object Arguments]", arrayTag$1 = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", mapTag$1 = "[object Map]", numberTag = "[object Number]", objectTag$2 = "[object Object]", regexpTag = "[object RegExp]", setTag$1 = "[object Set]", stringTag = "[object String]", weakMapTag$1 = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag$1 = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag] = typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] = typedArrayTags[setTag$1] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag$1] = false;
function baseIsTypedArray$1(value) {
  return isObjectLike$1(value) && isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}
var _baseIsTypedArray = baseIsTypedArray$1;
function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}
var _baseUnary = baseUnary$1;
var _nodeUtil = { exports: {} };
_nodeUtil.exports;
(function(module, exports) {
  var freeGlobal2 = _freeGlobal;
  var freeExports = exports && !exports.nodeType && exports;
  var freeModule = freeExports && true && module && !module.nodeType && module;
  var moduleExports = freeModule && freeModule.exports === freeExports;
  var freeProcess = moduleExports && freeGlobal2.process;
  var nodeUtil2 = function() {
    try {
      var types = freeModule && freeModule.require && freeModule.require("util").types;
      if (types) {
        return types;
      }
      return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {
    }
  }();
  module.exports = nodeUtil2;
})(_nodeUtil, _nodeUtil.exports);
var _nodeUtilExports = _nodeUtil.exports;
var baseIsTypedArray = _baseIsTypedArray, baseUnary = _baseUnary, nodeUtil = _nodeUtilExports;
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
var isTypedArray_1 = isTypedArray$2;
var baseTimes = _baseTimes, isArguments = isArguments_1, isArray$1 = isArray_1, isBuffer$1 = isBufferExports, isIndex = _isIndex, isTypedArray$1 = isTypedArray_1;
var objectProto$4 = Object.prototype;
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;
function arrayLikeKeys$1(value, inherited) {
  var isArr = isArray$1(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer$1(value), isType = !isArr && !isArg && !isBuff && isTypedArray$1(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}
var _arrayLikeKeys = arrayLikeKeys$1;
var objectProto$3 = Object.prototype;
function isPrototype$1(value) {
  var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto$3;
  return value === proto;
}
var _isPrototype = isPrototype$1;
function overArg$1(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}
var _overArg = overArg$1;
var overArg = _overArg;
var nativeKeys$1 = overArg(Object.keys, Object);
var _nativeKeys = nativeKeys$1;
var isPrototype = _isPrototype, nativeKeys = _nativeKeys;
var objectProto$2 = Object.prototype;
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
function baseKeys$1(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != "constructor") {
      result.push(key);
    }
  }
  return result;
}
var _baseKeys = baseKeys$1;
var isFunction = isFunction_1, isLength = isLength_1;
function isArrayLike$1(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}
var isArrayLike_1 = isArrayLike$1;
var arrayLikeKeys = _arrayLikeKeys, baseKeys = _baseKeys, isArrayLike = isArrayLike_1;
function keys$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
var keys_1 = keys$1;
var baseGetAllKeys = _baseGetAllKeys, getSymbols = _getSymbols, keys = keys_1;
function getAllKeys$1(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}
var _getAllKeys = getAllKeys$1;
var getAllKeys = _getAllKeys;
var COMPARE_PARTIAL_FLAG$1 = 1;
var objectProto$1 = Object.prototype;
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$1.call(other, key))) {
      return false;
    }
  }
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);
  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key], othValue = other[key];
    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    if (!(compared === void 0 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == "constructor");
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor, othCtor = other.constructor;
    if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack["delete"](object);
  stack["delete"](other);
  return result;
}
var _equalObjects = equalObjects$1;
var getNative$3 = _getNative, root$3 = _root;
var DataView$1 = getNative$3(root$3, "DataView");
var _DataView = DataView$1;
var getNative$2 = _getNative, root$2 = _root;
var Promise$2 = getNative$2(root$2, "Promise");
var _Promise = Promise$2;
var getNative$1 = _getNative, root$1 = _root;
var Set$2 = getNative$1(root$1, "Set");
var _Set = Set$2;
var getNative = _getNative, root = _root;
var WeakMap$1 = getNative(root, "WeakMap");
var _WeakMap = WeakMap$1;
var DataView = _DataView, Map$1 = _Map, Promise$1 = _Promise, Set$1 = _Set, WeakMap = _WeakMap, baseGetTag = _baseGetTag, toSource = _toSource;
var mapTag = "[object Map]", objectTag$1 = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map$1), promiseCtorString = toSource(Promise$1), setCtorString = toSource(Set$1), weakMapCtorString = toSource(WeakMap);
var getTag$1 = baseGetTag;
if (DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag || Map$1 && getTag$1(new Map$1()) != mapTag || Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag || Set$1 && getTag$1(new Set$1()) != setTag || WeakMap && getTag$1(new WeakMap()) != weakMapTag) {
  getTag$1 = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag$1 ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString:
          return dataViewTag;
        case mapCtorString:
          return mapTag;
        case promiseCtorString:
          return promiseTag;
        case setCtorString:
          return setTag;
        case weakMapCtorString:
          return weakMapTag;
      }
    }
    return result;
  };
}
var _getTag = getTag$1;
var Stack = _Stack, equalArrays = _equalArrays, equalByTag = _equalByTag, equalObjects = _equalObjects, getTag = _getTag, isArray = isArray_1, isBuffer = isBufferExports, isTypedArray = isTypedArray_1;
var COMPARE_PARTIAL_FLAG = 1;
var argsTag = "[object Arguments]", arrayTag = "[object Array]", objectTag = "[object Object]";
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;
  var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
var _baseIsEqualDeep = baseIsEqualDeep$1;
var baseIsEqualDeep = _baseIsEqualDeep, isObjectLike = isObjectLike_1;
function baseIsEqual$1(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$1, stack);
}
var _baseIsEqual = baseIsEqual$1;
var baseIsEqual = _baseIsEqual;
function isEqual(value, other) {
  return baseIsEqual(value, other);
}
var isEqual_1$1 = isEqual;
var quill = { exports: {} };
/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function(module, exports) {
  (function webpackUniversalModuleDefinition(root2, factory) {
    module.exports = factory();
  })(typeof self !== "undefined" ? self : commonjsGlobal, function() {
    return (
      /******/
      function(modules) {
        var installedModules = {};
        function __webpack_require__(moduleId) {
          if (installedModules[moduleId]) {
            return installedModules[moduleId].exports;
          }
          var module2 = installedModules[moduleId] = {
            /******/
            i: moduleId,
            /******/
            l: false,
            /******/
            exports: {}
            /******/
          };
          modules[moduleId].call(module2.exports, module2, module2.exports, __webpack_require__);
          module2.l = true;
          return module2.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports2, name, getter) {
          if (!__webpack_require__.o(exports2, name)) {
            Object.defineProperty(exports2, name, {
              /******/
              configurable: false,
              /******/
              enumerable: true,
              /******/
              get: getter
              /******/
            });
          }
        };
        __webpack_require__.n = function(module2) {
          var getter = module2 && module2.__esModule ? (
            /******/
            function getDefault() {
              return module2["default"];
            }
          ) : (
            /******/
            function getModuleExports() {
              return module2;
            }
          );
          __webpack_require__.d(getter, "a", getter);
          return getter;
        };
        __webpack_require__.o = function(object, property) {
          return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        return __webpack_require__(__webpack_require__.s = 109);
      }([
        /* 0 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", { value: true });
          var container_1 = __webpack_require__(17);
          var format_1 = __webpack_require__(18);
          var leaf_1 = __webpack_require__(19);
          var scroll_1 = __webpack_require__(45);
          var inline_1 = __webpack_require__(46);
          var block_1 = __webpack_require__(47);
          var embed_1 = __webpack_require__(48);
          var text_1 = __webpack_require__(49);
          var attributor_1 = __webpack_require__(12);
          var class_1 = __webpack_require__(32);
          var style_1 = __webpack_require__(33);
          var store_1 = __webpack_require__(31);
          var Registry = __webpack_require__(1);
          var Parchment = {
            Scope: Registry.Scope,
            create: Registry.create,
            find: Registry.find,
            query: Registry.query,
            register: Registry.register,
            Container: container_1.default,
            Format: format_1.default,
            Leaf: leaf_1.default,
            Embed: embed_1.default,
            Scroll: scroll_1.default,
            Block: block_1.default,
            Inline: inline_1.default,
            Text: text_1.default,
            Attributor: {
              Attribute: attributor_1.default,
              Class: class_1.default,
              Style: style_1.default,
              Store: store_1.default
            }
          };
          exports2.default = Parchment;
        },
        /* 1 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var ParchmentError = (
            /** @class */
            function(_super) {
              __extends2(ParchmentError2, _super);
              function ParchmentError2(message) {
                var _this = this;
                message = "[Parchment] " + message;
                _this = _super.call(this, message) || this;
                _this.message = message;
                _this.name = _this.constructor.name;
                return _this;
              }
              return ParchmentError2;
            }(Error)
          );
          exports2.ParchmentError = ParchmentError;
          var attributes = {};
          var classes = {};
          var tags = {};
          var types = {};
          exports2.DATA_KEY = "__blot";
          var Scope;
          (function(Scope2) {
            Scope2[Scope2["TYPE"] = 3] = "TYPE";
            Scope2[Scope2["LEVEL"] = 12] = "LEVEL";
            Scope2[Scope2["ATTRIBUTE"] = 13] = "ATTRIBUTE";
            Scope2[Scope2["BLOT"] = 14] = "BLOT";
            Scope2[Scope2["INLINE"] = 7] = "INLINE";
            Scope2[Scope2["BLOCK"] = 11] = "BLOCK";
            Scope2[Scope2["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
            Scope2[Scope2["INLINE_BLOT"] = 6] = "INLINE_BLOT";
            Scope2[Scope2["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
            Scope2[Scope2["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
            Scope2[Scope2["ANY"] = 15] = "ANY";
          })(Scope = exports2.Scope || (exports2.Scope = {}));
          function create(input, value) {
            var match = query(input);
            if (match == null) {
              throw new ParchmentError("Unable to create " + input + " blot");
            }
            var BlotClass = match;
            var node = (
              // @ts-ignore
              input instanceof Node || input["nodeType"] === Node.TEXT_NODE ? input : BlotClass.create(value)
            );
            return new BlotClass(node, value);
          }
          exports2.create = create;
          function find(node, bubble) {
            if (bubble === void 0) {
              bubble = false;
            }
            if (node == null)
              return null;
            if (node[exports2.DATA_KEY] != null)
              return node[exports2.DATA_KEY].blot;
            if (bubble)
              return find(node.parentNode, bubble);
            return null;
          }
          exports2.find = find;
          function query(query2, scope) {
            if (scope === void 0) {
              scope = Scope.ANY;
            }
            var match;
            if (typeof query2 === "string") {
              match = types[query2] || attributes[query2];
            } else if (query2 instanceof Text || query2["nodeType"] === Node.TEXT_NODE) {
              match = types["text"];
            } else if (typeof query2 === "number") {
              if (query2 & Scope.LEVEL & Scope.BLOCK) {
                match = types["block"];
              } else if (query2 & Scope.LEVEL & Scope.INLINE) {
                match = types["inline"];
              }
            } else if (query2 instanceof HTMLElement) {
              var names = (query2.getAttribute("class") || "").split(/\s+/);
              for (var i in names) {
                match = classes[names[i]];
                if (match)
                  break;
              }
              match = match || tags[query2.tagName];
            }
            if (match == null)
              return null;
            if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
              return match;
            return null;
          }
          exports2.query = query;
          function register() {
            var Definitions = [];
            for (var _i = 0; _i < arguments.length; _i++) {
              Definitions[_i] = arguments[_i];
            }
            if (Definitions.length > 1) {
              return Definitions.map(function(d) {
                return register(d);
              });
            }
            var Definition = Definitions[0];
            if (typeof Definition.blotName !== "string" && typeof Definition.attrName !== "string") {
              throw new ParchmentError("Invalid definition");
            } else if (Definition.blotName === "abstract") {
              throw new ParchmentError("Cannot register abstract class");
            }
            types[Definition.blotName || Definition.attrName] = Definition;
            if (typeof Definition.keyName === "string") {
              attributes[Definition.keyName] = Definition;
            } else {
              if (Definition.className != null) {
                classes[Definition.className] = Definition;
              }
              if (Definition.tagName != null) {
                if (Array.isArray(Definition.tagName)) {
                  Definition.tagName = Definition.tagName.map(function(tagName) {
                    return tagName.toUpperCase();
                  });
                } else {
                  Definition.tagName = Definition.tagName.toUpperCase();
                }
                var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
                tagNames.forEach(function(tag) {
                  if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                  }
                });
              }
            }
            return Definition;
          }
          exports2.register = register;
        },
        /* 2 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var diff = __webpack_require__(51);
          var equal = __webpack_require__(11);
          var extend = __webpack_require__(3);
          var op = __webpack_require__(20);
          var NULL_CHARACTER = String.fromCharCode(0);
          var Delta = function(ops) {
            if (Array.isArray(ops)) {
              this.ops = ops;
            } else if (ops != null && Array.isArray(ops.ops)) {
              this.ops = ops.ops;
            } else {
              this.ops = [];
            }
          };
          Delta.prototype.insert = function(text, attributes) {
            var newOp = {};
            if (text.length === 0)
              return this;
            newOp.insert = text;
            if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
              newOp.attributes = attributes;
            }
            return this.push(newOp);
          };
          Delta.prototype["delete"] = function(length) {
            if (length <= 0)
              return this;
            return this.push({ "delete": length });
          };
          Delta.prototype.retain = function(length, attributes) {
            if (length <= 0)
              return this;
            var newOp = { retain: length };
            if (attributes != null && typeof attributes === "object" && Object.keys(attributes).length > 0) {
              newOp.attributes = attributes;
            }
            return this.push(newOp);
          };
          Delta.prototype.push = function(newOp) {
            var index = this.ops.length;
            var lastOp = this.ops[index - 1];
            newOp = extend(true, {}, newOp);
            if (typeof lastOp === "object") {
              if (typeof newOp["delete"] === "number" && typeof lastOp["delete"] === "number") {
                this.ops[index - 1] = { "delete": lastOp["delete"] + newOp["delete"] };
                return this;
              }
              if (typeof lastOp["delete"] === "number" && newOp.insert != null) {
                index -= 1;
                lastOp = this.ops[index - 1];
                if (typeof lastOp !== "object") {
                  this.ops.unshift(newOp);
                  return this;
                }
              }
              if (equal(newOp.attributes, lastOp.attributes)) {
                if (typeof newOp.insert === "string" && typeof lastOp.insert === "string") {
                  this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
                  if (typeof newOp.attributes === "object")
                    this.ops[index - 1].attributes = newOp.attributes;
                  return this;
                } else if (typeof newOp.retain === "number" && typeof lastOp.retain === "number") {
                  this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
                  if (typeof newOp.attributes === "object")
                    this.ops[index - 1].attributes = newOp.attributes;
                  return this;
                }
              }
            }
            if (index === this.ops.length) {
              this.ops.push(newOp);
            } else {
              this.ops.splice(index, 0, newOp);
            }
            return this;
          };
          Delta.prototype.chop = function() {
            var lastOp = this.ops[this.ops.length - 1];
            if (lastOp && lastOp.retain && !lastOp.attributes) {
              this.ops.pop();
            }
            return this;
          };
          Delta.prototype.filter = function(predicate) {
            return this.ops.filter(predicate);
          };
          Delta.prototype.forEach = function(predicate) {
            this.ops.forEach(predicate);
          };
          Delta.prototype.map = function(predicate) {
            return this.ops.map(predicate);
          };
          Delta.prototype.partition = function(predicate) {
            var passed = [], failed = [];
            this.forEach(function(op2) {
              var target = predicate(op2) ? passed : failed;
              target.push(op2);
            });
            return [passed, failed];
          };
          Delta.prototype.reduce = function(predicate, initial) {
            return this.ops.reduce(predicate, initial);
          };
          Delta.prototype.changeLength = function() {
            return this.reduce(function(length, elem) {
              if (elem.insert) {
                return length + op.length(elem);
              } else if (elem.delete) {
                return length - elem.delete;
              }
              return length;
            }, 0);
          };
          Delta.prototype.length = function() {
            return this.reduce(function(length, elem) {
              return length + op.length(elem);
            }, 0);
          };
          Delta.prototype.slice = function(start, end) {
            start = start || 0;
            if (typeof end !== "number")
              end = Infinity;
            var ops = [];
            var iter = op.iterator(this.ops);
            var index = 0;
            while (index < end && iter.hasNext()) {
              var nextOp;
              if (index < start) {
                nextOp = iter.next(start - index);
              } else {
                nextOp = iter.next(end - index);
                ops.push(nextOp);
              }
              index += op.length(nextOp);
            }
            return new Delta(ops);
          };
          Delta.prototype.compose = function(other) {
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            var ops = [];
            var firstOther = otherIter.peek();
            if (firstOther != null && typeof firstOther.retain === "number" && firstOther.attributes == null) {
              var firstLeft = firstOther.retain;
              while (thisIter.peekType() === "insert" && thisIter.peekLength() <= firstLeft) {
                firstLeft -= thisIter.peekLength();
                ops.push(thisIter.next());
              }
              if (firstOther.retain - firstLeft > 0) {
                otherIter.next(firstOther.retain - firstLeft);
              }
            }
            var delta = new Delta(ops);
            while (thisIter.hasNext() || otherIter.hasNext()) {
              if (otherIter.peekType() === "insert") {
                delta.push(otherIter.next());
              } else if (thisIter.peekType() === "delete") {
                delta.push(thisIter.next());
              } else {
                var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length);
                var otherOp = otherIter.next(length);
                if (typeof otherOp.retain === "number") {
                  var newOp = {};
                  if (typeof thisOp.retain === "number") {
                    newOp.retain = length;
                  } else {
                    newOp.insert = thisOp.insert;
                  }
                  var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === "number");
                  if (attributes)
                    newOp.attributes = attributes;
                  delta.push(newOp);
                  if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
                    var rest = new Delta(thisIter.rest());
                    return delta.concat(rest).chop();
                  }
                } else if (typeof otherOp["delete"] === "number" && typeof thisOp.retain === "number") {
                  delta.push(otherOp);
                }
              }
            }
            return delta.chop();
          };
          Delta.prototype.concat = function(other) {
            var delta = new Delta(this.ops.slice());
            if (other.ops.length > 0) {
              delta.push(other.ops[0]);
              delta.ops = delta.ops.concat(other.ops.slice(1));
            }
            return delta;
          };
          Delta.prototype.diff = function(other, index) {
            if (this.ops === other.ops) {
              return new Delta();
            }
            var strings = [this, other].map(function(delta2) {
              return delta2.map(function(op2) {
                if (op2.insert != null) {
                  return typeof op2.insert === "string" ? op2.insert : NULL_CHARACTER;
                }
                var prep = delta2 === other ? "on" : "with";
                throw new Error("diff() called " + prep + " non-document");
              }).join("");
            });
            var delta = new Delta();
            var diffResult = diff(strings[0], strings[1], index);
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            diffResult.forEach(function(component) {
              var length = component[1].length;
              while (length > 0) {
                var opLength = 0;
                switch (component[0]) {
                  case diff.INSERT:
                    opLength = Math.min(otherIter.peekLength(), length);
                    delta.push(otherIter.next(opLength));
                    break;
                  case diff.DELETE:
                    opLength = Math.min(length, thisIter.peekLength());
                    thisIter.next(opLength);
                    delta["delete"](opLength);
                    break;
                  case diff.EQUAL:
                    opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
                    var thisOp = thisIter.next(opLength);
                    var otherOp = otherIter.next(opLength);
                    if (equal(thisOp.insert, otherOp.insert)) {
                      delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
                    } else {
                      delta.push(otherOp)["delete"](opLength);
                    }
                    break;
                }
                length -= opLength;
              }
            });
            return delta.chop();
          };
          Delta.prototype.eachLine = function(predicate, newline) {
            newline = newline || "\n";
            var iter = op.iterator(this.ops);
            var line2 = new Delta();
            var i = 0;
            while (iter.hasNext()) {
              if (iter.peekType() !== "insert")
                return;
              var thisOp = iter.peek();
              var start = op.length(thisOp) - iter.peekLength();
              var index = typeof thisOp.insert === "string" ? thisOp.insert.indexOf(newline, start) - start : -1;
              if (index < 0) {
                line2.push(iter.next());
              } else if (index > 0) {
                line2.push(iter.next(index));
              } else {
                if (predicate(line2, iter.next(1).attributes || {}, i) === false) {
                  return;
                }
                i += 1;
                line2 = new Delta();
              }
            }
            if (line2.length() > 0) {
              predicate(line2, {}, i);
            }
          };
          Delta.prototype.transform = function(other, priority) {
            priority = !!priority;
            if (typeof other === "number") {
              return this.transformPosition(other, priority);
            }
            var thisIter = op.iterator(this.ops);
            var otherIter = op.iterator(other.ops);
            var delta = new Delta();
            while (thisIter.hasNext() || otherIter.hasNext()) {
              if (thisIter.peekType() === "insert" && (priority || otherIter.peekType() !== "insert")) {
                delta.retain(op.length(thisIter.next()));
              } else if (otherIter.peekType() === "insert") {
                delta.push(otherIter.next());
              } else {
                var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
                var thisOp = thisIter.next(length);
                var otherOp = otherIter.next(length);
                if (thisOp["delete"]) {
                  continue;
                } else if (otherOp["delete"]) {
                  delta.push(otherOp);
                } else {
                  delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
                }
              }
            }
            return delta.chop();
          };
          Delta.prototype.transformPosition = function(index, priority) {
            priority = !!priority;
            var thisIter = op.iterator(this.ops);
            var offset = 0;
            while (thisIter.hasNext() && offset <= index) {
              var length = thisIter.peekLength();
              var nextType = thisIter.peekType();
              thisIter.next();
              if (nextType === "delete") {
                index -= Math.min(length, index - offset);
                continue;
              } else if (nextType === "insert" && (offset < index || !priority)) {
                index += length;
              }
              offset += length;
            }
            return index;
          };
          module2.exports = Delta;
        },
        /* 3 */
        /***/
        function(module2, exports2) {
          var hasOwn = Object.prototype.hasOwnProperty;
          var toStr = Object.prototype.toString;
          var defineProperty = Object.defineProperty;
          var gOPD = Object.getOwnPropertyDescriptor;
          var isArray2 = function isArray22(arr) {
            if (typeof Array.isArray === "function") {
              return Array.isArray(arr);
            }
            return toStr.call(arr) === "[object Array]";
          };
          var isPlainObject = function isPlainObject2(obj) {
            if (!obj || toStr.call(obj) !== "[object Object]") {
              return false;
            }
            var hasOwnConstructor = hasOwn.call(obj, "constructor");
            var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
            if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
              return false;
            }
            var key;
            for (key in obj) {
            }
            return typeof key === "undefined" || hasOwn.call(obj, key);
          };
          var setProperty = function setProperty2(target, options) {
            if (defineProperty && options.name === "__proto__") {
              defineProperty(target, options.name, {
                enumerable: true,
                configurable: true,
                value: options.newValue,
                writable: true
              });
            } else {
              target[options.name] = options.newValue;
            }
          };
          var getProperty = function getProperty2(obj, name) {
            if (name === "__proto__") {
              if (!hasOwn.call(obj, name)) {
                return void 0;
              } else if (gOPD) {
                return gOPD(obj, name).value;
              }
            }
            return obj[name];
          };
          module2.exports = function extend() {
            var options, name, src, copy, copyIsArray, clone;
            var target = arguments[0];
            var i = 1;
            var length = arguments.length;
            var deep = false;
            if (typeof target === "boolean") {
              deep = target;
              target = arguments[1] || {};
              i = 2;
            }
            if (target == null || typeof target !== "object" && typeof target !== "function") {
              target = {};
            }
            for (; i < length; ++i) {
              options = arguments[i];
              if (options != null) {
                for (name in options) {
                  src = getProperty(target, name);
                  copy = getProperty(options, name);
                  if (target !== copy) {
                    if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray2(copy)))) {
                      if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && isArray2(src) ? src : [];
                      } else {
                        clone = src && isPlainObject(src) ? src : {};
                      }
                      setProperty(target, { name, newValue: extend(deep, clone, copy) });
                    } else if (typeof copy !== "undefined") {
                      setProperty(target, { name, newValue: copy });
                    }
                  }
                }
              }
            }
            return target;
          };
        },
        /* 4 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BlockEmbed = exports2.bubbleFormats = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var NEWLINE_LENGTH = 1;
          var BlockEmbed = function(_Parchment$Embed) {
            _inherits(BlockEmbed2, _Parchment$Embed);
            function BlockEmbed2() {
              _classCallCheck(this, BlockEmbed2);
              return _possibleConstructorReturn(this, (BlockEmbed2.__proto__ || Object.getPrototypeOf(BlockEmbed2)).apply(this, arguments));
            }
            _createClass(BlockEmbed2, [{
              key: "attach",
              value: function attach() {
                _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "attach", this).call(this);
                this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
              }
            }, {
              key: "delta",
              value: function delta() {
                return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
              }
            }, {
              key: "format",
              value: function format(name, value) {
                var attribute2 = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
                if (attribute2 != null) {
                  this.attributes.attribute(attribute2, value);
                }
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                this.format(name, value);
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (typeof value === "string" && value.endsWith("\n")) {
                  var block = _parchment2.default.create(Block.blotName);
                  this.parent.insertBefore(block, index === 0 ? this : this.next);
                  block.insertAt(0, value.slice(0, -1));
                } else {
                  _get(BlockEmbed2.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed2.prototype), "insertAt", this).call(this, index, value, def);
                }
              }
            }]);
            return BlockEmbed2;
          }(_parchment2.default.Embed);
          BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
          var Block = function(_Parchment$Block) {
            _inherits(Block2, _Parchment$Block);
            function Block2(domNode) {
              _classCallCheck(this, Block2);
              var _this2 = _possibleConstructorReturn(this, (Block2.__proto__ || Object.getPrototypeOf(Block2)).call(this, domNode));
              _this2.cache = {};
              return _this2;
            }
            _createClass(Block2, [{
              key: "delta",
              value: function delta() {
                if (this.cache.delta == null) {
                  this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function(delta2, leaf) {
                    if (leaf.length() === 0) {
                      return delta2;
                    } else {
                      return delta2.insert(leaf.value(), bubbleFormats(leaf));
                    }
                  }, new _quillDelta2.default()).insert("\n", bubbleFormats(this));
                }
                return this.cache.delta;
              }
            }, {
              key: "deleteAt",
              value: function deleteAt(index, length) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "deleteAt", this).call(this, index, length);
                this.cache = {};
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (length <= 0)
                  return;
                if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                  if (index + length === this.length()) {
                    this.format(name, value);
                  }
                } else {
                  _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "formatAt", this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
                }
                this.cache = {};
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null)
                  return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, index, value, def);
                if (value.length === 0)
                  return;
                var lines = value.split("\n");
                var text = lines.shift();
                if (text.length > 0) {
                  if (index < this.length() - 1 || this.children.tail == null) {
                    _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertAt", this).call(this, Math.min(index, this.length() - 1), text);
                  } else {
                    this.children.tail.insertAt(this.children.tail.length(), text);
                  }
                  this.cache = {};
                }
                var block = this;
                lines.reduce(function(index2, line2) {
                  block = block.split(index2, true);
                  block.insertAt(0, line2);
                  return line2.length;
                }, index + text.length);
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                var head = this.children.head;
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "insertBefore", this).call(this, blot, ref);
                if (head instanceof _break2.default) {
                  head.remove();
                }
                this.cache = {};
              }
            }, {
              key: "length",
              value: function length() {
                if (this.cache.length == null) {
                  this.cache.length = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "length", this).call(this) + NEWLINE_LENGTH;
                }
                return this.cache.length;
              }
            }, {
              key: "moveChildren",
              value: function moveChildren(target, ref) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "moveChildren", this).call(this, target, ref);
                this.cache = {};
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "optimize", this).call(this, context);
                this.cache = {};
              }
            }, {
              key: "path",
              value: function path(index) {
                return _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "path", this).call(this, index, true);
              }
            }, {
              key: "removeChild",
              value: function removeChild(child) {
                _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "removeChild", this).call(this, child);
                this.cache = {};
              }
            }, {
              key: "split",
              value: function split(index) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
                  var clone = this.clone();
                  if (index === 0) {
                    this.parent.insertBefore(clone, this);
                    return this;
                  } else {
                    this.parent.insertBefore(clone, this.next);
                    return clone;
                  }
                } else {
                  var next = _get(Block2.prototype.__proto__ || Object.getPrototypeOf(Block2.prototype), "split", this).call(this, index, force);
                  this.cache = {};
                  return next;
                }
              }
            }]);
            return Block2;
          }(_parchment2.default.Block);
          Block.blotName = "block";
          Block.tagName = "P";
          Block.defaultChild = "break";
          Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];
          function bubbleFormats(blot) {
            var formats = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            if (blot == null)
              return formats;
            if (typeof blot.formats === "function") {
              formats = (0, _extend2.default)(formats, blot.formats());
            }
            if (blot.parent == null || blot.parent.blotName == "scroll" || blot.parent.statics.scope !== blot.statics.scope) {
              return formats;
            }
            return bubbleFormats(blot.parent, formats);
          }
          exports2.bubbleFormats = bubbleFormats;
          exports2.BlockEmbed = BlockEmbed;
          exports2.default = Block;
        },
        /* 5 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.overload = exports2.expandConfig = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          __webpack_require__(50);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _editor = __webpack_require__(14);
          var _editor2 = _interopRequireDefault(_editor);
          var _emitter3 = __webpack_require__(8);
          var _emitter4 = _interopRequireDefault(_emitter3);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _selection = __webpack_require__(15);
          var _selection2 = _interopRequireDefault(_selection);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _theme = __webpack_require__(34);
          var _theme2 = _interopRequireDefault(_theme);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var debug = (0, _logger2.default)("quill");
          var Quill = function() {
            _createClass(Quill2, null, [{
              key: "debug",
              value: function debug2(limit) {
                if (limit === true) {
                  limit = "log";
                }
                _logger2.default.level(limit);
              }
            }, {
              key: "find",
              value: function find(node) {
                return node.__quill || _parchment2.default.find(node);
              }
            }, {
              key: "import",
              value: function _import(name) {
                if (this.imports[name] == null) {
                  debug.error("Cannot import " + name + ". Are you sure it was registered?");
                }
                return this.imports[name];
              }
            }, {
              key: "register",
              value: function register(path, target) {
                var _this = this;
                var overwrite = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                if (typeof path !== "string") {
                  var name = path.attrName || path.blotName;
                  if (typeof name === "string") {
                    this.register("formats/" + name, path, target);
                  } else {
                    Object.keys(path).forEach(function(key) {
                      _this.register(key, path[key], target);
                    });
                  }
                } else {
                  if (this.imports[path] != null && !overwrite) {
                    debug.warn("Overwriting " + path + " with", target);
                  }
                  this.imports[path] = target;
                  if ((path.startsWith("blots/") || path.startsWith("formats/")) && target.blotName !== "abstract") {
                    _parchment2.default.register(target);
                  } else if (path.startsWith("modules") && typeof target.register === "function") {
                    target.register();
                  }
                }
              }
            }]);
            function Quill2(container2) {
              var _this2 = this;
              var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              _classCallCheck(this, Quill2);
              this.options = expandConfig(container2, options);
              this.container = this.options.container;
              if (this.container == null) {
                return debug.error("Invalid Quill container", container2);
              }
              if (this.options.debug) {
                Quill2.debug(this.options.debug);
              }
              var html = this.container.innerHTML.trim();
              this.container.classList.add("ql-container");
              this.container.innerHTML = "";
              this.container.__quill = this;
              this.root = this.addContainer("ql-editor");
              this.root.classList.add("ql-blank");
              this.root.setAttribute("data-gramm", false);
              this.scrollingContainer = this.options.scrollingContainer || this.root;
              this.emitter = new _emitter4.default();
              this.scroll = _parchment2.default.create(this.root, {
                emitter: this.emitter,
                whitelist: this.options.formats
              });
              this.editor = new _editor2.default(this.scroll);
              this.selection = new _selection2.default(this.scroll, this.emitter);
              this.theme = new this.options.theme(this, this.options);
              this.keyboard = this.theme.addModule("keyboard");
              this.clipboard = this.theme.addModule("clipboard");
              this.history = this.theme.addModule("history");
              this.theme.init();
              this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type) {
                if (type === _emitter4.default.events.TEXT_CHANGE) {
                  _this2.root.classList.toggle("ql-blank", _this2.editor.isBlank());
                }
              });
              this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function(source, mutations) {
                var range = _this2.selection.lastRange;
                var index = range && range.length === 0 ? range.index : void 0;
                modify.call(_this2, function() {
                  return _this2.editor.update(null, mutations, index);
                }, source);
              });
              var contents = this.clipboard.convert(`<div class='ql-editor' style="white-space: normal;">` + html + "<p><br></p></div>");
              this.setContents(contents);
              this.history.clear();
              if (this.options.placeholder) {
                this.root.setAttribute("data-placeholder", this.options.placeholder);
              }
              if (this.options.readOnly) {
                this.disable();
              }
            }
            _createClass(Quill2, [{
              key: "addContainer",
              value: function addContainer(container2) {
                var refNode = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (typeof container2 === "string") {
                  var className = container2;
                  container2 = document.createElement("div");
                  container2.classList.add(className);
                }
                this.container.insertBefore(container2, refNode);
                return container2;
              }
            }, {
              key: "blur",
              value: function blur() {
                this.selection.setRange(null);
              }
            }, {
              key: "deleteText",
              value: function deleteText(index, length, source) {
                var _this3 = this;
                var _overload = overload(index, length, source);
                var _overload2 = _slicedToArray(_overload, 4);
                index = _overload2[0];
                length = _overload2[1];
                source = _overload2[3];
                return modify.call(this, function() {
                  return _this3.editor.deleteText(index, length);
                }, source, index, -1 * length);
              }
            }, {
              key: "disable",
              value: function disable() {
                this.enable(false);
              }
            }, {
              key: "enable",
              value: function enable() {
                var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this.scroll.enable(enabled);
                this.container.classList.toggle("ql-disabled", !enabled);
              }
            }, {
              key: "focus",
              value: function focus() {
                var scrollTop = this.scrollingContainer.scrollTop;
                this.selection.focus();
                this.scrollingContainer.scrollTop = scrollTop;
                this.scrollIntoView();
              }
            }, {
              key: "format",
              value: function format(name, value) {
                var _this4 = this;
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  var range = _this4.getSelection(true);
                  var change = new _quillDelta2.default();
                  if (range == null) {
                    return change;
                  } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
                    change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
                  } else if (range.length === 0) {
                    _this4.selection.format(name, value);
                    return change;
                  } else {
                    change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
                  }
                  _this4.setSelection(range, _emitter4.default.sources.SILENT);
                  return change;
                }, source);
              }
            }, {
              key: "formatLine",
              value: function formatLine(index, length, name, value, source) {
                var _this5 = this;
                var formats = void 0;
                var _overload3 = overload(index, length, name, value, source);
                var _overload4 = _slicedToArray(_overload3, 4);
                index = _overload4[0];
                length = _overload4[1];
                formats = _overload4[2];
                source = _overload4[3];
                return modify.call(this, function() {
                  return _this5.editor.formatLine(index, length, formats);
                }, source, index, 0);
              }
            }, {
              key: "formatText",
              value: function formatText(index, length, name, value, source) {
                var _this6 = this;
                var formats = void 0;
                var _overload5 = overload(index, length, name, value, source);
                var _overload6 = _slicedToArray(_overload5, 4);
                index = _overload6[0];
                length = _overload6[1];
                formats = _overload6[2];
                source = _overload6[3];
                return modify.call(this, function() {
                  return _this6.editor.formatText(index, length, formats);
                }, source, index, 0);
              }
            }, {
              key: "getBounds",
              value: function getBounds(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var bounds = void 0;
                if (typeof index === "number") {
                  bounds = this.selection.getBounds(index, length);
                } else {
                  bounds = this.selection.getBounds(index.index, index.length);
                }
                var containerBounds = this.container.getBoundingClientRect();
                return {
                  bottom: bounds.bottom - containerBounds.top,
                  height: bounds.height,
                  left: bounds.left - containerBounds.left,
                  right: bounds.right - containerBounds.left,
                  top: bounds.top - containerBounds.top,
                  width: bounds.width
                };
              }
            }, {
              key: "getContents",
              value: function getContents() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index;
                var _overload7 = overload(index, length);
                var _overload8 = _slicedToArray(_overload7, 2);
                index = _overload8[0];
                length = _overload8[1];
                return this.editor.getContents(index, length);
              }
            }, {
              key: "getFormat",
              value: function getFormat() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.getSelection(true);
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                if (typeof index === "number") {
                  return this.editor.getFormat(index, length);
                } else {
                  return this.editor.getFormat(index.index, index.length);
                }
              }
            }, {
              key: "getIndex",
              value: function getIndex(blot) {
                return blot.offset(this.scroll);
              }
            }, {
              key: "getLength",
              value: function getLength() {
                return this.scroll.length();
              }
            }, {
              key: "getLeaf",
              value: function getLeaf(index) {
                return this.scroll.leaf(index);
              }
            }, {
              key: "getLine",
              value: function getLine(index) {
                return this.scroll.line(index);
              }
            }, {
              key: "getLines",
              value: function getLines() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                if (typeof index !== "number") {
                  return this.scroll.lines(index.index, index.length);
                } else {
                  return this.scroll.lines(index, length);
                }
              }
            }, {
              key: "getModule",
              value: function getModule(name) {
                return this.theme.modules[name];
              }
            }, {
              key: "getSelection",
              value: function getSelection() {
                var focus = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (focus)
                  this.focus();
                this.update();
                return this.selection.getRange()[0];
              }
            }, {
              key: "getText",
              value: function getText() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.getLength() - index;
                var _overload9 = overload(index, length);
                var _overload10 = _slicedToArray(_overload9, 2);
                index = _overload10[0];
                length = _overload10[1];
                return this.editor.getText(index, length);
              }
            }, {
              key: "hasFocus",
              value: function hasFocus() {
                return this.selection.hasFocus();
              }
            }, {
              key: "insertEmbed",
              value: function insertEmbed(index, embed, value) {
                var _this7 = this;
                var source = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Quill2.sources.API;
                return modify.call(this, function() {
                  return _this7.editor.insertEmbed(index, embed, value);
                }, source, index);
              }
            }, {
              key: "insertText",
              value: function insertText(index, text, name, value, source) {
                var _this8 = this;
                var formats = void 0;
                var _overload11 = overload(index, 0, name, value, source);
                var _overload12 = _slicedToArray(_overload11, 4);
                index = _overload12[0];
                formats = _overload12[2];
                source = _overload12[3];
                return modify.call(this, function() {
                  return _this8.editor.insertText(index, text, formats);
                }, source, index, text.length);
              }
            }, {
              key: "isEnabled",
              value: function isEnabled() {
                return !this.container.classList.contains("ql-disabled");
              }
            }, {
              key: "off",
              value: function off() {
                return this.emitter.off.apply(this.emitter, arguments);
              }
            }, {
              key: "on",
              value: function on2() {
                return this.emitter.on.apply(this.emitter, arguments);
              }
            }, {
              key: "once",
              value: function once() {
                return this.emitter.once.apply(this.emitter, arguments);
              }
            }, {
              key: "pasteHTML",
              value: function pasteHTML(index, html, source) {
                this.clipboard.dangerouslyPasteHTML(index, html, source);
              }
            }, {
              key: "removeFormat",
              value: function removeFormat(index, length, source) {
                var _this9 = this;
                var _overload13 = overload(index, length, source);
                var _overload14 = _slicedToArray(_overload13, 4);
                index = _overload14[0];
                length = _overload14[1];
                source = _overload14[3];
                return modify.call(this, function() {
                  return _this9.editor.removeFormat(index, length);
                }, source, index);
              }
            }, {
              key: "scrollIntoView",
              value: function scrollIntoView() {
                this.selection.scrollIntoView(this.scrollingContainer);
              }
            }, {
              key: "setContents",
              value: function setContents(delta) {
                var _this10 = this;
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  delta = new _quillDelta2.default(delta);
                  var length = _this10.getLength();
                  var deleted = _this10.editor.deleteText(0, length);
                  var applied = _this10.editor.applyDelta(delta);
                  var lastOp = applied.ops[applied.ops.length - 1];
                  if (lastOp != null && typeof lastOp.insert === "string" && lastOp.insert[lastOp.insert.length - 1] === "\n") {
                    _this10.editor.deleteText(_this10.getLength() - 1, 1);
                    applied.delete(1);
                  }
                  var ret = deleted.compose(applied);
                  return ret;
                }, source);
              }
            }, {
              key: "setSelection",
              value: function setSelection(index, length, source) {
                if (index == null) {
                  this.selection.setRange(null, length || Quill2.sources.API);
                } else {
                  var _overload15 = overload(index, length, source);
                  var _overload16 = _slicedToArray(_overload15, 4);
                  index = _overload16[0];
                  length = _overload16[1];
                  source = _overload16[3];
                  this.selection.setRange(new _selection.Range(index, length), source);
                  if (source !== _emitter4.default.sources.SILENT) {
                    this.selection.scrollIntoView(this.scrollingContainer);
                  }
                }
              }
            }, {
              key: "setText",
              value: function setText(text) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                var delta = new _quillDelta2.default().insert(text);
                return this.setContents(delta, source);
              }
            }, {
              key: "update",
              value: function update() {
                var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
                var change = this.scroll.update(source);
                this.selection.update(source);
                return change;
              }
            }, {
              key: "updateContents",
              value: function updateContents(delta) {
                var _this11 = this;
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : _emitter4.default.sources.API;
                return modify.call(this, function() {
                  delta = new _quillDelta2.default(delta);
                  return _this11.editor.applyDelta(delta, source);
                }, source, true);
              }
            }]);
            return Quill2;
          }();
          Quill.DEFAULTS = {
            bounds: null,
            formats: null,
            modules: {},
            placeholder: "",
            readOnly: false,
            scrollingContainer: null,
            strict: true,
            theme: "default"
          };
          Quill.events = _emitter4.default.events;
          Quill.sources = _emitter4.default.sources;
          Quill.version = "1.3.7";
          Quill.imports = {
            "delta": _quillDelta2.default,
            "parchment": _parchment2.default,
            "core/module": _module2.default,
            "core/theme": _theme2.default
          };
          function expandConfig(container2, userConfig) {
            userConfig = (0, _extend2.default)(true, {
              container: container2,
              modules: {
                clipboard: true,
                keyboard: true,
                history: true
              }
            }, userConfig);
            if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
              userConfig.theme = _theme2.default;
            } else {
              userConfig.theme = Quill.import("themes/" + userConfig.theme);
              if (userConfig.theme == null) {
                throw new Error("Invalid theme " + userConfig.theme + ". Did you register it?");
              }
            }
            var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
            [themeConfig, userConfig].forEach(function(config) {
              config.modules = config.modules || {};
              Object.keys(config.modules).forEach(function(module3) {
                if (config.modules[module3] === true) {
                  config.modules[module3] = {};
                }
              });
            });
            var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
            var moduleConfig = moduleNames.reduce(function(config, name) {
              var moduleClass = Quill.import("modules/" + name);
              if (moduleClass == null) {
                debug.error("Cannot load " + name + " module. Are you sure you registered it?");
              } else {
                config[name] = moduleClass.DEFAULTS || {};
              }
              return config;
            }, {});
            if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
              userConfig.modules.toolbar = {
                container: userConfig.modules.toolbar
              };
            }
            userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
            ["bounds", "container", "scrollingContainer"].forEach(function(key) {
              if (typeof userConfig[key] === "string") {
                userConfig[key] = document.querySelector(userConfig[key]);
              }
            });
            userConfig.modules = Object.keys(userConfig.modules).reduce(function(config, name) {
              if (userConfig.modules[name]) {
                config[name] = userConfig.modules[name];
              }
              return config;
            }, {});
            return userConfig;
          }
          function modify(modifier, source, index, shift) {
            if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
              return new _quillDelta2.default();
            }
            var range = index == null ? null : this.getSelection();
            var oldDelta = this.editor.delta;
            var change = modifier();
            if (range != null) {
              if (index === true)
                index = range.index;
              if (shift == null) {
                range = shiftRange(range, change, source);
              } else if (shift !== 0) {
                range = shiftRange(range, index, shift, source);
              }
              this.setSelection(range, _emitter4.default.sources.SILENT);
            }
            if (change.length() > 0) {
              var _emitter;
              var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
              (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
              if (source !== _emitter4.default.sources.SILENT) {
                var _emitter2;
                (_emitter2 = this.emitter).emit.apply(_emitter2, args);
              }
            }
            return change;
          }
          function overload(index, length, name, value, source) {
            var formats = {};
            if (typeof index.index === "number" && typeof index.length === "number") {
              if (typeof length !== "number") {
                source = value, value = name, name = length, length = index.length, index = index.index;
              } else {
                length = index.length, index = index.index;
              }
            } else if (typeof length !== "number") {
              source = value, value = name, name = length, length = 0;
            }
            if ((typeof name === "undefined" ? "undefined" : _typeof(name)) === "object") {
              formats = name;
              source = value;
            } else if (typeof name === "string") {
              if (value != null) {
                formats[name] = value;
              } else {
                source = name;
              }
            }
            source = source || _emitter4.default.sources.API;
            return [index, length, formats, source];
          }
          function shiftRange(range, index, length, source) {
            if (range == null)
              return null;
            var start = void 0, end = void 0;
            if (index instanceof _quillDelta2.default) {
              var _map = [range.index, range.index + range.length].map(function(pos) {
                return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
              });
              var _map2 = _slicedToArray(_map, 2);
              start = _map2[0];
              end = _map2[1];
            } else {
              var _map3 = [range.index, range.index + range.length].map(function(pos) {
                if (pos < index || pos === index && source === _emitter4.default.sources.USER)
                  return pos;
                if (length >= 0) {
                  return pos + length;
                } else {
                  return Math.max(index, pos + length);
                }
              });
              var _map4 = _slicedToArray(_map3, 2);
              start = _map4[0];
              end = _map4[1];
            }
            return new _selection.Range(start, end - start);
          }
          exports2.expandConfig = expandConfig;
          exports2.overload = overload;
          exports2.default = Quill;
        },
        /* 6 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Inline = function(_Parchment$Inline) {
            _inherits(Inline2, _Parchment$Inline);
            function Inline2() {
              _classCallCheck(this, Inline2);
              return _possibleConstructorReturn(this, (Inline2.__proto__ || Object.getPrototypeOf(Inline2)).apply(this, arguments));
            }
            _createClass(Inline2, [{
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (Inline2.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
                  var blot = this.isolate(index, length);
                  if (value) {
                    blot.wrap(name, value);
                  }
                } else {
                  _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "formatAt", this).call(this, index, length, name, value);
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(Inline2.prototype.__proto__ || Object.getPrototypeOf(Inline2.prototype), "optimize", this).call(this, context);
                if (this.parent instanceof Inline2 && Inline2.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
                  var parent = this.parent.isolate(this.offset(), this.length());
                  this.moveChildren(parent);
                  parent.wrap(this);
                }
              }
            }], [{
              key: "compare",
              value: function compare(self2, other) {
                var selfIndex = Inline2.order.indexOf(self2);
                var otherIndex = Inline2.order.indexOf(other);
                if (selfIndex >= 0 || otherIndex >= 0) {
                  return selfIndex - otherIndex;
                } else if (self2 === other) {
                  return 0;
                } else if (self2 < other) {
                  return -1;
                } else {
                  return 1;
                }
              }
            }]);
            return Inline2;
          }(_parchment2.default.Inline);
          Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
          Inline.order = [
            "cursor",
            "inline",
            // Must be lower
            "underline",
            "strike",
            "italic",
            "bold",
            "script",
            "link",
            "code"
            // Must be higher
          ];
          exports2.default = Inline;
        },
        /* 7 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TextBlot = function(_Parchment$Text) {
            _inherits(TextBlot2, _Parchment$Text);
            function TextBlot2() {
              _classCallCheck(this, TextBlot2);
              return _possibleConstructorReturn(this, (TextBlot2.__proto__ || Object.getPrototypeOf(TextBlot2)).apply(this, arguments));
            }
            return TextBlot2;
          }(_parchment2.default.Text);
          exports2.default = TextBlot;
        },
        /* 8 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _eventemitter = __webpack_require__(54);
          var _eventemitter2 = _interopRequireDefault(_eventemitter);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:events");
          var EVENTS = ["selectionchange", "mousedown", "mouseup", "click"];
          EVENTS.forEach(function(eventName) {
            document.addEventListener(eventName, function() {
              for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
              }
              [].slice.call(document.querySelectorAll(".ql-container")).forEach(function(node) {
                if (node.__quill && node.__quill.emitter) {
                  var _node$__quill$emitter;
                  (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
                }
              });
            });
          });
          var Emitter = function(_EventEmitter) {
            _inherits(Emitter2, _EventEmitter);
            function Emitter2() {
              _classCallCheck(this, Emitter2);
              var _this = _possibleConstructorReturn(this, (Emitter2.__proto__ || Object.getPrototypeOf(Emitter2)).call(this));
              _this.listeners = {};
              _this.on("error", debug.error);
              return _this;
            }
            _createClass(Emitter2, [{
              key: "emit",
              value: function emit() {
                debug.log.apply(debug, arguments);
                _get(Emitter2.prototype.__proto__ || Object.getPrototypeOf(Emitter2.prototype), "emit", this).apply(this, arguments);
              }
            }, {
              key: "handleDOM",
              value: function handleDOM(event) {
                for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  args[_key2 - 1] = arguments[_key2];
                }
                (this.listeners[event.type] || []).forEach(function(_ref) {
                  var node = _ref.node, handler = _ref.handler;
                  if (event.target === node || node.contains(event.target)) {
                    handler.apply(void 0, [event].concat(args));
                  }
                });
              }
            }, {
              key: "listenDOM",
              value: function listenDOM(eventName, node, handler) {
                if (!this.listeners[eventName]) {
                  this.listeners[eventName] = [];
                }
                this.listeners[eventName].push({ node, handler });
              }
            }]);
            return Emitter2;
          }(_eventemitter2.default);
          Emitter.events = {
            EDITOR_CHANGE: "editor-change",
            SCROLL_BEFORE_UPDATE: "scroll-before-update",
            SCROLL_OPTIMIZE: "scroll-optimize",
            SCROLL_UPDATE: "scroll-update",
            SELECTION_CHANGE: "selection-change",
            TEXT_CHANGE: "text-change"
          };
          Emitter.sources = {
            API: "api",
            SILENT: "silent",
            USER: "user"
          };
          exports2.default = Emitter;
        },
        /* 9 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Module = function Module2(quill2) {
            var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            _classCallCheck(this, Module2);
            this.quill = quill2;
            this.options = options;
          };
          Module.DEFAULTS = {};
          exports2.default = Module;
        },
        /* 10 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var levels = ["error", "warn", "log", "info"];
          var level = "warn";
          function debug(method) {
            if (levels.indexOf(method) <= levels.indexOf(level)) {
              var _console;
              for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
              }
              (_console = console)[method].apply(_console, args);
            }
          }
          function namespace(ns) {
            return levels.reduce(function(logger, method) {
              logger[method] = debug.bind(console, method, ns);
              return logger;
            }, {});
          }
          debug.level = namespace.level = function(newLevel) {
            level = newLevel;
          };
          exports2.default = namespace;
        },
        /* 11 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var pSlice = Array.prototype.slice;
          var objectKeys = __webpack_require__(52);
          var isArguments2 = __webpack_require__(53);
          var deepEqual = module2.exports = function(actual, expected, opts) {
            if (!opts)
              opts = {};
            if (actual === expected) {
              return true;
            } else if (actual instanceof Date && expected instanceof Date) {
              return actual.getTime() === expected.getTime();
            } else if (!actual || !expected || typeof actual != "object" && typeof expected != "object") {
              return opts.strict ? actual === expected : actual == expected;
            } else {
              return objEquiv(actual, expected, opts);
            }
          };
          function isUndefinedOrNull(value) {
            return value === null || value === void 0;
          }
          function isBuffer2(x2) {
            if (!x2 || typeof x2 !== "object" || typeof x2.length !== "number")
              return false;
            if (typeof x2.copy !== "function" || typeof x2.slice !== "function") {
              return false;
            }
            if (x2.length > 0 && typeof x2[0] !== "number")
              return false;
            return true;
          }
          function objEquiv(a, b, opts) {
            var i, key;
            if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
              return false;
            if (a.prototype !== b.prototype)
              return false;
            if (isArguments2(a)) {
              if (!isArguments2(b)) {
                return false;
              }
              a = pSlice.call(a);
              b = pSlice.call(b);
              return deepEqual(a, b, opts);
            }
            if (isBuffer2(a)) {
              if (!isBuffer2(b)) {
                return false;
              }
              if (a.length !== b.length)
                return false;
              for (i = 0; i < a.length; i++) {
                if (a[i] !== b[i])
                  return false;
              }
              return true;
            }
            try {
              var ka = objectKeys(a), kb = objectKeys(b);
            } catch (e) {
              return false;
            }
            if (ka.length != kb.length)
              return false;
            ka.sort();
            kb.sort();
            for (i = ka.length - 1; i >= 0; i--) {
              if (ka[i] != kb[i])
                return false;
            }
            for (i = ka.length - 1; i >= 0; i--) {
              key = ka[i];
              if (!deepEqual(a[key], b[key], opts))
                return false;
            }
            return typeof a === typeof b;
          }
        },
        /* 12 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", { value: true });
          var Registry = __webpack_require__(1);
          var Attributor = (
            /** @class */
            function() {
              function Attributor2(attrName, keyName, options) {
                if (options === void 0) {
                  options = {};
                }
                this.attrName = attrName;
                this.keyName = keyName;
                var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
                if (options.scope != null) {
                  this.scope = options.scope & Registry.Scope.LEVEL | attributeBit;
                } else {
                  this.scope = Registry.Scope.ATTRIBUTE;
                }
                if (options.whitelist != null)
                  this.whitelist = options.whitelist;
              }
              Attributor2.keys = function(node) {
                return [].map.call(node.attributes, function(item) {
                  return item.name;
                });
              };
              Attributor2.prototype.add = function(node, value) {
                if (!this.canAdd(node, value))
                  return false;
                node.setAttribute(this.keyName, value);
                return true;
              };
              Attributor2.prototype.canAdd = function(node, value) {
                var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
                if (match == null)
                  return false;
                if (this.whitelist == null)
                  return true;
                if (typeof value === "string") {
                  return this.whitelist.indexOf(value.replace(/["']/g, "")) > -1;
                } else {
                  return this.whitelist.indexOf(value) > -1;
                }
              };
              Attributor2.prototype.remove = function(node) {
                node.removeAttribute(this.keyName);
              };
              Attributor2.prototype.value = function(node) {
                var value = node.getAttribute(this.keyName);
                if (this.canAdd(node, value) && value) {
                  return value;
                }
                return "";
              };
              return Attributor2;
            }()
          );
          exports2.default = Attributor;
        },
        /* 13 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.Code = void 0;
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Code = function(_Inline) {
            _inherits(Code2, _Inline);
            function Code2() {
              _classCallCheck(this, Code2);
              return _possibleConstructorReturn(this, (Code2.__proto__ || Object.getPrototypeOf(Code2)).apply(this, arguments));
            }
            return Code2;
          }(_inline2.default);
          Code.blotName = "code";
          Code.tagName = "CODE";
          var CodeBlock = function(_Block) {
            _inherits(CodeBlock2, _Block);
            function CodeBlock2() {
              _classCallCheck(this, CodeBlock2);
              return _possibleConstructorReturn(this, (CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2)).apply(this, arguments));
            }
            _createClass(CodeBlock2, [{
              key: "delta",
              value: function delta() {
                var _this3 = this;
                var text = this.domNode.textContent;
                if (text.endsWith("\n")) {
                  text = text.slice(0, -1);
                }
                return text.split("\n").reduce(function(delta2, frag) {
                  return delta2.insert(frag).insert("\n", _this3.formats());
                }, new _quillDelta2.default());
              }
            }, {
              key: "format",
              value: function format(name, value) {
                if (name === this.statics.blotName && value)
                  return;
                var _descendant = this.descendant(_text2.default, this.length() - 1), _descendant2 = _slicedToArray(_descendant, 1), text = _descendant2[0];
                if (text != null) {
                  text.deleteAt(text.length() - 1, 1);
                }
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "format", this).call(this, name, value);
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, name, value) {
                if (length === 0)
                  return;
                if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
                  return;
                }
                var nextNewline = this.newlineIndex(index);
                if (nextNewline < 0 || nextNewline >= index + length)
                  return;
                var prevNewline = this.newlineIndex(index, true) + 1;
                var isolateLength = nextNewline - prevNewline + 1;
                var blot = this.isolate(prevNewline, isolateLength);
                var next = blot.next;
                blot.format(name, value);
                if (next instanceof CodeBlock2) {
                  next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
                }
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null)
                  return;
                var _descendant3 = this.descendant(_text2.default, index), _descendant4 = _slicedToArray(_descendant3, 2), text = _descendant4[0], offset = _descendant4[1];
                text.insertAt(offset, value);
              }
            }, {
              key: "length",
              value: function length() {
                var length2 = this.domNode.textContent.length;
                if (!this.domNode.textContent.endsWith("\n")) {
                  return length2 + 1;
                }
                return length2;
              }
            }, {
              key: "newlineIndex",
              value: function newlineIndex(searchIndex) {
                var reverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (!reverse) {
                  var offset = this.domNode.textContent.slice(searchIndex).indexOf("\n");
                  return offset > -1 ? searchIndex + offset : -1;
                } else {
                  return this.domNode.textContent.slice(0, searchIndex).lastIndexOf("\n");
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                if (!this.domNode.textContent.endsWith("\n")) {
                  this.appendChild(_parchment2.default.create("text", "\n"));
                }
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "optimize", this).call(this, context);
                var next = this.next;
                if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
                  next.optimize(context);
                  next.moveChildren(this);
                  next.remove();
                }
              }
            }, {
              key: "replace",
              value: function replace(target) {
                _get(CodeBlock2.prototype.__proto__ || Object.getPrototypeOf(CodeBlock2.prototype), "replace", this).call(this, target);
                [].slice.call(this.domNode.querySelectorAll("*")).forEach(function(node) {
                  var blot = _parchment2.default.find(node);
                  if (blot == null) {
                    node.parentNode.removeChild(node);
                  } else if (blot instanceof _parchment2.default.Embed) {
                    blot.remove();
                  } else {
                    blot.unwrap();
                  }
                });
              }
            }], [{
              key: "create",
              value: function create(value) {
                var domNode = _get(CodeBlock2.__proto__ || Object.getPrototypeOf(CodeBlock2), "create", this).call(this, value);
                domNode.setAttribute("spellcheck", false);
                return domNode;
              }
            }, {
              key: "formats",
              value: function formats() {
                return true;
              }
            }]);
            return CodeBlock2;
          }(_block2.default);
          CodeBlock.blotName = "code-block";
          CodeBlock.tagName = "PRE";
          CodeBlock.TAB = "  ";
          exports2.Code = Code;
          exports2.default = CodeBlock;
        },
        /* 14 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _op = __webpack_require__(20);
          var _op2 = _interopRequireDefault(_op);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _cursor = __webpack_require__(24);
          var _cursor2 = _interopRequireDefault(_cursor);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var ASCII = /^[ -~]*$/;
          var Editor = function() {
            function Editor2(scroll) {
              _classCallCheck(this, Editor2);
              this.scroll = scroll;
              this.delta = this.getDelta();
            }
            _createClass(Editor2, [{
              key: "applyDelta",
              value: function applyDelta(delta) {
                var _this = this;
                var consumeNextNewline = false;
                this.scroll.update();
                var scrollLength = this.scroll.length();
                this.scroll.batchStart();
                delta = normalizeDelta(delta);
                delta.reduce(function(index, op) {
                  var length = op.retain || op.delete || op.insert.length || 1;
                  var attributes = op.attributes || {};
                  if (op.insert != null) {
                    if (typeof op.insert === "string") {
                      var text = op.insert;
                      if (text.endsWith("\n") && consumeNextNewline) {
                        consumeNextNewline = false;
                        text = text.slice(0, -1);
                      }
                      if (index >= scrollLength && !text.endsWith("\n")) {
                        consumeNextNewline = true;
                      }
                      _this.scroll.insertAt(index, text);
                      var _scroll$line = _this.scroll.line(index), _scroll$line2 = _slicedToArray(_scroll$line, 2), line2 = _scroll$line2[0], offset = _scroll$line2[1];
                      var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line2));
                      if (line2 instanceof _block2.default) {
                        var _line$descendant = line2.descendant(_parchment2.default.Leaf, offset), _line$descendant2 = _slicedToArray(_line$descendant, 1), leaf = _line$descendant2[0];
                        formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
                      }
                      attributes = _op2.default.attributes.diff(formats, attributes) || {};
                    } else if (_typeof(op.insert) === "object") {
                      var key = Object.keys(op.insert)[0];
                      if (key == null)
                        return index;
                      _this.scroll.insertAt(index, key, op.insert[key]);
                    }
                    scrollLength += length;
                  }
                  Object.keys(attributes).forEach(function(name) {
                    _this.scroll.formatAt(index, length, name, attributes[name]);
                  });
                  return index + length;
                }, 0);
                delta.reduce(function(index, op) {
                  if (typeof op.delete === "number") {
                    _this.scroll.deleteAt(index, op.delete);
                    return index;
                  }
                  return index + (op.retain || op.insert.length || 1);
                }, 0);
                this.scroll.batchEnd();
                return this.update(delta);
              }
            }, {
              key: "deleteText",
              value: function deleteText(index, length) {
                this.scroll.deleteAt(index, length);
                return this.update(new _quillDelta2.default().retain(index).delete(length));
              }
            }, {
              key: "formatLine",
              value: function formatLine(index, length) {
                var _this2 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                this.scroll.update();
                Object.keys(formats).forEach(function(format) {
                  if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format])
                    return;
                  var lines = _this2.scroll.lines(index, Math.max(length, 1));
                  var lengthRemaining = length;
                  lines.forEach(function(line2) {
                    var lineLength = line2.length();
                    if (!(line2 instanceof _code2.default)) {
                      line2.format(format, formats[format]);
                    } else {
                      var codeIndex = index - line2.offset(_this2.scroll);
                      var codeLength = line2.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
                      line2.formatAt(codeIndex, codeLength, format, formats[format]);
                    }
                    lengthRemaining -= lineLength;
                  });
                });
                this.scroll.optimize();
                return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
              }
            }, {
              key: "formatText",
              value: function formatText(index, length) {
                var _this3 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                Object.keys(formats).forEach(function(format) {
                  _this3.scroll.formatAt(index, length, format, formats[format]);
                });
                return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
              }
            }, {
              key: "getContents",
              value: function getContents(index, length) {
                return this.delta.slice(index, index + length);
              }
            }, {
              key: "getDelta",
              value: function getDelta() {
                return this.scroll.lines().reduce(function(delta, line2) {
                  return delta.concat(line2.delta());
                }, new _quillDelta2.default());
              }
            }, {
              key: "getFormat",
              value: function getFormat(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var lines = [], leaves = [];
                if (length === 0) {
                  this.scroll.path(index).forEach(function(path) {
                    var _path = _slicedToArray(path, 1), blot = _path[0];
                    if (blot instanceof _block2.default) {
                      lines.push(blot);
                    } else if (blot instanceof _parchment2.default.Leaf) {
                      leaves.push(blot);
                    }
                  });
                } else {
                  lines = this.scroll.lines(index, length);
                  leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
                }
                var formatsArr = [lines, leaves].map(function(blots) {
                  if (blots.length === 0)
                    return {};
                  var formats = (0, _block.bubbleFormats)(blots.shift());
                  while (Object.keys(formats).length > 0) {
                    var blot = blots.shift();
                    if (blot == null)
                      return formats;
                    formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
                  }
                  return formats;
                });
                return _extend2.default.apply(_extend2.default, formatsArr);
              }
            }, {
              key: "getText",
              value: function getText(index, length) {
                return this.getContents(index, length).filter(function(op) {
                  return typeof op.insert === "string";
                }).map(function(op) {
                  return op.insert;
                }).join("");
              }
            }, {
              key: "insertEmbed",
              value: function insertEmbed(index, embed, value) {
                this.scroll.insertAt(index, embed, value);
                return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
              }
            }, {
              key: "insertText",
              value: function insertText(index, text) {
                var _this4 = this;
                var formats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                text = text.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                this.scroll.insertAt(index, text);
                Object.keys(formats).forEach(function(format) {
                  _this4.scroll.formatAt(index, text.length, format, formats[format]);
                });
                return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
              }
            }, {
              key: "isBlank",
              value: function isBlank() {
                if (this.scroll.children.length == 0)
                  return true;
                if (this.scroll.children.length > 1)
                  return false;
                var block = this.scroll.children.head;
                if (block.statics.blotName !== _block2.default.blotName)
                  return false;
                if (block.children.length > 1)
                  return false;
                return block.children.head instanceof _break2.default;
              }
            }, {
              key: "removeFormat",
              value: function removeFormat(index, length) {
                var text = this.getText(index, length);
                var _scroll$line3 = this.scroll.line(index + length), _scroll$line4 = _slicedToArray(_scroll$line3, 2), line2 = _scroll$line4[0], offset = _scroll$line4[1];
                var suffixLength = 0, suffix = new _quillDelta2.default();
                if (line2 != null) {
                  if (!(line2 instanceof _code2.default)) {
                    suffixLength = line2.length() - offset;
                  } else {
                    suffixLength = line2.newlineIndex(offset) - offset + 1;
                  }
                  suffix = line2.delta().slice(offset, offset + suffixLength - 1).insert("\n");
                }
                var contents = this.getContents(index, length + suffixLength);
                var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
                var delta = new _quillDelta2.default().retain(index).concat(diff);
                return this.applyDelta(delta);
              }
            }, {
              key: "update",
              value: function update(change) {
                var mutations = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                var cursorIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : void 0;
                var oldDelta = this.delta;
                if (mutations.length === 1 && mutations[0].type === "characterData" && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
                  var textBlot = _parchment2.default.find(mutations[0].target);
                  var formats = (0, _block.bubbleFormats)(textBlot);
                  var index = textBlot.offset(this.scroll);
                  var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, "");
                  var oldText = new _quillDelta2.default().insert(oldValue);
                  var newText = new _quillDelta2.default().insert(textBlot.value());
                  var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
                  change = diffDelta.reduce(function(delta, op) {
                    if (op.insert) {
                      return delta.insert(op.insert, formats);
                    } else {
                      return delta.push(op);
                    }
                  }, new _quillDelta2.default());
                  this.delta = oldDelta.compose(change);
                } else {
                  this.delta = this.getDelta();
                  if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
                    change = oldDelta.diff(this.delta, cursorIndex);
                  }
                }
                return change;
              }
            }]);
            return Editor2;
          }();
          function combineFormats(formats, combined) {
            return Object.keys(combined).reduce(function(merged, name) {
              if (formats[name] == null)
                return merged;
              if (combined[name] === formats[name]) {
                merged[name] = combined[name];
              } else if (Array.isArray(combined[name])) {
                if (combined[name].indexOf(formats[name]) < 0) {
                  merged[name] = combined[name].concat([formats[name]]);
                }
              } else {
                merged[name] = [combined[name], formats[name]];
              }
              return merged;
            }, {});
          }
          function normalizeDelta(delta) {
            return delta.reduce(function(delta2, op) {
              if (op.insert === 1) {
                var attributes = (0, _clone2.default)(op.attributes);
                delete attributes["image"];
                return delta2.insert({ image: op.attributes.image }, attributes);
              }
              if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
                op = (0, _clone2.default)(op);
                if (op.attributes.list) {
                  op.attributes.list = "ordered";
                } else {
                  op.attributes.list = "bullet";
                  delete op.attributes.bullet;
                }
              }
              if (typeof op.insert === "string") {
                var text = op.insert.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                return delta2.insert(text, op.attributes);
              }
              return delta2.push(op);
            }, new _quillDelta2.default());
          }
          exports2.default = Editor;
        },
        /* 15 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.Range = void 0;
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _emitter3 = __webpack_require__(8);
          var _emitter4 = _interopRequireDefault(_emitter3);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _toConsumableArray(arr) {
            if (Array.isArray(arr)) {
              for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
                arr2[i] = arr[i];
              }
              return arr2;
            } else {
              return Array.from(arr);
            }
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var debug = (0, _logger2.default)("quill:selection");
          var Range = function Range2(index) {
            var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
            _classCallCheck(this, Range2);
            this.index = index;
            this.length = length;
          };
          var Selection = function() {
            function Selection2(scroll, emitter) {
              var _this = this;
              _classCallCheck(this, Selection2);
              this.emitter = emitter;
              this.scroll = scroll;
              this.composing = false;
              this.mouseDown = false;
              this.root = this.scroll.domNode;
              this.cursor = _parchment2.default.create("cursor", this);
              this.lastRange = this.savedRange = new Range(0, 0);
              this.handleComposition();
              this.handleDragging();
              this.emitter.listenDOM("selectionchange", document, function() {
                if (!_this.mouseDown) {
                  setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
                }
              });
              this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function(type, delta) {
                if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
                  _this.update(_emitter4.default.sources.SILENT);
                }
              });
              this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function() {
                if (!_this.hasFocus())
                  return;
                var native = _this.getNativeRange();
                if (native == null)
                  return;
                if (native.start.node === _this.cursor.textNode)
                  return;
                _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function() {
                  try {
                    _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
                  } catch (ignored) {
                  }
                });
              });
              this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function(mutations, context) {
                if (context.range) {
                  var _context$range = context.range, startNode = _context$range.startNode, startOffset = _context$range.startOffset, endNode = _context$range.endNode, endOffset = _context$range.endOffset;
                  _this.setNativeRange(startNode, startOffset, endNode, endOffset);
                }
              });
              this.update(_emitter4.default.sources.SILENT);
            }
            _createClass(Selection2, [{
              key: "handleComposition",
              value: function handleComposition() {
                var _this2 = this;
                this.root.addEventListener("compositionstart", function() {
                  _this2.composing = true;
                });
                this.root.addEventListener("compositionend", function() {
                  _this2.composing = false;
                  if (_this2.cursor.parent) {
                    var range = _this2.cursor.restore();
                    if (!range)
                      return;
                    setTimeout(function() {
                      _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
                    }, 1);
                  }
                });
              }
            }, {
              key: "handleDragging",
              value: function handleDragging() {
                var _this3 = this;
                this.emitter.listenDOM("mousedown", document.body, function() {
                  _this3.mouseDown = true;
                });
                this.emitter.listenDOM("mouseup", document.body, function() {
                  _this3.mouseDown = false;
                  _this3.update(_emitter4.default.sources.USER);
                });
              }
            }, {
              key: "focus",
              value: function focus() {
                if (this.hasFocus())
                  return;
                this.root.focus();
                this.setRange(this.savedRange);
              }
            }, {
              key: "format",
              value: function format(_format, value) {
                if (this.scroll.whitelist != null && !this.scroll.whitelist[_format])
                  return;
                this.scroll.update();
                var nativeRange = this.getNativeRange();
                if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK))
                  return;
                if (nativeRange.start.node !== this.cursor.textNode) {
                  var blot = _parchment2.default.find(nativeRange.start.node, false);
                  if (blot == null)
                    return;
                  if (blot instanceof _parchment2.default.Leaf) {
                    var after = blot.split(nativeRange.start.offset);
                    blot.parent.insertBefore(this.cursor, after);
                  } else {
                    blot.insertBefore(this.cursor, nativeRange.start.node);
                  }
                  this.cursor.attach();
                }
                this.cursor.format(_format, value);
                this.scroll.optimize();
                this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
                this.update();
              }
            }, {
              key: "getBounds",
              value: function getBounds(index) {
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                var scrollLength = this.scroll.length();
                index = Math.min(index, scrollLength - 1);
                length = Math.min(index + length, scrollLength - 1) - index;
                var node = void 0, _scroll$leaf = this.scroll.leaf(index), _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2), leaf = _scroll$leaf2[0], offset = _scroll$leaf2[1];
                if (leaf == null)
                  return null;
                var _leaf$position = leaf.position(offset, true);
                var _leaf$position2 = _slicedToArray(_leaf$position, 2);
                node = _leaf$position2[0];
                offset = _leaf$position2[1];
                var range = document.createRange();
                if (length > 0) {
                  range.setStart(node, offset);
                  var _scroll$leaf3 = this.scroll.leaf(index + length);
                  var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);
                  leaf = _scroll$leaf4[0];
                  offset = _scroll$leaf4[1];
                  if (leaf == null)
                    return null;
                  var _leaf$position3 = leaf.position(offset, true);
                  var _leaf$position4 = _slicedToArray(_leaf$position3, 2);
                  node = _leaf$position4[0];
                  offset = _leaf$position4[1];
                  range.setEnd(node, offset);
                  return range.getBoundingClientRect();
                } else {
                  var side = "left";
                  var rect = void 0;
                  if (node instanceof Text) {
                    if (offset < node.data.length) {
                      range.setStart(node, offset);
                      range.setEnd(node, offset + 1);
                    } else {
                      range.setStart(node, offset - 1);
                      range.setEnd(node, offset);
                      side = "right";
                    }
                    rect = range.getBoundingClientRect();
                  } else {
                    rect = leaf.domNode.getBoundingClientRect();
                    if (offset > 0)
                      side = "right";
                  }
                  return {
                    bottom: rect.top + rect.height,
                    height: rect.height,
                    left: rect[side],
                    right: rect[side],
                    top: rect.top,
                    width: 0
                  };
                }
              }
            }, {
              key: "getNativeRange",
              value: function getNativeRange() {
                var selection = document.getSelection();
                if (selection == null || selection.rangeCount <= 0)
                  return null;
                var nativeRange = selection.getRangeAt(0);
                if (nativeRange == null)
                  return null;
                var range = this.normalizeNative(nativeRange);
                debug.info("getNativeRange", range);
                return range;
              }
            }, {
              key: "getRange",
              value: function getRange() {
                var normalized = this.getNativeRange();
                if (normalized == null)
                  return [null, null];
                var range = this.normalizedToRange(normalized);
                return [range, normalized];
              }
            }, {
              key: "hasFocus",
              value: function hasFocus() {
                return document.activeElement === this.root;
              }
            }, {
              key: "normalizedToRange",
              value: function normalizedToRange(range) {
                var _this4 = this;
                var positions = [[range.start.node, range.start.offset]];
                if (!range.native.collapsed) {
                  positions.push([range.end.node, range.end.offset]);
                }
                var indexes = positions.map(function(position) {
                  var _position = _slicedToArray(position, 2), node = _position[0], offset = _position[1];
                  var blot = _parchment2.default.find(node, true);
                  var index = blot.offset(_this4.scroll);
                  if (offset === 0) {
                    return index;
                  } else if (blot instanceof _parchment2.default.Container) {
                    return index + blot.length();
                  } else {
                    return index + blot.index(node, offset);
                  }
                });
                var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
                var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
                return new Range(start, end - start);
              }
            }, {
              key: "normalizeNative",
              value: function normalizeNative(nativeRange) {
                if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
                  return null;
                }
                var range = {
                  start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
                  end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
                  native: nativeRange
                };
                [range.start, range.end].forEach(function(position) {
                  var node = position.node, offset = position.offset;
                  while (!(node instanceof Text) && node.childNodes.length > 0) {
                    if (node.childNodes.length > offset) {
                      node = node.childNodes[offset];
                      offset = 0;
                    } else if (node.childNodes.length === offset) {
                      node = node.lastChild;
                      offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
                    } else {
                      break;
                    }
                  }
                  position.node = node, position.offset = offset;
                });
                return range;
              }
            }, {
              key: "rangeToNative",
              value: function rangeToNative(range) {
                var _this5 = this;
                var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
                var args = [];
                var scrollLength = this.scroll.length();
                indexes.forEach(function(index, i) {
                  index = Math.min(scrollLength - 1, index);
                  var node = void 0, _scroll$leaf5 = _this5.scroll.leaf(index), _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2), leaf = _scroll$leaf6[0], offset = _scroll$leaf6[1];
                  var _leaf$position5 = leaf.position(offset, i !== 0);
                  var _leaf$position6 = _slicedToArray(_leaf$position5, 2);
                  node = _leaf$position6[0];
                  offset = _leaf$position6[1];
                  args.push(node, offset);
                });
                if (args.length < 2) {
                  args = args.concat(args);
                }
                return args;
              }
            }, {
              key: "scrollIntoView",
              value: function scrollIntoView(scrollingContainer) {
                var range = this.lastRange;
                if (range == null)
                  return;
                var bounds = this.getBounds(range.index, range.length);
                if (bounds == null)
                  return;
                var limit = this.scroll.length() - 1;
                var _scroll$line = this.scroll.line(Math.min(range.index, limit)), _scroll$line2 = _slicedToArray(_scroll$line, 1), first = _scroll$line2[0];
                var last = first;
                if (range.length > 0) {
                  var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));
                  var _scroll$line4 = _slicedToArray(_scroll$line3, 1);
                  last = _scroll$line4[0];
                }
                if (first == null || last == null)
                  return;
                var scrollBounds = scrollingContainer.getBoundingClientRect();
                if (bounds.top < scrollBounds.top) {
                  scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
                } else if (bounds.bottom > scrollBounds.bottom) {
                  scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
                }
              }
            }, {
              key: "setNativeRange",
              value: function setNativeRange(startNode, startOffset) {
                var endNode = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : startNode;
                var endOffset = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : startOffset;
                var force = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
                debug.info("setNativeRange", startNode, startOffset, endNode, endOffset);
                if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
                  return;
                }
                var selection = document.getSelection();
                if (selection == null)
                  return;
                if (startNode != null) {
                  if (!this.hasFocus())
                    this.root.focus();
                  var native = (this.getNativeRange() || {}).native;
                  if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {
                    if (startNode.tagName == "BR") {
                      startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
                      startNode = startNode.parentNode;
                    }
                    if (endNode.tagName == "BR") {
                      endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
                      endNode = endNode.parentNode;
                    }
                    var range = document.createRange();
                    range.setStart(startNode, startOffset);
                    range.setEnd(endNode, endOffset);
                    selection.removeAllRanges();
                    selection.addRange(range);
                  }
                } else {
                  selection.removeAllRanges();
                  this.root.blur();
                  document.body.focus();
                }
              }
            }, {
              key: "setRange",
              value: function setRange(range) {
                var force = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _emitter4.default.sources.API;
                if (typeof force === "string") {
                  source = force;
                  force = false;
                }
                debug.info("setRange", range);
                if (range != null) {
                  var args = this.rangeToNative(range);
                  this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
                } else {
                  this.setNativeRange(null);
                }
                this.update(source);
              }
            }, {
              key: "update",
              value: function update() {
                var source = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : _emitter4.default.sources.USER;
                var oldRange = this.lastRange;
                var _getRange = this.getRange(), _getRange2 = _slicedToArray(_getRange, 2), lastRange = _getRange2[0], nativeRange = _getRange2[1];
                this.lastRange = lastRange;
                if (this.lastRange != null) {
                  this.savedRange = this.lastRange;
                }
                if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
                  var _emitter;
                  if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
                    this.cursor.restore();
                  }
                  var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
                  (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
                  if (source !== _emitter4.default.sources.SILENT) {
                    var _emitter2;
                    (_emitter2 = this.emitter).emit.apply(_emitter2, args);
                  }
                }
              }
            }]);
            return Selection2;
          }();
          function contains(parent, descendant) {
            try {
              descendant.parentNode;
            } catch (e) {
              return false;
            }
            if (descendant instanceof Text) {
              descendant = descendant.parentNode;
            }
            return parent.contains(descendant);
          }
          exports2.Range = Range;
          exports2.default = Selection;
        },
        /* 16 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Break = function(_Parchment$Embed) {
            _inherits(Break2, _Parchment$Embed);
            function Break2() {
              _classCallCheck(this, Break2);
              return _possibleConstructorReturn(this, (Break2.__proto__ || Object.getPrototypeOf(Break2)).apply(this, arguments));
            }
            _createClass(Break2, [{
              key: "insertInto",
              value: function insertInto(parent, ref) {
                if (parent.children.length === 0) {
                  _get(Break2.prototype.__proto__ || Object.getPrototypeOf(Break2.prototype), "insertInto", this).call(this, parent, ref);
                } else {
                  this.remove();
                }
              }
            }, {
              key: "length",
              value: function length() {
                return 0;
              }
            }, {
              key: "value",
              value: function value() {
                return "";
              }
            }], [{
              key: "value",
              value: function value() {
                return void 0;
              }
            }]);
            return Break2;
          }(_parchment2.default.Embed);
          Break.blotName = "break";
          Break.tagName = "BR";
          exports2.default = Break;
        },
        /* 17 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var linked_list_1 = __webpack_require__(44);
          var shadow_1 = __webpack_require__(30);
          var Registry = __webpack_require__(1);
          var ContainerBlot = (
            /** @class */
            function(_super) {
              __extends2(ContainerBlot2, _super);
              function ContainerBlot2(domNode) {
                var _this = _super.call(this, domNode) || this;
                _this.build();
                return _this;
              }
              ContainerBlot2.prototype.appendChild = function(other) {
                this.insertBefore(other);
              };
              ContainerBlot2.prototype.attach = function() {
                _super.prototype.attach.call(this);
                this.children.forEach(function(child) {
                  child.attach();
                });
              };
              ContainerBlot2.prototype.build = function() {
                var _this = this;
                this.children = new linked_list_1.default();
                [].slice.call(this.domNode.childNodes).reverse().forEach(function(node) {
                  try {
                    var child = makeBlot(node);
                    _this.insertBefore(child, _this.children.head || void 0);
                  } catch (err) {
                    if (err instanceof Registry.ParchmentError)
                      return;
                    else
                      throw err;
                  }
                });
              };
              ContainerBlot2.prototype.deleteAt = function(index, length) {
                if (index === 0 && length === this.length()) {
                  return this.remove();
                }
                this.children.forEachAt(index, length, function(child, offset, length2) {
                  child.deleteAt(offset, length2);
                });
              };
              ContainerBlot2.prototype.descendant = function(criteria, index) {
                var _a = this.children.find(index), child = _a[0], offset = _a[1];
                if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
                  return [child, offset];
                } else if (child instanceof ContainerBlot2) {
                  return child.descendant(criteria, offset);
                } else {
                  return [null, -1];
                }
              };
              ContainerBlot2.prototype.descendants = function(criteria, index, length) {
                if (index === void 0) {
                  index = 0;
                }
                if (length === void 0) {
                  length = Number.MAX_VALUE;
                }
                var descendants = [];
                var lengthLeft = length;
                this.children.forEachAt(index, length, function(child, index2, length2) {
                  if (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) {
                    descendants.push(child);
                  }
                  if (child instanceof ContainerBlot2) {
                    descendants = descendants.concat(child.descendants(criteria, index2, lengthLeft));
                  }
                  lengthLeft -= length2;
                });
                return descendants;
              };
              ContainerBlot2.prototype.detach = function() {
                this.children.forEach(function(child) {
                  child.detach();
                });
                _super.prototype.detach.call(this);
              };
              ContainerBlot2.prototype.formatAt = function(index, length, name, value) {
                this.children.forEachAt(index, length, function(child, offset, length2) {
                  child.formatAt(offset, length2, name, value);
                });
              };
              ContainerBlot2.prototype.insertAt = function(index, value, def) {
                var _a = this.children.find(index), child = _a[0], offset = _a[1];
                if (child) {
                  child.insertAt(offset, value, def);
                } else {
                  var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                  this.appendChild(blot);
                }
              };
              ContainerBlot2.prototype.insertBefore = function(childBlot, refBlot) {
                if (this.statics.allowedChildren != null && !this.statics.allowedChildren.some(function(child) {
                  return childBlot instanceof child;
                })) {
                  throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
                }
                childBlot.insertInto(this, refBlot);
              };
              ContainerBlot2.prototype.length = function() {
                return this.children.reduce(function(memo, child) {
                  return memo + child.length();
                }, 0);
              };
              ContainerBlot2.prototype.moveChildren = function(targetParent, refNode) {
                this.children.forEach(function(child) {
                  targetParent.insertBefore(child, refNode);
                });
              };
              ContainerBlot2.prototype.optimize = function(context) {
                _super.prototype.optimize.call(this, context);
                if (this.children.length === 0) {
                  if (this.statics.defaultChild != null) {
                    var child = Registry.create(this.statics.defaultChild);
                    this.appendChild(child);
                    child.optimize(context);
                  } else {
                    this.remove();
                  }
                }
              };
              ContainerBlot2.prototype.path = function(index, inclusive) {
                if (inclusive === void 0) {
                  inclusive = false;
                }
                var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
                var position = [[this, index]];
                if (child instanceof ContainerBlot2) {
                  return position.concat(child.path(offset, inclusive));
                } else if (child != null) {
                  position.push([child, offset]);
                }
                return position;
              };
              ContainerBlot2.prototype.removeChild = function(child) {
                this.children.remove(child);
              };
              ContainerBlot2.prototype.replace = function(target) {
                if (target instanceof ContainerBlot2) {
                  target.moveChildren(this);
                }
                _super.prototype.replace.call(this, target);
              };
              ContainerBlot2.prototype.split = function(index, force) {
                if (force === void 0) {
                  force = false;
                }
                if (!force) {
                  if (index === 0)
                    return this;
                  if (index === this.length())
                    return this.next;
                }
                var after = this.clone();
                this.parent.insertBefore(after, this.next);
                this.children.forEachAt(index, this.length(), function(child, offset, length) {
                  child = child.split(offset, force);
                  after.appendChild(child);
                });
                return after;
              };
              ContainerBlot2.prototype.unwrap = function() {
                this.moveChildren(this.parent, this.next);
                this.remove();
              };
              ContainerBlot2.prototype.update = function(mutations, context) {
                var _this = this;
                var addedNodes = [];
                var removedNodes = [];
                mutations.forEach(function(mutation) {
                  if (mutation.target === _this.domNode && mutation.type === "childList") {
                    addedNodes.push.apply(addedNodes, mutation.addedNodes);
                    removedNodes.push.apply(removedNodes, mutation.removedNodes);
                  }
                });
                removedNodes.forEach(function(node) {
                  if (node.parentNode != null && // @ts-ignore
                  node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                    return;
                  }
                  var blot = Registry.find(node);
                  if (blot == null)
                    return;
                  if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                    blot.detach();
                  }
                });
                addedNodes.filter(function(node) {
                  return node.parentNode == _this.domNode;
                }).sort(function(a, b) {
                  if (a === b)
                    return 0;
                  if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                    return 1;
                  }
                  return -1;
                }).forEach(function(node) {
                  var refBlot = null;
                  if (node.nextSibling != null) {
                    refBlot = Registry.find(node.nextSibling);
                  }
                  var blot = makeBlot(node);
                  if (blot.next != refBlot || blot.next == null) {
                    if (blot.parent != null) {
                      blot.parent.removeChild(_this);
                    }
                    _this.insertBefore(blot, refBlot || void 0);
                  }
                });
              };
              return ContainerBlot2;
            }(shadow_1.default)
          );
          function makeBlot(node) {
            var blot = Registry.find(node);
            if (blot == null) {
              try {
                blot = Registry.create(node);
              } catch (e) {
                blot = Registry.create(Registry.Scope.INLINE);
                [].slice.call(node.childNodes).forEach(function(child) {
                  blot.domNode.appendChild(child);
                });
                if (node.parentNode) {
                  node.parentNode.replaceChild(blot.domNode, node);
                }
                blot.attach();
              }
            }
            return blot;
          }
          exports2.default = ContainerBlot;
        },
        /* 18 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          var store_1 = __webpack_require__(31);
          var container_1 = __webpack_require__(17);
          var Registry = __webpack_require__(1);
          var FormatBlot = (
            /** @class */
            function(_super) {
              __extends2(FormatBlot2, _super);
              function FormatBlot2(domNode) {
                var _this = _super.call(this, domNode) || this;
                _this.attributes = new store_1.default(_this.domNode);
                return _this;
              }
              FormatBlot2.formats = function(domNode) {
                if (typeof this.tagName === "string") {
                  return true;
                } else if (Array.isArray(this.tagName)) {
                  return domNode.tagName.toLowerCase();
                }
                return void 0;
              };
              FormatBlot2.prototype.format = function(name, value) {
                var format = Registry.query(name);
                if (format instanceof attributor_1.default) {
                  this.attributes.attribute(format, value);
                } else if (value) {
                  if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                    this.replaceWith(name, value);
                  }
                }
              };
              FormatBlot2.prototype.formats = function() {
                var formats = this.attributes.values();
                var format = this.statics.formats(this.domNode);
                if (format != null) {
                  formats[this.statics.blotName] = format;
                }
                return formats;
              };
              FormatBlot2.prototype.replaceWith = function(name, value) {
                var replacement = _super.prototype.replaceWith.call(this, name, value);
                this.attributes.copy(replacement);
                return replacement;
              };
              FormatBlot2.prototype.update = function(mutations, context) {
                var _this = this;
                _super.prototype.update.call(this, mutations, context);
                if (mutations.some(function(mutation) {
                  return mutation.target === _this.domNode && mutation.type === "attributes";
                })) {
                  this.attributes.build();
                }
              };
              FormatBlot2.prototype.wrap = function(name, value) {
                var wrapper = _super.prototype.wrap.call(this, name, value);
                if (wrapper instanceof FormatBlot2 && wrapper.statics.scope === this.statics.scope) {
                  this.attributes.move(wrapper);
                }
                return wrapper;
              };
              return FormatBlot2;
            }(container_1.default)
          );
          exports2.default = FormatBlot;
        },
        /* 19 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var shadow_1 = __webpack_require__(30);
          var Registry = __webpack_require__(1);
          var LeafBlot = (
            /** @class */
            function(_super) {
              __extends2(LeafBlot2, _super);
              function LeafBlot2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              LeafBlot2.value = function(domNode) {
                return true;
              };
              LeafBlot2.prototype.index = function(node, offset) {
                if (this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                  return Math.min(offset, 1);
                }
                return -1;
              };
              LeafBlot2.prototype.position = function(index, inclusive) {
                var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
                if (index > 0)
                  offset += 1;
                return [this.parent.domNode, offset];
              };
              LeafBlot2.prototype.value = function() {
                var _a;
                return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
              };
              LeafBlot2.scope = Registry.Scope.INLINE_BLOT;
              return LeafBlot2;
            }(shadow_1.default)
          );
          exports2.default = LeafBlot;
        },
        /* 20 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var equal = __webpack_require__(11);
          var extend = __webpack_require__(3);
          var lib2 = {
            attributes: {
              compose: function(a, b, keepNull) {
                if (typeof a !== "object")
                  a = {};
                if (typeof b !== "object")
                  b = {};
                var attributes = extend(true, {}, b);
                if (!keepNull) {
                  attributes = Object.keys(attributes).reduce(function(copy, key2) {
                    if (attributes[key2] != null) {
                      copy[key2] = attributes[key2];
                    }
                    return copy;
                  }, {});
                }
                for (var key in a) {
                  if (a[key] !== void 0 && b[key] === void 0) {
                    attributes[key] = a[key];
                  }
                }
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              },
              diff: function(a, b) {
                if (typeof a !== "object")
                  a = {};
                if (typeof b !== "object")
                  b = {};
                var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function(attributes2, key) {
                  if (!equal(a[key], b[key])) {
                    attributes2[key] = b[key] === void 0 ? null : b[key];
                  }
                  return attributes2;
                }, {});
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              },
              transform: function(a, b, priority) {
                if (typeof a !== "object")
                  return b;
                if (typeof b !== "object")
                  return void 0;
                if (!priority)
                  return b;
                var attributes = Object.keys(b).reduce(function(attributes2, key) {
                  if (a[key] === void 0)
                    attributes2[key] = b[key];
                  return attributes2;
                }, {});
                return Object.keys(attributes).length > 0 ? attributes : void 0;
              }
            },
            iterator: function(ops) {
              return new Iterator(ops);
            },
            length: function(op) {
              if (typeof op["delete"] === "number") {
                return op["delete"];
              } else if (typeof op.retain === "number") {
                return op.retain;
              } else {
                return typeof op.insert === "string" ? op.insert.length : 1;
              }
            }
          };
          function Iterator(ops) {
            this.ops = ops;
            this.index = 0;
            this.offset = 0;
          }
          Iterator.prototype.hasNext = function() {
            return this.peekLength() < Infinity;
          };
          Iterator.prototype.next = function(length) {
            if (!length)
              length = Infinity;
            var nextOp = this.ops[this.index];
            if (nextOp) {
              var offset = this.offset;
              var opLength = lib2.length(nextOp);
              if (length >= opLength - offset) {
                length = opLength - offset;
                this.index += 1;
                this.offset = 0;
              } else {
                this.offset += length;
              }
              if (typeof nextOp["delete"] === "number") {
                return { "delete": length };
              } else {
                var retOp = {};
                if (nextOp.attributes) {
                  retOp.attributes = nextOp.attributes;
                }
                if (typeof nextOp.retain === "number") {
                  retOp.retain = length;
                } else if (typeof nextOp.insert === "string") {
                  retOp.insert = nextOp.insert.substr(offset, length);
                } else {
                  retOp.insert = nextOp.insert;
                }
                return retOp;
              }
            } else {
              return { retain: Infinity };
            }
          };
          Iterator.prototype.peek = function() {
            return this.ops[this.index];
          };
          Iterator.prototype.peekLength = function() {
            if (this.ops[this.index]) {
              return lib2.length(this.ops[this.index]) - this.offset;
            } else {
              return Infinity;
            }
          };
          Iterator.prototype.peekType = function() {
            if (this.ops[this.index]) {
              if (typeof this.ops[this.index]["delete"] === "number") {
                return "delete";
              } else if (typeof this.ops[this.index].retain === "number") {
                return "retain";
              } else {
                return "insert";
              }
            }
            return "retain";
          };
          Iterator.prototype.rest = function() {
            if (!this.hasNext()) {
              return [];
            } else if (this.offset === 0) {
              return this.ops.slice(this.index);
            } else {
              var offset = this.offset;
              var index = this.index;
              var next = this.next();
              var rest = this.ops.slice(this.index);
              this.offset = offset;
              this.index = index;
              return [next].concat(rest);
            }
          };
          module2.exports = lib2;
        },
        /* 21 */
        /***/
        function(module2, exports2) {
          var clone = function() {
            function _instanceof(obj, type) {
              return type != null && obj instanceof type;
            }
            var nativeMap;
            try {
              nativeMap = Map;
            } catch (_) {
              nativeMap = function() {
              };
            }
            var nativeSet;
            try {
              nativeSet = Set;
            } catch (_) {
              nativeSet = function() {
              };
            }
            var nativePromise;
            try {
              nativePromise = Promise;
            } catch (_) {
              nativePromise = function() {
              };
            }
            function clone2(parent, circular, depth, prototype, includeNonEnumerable) {
              if (typeof circular === "object") {
                depth = circular.depth;
                prototype = circular.prototype;
                includeNonEnumerable = circular.includeNonEnumerable;
                circular = circular.circular;
              }
              var allParents = [];
              var allChildren = [];
              var useBuffer = typeof Buffer != "undefined";
              if (typeof circular == "undefined")
                circular = true;
              if (typeof depth == "undefined")
                depth = Infinity;
              function _clone(parent2, depth2) {
                if (parent2 === null)
                  return null;
                if (depth2 === 0)
                  return parent2;
                var child;
                var proto;
                if (typeof parent2 != "object") {
                  return parent2;
                }
                if (_instanceof(parent2, nativeMap)) {
                  child = new nativeMap();
                } else if (_instanceof(parent2, nativeSet)) {
                  child = new nativeSet();
                } else if (_instanceof(parent2, nativePromise)) {
                  child = new nativePromise(function(resolve, reject) {
                    parent2.then(function(value) {
                      resolve(_clone(value, depth2 - 1));
                    }, function(err) {
                      reject(_clone(err, depth2 - 1));
                    });
                  });
                } else if (clone2.__isArray(parent2)) {
                  child = [];
                } else if (clone2.__isRegExp(parent2)) {
                  child = new RegExp(parent2.source, __getRegExpFlags(parent2));
                  if (parent2.lastIndex)
                    child.lastIndex = parent2.lastIndex;
                } else if (clone2.__isDate(parent2)) {
                  child = new Date(parent2.getTime());
                } else if (useBuffer && Buffer.isBuffer(parent2)) {
                  if (Buffer.allocUnsafe) {
                    child = Buffer.allocUnsafe(parent2.length);
                  } else {
                    child = new Buffer(parent2.length);
                  }
                  parent2.copy(child);
                  return child;
                } else if (_instanceof(parent2, Error)) {
                  child = Object.create(parent2);
                } else {
                  if (typeof prototype == "undefined") {
                    proto = Object.getPrototypeOf(parent2);
                    child = Object.create(proto);
                  } else {
                    child = Object.create(prototype);
                    proto = prototype;
                  }
                }
                if (circular) {
                  var index = allParents.indexOf(parent2);
                  if (index != -1) {
                    return allChildren[index];
                  }
                  allParents.push(parent2);
                  allChildren.push(child);
                }
                if (_instanceof(parent2, nativeMap)) {
                  parent2.forEach(function(value, key) {
                    var keyChild = _clone(key, depth2 - 1);
                    var valueChild = _clone(value, depth2 - 1);
                    child.set(keyChild, valueChild);
                  });
                }
                if (_instanceof(parent2, nativeSet)) {
                  parent2.forEach(function(value) {
                    var entryChild = _clone(value, depth2 - 1);
                    child.add(entryChild);
                  });
                }
                for (var i in parent2) {
                  var attrs;
                  if (proto) {
                    attrs = Object.getOwnPropertyDescriptor(proto, i);
                  }
                  if (attrs && attrs.set == null) {
                    continue;
                  }
                  child[i] = _clone(parent2[i], depth2 - 1);
                }
                if (Object.getOwnPropertySymbols) {
                  var symbols = Object.getOwnPropertySymbols(parent2);
                  for (var i = 0; i < symbols.length; i++) {
                    var symbol = symbols[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent2, symbol);
                    if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
                      continue;
                    }
                    child[symbol] = _clone(parent2[symbol], depth2 - 1);
                    if (!descriptor.enumerable) {
                      Object.defineProperty(child, symbol, {
                        enumerable: false
                      });
                    }
                  }
                }
                if (includeNonEnumerable) {
                  var allPropertyNames = Object.getOwnPropertyNames(parent2);
                  for (var i = 0; i < allPropertyNames.length; i++) {
                    var propertyName = allPropertyNames[i];
                    var descriptor = Object.getOwnPropertyDescriptor(parent2, propertyName);
                    if (descriptor && descriptor.enumerable) {
                      continue;
                    }
                    child[propertyName] = _clone(parent2[propertyName], depth2 - 1);
                    Object.defineProperty(child, propertyName, {
                      enumerable: false
                    });
                  }
                }
                return child;
              }
              return _clone(parent, depth);
            }
            clone2.clonePrototype = function clonePrototype(parent) {
              if (parent === null)
                return null;
              var c = function() {
              };
              c.prototype = parent;
              return new c();
            };
            function __objToStr(o) {
              return Object.prototype.toString.call(o);
            }
            clone2.__objToStr = __objToStr;
            function __isDate(o) {
              return typeof o === "object" && __objToStr(o) === "[object Date]";
            }
            clone2.__isDate = __isDate;
            function __isArray(o) {
              return typeof o === "object" && __objToStr(o) === "[object Array]";
            }
            clone2.__isArray = __isArray;
            function __isRegExp(o) {
              return typeof o === "object" && __objToStr(o) === "[object RegExp]";
            }
            clone2.__isRegExp = __isRegExp;
            function __getRegExpFlags(re2) {
              var flags = "";
              if (re2.global)
                flags += "g";
              if (re2.ignoreCase)
                flags += "i";
              if (re2.multiline)
                flags += "m";
              return flags;
            }
            clone2.__getRegExpFlags = __getRegExpFlags;
            return clone2;
          }();
          if (typeof module2 === "object" && module2.exports) {
            module2.exports = clone;
          }
        },
        /* 22 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          function isLine(blot) {
            return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
          }
          var Scroll = function(_Parchment$Scroll) {
            _inherits(Scroll2, _Parchment$Scroll);
            function Scroll2(domNode, config) {
              _classCallCheck(this, Scroll2);
              var _this = _possibleConstructorReturn(this, (Scroll2.__proto__ || Object.getPrototypeOf(Scroll2)).call(this, domNode));
              _this.emitter = config.emitter;
              if (Array.isArray(config.whitelist)) {
                _this.whitelist = config.whitelist.reduce(function(whitelist, format) {
                  whitelist[format] = true;
                  return whitelist;
                }, {});
              }
              _this.domNode.addEventListener("DOMNodeInserted", function() {
              });
              _this.optimize();
              _this.enable();
              return _this;
            }
            _createClass(Scroll2, [{
              key: "batchStart",
              value: function batchStart() {
                this.batch = true;
              }
            }, {
              key: "batchEnd",
              value: function batchEnd() {
                this.batch = false;
                this.optimize();
              }
            }, {
              key: "deleteAt",
              value: function deleteAt(index, length) {
                var _line = this.line(index), _line2 = _slicedToArray(_line, 2), first = _line2[0], offset = _line2[1];
                var _line3 = this.line(index + length), _line4 = _slicedToArray(_line3, 1), last = _line4[0];
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "deleteAt", this).call(this, index, length);
                if (last != null && first !== last && offset > 0) {
                  if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
                    this.optimize();
                    return;
                  }
                  if (first instanceof _code2.default) {
                    var newlineIndex = first.newlineIndex(first.length(), true);
                    if (newlineIndex > -1) {
                      first = first.split(newlineIndex + 1);
                      if (first === last) {
                        this.optimize();
                        return;
                      }
                    }
                  } else if (last instanceof _code2.default) {
                    var _newlineIndex = last.newlineIndex(0);
                    if (_newlineIndex > -1) {
                      last.split(_newlineIndex + 1);
                    }
                  }
                  var ref = last.children.head instanceof _break2.default ? null : last.children.head;
                  first.moveChildren(last, ref);
                  first.remove();
                }
                this.optimize();
              }
            }, {
              key: "enable",
              value: function enable() {
                var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                this.domNode.setAttribute("contenteditable", enabled);
              }
            }, {
              key: "formatAt",
              value: function formatAt(index, length, format, value) {
                if (this.whitelist != null && !this.whitelist[format])
                  return;
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "formatAt", this).call(this, index, length, format, value);
                this.optimize();
              }
            }, {
              key: "insertAt",
              value: function insertAt(index, value, def) {
                if (def != null && this.whitelist != null && !this.whitelist[value])
                  return;
                if (index >= this.length()) {
                  if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
                    var blot = _parchment2.default.create(this.statics.defaultChild);
                    this.appendChild(blot);
                    if (def == null && value.endsWith("\n")) {
                      value = value.slice(0, -1);
                    }
                    blot.insertAt(0, value, def);
                  } else {
                    var embed = _parchment2.default.create(value, def);
                    this.appendChild(embed);
                  }
                } else {
                  _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertAt", this).call(this, index, value, def);
                }
                this.optimize();
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
                  var wrapper = _parchment2.default.create(this.statics.defaultChild);
                  wrapper.appendChild(blot);
                  blot = wrapper;
                }
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "insertBefore", this).call(this, blot, ref);
              }
            }, {
              key: "leaf",
              value: function leaf(index) {
                return this.path(index).pop() || [null, -1];
              }
            }, {
              key: "line",
              value: function line2(index) {
                if (index === this.length()) {
                  return this.line(index - 1);
                }
                return this.descendant(isLine, index);
              }
            }, {
              key: "lines",
              value: function lines() {
                var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                var length = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MAX_VALUE;
                var getLines = function getLines2(blot, index2, length2) {
                  var lines2 = [], lengthLeft = length2;
                  blot.children.forEachAt(index2, length2, function(child, index3, length3) {
                    if (isLine(child)) {
                      lines2.push(child);
                    } else if (child instanceof _parchment2.default.Container) {
                      lines2 = lines2.concat(getLines2(child, index3, lengthLeft));
                    }
                    lengthLeft -= length3;
                  });
                  return lines2;
                };
                return getLines(this, index, length);
              }
            }, {
              key: "optimize",
              value: function optimize() {
                var mutations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                if (this.batch === true)
                  return;
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "optimize", this).call(this, mutations, context);
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
                }
              }
            }, {
              key: "path",
              value: function path(index) {
                return _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "path", this).call(this, index).slice(1);
              }
            }, {
              key: "update",
              value: function update(mutations) {
                if (this.batch === true)
                  return;
                var source = _emitter2.default.sources.USER;
                if (typeof mutations === "string") {
                  source = mutations;
                }
                if (!Array.isArray(mutations)) {
                  mutations = this.observer.takeRecords();
                }
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
                }
                _get(Scroll2.prototype.__proto__ || Object.getPrototypeOf(Scroll2.prototype), "update", this).call(this, mutations.concat([]));
                if (mutations.length > 0) {
                  this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
                }
              }
            }]);
            return Scroll2;
          }(_parchment2.default.Scroll);
          Scroll.blotName = "scroll";
          Scroll.className = "ql-editor";
          Scroll.tagName = "DIV";
          Scroll.defaultChild = "block";
          Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];
          exports2.default = Scroll;
        },
        /* 23 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SHORTKEY = exports2.default = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _clone = __webpack_require__(21);
          var _clone2 = _interopRequireDefault(_clone);
          var _deepEqual = __webpack_require__(11);
          var _deepEqual2 = _interopRequireDefault(_deepEqual);
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _op = __webpack_require__(20);
          var _op2 = _interopRequireDefault(_op);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:keyboard");
          var SHORTKEY = /Mac/i.test(navigator.platform) ? "metaKey" : "ctrlKey";
          var Keyboard = function(_Module) {
            _inherits(Keyboard2, _Module);
            _createClass(Keyboard2, null, [{
              key: "match",
              value: function match(evt, binding) {
                binding = normalize(binding);
                if (["altKey", "ctrlKey", "metaKey", "shiftKey"].some(function(key) {
                  return !!binding[key] !== evt[key] && binding[key] !== null;
                })) {
                  return false;
                }
                return binding.key === (evt.which || evt.keyCode);
              }
            }]);
            function Keyboard2(quill2, options) {
              _classCallCheck(this, Keyboard2);
              var _this = _possibleConstructorReturn(this, (Keyboard2.__proto__ || Object.getPrototypeOf(Keyboard2)).call(this, quill2, options));
              _this.bindings = {};
              Object.keys(_this.options.bindings).forEach(function(name) {
                if (name === "list autofill" && quill2.scroll.whitelist != null && !quill2.scroll.whitelist["list"]) {
                  return;
                }
                if (_this.options.bindings[name]) {
                  _this.addBinding(_this.options.bindings[name]);
                }
              });
              _this.addBinding({ key: Keyboard2.keys.ENTER, shiftKey: null }, handleEnter);
              _this.addBinding({ key: Keyboard2.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function() {
              });
              if (/Firefox/i.test(navigator.userAgent)) {
                _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
                _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: true }, handleDelete);
              } else {
                _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
                _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
              }
              _this.addBinding({ key: Keyboard2.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
              _this.addBinding({ key: Keyboard2.keys.DELETE }, { collapsed: false }, handleDeleteRange);
              _this.addBinding({ key: Keyboard2.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
              _this.listen();
              return _this;
            }
            _createClass(Keyboard2, [{
              key: "addBinding",
              value: function addBinding(key) {
                var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var handler = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var binding = normalize(key);
                if (binding == null || binding.key == null) {
                  return debug.warn("Attempted to add invalid keyboard binding", binding);
                }
                if (typeof context === "function") {
                  context = { handler: context };
                }
                if (typeof handler === "function") {
                  handler = { handler };
                }
                binding = (0, _extend2.default)(binding, context, handler);
                this.bindings[binding.key] = this.bindings[binding.key] || [];
                this.bindings[binding.key].push(binding);
              }
            }, {
              key: "listen",
              value: function listen() {
                var _this2 = this;
                this.quill.root.addEventListener("keydown", function(evt) {
                  if (evt.defaultPrevented)
                    return;
                  var which = evt.which || evt.keyCode;
                  var bindings = (_this2.bindings[which] || []).filter(function(binding) {
                    return Keyboard2.match(evt, binding);
                  });
                  if (bindings.length === 0)
                    return;
                  var range = _this2.quill.getSelection();
                  if (range == null || !_this2.quill.hasFocus())
                    return;
                  var _quill$getLine = _this2.quill.getLine(range.index), _quill$getLine2 = _slicedToArray(_quill$getLine, 2), line2 = _quill$getLine2[0], offset = _quill$getLine2[1];
                  var _quill$getLeaf = _this2.quill.getLeaf(range.index), _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2), leafStart = _quill$getLeaf2[0], offsetStart = _quill$getLeaf2[1];
                  var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length), _ref2 = _slicedToArray(_ref, 2), leafEnd = _ref2[0], offsetEnd = _ref2[1];
                  var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : "";
                  var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : "";
                  var curContext = {
                    collapsed: range.length === 0,
                    empty: range.length === 0 && line2.length() <= 1,
                    format: _this2.quill.getFormat(range),
                    offset,
                    prefix: prefixText,
                    suffix: suffixText
                  };
                  var prevented = bindings.some(function(binding) {
                    if (binding.collapsed != null && binding.collapsed !== curContext.collapsed)
                      return false;
                    if (binding.empty != null && binding.empty !== curContext.empty)
                      return false;
                    if (binding.offset != null && binding.offset !== curContext.offset)
                      return false;
                    if (Array.isArray(binding.format)) {
                      if (binding.format.every(function(name) {
                        return curContext.format[name] == null;
                      })) {
                        return false;
                      }
                    } else if (_typeof(binding.format) === "object") {
                      if (!Object.keys(binding.format).every(function(name) {
                        if (binding.format[name] === true)
                          return curContext.format[name] != null;
                        if (binding.format[name] === false)
                          return curContext.format[name] == null;
                        return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
                      })) {
                        return false;
                      }
                    }
                    if (binding.prefix != null && !binding.prefix.test(curContext.prefix))
                      return false;
                    if (binding.suffix != null && !binding.suffix.test(curContext.suffix))
                      return false;
                    return binding.handler.call(_this2, range, curContext) !== true;
                  });
                  if (prevented) {
                    evt.preventDefault();
                  }
                });
              }
            }]);
            return Keyboard2;
          }(_module2.default);
          Keyboard.keys = {
            BACKSPACE: 8,
            TAB: 9,
            ENTER: 13,
            ESCAPE: 27,
            LEFT: 37,
            UP: 38,
            RIGHT: 39,
            DOWN: 40,
            DELETE: 46
          };
          Keyboard.DEFAULTS = {
            bindings: {
              "bold": makeFormatHandler("bold"),
              "italic": makeFormatHandler("italic"),
              "underline": makeFormatHandler("underline"),
              "indent": {
                // highlight tab or tab at beginning of list, indent or blockquote
                key: Keyboard.keys.TAB,
                format: ["blockquote", "indent", "list"],
                handler: function handler(range, context) {
                  if (context.collapsed && context.offset !== 0)
                    return true;
                  this.quill.format("indent", "+1", _quill2.default.sources.USER);
                }
              },
              "outdent": {
                key: Keyboard.keys.TAB,
                shiftKey: true,
                format: ["blockquote", "indent", "list"],
                // highlight tab or tab at beginning of list, indent or blockquote
                handler: function handler(range, context) {
                  if (context.collapsed && context.offset !== 0)
                    return true;
                  this.quill.format("indent", "-1", _quill2.default.sources.USER);
                }
              },
              "outdent backspace": {
                key: Keyboard.keys.BACKSPACE,
                collapsed: true,
                shiftKey: null,
                metaKey: null,
                ctrlKey: null,
                altKey: null,
                format: ["indent", "list"],
                offset: 0,
                handler: function handler(range, context) {
                  if (context.format.indent != null) {
                    this.quill.format("indent", "-1", _quill2.default.sources.USER);
                  } else if (context.format.list != null) {
                    this.quill.format("list", false, _quill2.default.sources.USER);
                  }
                }
              },
              "indent code-block": makeCodeBlockHandler(true),
              "outdent code-block": makeCodeBlockHandler(false),
              "remove tab": {
                key: Keyboard.keys.TAB,
                shiftKey: true,
                collapsed: true,
                prefix: /\t$/,
                handler: function handler(range) {
                  this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
                }
              },
              "tab": {
                key: Keyboard.keys.TAB,
                handler: function handler(range) {
                  this.quill.history.cutoff();
                  var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert("	");
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                }
              },
              "list empty enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["list"],
                empty: true,
                handler: function handler(range, context) {
                  this.quill.format("list", false, _quill2.default.sources.USER);
                  if (context.format.indent) {
                    this.quill.format("indent", false, _quill2.default.sources.USER);
                  }
                }
              },
              "checklist enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: { list: "checked" },
                handler: function handler(range) {
                  var _quill$getLine3 = this.quill.getLine(range.index), _quill$getLine4 = _slicedToArray(_quill$getLine3, 2), line2 = _quill$getLine4[0], offset = _quill$getLine4[1];
                  var formats = (0, _extend2.default)({}, line2.formats(), { list: "checked" });
                  var delta = new _quillDelta2.default().retain(range.index).insert("\n", formats).retain(line2.length() - offset - 1).retain(1, { list: "unchecked" });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                  this.quill.scrollIntoView();
                }
              },
              "header enter": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["header"],
                suffix: /^$/,
                handler: function handler(range, context) {
                  var _quill$getLine5 = this.quill.getLine(range.index), _quill$getLine6 = _slicedToArray(_quill$getLine5, 2), line2 = _quill$getLine6[0], offset = _quill$getLine6[1];
                  var delta = new _quillDelta2.default().retain(range.index).insert("\n", context.format).retain(line2.length() - offset - 1).retain(1, { header: null });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
                  this.quill.scrollIntoView();
                }
              },
              "list autofill": {
                key: " ",
                collapsed: true,
                format: { list: false },
                prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
                handler: function handler(range, context) {
                  var length = context.prefix.length;
                  var _quill$getLine7 = this.quill.getLine(range.index), _quill$getLine8 = _slicedToArray(_quill$getLine7, 2), line2 = _quill$getLine8[0], offset = _quill$getLine8[1];
                  if (offset > length)
                    return true;
                  var value = void 0;
                  switch (context.prefix.trim()) {
                    case "[]":
                    case "[ ]":
                      value = "unchecked";
                      break;
                    case "[x]":
                      value = "checked";
                      break;
                    case "-":
                    case "*":
                      value = "bullet";
                      break;
                    default:
                      value = "ordered";
                  }
                  this.quill.insertText(range.index, " ", _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line2.length() - 2 - offset).retain(1, { list: value });
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                  this.quill.history.cutoff();
                  this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
                }
              },
              "code exit": {
                key: Keyboard.keys.ENTER,
                collapsed: true,
                format: ["code-block"],
                prefix: /\n\n$/,
                suffix: /^\s+$/,
                handler: function handler(range) {
                  var _quill$getLine9 = this.quill.getLine(range.index), _quill$getLine10 = _slicedToArray(_quill$getLine9, 2), line2 = _quill$getLine10[0], offset = _quill$getLine10[1];
                  var delta = new _quillDelta2.default().retain(range.index + line2.length() - offset - 2).retain(1, { "code-block": null }).delete(1);
                  this.quill.updateContents(delta, _quill2.default.sources.USER);
                }
              },
              "embed left": makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
              "embed left shift": makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
              "embed right": makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
              "embed right shift": makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
            }
          };
          function makeEmbedArrowHandler(key, shiftKey) {
            var _ref3;
            var where = key === Keyboard.keys.LEFT ? "prefix" : "suffix";
            return _ref3 = {
              key,
              shiftKey,
              altKey: null
            }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, "handler", function handler(range) {
              var index = range.index;
              if (key === Keyboard.keys.RIGHT) {
                index += range.length + 1;
              }
              var _quill$getLeaf3 = this.quill.getLeaf(index), _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1), leaf = _quill$getLeaf4[0];
              if (!(leaf instanceof _parchment2.default.Embed))
                return true;
              if (key === Keyboard.keys.LEFT) {
                if (shiftKey) {
                  this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
                } else {
                  this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
                }
              } else {
                if (shiftKey) {
                  this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
                } else {
                  this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
                }
              }
              return false;
            }), _ref3;
          }
          function handleBackspace(range, context) {
            if (range.index === 0 || this.quill.getLength() <= 1)
              return;
            var _quill$getLine11 = this.quill.getLine(range.index), _quill$getLine12 = _slicedToArray(_quill$getLine11, 1), line2 = _quill$getLine12[0];
            var formats = {};
            if (context.offset === 0) {
              var _quill$getLine13 = this.quill.getLine(range.index - 1), _quill$getLine14 = _slicedToArray(_quill$getLine13, 1), prev = _quill$getLine14[0];
              if (prev != null && prev.length() > 1) {
                var curFormats = line2.formats();
                var prevFormats = this.quill.getFormat(range.index - 1, 1);
                formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
              }
            }
            var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
            this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
            }
            this.quill.focus();
          }
          function handleDelete(range, context) {
            var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
            if (range.index >= this.quill.getLength() - length)
              return;
            var formats = {}, nextLength = 0;
            var _quill$getLine15 = this.quill.getLine(range.index), _quill$getLine16 = _slicedToArray(_quill$getLine15, 1), line2 = _quill$getLine16[0];
            if (context.offset >= line2.length() - 1) {
              var _quill$getLine17 = this.quill.getLine(range.index + 1), _quill$getLine18 = _slicedToArray(_quill$getLine17, 1), next = _quill$getLine18[0];
              if (next) {
                var curFormats = line2.formats();
                var nextFormats = this.quill.getFormat(range.index, 1);
                formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
                nextLength = next.length();
              }
            }
            this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
            }
          }
          function handleDeleteRange(range) {
            var lines = this.quill.getLines(range);
            var formats = {};
            if (lines.length > 1) {
              var firstFormats = lines[0].formats();
              var lastFormats = lines[lines.length - 1].formats();
              formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
            }
            this.quill.deleteText(range, _quill2.default.sources.USER);
            if (Object.keys(formats).length > 0) {
              this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
            }
            this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
            this.quill.focus();
          }
          function handleEnter(range, context) {
            var _this3 = this;
            if (range.length > 0) {
              this.quill.scroll.deleteAt(range.index, range.length);
            }
            var lineFormats = Object.keys(context.format).reduce(function(lineFormats2, format) {
              if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
                lineFormats2[format] = context.format[format];
              }
              return lineFormats2;
            }, {});
            this.quill.insertText(range.index, "\n", lineFormats, _quill2.default.sources.USER);
            this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
            this.quill.focus();
            Object.keys(context.format).forEach(function(name) {
              if (lineFormats[name] != null)
                return;
              if (Array.isArray(context.format[name]))
                return;
              if (name === "link")
                return;
              _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
            });
          }
          function makeCodeBlockHandler(indent) {
            return {
              key: Keyboard.keys.TAB,
              shiftKey: !indent,
              format: { "code-block": true },
              handler: function handler(range) {
                var CodeBlock = _parchment2.default.query("code-block");
                var index = range.index, length = range.length;
                var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), block = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                if (block == null)
                  return;
                var scrollIndex = this.quill.getIndex(block);
                var start = block.newlineIndex(offset, true) + 1;
                var end = block.newlineIndex(scrollIndex + offset + length);
                var lines = block.domNode.textContent.slice(start, end).split("\n");
                offset = 0;
                lines.forEach(function(line2, i) {
                  if (indent) {
                    block.insertAt(start + offset, CodeBlock.TAB);
                    offset += CodeBlock.TAB.length;
                    if (i === 0) {
                      index += CodeBlock.TAB.length;
                    } else {
                      length += CodeBlock.TAB.length;
                    }
                  } else if (line2.startsWith(CodeBlock.TAB)) {
                    block.deleteAt(start + offset, CodeBlock.TAB.length);
                    offset -= CodeBlock.TAB.length;
                    if (i === 0) {
                      index -= CodeBlock.TAB.length;
                    } else {
                      length -= CodeBlock.TAB.length;
                    }
                  }
                  offset += line2.length + 1;
                });
                this.quill.update(_quill2.default.sources.USER);
                this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
              }
            };
          }
          function makeFormatHandler(format) {
            return {
              key: format[0].toUpperCase(),
              shortKey: true,
              handler: function handler(range, context) {
                this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
              }
            };
          }
          function normalize(binding) {
            if (typeof binding === "string" || typeof binding === "number") {
              return normalize({ key: binding });
            }
            if ((typeof binding === "undefined" ? "undefined" : _typeof(binding)) === "object") {
              binding = (0, _clone2.default)(binding, false);
            }
            if (typeof binding.key === "string") {
              if (Keyboard.keys[binding.key.toUpperCase()] != null) {
                binding.key = Keyboard.keys[binding.key.toUpperCase()];
              } else if (binding.key.length === 1) {
                binding.key = binding.key.toUpperCase().charCodeAt(0);
              } else {
                return null;
              }
            }
            if (binding.shortKey) {
              binding[SHORTKEY] = binding.shortKey;
              delete binding.shortKey;
            }
            return binding;
          }
          exports2.default = Keyboard;
          exports2.SHORTKEY = SHORTKEY;
        },
        /* 24 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Cursor = function(_Parchment$Embed) {
            _inherits(Cursor2, _Parchment$Embed);
            _createClass(Cursor2, null, [{
              key: "value",
              value: function value() {
                return void 0;
              }
            }]);
            function Cursor2(domNode, selection) {
              _classCallCheck(this, Cursor2);
              var _this = _possibleConstructorReturn(this, (Cursor2.__proto__ || Object.getPrototypeOf(Cursor2)).call(this, domNode));
              _this.selection = selection;
              _this.textNode = document.createTextNode(Cursor2.CONTENTS);
              _this.domNode.appendChild(_this.textNode);
              _this._length = 0;
              return _this;
            }
            _createClass(Cursor2, [{
              key: "detach",
              value: function detach() {
                if (this.parent != null)
                  this.parent.removeChild(this);
              }
            }, {
              key: "format",
              value: function format(name, value) {
                if (this._length !== 0) {
                  return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "format", this).call(this, name, value);
                }
                var target = this, index = 0;
                while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
                  index += target.offset(target.parent);
                  target = target.parent;
                }
                if (target != null) {
                  this._length = Cursor2.CONTENTS.length;
                  target.optimize();
                  target.formatAt(index, Cursor2.CONTENTS.length, name, value);
                  this._length = 0;
                }
              }
            }, {
              key: "index",
              value: function index(node, offset) {
                if (node === this.textNode)
                  return 0;
                return _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "index", this).call(this, node, offset);
              }
            }, {
              key: "length",
              value: function length() {
                return this._length;
              }
            }, {
              key: "position",
              value: function position() {
                return [this.textNode, this.textNode.data.length];
              }
            }, {
              key: "remove",
              value: function remove() {
                _get(Cursor2.prototype.__proto__ || Object.getPrototypeOf(Cursor2.prototype), "remove", this).call(this);
                this.parent = null;
              }
            }, {
              key: "restore",
              value: function restore() {
                if (this.selection.composing || this.parent == null)
                  return;
                var textNode = this.textNode;
                var range = this.selection.getNativeRange();
                var restoreText = void 0, start = void 0, end = void 0;
                if (range != null && range.start.node === textNode && range.end.node === textNode) {
                  var _ref = [textNode, range.start.offset, range.end.offset];
                  restoreText = _ref[0];
                  start = _ref[1];
                  end = _ref[2];
                }
                while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
                  this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
                }
                if (this.textNode.data !== Cursor2.CONTENTS) {
                  var text = this.textNode.data.split(Cursor2.CONTENTS).join("");
                  if (this.next instanceof _text2.default) {
                    restoreText = this.next.domNode;
                    this.next.insertAt(0, text);
                    this.textNode.data = Cursor2.CONTENTS;
                  } else {
                    this.textNode.data = text;
                    this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
                    this.textNode = document.createTextNode(Cursor2.CONTENTS);
                    this.domNode.appendChild(this.textNode);
                  }
                }
                this.remove();
                if (start != null) {
                  var _map = [start, end].map(function(offset) {
                    return Math.max(0, Math.min(restoreText.data.length, offset - 1));
                  });
                  var _map2 = _slicedToArray(_map, 2);
                  start = _map2[0];
                  end = _map2[1];
                  return {
                    startNode: restoreText,
                    startOffset: start,
                    endNode: restoreText,
                    endOffset: end
                  };
                }
              }
            }, {
              key: "update",
              value: function update(mutations, context) {
                var _this2 = this;
                if (mutations.some(function(mutation) {
                  return mutation.type === "characterData" && mutation.target === _this2.textNode;
                })) {
                  var range = this.restore();
                  if (range)
                    context.range = range;
                }
              }
            }, {
              key: "value",
              value: function value() {
                return "";
              }
            }]);
            return Cursor2;
          }(_parchment2.default.Embed);
          Cursor.blotName = "cursor";
          Cursor.className = "ql-cursor";
          Cursor.tagName = "span";
          Cursor.CONTENTS = "\uFEFF";
          exports2.default = Cursor;
        },
        /* 25 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Container2 = function(_Parchment$Container) {
            _inherits(Container22, _Parchment$Container);
            function Container22() {
              _classCallCheck(this, Container22);
              return _possibleConstructorReturn(this, (Container22.__proto__ || Object.getPrototypeOf(Container22)).apply(this, arguments));
            }
            return Container22;
          }(_parchment2.default.Container);
          Container2.allowedChildren = [_block2.default, _block.BlockEmbed, Container2];
          exports2.default = Container2;
        },
        /* 26 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.ColorStyle = exports2.ColorClass = exports2.ColorAttributor = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ColorAttributor = function(_Parchment$Attributor) {
            _inherits(ColorAttributor2, _Parchment$Attributor);
            function ColorAttributor2() {
              _classCallCheck(this, ColorAttributor2);
              return _possibleConstructorReturn(this, (ColorAttributor2.__proto__ || Object.getPrototypeOf(ColorAttributor2)).apply(this, arguments));
            }
            _createClass(ColorAttributor2, [{
              key: "value",
              value: function value(domNode) {
                var value2 = _get(ColorAttributor2.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor2.prototype), "value", this).call(this, domNode);
                if (!value2.startsWith("rgb("))
                  return value2;
                value2 = value2.replace(/^[^\d]+/, "").replace(/[^\d]+$/, "");
                return "#" + value2.split(",").map(function(component) {
                  return ("00" + parseInt(component).toString(16)).slice(-2);
                }).join("");
              }
            }]);
            return ColorAttributor2;
          }(_parchment2.default.Attributor.Style);
          var ColorClass = new _parchment2.default.Attributor.Class("color", "ql-color", {
            scope: _parchment2.default.Scope.INLINE
          });
          var ColorStyle = new ColorAttributor("color", "color", {
            scope: _parchment2.default.Scope.INLINE
          });
          exports2.ColorAttributor = ColorAttributor;
          exports2.ColorClass = ColorClass;
          exports2.ColorStyle = ColorStyle;
        },
        /* 27 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.sanitize = exports2.default = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Link2 = function(_Inline) {
            _inherits(Link22, _Inline);
            function Link22() {
              _classCallCheck(this, Link22);
              return _possibleConstructorReturn(this, (Link22.__proto__ || Object.getPrototypeOf(Link22)).apply(this, arguments));
            }
            _createClass(Link22, [{
              key: "format",
              value: function format(name, value) {
                if (name !== this.statics.blotName || !value)
                  return _get(Link22.prototype.__proto__ || Object.getPrototypeOf(Link22.prototype), "format", this).call(this, name, value);
                value = this.constructor.sanitize(value);
                this.domNode.setAttribute("href", value);
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Link22.__proto__ || Object.getPrototypeOf(Link22), "create", this).call(this, value);
                value = this.sanitize(value);
                node.setAttribute("href", value);
                node.setAttribute("rel", "noopener noreferrer");
                node.setAttribute("target", "_blank");
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return domNode.getAttribute("href");
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
              }
            }]);
            return Link22;
          }(_inline2.default);
          Link2.blotName = "link";
          Link2.tagName = "A";
          Link2.SANITIZED_URL = "about:blank";
          Link2.PROTOCOL_WHITELIST = ["http", "https", "mailto", "tel"];
          function _sanitize(url, protocols) {
            var anchor = document.createElement("a");
            anchor.href = url;
            var protocol = anchor.href.slice(0, anchor.href.indexOf(":"));
            return protocols.indexOf(protocol) > -1;
          }
          exports2.default = Link2;
          exports2.sanitize = _sanitize;
        },
        /* 28 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          var _dropdown = __webpack_require__(107);
          var _dropdown2 = _interopRequireDefault(_dropdown);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var optionsCounter = 0;
          function toggleAriaAttribute(element, attribute2) {
            element.setAttribute(attribute2, !(element.getAttribute(attribute2) === "true"));
          }
          var Picker = function() {
            function Picker2(select) {
              var _this = this;
              _classCallCheck(this, Picker2);
              this.select = select;
              this.container = document.createElement("span");
              this.buildPicker();
              this.select.style.display = "none";
              this.select.parentNode.insertBefore(this.container, this.select);
              this.label.addEventListener("mousedown", function() {
                _this.togglePicker();
              });
              this.label.addEventListener("keydown", function(event) {
                switch (event.keyCode) {
                  case _keyboard2.default.keys.ENTER:
                    _this.togglePicker();
                    break;
                  case _keyboard2.default.keys.ESCAPE:
                    _this.escape();
                    event.preventDefault();
                    break;
                }
              });
              this.select.addEventListener("change", this.update.bind(this));
            }
            _createClass(Picker2, [{
              key: "togglePicker",
              value: function togglePicker() {
                this.container.classList.toggle("ql-expanded");
                toggleAriaAttribute(this.label, "aria-expanded");
                toggleAriaAttribute(this.options, "aria-hidden");
              }
            }, {
              key: "buildItem",
              value: function buildItem(option) {
                var _this2 = this;
                var item = document.createElement("span");
                item.tabIndex = "0";
                item.setAttribute("role", "button");
                item.classList.add("ql-picker-item");
                if (option.hasAttribute("value")) {
                  item.setAttribute("data-value", option.getAttribute("value"));
                }
                if (option.textContent) {
                  item.setAttribute("data-label", option.textContent);
                }
                item.addEventListener("click", function() {
                  _this2.selectItem(item, true);
                });
                item.addEventListener("keydown", function(event) {
                  switch (event.keyCode) {
                    case _keyboard2.default.keys.ENTER:
                      _this2.selectItem(item, true);
                      event.preventDefault();
                      break;
                    case _keyboard2.default.keys.ESCAPE:
                      _this2.escape();
                      event.preventDefault();
                      break;
                  }
                });
                return item;
              }
            }, {
              key: "buildLabel",
              value: function buildLabel() {
                var label = document.createElement("span");
                label.classList.add("ql-picker-label");
                label.innerHTML = _dropdown2.default;
                label.tabIndex = "0";
                label.setAttribute("role", "button");
                label.setAttribute("aria-expanded", "false");
                this.container.appendChild(label);
                return label;
              }
            }, {
              key: "buildOptions",
              value: function buildOptions() {
                var _this3 = this;
                var options = document.createElement("span");
                options.classList.add("ql-picker-options");
                options.setAttribute("aria-hidden", "true");
                options.tabIndex = "-1";
                options.id = "ql-picker-options-" + optionsCounter;
                optionsCounter += 1;
                this.label.setAttribute("aria-controls", options.id);
                this.options = options;
                [].slice.call(this.select.options).forEach(function(option) {
                  var item = _this3.buildItem(option);
                  options.appendChild(item);
                  if (option.selected === true) {
                    _this3.selectItem(item);
                  }
                });
                this.container.appendChild(options);
              }
            }, {
              key: "buildPicker",
              value: function buildPicker() {
                var _this4 = this;
                [].slice.call(this.select.attributes).forEach(function(item) {
                  _this4.container.setAttribute(item.name, item.value);
                });
                this.container.classList.add("ql-picker");
                this.label = this.buildLabel();
                this.buildOptions();
              }
            }, {
              key: "escape",
              value: function escape() {
                var _this5 = this;
                this.close();
                setTimeout(function() {
                  return _this5.label.focus();
                }, 1);
              }
            }, {
              key: "close",
              value: function close() {
                this.container.classList.remove("ql-expanded");
                this.label.setAttribute("aria-expanded", "false");
                this.options.setAttribute("aria-hidden", "true");
              }
            }, {
              key: "selectItem",
              value: function selectItem(item) {
                var trigger = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var selected = this.container.querySelector(".ql-selected");
                if (item === selected)
                  return;
                if (selected != null) {
                  selected.classList.remove("ql-selected");
                }
                if (item == null)
                  return;
                item.classList.add("ql-selected");
                this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
                if (item.hasAttribute("data-value")) {
                  this.label.setAttribute("data-value", item.getAttribute("data-value"));
                } else {
                  this.label.removeAttribute("data-value");
                }
                if (item.hasAttribute("data-label")) {
                  this.label.setAttribute("data-label", item.getAttribute("data-label"));
                } else {
                  this.label.removeAttribute("data-label");
                }
                if (trigger) {
                  if (typeof Event === "function") {
                    this.select.dispatchEvent(new Event("change"));
                  } else if ((typeof Event === "undefined" ? "undefined" : _typeof(Event)) === "object") {
                    var event = document.createEvent("Event");
                    event.initEvent("change", true, true);
                    this.select.dispatchEvent(event);
                  }
                  this.close();
                }
              }
            }, {
              key: "update",
              value: function update() {
                var option = void 0;
                if (this.select.selectedIndex > -1) {
                  var item = this.container.querySelector(".ql-picker-options").children[this.select.selectedIndex];
                  option = this.select.options[this.select.selectedIndex];
                  this.selectItem(item);
                } else {
                  this.selectItem(null);
                }
                var isActive = option != null && option !== this.select.querySelector("option[selected]");
                this.label.classList.toggle("ql-active", isActive);
              }
            }]);
            return Picker2;
          }();
          exports2.default = Picker;
        },
        /* 29 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _break = __webpack_require__(16);
          var _break2 = _interopRequireDefault(_break);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          var _cursor = __webpack_require__(24);
          var _cursor2 = _interopRequireDefault(_cursor);
          var _embed = __webpack_require__(35);
          var _embed2 = _interopRequireDefault(_embed);
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          var _scroll = __webpack_require__(22);
          var _scroll2 = _interopRequireDefault(_scroll);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          var _clipboard = __webpack_require__(55);
          var _clipboard2 = _interopRequireDefault(_clipboard);
          var _history = __webpack_require__(42);
          var _history2 = _interopRequireDefault(_history);
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          _quill2.default.register({
            "blots/block": _block2.default,
            "blots/block/embed": _block.BlockEmbed,
            "blots/break": _break2.default,
            "blots/container": _container2.default,
            "blots/cursor": _cursor2.default,
            "blots/embed": _embed2.default,
            "blots/inline": _inline2.default,
            "blots/scroll": _scroll2.default,
            "blots/text": _text2.default,
            "modules/clipboard": _clipboard2.default,
            "modules/history": _history2.default,
            "modules/keyboard": _keyboard2.default
          });
          _parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);
          exports2.default = _quill2.default;
        },
        /* 30 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", { value: true });
          var Registry = __webpack_require__(1);
          var ShadowBlot = (
            /** @class */
            function() {
              function ShadowBlot2(domNode) {
                this.domNode = domNode;
                this.domNode[Registry.DATA_KEY] = { blot: this };
              }
              Object.defineProperty(ShadowBlot2.prototype, "statics", {
                // Hack for accessing inherited static methods
                get: function() {
                  return this.constructor;
                },
                enumerable: true,
                configurable: true
              });
              ShadowBlot2.create = function(value) {
                if (this.tagName == null) {
                  throw new Registry.ParchmentError("Blot definition missing tagName");
                }
                var node;
                if (Array.isArray(this.tagName)) {
                  if (typeof value === "string") {
                    value = value.toUpperCase();
                    if (parseInt(value).toString() === value) {
                      value = parseInt(value);
                    }
                  }
                  if (typeof value === "number") {
                    node = document.createElement(this.tagName[value - 1]);
                  } else if (this.tagName.indexOf(value) > -1) {
                    node = document.createElement(value);
                  } else {
                    node = document.createElement(this.tagName[0]);
                  }
                } else {
                  node = document.createElement(this.tagName);
                }
                if (this.className) {
                  node.classList.add(this.className);
                }
                return node;
              };
              ShadowBlot2.prototype.attach = function() {
                if (this.parent != null) {
                  this.scroll = this.parent.scroll;
                }
              };
              ShadowBlot2.prototype.clone = function() {
                var domNode = this.domNode.cloneNode(false);
                return Registry.create(domNode);
              };
              ShadowBlot2.prototype.detach = function() {
                if (this.parent != null)
                  this.parent.removeChild(this);
                delete this.domNode[Registry.DATA_KEY];
              };
              ShadowBlot2.prototype.deleteAt = function(index, length) {
                var blot = this.isolate(index, length);
                blot.remove();
              };
              ShadowBlot2.prototype.formatAt = function(index, length, name, value) {
                var blot = this.isolate(index, length);
                if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
                  blot.wrap(name, value);
                } else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
                  var parent = Registry.create(this.statics.scope);
                  blot.wrap(parent);
                  parent.format(name, value);
                }
              };
              ShadowBlot2.prototype.insertAt = function(index, value, def) {
                var blot = def == null ? Registry.create("text", value) : Registry.create(value, def);
                var ref = this.split(index);
                this.parent.insertBefore(blot, ref);
              };
              ShadowBlot2.prototype.insertInto = function(parentBlot, refBlot) {
                if (refBlot === void 0) {
                  refBlot = null;
                }
                if (this.parent != null) {
                  this.parent.children.remove(this);
                }
                var refDomNode = null;
                parentBlot.children.insertBefore(this, refBlot);
                if (refBlot != null) {
                  refDomNode = refBlot.domNode;
                }
                if (this.domNode.parentNode != parentBlot.domNode || this.domNode.nextSibling != refDomNode) {
                  parentBlot.domNode.insertBefore(this.domNode, refDomNode);
                }
                this.parent = parentBlot;
                this.attach();
              };
              ShadowBlot2.prototype.isolate = function(index, length) {
                var target = this.split(index);
                target.split(length);
                return target;
              };
              ShadowBlot2.prototype.length = function() {
                return 1;
              };
              ShadowBlot2.prototype.offset = function(root2) {
                if (root2 === void 0) {
                  root2 = this.parent;
                }
                if (this.parent == null || this == root2)
                  return 0;
                return this.parent.children.offset(this) + this.parent.offset(root2);
              };
              ShadowBlot2.prototype.optimize = function(context) {
                if (this.domNode[Registry.DATA_KEY] != null) {
                  delete this.domNode[Registry.DATA_KEY].mutations;
                }
              };
              ShadowBlot2.prototype.remove = function() {
                if (this.domNode.parentNode != null) {
                  this.domNode.parentNode.removeChild(this.domNode);
                }
                this.detach();
              };
              ShadowBlot2.prototype.replace = function(target) {
                if (target.parent == null)
                  return;
                target.parent.insertBefore(this, target.next);
                target.remove();
              };
              ShadowBlot2.prototype.replaceWith = function(name, value) {
                var replacement = typeof name === "string" ? Registry.create(name, value) : name;
                replacement.replace(this);
                return replacement;
              };
              ShadowBlot2.prototype.split = function(index, force) {
                return index === 0 ? this : this.next;
              };
              ShadowBlot2.prototype.update = function(mutations, context) {
              };
              ShadowBlot2.prototype.wrap = function(name, value) {
                var wrapper = typeof name === "string" ? Registry.create(name, value) : name;
                if (this.parent != null) {
                  this.parent.insertBefore(wrapper, this.next);
                }
                wrapper.appendChild(this);
                return wrapper;
              };
              ShadowBlot2.blotName = "abstract";
              return ShadowBlot2;
            }()
          );
          exports2.default = ShadowBlot;
        },
        /* 31 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          var class_1 = __webpack_require__(32);
          var style_1 = __webpack_require__(33);
          var Registry = __webpack_require__(1);
          var AttributorStore = (
            /** @class */
            function() {
              function AttributorStore2(domNode) {
                this.attributes = {};
                this.domNode = domNode;
                this.build();
              }
              AttributorStore2.prototype.attribute = function(attribute2, value) {
                if (value) {
                  if (attribute2.add(this.domNode, value)) {
                    if (attribute2.value(this.domNode) != null) {
                      this.attributes[attribute2.attrName] = attribute2;
                    } else {
                      delete this.attributes[attribute2.attrName];
                    }
                  }
                } else {
                  attribute2.remove(this.domNode);
                  delete this.attributes[attribute2.attrName];
                }
              };
              AttributorStore2.prototype.build = function() {
                var _this = this;
                this.attributes = {};
                var attributes = attributor_1.default.keys(this.domNode);
                var classes = class_1.default.keys(this.domNode);
                var styles2 = style_1.default.keys(this.domNode);
                attributes.concat(classes).concat(styles2).forEach(function(name) {
                  var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
                  if (attr instanceof attributor_1.default) {
                    _this.attributes[attr.attrName] = attr;
                  }
                });
              };
              AttributorStore2.prototype.copy = function(target) {
                var _this = this;
                Object.keys(this.attributes).forEach(function(key) {
                  var value = _this.attributes[key].value(_this.domNode);
                  target.format(key, value);
                });
              };
              AttributorStore2.prototype.move = function(target) {
                var _this = this;
                this.copy(target);
                Object.keys(this.attributes).forEach(function(key) {
                  _this.attributes[key].remove(_this.domNode);
                });
                this.attributes = {};
              };
              AttributorStore2.prototype.values = function() {
                var _this = this;
                return Object.keys(this.attributes).reduce(function(attributes, name) {
                  attributes[name] = _this.attributes[name].value(_this.domNode);
                  return attributes;
                }, {});
              };
              return AttributorStore2;
            }()
          );
          exports2.default = AttributorStore;
        },
        /* 32 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          function match(node, prefix) {
            var className = node.getAttribute("class") || "";
            return className.split(/\s+/).filter(function(name) {
              return name.indexOf(prefix + "-") === 0;
            });
          }
          var ClassAttributor = (
            /** @class */
            function(_super) {
              __extends2(ClassAttributor2, _super);
              function ClassAttributor2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              ClassAttributor2.keys = function(node) {
                return (node.getAttribute("class") || "").split(/\s+/).map(function(name) {
                  return name.split("-").slice(0, -1).join("-");
                });
              };
              ClassAttributor2.prototype.add = function(node, value) {
                if (!this.canAdd(node, value))
                  return false;
                this.remove(node);
                node.classList.add(this.keyName + "-" + value);
                return true;
              };
              ClassAttributor2.prototype.remove = function(node) {
                var matches = match(node, this.keyName);
                matches.forEach(function(name) {
                  node.classList.remove(name);
                });
                if (node.classList.length === 0) {
                  node.removeAttribute("class");
                }
              };
              ClassAttributor2.prototype.value = function(node) {
                var result = match(node, this.keyName)[0] || "";
                var value = result.slice(this.keyName.length + 1);
                return this.canAdd(node, value) ? value : "";
              };
              return ClassAttributor2;
            }(attributor_1.default)
          );
          exports2.default = ClassAttributor;
        },
        /* 33 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var attributor_1 = __webpack_require__(12);
          function camelize(name) {
            var parts = name.split("-");
            var rest = parts.slice(1).map(function(part) {
              return part[0].toUpperCase() + part.slice(1);
            }).join("");
            return parts[0] + rest;
          }
          var StyleAttributor = (
            /** @class */
            function(_super) {
              __extends2(StyleAttributor2, _super);
              function StyleAttributor2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              StyleAttributor2.keys = function(node) {
                return (node.getAttribute("style") || "").split(";").map(function(value) {
                  var arr = value.split(":");
                  return arr[0].trim();
                });
              };
              StyleAttributor2.prototype.add = function(node, value) {
                if (!this.canAdd(node, value))
                  return false;
                node.style[camelize(this.keyName)] = value;
                return true;
              };
              StyleAttributor2.prototype.remove = function(node) {
                node.style[camelize(this.keyName)] = "";
                if (!node.getAttribute("style")) {
                  node.removeAttribute("style");
                }
              };
              StyleAttributor2.prototype.value = function(node) {
                var value = node.style[camelize(this.keyName)];
                return this.canAdd(node, value) ? value : "";
              };
              return StyleAttributor2;
            }(attributor_1.default)
          );
          exports2.default = StyleAttributor;
        },
        /* 34 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Theme = function() {
            function Theme2(quill2, options) {
              _classCallCheck(this, Theme2);
              this.quill = quill2;
              this.options = options;
              this.modules = {};
            }
            _createClass(Theme2, [{
              key: "init",
              value: function init() {
                var _this = this;
                Object.keys(this.options.modules).forEach(function(name) {
                  if (_this.modules[name] == null) {
                    _this.addModule(name);
                  }
                });
              }
            }, {
              key: "addModule",
              value: function addModule(name) {
                var moduleClass = this.quill.constructor.import("modules/" + name);
                this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
                return this.modules[name];
              }
            }]);
            return Theme2;
          }();
          Theme.DEFAULTS = {
            modules: {}
          };
          Theme.themes = {
            "default": Theme
          };
          exports2.default = Theme;
        },
        /* 35 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _text = __webpack_require__(7);
          var _text2 = _interopRequireDefault(_text);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var GUARD_TEXT = "\uFEFF";
          var Embed = function(_Parchment$Embed) {
            _inherits(Embed2, _Parchment$Embed);
            function Embed2(node) {
              _classCallCheck(this, Embed2);
              var _this = _possibleConstructorReturn(this, (Embed2.__proto__ || Object.getPrototypeOf(Embed2)).call(this, node));
              _this.contentNode = document.createElement("span");
              _this.contentNode.setAttribute("contenteditable", false);
              [].slice.call(_this.domNode.childNodes).forEach(function(childNode) {
                _this.contentNode.appendChild(childNode);
              });
              _this.leftGuard = document.createTextNode(GUARD_TEXT);
              _this.rightGuard = document.createTextNode(GUARD_TEXT);
              _this.domNode.appendChild(_this.leftGuard);
              _this.domNode.appendChild(_this.contentNode);
              _this.domNode.appendChild(_this.rightGuard);
              return _this;
            }
            _createClass(Embed2, [{
              key: "index",
              value: function index(node, offset) {
                if (node === this.leftGuard)
                  return 0;
                if (node === this.rightGuard)
                  return 1;
                return _get(Embed2.prototype.__proto__ || Object.getPrototypeOf(Embed2.prototype), "index", this).call(this, node, offset);
              }
            }, {
              key: "restore",
              value: function restore(node) {
                var range = void 0, textNode = void 0;
                var text = node.data.split(GUARD_TEXT).join("");
                if (node === this.leftGuard) {
                  if (this.prev instanceof _text2.default) {
                    var prevLength = this.prev.length();
                    this.prev.insertAt(prevLength, text);
                    range = {
                      startNode: this.prev.domNode,
                      startOffset: prevLength + text.length
                    };
                  } else {
                    textNode = document.createTextNode(text);
                    this.parent.insertBefore(_parchment2.default.create(textNode), this);
                    range = {
                      startNode: textNode,
                      startOffset: text.length
                    };
                  }
                } else if (node === this.rightGuard) {
                  if (this.next instanceof _text2.default) {
                    this.next.insertAt(0, text);
                    range = {
                      startNode: this.next.domNode,
                      startOffset: text.length
                    };
                  } else {
                    textNode = document.createTextNode(text);
                    this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
                    range = {
                      startNode: textNode,
                      startOffset: text.length
                    };
                  }
                }
                node.data = GUARD_TEXT;
                return range;
              }
            }, {
              key: "update",
              value: function update(mutations, context) {
                var _this2 = this;
                mutations.forEach(function(mutation) {
                  if (mutation.type === "characterData" && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
                    var range = _this2.restore(mutation.target);
                    if (range)
                      context.range = range;
                  }
                });
              }
            }]);
            return Embed2;
          }(_parchment2.default.Embed);
          exports2.default = Embed;
        },
        /* 36 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.AlignStyle = exports2.AlignClass = exports2.AlignAttribute = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var config = {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: ["right", "center", "justify"]
          };
          var AlignAttribute = new _parchment2.default.Attributor.Attribute("align", "align", config);
          var AlignClass = new _parchment2.default.Attributor.Class("align", "ql-align", config);
          var AlignStyle = new _parchment2.default.Attributor.Style("align", "text-align", config);
          exports2.AlignAttribute = AlignAttribute;
          exports2.AlignClass = AlignClass;
          exports2.AlignStyle = AlignStyle;
        },
        /* 37 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.BackgroundStyle = exports2.BackgroundClass = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _color = __webpack_require__(26);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var BackgroundClass = new _parchment2.default.Attributor.Class("background", "ql-bg", {
            scope: _parchment2.default.Scope.INLINE
          });
          var BackgroundStyle = new _color.ColorAttributor("background", "background-color", {
            scope: _parchment2.default.Scope.INLINE
          });
          exports2.BackgroundClass = BackgroundClass;
          exports2.BackgroundStyle = BackgroundStyle;
        },
        /* 38 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.DirectionStyle = exports2.DirectionClass = exports2.DirectionAttribute = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var config = {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: ["rtl"]
          };
          var DirectionAttribute = new _parchment2.default.Attributor.Attribute("direction", "dir", config);
          var DirectionClass = new _parchment2.default.Attributor.Class("direction", "ql-direction", config);
          var DirectionStyle = new _parchment2.default.Attributor.Style("direction", "direction", config);
          exports2.DirectionAttribute = DirectionAttribute;
          exports2.DirectionClass = DirectionClass;
          exports2.DirectionStyle = DirectionStyle;
        },
        /* 39 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.FontClass = exports2.FontStyle = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var config = {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["serif", "monospace"]
          };
          var FontClass = new _parchment2.default.Attributor.Class("font", "ql-font", config);
          var FontStyleAttributor = function(_Parchment$Attributor) {
            _inherits(FontStyleAttributor2, _Parchment$Attributor);
            function FontStyleAttributor2() {
              _classCallCheck(this, FontStyleAttributor2);
              return _possibleConstructorReturn(this, (FontStyleAttributor2.__proto__ || Object.getPrototypeOf(FontStyleAttributor2)).apply(this, arguments));
            }
            _createClass(FontStyleAttributor2, [{
              key: "value",
              value: function value(node) {
                return _get(FontStyleAttributor2.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor2.prototype), "value", this).call(this, node).replace(/["']/g, "");
              }
            }]);
            return FontStyleAttributor2;
          }(_parchment2.default.Attributor.Style);
          var FontStyle = new FontStyleAttributor("font", "font-family", config);
          exports2.FontStyle = FontStyle;
          exports2.FontClass = FontClass;
        },
        /* 40 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.SizeStyle = exports2.SizeClass = void 0;
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          var SizeClass = new _parchment2.default.Attributor.Class("size", "ql-size", {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["small", "large", "huge"]
          });
          var SizeStyle = new _parchment2.default.Attributor.Style("size", "font-size", {
            scope: _parchment2.default.Scope.INLINE,
            whitelist: ["10px", "18px", "32px"]
          });
          exports2.SizeClass = SizeClass;
          exports2.SizeStyle = SizeStyle;
        },
        /* 41 */
        /***/
        function(module2, exports2, __webpack_require__) {
          module2.exports = {
            "align": {
              "": __webpack_require__(76),
              "center": __webpack_require__(77),
              "right": __webpack_require__(78),
              "justify": __webpack_require__(79)
            },
            "background": __webpack_require__(80),
            "blockquote": __webpack_require__(81),
            "bold": __webpack_require__(82),
            "clean": __webpack_require__(83),
            "code": __webpack_require__(58),
            "code-block": __webpack_require__(58),
            "color": __webpack_require__(84),
            "direction": {
              "": __webpack_require__(85),
              "rtl": __webpack_require__(86)
            },
            "float": {
              "center": __webpack_require__(87),
              "full": __webpack_require__(88),
              "left": __webpack_require__(89),
              "right": __webpack_require__(90)
            },
            "formula": __webpack_require__(91),
            "header": {
              "1": __webpack_require__(92),
              "2": __webpack_require__(93)
            },
            "italic": __webpack_require__(94),
            "image": __webpack_require__(95),
            "indent": {
              "+1": __webpack_require__(96),
              "-1": __webpack_require__(97)
            },
            "link": __webpack_require__(98),
            "list": {
              "ordered": __webpack_require__(99),
              "bullet": __webpack_require__(100),
              "check": __webpack_require__(101)
            },
            "script": {
              "sub": __webpack_require__(102),
              "super": __webpack_require__(103)
            },
            "strike": __webpack_require__(104),
            "underline": __webpack_require__(105),
            "video": __webpack_require__(106)
          };
        },
        /* 42 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.getLastChangeIndex = exports2.default = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var History2 = function(_Module) {
            _inherits(History22, _Module);
            function History22(quill2, options) {
              _classCallCheck(this, History22);
              var _this = _possibleConstructorReturn(this, (History22.__proto__ || Object.getPrototypeOf(History22)).call(this, quill2, options));
              _this.lastRecorded = 0;
              _this.ignoreChange = false;
              _this.clear();
              _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(eventName, delta, oldDelta, source) {
                if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange)
                  return;
                if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
                  _this.record(delta, oldDelta);
                } else {
                  _this.transform(delta);
                }
              });
              _this.quill.keyboard.addBinding({ key: "Z", shortKey: true }, _this.undo.bind(_this));
              _this.quill.keyboard.addBinding({ key: "Z", shortKey: true, shiftKey: true }, _this.redo.bind(_this));
              if (/Win/i.test(navigator.platform)) {
                _this.quill.keyboard.addBinding({ key: "Y", shortKey: true }, _this.redo.bind(_this));
              }
              return _this;
            }
            _createClass(History22, [{
              key: "change",
              value: function change(source, dest) {
                if (this.stack[source].length === 0)
                  return;
                var delta = this.stack[source].pop();
                this.stack[dest].push(delta);
                this.lastRecorded = 0;
                this.ignoreChange = true;
                this.quill.updateContents(delta[source], _quill2.default.sources.USER);
                this.ignoreChange = false;
                var index = getLastChangeIndex(delta[source]);
                this.quill.setSelection(index);
              }
            }, {
              key: "clear",
              value: function clear() {
                this.stack = { undo: [], redo: [] };
              }
            }, {
              key: "cutoff",
              value: function cutoff() {
                this.lastRecorded = 0;
              }
            }, {
              key: "record",
              value: function record(changeDelta, oldDelta) {
                if (changeDelta.ops.length === 0)
                  return;
                this.stack.redo = [];
                var undoDelta = this.quill.getContents().diff(oldDelta);
                var timestamp = Date.now();
                if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
                  var delta = this.stack.undo.pop();
                  undoDelta = undoDelta.compose(delta.undo);
                  changeDelta = delta.redo.compose(changeDelta);
                } else {
                  this.lastRecorded = timestamp;
                }
                this.stack.undo.push({
                  redo: changeDelta,
                  undo: undoDelta
                });
                if (this.stack.undo.length > this.options.maxStack) {
                  this.stack.undo.shift();
                }
              }
            }, {
              key: "redo",
              value: function redo() {
                this.change("redo", "undo");
              }
            }, {
              key: "transform",
              value: function transform(delta) {
                this.stack.undo.forEach(function(change) {
                  change.undo = delta.transform(change.undo, true);
                  change.redo = delta.transform(change.redo, true);
                });
                this.stack.redo.forEach(function(change) {
                  change.undo = delta.transform(change.undo, true);
                  change.redo = delta.transform(change.redo, true);
                });
              }
            }, {
              key: "undo",
              value: function undo() {
                this.change("undo", "redo");
              }
            }]);
            return History22;
          }(_module2.default);
          History2.DEFAULTS = {
            delay: 1e3,
            maxStack: 100,
            userOnly: false
          };
          function endsWithNewlineChange(delta) {
            var lastOp = delta.ops[delta.ops.length - 1];
            if (lastOp == null)
              return false;
            if (lastOp.insert != null) {
              return typeof lastOp.insert === "string" && lastOp.insert.endsWith("\n");
            }
            if (lastOp.attributes != null) {
              return Object.keys(lastOp.attributes).some(function(attr) {
                return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
              });
            }
            return false;
          }
          function getLastChangeIndex(delta) {
            var deleteLength = delta.reduce(function(length, op) {
              length += op.delete || 0;
              return length;
            }, 0);
            var changeIndex = delta.length() - deleteLength;
            if (endsWithNewlineChange(delta)) {
              changeIndex -= 1;
            }
            return changeIndex;
          }
          exports2.default = History2;
          exports2.getLastChangeIndex = getLastChangeIndex;
        },
        /* 43 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BaseTooltip = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _keyboard = __webpack_require__(23);
          var _keyboard2 = _interopRequireDefault(_keyboard);
          var _theme = __webpack_require__(34);
          var _theme2 = _interopRequireDefault(_theme);
          var _colorPicker = __webpack_require__(59);
          var _colorPicker2 = _interopRequireDefault(_colorPicker);
          var _iconPicker = __webpack_require__(60);
          var _iconPicker2 = _interopRequireDefault(_iconPicker);
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          var _tooltip = __webpack_require__(61);
          var _tooltip2 = _interopRequireDefault(_tooltip);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ALIGNS = [false, "center", "right", "justify"];
          var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];
          var FONTS = [false, "serif", "monospace"];
          var HEADERS = ["1", "2", "3", false];
          var SIZES = ["small", false, "large", "huge"];
          var BaseTheme = function(_Theme) {
            _inherits(BaseTheme2, _Theme);
            function BaseTheme2(quill2, options) {
              _classCallCheck(this, BaseTheme2);
              var _this = _possibleConstructorReturn(this, (BaseTheme2.__proto__ || Object.getPrototypeOf(BaseTheme2)).call(this, quill2, options));
              var listener = function listener2(e) {
                if (!document.body.contains(quill2.root)) {
                  return document.body.removeEventListener("click", listener2);
                }
                if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
                  _this.tooltip.hide();
                }
                if (_this.pickers != null) {
                  _this.pickers.forEach(function(picker) {
                    if (!picker.container.contains(e.target)) {
                      picker.close();
                    }
                  });
                }
              };
              quill2.emitter.listenDOM("click", document.body, listener);
              return _this;
            }
            _createClass(BaseTheme2, [{
              key: "addModule",
              value: function addModule(name) {
                var module3 = _get(BaseTheme2.prototype.__proto__ || Object.getPrototypeOf(BaseTheme2.prototype), "addModule", this).call(this, name);
                if (name === "toolbar") {
                  this.extendToolbar(module3);
                }
                return module3;
              }
            }, {
              key: "buildButtons",
              value: function buildButtons(buttons, icons) {
                buttons.forEach(function(button2) {
                  var className = button2.getAttribute("class") || "";
                  className.split(/\s+/).forEach(function(name) {
                    if (!name.startsWith("ql-"))
                      return;
                    name = name.slice("ql-".length);
                    if (icons[name] == null)
                      return;
                    if (name === "direction") {
                      button2.innerHTML = icons[name][""] + icons[name]["rtl"];
                    } else if (typeof icons[name] === "string") {
                      button2.innerHTML = icons[name];
                    } else {
                      var value = button2.value || "";
                      if (value != null && icons[name][value]) {
                        button2.innerHTML = icons[name][value];
                      }
                    }
                  });
                });
              }
            }, {
              key: "buildPickers",
              value: function buildPickers(selects, icons) {
                var _this2 = this;
                this.pickers = selects.map(function(select) {
                  if (select.classList.contains("ql-align")) {
                    if (select.querySelector("option") == null) {
                      fillSelect(select, ALIGNS);
                    }
                    return new _iconPicker2.default(select, icons.align);
                  } else if (select.classList.contains("ql-background") || select.classList.contains("ql-color")) {
                    var format = select.classList.contains("ql-background") ? "background" : "color";
                    if (select.querySelector("option") == null) {
                      fillSelect(select, COLORS, format === "background" ? "#ffffff" : "#000000");
                    }
                    return new _colorPicker2.default(select, icons[format]);
                  } else {
                    if (select.querySelector("option") == null) {
                      if (select.classList.contains("ql-font")) {
                        fillSelect(select, FONTS);
                      } else if (select.classList.contains("ql-header")) {
                        fillSelect(select, HEADERS);
                      } else if (select.classList.contains("ql-size")) {
                        fillSelect(select, SIZES);
                      }
                    }
                    return new _picker2.default(select);
                  }
                });
                var update = function update2() {
                  _this2.pickers.forEach(function(picker) {
                    picker.update();
                  });
                };
                this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
              }
            }]);
            return BaseTheme2;
          }(_theme2.default);
          BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  formula: function formula() {
                    this.quill.theme.tooltip.edit("formula");
                  },
                  image: function image() {
                    var _this3 = this;
                    var fileInput = this.container.querySelector("input.ql-image[type=file]");
                    if (fileInput == null) {
                      fileInput = document.createElement("input");
                      fileInput.setAttribute("type", "file");
                      fileInput.setAttribute("accept", "image/png, image/gif, image/jpeg, image/bmp, image/x-icon");
                      fileInput.classList.add("ql-image");
                      fileInput.addEventListener("change", function() {
                        if (fileInput.files != null && fileInput.files[0] != null) {
                          var reader = new FileReader();
                          reader.onload = function(e) {
                            var range = _this3.quill.getSelection(true);
                            _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                            _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                            fileInput.value = "";
                          };
                          reader.readAsDataURL(fileInput.files[0]);
                        }
                      });
                      this.container.appendChild(fileInput);
                    }
                    fileInput.click();
                  },
                  video: function video() {
                    this.quill.theme.tooltip.edit("video");
                  }
                }
              }
            }
          });
          var BaseTooltip = function(_Tooltip) {
            _inherits(BaseTooltip2, _Tooltip);
            function BaseTooltip2(quill2, boundsContainer) {
              _classCallCheck(this, BaseTooltip2);
              var _this4 = _possibleConstructorReturn(this, (BaseTooltip2.__proto__ || Object.getPrototypeOf(BaseTooltip2)).call(this, quill2, boundsContainer));
              _this4.textbox = _this4.root.querySelector('input[type="text"]');
              _this4.listen();
              return _this4;
            }
            _createClass(BaseTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this5 = this;
                this.textbox.addEventListener("keydown", function(event) {
                  if (_keyboard2.default.match(event, "enter")) {
                    _this5.save();
                    event.preventDefault();
                  } else if (_keyboard2.default.match(event, "escape")) {
                    _this5.cancel();
                    event.preventDefault();
                  }
                });
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this.hide();
              }
            }, {
              key: "edit",
              value: function edit() {
                var mode = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "link";
                var preview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                this.root.classList.remove("ql-hidden");
                this.root.classList.add("ql-editing");
                if (preview != null) {
                  this.textbox.value = preview;
                } else if (mode !== this.root.getAttribute("data-mode")) {
                  this.textbox.value = "";
                }
                this.position(this.quill.getBounds(this.quill.selection.savedRange));
                this.textbox.select();
                this.textbox.setAttribute("placeholder", this.textbox.getAttribute("data-" + mode) || "");
                this.root.setAttribute("data-mode", mode);
              }
            }, {
              key: "restoreFocus",
              value: function restoreFocus() {
                var scrollTop = this.quill.scrollingContainer.scrollTop;
                this.quill.focus();
                this.quill.scrollingContainer.scrollTop = scrollTop;
              }
            }, {
              key: "save",
              value: function save() {
                var value = this.textbox.value;
                switch (this.root.getAttribute("data-mode")) {
                  case "link": {
                    var scrollTop = this.quill.root.scrollTop;
                    if (this.linkRange) {
                      this.quill.formatText(this.linkRange, "link", value, _emitter2.default.sources.USER);
                      delete this.linkRange;
                    } else {
                      this.restoreFocus();
                      this.quill.format("link", value, _emitter2.default.sources.USER);
                    }
                    this.quill.root.scrollTop = scrollTop;
                    break;
                  }
                  case "video": {
                    value = extractVideoUrl(value);
                  }
                  case "formula": {
                    if (!value)
                      break;
                    var range = this.quill.getSelection(true);
                    if (range != null) {
                      var index = range.index + range.length;
                      this.quill.insertEmbed(index, this.root.getAttribute("data-mode"), value, _emitter2.default.sources.USER);
                      if (this.root.getAttribute("data-mode") === "formula") {
                        this.quill.insertText(index + 1, " ", _emitter2.default.sources.USER);
                      }
                      this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
                    }
                    break;
                  }
                }
                this.textbox.value = "";
                this.hide();
              }
            }]);
            return BaseTooltip2;
          }(_tooltip2.default);
          function extractVideoUrl(url) {
            var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
            if (match) {
              return (match[1] || "https") + "://www.youtube.com/embed/" + match[2] + "?showinfo=0";
            }
            if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
              return (match[1] || "https") + "://player.vimeo.com/video/" + match[2] + "/";
            }
            return url;
          }
          function fillSelect(select, values) {
            var defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            values.forEach(function(value) {
              var option = document.createElement("option");
              if (value === defaultValue) {
                option.setAttribute("selected", "selected");
              } else {
                option.setAttribute("value", value);
              }
              select.appendChild(option);
            });
          }
          exports2.BaseTooltip = BaseTooltip;
          exports2.default = BaseTheme;
        },
        /* 44 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", { value: true });
          var LinkedList = (
            /** @class */
            function() {
              function LinkedList2() {
                this.head = this.tail = null;
                this.length = 0;
              }
              LinkedList2.prototype.append = function() {
                var nodes = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                  nodes[_i] = arguments[_i];
                }
                this.insertBefore(nodes[0], null);
                if (nodes.length > 1) {
                  this.append.apply(this, nodes.slice(1));
                }
              };
              LinkedList2.prototype.contains = function(node) {
                var cur, next = this.iterator();
                while (cur = next()) {
                  if (cur === node)
                    return true;
                }
                return false;
              };
              LinkedList2.prototype.insertBefore = function(node, refNode) {
                if (!node)
                  return;
                node.next = refNode;
                if (refNode != null) {
                  node.prev = refNode.prev;
                  if (refNode.prev != null) {
                    refNode.prev.next = node;
                  }
                  refNode.prev = node;
                  if (refNode === this.head) {
                    this.head = node;
                  }
                } else if (this.tail != null) {
                  this.tail.next = node;
                  node.prev = this.tail;
                  this.tail = node;
                } else {
                  node.prev = null;
                  this.head = this.tail = node;
                }
                this.length += 1;
              };
              LinkedList2.prototype.offset = function(target) {
                var index = 0, cur = this.head;
                while (cur != null) {
                  if (cur === target)
                    return index;
                  index += cur.length();
                  cur = cur.next;
                }
                return -1;
              };
              LinkedList2.prototype.remove = function(node) {
                if (!this.contains(node))
                  return;
                if (node.prev != null)
                  node.prev.next = node.next;
                if (node.next != null)
                  node.next.prev = node.prev;
                if (node === this.head)
                  this.head = node.next;
                if (node === this.tail)
                  this.tail = node.prev;
                this.length -= 1;
              };
              LinkedList2.prototype.iterator = function(curNode) {
                if (curNode === void 0) {
                  curNode = this.head;
                }
                return function() {
                  var ret = curNode;
                  if (curNode != null)
                    curNode = curNode.next;
                  return ret;
                };
              };
              LinkedList2.prototype.find = function(index, inclusive) {
                if (inclusive === void 0) {
                  inclusive = false;
                }
                var cur, next = this.iterator();
                while (cur = next()) {
                  var length = cur.length();
                  if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) {
                    return [cur, index];
                  }
                  index -= length;
                }
                return [null, 0];
              };
              LinkedList2.prototype.forEach = function(callback) {
                var cur, next = this.iterator();
                while (cur = next()) {
                  callback(cur);
                }
              };
              LinkedList2.prototype.forEachAt = function(index, length, callback) {
                if (length <= 0)
                  return;
                var _a = this.find(index), startNode = _a[0], offset = _a[1];
                var cur, curIndex = index - offset, next = this.iterator(startNode);
                while ((cur = next()) && curIndex < index + length) {
                  var curLength = cur.length();
                  if (index > curIndex) {
                    callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
                  } else {
                    callback(cur, 0, Math.min(curLength, index + length - curIndex));
                  }
                  curIndex += curLength;
                }
              };
              LinkedList2.prototype.map = function(callback) {
                return this.reduce(function(memo, cur) {
                  memo.push(callback(cur));
                  return memo;
                }, []);
              };
              LinkedList2.prototype.reduce = function(callback, memo) {
                var cur, next = this.iterator();
                while (cur = next()) {
                  memo = callback(memo, cur);
                }
                return memo;
              };
              return LinkedList2;
            }()
          );
          exports2.default = LinkedList;
        },
        /* 45 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var container_1 = __webpack_require__(17);
          var Registry = __webpack_require__(1);
          var OBSERVER_CONFIG = {
            attributes: true,
            characterData: true,
            characterDataOldValue: true,
            childList: true,
            subtree: true
          };
          var MAX_OPTIMIZE_ITERATIONS = 100;
          var ScrollBlot = (
            /** @class */
            function(_super) {
              __extends2(ScrollBlot2, _super);
              function ScrollBlot2(node) {
                var _this = _super.call(this, node) || this;
                _this.scroll = _this;
                _this.observer = new MutationObserver(function(mutations) {
                  _this.update(mutations);
                });
                _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
                _this.attach();
                return _this;
              }
              ScrollBlot2.prototype.detach = function() {
                _super.prototype.detach.call(this);
                this.observer.disconnect();
              };
              ScrollBlot2.prototype.deleteAt = function(index, length) {
                this.update();
                if (index === 0 && length === this.length()) {
                  this.children.forEach(function(child) {
                    child.remove();
                  });
                } else {
                  _super.prototype.deleteAt.call(this, index, length);
                }
              };
              ScrollBlot2.prototype.formatAt = function(index, length, name, value) {
                this.update();
                _super.prototype.formatAt.call(this, index, length, name, value);
              };
              ScrollBlot2.prototype.insertAt = function(index, value, def) {
                this.update();
                _super.prototype.insertAt.call(this, index, value, def);
              };
              ScrollBlot2.prototype.optimize = function(mutations, context) {
                var _this = this;
                if (mutations === void 0) {
                  mutations = [];
                }
                if (context === void 0) {
                  context = {};
                }
                _super.prototype.optimize.call(this, context);
                var records = [].slice.call(this.observer.takeRecords());
                while (records.length > 0)
                  mutations.push(records.pop());
                var mark = function(blot, markParent) {
                  if (markParent === void 0) {
                    markParent = true;
                  }
                  if (blot == null || blot === _this)
                    return;
                  if (blot.domNode.parentNode == null)
                    return;
                  if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                    blot.domNode[Registry.DATA_KEY].mutations = [];
                  }
                  if (markParent)
                    mark(blot.parent);
                };
                var optimize = function(blot) {
                  if (
                    // @ts-ignore
                    blot.domNode[Registry.DATA_KEY] == null || // @ts-ignore
                    blot.domNode[Registry.DATA_KEY].mutations == null
                  ) {
                    return;
                  }
                  if (blot instanceof container_1.default) {
                    blot.children.forEach(optimize);
                  }
                  blot.optimize(context);
                };
                var remaining = mutations;
                for (var i = 0; remaining.length > 0; i += 1) {
                  if (i >= MAX_OPTIMIZE_ITERATIONS) {
                    throw new Error("[Parchment] Maximum optimize iterations reached");
                  }
                  remaining.forEach(function(mutation) {
                    var blot = Registry.find(mutation.target, true);
                    if (blot == null)
                      return;
                    if (blot.domNode === mutation.target) {
                      if (mutation.type === "childList") {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function(node) {
                          var child = Registry.find(node, false);
                          mark(child, false);
                          if (child instanceof container_1.default) {
                            child.children.forEach(function(grandChild) {
                              mark(grandChild, false);
                            });
                          }
                        });
                      } else if (mutation.type === "attributes") {
                        mark(blot.prev);
                      }
                    }
                    mark(blot);
                  });
                  this.children.forEach(optimize);
                  remaining = [].slice.call(this.observer.takeRecords());
                  records = remaining.slice();
                  while (records.length > 0)
                    mutations.push(records.pop());
                }
              };
              ScrollBlot2.prototype.update = function(mutations, context) {
                var _this = this;
                if (context === void 0) {
                  context = {};
                }
                mutations = mutations || this.observer.takeRecords();
                mutations.map(function(mutation) {
                  var blot = Registry.find(mutation.target, true);
                  if (blot == null)
                    return null;
                  if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                    blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                    return blot;
                  } else {
                    blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                    return null;
                  }
                }).forEach(function(blot) {
                  if (blot == null || blot === _this || //@ts-ignore
                  blot.domNode[Registry.DATA_KEY] == null)
                    return;
                  blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
                });
                if (this.domNode[Registry.DATA_KEY].mutations != null) {
                  _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
                }
                this.optimize(mutations, context);
              };
              ScrollBlot2.blotName = "scroll";
              ScrollBlot2.defaultChild = "block";
              ScrollBlot2.scope = Registry.Scope.BLOCK_BLOT;
              ScrollBlot2.tagName = "DIV";
              return ScrollBlot2;
            }(container_1.default)
          );
          exports2.default = ScrollBlot;
        },
        /* 46 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var format_1 = __webpack_require__(18);
          var Registry = __webpack_require__(1);
          function isEqual2(obj1, obj2) {
            if (Object.keys(obj1).length !== Object.keys(obj2).length)
              return false;
            for (var prop in obj1) {
              if (obj1[prop] !== obj2[prop])
                return false;
            }
            return true;
          }
          var InlineBlot = (
            /** @class */
            function(_super) {
              __extends2(InlineBlot2, _super);
              function InlineBlot2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              InlineBlot2.formats = function(domNode) {
                if (domNode.tagName === InlineBlot2.tagName)
                  return void 0;
                return _super.formats.call(this, domNode);
              };
              InlineBlot2.prototype.format = function(name, value) {
                var _this = this;
                if (name === this.statics.blotName && !value) {
                  this.children.forEach(function(child) {
                    if (!(child instanceof format_1.default)) {
                      child = child.wrap(InlineBlot2.blotName, true);
                    }
                    _this.attributes.copy(child);
                  });
                  this.unwrap();
                } else {
                  _super.prototype.format.call(this, name, value);
                }
              };
              InlineBlot2.prototype.formatAt = function(index, length, name, value) {
                if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
                  var blot = this.isolate(index, length);
                  blot.format(name, value);
                } else {
                  _super.prototype.formatAt.call(this, index, length, name, value);
                }
              };
              InlineBlot2.prototype.optimize = function(context) {
                _super.prototype.optimize.call(this, context);
                var formats = this.formats();
                if (Object.keys(formats).length === 0) {
                  return this.unwrap();
                }
                var next = this.next;
                if (next instanceof InlineBlot2 && next.prev === this && isEqual2(formats, next.formats())) {
                  next.moveChildren(this);
                  next.remove();
                }
              };
              InlineBlot2.blotName = "inline";
              InlineBlot2.scope = Registry.Scope.INLINE_BLOT;
              InlineBlot2.tagName = "SPAN";
              return InlineBlot2;
            }(format_1.default)
          );
          exports2.default = InlineBlot;
        },
        /* 47 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var format_1 = __webpack_require__(18);
          var Registry = __webpack_require__(1);
          var BlockBlot = (
            /** @class */
            function(_super) {
              __extends2(BlockBlot2, _super);
              function BlockBlot2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              BlockBlot2.formats = function(domNode) {
                var tagName = Registry.query(BlockBlot2.blotName).tagName;
                if (domNode.tagName === tagName)
                  return void 0;
                return _super.formats.call(this, domNode);
              };
              BlockBlot2.prototype.format = function(name, value) {
                if (Registry.query(name, Registry.Scope.BLOCK) == null) {
                  return;
                } else if (name === this.statics.blotName && !value) {
                  this.replaceWith(BlockBlot2.blotName);
                } else {
                  _super.prototype.format.call(this, name, value);
                }
              };
              BlockBlot2.prototype.formatAt = function(index, length, name, value) {
                if (Registry.query(name, Registry.Scope.BLOCK) != null) {
                  this.format(name, value);
                } else {
                  _super.prototype.formatAt.call(this, index, length, name, value);
                }
              };
              BlockBlot2.prototype.insertAt = function(index, value, def) {
                if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
                  _super.prototype.insertAt.call(this, index, value, def);
                } else {
                  var after = this.split(index);
                  var blot = Registry.create(value, def);
                  after.parent.insertBefore(blot, after);
                }
              };
              BlockBlot2.prototype.update = function(mutations, context) {
                if (navigator.userAgent.match(/Trident/)) {
                  this.build();
                } else {
                  _super.prototype.update.call(this, mutations, context);
                }
              };
              BlockBlot2.blotName = "block";
              BlockBlot2.scope = Registry.Scope.BLOCK_BLOT;
              BlockBlot2.tagName = "P";
              return BlockBlot2;
            }(format_1.default)
          );
          exports2.default = BlockBlot;
        },
        /* 48 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var leaf_1 = __webpack_require__(19);
          var EmbedBlot = (
            /** @class */
            function(_super) {
              __extends2(EmbedBlot2, _super);
              function EmbedBlot2() {
                return _super !== null && _super.apply(this, arguments) || this;
              }
              EmbedBlot2.formats = function(domNode) {
                return void 0;
              };
              EmbedBlot2.prototype.format = function(name, value) {
                _super.prototype.formatAt.call(this, 0, this.length(), name, value);
              };
              EmbedBlot2.prototype.formatAt = function(index, length, name, value) {
                if (index === 0 && length === this.length()) {
                  this.format(name, value);
                } else {
                  _super.prototype.formatAt.call(this, index, length, name, value);
                }
              };
              EmbedBlot2.prototype.formats = function() {
                return this.statics.formats(this.domNode);
              };
              return EmbedBlot2;
            }(leaf_1.default)
          );
          exports2.default = EmbedBlot;
        },
        /* 49 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var __extends2 = this && this.__extends || function() {
            var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d, b) {
              d.__proto__ = b;
            } || function(d, b) {
              for (var p in b)
                if (b.hasOwnProperty(p))
                  d[p] = b[p];
            };
            return function(d, b) {
              extendStatics(d, b);
              function __() {
                this.constructor = d;
              }
              d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
            };
          }();
          Object.defineProperty(exports2, "__esModule", { value: true });
          var leaf_1 = __webpack_require__(19);
          var Registry = __webpack_require__(1);
          var TextBlot = (
            /** @class */
            function(_super) {
              __extends2(TextBlot2, _super);
              function TextBlot2(node) {
                var _this = _super.call(this, node) || this;
                _this.text = _this.statics.value(_this.domNode);
                return _this;
              }
              TextBlot2.create = function(value) {
                return document.createTextNode(value);
              };
              TextBlot2.value = function(domNode) {
                var text = domNode.data;
                if (text["normalize"])
                  text = text["normalize"]();
                return text;
              };
              TextBlot2.prototype.deleteAt = function(index, length) {
                this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
              };
              TextBlot2.prototype.index = function(node, offset) {
                if (this.domNode === node) {
                  return offset;
                }
                return -1;
              };
              TextBlot2.prototype.insertAt = function(index, value, def) {
                if (def == null) {
                  this.text = this.text.slice(0, index) + value + this.text.slice(index);
                  this.domNode.data = this.text;
                } else {
                  _super.prototype.insertAt.call(this, index, value, def);
                }
              };
              TextBlot2.prototype.length = function() {
                return this.text.length;
              };
              TextBlot2.prototype.optimize = function(context) {
                _super.prototype.optimize.call(this, context);
                this.text = this.statics.value(this.domNode);
                if (this.text.length === 0) {
                  this.remove();
                } else if (this.next instanceof TextBlot2 && this.next.prev === this) {
                  this.insertAt(this.length(), this.next.value());
                  this.next.remove();
                }
              };
              TextBlot2.prototype.position = function(index, inclusive) {
                return [this.domNode, index];
              };
              TextBlot2.prototype.split = function(index, force) {
                if (force === void 0) {
                  force = false;
                }
                if (!force) {
                  if (index === 0)
                    return this;
                  if (index === this.length())
                    return this.next;
                }
                var after = Registry.create(this.domNode.splitText(index));
                this.parent.insertBefore(after, this.next);
                this.text = this.statics.value(this.domNode);
                return after;
              };
              TextBlot2.prototype.update = function(mutations, context) {
                var _this = this;
                if (mutations.some(function(mutation) {
                  return mutation.type === "characterData" && mutation.target === _this.domNode;
                })) {
                  this.text = this.statics.value(this.domNode);
                }
              };
              TextBlot2.prototype.value = function() {
                return this.text;
              };
              TextBlot2.blotName = "text";
              TextBlot2.scope = Registry.Scope.INLINE_BLOT;
              return TextBlot2;
            }(leaf_1.default)
          );
          exports2.default = TextBlot;
        },
        /* 50 */
        /***/
        function(module2, exports2, __webpack_require__) {
          var elem = document.createElement("div");
          elem.classList.toggle("test-class", false);
          if (elem.classList.contains("test-class")) {
            var _toggle = DOMTokenList.prototype.toggle;
            DOMTokenList.prototype.toggle = function(token, force) {
              if (arguments.length > 1 && !this.contains(token) === !force) {
                return force;
              } else {
                return _toggle.call(this, token);
              }
            };
          }
          if (!String.prototype.startsWith) {
            String.prototype.startsWith = function(searchString, position) {
              position = position || 0;
              return this.substr(position, searchString.length) === searchString;
            };
          }
          if (!String.prototype.endsWith) {
            String.prototype.endsWith = function(searchString, position) {
              var subjectString = this.toString();
              if (typeof position !== "number" || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                position = subjectString.length;
              }
              position -= searchString.length;
              var lastIndex = subjectString.indexOf(searchString, position);
              return lastIndex !== -1 && lastIndex === position;
            };
          }
          if (!Array.prototype.find) {
            Object.defineProperty(Array.prototype, "find", {
              value: function value(predicate) {
                if (this === null) {
                  throw new TypeError("Array.prototype.find called on null or undefined");
                }
                if (typeof predicate !== "function") {
                  throw new TypeError("predicate must be a function");
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value2;
                for (var i = 0; i < length; i++) {
                  value2 = list[i];
                  if (predicate.call(thisArg, value2, i, list)) {
                    return value2;
                  }
                }
                return void 0;
              }
            });
          }
          document.addEventListener("DOMContentLoaded", function() {
            document.execCommand("enableObjectResizing", false, false);
            document.execCommand("autoUrlDetect", false, false);
          });
        },
        /* 51 */
        /***/
        function(module2, exports2) {
          var DIFF_DELETE = -1;
          var DIFF_INSERT = 1;
          var DIFF_EQUAL = 0;
          function diff_main(text1, text2, cursor_pos) {
            if (text1 == text2) {
              if (text1) {
                return [[DIFF_EQUAL, text1]];
              }
              return [];
            }
            if (cursor_pos < 0 || text1.length < cursor_pos) {
              cursor_pos = null;
            }
            var commonlength = diff_commonPrefix(text1, text2);
            var commonprefix = text1.substring(0, commonlength);
            text1 = text1.substring(commonlength);
            text2 = text2.substring(commonlength);
            commonlength = diff_commonSuffix(text1, text2);
            var commonsuffix = text1.substring(text1.length - commonlength);
            text1 = text1.substring(0, text1.length - commonlength);
            text2 = text2.substring(0, text2.length - commonlength);
            var diffs = diff_compute_(text1, text2);
            if (commonprefix) {
              diffs.unshift([DIFF_EQUAL, commonprefix]);
            }
            if (commonsuffix) {
              diffs.push([DIFF_EQUAL, commonsuffix]);
            }
            diff_cleanupMerge(diffs);
            if (cursor_pos != null) {
              diffs = fix_cursor(diffs, cursor_pos);
            }
            diffs = fix_emoji(diffs);
            return diffs;
          }
          function diff_compute_(text1, text2) {
            var diffs;
            if (!text1) {
              return [[DIFF_INSERT, text2]];
            }
            if (!text2) {
              return [[DIFF_DELETE, text1]];
            }
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            var i = longtext.indexOf(shorttext);
            if (i != -1) {
              diffs = [
                [DIFF_INSERT, longtext.substring(0, i)],
                [DIFF_EQUAL, shorttext],
                [DIFF_INSERT, longtext.substring(i + shorttext.length)]
              ];
              if (text1.length > text2.length) {
                diffs[0][0] = diffs[2][0] = DIFF_DELETE;
              }
              return diffs;
            }
            if (shorttext.length == 1) {
              return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
            }
            var hm = diff_halfMatch_(text1, text2);
            if (hm) {
              var text1_a = hm[0];
              var text1_b = hm[1];
              var text2_a = hm[2];
              var text2_b = hm[3];
              var mid_common = hm[4];
              var diffs_a = diff_main(text1_a, text2_a);
              var diffs_b = diff_main(text1_b, text2_b);
              return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
            }
            return diff_bisect_(text1, text2);
          }
          function diff_bisect_(text1, text2) {
            var text1_length = text1.length;
            var text2_length = text2.length;
            var max_d = Math.ceil((text1_length + text2_length) / 2);
            var v_offset = max_d;
            var v_length = 2 * max_d;
            var v1 = new Array(v_length);
            var v2 = new Array(v_length);
            for (var x2 = 0; x2 < v_length; x2++) {
              v1[x2] = -1;
              v2[x2] = -1;
            }
            v1[v_offset + 1] = 0;
            v2[v_offset + 1] = 0;
            var delta = text1_length - text2_length;
            var front = delta % 2 != 0;
            var k1start = 0;
            var k1end = 0;
            var k2start = 0;
            var k2end = 0;
            for (var d = 0; d < max_d; d++) {
              for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
                var k1_offset = v_offset + k1;
                var x1;
                if (k1 == -d || k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1]) {
                  x1 = v1[k1_offset + 1];
                } else {
                  x1 = v1[k1_offset - 1] + 1;
                }
                var y1 = x1 - k1;
                while (x1 < text1_length && y1 < text2_length && text1.charAt(x1) == text2.charAt(y1)) {
                  x1++;
                  y1++;
                }
                v1[k1_offset] = x1;
                if (x1 > text1_length) {
                  k1end += 2;
                } else if (y1 > text2_length) {
                  k1start += 2;
                } else if (front) {
                  var k2_offset = v_offset + delta - k1;
                  if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
                    var x22 = text1_length - v2[k2_offset];
                    if (x1 >= x22) {
                      return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                  }
                }
              }
              for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
                var k2_offset = v_offset + k2;
                var x22;
                if (k2 == -d || k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1]) {
                  x22 = v2[k2_offset + 1];
                } else {
                  x22 = v2[k2_offset - 1] + 1;
                }
                var y2 = x22 - k2;
                while (x22 < text1_length && y2 < text2_length && text1.charAt(text1_length - x22 - 1) == text2.charAt(text2_length - y2 - 1)) {
                  x22++;
                  y2++;
                }
                v2[k2_offset] = x22;
                if (x22 > text1_length) {
                  k2end += 2;
                } else if (y2 > text2_length) {
                  k2start += 2;
                } else if (!front) {
                  var k1_offset = v_offset + delta - k2;
                  if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
                    var x1 = v1[k1_offset];
                    var y1 = v_offset + x1 - k1_offset;
                    x22 = text1_length - x22;
                    if (x1 >= x22) {
                      return diff_bisectSplit_(text1, text2, x1, y1);
                    }
                  }
                }
              }
            }
            return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
          }
          function diff_bisectSplit_(text1, text2, x2, y) {
            var text1a = text1.substring(0, x2);
            var text2a = text2.substring(0, y);
            var text1b = text1.substring(x2);
            var text2b = text2.substring(y);
            var diffs = diff_main(text1a, text2a);
            var diffsb = diff_main(text1b, text2b);
            return diffs.concat(diffsb);
          }
          function diff_commonPrefix(text1, text2) {
            if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
              return 0;
            }
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerstart = 0;
            while (pointermin < pointermid) {
              if (text1.substring(pointerstart, pointermid) == text2.substring(pointerstart, pointermid)) {
                pointermin = pointermid;
                pointerstart = pointermin;
              } else {
                pointermax = pointermid;
              }
              pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
          }
          function diff_commonSuffix(text1, text2) {
            if (!text1 || !text2 || text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
              return 0;
            }
            var pointermin = 0;
            var pointermax = Math.min(text1.length, text2.length);
            var pointermid = pointermax;
            var pointerend = 0;
            while (pointermin < pointermid) {
              if (text1.substring(text1.length - pointermid, text1.length - pointerend) == text2.substring(text2.length - pointermid, text2.length - pointerend)) {
                pointermin = pointermid;
                pointerend = pointermin;
              } else {
                pointermax = pointermid;
              }
              pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
            }
            return pointermid;
          }
          function diff_halfMatch_(text1, text2) {
            var longtext = text1.length > text2.length ? text1 : text2;
            var shorttext = text1.length > text2.length ? text2 : text1;
            if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
              return null;
            }
            function diff_halfMatchI_(longtext2, shorttext2, i) {
              var seed = longtext2.substring(i, i + Math.floor(longtext2.length / 4));
              var j = -1;
              var best_common = "";
              var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
              while ((j = shorttext2.indexOf(seed, j + 1)) != -1) {
                var prefixLength = diff_commonPrefix(
                  longtext2.substring(i),
                  shorttext2.substring(j)
                );
                var suffixLength = diff_commonSuffix(
                  longtext2.substring(0, i),
                  shorttext2.substring(0, j)
                );
                if (best_common.length < suffixLength + prefixLength) {
                  best_common = shorttext2.substring(j - suffixLength, j) + shorttext2.substring(j, j + prefixLength);
                  best_longtext_a = longtext2.substring(0, i - suffixLength);
                  best_longtext_b = longtext2.substring(i + prefixLength);
                  best_shorttext_a = shorttext2.substring(0, j - suffixLength);
                  best_shorttext_b = shorttext2.substring(j + prefixLength);
                }
              }
              if (best_common.length * 2 >= longtext2.length) {
                return [
                  best_longtext_a,
                  best_longtext_b,
                  best_shorttext_a,
                  best_shorttext_b,
                  best_common
                ];
              } else {
                return null;
              }
            }
            var hm1 = diff_halfMatchI_(
              longtext,
              shorttext,
              Math.ceil(longtext.length / 4)
            );
            var hm2 = diff_halfMatchI_(
              longtext,
              shorttext,
              Math.ceil(longtext.length / 2)
            );
            var hm;
            if (!hm1 && !hm2) {
              return null;
            } else if (!hm2) {
              hm = hm1;
            } else if (!hm1) {
              hm = hm2;
            } else {
              hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
            }
            var text1_a, text1_b, text2_a, text2_b;
            if (text1.length > text2.length) {
              text1_a = hm[0];
              text1_b = hm[1];
              text2_a = hm[2];
              text2_b = hm[3];
            } else {
              text2_a = hm[0];
              text2_b = hm[1];
              text1_a = hm[2];
              text1_b = hm[3];
            }
            var mid_common = hm[4];
            return [text1_a, text1_b, text2_a, text2_b, mid_common];
          }
          function diff_cleanupMerge(diffs) {
            diffs.push([DIFF_EQUAL, ""]);
            var pointer = 0;
            var count_delete = 0;
            var count_insert = 0;
            var text_delete = "";
            var text_insert = "";
            var commonlength;
            while (pointer < diffs.length) {
              switch (diffs[pointer][0]) {
                case DIFF_INSERT:
                  count_insert++;
                  text_insert += diffs[pointer][1];
                  pointer++;
                  break;
                case DIFF_DELETE:
                  count_delete++;
                  text_delete += diffs[pointer][1];
                  pointer++;
                  break;
                case DIFF_EQUAL:
                  if (count_delete + count_insert > 1) {
                    if (count_delete !== 0 && count_insert !== 0) {
                      commonlength = diff_commonPrefix(text_insert, text_delete);
                      if (commonlength !== 0) {
                        if (pointer - count_delete - count_insert > 0 && diffs[pointer - count_delete - count_insert - 1][0] == DIFF_EQUAL) {
                          diffs[pointer - count_delete - count_insert - 1][1] += text_insert.substring(0, commonlength);
                        } else {
                          diffs.splice(0, 0, [
                            DIFF_EQUAL,
                            text_insert.substring(0, commonlength)
                          ]);
                          pointer++;
                        }
                        text_insert = text_insert.substring(commonlength);
                        text_delete = text_delete.substring(commonlength);
                      }
                      commonlength = diff_commonSuffix(text_insert, text_delete);
                      if (commonlength !== 0) {
                        diffs[pointer][1] = text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
                        text_insert = text_insert.substring(0, text_insert.length - commonlength);
                        text_delete = text_delete.substring(0, text_delete.length - commonlength);
                      }
                    }
                    if (count_delete === 0) {
                      diffs.splice(
                        pointer - count_insert,
                        count_delete + count_insert,
                        [DIFF_INSERT, text_insert]
                      );
                    } else if (count_insert === 0) {
                      diffs.splice(
                        pointer - count_delete,
                        count_delete + count_insert,
                        [DIFF_DELETE, text_delete]
                      );
                    } else {
                      diffs.splice(
                        pointer - count_delete - count_insert,
                        count_delete + count_insert,
                        [DIFF_DELETE, text_delete],
                        [DIFF_INSERT, text_insert]
                      );
                    }
                    pointer = pointer - count_delete - count_insert + (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
                  } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
                    diffs[pointer - 1][1] += diffs[pointer][1];
                    diffs.splice(pointer, 1);
                  } else {
                    pointer++;
                  }
                  count_insert = 0;
                  count_delete = 0;
                  text_delete = "";
                  text_insert = "";
                  break;
              }
            }
            if (diffs[diffs.length - 1][1] === "") {
              diffs.pop();
            }
            var changes = false;
            pointer = 1;
            while (pointer < diffs.length - 1) {
              if (diffs[pointer - 1][0] == DIFF_EQUAL && diffs[pointer + 1][0] == DIFF_EQUAL) {
                if (diffs[pointer][1].substring(diffs[pointer][1].length - diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
                  diffs[pointer][1] = diffs[pointer - 1][1] + diffs[pointer][1].substring(0, diffs[pointer][1].length - diffs[pointer - 1][1].length);
                  diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
                  diffs.splice(pointer - 1, 1);
                  changes = true;
                } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) == diffs[pointer + 1][1]) {
                  diffs[pointer - 1][1] += diffs[pointer + 1][1];
                  diffs[pointer][1] = diffs[pointer][1].substring(diffs[pointer + 1][1].length) + diffs[pointer + 1][1];
                  diffs.splice(pointer + 1, 1);
                  changes = true;
                }
              }
              pointer++;
            }
            if (changes) {
              diff_cleanupMerge(diffs);
            }
          }
          var diff = diff_main;
          diff.INSERT = DIFF_INSERT;
          diff.DELETE = DIFF_DELETE;
          diff.EQUAL = DIFF_EQUAL;
          module2.exports = diff;
          function cursor_normalize_diff(diffs, cursor_pos) {
            if (cursor_pos === 0) {
              return [DIFF_EQUAL, diffs];
            }
            for (var current_pos = 0, i = 0; i < diffs.length; i++) {
              var d = diffs[i];
              if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
                var next_pos = current_pos + d[1].length;
                if (cursor_pos === next_pos) {
                  return [i + 1, diffs];
                } else if (cursor_pos < next_pos) {
                  diffs = diffs.slice();
                  var split_pos = cursor_pos - current_pos;
                  var d_left = [d[0], d[1].slice(0, split_pos)];
                  var d_right = [d[0], d[1].slice(split_pos)];
                  diffs.splice(i, 1, d_left, d_right);
                  return [i + 1, diffs];
                } else {
                  current_pos = next_pos;
                }
              }
            }
            throw new Error("cursor_pos is out of bounds!");
          }
          function fix_cursor(diffs, cursor_pos) {
            var norm = cursor_normalize_diff(diffs, cursor_pos);
            var ndiffs = norm[1];
            var cursor_pointer = norm[0];
            var d = ndiffs[cursor_pointer];
            var d_next = ndiffs[cursor_pointer + 1];
            if (d == null) {
              return diffs;
            } else if (d[0] !== DIFF_EQUAL) {
              return diffs;
            } else {
              if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
                ndiffs.splice(cursor_pointer, 2, d_next, d);
                return merge_tuples(ndiffs, cursor_pointer, 2);
              } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
                ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
                var suffix = d_next[1].slice(d[1].length);
                if (suffix.length > 0) {
                  ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
                }
                return merge_tuples(ndiffs, cursor_pointer, 3);
              } else {
                return diffs;
              }
            }
          }
          function fix_emoji(diffs) {
            var compact = false;
            var starts_with_pair_end = function(str) {
              return str.charCodeAt(0) >= 56320 && str.charCodeAt(0) <= 57343;
            };
            var ends_with_pair_start = function(str) {
              return str.charCodeAt(str.length - 1) >= 55296 && str.charCodeAt(str.length - 1) <= 56319;
            };
            for (var i = 2; i < diffs.length; i += 1) {
              if (diffs[i - 2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i - 2][1]) && diffs[i - 1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i - 1][1]) && diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
                compact = true;
                diffs[i - 1][1] = diffs[i - 2][1].slice(-1) + diffs[i - 1][1];
                diffs[i][1] = diffs[i - 2][1].slice(-1) + diffs[i][1];
                diffs[i - 2][1] = diffs[i - 2][1].slice(0, -1);
              }
            }
            if (!compact) {
              return diffs;
            }
            var fixed_diffs = [];
            for (var i = 0; i < diffs.length; i += 1) {
              if (diffs[i][1].length > 0) {
                fixed_diffs.push(diffs[i]);
              }
            }
            return fixed_diffs;
          }
          function merge_tuples(diffs, start, length) {
            for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
              if (i + 1 < diffs.length) {
                var left_d = diffs[i];
                var right_d = diffs[i + 1];
                if (left_d[0] === right_d[1]) {
                  diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
                }
              }
            }
            return diffs;
          }
        },
        /* 52 */
        /***/
        function(module2, exports2) {
          exports2 = module2.exports = typeof Object.keys === "function" ? Object.keys : shim;
          exports2.shim = shim;
          function shim(obj) {
            var keys2 = [];
            for (var key in obj)
              keys2.push(key);
            return keys2;
          }
        },
        /* 53 */
        /***/
        function(module2, exports2) {
          var supportsArgumentsClass = function() {
            return Object.prototype.toString.call(arguments);
          }() == "[object Arguments]";
          exports2 = module2.exports = supportsArgumentsClass ? supported : unsupported;
          exports2.supported = supported;
          function supported(object) {
            return Object.prototype.toString.call(object) == "[object Arguments]";
          }
          exports2.unsupported = unsupported;
          function unsupported(object) {
            return object && typeof object == "object" && typeof object.length == "number" && Object.prototype.hasOwnProperty.call(object, "callee") && !Object.prototype.propertyIsEnumerable.call(object, "callee") || false;
          }
        },
        /* 54 */
        /***/
        function(module2, exports2) {
          var has = Object.prototype.hasOwnProperty, prefix = "~";
          function Events() {
          }
          if (Object.create) {
            Events.prototype = /* @__PURE__ */ Object.create(null);
            if (!new Events().__proto__)
              prefix = false;
          }
          function EE(fn2, context, once) {
            this.fn = fn2;
            this.context = context;
            this.once = once || false;
          }
          function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
          }
          EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0)
              return names;
            for (name in events = this._events) {
              if (has.call(events, name))
                names.push(prefix ? name.slice(1) : name);
            }
            if (Object.getOwnPropertySymbols) {
              return names.concat(Object.getOwnPropertySymbols(events));
            }
            return names;
          };
          EventEmitter.prototype.listeners = function listeners(event, exists) {
            var evt = prefix ? prefix + event : event, available = this._events[evt];
            if (exists)
              return !!available;
            if (!available)
              return [];
            if (available.fn)
              return [available.fn];
            for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
              ee[i] = available[i].fn;
            }
            return ee;
          };
          EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
              if (listeners.once)
                this.removeListener(event, listeners.fn, void 0, true);
              switch (len) {
                case 1:
                  return listeners.fn.call(listeners.context), true;
                case 2:
                  return listeners.fn.call(listeners.context, a1), true;
                case 3:
                  return listeners.fn.call(listeners.context, a1, a2), true;
                case 4:
                  return listeners.fn.call(listeners.context, a1, a2, a3), true;
                case 5:
                  return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                case 6:
                  return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
              }
              for (i = 1, args = new Array(len - 1); i < len; i++) {
                args[i - 1] = arguments[i];
              }
              listeners.fn.apply(listeners.context, args);
            } else {
              var length = listeners.length, j;
              for (i = 0; i < length; i++) {
                if (listeners[i].once)
                  this.removeListener(event, listeners[i].fn, void 0, true);
                switch (len) {
                  case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                  case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                  case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                  case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                  default:
                    if (!args)
                      for (j = 1, args = new Array(len - 1); j < len; j++) {
                        args[j - 1] = arguments[j];
                      }
                    listeners[i].fn.apply(listeners[i].context, args);
                }
              }
            }
            return true;
          };
          EventEmitter.prototype.on = function on2(event, fn2, context) {
            var listener = new EE(fn2, context || this), evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              this._events[evt] = listener, this._eventsCount++;
            else if (!this._events[evt].fn)
              this._events[evt].push(listener);
            else
              this._events[evt] = [this._events[evt], listener];
            return this;
          };
          EventEmitter.prototype.once = function once(event, fn2, context) {
            var listener = new EE(fn2, context || this, true), evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              this._events[evt] = listener, this._eventsCount++;
            else if (!this._events[evt].fn)
              this._events[evt].push(listener);
            else
              this._events[evt] = [this._events[evt], listener];
            return this;
          };
          EventEmitter.prototype.removeListener = function removeListener(event, fn2, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt])
              return this;
            if (!fn2) {
              if (--this._eventsCount === 0)
                this._events = new Events();
              else
                delete this._events[evt];
              return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
              if (listeners.fn === fn2 && (!once || listeners.once) && (!context || listeners.context === context)) {
                if (--this._eventsCount === 0)
                  this._events = new Events();
                else
                  delete this._events[evt];
              }
            } else {
              for (var i = 0, events = [], length = listeners.length; i < length; i++) {
                if (listeners[i].fn !== fn2 || once && !listeners[i].once || context && listeners[i].context !== context) {
                  events.push(listeners[i]);
                }
              }
              if (events.length)
                this._events[evt] = events.length === 1 ? events[0] : events;
              else if (--this._eventsCount === 0)
                this._events = new Events();
              else
                delete this._events[evt];
            }
            return this;
          };
          EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
              evt = prefix ? prefix + event : event;
              if (this._events[evt]) {
                if (--this._eventsCount === 0)
                  this._events = new Events();
                else
                  delete this._events[evt];
              }
            } else {
              this._events = new Events();
              this._eventsCount = 0;
            }
            return this;
          };
          EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
          EventEmitter.prototype.addListener = EventEmitter.prototype.on;
          EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
            return this;
          };
          EventEmitter.prefixed = prefix;
          EventEmitter.EventEmitter = EventEmitter;
          if ("undefined" !== typeof module2) {
            module2.exports = EventEmitter;
          }
        },
        /* 55 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.matchText = exports2.matchSpacing = exports2.matchNewline = exports2.matchBlot = exports2.matchAttributor = exports2.default = void 0;
          var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
            return typeof obj;
          } : function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
          };
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend2 = __webpack_require__(3);
          var _extend3 = _interopRequireDefault(_extend2);
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _align = __webpack_require__(36);
          var _background = __webpack_require__(37);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _color = __webpack_require__(26);
          var _direction = __webpack_require__(38);
          var _font = __webpack_require__(39);
          var _size = __webpack_require__(40);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:clipboard");
          var DOM_KEY = "__ql-matcher";
          var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ["br", matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ["li", matchIndent], ["b", matchAlias.bind(matchAlias, "bold")], ["i", matchAlias.bind(matchAlias, "italic")], ["style", matchIgnore]];
          var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function(memo, attr) {
            memo[attr.keyName] = attr;
            return memo;
          }, {});
          var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function(memo, attr) {
            memo[attr.keyName] = attr;
            return memo;
          }, {});
          var Clipboard = function(_Module) {
            _inherits(Clipboard2, _Module);
            function Clipboard2(quill2, options) {
              _classCallCheck(this, Clipboard2);
              var _this = _possibleConstructorReturn(this, (Clipboard2.__proto__ || Object.getPrototypeOf(Clipboard2)).call(this, quill2, options));
              _this.quill.root.addEventListener("paste", _this.onPaste.bind(_this));
              _this.container = _this.quill.addContainer("ql-clipboard");
              _this.container.setAttribute("contenteditable", true);
              _this.container.setAttribute("tabindex", -1);
              _this.matchers = [];
              CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), selector = _ref2[0], matcher = _ref2[1];
                if (!options.matchVisual && matcher === matchSpacing)
                  return;
                _this.addMatcher(selector, matcher);
              });
              return _this;
            }
            _createClass(Clipboard2, [{
              key: "addMatcher",
              value: function addMatcher(selector, matcher) {
                this.matchers.push([selector, matcher]);
              }
            }, {
              key: "convert",
              value: function convert(html) {
                if (typeof html === "string") {
                  this.container.innerHTML = html.replace(/\>\r?\n +\</g, "><");
                  return this.convert();
                }
                var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
                if (formats[_code2.default.blotName]) {
                  var text = this.container.innerText;
                  this.container.innerHTML = "";
                  return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
                }
                var _prepareMatching = this.prepareMatching(), _prepareMatching2 = _slicedToArray(_prepareMatching, 2), elementMatchers = _prepareMatching2[0], textMatchers = _prepareMatching2[1];
                var delta = traverse(this.container, elementMatchers, textMatchers);
                if (deltaEndsWith(delta, "\n") && delta.ops[delta.ops.length - 1].attributes == null) {
                  delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
                }
                debug.log("convert", this.container.innerHTML, delta);
                this.container.innerHTML = "";
                return delta;
              }
            }, {
              key: "dangerouslyPasteHTML",
              value: function dangerouslyPasteHTML(index, html) {
                var source = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _quill2.default.sources.API;
                if (typeof index === "string") {
                  this.quill.setContents(this.convert(index), html);
                  this.quill.setSelection(0, _quill2.default.sources.SILENT);
                } else {
                  var paste = this.convert(html);
                  this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
                  this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
                }
              }
            }, {
              key: "onPaste",
              value: function onPaste(e) {
                var _this2 = this;
                if (e.defaultPrevented || !this.quill.isEnabled())
                  return;
                var range = this.quill.getSelection();
                var delta = new _quillDelta2.default().retain(range.index);
                var scrollTop = this.quill.scrollingContainer.scrollTop;
                this.container.focus();
                this.quill.selection.update(_quill2.default.sources.SILENT);
                setTimeout(function() {
                  delta = delta.concat(_this2.convert()).delete(range.length);
                  _this2.quill.updateContents(delta, _quill2.default.sources.USER);
                  _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
                  _this2.quill.scrollingContainer.scrollTop = scrollTop;
                  _this2.quill.focus();
                }, 1);
              }
            }, {
              key: "prepareMatching",
              value: function prepareMatching() {
                var _this3 = this;
                var elementMatchers = [], textMatchers = [];
                this.matchers.forEach(function(pair) {
                  var _pair = _slicedToArray(pair, 2), selector = _pair[0], matcher = _pair[1];
                  switch (selector) {
                    case Node.TEXT_NODE:
                      textMatchers.push(matcher);
                      break;
                    case Node.ELEMENT_NODE:
                      elementMatchers.push(matcher);
                      break;
                    default:
                      [].forEach.call(_this3.container.querySelectorAll(selector), function(node) {
                        node[DOM_KEY] = node[DOM_KEY] || [];
                        node[DOM_KEY].push(matcher);
                      });
                      break;
                  }
                });
                return [elementMatchers, textMatchers];
              }
            }]);
            return Clipboard2;
          }(_module2.default);
          Clipboard.DEFAULTS = {
            matchers: [],
            matchVisual: true
          };
          function applyFormat(delta, format, value) {
            if ((typeof format === "undefined" ? "undefined" : _typeof(format)) === "object") {
              return Object.keys(format).reduce(function(delta2, key) {
                return applyFormat(delta2, key, format[key]);
              }, delta);
            } else {
              return delta.reduce(function(delta2, op) {
                if (op.attributes && op.attributes[format]) {
                  return delta2.push(op);
                } else {
                  return delta2.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
                }
              }, new _quillDelta2.default());
            }
          }
          function computeStyle(node) {
            if (node.nodeType !== Node.ELEMENT_NODE)
              return {};
            var DOM_KEY2 = "__ql-computed-style";
            return node[DOM_KEY2] || (node[DOM_KEY2] = window.getComputedStyle(node));
          }
          function deltaEndsWith(delta, text) {
            var endText = "";
            for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
              var op = delta.ops[i];
              if (typeof op.insert !== "string")
                break;
              endText = op.insert + endText;
            }
            return endText.slice(-1 * text.length) === text;
          }
          function isLine(node) {
            if (node.childNodes.length === 0)
              return false;
            var style = computeStyle(node);
            return ["block", "list-item"].indexOf(style.display) > -1;
          }
          function traverse(node, elementMatchers, textMatchers) {
            if (node.nodeType === node.TEXT_NODE) {
              return textMatchers.reduce(function(delta, matcher) {
                return matcher(node, delta);
              }, new _quillDelta2.default());
            } else if (node.nodeType === node.ELEMENT_NODE) {
              return [].reduce.call(node.childNodes || [], function(delta, childNode) {
                var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
                if (childNode.nodeType === node.ELEMENT_NODE) {
                  childrenDelta = elementMatchers.reduce(function(childrenDelta2, matcher) {
                    return matcher(childNode, childrenDelta2);
                  }, childrenDelta);
                  childrenDelta = (childNode[DOM_KEY] || []).reduce(function(childrenDelta2, matcher) {
                    return matcher(childNode, childrenDelta2);
                  }, childrenDelta);
                }
                return delta.concat(childrenDelta);
              }, new _quillDelta2.default());
            } else {
              return new _quillDelta2.default();
            }
          }
          function matchAlias(format, node, delta) {
            return applyFormat(delta, format, true);
          }
          function matchAttributor(node, delta) {
            var attributes = _parchment2.default.Attributor.Attribute.keys(node);
            var classes = _parchment2.default.Attributor.Class.keys(node);
            var styles2 = _parchment2.default.Attributor.Style.keys(node);
            var formats = {};
            attributes.concat(classes).concat(styles2).forEach(function(name) {
              var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
              if (attr != null) {
                formats[attr.attrName] = attr.value(node);
                if (formats[attr.attrName])
                  return;
              }
              attr = ATTRIBUTE_ATTRIBUTORS[name];
              if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                formats[attr.attrName] = attr.value(node) || void 0;
              }
              attr = STYLE_ATTRIBUTORS[name];
              if (attr != null && (attr.attrName === name || attr.keyName === name)) {
                attr = STYLE_ATTRIBUTORS[name];
                formats[attr.attrName] = attr.value(node) || void 0;
              }
            });
            if (Object.keys(formats).length > 0) {
              delta = applyFormat(delta, formats);
            }
            return delta;
          }
          function matchBlot(node, delta) {
            var match = _parchment2.default.query(node);
            if (match == null)
              return delta;
            if (match.prototype instanceof _parchment2.default.Embed) {
              var embed = {};
              var value = match.value(node);
              if (value != null) {
                embed[match.blotName] = value;
                delta = new _quillDelta2.default().insert(embed, match.formats(node));
              }
            } else if (typeof match.formats === "function") {
              delta = applyFormat(delta, match.blotName, match.formats(node));
            }
            return delta;
          }
          function matchBreak(node, delta) {
            if (!deltaEndsWith(delta, "\n")) {
              delta.insert("\n");
            }
            return delta;
          }
          function matchIgnore() {
            return new _quillDelta2.default();
          }
          function matchIndent(node, delta) {
            var match = _parchment2.default.query(node);
            if (match == null || match.blotName !== "list-item" || !deltaEndsWith(delta, "\n")) {
              return delta;
            }
            var indent = -1, parent = node.parentNode;
            while (!parent.classList.contains("ql-clipboard")) {
              if ((_parchment2.default.query(parent) || {}).blotName === "list") {
                indent += 1;
              }
              parent = parent.parentNode;
            }
            if (indent <= 0)
              return delta;
            return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent }));
          }
          function matchNewline(node, delta) {
            if (!deltaEndsWith(delta, "\n")) {
              if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
                delta.insert("\n");
              }
            }
            return delta;
          }
          function matchSpacing(node, delta) {
            if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, "\n\n")) {
              var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
              if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
                delta.insert("\n");
              }
            }
            return delta;
          }
          function matchStyles(node, delta) {
            var formats = {};
            var style = node.style || {};
            if (style.fontStyle && computeStyle(node).fontStyle === "italic") {
              formats.italic = true;
            }
            if (style.fontWeight && (computeStyle(node).fontWeight.startsWith("bold") || parseInt(computeStyle(node).fontWeight) >= 700)) {
              formats.bold = true;
            }
            if (Object.keys(formats).length > 0) {
              delta = applyFormat(delta, formats);
            }
            if (parseFloat(style.textIndent || 0) > 0) {
              delta = new _quillDelta2.default().insert("	").concat(delta);
            }
            return delta;
          }
          function matchText(node, delta) {
            var text = node.data;
            if (node.parentNode.tagName === "O:P") {
              return delta.insert(text.trim());
            }
            if (text.trim().length === 0 && node.parentNode.classList.contains("ql-clipboard")) {
              return delta;
            }
            if (!computeStyle(node.parentNode).whiteSpace.startsWith("pre")) {
              var replacer = function replacer2(collapse, match) {
                match = match.replace(/[^\u00a0]/g, "");
                return match.length < 1 && collapse ? " " : match;
              };
              text = text.replace(/\r\n/g, " ").replace(/\n/g, " ");
              text = text.replace(/\s\s+/g, replacer.bind(replacer, true));
              if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
                text = text.replace(/^\s+/, replacer.bind(replacer, false));
              }
              if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
                text = text.replace(/\s+$/, replacer.bind(replacer, false));
              }
            }
            return delta.insert(text);
          }
          exports2.default = Clipboard;
          exports2.matchAttributor = matchAttributor;
          exports2.matchBlot = matchBlot;
          exports2.matchNewline = matchNewline;
          exports2.matchSpacing = matchSpacing;
          exports2.matchText = matchText;
        },
        /* 56 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Bold = function(_Inline) {
            _inherits(Bold2, _Inline);
            function Bold2() {
              _classCallCheck(this, Bold2);
              return _possibleConstructorReturn(this, (Bold2.__proto__ || Object.getPrototypeOf(Bold2)).apply(this, arguments));
            }
            _createClass(Bold2, [{
              key: "optimize",
              value: function optimize(context) {
                _get(Bold2.prototype.__proto__ || Object.getPrototypeOf(Bold2.prototype), "optimize", this).call(this, context);
                if (this.domNode.tagName !== this.statics.tagName[0]) {
                  this.replaceWith(this.statics.blotName);
                }
              }
            }], [{
              key: "create",
              value: function create() {
                return _get(Bold2.__proto__ || Object.getPrototypeOf(Bold2), "create", this).call(this);
              }
            }, {
              key: "formats",
              value: function formats() {
                return true;
              }
            }]);
            return Bold2;
          }(_inline2.default);
          Bold.blotName = "bold";
          Bold.tagName = ["STRONG", "B"];
          exports2.default = Bold;
        },
        /* 57 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.addControls = exports2.default = void 0;
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _quillDelta = __webpack_require__(2);
          var _quillDelta2 = _interopRequireDefault(_quillDelta);
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _logger = __webpack_require__(10);
          var _logger2 = _interopRequireDefault(_logger);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var debug = (0, _logger2.default)("quill:toolbar");
          var Toolbar = function(_Module) {
            _inherits(Toolbar2, _Module);
            function Toolbar2(quill2, options) {
              _classCallCheck(this, Toolbar2);
              var _this = _possibleConstructorReturn(this, (Toolbar2.__proto__ || Object.getPrototypeOf(Toolbar2)).call(this, quill2, options));
              if (Array.isArray(_this.options.container)) {
                var container2 = document.createElement("div");
                addControls(container2, _this.options.container);
                quill2.container.parentNode.insertBefore(container2, quill2.container);
                _this.container = container2;
              } else if (typeof _this.options.container === "string") {
                _this.container = document.querySelector(_this.options.container);
              } else {
                _this.container = _this.options.container;
              }
              if (!(_this.container instanceof HTMLElement)) {
                var _ret;
                return _ret = debug.error("Container required for toolbar", _this.options), _possibleConstructorReturn(_this, _ret);
              }
              _this.container.classList.add("ql-toolbar");
              _this.controls = [];
              _this.handlers = {};
              Object.keys(_this.options.handlers).forEach(function(format) {
                _this.addHandler(format, _this.options.handlers[format]);
              });
              [].forEach.call(_this.container.querySelectorAll("button, select"), function(input) {
                _this.attach(input);
              });
              _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function(type, range) {
                if (type === _quill2.default.events.SELECTION_CHANGE) {
                  _this.update(range);
                }
              });
              _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                var _this$quill$selection = _this.quill.selection.getRange(), _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1), range = _this$quill$selection2[0];
                _this.update(range);
              });
              return _this;
            }
            _createClass(Toolbar2, [{
              key: "addHandler",
              value: function addHandler(format, handler) {
                this.handlers[format] = handler;
              }
            }, {
              key: "attach",
              value: function attach(input) {
                var _this2 = this;
                var format = [].find.call(input.classList, function(className) {
                  return className.indexOf("ql-") === 0;
                });
                if (!format)
                  return;
                format = format.slice("ql-".length);
                if (input.tagName === "BUTTON") {
                  input.setAttribute("type", "button");
                }
                if (this.handlers[format] == null) {
                  if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
                    debug.warn("ignoring attaching to disabled format", format, input);
                    return;
                  }
                  if (_parchment2.default.query(format) == null) {
                    debug.warn("ignoring attaching to nonexistent format", format, input);
                    return;
                  }
                }
                var eventName = input.tagName === "SELECT" ? "change" : "click";
                input.addEventListener(eventName, function(e) {
                  var value = void 0;
                  if (input.tagName === "SELECT") {
                    if (input.selectedIndex < 0)
                      return;
                    var selected = input.options[input.selectedIndex];
                    if (selected.hasAttribute("selected")) {
                      value = false;
                    } else {
                      value = selected.value || false;
                    }
                  } else {
                    if (input.classList.contains("ql-active")) {
                      value = false;
                    } else {
                      value = input.value || !input.hasAttribute("value");
                    }
                    e.preventDefault();
                  }
                  _this2.quill.focus();
                  var _quill$selection$getR = _this2.quill.selection.getRange(), _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1), range = _quill$selection$getR2[0];
                  if (_this2.handlers[format] != null) {
                    _this2.handlers[format].call(_this2, value);
                  } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
                    value = prompt("Enter " + format);
                    if (!value)
                      return;
                    _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
                  } else {
                    _this2.quill.format(format, value, _quill2.default.sources.USER);
                  }
                  _this2.update(range);
                });
                this.controls.push([format, input]);
              }
            }, {
              key: "update",
              value: function update(range) {
                var formats = range == null ? {} : this.quill.getFormat(range);
                this.controls.forEach(function(pair) {
                  var _pair = _slicedToArray(pair, 2), format = _pair[0], input = _pair[1];
                  if (input.tagName === "SELECT") {
                    var option = void 0;
                    if (range == null) {
                      option = null;
                    } else if (formats[format] == null) {
                      option = input.querySelector("option[selected]");
                    } else if (!Array.isArray(formats[format])) {
                      var value = formats[format];
                      if (typeof value === "string") {
                        value = value.replace(/\"/g, '\\"');
                      }
                      option = input.querySelector('option[value="' + value + '"]');
                    }
                    if (option == null) {
                      input.value = "";
                      input.selectedIndex = -1;
                    } else {
                      option.selected = true;
                    }
                  } else {
                    if (range == null) {
                      input.classList.remove("ql-active");
                    } else if (input.hasAttribute("value")) {
                      var isActive = formats[format] === input.getAttribute("value") || formats[format] != null && formats[format].toString() === input.getAttribute("value") || formats[format] == null && !input.getAttribute("value");
                      input.classList.toggle("ql-active", isActive);
                    } else {
                      input.classList.toggle("ql-active", formats[format] != null);
                    }
                  }
                });
              }
            }]);
            return Toolbar2;
          }(_module2.default);
          Toolbar.DEFAULTS = {};
          function addButton(container2, format, value) {
            var input = document.createElement("button");
            input.setAttribute("type", "button");
            input.classList.add("ql-" + format);
            if (value != null) {
              input.value = value;
            }
            container2.appendChild(input);
          }
          function addControls(container2, groups) {
            if (!Array.isArray(groups[0])) {
              groups = [groups];
            }
            groups.forEach(function(controls) {
              var group = document.createElement("span");
              group.classList.add("ql-formats");
              controls.forEach(function(control) {
                if (typeof control === "string") {
                  addButton(group, control);
                } else {
                  var format = Object.keys(control)[0];
                  var value = control[format];
                  if (Array.isArray(value)) {
                    addSelect(group, format, value);
                  } else {
                    addButton(group, format, value);
                  }
                }
              });
              container2.appendChild(group);
            });
          }
          function addSelect(container2, format, values) {
            var input = document.createElement("select");
            input.classList.add("ql-" + format);
            values.forEach(function(value) {
              var option = document.createElement("option");
              if (value !== false) {
                option.setAttribute("value", value);
              } else {
                option.setAttribute("selected", "selected");
              }
              input.appendChild(option);
            });
            container2.appendChild(input);
          }
          Toolbar.DEFAULTS = {
            container: null,
            handlers: {
              clean: function clean() {
                var _this3 = this;
                var range = this.quill.getSelection();
                if (range == null)
                  return;
                if (range.length == 0) {
                  var formats = this.quill.getFormat();
                  Object.keys(formats).forEach(function(name) {
                    if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
                      _this3.quill.format(name, false);
                    }
                  });
                } else {
                  this.quill.removeFormat(range, _quill2.default.sources.USER);
                }
              },
              direction: function direction(value) {
                var align = this.quill.getFormat()["align"];
                if (value === "rtl" && align == null) {
                  this.quill.format("align", "right", _quill2.default.sources.USER);
                } else if (!value && align === "right") {
                  this.quill.format("align", false, _quill2.default.sources.USER);
                }
                this.quill.format("direction", value, _quill2.default.sources.USER);
              },
              indent: function indent(value) {
                var range = this.quill.getSelection();
                var formats = this.quill.getFormat(range);
                var indent2 = parseInt(formats.indent || 0);
                if (value === "+1" || value === "-1") {
                  var modifier = value === "+1" ? 1 : -1;
                  if (formats.direction === "rtl")
                    modifier *= -1;
                  this.quill.format("indent", indent2 + modifier, _quill2.default.sources.USER);
                }
              },
              link: function link(value) {
                if (value === true) {
                  value = prompt("Enter link URL:");
                }
                this.quill.format("link", value, _quill2.default.sources.USER);
              },
              list: function list(value) {
                var range = this.quill.getSelection();
                var formats = this.quill.getFormat(range);
                if (value === "check") {
                  if (formats["list"] === "checked" || formats["list"] === "unchecked") {
                    this.quill.format("list", false, _quill2.default.sources.USER);
                  } else {
                    this.quill.format("list", "unchecked", _quill2.default.sources.USER);
                  }
                } else {
                  this.quill.format("list", value, _quill2.default.sources.USER);
                }
              }
            }
          };
          exports2.default = Toolbar;
          exports2.addControls = addControls;
        },
        /* 58 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polyline class="ql-even ql-stroke" points="5 7 3 9 5 11"></polyline> <polyline class="ql-even ql-stroke" points="13 7 15 9 13 11"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>';
        },
        /* 59 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ColorPicker = function(_Picker) {
            _inherits(ColorPicker2, _Picker);
            function ColorPicker2(select, label) {
              _classCallCheck(this, ColorPicker2);
              var _this = _possibleConstructorReturn(this, (ColorPicker2.__proto__ || Object.getPrototypeOf(ColorPicker2)).call(this, select));
              _this.label.innerHTML = label;
              _this.container.classList.add("ql-color-picker");
              [].slice.call(_this.container.querySelectorAll(".ql-picker-item"), 0, 7).forEach(function(item) {
                item.classList.add("ql-primary");
              });
              return _this;
            }
            _createClass(ColorPicker2, [{
              key: "buildItem",
              value: function buildItem(option) {
                var item = _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "buildItem", this).call(this, option);
                item.style.backgroundColor = option.getAttribute("value") || "";
                return item;
              }
            }, {
              key: "selectItem",
              value: function selectItem(item, trigger) {
                _get(ColorPicker2.prototype.__proto__ || Object.getPrototypeOf(ColorPicker2.prototype), "selectItem", this).call(this, item, trigger);
                var colorLabel = this.label.querySelector(".ql-color-label");
                var value = item ? item.getAttribute("data-value") || "" : "";
                if (colorLabel) {
                  if (colorLabel.tagName === "line") {
                    colorLabel.style.stroke = value;
                  } else {
                    colorLabel.style.fill = value;
                  }
                }
              }
            }]);
            return ColorPicker2;
          }(_picker2.default);
          exports2.default = ColorPicker;
        },
        /* 60 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var IconPicker = function(_Picker) {
            _inherits(IconPicker2, _Picker);
            function IconPicker2(select, icons) {
              _classCallCheck(this, IconPicker2);
              var _this = _possibleConstructorReturn(this, (IconPicker2.__proto__ || Object.getPrototypeOf(IconPicker2)).call(this, select));
              _this.container.classList.add("ql-icon-picker");
              [].forEach.call(_this.container.querySelectorAll(".ql-picker-item"), function(item) {
                item.innerHTML = icons[item.getAttribute("data-value") || ""];
              });
              _this.defaultItem = _this.container.querySelector(".ql-selected");
              _this.selectItem(_this.defaultItem);
              return _this;
            }
            _createClass(IconPicker2, [{
              key: "selectItem",
              value: function selectItem(item, trigger) {
                _get(IconPicker2.prototype.__proto__ || Object.getPrototypeOf(IconPicker2.prototype), "selectItem", this).call(this, item, trigger);
                item = item || this.defaultItem;
                this.label.innerHTML = item.innerHTML;
              }
            }]);
            return IconPicker2;
          }(_picker2.default);
          exports2.default = IconPicker;
        },
        /* 61 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          var Tooltip2 = function() {
            function Tooltip22(quill2, boundsContainer) {
              var _this = this;
              _classCallCheck(this, Tooltip22);
              this.quill = quill2;
              this.boundsContainer = boundsContainer || document.body;
              this.root = quill2.addContainer("ql-tooltip");
              this.root.innerHTML = this.constructor.TEMPLATE;
              if (this.quill.root === this.quill.scrollingContainer) {
                this.quill.root.addEventListener("scroll", function() {
                  _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + "px";
                });
              }
              this.hide();
            }
            _createClass(Tooltip22, [{
              key: "hide",
              value: function hide() {
                this.root.classList.add("ql-hidden");
              }
            }, {
              key: "position",
              value: function position(reference) {
                var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
                var top = reference.bottom + this.quill.root.scrollTop;
                this.root.style.left = left + "px";
                this.root.style.top = top + "px";
                this.root.classList.remove("ql-flip");
                var containerBounds = this.boundsContainer.getBoundingClientRect();
                var rootBounds = this.root.getBoundingClientRect();
                var shift = 0;
                if (rootBounds.right > containerBounds.right) {
                  shift = containerBounds.right - rootBounds.right;
                  this.root.style.left = left + shift + "px";
                }
                if (rootBounds.left < containerBounds.left) {
                  shift = containerBounds.left - rootBounds.left;
                  this.root.style.left = left + shift + "px";
                }
                if (rootBounds.bottom > containerBounds.bottom) {
                  var height = rootBounds.bottom - rootBounds.top;
                  var verticalShift = reference.bottom - reference.top + height;
                  this.root.style.top = top - verticalShift + "px";
                  this.root.classList.add("ql-flip");
                }
                return shift;
              }
            }, {
              key: "show",
              value: function show() {
                this.root.classList.remove("ql-editing");
                this.root.classList.remove("ql-hidden");
              }
            }]);
            return Tooltip22;
          }();
          exports2.default = Tooltip2;
        },
        /* 62 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _slicedToArray = /* @__PURE__ */ function() {
            function sliceIterator(arr, i) {
              var _arr = [];
              var _n2 = true;
              var _d = false;
              var _e2 = void 0;
              try {
                for (var _i = arr[Symbol.iterator](), _s; !(_n2 = (_s = _i.next()).done); _n2 = true) {
                  _arr.push(_s.value);
                  if (i && _arr.length === i)
                    break;
                }
              } catch (err) {
                _d = true;
                _e2 = err;
              } finally {
                try {
                  if (!_n2 && _i["return"])
                    _i["return"]();
                } finally {
                  if (_d)
                    throw _e2;
                }
              }
              return _arr;
            }
            return function(arr, i) {
              if (Array.isArray(arr)) {
                return arr;
              } else if (Symbol.iterator in Object(arr)) {
                return sliceIterator(arr, i);
              } else {
                throw new TypeError("Invalid attempt to destructure non-iterable instance");
              }
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _base = __webpack_require__(43);
          var _base2 = _interopRequireDefault(_base);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          var _selection = __webpack_require__(15);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TOOLBAR_CONFIG = [[{ header: ["1", "2", "3", false] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], ["clean"]];
          var SnowTheme = function(_BaseTheme) {
            _inherits(SnowTheme2, _BaseTheme);
            function SnowTheme2(quill2, options) {
              _classCallCheck(this, SnowTheme2);
              if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                options.modules.toolbar.container = TOOLBAR_CONFIG;
              }
              var _this = _possibleConstructorReturn(this, (SnowTheme2.__proto__ || Object.getPrototypeOf(SnowTheme2)).call(this, quill2, options));
              _this.quill.container.classList.add("ql-snow");
              return _this;
            }
            _createClass(SnowTheme2, [{
              key: "extendToolbar",
              value: function extendToolbar(toolbar) {
                toolbar.container.classList.add("ql-snow");
                this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
                this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
                if (toolbar.container.querySelector(".ql-link")) {
                  this.quill.keyboard.addBinding({ key: "K", shortKey: true }, function(range, context) {
                    toolbar.handlers["link"].call(toolbar, !context.format.link);
                  });
                }
              }
            }]);
            return SnowTheme2;
          }(_base2.default);
          SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function link(value) {
                    if (value) {
                      var range = this.quill.getSelection();
                      if (range == null || range.length == 0)
                        return;
                      var preview = this.quill.getText(range);
                      if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf("mailto:") !== 0) {
                        preview = "mailto:" + preview;
                      }
                      var tooltip = this.quill.theme.tooltip;
                      tooltip.edit("link", preview);
                    } else {
                      this.quill.format("link", false);
                    }
                  }
                }
              }
            }
          });
          var SnowTooltip = function(_BaseTooltip) {
            _inherits(SnowTooltip2, _BaseTooltip);
            function SnowTooltip2(quill2, bounds) {
              _classCallCheck(this, SnowTooltip2);
              var _this2 = _possibleConstructorReturn(this, (SnowTooltip2.__proto__ || Object.getPrototypeOf(SnowTooltip2)).call(this, quill2, bounds));
              _this2.preview = _this2.root.querySelector("a.ql-preview");
              return _this2;
            }
            _createClass(SnowTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this3 = this;
                _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "listen", this).call(this);
                this.root.querySelector("a.ql-action").addEventListener("click", function(event) {
                  if (_this3.root.classList.contains("ql-editing")) {
                    _this3.save();
                  } else {
                    _this3.edit("link", _this3.preview.textContent);
                  }
                  event.preventDefault();
                });
                this.root.querySelector("a.ql-remove").addEventListener("click", function(event) {
                  if (_this3.linkRange != null) {
                    var range = _this3.linkRange;
                    _this3.restoreFocus();
                    _this3.quill.formatText(range, "link", false, _emitter2.default.sources.USER);
                    delete _this3.linkRange;
                  }
                  event.preventDefault();
                  _this3.hide();
                });
                this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function(range, oldRange, source) {
                  if (range == null)
                    return;
                  if (range.length === 0 && source === _emitter2.default.sources.USER) {
                    var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index), _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2), link = _quill$scroll$descend2[0], offset = _quill$scroll$descend2[1];
                    if (link != null) {
                      _this3.linkRange = new _selection.Range(range.index - offset, link.length());
                      var preview = _link2.default.formats(link.domNode);
                      _this3.preview.textContent = preview;
                      _this3.preview.setAttribute("href", preview);
                      _this3.show();
                      _this3.position(_this3.quill.getBounds(_this3.linkRange));
                      return;
                    }
                  } else {
                    delete _this3.linkRange;
                  }
                  _this3.hide();
                });
              }
            }, {
              key: "show",
              value: function show() {
                _get(SnowTooltip2.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip2.prototype), "show", this).call(this);
                this.root.removeAttribute("data-mode");
              }
            }]);
            return SnowTooltip2;
          }(_base.BaseTooltip);
          SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join("");
          exports2.default = SnowTheme;
        },
        /* 63 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _core = __webpack_require__(29);
          var _core2 = _interopRequireDefault(_core);
          var _align = __webpack_require__(36);
          var _direction = __webpack_require__(38);
          var _indent = __webpack_require__(64);
          var _blockquote = __webpack_require__(65);
          var _blockquote2 = _interopRequireDefault(_blockquote);
          var _header = __webpack_require__(66);
          var _header2 = _interopRequireDefault(_header);
          var _list = __webpack_require__(67);
          var _list2 = _interopRequireDefault(_list);
          var _background = __webpack_require__(37);
          var _color = __webpack_require__(26);
          var _font = __webpack_require__(39);
          var _size = __webpack_require__(40);
          var _bold = __webpack_require__(56);
          var _bold2 = _interopRequireDefault(_bold);
          var _italic = __webpack_require__(68);
          var _italic2 = _interopRequireDefault(_italic);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          var _script = __webpack_require__(69);
          var _script2 = _interopRequireDefault(_script);
          var _strike = __webpack_require__(70);
          var _strike2 = _interopRequireDefault(_strike);
          var _underline = __webpack_require__(71);
          var _underline2 = _interopRequireDefault(_underline);
          var _image = __webpack_require__(72);
          var _image2 = _interopRequireDefault(_image);
          var _video = __webpack_require__(73);
          var _video2 = _interopRequireDefault(_video);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          var _formula = __webpack_require__(74);
          var _formula2 = _interopRequireDefault(_formula);
          var _syntax = __webpack_require__(75);
          var _syntax2 = _interopRequireDefault(_syntax);
          var _toolbar = __webpack_require__(57);
          var _toolbar2 = _interopRequireDefault(_toolbar);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          var _picker = __webpack_require__(28);
          var _picker2 = _interopRequireDefault(_picker);
          var _colorPicker = __webpack_require__(59);
          var _colorPicker2 = _interopRequireDefault(_colorPicker);
          var _iconPicker = __webpack_require__(60);
          var _iconPicker2 = _interopRequireDefault(_iconPicker);
          var _tooltip = __webpack_require__(61);
          var _tooltip2 = _interopRequireDefault(_tooltip);
          var _bubble = __webpack_require__(108);
          var _bubble2 = _interopRequireDefault(_bubble);
          var _snow = __webpack_require__(62);
          var _snow2 = _interopRequireDefault(_snow);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          _core2.default.register({
            "attributors/attribute/direction": _direction.DirectionAttribute,
            "attributors/class/align": _align.AlignClass,
            "attributors/class/background": _background.BackgroundClass,
            "attributors/class/color": _color.ColorClass,
            "attributors/class/direction": _direction.DirectionClass,
            "attributors/class/font": _font.FontClass,
            "attributors/class/size": _size.SizeClass,
            "attributors/style/align": _align.AlignStyle,
            "attributors/style/background": _background.BackgroundStyle,
            "attributors/style/color": _color.ColorStyle,
            "attributors/style/direction": _direction.DirectionStyle,
            "attributors/style/font": _font.FontStyle,
            "attributors/style/size": _size.SizeStyle
          }, true);
          _core2.default.register({
            "formats/align": _align.AlignClass,
            "formats/direction": _direction.DirectionClass,
            "formats/indent": _indent.IndentClass,
            "formats/background": _background.BackgroundStyle,
            "formats/color": _color.ColorStyle,
            "formats/font": _font.FontClass,
            "formats/size": _size.SizeClass,
            "formats/blockquote": _blockquote2.default,
            "formats/code-block": _code2.default,
            "formats/header": _header2.default,
            "formats/list": _list2.default,
            "formats/bold": _bold2.default,
            "formats/code": _code.Code,
            "formats/italic": _italic2.default,
            "formats/link": _link2.default,
            "formats/script": _script2.default,
            "formats/strike": _strike2.default,
            "formats/underline": _underline2.default,
            "formats/image": _image2.default,
            "formats/video": _video2.default,
            "formats/list/item": _list.ListItem,
            "modules/formula": _formula2.default,
            "modules/syntax": _syntax2.default,
            "modules/toolbar": _toolbar2.default,
            "themes/bubble": _bubble2.default,
            "themes/snow": _snow2.default,
            "ui/icons": _icons2.default,
            "ui/picker": _picker2.default,
            "ui/icon-picker": _iconPicker2.default,
            "ui/color-picker": _colorPicker2.default,
            "ui/tooltip": _tooltip2.default
          }, true);
          exports2.default = _core2.default;
        },
        /* 64 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.IndentClass = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var IdentAttributor = function(_Parchment$Attributor) {
            _inherits(IdentAttributor2, _Parchment$Attributor);
            function IdentAttributor2() {
              _classCallCheck(this, IdentAttributor2);
              return _possibleConstructorReturn(this, (IdentAttributor2.__proto__ || Object.getPrototypeOf(IdentAttributor2)).apply(this, arguments));
            }
            _createClass(IdentAttributor2, [{
              key: "add",
              value: function add(node, value) {
                if (value === "+1" || value === "-1") {
                  var indent = this.value(node) || 0;
                  value = value === "+1" ? indent + 1 : indent - 1;
                }
                if (value === 0) {
                  this.remove(node);
                  return true;
                } else {
                  return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "add", this).call(this, node, value);
                }
              }
            }, {
              key: "canAdd",
              value: function canAdd(node, value) {
                return _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node, value) || _get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "canAdd", this).call(this, node, parseInt(value));
              }
            }, {
              key: "value",
              value: function value(node) {
                return parseInt(_get(IdentAttributor2.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor2.prototype), "value", this).call(this, node)) || void 0;
              }
            }]);
            return IdentAttributor2;
          }(_parchment2.default.Attributor.Class);
          var IndentClass = new IdentAttributor("indent", "ql-indent", {
            scope: _parchment2.default.Scope.BLOCK,
            whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
          });
          exports2.IndentClass = IndentClass;
        },
        /* 65 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Blockquote = function(_Block) {
            _inherits(Blockquote2, _Block);
            function Blockquote2() {
              _classCallCheck(this, Blockquote2);
              return _possibleConstructorReturn(this, (Blockquote2.__proto__ || Object.getPrototypeOf(Blockquote2)).apply(this, arguments));
            }
            return Blockquote2;
          }(_block2.default);
          Blockquote.blotName = "blockquote";
          Blockquote.tagName = "blockquote";
          exports2.default = Blockquote;
        },
        /* 66 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Header = function(_Block) {
            _inherits(Header2, _Block);
            function Header2() {
              _classCallCheck(this, Header2);
              return _possibleConstructorReturn(this, (Header2.__proto__ || Object.getPrototypeOf(Header2)).apply(this, arguments));
            }
            _createClass(Header2, null, [{
              key: "formats",
              value: function formats(domNode) {
                return this.tagName.indexOf(domNode.tagName) + 1;
              }
            }]);
            return Header2;
          }(_block2.default);
          Header.blotName = "header";
          Header.tagName = ["H1", "H2", "H3", "H4", "H5", "H6"];
          exports2.default = Header;
        },
        /* 67 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.ListItem = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _block = __webpack_require__(4);
          var _block2 = _interopRequireDefault(_block);
          var _container = __webpack_require__(25);
          var _container2 = _interopRequireDefault(_container);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _defineProperty(obj, key, value) {
            if (key in obj) {
              Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
            } else {
              obj[key] = value;
            }
            return obj;
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ListItem = function(_Block) {
            _inherits(ListItem2, _Block);
            function ListItem2() {
              _classCallCheck(this, ListItem2);
              return _possibleConstructorReturn(this, (ListItem2.__proto__ || Object.getPrototypeOf(ListItem2)).apply(this, arguments));
            }
            _createClass(ListItem2, [{
              key: "format",
              value: function format(name, value) {
                if (name === List.blotName && !value) {
                  this.replaceWith(_parchment2.default.create(this.statics.scope));
                } else {
                  _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "format", this).call(this, name, value);
                }
              }
            }, {
              key: "remove",
              value: function remove() {
                if (this.prev == null && this.next == null) {
                  this.parent.remove();
                } else {
                  _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "remove", this).call(this);
                }
              }
            }, {
              key: "replaceWith",
              value: function replaceWith(name, value) {
                this.parent.isolate(this.offset(this.parent), this.length());
                if (name === this.parent.statics.blotName) {
                  this.parent.replaceWith(name, value);
                  return this;
                } else {
                  this.parent.unwrap();
                  return _get(ListItem2.prototype.__proto__ || Object.getPrototypeOf(ListItem2.prototype), "replaceWith", this).call(this, name, value);
                }
              }
            }], [{
              key: "formats",
              value: function formats(domNode) {
                return domNode.tagName === this.tagName ? void 0 : _get(ListItem2.__proto__ || Object.getPrototypeOf(ListItem2), "formats", this).call(this, domNode);
              }
            }]);
            return ListItem2;
          }(_block2.default);
          ListItem.blotName = "list-item";
          ListItem.tagName = "LI";
          var List = function(_Container) {
            _inherits(List2, _Container);
            _createClass(List2, null, [{
              key: "create",
              value: function create(value) {
                var tagName = value === "ordered" ? "OL" : "UL";
                var node = _get(List2.__proto__ || Object.getPrototypeOf(List2), "create", this).call(this, tagName);
                if (value === "checked" || value === "unchecked") {
                  node.setAttribute("data-checked", value === "checked");
                }
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                if (domNode.tagName === "OL")
                  return "ordered";
                if (domNode.tagName === "UL") {
                  if (domNode.hasAttribute("data-checked")) {
                    return domNode.getAttribute("data-checked") === "true" ? "checked" : "unchecked";
                  } else {
                    return "bullet";
                  }
                }
                return void 0;
              }
            }]);
            function List2(domNode) {
              _classCallCheck(this, List2);
              var _this2 = _possibleConstructorReturn(this, (List2.__proto__ || Object.getPrototypeOf(List2)).call(this, domNode));
              var listEventHandler = function listEventHandler2(e) {
                if (e.target.parentNode !== domNode)
                  return;
                var format = _this2.statics.formats(domNode);
                var blot = _parchment2.default.find(e.target);
                if (format === "checked") {
                  blot.format("list", "unchecked");
                } else if (format === "unchecked") {
                  blot.format("list", "checked");
                }
              };
              domNode.addEventListener("touchstart", listEventHandler);
              domNode.addEventListener("mousedown", listEventHandler);
              return _this2;
            }
            _createClass(List2, [{
              key: "format",
              value: function format(name, value) {
                if (this.children.length > 0) {
                  this.children.tail.format(name, value);
                }
              }
            }, {
              key: "formats",
              value: function formats() {
                return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
              }
            }, {
              key: "insertBefore",
              value: function insertBefore(blot, ref) {
                if (blot instanceof ListItem) {
                  _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "insertBefore", this).call(this, blot, ref);
                } else {
                  var index = ref == null ? this.length() : ref.offset(this);
                  var after = this.split(index);
                  after.parent.insertBefore(blot, after);
                }
              }
            }, {
              key: "optimize",
              value: function optimize(context) {
                _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "optimize", this).call(this, context);
                var next = this.next;
                if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute("data-checked") === this.domNode.getAttribute("data-checked")) {
                  next.moveChildren(this);
                  next.remove();
                }
              }
            }, {
              key: "replace",
              value: function replace(target) {
                if (target.statics.blotName !== this.statics.blotName) {
                  var item = _parchment2.default.create(this.statics.defaultChild);
                  target.moveChildren(item);
                  this.appendChild(item);
                }
                _get(List2.prototype.__proto__ || Object.getPrototypeOf(List2.prototype), "replace", this).call(this, target);
              }
            }]);
            return List2;
          }(_container2.default);
          List.blotName = "list";
          List.scope = _parchment2.default.Scope.BLOCK_BLOT;
          List.tagName = ["OL", "UL"];
          List.defaultChild = "list-item";
          List.allowedChildren = [ListItem];
          exports2.ListItem = ListItem;
          exports2.default = List;
        },
        /* 68 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _bold = __webpack_require__(56);
          var _bold2 = _interopRequireDefault(_bold);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Italic = function(_Bold) {
            _inherits(Italic2, _Bold);
            function Italic2() {
              _classCallCheck(this, Italic2);
              return _possibleConstructorReturn(this, (Italic2.__proto__ || Object.getPrototypeOf(Italic2)).apply(this, arguments));
            }
            return Italic2;
          }(_bold2.default);
          Italic.blotName = "italic";
          Italic.tagName = ["EM", "I"];
          exports2.default = Italic;
        },
        /* 69 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Script = function(_Inline) {
            _inherits(Script2, _Inline);
            function Script2() {
              _classCallCheck(this, Script2);
              return _possibleConstructorReturn(this, (Script2.__proto__ || Object.getPrototypeOf(Script2)).apply(this, arguments));
            }
            _createClass(Script2, null, [{
              key: "create",
              value: function create(value) {
                if (value === "super") {
                  return document.createElement("sup");
                } else if (value === "sub") {
                  return document.createElement("sub");
                } else {
                  return _get(Script2.__proto__ || Object.getPrototypeOf(Script2), "create", this).call(this, value);
                }
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                if (domNode.tagName === "SUB")
                  return "sub";
                if (domNode.tagName === "SUP")
                  return "super";
                return void 0;
              }
            }]);
            return Script2;
          }(_inline2.default);
          Script.blotName = "script";
          Script.tagName = ["SUB", "SUP"];
          exports2.default = Script;
        },
        /* 70 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Strike = function(_Inline) {
            _inherits(Strike2, _Inline);
            function Strike2() {
              _classCallCheck(this, Strike2);
              return _possibleConstructorReturn(this, (Strike2.__proto__ || Object.getPrototypeOf(Strike2)).apply(this, arguments));
            }
            return Strike2;
          }(_inline2.default);
          Strike.blotName = "strike";
          Strike.tagName = "S";
          exports2.default = Strike;
        },
        /* 71 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _inline = __webpack_require__(6);
          var _inline2 = _interopRequireDefault(_inline);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var Underline = function(_Inline) {
            _inherits(Underline2, _Inline);
            function Underline2() {
              _classCallCheck(this, Underline2);
              return _possibleConstructorReturn(this, (Underline2.__proto__ || Object.getPrototypeOf(Underline2)).apply(this, arguments));
            }
            return Underline2;
          }(_inline2.default);
          Underline.blotName = "underline";
          Underline.tagName = "U";
          exports2.default = Underline;
        },
        /* 72 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _link = __webpack_require__(27);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ATTRIBUTES = ["alt", "height", "width"];
          var Image = function(_Parchment$Embed) {
            _inherits(Image2, _Parchment$Embed);
            function Image2() {
              _classCallCheck(this, Image2);
              return _possibleConstructorReturn(this, (Image2.__proto__ || Object.getPrototypeOf(Image2)).apply(this, arguments));
            }
            _createClass(Image2, [{
              key: "format",
              value: function format(name, value) {
                if (ATTRIBUTES.indexOf(name) > -1) {
                  if (value) {
                    this.domNode.setAttribute(name, value);
                  } else {
                    this.domNode.removeAttribute(name);
                  }
                } else {
                  _get(Image2.prototype.__proto__ || Object.getPrototypeOf(Image2.prototype), "format", this).call(this, name, value);
                }
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Image2.__proto__ || Object.getPrototypeOf(Image2), "create", this).call(this, value);
                if (typeof value === "string") {
                  node.setAttribute("src", this.sanitize(value));
                }
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return ATTRIBUTES.reduce(function(formats2, attribute2) {
                  if (domNode.hasAttribute(attribute2)) {
                    formats2[attribute2] = domNode.getAttribute(attribute2);
                  }
                  return formats2;
                }, {});
              }
            }, {
              key: "match",
              value: function match(url) {
                return /\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url);
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return (0, _link.sanitize)(url, ["http", "https", "data"]) ? url : "//:0";
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("src");
              }
            }]);
            return Image2;
          }(_parchment2.default.Embed);
          Image.blotName = "image";
          Image.tagName = "IMG";
          exports2.default = Image;
        },
        /* 73 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _block = __webpack_require__(4);
          var _link = __webpack_require__(27);
          var _link2 = _interopRequireDefault(_link);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var ATTRIBUTES = ["height", "width"];
          var Video = function(_BlockEmbed) {
            _inherits(Video2, _BlockEmbed);
            function Video2() {
              _classCallCheck(this, Video2);
              return _possibleConstructorReturn(this, (Video2.__proto__ || Object.getPrototypeOf(Video2)).apply(this, arguments));
            }
            _createClass(Video2, [{
              key: "format",
              value: function format(name, value) {
                if (ATTRIBUTES.indexOf(name) > -1) {
                  if (value) {
                    this.domNode.setAttribute(name, value);
                  } else {
                    this.domNode.removeAttribute(name);
                  }
                } else {
                  _get(Video2.prototype.__proto__ || Object.getPrototypeOf(Video2.prototype), "format", this).call(this, name, value);
                }
              }
            }], [{
              key: "create",
              value: function create(value) {
                var node = _get(Video2.__proto__ || Object.getPrototypeOf(Video2), "create", this).call(this, value);
                node.setAttribute("frameborder", "0");
                node.setAttribute("allowfullscreen", true);
                node.setAttribute("src", this.sanitize(value));
                return node;
              }
            }, {
              key: "formats",
              value: function formats(domNode) {
                return ATTRIBUTES.reduce(function(formats2, attribute2) {
                  if (domNode.hasAttribute(attribute2)) {
                    formats2[attribute2] = domNode.getAttribute(attribute2);
                  }
                  return formats2;
                }, {});
              }
            }, {
              key: "sanitize",
              value: function sanitize(url) {
                return _link2.default.sanitize(url);
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("src");
              }
            }]);
            return Video2;
          }(_block.BlockEmbed);
          Video.blotName = "video";
          Video.className = "ql-video";
          Video.tagName = "IFRAME";
          exports2.default = Video;
        },
        /* 74 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.FormulaBlot = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _embed = __webpack_require__(35);
          var _embed2 = _interopRequireDefault(_embed);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var FormulaBlot = function(_Embed) {
            _inherits(FormulaBlot2, _Embed);
            function FormulaBlot2() {
              _classCallCheck(this, FormulaBlot2);
              return _possibleConstructorReturn(this, (FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2)).apply(this, arguments));
            }
            _createClass(FormulaBlot2, null, [{
              key: "create",
              value: function create(value) {
                var node = _get(FormulaBlot2.__proto__ || Object.getPrototypeOf(FormulaBlot2), "create", this).call(this, value);
                if (typeof value === "string") {
                  window.katex.render(value, node, {
                    throwOnError: false,
                    errorColor: "#f00"
                  });
                  node.setAttribute("data-value", value);
                }
                return node;
              }
            }, {
              key: "value",
              value: function value(domNode) {
                return domNode.getAttribute("data-value");
              }
            }]);
            return FormulaBlot2;
          }(_embed2.default);
          FormulaBlot.blotName = "formula";
          FormulaBlot.className = "ql-formula";
          FormulaBlot.tagName = "SPAN";
          var Formula = function(_Module) {
            _inherits(Formula2, _Module);
            _createClass(Formula2, null, [{
              key: "register",
              value: function register() {
                _quill2.default.register(FormulaBlot, true);
              }
            }]);
            function Formula2() {
              _classCallCheck(this, Formula2);
              var _this2 = _possibleConstructorReturn(this, (Formula2.__proto__ || Object.getPrototypeOf(Formula2)).call(this));
              if (window.katex == null) {
                throw new Error("Formula module requires KaTeX.");
              }
              return _this2;
            }
            return Formula2;
          }(_module2.default);
          exports2.FormulaBlot = FormulaBlot;
          exports2.default = Formula;
        },
        /* 75 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.CodeToken = exports2.CodeBlock = void 0;
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _parchment = __webpack_require__(0);
          var _parchment2 = _interopRequireDefault(_parchment);
          var _quill = __webpack_require__(5);
          var _quill2 = _interopRequireDefault(_quill);
          var _module = __webpack_require__(9);
          var _module2 = _interopRequireDefault(_module);
          var _code = __webpack_require__(13);
          var _code2 = _interopRequireDefault(_code);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var SyntaxCodeBlock = function(_CodeBlock) {
            _inherits(SyntaxCodeBlock2, _CodeBlock);
            function SyntaxCodeBlock2() {
              _classCallCheck(this, SyntaxCodeBlock2);
              return _possibleConstructorReturn(this, (SyntaxCodeBlock2.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2)).apply(this, arguments));
            }
            _createClass(SyntaxCodeBlock2, [{
              key: "replaceWith",
              value: function replaceWith(block) {
                this.domNode.textContent = this.domNode.textContent;
                this.attach();
                _get(SyntaxCodeBlock2.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock2.prototype), "replaceWith", this).call(this, block);
              }
            }, {
              key: "highlight",
              value: function highlight(_highlight) {
                var text = this.domNode.textContent;
                if (this.cachedText !== text) {
                  if (text.trim().length > 0 || this.cachedText == null) {
                    this.domNode.innerHTML = _highlight(text);
                    this.domNode.normalize();
                    this.attach();
                  }
                  this.cachedText = text;
                }
              }
            }]);
            return SyntaxCodeBlock2;
          }(_code2.default);
          SyntaxCodeBlock.className = "ql-syntax";
          var CodeToken = new _parchment2.default.Attributor.Class("token", "hljs", {
            scope: _parchment2.default.Scope.INLINE
          });
          var Syntax = function(_Module) {
            _inherits(Syntax2, _Module);
            _createClass(Syntax2, null, [{
              key: "register",
              value: function register() {
                _quill2.default.register(CodeToken, true);
                _quill2.default.register(SyntaxCodeBlock, true);
              }
            }]);
            function Syntax2(quill2, options) {
              _classCallCheck(this, Syntax2);
              var _this2 = _possibleConstructorReturn(this, (Syntax2.__proto__ || Object.getPrototypeOf(Syntax2)).call(this, quill2, options));
              if (typeof _this2.options.highlight !== "function") {
                throw new Error("Syntax module requires highlight.js. Please include the library on the page before Quill.");
              }
              var timer = null;
              _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function() {
                clearTimeout(timer);
                timer = setTimeout(function() {
                  _this2.highlight();
                  timer = null;
                }, _this2.options.interval);
              });
              _this2.highlight();
              return _this2;
            }
            _createClass(Syntax2, [{
              key: "highlight",
              value: function highlight() {
                var _this3 = this;
                if (this.quill.selection.composing)
                  return;
                this.quill.update(_quill2.default.sources.USER);
                var range = this.quill.getSelection();
                this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function(code) {
                  code.highlight(_this3.options.highlight);
                });
                this.quill.update(_quill2.default.sources.SILENT);
                if (range != null) {
                  this.quill.setSelection(range, _quill2.default.sources.SILENT);
                }
              }
            }]);
            return Syntax2;
          }(_module2.default);
          Syntax.DEFAULTS = {
            highlight: function() {
              if (window.hljs == null)
                return null;
              return function(text) {
                var result = window.hljs.highlightAuto(text);
                return result.value;
              };
            }(),
            interval: 1e3
          };
          exports2.CodeBlock = SyntaxCodeBlock;
          exports2.CodeToken = CodeToken;
          exports2.default = Syntax;
        },
        /* 76 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>';
        },
        /* 77 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>';
        },
        /* 78 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>';
        },
        /* 79 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>';
        },
        /* 80 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <g class="ql-fill ql-color-label"> <polygon points="6 6.868 6 6 5 6 5 7 5.942 7 6 6.868"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points="6.817 5 6 5 6 6 6.38 6 6.817 5"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points="4 11.439 4 11 3 11 3 12 3.755 12 4 11.439"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points="4.63 10 4 10 4 11 4.192 11 4.63 10"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points="13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points="12 6.868 12 6 11.62 6 12 6.868"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points="12.933 9 13 9 13 8 12.495 8 12.933 9"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points="5.5 13 9 5 12.5 13"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>';
        },
        /* 81 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class="ql-fill ql-stroke" height=3 width=3 x=4 y=5></rect> <rect class="ql-fill ql-stroke" height=3 width=3 x=11 y=5></rect> <path class="ql-even ql-fill ql-stroke" d=M7,8c0,4.031-3,5-3,5></path> <path class="ql-even ql-fill ql-stroke" d=M14,8c0,4.031-3,5-3,5></path> </svg>';
        },
        /* 82 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>';
        },
        /* 83 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>';
        },
        /* 84 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-color-label ql-stroke ql-transparent" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points="5.5 11 9 3 12.5 11"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>';
        },
        /* 85 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="3 11 5 9 3 7 3 11"></polygon> <line class="ql-stroke ql-fill" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>';
        },
        /* 86 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class="ql-stroke ql-fill" points="15 12 13 10 15 8 15 12"></polygon> <line class="ql-stroke ql-fill" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>';
        },
        /* 87 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 88 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 89 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>';
        },
        /* 90 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform="translate(24 18) rotate(-180)"/> </svg>';
        },
        /* 91 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>';
        },
        /* 92 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>';
        },
        /* 93 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewBox="0 0 18 18"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>';
        },
        /* 94 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>';
        },
        /* 95 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class="ql-even ql-fill" points="5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"></polyline> </svg>';
        },
        /* 96 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class="ql-fill ql-stroke" points="3 7 3 11 5 9 3 7"></polyline> </svg>';
        },
        /* 97 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="5 7 5 11 3 9 5 7"></polyline> </svg>';
        },
        /* 98 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class="ql-even ql-stroke" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class="ql-even ql-stroke" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>';
        },
        /* 99 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class="ql-stroke ql-thin" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class="ql-stroke ql-thin" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class="ql-stroke ql-thin" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>';
        },
        /* 100 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>';
        },
        /* 101 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg class="" viewbox="0 0 18 18"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points="3 4 4 5 6 3"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points="3 14 4 15 6 13"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points="3 9 4 10 6 8"></polyline> </svg>';
        },
        /* 102 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>';
        },
        /* 103 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>';
        },
        /* 104 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <line class="ql-stroke ql-thin" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>';
        },
        /* 105 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>';
        },
        /* 106 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>';
        },
        /* 107 */
        /***/
        function(module2, exports2) {
          module2.exports = '<svg viewbox="0 0 18 18"> <polygon class=ql-stroke points="7 11 9 13 11 11 7 11"></polygon> <polygon class=ql-stroke points="7 7 9 5 11 7 7 7"></polygon> </svg>';
        },
        /* 108 */
        /***/
        function(module2, exports2, __webpack_require__) {
          Object.defineProperty(exports2, "__esModule", {
            value: true
          });
          exports2.default = exports2.BubbleTooltip = void 0;
          var _get = function get(object, property, receiver) {
            if (object === null)
              object = Function.prototype;
            var desc = Object.getOwnPropertyDescriptor(object, property);
            if (desc === void 0) {
              var parent = Object.getPrototypeOf(object);
              if (parent === null) {
                return void 0;
              } else {
                return get(parent, property, receiver);
              }
            } else if ("value" in desc) {
              return desc.value;
            } else {
              var getter = desc.get;
              if (getter === void 0) {
                return void 0;
              }
              return getter.call(receiver);
            }
          };
          var _createClass = /* @__PURE__ */ function() {
            function defineProperties(target, props) {
              for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor)
                  descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
              }
            }
            return function(Constructor, protoProps, staticProps) {
              if (protoProps)
                defineProperties(Constructor.prototype, protoProps);
              if (staticProps)
                defineProperties(Constructor, staticProps);
              return Constructor;
            };
          }();
          var _extend = __webpack_require__(3);
          var _extend2 = _interopRequireDefault(_extend);
          var _emitter = __webpack_require__(8);
          var _emitter2 = _interopRequireDefault(_emitter);
          var _base = __webpack_require__(43);
          var _base2 = _interopRequireDefault(_base);
          var _selection = __webpack_require__(15);
          var _icons = __webpack_require__(41);
          var _icons2 = _interopRequireDefault(_icons);
          function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : { default: obj };
          }
          function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) {
              throw new TypeError("Cannot call a class as a function");
            }
          }
          function _possibleConstructorReturn(self2, call) {
            if (!self2) {
              throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }
            return call && (typeof call === "object" || typeof call === "function") ? call : self2;
          }
          function _inherits(subClass, superClass) {
            if (typeof superClass !== "function" && superClass !== null) {
              throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            }
            subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });
            if (superClass)
              Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
          }
          var TOOLBAR_CONFIG = [["bold", "italic", "link"], [{ header: 1 }, { header: 2 }, "blockquote"]];
          var BubbleTheme = function(_BaseTheme) {
            _inherits(BubbleTheme2, _BaseTheme);
            function BubbleTheme2(quill2, options) {
              _classCallCheck(this, BubbleTheme2);
              if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
                options.modules.toolbar.container = TOOLBAR_CONFIG;
              }
              var _this = _possibleConstructorReturn(this, (BubbleTheme2.__proto__ || Object.getPrototypeOf(BubbleTheme2)).call(this, quill2, options));
              _this.quill.container.classList.add("ql-bubble");
              return _this;
            }
            _createClass(BubbleTheme2, [{
              key: "extendToolbar",
              value: function extendToolbar(toolbar) {
                this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
                this.tooltip.root.appendChild(toolbar.container);
                this.buildButtons([].slice.call(toolbar.container.querySelectorAll("button")), _icons2.default);
                this.buildPickers([].slice.call(toolbar.container.querySelectorAll("select")), _icons2.default);
              }
            }]);
            return BubbleTheme2;
          }(_base2.default);
          BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
            modules: {
              toolbar: {
                handlers: {
                  link: function link(value) {
                    if (!value) {
                      this.quill.format("link", false);
                    } else {
                      this.quill.theme.tooltip.edit();
                    }
                  }
                }
              }
            }
          });
          var BubbleTooltip = function(_BaseTooltip) {
            _inherits(BubbleTooltip2, _BaseTooltip);
            function BubbleTooltip2(quill2, bounds) {
              _classCallCheck(this, BubbleTooltip2);
              var _this2 = _possibleConstructorReturn(this, (BubbleTooltip2.__proto__ || Object.getPrototypeOf(BubbleTooltip2)).call(this, quill2, bounds));
              _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function(type, range, oldRange, source) {
                if (type !== _emitter2.default.events.SELECTION_CHANGE)
                  return;
                if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
                  _this2.show();
                  _this2.root.style.left = "0px";
                  _this2.root.style.width = "";
                  _this2.root.style.width = _this2.root.offsetWidth + "px";
                  var lines = _this2.quill.getLines(range.index, range.length);
                  if (lines.length === 1) {
                    _this2.position(_this2.quill.getBounds(range));
                  } else {
                    var lastLine = lines[lines.length - 1];
                    var index = _this2.quill.getIndex(lastLine);
                    var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
                    var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
                    _this2.position(_bounds);
                  }
                } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
                  _this2.hide();
                }
              });
              return _this2;
            }
            _createClass(BubbleTooltip2, [{
              key: "listen",
              value: function listen() {
                var _this3 = this;
                _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "listen", this).call(this);
                this.root.querySelector(".ql-close").addEventListener("click", function() {
                  _this3.root.classList.remove("ql-editing");
                });
                this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function() {
                  setTimeout(function() {
                    if (_this3.root.classList.contains("ql-hidden"))
                      return;
                    var range = _this3.quill.getSelection();
                    if (range != null) {
                      _this3.position(_this3.quill.getBounds(range));
                    }
                  }, 1);
                });
              }
            }, {
              key: "cancel",
              value: function cancel() {
                this.show();
              }
            }, {
              key: "position",
              value: function position(reference) {
                var shift = _get(BubbleTooltip2.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip2.prototype), "position", this).call(this, reference);
                var arrow = this.root.querySelector(".ql-tooltip-arrow");
                arrow.style.marginLeft = "";
                if (shift === 0)
                  return shift;
                arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + "px";
              }
            }]);
            return BubbleTooltip2;
          }(_base.BaseTooltip);
          BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', "</div>"].join("");
          exports2.BubbleTooltip = BubbleTooltip;
          exports2.default = BubbleTheme;
        },
        /* 109 */
        /***/
        function(module2, exports2, __webpack_require__) {
          module2.exports = __webpack_require__(63);
        }
        /******/
      ])["default"]
    );
  });
})(quill);
var quillExports = quill.exports;
var __extends = commonjsGlobal && commonjsGlobal.__extends || /* @__PURE__ */ function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = commonjsGlobal && commonjsGlobal.__assign || function() {
  __assign = Object.assign || function(t) {
    for (var s2, i = 1, n = arguments.length; i < n; i++) {
      s2 = arguments[i];
      for (var p in s2)
        if (Object.prototype.hasOwnProperty.call(s2, p))
          t[p] = s2[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __spreadArrays = commonjsGlobal && commonjsGlobal.__spreadArrays || function() {
  for (var s2 = 0, i = 0, il = arguments.length; i < il; i++)
    s2 += arguments[i].length;
  for (var r = Array(s2), k2 = 0, i = 0; i < il; i++)
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k2++)
      r[k2] = a[j];
  return r;
};
var __importDefault = commonjsGlobal && commonjsGlobal.__importDefault || function(mod) {
  return mod && mod.__esModule ? mod : { "default": mod };
};
var react_1 = __importDefault(k$1);
var react_dom_1 = __importDefault(require$$1);
var isEqual_1 = __importDefault(isEqual_1$1);
var quill_1 = __importDefault(quillExports);
var ReactQuill = (
  /** @class */
  function(_super) {
    __extends(ReactQuill2, _super);
    function ReactQuill2(props) {
      var _this = _super.call(this, props) || this;
      _this.dirtyProps = [
        "modules",
        "formats",
        "bounds",
        "theme",
        "children"
      ];
      _this.cleanProps = [
        "id",
        "className",
        "style",
        "placeholder",
        "tabIndex",
        "onChange",
        "onChangeSelection",
        "onFocus",
        "onBlur",
        "onKeyPress",
        "onKeyDown",
        "onKeyUp"
      ];
      _this.state = {
        generation: 0
      };
      _this.selection = null;
      _this.onEditorChange = function(eventName, rangeOrDelta, oldRangeOrDelta, source) {
        var _a, _b, _c, _d;
        if (eventName === "text-change") {
          (_b = (_a = _this).onEditorChangeText) === null || _b === void 0 ? void 0 : _b.call(_a, _this.editor.root.innerHTML, rangeOrDelta, source, _this.unprivilegedEditor);
        } else if (eventName === "selection-change") {
          (_d = (_c = _this).onEditorChangeSelection) === null || _d === void 0 ? void 0 : _d.call(_c, rangeOrDelta, source, _this.unprivilegedEditor);
        }
      };
      var value = _this.isControlled() ? props.value : props.defaultValue;
      _this.value = value !== null && value !== void 0 ? value : "";
      return _this;
    }
    ReactQuill2.prototype.validateProps = function(props) {
      var _a;
      if (react_1.default.Children.count(props.children) > 1)
        throw new Error("The Quill editing area can only be composed of a single React element.");
      if (react_1.default.Children.count(props.children)) {
        var child = react_1.default.Children.only(props.children);
        if (((_a = child) === null || _a === void 0 ? void 0 : _a.type) === "textarea")
          throw new Error("Quill does not support editing on a <textarea>. Use a <div> instead.");
      }
      if (this.lastDeltaChangeSet && props.value === this.lastDeltaChangeSet)
        throw new Error("You are passing the `delta` object from the `onChange` event back as `value`. You most probably want `editor.getContents()` instead. See: https://github.com/zenoamaro/react-quill#using-deltas");
    };
    ReactQuill2.prototype.shouldComponentUpdate = function(nextProps, nextState) {
      var _this = this;
      var _a;
      this.validateProps(nextProps);
      if (!this.editor || this.state.generation !== nextState.generation) {
        return true;
      }
      if ("value" in nextProps) {
        var prevContents = this.getEditorContents();
        var nextContents = (_a = nextProps.value, _a !== null && _a !== void 0 ? _a : "");
        if (!this.isEqualValue(nextContents, prevContents)) {
          this.setEditorContents(this.editor, nextContents);
        }
      }
      if (nextProps.readOnly !== this.props.readOnly) {
        this.setEditorReadOnly(this.editor, nextProps.readOnly);
      }
      return __spreadArrays(this.cleanProps, this.dirtyProps).some(function(prop) {
        return !isEqual_1.default(nextProps[prop], _this.props[prop]);
      });
    };
    ReactQuill2.prototype.shouldComponentRegenerate = function(nextProps) {
      var _this = this;
      return this.dirtyProps.some(function(prop) {
        return !isEqual_1.default(nextProps[prop], _this.props[prop]);
      });
    };
    ReactQuill2.prototype.componentDidMount = function() {
      this.instantiateEditor();
      this.setEditorContents(this.editor, this.getEditorContents());
    };
    ReactQuill2.prototype.componentWillUnmount = function() {
      this.destroyEditor();
    };
    ReactQuill2.prototype.componentDidUpdate = function(prevProps, prevState) {
      var _this = this;
      if (this.editor && this.shouldComponentRegenerate(prevProps)) {
        var delta = this.editor.getContents();
        var selection = this.editor.getSelection();
        this.regenerationSnapshot = { delta, selection };
        this.setState({ generation: this.state.generation + 1 });
        this.destroyEditor();
      }
      if (this.state.generation !== prevState.generation) {
        var _a = this.regenerationSnapshot, delta = _a.delta, selection_1 = _a.selection;
        delete this.regenerationSnapshot;
        this.instantiateEditor();
        var editor_1 = this.editor;
        editor_1.setContents(delta);
        postpone(function() {
          return _this.setEditorSelection(editor_1, selection_1);
        });
      }
    };
    ReactQuill2.prototype.instantiateEditor = function() {
      if (this.editor) {
        this.hookEditor(this.editor);
      } else {
        this.editor = this.createEditor(this.getEditingArea(), this.getEditorConfig());
      }
    };
    ReactQuill2.prototype.destroyEditor = function() {
      if (!this.editor)
        return;
      this.unhookEditor(this.editor);
    };
    ReactQuill2.prototype.isControlled = function() {
      return "value" in this.props;
    };
    ReactQuill2.prototype.getEditorConfig = function() {
      return {
        bounds: this.props.bounds,
        formats: this.props.formats,
        modules: this.props.modules,
        placeholder: this.props.placeholder,
        readOnly: this.props.readOnly,
        scrollingContainer: this.props.scrollingContainer,
        tabIndex: this.props.tabIndex,
        theme: this.props.theme
      };
    };
    ReactQuill2.prototype.getEditor = function() {
      if (!this.editor)
        throw new Error("Accessing non-instantiated editor");
      return this.editor;
    };
    ReactQuill2.prototype.createEditor = function(element, config) {
      var editor = new quill_1.default(element, config);
      if (config.tabIndex != null) {
        this.setEditorTabIndex(editor, config.tabIndex);
      }
      this.hookEditor(editor);
      return editor;
    };
    ReactQuill2.prototype.hookEditor = function(editor) {
      this.unprivilegedEditor = this.makeUnprivilegedEditor(editor);
      editor.on("editor-change", this.onEditorChange);
    };
    ReactQuill2.prototype.unhookEditor = function(editor) {
      editor.off("editor-change", this.onEditorChange);
    };
    ReactQuill2.prototype.getEditorContents = function() {
      return this.value;
    };
    ReactQuill2.prototype.getEditorSelection = function() {
      return this.selection;
    };
    ReactQuill2.prototype.isDelta = function(value) {
      return value && value.ops;
    };
    ReactQuill2.prototype.isEqualValue = function(value, nextValue) {
      if (this.isDelta(value) && this.isDelta(nextValue)) {
        return isEqual_1.default(value.ops, nextValue.ops);
      } else {
        return isEqual_1.default(value, nextValue);
      }
    };
    ReactQuill2.prototype.setEditorContents = function(editor, value) {
      var _this = this;
      this.value = value;
      var sel = this.getEditorSelection();
      if (typeof value === "string") {
        editor.setContents(editor.clipboard.convert(value));
      } else {
        editor.setContents(value);
      }
      postpone(function() {
        return _this.setEditorSelection(editor, sel);
      });
    };
    ReactQuill2.prototype.setEditorSelection = function(editor, range) {
      this.selection = range;
      if (range) {
        var length_1 = editor.getLength();
        range.index = Math.max(0, Math.min(range.index, length_1 - 1));
        range.length = Math.max(0, Math.min(range.length, length_1 - 1 - range.index));
        editor.setSelection(range);
      }
    };
    ReactQuill2.prototype.setEditorTabIndex = function(editor, tabIndex) {
      var _a, _b;
      if ((_b = (_a = editor) === null || _a === void 0 ? void 0 : _a.scroll) === null || _b === void 0 ? void 0 : _b.domNode) {
        editor.scroll.domNode.tabIndex = tabIndex;
      }
    };
    ReactQuill2.prototype.setEditorReadOnly = function(editor, value) {
      if (value) {
        editor.disable();
      } else {
        editor.enable();
      }
    };
    ReactQuill2.prototype.makeUnprivilegedEditor = function(editor) {
      var e = editor;
      return {
        getHTML: function() {
          return e.root.innerHTML;
        },
        getLength: e.getLength.bind(e),
        getText: e.getText.bind(e),
        getContents: e.getContents.bind(e),
        getSelection: e.getSelection.bind(e),
        getBounds: e.getBounds.bind(e)
      };
    };
    ReactQuill2.prototype.getEditingArea = function() {
      if (!this.editingArea) {
        throw new Error("Instantiating on missing editing area");
      }
      var element = react_dom_1.default.findDOMNode(this.editingArea);
      if (!element) {
        throw new Error("Cannot find element for editing area");
      }
      if (element.nodeType === 3) {
        throw new Error("Editing area cannot be a text node");
      }
      return element;
    };
    ReactQuill2.prototype.renderEditingArea = function() {
      var _this = this;
      var _a = this.props, children = _a.children, preserveWhitespace = _a.preserveWhitespace;
      var generation = this.state.generation;
      var properties = {
        key: generation,
        ref: function(instance) {
          _this.editingArea = instance;
        }
      };
      if (react_1.default.Children.count(children)) {
        return react_1.default.cloneElement(react_1.default.Children.only(children), properties);
      }
      return preserveWhitespace ? react_1.default.createElement("pre", __assign({}, properties)) : react_1.default.createElement("div", __assign({}, properties));
    };
    ReactQuill2.prototype.render = function() {
      var _a;
      return react_1.default.createElement("div", { id: this.props.id, style: this.props.style, key: this.state.generation, className: "quill " + (_a = this.props.className, _a !== null && _a !== void 0 ? _a : ""), onKeyPress: this.props.onKeyPress, onKeyDown: this.props.onKeyDown, onKeyUp: this.props.onKeyUp }, this.renderEditingArea());
    };
    ReactQuill2.prototype.onEditorChangeText = function(value, delta, source, editor) {
      var _a, _b;
      if (!this.editor)
        return;
      var nextContents = this.isDelta(this.value) ? editor.getContents() : editor.getHTML();
      if (nextContents !== this.getEditorContents()) {
        this.lastDeltaChangeSet = delta;
        this.value = nextContents;
        (_b = (_a = this.props).onChange) === null || _b === void 0 ? void 0 : _b.call(_a, value, delta, source, editor);
      }
    };
    ReactQuill2.prototype.onEditorChangeSelection = function(nextSelection, source, editor) {
      var _a, _b, _c, _d, _e2, _f;
      if (!this.editor)
        return;
      var currentSelection = this.getEditorSelection();
      var hasGainedFocus = !currentSelection && nextSelection;
      var hasLostFocus = currentSelection && !nextSelection;
      if (isEqual_1.default(nextSelection, currentSelection))
        return;
      this.selection = nextSelection;
      (_b = (_a = this.props).onChangeSelection) === null || _b === void 0 ? void 0 : _b.call(_a, nextSelection, source, editor);
      if (hasGainedFocus) {
        (_d = (_c = this.props).onFocus) === null || _d === void 0 ? void 0 : _d.call(_c, nextSelection, source, editor);
      } else if (hasLostFocus) {
        (_f = (_e2 = this.props).onBlur) === null || _f === void 0 ? void 0 : _f.call(_e2, currentSelection, source, editor);
      }
    };
    ReactQuill2.prototype.focus = function() {
      if (!this.editor)
        return;
      this.editor.focus();
    };
    ReactQuill2.prototype.blur = function() {
      if (!this.editor)
        return;
      this.selection = null;
      this.editor.blur();
    };
    ReactQuill2.displayName = "React Quill";
    ReactQuill2.Quill = quill_1.default;
    ReactQuill2.defaultProps = {
      theme: "snow",
      modules: {},
      readOnly: false
    };
    return ReactQuill2;
  }(react_1.default.Component)
);
function postpone(fn2) {
  Promise.resolve().then(fn2);
}
var lib = ReactQuill;
const ReactQuill$1 = /* @__PURE__ */ getDefaultExportFromCjs(lib);
function QuillEditor({
  initialValue = "",
  value,
  onChange,
  modules,
  formats
}) {
  const [content2, setContent] = useState(initialValue);
  useEffect(() => {
    setContent(value);
  }, [value]);
  const handleContentChange = (value2) => {
    setContent(value2);
    if (onChange) {
      onChange(value2);
    }
  };
  const defaultModules = {
    toolbar: [[{
      header: [1, 2, 3, 4, 5, 6, false]
    }], ["bold", "italic", "underline", "strike", "blockquote"], [{
      size: []
    }], [{
      font: []
    }], [{
      align: ["right", "center", "justify"]
    }], [{
      list: "ordered"
    }, {
      list: "bullet"
    }], ["link", "image"], [{
      color: ["red", "#785412", "yellow"]
    }], [{
      background: ["red", "#785412", "yellow"]
    }]]
  };
  const defaultFormats = ["header", "bold", "italic", "underline", "strike", "blockquote", "list", "bullet", "link", "color", "image", "background", "align", "size", "font"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ReactQuill$1, { theme: "snow", modules: modules || defaultModules, formats: formats || defaultFormats, value: content2, onChange: handleContentChange, "data-testid": "quill-editor" });
}
QuillEditor.propTypes = {
  initialValue: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  modules: PropTypes.object,
  formats: PropTypes.array
};
const templates$1 = [
  {
    Id: "00XQk000000DPiAMAW",
    Name: "More Info Needed - Cancelled Merchandise/Services",
    Description: "More Info Needed - Cancelled Merchandise/Services",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder related to Cancelled Merchandise/Services.\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>\n	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n<br />\n<br />\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\n<strong>Supporting Documentation</strong><br />\n<br />\n<strong>Required</strong><br />\n<br />\n· Date merchandise/service was expected or received<br />\n<br />\n· Date of merchandise/service was cancelled or returned<br />\n<br />\n· Name of shipping company, as applicable<br />\n<br />\n· The Invoice/tracking number, as applicable<br />\n<br />\n· Date the Merchant received the merchandise, as applicable<br />\n<br />\n· Disposition of the merchandise, as applicable<br />\n<br />\n· Did the merchant refuse the return of merchandise, refused to provide<br />\n<br />\na return merchandise authorization, or informed the Cardholder not to<br />\n<br />\nreturn the merchandise? (Yes/No)<br />\n<br />\n<br />\n<strong>Good Faith Attempt</strong><br />\n<br />\n· Date of contact<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat, etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<strong>Good to Have</strong><br />\n<br />\n· Purchase order<br />\n<br />\n· Proof of cancellation<br />\n<br />\n· All relevant communication between the cardholder and merchant<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</body>\n</html>'
  },
  {
    Id: "00XQk000000DPztMAG",
    Name: "More Info Needed - Incorrect Dispute Reason",
    Description: "More Info Needed - Incorrect Dispute Reason",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">Hello&nbsp;{{{Case.Construct_Name__c}}}<br />
<br />
<br />
Thank you for your dispute inquiry. We have reviewed your submission and have found there is a discrepancy between the dispute reason you have provided and the cardholder's comments.&nbsp;
<ul>
	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>
	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT]</strong></li>
	<li><strong>Transaction Token: [AGNET ENTER TRANSACTION TOKEN]</strong></li>
	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that&nbsp;there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:
	<ul>
		<li>[AGENT ENTER TRANSACTION TOKEN]</li>
	</ul>
	</li>
</ul>
<br />
[Insert Comment Related to Discrepancy]<br />
<br />
<br />
Please reach out to your cardholder for additional information and correct the dispute reason, if needed.&nbsp;<br />
<br />
Please Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />
<br />
<br />
Kind regards,<br />
<br />
Chargebacks &amp; Disputes<br />
<br />
{{{Case.Email_Thread}}}</body>
</html>`
  },
  {
    Id: "00XQk000000DQG1MAO",
    Name: "More Info Needed - Merchandise/Services not Received",
    Description: "More Info Needed - Merchandise/Services not Received",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for a transaction related to Merchandise/Services not Received.\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>\n	<li><strong>Dispute Amount" [AGENT ENTER DISPUTE AMOUNT]</strong></li>\n	<li><strong>Transaction Token: [AGNET ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that&nbsp;there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n<br />\n<br />\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\n<strong>Supporting Documentation<br />\n<br />\nRequired</strong><br />\n<br />\n· Detailed Description of Merchandise/Services (items purchased - must include product, sizes, colors, brand, &nbsp;etc.)<br />\n<br />\n· Expected Delivery/Service Date<br />\n<br />\n<br />\n<strong>Good Faith Attempt to Resolve with Merchant<br />\n<br />\nRequired</strong><br />\n<br />\n· Did the cardholder attempt to resolve with merchant first (Yes/No)<br />\n<br />\n<br />\n<strong>Good to Have</strong><br />\n<br />\n· Purchase order<br />\n<br />\n· Location for delivery/pick-up<br />\n<br />\n· Shipping/tracking details<br />\n<br />\n· Date cardholder contacted the merchant<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</body>\n</html>'
  },
  {
    Id: "00XQk000000Dw2zMAC",
    Name: "More Info Needed - Explanation of Credit",
    Description: "More Info Needed - Explanation of Credit",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>&nbsp;</p>\n\n<p>Hello {{{Case.Construct_Name__c}}},<br />\n<br />\nThank you for you dispute inquiry. We have located a credit(s) that appears to be associated with the transaction being disputed. Please see screenshot of credit listed below. We will need a detailed explanation of why the credit is not associated with this transaction and which transaction the credit is associated with.</p>\n\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT]</strong></li>\n	<li><strong>Transaction Token: [AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n[Insert MQD Refund Line Item]<br />\n<br />\nPer Visa Core Rules, we cannot file a dispute against this transaction until a complete explanation of credit is provided. Please reach out to your cardholder for additional information related to this transaction and the associated credit(s).<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\nKind regards,<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}\n<p><br />\n<br />\n<br />\n<strong>Transaction Token: [AGENT ENTER TRANSACTION TOKEN]</strong></p>\n</body>\n</html>'
  },
  {
    Id: "00XQk000000EoTCMA0",
    Name: "More Info Needed - Credit not Processed",
    Description: "More Info Needed - Credit not Processed",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for the dispute reason Credit not processed.\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>\n	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that&nbsp;there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n<br />\n<br />\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\n<strong>Supporting Documentation</strong><br />\n<br />\nRequired&nbsp;<br />\n<br />\n· Proof a credit is due (refund receipt, purchase return receipt, credit memo, etc.)<br />\n<br />\n<br />\n<br />\n<strong>Good Faith Attempt</strong><br />\n<br />\nRequired<br />\n<br />\n· Date of contact<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat, etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<br />\nIf the merchant did not provide proof of credit, the dispute will need to be filed under 13.1-Merchandise/Services not Received, or 13.7-Cancelled Merchandise/Services if the merchandise was returned. Credit not processed is not a valid dispute for cancelled orders unless a credit/refund was promised.<br />\n<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</body>\n</html>'
  },
  {
    Id: "00XQk000000JTRJMA4",
    Name: "More Info Needed Basic",
    Description: "Scenario: The customer is requesting to make a claim on a transaction but we need more information in order to do so and the claim is related to Card Recovery Bulletin (Visa 11.1), Late Presentment (Visa 12.1), Incorrect Transaction Code (Visa 12.2), Incorrect Currency (Visa 12.3), Canceled Recurring Transaction (Visa 13.2), Counterfeit Merchandise (Visa 13.4)",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>Hi Team,</p>\n\n<p>&nbsp;</p>\n\n<p>We would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder related to your claim:</p>\n\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>\n	<li><strong>Dispute Amount" [AGENT ENTER DISPUTE AMOUNT]</strong></li>\n	<li><strong>Transaction Token: [AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li>Dispute Reason</li>\n	<li dir="ltr">Merchant name:</li>\n	<li dir="ltr">Date/time of transaction:</li>\n	<li dir="ltr">Transaction amount:</li>\n	<li dir="ltr">Claim amount (must include original transaction amount):</li>\n	<li dir="ltr">Was your physical card compromised?</li>\n	<li dir="ltr">Is the card still in your possession?</li>\n	<li dir="ltr">Was this a recurring payment?</li>\n	<li dir="ltr">Have you purchased from this merchant in the past?</li>\n	<li dir="ltr">Have you tried to contact the merchant to resolve?</li>\n	<li dir="ltr">What merchandise or service (please provide a detailed description) was ordered and when was it expected to be received?</li>\n	<li>\n	<p>Who has possession of the merchandise</p>\n	</li>\n</ul>\n\n<ul>\n	<li>\n	<p>Was an attempt made to return the merchandise?&nbsp;</p>\n	</li>\n	<li>\n	<p>Date of attempted return</p>\n	</li>\n	<li>\n	<p>Date that the cardholder canceled the services.</p>\n	</li>\n	<li>\n	<p>How the cardholder contacted the merchant.</p>\n	</li>\n	<li>\n	<p>Details used to contact the merchant (such as email address, telephone number or physical address).</p>\n	</li>\n	<li>\n	<p>The date that the payment credential was closed.</p>\n	</li>\n	<li>\n	<p>Name of the agency that certified that the merchandise is counterfeit.</p>\n	</li>\n	<li>\n	<p>Date that the customer received the merchandise OR the date that they received notification that the merchandise was counterfeit.</p>\n	</li>\n	<li>\n	<p>Detailed Description of Merchandise.</p>\n	</li>\n	<li>\n	<p>Who has possession of the merchandise</p>\n	</li>\n	<li>\n	<p>The date the merchandise was returned or service was canceled.</p>\n	</li>\n	<li>\n	<p>Name of the shipping company.</p>\n	</li>\n	<li>\n	<p>Invoice or tracking number (if available).</p>\n	</li>\n	<li>\n	<p>The date the merchandise was received back by the merchant.</p>\n	</li>\n	<li>\n	<p>Certification that the merchant refused to accept back the merchandise, or refused to provide a return label, or the merchant informed the customer to not return the merchandise.<br />\n	&nbsp;</p>\n	</li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n\n<p>&nbsp;</p>\n\n<p><b>(NOTE TO AGENT- You may remove questions that do not apply)</b></p>\n\n<p>&nbsp;</p>\n\n<p>&nbsp;</p>\n\n<p>Please reply to this email with the information requested above by no later than (<b>TODAY + 9 calendar days. i.e. If today is 07/22, type in 07/31</b>) .&nbsp;<b>Do not</b>&nbsp;include your full account number in your reply. The above information helps us locate your claim transaction(s).<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.</p>\n\n<p>Regards,</p>\n\n<p>&nbsp;</p>\n\n<p>Disputes &amp; Chargebacks<br />\n<br />\n{{{Case.Email_Thread}}}</p>\n</body>\n</html>'
  },
  {
    Id: "00XQk000000JTW9MAO",
    Name: "More Info Needed - Canceled Recurring Transaction",
    Description: "Only for Recurring Transactions",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">
<p>Hi Team,<br />
<br />
We would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder related to&nbsp;<b>Canceled Recurring Transaction</b>.</p>

<ul>
	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>
	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>
	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>
	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:
	<ul>
		<li>[AGENT ENTER TRANSACTION TOKEN]</li>
	</ul>
	</li>
</ul>

<p><br />
Please keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />
<br />
Failure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />
<br />
<b>Supporting Documentation</b><br />
Required<br />
· Date cardholder withdrew permission to charge<br />
· Cancellation Reason<br />
· Contact method with merchant (Email, Call Center Name, Mail, SMS/Text, In-person, Webform)<br />
· Card Network Requires the merchant's Email, Call Center Name, Mailing Address, SMS/Text Number, In-person Address, or Website Name.<br />
· Contact merchant details:<br />
<br />
<b>Good to Have</b><br />
· Purchase order<br />
· Proof of cancellation<br />
· All relevant communication between the cardholder and merchant<br />
<br />
Please Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />
<br />
Kind regards,<br />
Chargebacks &amp; Disputes&nbsp;</p>

<p>{{{Case.Email_Thread}}}</p>
</body>
</html>`
  },
  {
    Id: "00XQk000000SkhSMAS",
    Name: "More Info Needed - Incorrect Amount",
    Description: "",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>Hi Team,<br />\n&nbsp;</p>\n\n<p>We would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for a transaction related to&nbsp;<b>Incorrect Transaction Amount</b>.</p>\n\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>\n	<li><strong>Dispute Amount" [AGENT ENTER DISPUTE AMOUNT]</strong></li>\n	<li><strong>Transaction Token: [AGNET ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n\n<p>Please keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.</p>\n\n<p>&nbsp;</p>\n\n<p>Failure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n&nbsp;</p>\n\n<p><b>Supporting Documentation</b></p>\n\n<p><b>Required</b></p>\n\n<p>A copy of the Transaction Receipt</p>\n\n<p>Certification of the correct Transaction Amount</p>\n\n<p>Dispute Amount (Transaction amount minus amount Cardholder claims is correct)</p>\n\n<p>&nbsp;</p>\n\n<p>**Dispute Amount and Transaction Amount cannot be the same.&nbsp;</p>\n\n<p>&nbsp;</p>\n\n<p>Please Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.</p>\n\n<p>&nbsp;</p>\n\n<p>Kind regards,</p>\n\n<p>Chargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</p>\n</body>\n</html>'
  },
  {
    Id: "00XQk000000gwQzMAI",
    Name: "More Info Needed - Incorrect Transaction Code Pulse",
    Description: "",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>Hi Team,<br />\n&nbsp;</p>\n\n<p>We would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for a transaction related to&nbsp;<b>Incorrect Transaction Code with Pulse</b>.<br />\n&nbsp;</p>\n\n<p>Please keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.</p>\n\n<p>&nbsp;</p>\n\n<p>Failure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n&nbsp;</p>\n\n<p><b>Supporting Documentation</b></p>\n\n<p><b>Required</b><br />\n&nbsp;</p>\n\n<ul>\n	<li>Detailed description of goods returned or services returned</li>\n	<li>Date of return or promised return</li>\n	<li>Return Method</li>\n	<li>Credit Confirmation Number (if Available)</li>\n	<li aria-level="1" style="list-style-type:disc"><span style="overflow:hidden"><span style="overflow-wrap:break-word"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Montserrat,sans-serif"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">Credit slip reflecting a credit OR </span></span></span></span></span></span></span></span><span style="overflow:hidden"><span style="overflow-wrap:break-word"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Montserrat,sans-serif"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">Transaction Receipt reflecting a purchase OR </span></span></span></span></span></span></span></span><span style="overflow:hidden"><span style="overflow-wrap:break-word"><span style="font-size:11pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Montserrat,sans-serif"><span style="color:#000000"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">Evidence of a purchase or Merchant Promise of Credit</span></span></span></span></span></span></span></span></li>\n</ul>\n\n<div style="list-style-type:disc"><b>&nbsp;<br />\n[NOTE TO AGENT - PLEASE REMOVE THIS SECTION IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n\n<ul>\n	<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n</ul>\n</div>\n\n<p><br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.</p>\n\n<p>&nbsp;</p>\n\n<p>Kind regards,</p>\n\n<p>Chargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</p>\n</body>\n</html>'
  },
  {
    Id: "00XQk000000ri7lMAA",
    Name: "More Info Needed - Pulse Canceled Services Non Recurring",
    Description: "More Info Needed - Pulse Canceled Services Non Recurring",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder related to Cancelled Merchandise/Services.\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>\n	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n<br />\n<br />\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\n<strong>Supporting Documentation</strong><br />\n<br />\n<strong>Required</strong><br />\n&nbsp;\n<ol>\n	<li aria-level="2" style="list-style-type:lower-alpha"><span style="font-size:9.5pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Roboto,sans-serif"><span style="color:#333333"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">What service (please provide a detailed description) was ordered and when was it expected to be received?</span></span></span></span></span></span></li>\n	<li aria-level="2" style="list-style-type:lower-alpha"><span style="font-size:9.5pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Roboto,sans-serif"><span style="color:#333333"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">Date SERVICE was canceled</span></span></span></span></span></span></li>\n	<li aria-level="2" style="list-style-type:lower-alpha"><span style="font-size:9.5pt; font-variant:normal; white-space:pre-wrap"><span style="font-family:Roboto,sans-serif"><span style="color:#333333"><span style="font-weight:400"><span style="font-style:italic"><span style="text-decoration:none">Proof of Cancellation (Email, Web Chat, Cancellation Confirmation, App Screenshot)</span></span></span></span></span></span></li>\n</ol>\n<br />\n<br />\n<br />\n<strong>Good Faith Attempt</strong><br />\n<br />\n· Date of contact<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat, etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<strong>Good to Have</strong><br />\n<br />\n· Purchase order<br />\n<br />\n· Proof of cancellation<br />\n<br />\n· All relevant communication between the cardholder and merchant<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</body>\n</html>'
  },
  {
    Id: "00XQk000000EoubMAC",
    Name: "More Info Needed - Paid by Other Means",
    Description: "More Info Needed - Paid by Other Means",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for a transaction related to Paid by Other Means:\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>\n	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that&nbsp;there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\n<br />\n<br />\n<br />\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\nSupporting Documentation<br />\n<br />\nRequired<br />\n<br />\n· Proof transaction was paid by other means (cash receipt, credit/debit receipt, bank statement - redact account/card numbers)<br />\n<br />\n<br />\n<br />\nGood Faith Attempt<br />\n<br />\nRequired<br />\n<br />\n· Date of contact<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat, etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}<br />\n&nbsp;</body>\n</html>'
  },
  {
    Id: "00XQk000000EoplMAC",
    Name: "More Info Needed - Defective/Not as Described",
    Description: "More Info Needed - Defective/Not as Described",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\n<br />\n<br />\nWe would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder for a transaction related to Defective/Not as Described Merchandise or Services.<br />\n&nbsp;\n<ul>\n	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME]</strong></li>\n	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT]</strong></li>\n	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>\n	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that&nbsp;there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:\n	<ul>\n		<li>[AGENT ENTER TRANSACTION TOKEN]</li>\n	</ul>\n	</li>\n</ul>\nPlease keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.<br />\n<br />\n<br />\n<br />\nFailure to provide relevant supporting documentation will likely result in an unfavorable ruling from the Card Network.<br />\n<br />\n<br />\n<strong>Supporting Documentation</strong><br />\n<br />\nRequired<br />\n<br />\n· Specify why the merchandise/service were not as described – detailed description is required<br />\n<br />\n· Who has possession of the merchandise&nbsp;<br />\n<br />\n· Was an attempt made to return the merchandise &nbsp;- detailed description of how is required<br />\n<br />\n· Date of attempted return<br />\n<br />\n<br />\n<br />\n<strong>Good Faith Attempt (Did the cardholder reach out to the merchant?)<br />\n<br />\nRequired</strong><br />\n<br />\n· Date of contact<br />\n<br />\n· Name of the person you contacted<br />\n<br />\n· Method of contact (phone, email, chat, etc.)<br />\n<br />\n· Merchant’s response (provide email/chat correspondence, if possible)<br />\n<br />\n<br />\n<br />\n<strong>Good to Have</strong><br />\n<br />\n· Purchase order<br />\n<br />\n· Images to validate cause for dispute<br />\n<br />\n· Third-party professional opinion letter<br />\n<br />\n· If item was returned provide tracking number for return (Required if Returned)<br />\n<br />\n<br />\n<br />\nPlease Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.<br />\n<br />\n<br />\n<br />\nKind regards,<br />\n<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}<br />\n&nbsp;</body>\n</html>'
  },
  {
    Id: "00XQk000000DvwYMAS",
    Name: "More Info Needed - Cancelled Guaranteed Reservation/Billed No-Show",
    Description: "More Info Needed - Cancelled Guaranteed Reservation/Billed No-Show",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">
<p>Hi Team,</p>

<p>We would like to provide the cardholder with the best opportunity for recovery. However, we need your assistance with requesting supporting documentation from the cardholder related to Cancelled Guaranteed Reservation/Billed No-Show.</p>

<ul>
	<li><strong>Merchant Name: [AGENT ENTER MERCHANT NAME] </strong></li>
	<li><strong>Dispute Amount:&nbsp;[AGENT ENTER DISPUTE AMOUNT] </strong></li>
	<li><strong>Transaction Token:&nbsp;[AGENT ENTER TRANSACTION TOKEN]</strong></li>
	<li><b>[NOTE TO AGENT - PLEASE REMOVE THIS BULLET POINT IF NOT APPLICABLE] Undisputed Transactions</b>: We identified that there were other transactions, which took place within the same timeframe, that have not been disputed. Please review the following transactions and confirm if you recognize them:
	<ul>
		<li>[AGENT ENTER TRANSACTION TOKEN]</li>
	</ul>
	</li>
</ul>

<p>Please keep in mind, the information and documentation we are requesting is required by the Card Networks (Visa, Mastercard, and Discover) to prove the merchant is liable for the disputed transaction.</p>

<p>Failure to provide relevant supporting documentation may result in an unfavorable ruling from the Card Network.</p>

<p><strong>Supporting Documentation Required</strong></p>

<p>· Date of expected services</p>

<p>· Date the Cardholder properly cancelled the Guaranteed Reservation</p>

<p>· Did the attempt to cancel within 24 prior to the service? (Yes/No)</p>

<p>· Did the merchant bill a No-show transaction for more than one day's accommodation? (Yes/No)</p>

<p>· How did the cardholder cancel the services?</p>

<p>Good Faith Attempt Required</p>

<p>· Date of contact</p>

<p>· Name of the person you contacted</p>

<p>· Method of contact (phone, email, chat, etc.)</p>

<p>· Merchant’s response (provide email/chat correspondence, if possible)</p>

<p>Please Note: <strong>If the Reg E configuration is not enabled for the dispute reason code</strong>, we cannot issue provisional credit and file a chargeback until all documentation is received in full. As the program, it is your responsibility to ensure the cardholder is made whole where Reg-E applies while corresponding with the cardholder for supporting documentation. <strong>If the Reg E configuration is enabled for the dispute reason code</strong>, we will issue provisional credit while we wait for you to provide all requested documentation.</p>

<p>Kind regards,<br />
Chargebacks &amp; Disputes&nbsp;<br />
<br />
{{{Case.Email_Thread}}}</p>
</body>
</html>`
  },
  {
    Id: "00XQk000000DDkDMAW",
    Name: "Cardholder Details Request - Rebuttal Received",
    Description: "Cardholder Details Request - Rebuttal Received",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">URGENT RESPONSE REQUIRED<br />
<br />
<br />
Hello Team,<br />
<br />
We have received a merchant rebuttal, but do not have the cardholder's full name, physical address, and email address available to us for this account. This information is required to accurately address the merchant's supporting documentation.&nbsp;<br />
<br />
Please reply directly to this correspondence with the requested information within 5 days. Thank you!<br />
<br />
Kind regards,<br />
<br />
Chargeback &amp; Dispute Team<br />
<br />
{{{Case.Email_Thread}}}</body>
</html>`
  },
  {
    Id: "00XQk000000Dw4bMAC",
    Name: "Cardholder Details Request - Chargeback NOT Filed",
    Description: "Cardholder Details Request - Chargeback NOT Filed",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">
<p>Hello {{{Case.Construct_Name__c}}},<br />
<br />
We have checked our system and see that this particular account does not list cardholder's details.<br />
<br />
We are unable to file a chargeback without the cardholder's full name, physical address, and email address available to us for this account.<br />
<br />
Please respond directly to this correspondence with the requested information so we can file a chargeback on the cardholder's behalf.<br />
<br />
Kind regards,<br />
Chargeback &amp; Dispute Team</p>

<p>{{{Case.Email_Thread}}}</p>
</body>
</html>`
  },
  {
    Id: "00XQk000000EpHBMA0",
    Name: "Cardholder Details Request - Chargeback Filed",
    Description: "Cardholder Details Request - Chargeback Filed",
    FolderName: "Disputes Email Templates",
    HtmlValue: `<html>
<head>
	<title></title>
</head>
<body style="height: auto; min-height: auto;">Hello,<br />
<br />
<br />
We have filed a chargeback on the cardholder's behalf. However, we will not be able to continue with recovery efforts if the merchant files a rebuttal as we do not have the cardholder's full name, physical address, and email address available to us for this account.&nbsp;<br />
<br />
<br />
Please respond directly to this correspondence with the requested information so we can offer the best opportunity for recovery. Thank you!<br />
<br />
<br />
Kind regards,<br />
<br />
Chargebacks &amp; Disputes&nbsp;<br />
<br />
{{{Case.Email_Thread}}}</body>
</html>`
  },
  {
    Id: "00XQk000000EomXMAS",
    Name: "Nature of Claim",
    Description: "Nature of Claim",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">Hi Team,<br />\n<br />\nWe are unable to determine whether your request is related to a Consumer, Processing Error, or Fraud dispute.<br />\n<br />\nPlease provide detailed information as to the nature of your dispute along with supporting documentation.<br />\n<br />\nPlease note, we may request additional documentation based on card network rule and requirement once the nature of your dispute has been identified.<br />\n<br />\nKind regards,<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</body>\n</html>'
  },
  {
    Id: "00XQk000000Dw6DMAS",
    Name: "No Supporting Documentation - Program Push Back",
    Description: "No Supporting Documentation - Program Push Back",
    FolderName: "Disputes Email Templates",
    HtmlValue: '<html>\n<head>\n	<title></title>\n</head>\n<body style="height: auto; min-height: auto;">\n<p>Hi Team,<br />\n<br />\nWe will submit the chargeback with the statement provided from the cardholder, but cannot guarantee a favorable outcome. Without supporting documentation we will not be able to proceed with Arbitration if the merchant does not accept liability.<br />\n<br />\nFeel free to reach out to us if you have any questions. Thank you!<br />\n<br />\nKind regards,<br />\nChargebacks &amp; Disputes<br />\n<br />\n{{{Case.Email_Thread}}}</p>\n\n<p>&nbsp;</p>\n</body>\n</html>'
  }
];
function DisputesMailContainer({
  caseId: initialCaseId,
  hideModal,
  refetchMailData,
  initialSubject
}) {
  const {
    getActiveProgram
  } = disputeStorage || {};
  const activeProgramShortCode = parseAndGet(getActiveProgram(), "short_name");
  const [emailBody, setEmailBody] = useState("");
  const [selectedTemplateName, setSelectedTemplateName] = useState("");
  const [localError, setLocalError] = useState(null);
  const {
    data: ContactData,
    loading: ContactLoading
  } = useSalesforceContact({
    programShortCode: activeProgramShortCode,
    contactRole: SALESFORCE_CONTACT_TYPES.SECONDARY
  });
  const [ccEmail, setCCEmail] = useState("");
  const [emailSubject, setEmailSubject] = useState(initialSubject || "");
  const {
    sendEmail,
    loading: sendEmailLoading,
    error
  } = useSalesforceMailApi();
  const [ccEmailError, setCCEmailError] = useState("");
  const validateEmails = (emails) => {
    if (!emails.trim())
      return true;
    const emailList = emails.split(",").map((email) => email.trim());
    const emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    return emailList.every((email) => emailRegex.test(email));
  };
  const handleCCEmailChange = (e) => {
    const value = e.target.value;
    setCCEmail(value);
    if (!validateEmails(value)) {
      setCCEmailError("Please enter valid comma-separated email addresses");
    } else {
      setCCEmailError("");
    }
  };
  useEffect(() => {
    if (Array.isArray(ContactData)) {
      const emails = ContactData.filter((contact) => contact?.Email).map((contact) => contact.Email).filter((email, index, self2) => self2.indexOf(email) === index);
      setCCEmail(emails.join(", "));
    } else if (ContactData?.Email) {
      setCCEmail(ContactData.Email);
    }
  }, [ContactData]);
  const options = templates$1.map((template) => ({
    val: template.Name,
    render: template.Name,
    // What gets displayed in the dropdown
    searchString: template.Name
    // For searchable dropdown
  }));
  const handleTemplateSelect = (value) => {
    setSelectedTemplateName(value);
    const selected = templates$1.find((template) => template.Name === value);
    if (selected) {
      setEmailBody(selected.HtmlValue);
    }
  };
  const handleEditorChange = (value) => {
    setEmailBody(value);
  };
  const handleSendEmail = async () => {
    try {
      if (!emailBody) {
        setLocalError("Email body cannot be empty");
        return;
      }
      if (!validateEmails(ccEmail)) {
        setLocalError("Please fix the CC email format before sending");
        return;
      }
      const response = await sendEmail({
        caseId: initialCaseId,
        emailBody,
        emailBodyType: "html",
        ccEmailAddress: ccEmail,
        emailSubject
      });
      if (response.data.sendEmail.success === true) {
        hideModal();
        if (refetchMailData) {
          await refetchMailData();
        }
      }
    } catch (error2) {
      console.error("Error sending email:", error2);
    }
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      Select,
      {
        anchor: "left",
        dropDownWrap: {
          width: "300px"
        },
        label: "Email Templates",
        numOptions: 6,
        options: options.map((option) => option.val),
        onChange: (value) => handleTemplateSelect(value),
        value: selectedTemplateName,
        showSearch: true,
        placeholder: "Select from options"
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("form", { onSubmit: (e) => {
      e.preventDefault();
      handleSendEmail();
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "SalesforceCase Id:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { type: "text", value: initialCaseId, readOnly: true, "aria-label": "SalesforceCase Id" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "CC:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { type: "text", value: ccEmail, loading: ContactLoading, onChange: handleCCEmailChange, "aria-label": "CC", disabled: ContactLoading, error: ccEmailError }),
          /* @__PURE__ */ jsxRuntimeExports.jsx("span", { style: {
            fontSize: "12px",
            color: "#666666",
            display: "block",
            marginTop: "4px"
          }, children: "Enter comma-separated email addresses (e.g., email1@domain.com, email2@domain.com)" }),
          ccEmailError && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { "data-testid": "cc-email-error", style: {
            fontSize: "12px",
            color: "#dc3545",
            display: "block",
            marginTop: "4px"
          }, children: ccEmailError })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Subject:" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { type: "text", value: emailSubject, onChange: (e) => setEmailSubject(e.target.value), "aria-label": "Subject" })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {})
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs("label", { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: "Email Body:" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(QuillEditor, { initialValue: emailBody, onChange: handleEditorChange, value: emailBody, "aria-label": "Email Body" })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "submit", loading: sendEmailLoading, children: "Send Email" }),
      localError && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { "data-testid": "local-error", children: [
        "Error sending email: ",
        localError
      ] }),
      error && /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { "data-testid": "api-error", children: [
        "Error sending email: ",
        error.message
      ] })
    ] })
  ] });
}
DisputesMailContainer.propTypes = {
  caseId: PropTypes.string.isRequired,
  hideModal: PropTypes.func.isRequired,
  refetchMailData: PropTypes.func,
  initialSubject: PropTypes.string
};
const DisputesMailContainer$1 = observer(DisputesMailContainer);
const emailContainer = "_emailContainer_l6e9e_2";
const emailHeader = "_emailHeader_l6e9e_8";
const emailDetail = "_emailDetail_l6e9e_12";
const emailMessage = "_emailMessage_l6e9e_16";
const toggleLink = "_toggleLink_l6e9e_20";
const emailDetailLabel = "_emailDetailLabel_l6e9e_26";
const styles = {
  emailContainer,
  emailHeader,
  emailDetail,
  emailMessage,
  toggleLink,
  emailDetailLabel
};
function SalesforceMailDetails({
  salesforceCaseId,
  onRefetchReady
}) {
  const {
    data: salesforceMailData,
    loading: salesforceMailLoading,
    error: salesforceMailError,
    refetch
  } = useGetEmailMessage({
    salesforceCaseId
  });
  const memoizedRefetch = useCallback(() => {
    if (salesforceCaseId) {
      return refetch();
    }
  }, [salesforceCaseId, refetch]);
  useEffect(() => {
    if (onRefetchReady) {
      onRefetchReady(memoizedRefetch);
    }
  }, [memoizedRefetch, onRefetchReady]);
  const [visibleEmailIndex, setVisibleEmailIndex] = useState(null);
  const [showAllEmails, setShowAllEmails] = useState(false);
  const toggleVisibility = (index) => {
    setVisibleEmailIndex(visibleEmailIndex === index ? null : index);
  };
  const toggleShowAllEmails = () => {
    setShowAllEmails(!showAllEmails);
  };
  if (salesforceMailError)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Error: ",
      salesforceMailError.message
    ] });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    salesforceMailLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: salesforceMailLoading, "data-testid": "loading-overlay" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "salesforce-mail-details", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("h4", { children: "Email History" }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
      salesforceMailData && salesforceMailData.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "salesforce-mail-details-list", children: [
        salesforceMailData.slice().reverse().map((email, index) => {
          if (!showAllEmails && index !== 0)
            return null;
          const [visiblePart, hiddenPart] = email.HtmlBody.split("------------------------------");
          const emailDetails = [{
            label: "Subject",
            value: email.Subject
          }, {
            label: "From",
            value: email.FromAddress
          }, {
            label: "To",
            value: email.ToAddress
          }, {
            label: "cc",
            value: email.CcAddress
          }];
          return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: styles.emailContainer, children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("h5", { className: styles.emailHeader, children: [
              "Email ",
              salesforceMailData.length - index
            ] }),
            emailDetails.map((detail) => /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { className: styles.emailDetail, children: [
              /* @__PURE__ */ jsxRuntimeExports.jsxs("span", { className: styles.emailDetailLabel, children: [
                detail.label,
                ":"
              ] }),
              " ",
              detail.value
            ] }, `${email.Id}-${detail.label}`)),
            /* @__PURE__ */ jsxRuntimeExports.jsx("p", { className: styles.emailDetail, children: /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: styles.emailDetailLabel, children: "Message:" }) }),
            /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: {
              __html: visiblePart
            } }),
            hiddenPart && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
              /* @__PURE__ */ jsxRuntimeExports.jsx("button", { onClick: () => toggleVisibility(index), className: styles.toggleLink, children: visibleEmailIndex === index ? "View less" : "View more" }),
              visibleEmailIndex === index && /* @__PURE__ */ jsxRuntimeExports.jsx("div", { dangerouslySetInnerHTML: {
                __html: hiddenPart
              } })
            ] })
          ] }, email.Id || index);
        }),
        salesforceMailData.length > 1 && /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: toggleShowAllEmails, children: showAllEmails ? "Hide" : "Show previous mails" })
      ] }) : !salesforceMailLoading && !salesforceMailError && /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "No email data available." })
    ] })
  ] });
}
SalesforceMailDetails.propTypes = {
  salesforceCaseId: PropTypes.string.isRequired,
  onRefetchReady: PropTypes.func
};
const SalesforceMailDetails$1 = observer(SalesforceMailDetails);
function SalesforceCaseDetails({
  CaseNumber
}) {
  const {
    data: salesforceCaseData,
    loading: salesforceCaseLoading,
    error: salesforceCaseError
  } = useGetSalesforceCase({
    CaseNumber
  });
  const [showSalesforceEmailModal, triggerSalesforceEmailModal, hideSalesforceEmailModal] = useShowEntity(() => {
  }, "Salesforce Email");
  const [salesforceCaseId, setSalesforceCaseId] = useState(null);
  const [refetchMailData, setRefetchMailData] = useState(null);
  useEffect(() => {
    if (salesforceCaseData?.Id) {
      setSalesforceCaseId(salesforceCaseData.Id);
    }
  }, [salesforceCaseData]);
  const handleRefetchReady = useCallback((refetchFn) => {
    setRefetchMailData(() => refetchFn);
  }, []);
  if (salesforceCaseError)
    return /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
      "Error: ",
      salesforceCaseError.message
    ] });
  const modal = /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { heading: "Send Salesforce Email", hideModal: hideSalesforceEmailModal, showHideModalButton: false, children: salesforceCaseData ? /* @__PURE__ */ jsxRuntimeExports.jsx(
    DisputesMailContainer$1,
    {
      caseId: salesforceCaseData.Id,
      hideModal: hideSalesforceEmailModal,
      refetchMailData,
      initialSubject: salesforceCaseData.Subject
    }
  ) : /* @__PURE__ */ jsxRuntimeExports.jsx("p", { children: "Loading case data..." }) });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    salesforceCaseLoading && /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: salesforceCaseLoading, "data-testid": "loading-overlay" }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "communication-history", children: [
      salesforceCaseData && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
        display: "flex",
        justifyContent: "flex-end"
      }, children: [
        showSalesforceEmailModal && modal,
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: triggerSalesforceEmailModal, type: "secondary", children: "Send Salesforce Email" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
      salesforceCaseData && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
          fontSize: "25px",
          marginTop: "-5px",
          marginBottom: "10px",
          fontWeight: 700
        }, children: "SalesforceCase Details" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(History, { mode: "large", hideHeader: true, data: [{
          description: /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Id: ",
              salesforceCaseData?.Id
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Case Number: ",
              salesforceCaseData?.CaseNumber
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Subject: ",
              salesforceCaseData?.Subject
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Description: ",
              salesforceCaseData?.Description
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Record Type Id: ",
              salesforceCaseData?.RecordTypeId
            ] }),
            /* @__PURE__ */ jsxRuntimeExports.jsxs("p", { children: [
              "Account Id: ",
              salesforceCaseData?.AccountId
            ] })
          ] }),
          email: salesforceCaseData?.CreatedBy?.Email,
          timestamp: salesforceCaseData?.CreatedDate
        }] })
      ] }),
      salesforceCaseId && /* @__PURE__ */ jsxRuntimeExports.jsx(
        SalesforceMailDetails$1,
        {
          salesforceCaseId,
          onRefetchReady: handleRefetchReady
        },
        salesforceCaseId
      )
    ] })
  ] });
}
SalesforceCaseDetails.propTypes = {
  CaseNumber: PropTypes.string.isRequired
};
const SalesforceCaseDetails$1 = observer(SalesforceCaseDetails);
function CreateSalesforceTicket({
  caseToken,
  dispute
}) {
  const {
    getActiveProgram
  } = disputeStorage || {};
  const activeProgramShortCode = parseAndGet(getActiveProgram(), "short_name");
  const {
    createNMISalesforceTicket,
    loading: salesforceLoading
  } = useNMISalesforceApi();
  const {
    data: ContactData,
    loading: ContactDataLoading,
    error: ContactDataError
  } = useSalesforceContact({
    programShortCode: activeProgramShortCode,
    contactRole: SALESFORCE_CONTACT_TYPES.PRIMARY
  });
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    dispute_details: {
      dispute_reason,
      dispute_amount
    } = {},
    memo,
    transaction: {
      token: transactionToken
    } = {}
  } = dispute;
  const handleSalesforceTicketCreation = useCallback(async () => {
    if (ContactDataError) {
      setErrorMessage("Error fetching contact data");
      setShowErrorModal(true);
      return;
    }
    if (!ContactData || !ContactData.length) {
      setErrorMessage("Contact data is not available");
      setShowErrorModal(true);
      return;
    }
    const primaryContact = ContactData[0];
    const [firstName, lastName] = primaryContact.Name ? primaryContact.Name.split(" ") : ["", ""];
    const formValues = {
      email: primaryContact.Email || "",
      firstName: firstName || "",
      lastName: lastName || "",
      subject: `${dispute_reason || ""} | ${transactionToken || ""} |  ${dispute_amount || ""}`,
      description: `${caseToken || ""}${memo ? " | " + memo : ""}`,
      recordTypeName: SALESFORCE_CASE_RECORD_TYPE,
      accountId: primaryContact.AccountId || "",
      isNMI: true
    };
    try {
      const response = await createNMISalesforceTicket(formValues);
      const salesforceCaseNumber = response?.data?.createNMISalesforceTicket?.case_number;
      if (salesforceCaseNumber) {
        await dispute.updateZendeskId(salesforceCaseNumber, caseToken);
      }
    } catch (error) {
      const errorMessage2 = error?.graphQLErrors?.[0]?.message || "Unable to create CRM ticket";
      setErrorMessage(errorMessage2);
      setShowErrorModal(true);
    }
  }, [createNMISalesforceTicket, dispute, caseToken, ContactData, ContactDataError, dispute_reason, transactionToken, dispute_amount, memo]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "create-salesforce-ticket-email-communication", style: {
      display: "flex",
      justifyContent: "flex-end"
    }, children: !ContactDataError && ContactDataLoading ? /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: true, "data-testid": "loading-overlay" }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Tooltip, { content: "Only for NMI program communications", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleSalesforceTicketCreation, type: "secondary", loading: salesforceLoading, children: "Create Salesforce Ticket" }) }) }),
    showErrorModal && /* @__PURE__ */ jsxRuntimeExports.jsxs(Modal, { heading: "Error", hideModal: () => setShowErrorModal(false), showHideModalButton: false, type: "sm", "data-testid": "error-modal", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "error-message", children: errorMessage }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: () => setShowErrorModal(false), children: "Close" })
    ] })
  ] });
}
CreateSalesforceTicket.propTypes = {
  caseToken: PropTypes.string.isRequired,
  dispute: PropTypes.shape({
    cardholder: PropTypes.shape({
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      token: PropTypes.string,
      email: PropTypes.string
    }),
    dispute_details: PropTypes.shape({
      dispute_reason: PropTypes.string,
      dispute_amount: PropTypes.string,
      cardholder_email_override: PropTypes.string
    }),
    memo: PropTypes.string,
    transaction: PropTypes.shape({
      token: PropTypes.string
    }),
    zendesk_ticket_id: PropTypes.string,
    alertStore: PropTypes.shape({
      setAlert: PropTypes.func.isRequired
    }).isRequired,
    updateZendeskId: PropTypes.func.isRequired
  }).isRequired
};
function CommunicationHistory({
  dispute
}) {
  const {
    zendesk_ticket_id,
    token
  } = dispute || {};
  const CaseNumber = zendesk_ticket_id;
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { "data-testid": "communication-history", children: CaseNumber ? /* @__PURE__ */ jsxRuntimeExports.jsx(SalesforceCaseDetails$1, { CaseNumber }) : /* @__PURE__ */ jsxRuntimeExports.jsx(CreateSalesforceTicket, { caseToken: token, dispute }) });
}
CommunicationHistory.propTypes = {
  dispute: PropTypes.shape({
    caseToken: PropTypes.string,
    zendesk_ticket_id: PropTypes.string
  })
};
const CommunicationHistory$1 = observer(CommunicationHistory);
const {
  BACKEND_RESOLUTION: BACKEND_RESOLUTION$1,
  SUBMISSION_DETAILS,
  TRANSITION_HISTORY,
  RELATED_TRANSACTIONS
} = DISPUTE_DETAILS_TABS;
const COMMUNICATION_HISTORY = flipFlop.get("create-salesforce-ticket-email-communication", false) ? DISPUTE_DETAILS_TABS.COMMUNICATION_HISTORY : null;
const usePCState = (toggleModal) => {
  const [isSourceBanner, setIsSourceBanner] = useState(false);
  const showPCModal = () => {
    setIsSourceBanner(true);
    toggleModal(true);
  };
  const hidePCModal = () => {
    setIsSourceBanner(false);
    toggleModal(false);
  };
  return [isSourceBanner, showPCModal, hidePCModal];
};
function DisputeDetails({
  dispute,
  goToDisputesQueue,
  goTo,
  canAccessNetworkRefresh
}) {
  const {
    onMemoChange,
    isModalVisible,
    memo,
    ...restTransitionProps
  } = transtionCaseWithNoteModal(dispute);
  const {
    getCreationOrigin,
    getActiveProgram
  } = disputeStorage || EMPTY_OBJECT;
  const activeProgramShortCode = parseAndGet(getActiveProgram(), "short_name");
  const shouldShowRelatedTab = !TMS_PROGRAMS.includes(activeProgramShortCode);
  const origin = getCreationOrigin();
  const {
    availableCaseTransitions,
    createCaseAction,
    createCaseEvent,
    disputesAccess: {
      hasAuxRiskExternalRole,
      hasRiskInternalRole,
      canPerformIssuerWriteOff,
      canPerformDisputesManualTransitions
    },
    dispute_details,
    dispute_transitions,
    formattedDisputeAmountWithCurrency,
    documents: documents2,
    formattedState,
    hasFullDisputesAccess,
    isEditing,
    isEUUKProgram,
    isLegacyDisputeType,
    isMastercard,
    isVisa,
    isNetworkIntegrated,
    isReasonIntegrated,
    isTransactionIntegrated,
    loading,
    milestones,
    shouldBlockReturnToTransactions,
    shouldShowConvertToNonIntegrated,
    showProvisionalCreditModal,
    showCommunicationDateModal,
    state,
    issuePCreditAndSubmit,
    setIssuePCreditAndSubmit,
    toggleProvisionalCreditModal,
    toggleCommunicationDateModal,
    token,
    transitions,
    type_change_time,
    updateNetworkCaseNumber,
    zendesk_ticket_id,
    updateZendeskId,
    disputeFileManager,
    showPCGrantError,
    useWriteOffV2,
    events,
    getChargeback,
    chargeback,
    chargeback_transitions,
    hydrate,
    notes
  } = dispute || EMPTY_OBJECT;
  const {
    dispute_state,
    creditType
  } = dispute_details || EMPTY_OBJECT;
  const {
    attachedDocs,
    case_token,
    loading: isDocumentsLoading,
    retrieveCaseDocuments,
    updateDocument,
    uploadDocument
  } = documents2 || EMPTY_OBJECT;
  const {
    cardholder_contact_date,
    cardholderComsNotSentYet,
    isPCTimeframeExpired,
    isRegE,
    network_case_number,
    network_case_status_details,
    provisionalCreditNotIssuedYet,
    regulation_details,
    dispute_reason
  } = dispute_details || EMPTY_OBJECT;
  const isIncorrectTransactionAmountReason = dispute_reason === "INCORRECT_TRANSACTION_AMOUNT";
  const nwSubmissionValidationError = flipFlop.get("disputes-nw-mandates-oct-2023", false) && isIncorrectTransactionAmountReason && !attachedDocs.length ? ATTACHED_FILES_ARE_REQUIRED : "";
  const {
    attachSelected,
    attachedToForm,
    attachFile,
    detachFile,
    replaceAllByFirstSelected,
    bulkActionType,
    isAttachAvailable,
    sortedItems,
    selected,
    select,
    setBulkActionType,
    setSortBy,
    sortBy,
    selectAll,
    deselectAll,
    deleteOptionIsShown,
    isDocRetrievalAvailable
  } = disputeFileManager || EMPTY_OBJECT;
  const {
    case_status,
    last_refresh_date,
    networkDetailsForRender,
    presentationalAttributesCount,
    refreshNetworkData,
    loading: networkLoading
  } = network_case_status_details || EMPTY_OBJECT;
  const {
    convertToNonIntegratedFormValidation,
    setAttr: setTransitionsAttr,
    sortedTransitions,
    showNetworkSubmissionModal,
    toggleSubmissionModal,
    transitionToInitiated,
    transitionToClosed,
    transitionToWithdrawnAndClosed,
    transitionToNonIntegrated,
    writeOffText,
    writeoffAndClose,
    lastTransitionFailure,
    lastTransition
  } = transitions || EMPTY_OBJECT;
  const {
    actionIsRequired,
    hasPresentableTransitions,
    previousActionLabel,
    previousActionWarning
  } = dispute_transitions || EMPTY_OBJECT;
  const {
    pc_perm_days_to_act: numOfDays
  } = regulation_details || EMPTY_OBJECT;
  const {
    provisionalCreditMilestone,
    latestPCRegEMilestone,
    caseLostCommunicationMilestone
  } = milestones;
  const [showTransactionsOriginModal, setShowTransactionsOriginModal] = useState(origin && !shouldBlockReturnToTransactions);
  const hasDisputesAccess = hasRiskInternalRole || hasAuxRiskExternalRole;
  const shouldShowForIntegrated = dispute.state === STATE_MAP.CHARGEBACK_INITIATED || hasPresentableTransitions && (isMastercard || isVisa);
  const isVisibleWhenClosed = dispute.state === STATE_MAP.CLOSED && hasPresentableTransitions;
  const shouldShowForLegacy = isLegacyDisputeType && (dispute.state === STATE_MAP.CHARGEBACK_INITIATED || isVisibleWhenClosed);
  const shouldShowBackendTab = shouldShowForLegacy || shouldShowForIntegrated;
  const shouldShowBLWarning = !isLegacyDisputeType && isMastercard && hasRiskInternalRole;
  const shouldShowProvisionalCreditBanner = provisionalCreditNotIssuedYet && ![STATE_MAP.CHARGEBACK_INITIATED, STATE_MAP.CLOSED].includes(state);
  const issueProvisionalCreditErrors = useMemo(() => showPCGrantError ? [pcIssuanceErrorText(creditType)] : [], [creditType, showPCGrantError]);
  const tabs = useMemo(() => ORDERED_DISPUTE_DETAILS_TABS.filter((tab) => {
    if (shouldShowBackendTab && tab === BACKEND_RESOLUTION$1 && hasDisputesAccess) {
      return tab;
    }
    if (shouldShowRelatedTab && tab === RELATED_TRANSACTIONS) {
      return tab;
    }
    if (DEFAULT_DISPUTE_DETAILS_TABS.includes(tab)) {
      return tab;
    }
    return null;
  }).filter(Boolean), [shouldShowBackendTab, shouldShowRelatedTab, hasDisputesAccess]);
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [isSourceBanner, showPCModal, hidePCModal] = usePCState(toggleProvisionalCreditModal);
  useEffect(() => {
    setActiveTab(tabs[0]);
  }, [tabs]);
  useEffect(() => {
    if (origin && !shouldBlockReturnToTransactions) {
      setShowTransactionsOriginModal(true);
    }
  }, [state, shouldBlockReturnToTransactions, origin]);
  const BackendResolutionComponent = isLegacyDisputeType ? LegacyDisputeTransitions : NetworkDisputeTransitionsContainer$1;
  const TabsMap = /* @__PURE__ */ new Map([[BACKEND_RESOLUTION$1, /* @__PURE__ */ jsxRuntimeExports.jsx(BackendResolutionComponent, { dispute, goTo }, 1)], [RELATED_TRANSACTIONS, /* @__PURE__ */ jsxRuntimeExports.jsx(RelatedTransactions, { dispute, goTo }, 2)], [SUBMISSION_DETAILS, /* @__PURE__ */ jsxRuntimeExports.jsx(SubmissionDetails$1, { dispute, goTo }, 3)], [TRANSITION_HISTORY, /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionHistory$1, { sortedTransitions, disputeTransitions: dispute_transitions?.data || [], notes, events: events?.data || [] }, 4)]]);
  if (COMMUNICATION_HISTORY) {
    TabsMap.set(COMMUNICATION_HISTORY, /* @__PURE__ */ jsxRuntimeExports.jsx(CommunicationHistory$1, { dispute }, 5));
  }
  const deleteDocumentByToken = async (document2) => {
    await dispute?.documents?.deleteDocument(document2?.token);
    deselectAll();
  };
  const {
    isModalOpen: isManualTransitionModalOpen,
    openModal: actualOpenManualTransitionModal,
    closeModal: closeManualTransitionModal
  } = useManualTransition();
  const openManualTransitionModal = () => {
    getChargeback();
    actualOpenManualTransitionModal();
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("section", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(CloseCaseModalContextWrapper, { isPCTimeframeExpired, transitionToClosed, numOfDays, isEUUKProgram, transitionToWithdrawnAndClosed, formattedDisputeAmountWithCurrency, useWriteOffV2, canPerformIssuerWriteOff, writeoffAndClose, memo, setMemo: onMemoChange, children: /* @__PURE__ */ jsxRuntimeExports.jsx(FileModalsContextWrapper, { replaceAllByFirstSelected, updateDocument, case_token, deleteDocumentByToken, isDocumentsLoading, state, disputeState: dispute_state, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(FileDrawerContextWrapper, { isAttachAvailable, sortBy, bulkActionType, setBulkActionType, selectAll, deselectAll, attachSelected, attachFile, detachFile, selected, items: sortedItems, select, setSortBy, onUploadClick: uploadDocument, getDocumentUrl: dispute?.documents?.getDocumentUrl, acceptedFileTypes: dispute?.documents?.acceptedFileTypes, deleteDocumentByToken, deleteOptionIsShown, attachedSize: attachedToForm?.size, isMastercard, replaceAllByFirstSelected, isDocumentsLoading, onRetrieveCaseDocuments: retrieveCaseDocuments, isDocRetrievalAvailable, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAlert$1, {}),
    showTransactionsOriginModal && /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeFromTransactionModal$1, { transactionOrigin: origin, hideModal: () => setShowTransactionsOriginModal(false), disputeState: state }),
    isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionCaseWithNoteModal, { ...restTransitionProps, onMemoChange, memo }),
    isManualTransitionModalOpen && /* @__PURE__ */ jsxRuntimeExports.jsx(ManualTransitionModal, { closeModal: closeManualTransitionModal, caseToken: token, case_state: state, dispute_state, network_case_state: case_status, dispute_transition_state: dispute_state, case_transition_state: lastTransition?.state || "", chargeback_state: chargeback.state || "", chargeback_transition_state: chargeback_transitions.lastTransitionState || "", hydrateChargebacks: getChargeback, hydrateDispute: hydrate }),
    hasFullDisputesAccess && showNetworkSubmissionModal && /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkSubmissionModal$1, { submitToNetwork: transitionToInitiated, hide: toggleSubmissionModal, isLegacyDisputeType, isRegE, issuePCreditAndSubmit, setIssuePCreditAndSubmit, error: nwSubmissionValidationError }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeDetailsHeader$1, { availableCaseTransitions, caseToken: token, formattedState, goToDisputesQueue, previousActionLabel, writeOffText, state, disputeState: dispute_state, ...canPerformDisputesManualTransitions ? {
      openManualTransitionModal
    } : {}, disputeTransitions: dispute_transitions, isRegE, dispute }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTokenHeader$1, { state, actionIsRequired, children: token }),
    shouldShowBLWarning && /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeTransitionWarning$1, { previousActionWarning }),
    !loading && /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationMessage, { isLegacyDispute: isEditing && !isReasonIntegrated ? false : isLegacyDisputeType, isNetworkIntegrated, isReasonIntegrated: isEditing ? true : isReasonIntegrated, isTransactionIntegrated, isTransitionedToLegacy: Boolean(type_change_time), extraSpacing: !shouldShowBLWarning }),
    shouldShowConvertToNonIntegrated && /* @__PURE__ */ jsxRuntimeExports.jsx(ConvertToNonIntegrated$1, { errors: convertToNonIntegratedFormValidation, memo, onMemoChange, setTransitionsAttr, transitionToNonIntegrated }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(StickyLoadingOverlay, { active: loading, children: [
      !isLegacyDisputeType && /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeNetworkDetails$1, { canAccessNetworkRefresh, caseStatus: case_status, isAdminUser: hasRiskInternalRole, lastRefreshDate: last_refresh_date, loading: networkLoading, networkDetailsForRender, network_case_number, presentationalAttributesCount, provisionalCreditStatus: latestPCRegEMilestone?.milestone, isRegE, refreshNetworkData, state, zendeskTicketId: zendesk_ticket_id, updateZendeskId, caseToken: case_token, isInternalUser: hasRiskInternalRole, creditType, rejectReason: isMastercard && dispute_details?.additional_dispute_details?.reject_reason || "" }),
      isLegacyDisputeType && /* @__PURE__ */ jsxRuntimeExports.jsx(LegacyDisputeNetworkDetails$1, { isInternalUser: hasRiskInternalRole, networkCaseNumber: network_case_number, provisionalCreditStatus: latestPCRegEMilestone?.milestone, isRegE, updateNetworkCaseNumber, state, zendeskTicketId: zendesk_ticket_id, updateZendeskId, creditType, caseToken: case_token }),
      shouldShowProvisionalCreditBanner && /* @__PURE__ */ jsxRuntimeExports.jsx(IssueProvisionalCreditBanner, { banner: provisionalCreditMilestone?.provisionalCreditBanner, showModal: showPCModal }),
      lastTransitionFailure && /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkRulesBanner, { failureReason: lastTransitionFailure, availableCaseTransitions }),
      showProvisionalCreditModal && /* @__PURE__ */ jsxRuntimeExports.jsx(IssueProvisionalCreditModal, { handleSubmit: (action2) => createCaseAction(action2), formattedDisputeAmountWithCurrency, hide: hidePCModal, isSourceBanner, creditType, errors: issueProvisionalCreditErrors }),
      cardholderComsNotSentYet && /* @__PURE__ */ jsxRuntimeExports.jsx(CommunicationDateBanner, { banner: caseLostCommunicationMilestone?.communicationDateBanner, showModal: toggleCommunicationDateModal }),
      showCommunicationDateModal && /* @__PURE__ */ jsxRuntimeExports.jsx(CommunicationDateModal, { handleSubmit: createCaseEvent, minDate: cardholder_contact_date, hide: () => toggleCommunicationDateModal(false) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs, { activeTab, tabs, onTabChange: setActiveTab }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      TabsMap.get(activeTab)
    ] })
  ] }) }) }) });
}
DisputeDetails.propTypes = {
  dispute: PropTypes.any,
  goToDisputesQueue: PropTypes.func,
  goTo: PropTypes.func,
  canAccessNetworkRefresh: PropTypes.bool
};
DisputeDetails.defaultProps = {
  dispute: null,
  goToDisputesQueue: null,
  goTo: null,
  canAccessNetworkRefresh: false
};
const DisputeDetails$1 = observer(DisputeDetails);
const VISA = {
  "dispute_reasons": ["CANCELLED_MERCHANDISE_OR_SERVICES", "CANCELLED_RECURRING_TRANSACTION", "CREDIT_NOT_PROCESSED", "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD", "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD", "INCORRECT_ACCOUNT_NUMBER", "INCORRECT_CURRENCY", "INCORRECT_TRANSACTION_AMOUNT", "INCORRECT_TRANSACTION_CODE", "LATE_PRESENTMENT", "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM", "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE", "NOT_AUTHORIZED_CARD_ABSENT", "NOT_AUTHORIZED_CARD_PRESENT", "NO_AUTHORIZATION", "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED", "DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS", "CARD_RECOVERY_BULLETIN", "DECLINED_AUTH", "COUNTERFEIT_MERCH", "INVALID_DATA", "MISREPRESENTATION", "ORIGINAL_CREDIT_NOT_ACCEPTED"],
  "transaction_types": ["account.funding.auth_plus_capture", "account.funding.authorization.clearing", "authorization.clearing", "authorization.clearing.quasi.cash", "original.credit.auth_plus_capture", "pindebit", "pindebit.atm.withdrawal", "pindebit.authorization.clearing", "pindebit.cashback", "pindebit.quasi.cash"]
};
const MASTERCARD = {
  "dispute_reasons": ["AUTHORIZATION_RELATED_FOR_DUAL_MESSAGE_SYSTEM", "CARDHOLDER_DISPUTE", "CARDHOLDER_DISPUTE_US_ONLY", "CHIP_LIABILITY_SHIFT", "CHIP_PIN_LIABILITY_SHIFT_LOST_STOLEN", "CHIP_READ_POS_LATE_PRESENTMENT", "DOMESTIC_CHARGEBACK_INTRA_EUROPEAN_USE", "INCORRECT_CURRENCY_OR_TRANSACTION_CODE", "INCORRECT_TRANSACTION_CODE", "INSTALLMENT_BILLING_DISPUTE", "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM", "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE", "NOT_AUTHORIZED_CARD_ABSENT", "NOT_AUTHORIZED_CARD_PRESENT", "NO_AUTHORIZATION", "POINT_OF_INTERACTION_ERRORS", "QUESTIONABLE_MERCHANT_ACTIVITY"],
  "transaction_types": ["account.funding.auth_plus_capture", "account.funding.authorization.clearing", "authorization.clearing", "authorization.clearing.quasi.cash", "original.credit.auth_plus_capture", "pindebit", "pindebit.atm.withdrawal", "pindebit.authorization.clearing", "pindebit.cashback", "pindebit.quasi.cash"]
};
const PULSE = {
  "dispute_reasons": ["NO_AUTHORIZATION", "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED", "CANCELLED_RECURRING_TRANSACTION", "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE", "LATE_PRESENTMENT", "NOT_AUTHORIZED_CARD_PRESENT", "NOT_AUTHORIZED_CARD_ABSENT", "CREDIT_NOT_PROCESSED", "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM", "INCORRECT_TRANSACTION_CODE", "DUPLICATE_PROCESSING", "DUPLICATE_PROCESSING_OR_PAID_BY_OTHER_MEANS", "INCORRECT_TRANSACTION_AMOUNT", "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD", "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD", "CANCELLED_MERCHANDISE_OR_SERVICES", "INCORRECT_ACCOUNT_NUMBER"],
  "transaction_types": ["account.funding.auth_plus_capture", "account.funding.authorization.clearing", "authorization.clearing", "authorization.clearing.quasi.cash", "original.credit.auth_plus_capture", "pindebit", "pindebit.atm.withdrawal", "pindebit.authorization.clearing", "pindebit.cashback", "pindebit.quasi.cash"]
};
const SERVICE_INTEGRATIONS = {
  "VISA": VISA,
  "MASTERCARD": MASTERCARD,
  "PULSE": PULSE
};
const GET_SERVICE_INTEGRATIONS = gql`
  query serviceIntegrations {
    serviceIntegrations {
      VISA {
        dispute_reasons
        transaction_types
      }
      MASTERCARD {
        dispute_reasons
        transaction_types
      }
      PULSE {
        dispute_reasons
        transaction_types
      }
    }
  }
`;
const fetchNetworkIntegrationInfoFromLocal = flipFlop.get("fetch-service-integration-from-local", false);
const useServiceIntegrations = () => {
  const {
    getCaseServiceIntegration,
    setCaseServiceIntegration
  } = disputeStorage;
  const [loadIntegrations, {
    data
  }] = useLazyQuery(GET_SERVICE_INTEGRATIONS, {
    onCompleted: (data2) => {
      setCaseServiceIntegration(data2.serviceIntegrations);
    }
  });
  useEffect(() => {
    const caseServiceIntegrations = getCaseServiceIntegration();
    if (caseServiceIntegrations) {
      return;
    }
    fetchNetworkIntegrationInfoFromLocal ? setCaseServiceIntegration(SERVICE_INTEGRATIONS) : loadIntegrations();
  }, [getCaseServiceIntegration, loadIntegrations]);
  return [data || getCaseServiceIntegration()];
};
const CREATE_TICKET = gql`
  mutation createZendeskTicket(
    $attachments: [FileInput]
    $comment: ZendeskCommentInput!
    $priority: String
    $subject: String!
    $submitter: ZendeskSubmitterInput!
  ) {
    createZendeskTicket(
      attachments: $attachments
      comment: $comment
      priority: $priority
      subject: $subject
      submitter: $submitter
    ) {
      ticket {
        id
        subject
        url
      }
    }
  }
`;
const useZendeskApi = () => {
  const [mutation, {
    data,
    loading,
    error
  }] = useMutation(CREATE_TICKET);
  const sendRequest = async (variables) => await mutation({
    variables
  });
  return {
    createTicket: sendRequest,
    data,
    loading,
    error
  };
};
const CasesProgramConfigsContext = createContext(null);
function SelectCaseTypeForm({
  selectedCaseType,
  setSelectedCaseType
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value: selectedCaseType, label: "Case type", groupItems: [{
      label: "Initiate a chargeback",
      value: CASE_TYPES.CHARGEBACK
    }, {
      label: "Report fraud transactions only",
      value: CASE_TYPES.FRAUD_REPORT
    }], inline: false, onChange: (value) => setSelectedCaseType(value) })
  ] });
}
SelectCaseTypeForm.propTypes = {
  selectedCaseType: PropTypes.string,
  setSelectedCaseType: PropTypes.func
};
const SelectCaseTypeForm$1 = observer(SelectCaseTypeForm);
const GET_CARDHOLDER_CHARGEBACK_HISTORY_QUERY = gql`
  query getCardholderChargebackHistory($user_token: String, $card_token: String) {
    getCardholderChargebackHistory(user_token: $user_token, card_token: $card_token) {
      amountOfChargebacksInitiatedByNetworkPast120Days
      numberOfChargebacksInitiatedByNetworkPast120Days
      amountOfChargebacksRejectedByNetworkPast120Days
      numberOfChargebacksRejectedByNetworkPast120Days
    }
  }
`;
const useCardholderChargebackHistory = (options) => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_CARDHOLDER_CHARGEBACK_HISTORY_QUERY, options);
  return {
    data: data?.getCardholderChargebackHistory,
    loading,
    error
  };
};
const CardholderChargebackHistory = ({
  card_token,
  cardholder_token
}) => {
  const [shouldFetchData, setShouldFetchData] = useState(false);
  useEffect(() => {
    if (card_token && cardholder_token) {
      setShouldFetchData(true);
    }
  }, [card_token, cardholder_token]);
  const {
    data,
    loading,
    error
  } = useCardholderChargebackHistory({
    variables: {
      user_token: cardholder_token,
      card_token
    },
    skip: !shouldFetchData
  });
  if (!shouldFetchData || data?.numberOfChargebacksInitiatedByNetworkPast120Days === 0 && data?.numberOfChargebacksRejectedByNetworkPast120Days === 0)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(StickyLoadingOverlay, { active: loading, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    !loading && /* @__PURE__ */ jsxRuntimeExports.jsxs(Admonition, { type: "info", heading: "Cardholder Chargeback History", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
      error && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: error.message }),
      !error && /* @__PURE__ */ jsxRuntimeExports.jsxs(Metrics, { inheritParentWidth: "false", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Metrics.MetricItem, { heading: "Chargebacks Initiated", content: data?.numberOfChargebacksInitiatedByNetworkPast120Days, tooltip: {
          content: "Number of chargebacks initiated with the network over the past 120 days.",
          direction: "topRight"
        } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Metrics.MetricItem, { heading: "Chargeback amount", content: data?.amountOfChargebacksInitiatedByNetworkPast120Days, tooltip: {
          content: "Overall monetary value of chargebacks initiated with the network over the past 120 days.",
          direction: "top"
        }, unit: "USD" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Metrics.MetricItem, { heading: "Network rejects", content: data?.numberOfChargebacksRejectedByNetworkPast120Days, tooltip: {
          content: "Number of chargebacks rejected by the network over the past 120 days.",
          direction: "top"
        } }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Metrics.MetricItem, { heading: "Rejected amount", content: data?.amountOfChargebacksRejectedByNetworkPast120Days, tooltip: {
          content: "Overall monetary value of chargebacks which were rejected by the network over the past 120 days.",
          direction: "topLeft"
        }, unit: "USD" })
      ] })
    ] })
  ] });
};
CardholderChargebackHistory.propTypes = {
  card_token: PropTypes.string.isRequired,
  cardholder_token: PropTypes.string.isRequired
};
function CreateDisputeForm({
  dispute,
  goTo,
  goToDisputesQueue,
  goToDispute,
  disputesAccess
}) {
  const [activeTab, setActiveTab] = useState(DISPUTE_CREATION);
  const {
    cardholder: {
      first_name,
      last_name,
      token: cardholderToken,
      email: cardholderEmail
    } = {},
    createCase,
    digDetails,
    dispute_details: {
      dispute_reason,
      dispute_amount,
      zendesk_mapping,
      cardholder_email_override,
      isProgramRequiredCRM
    } = {},
    disputeFormIsValid,
    handleSuccess,
    isLegacyDisputeType,
    isNetworkIntegrated,
    isTransactionIntegrated,
    loading,
    memo,
    program_short_code,
    setAttr,
    setDigDetails,
    isVisa,
    // Destructure these attributes to force a rerender on update
    transaction: {
      token: transactionToken,
      card,
      cardAcceptor,
      cardholder_transaction_time,
      currency_code,
      cardholder_token,
      card_token
    } = {},
    updateZendeskId,
    selectedCaseType,
    isFraudCase
  } = dispute || {};
  const showZendesk = {
    create: disputesAccess.hasAuxRiskExternalRole && !disputesAccess.hasRiskInternalRole,
    update: disputesAccess.hasRiskInternalRole
  };
  const {
    createTicket,
    loading: zendeskLoading
  } = useZendeskApi();
  const {
    createSalesforceTicket,
    loading: salesforceLoading
  } = useSalesforceApi();
  const getAttr = (attr, formatter) => {
    const value = digDetails(attr);
    if (formatter instanceof Function) {
      return formatter(value);
    }
    return value;
  };
  const handleCreateSubmission = async () => {
    setAttr("formSubmitted", true);
    if (!disputeFormIsValid) {
      return;
    }
    let caseToken;
    try {
      await createCase(({
        token
      }) => () => {
        caseToken = token;
      });
    } catch (error) {
      return;
    }
    if (flipFlop.get("create-salesforce-ticket", false)) {
      await handleSalesforceTicketCreation(caseToken);
    } else {
      await handleZendeskTicketCreation(caseToken);
    }
  };
  const handleSalesforceTicketCreation = async (caseToken) => {
    try {
      if (!caseToken || zendesk_mapping !== "create") {
        return;
      }
      const {
        getActiveProgram
      } = disputeStorage || {};
      const activeProgramShortCode = parseAndGet(getActiveProgram(), "short_name");
      const response = await createSalesforceTicket({
        email: cardholder_email_override || cardholderEmail,
        firstName: first_name,
        lastName: last_name || cardholderToken,
        subject: `${dispute_reason} | ${transactionToken} |  $${dispute_amount}`,
        description: `${caseToken}${memo ? ` | ${memo}` : ""}`,
        recordTypeName: SALESFORCE_RECORD_TYPE_MAP[activeProgramShortCode] || "Coinbase US - Dispute Intake",
        accountName: "Coinbase",
        // hardcoded since this is only for Coinbase use case
        isNMI: false
        /* This is hardcoded to false since this is only for Coinbase use case */
      });
      handleSuccess("Salesforce ticket created");
      const salesforceCaseNumber = response?.data?.createSalesforceTicket?.case_number;
      if (salesforceCaseNumber) {
        await updateZendeskId(salesforceCaseNumber, caseToken);
      }
    } catch (error) {
      dispute.alertStore.setAlert("Unable to create CRM ticket", {
        alertType: TOAST,
        icon: "error"
      });
    } finally {
      if (!caseToken) {
        return;
      }
      goToDispute({
        token: caseToken
      });
    }
  };
  const handleZendeskTicketCreation = async (caseToken) => {
    try {
      if (!caseToken || zendesk_mapping !== "create" || !showZendesk.create) {
        return;
      }
      const {
        disputeBody,
        userInfo
      } = getZendeskData({
        amount: dispute_amount,
        card,
        cardAcceptor,
        cardholder_transaction_time,
        cardholder: dispute.cardholder,
        currency_code,
        memo,
        program_short_code,
        reason: dispute_reason,
        transaction: dispute.transaction
      });
      const response = await createTicket({
        submitter: userInfo,
        subject: formatDisputeSubject({
          caseToken,
          currency_code,
          reason: dispute_reason,
          request_amount: dispute_amount,
          token: transactionToken
        }),
        comment: {
          body: formatDisputeBody(disputeBody)
        },
        priority: "urgent"
      });
      handleSuccess("Zendesk ticket created");
      const zendeskId = response?.data?.createZendeskTicket?.ticket?.id;
      if (zendeskId) {
        await updateZendeskId(zendeskId, caseToken);
      }
    } catch (error) {
      dispute.alertStore.setAlert("Unable to create Zendesk ticket", {
        alertType: TOAST,
        icon: "error"
      });
    } finally {
      if (!caseToken) {
        return;
      }
      goToDispute({
        token: caseToken
      });
    }
  };
  const submitButtons = [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: handleCreateSubmission, testId: "submit-dispute-creation", children: isFraudCase ? "Create Fraud Report" : "Create dispute" }, "submit-dispute-creation")];
  const canRenderBreadcrumbs = goToDisputesQueue instanceof Function;
  const tabs = [DISPUTE_CREATION, RELATED_TRANSACTIONS$2];
  const crumbs = [{
    children: "Dispute queue",
    onClick: goToDisputesQueue
  }, {
    children: "Create dispute"
  }];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAlert$1, {}),
    canRenderBreadcrumbs && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Breadcrumbs, { crumbs }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", testId: "dispute-form-header", children: "Create dispute" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(CardholderChargebackHistory, { card_token, cardholder_token }),
    !loading && /* @__PURE__ */ jsxRuntimeExports.jsx(IntegrationMessage, { isLegacyDispute: isLegacyDisputeType, isNetworkIntegrated, isTransactionIntegrated }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(StickyLoadingOverlay, { active: loading || zendeskLoading || salesforceLoading, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Tabs, { activeTab, onTabChange: setActiveTab, tabs, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      activeTab === DISPUTE_CREATION && /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$c.disputeDetailsFormBody, "data-testid": "create-dispute-form-container", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
          isVisa && /* @__PURE__ */ jsxRuntimeExports.jsx(SelectCaseTypeForm$1, { selectedCaseType, setSelectedCaseType: (val) => dispute.setAttr("selectedCaseType", val) }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeForm$1, { dispute, getAttr, handleChange: setDigDetails, isCreateForm: true, submitButtons, showZendesk })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { className: dds.auxDetailsContainer, children: /* @__PURE__ */ jsxRuntimeExports.jsx(AuxDisputeDetails$1, { dispute, goTo }) })
      ] }),
      activeTab === RELATED_TRANSACTIONS$2 && /* @__PURE__ */ jsxRuntimeExports.jsx(RelatedTransactions, { dispute, goTo })
    ] }) })
  ] });
}
CreateDisputeForm.propTypes = {
  dispute: PropTypes.any,
  goTo: PropTypes.func,
  goToDisputesQueue: PropTypes.func,
  goToDispute: PropTypes.func,
  disputesAccess: PropTypes.object
};
CreateDisputeForm.defaultProps = {
  dispute: null,
  goTo: null,
  goToDisputesQueue: null,
  goToDispute: null,
  disputesAccess: {}
};
const CreateDisputeForm$1 = observer(CreateDisputeForm);
function DisputeActions({
  actions: actions2,
  dispute,
  onRowClick
}) {
  const {
    token,
    documents: documents2
  } = dispute || {};
  const detailsAction = {
    text: "See details",
    onClick: () => onRowClick({
      row: {
        token
      }
    })
  };
  const hasDetailsAction = onRowClick instanceof Function && token;
  const {
    setIsModalVisible
  } = useContext(CloseCaseModalContext);
  const allActions = hasDetailsAction ? [detailsAction, ...actions2] : actions2;
  const handleClickWithShowModal = useCallback((onClick) => {
    onClick();
    setIsModalVisible(true);
  }, [setIsModalVisible]);
  const modifiedActions = allActions.map((action2) => {
    const {
      text,
      onClick,
      shouldShowModal
    } = action2;
    if (text === "Mark as ready") {
      return {
        text,
        onClick: () => onClick(documents2.count)
      };
    }
    if (shouldShowModal) {
      return {
        text,
        onClick: () => handleClickWithShowModal(onClick)
      };
    }
    return action2;
  });
  if (!modifiedActions.length)
    return null;
  return /* @__PURE__ */ jsxRuntimeExports.jsx(ActionsCell, { actions: modifiedActions });
}
DisputeActions.propTypes = {
  actions: PropTypes.array,
  dispute: PropTypes.any,
  onRowClick: PropTypes.func
};
DisputeActions.defaultProps = {
  actions: [],
  dispute: null,
  onRowClick: () => {
  }
};
const DisputeActions$1 = observer(DisputeActions);
const INIT_COLUMNS = [{
  header: "Last modified",
  accessor: "formattedLastModified",
  key: "formattedLastModified",
  noSort: true
}, {
  header: "Next steps",
  accessor: "actionableState",
  key: "actionableState",
  renderer: ({
    cellValue
  }) => {
    if (cellValue === "Action required") {
      return /* @__PURE__ */ jsxRuntimeExports.jsx(Pill, { type: "error", children: cellValue });
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: cellValue });
  }
}, {
  header: "Case state",
  accessor: "formattedState",
  key: "formattedState",
  filterType: "starts-with"
}, {
  header: "Backend state",
  accessor: "dispute_details",
  key: "dispute_state",
  renderer: ({
    cellValue
  }) => {
    const rawValue = cellValue.dispute_state || "";
    const valueToShow = Object.entries(DISPUTE_STATE_OPTIONS).reduce((acc, [key, value]) => {
      if (value === rawValue) {
        acc = key;
      }
      return acc;
    }, "");
    return valueToShow ? /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: valueToShow }) : "";
  }
}, {
  header: "Integrated",
  accessor: "type",
  key: "type",
  renderer: ({
    cellValue
  }) => {
    const textsMap = {
      DISPUTE: "Integrated",
      LEGACY_DISPUTE: "Non integrated"
    };
    return textsMap[cellValue];
  }
}, {
  header: "Case token",
  accessor: "token",
  key: "token"
}, {
  header: "Cardholder name",
  accessor: "formattedCardholder",
  key: "formattedCardholder"
}, {
  header: "Business token",
  accessor: "transaction",
  key: "transaction",
  renderer: ({
    cellValue
  }) => dig(cellValue, "business_token") || ""
}, {
  header: "Transaction token",
  accessor: "dispute_details",
  key: "original_transaction_token",
  renderer: ({
    cellValue
  }) => dig(cellValue, "original_transaction_token") || ""
}, {
  header: "Dispute reason",
  accessor: "basicFormattedDisputeReason",
  key: "basicFormattedDisputeReason"
}, {
  header: "Dispute amount",
  accessor: "formattedDisputeAmount",
  key: "formattedDisputeAmount"
}, {
  header: "Next actor",
  accessor: "dispute_details",
  key: "next_actor",
  renderer: ({
    row
  }) => row.fetchNetworkAttr("next_actor")
}, {
  header: "Days to act",
  accessor: "dispute_details",
  key: "formattedDaysToAct",
  renderer: ({
    row
  }) => row.fetchNetworkAttr("formattedDaysToAct")
}, {
  header: "Network case status",
  accessor: "dispute_details",
  key: "case_status",
  renderer: ({
    row
  }) => row.fetchNetworkAttr("case_status")
}, {
  header: "Network case ID",
  accessor: "dispute_details",
  key: "network_case_number",
  renderer: ({
    cellValue
  }) => dig(cellValue, "network_case_number") || "",
  hide: true
}, {
  header: "Case assignee",
  accessor: "assignee",
  key: "assignee",
  hide: true
}, {
  header: "Currency",
  accessor: "dispute_details",
  key: "currency_code",
  renderer: ({
    cellValue
  }) => dig(cellValue, "currency_code") || "",
  hide: true
}, {
  header: "Time created",
  accessor: "formattedCreatedTime",
  key: "formattedCreatedTime",
  hide: true,
  noSort: true
}];
class DisputesTable extends ParentTable {
  constructor(props) {
    super(props);
    const {
      onRowClick
    } = this.props;
    const actionColumn = {
      header: this.headerRenderer(),
      accessor: "availableCaseTransitions",
      key: "actions",
      renderer: ({
        row,
        cellValue
      }) => /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeActions$1, { actions: cellValue, onRowClick, dispute: row }),
      noPadding: true,
      noResize: true,
      noRowClick: true,
      noSort: true,
      noEdit: true,
      deferRenderPlaceholder: () => /* @__PURE__ */ jsxRuntimeExports.jsx(ActionPlaceholder, { width: 32 })
    };
    this.state = {
      ...this.colEditState(props, [actionColumn, ...INIT_COLUMNS])
    };
  }
  render() {
    const {
      dynamicHeight,
      onRowClick,
      verticalOffset,
      sort,
      data,
      loading,
      onSort,
      updateKey,
      clearFilters: clearFilters2
    } = this.props;
    const tableMinHeight = (data && data.length) > 0 ? 140 : 360;
    const tableHeight = Math.max(tableMinHeight, dynamicHeight - verticalOffset);
    const {
      columns: columns2,
      tableKey
    } = this.state;
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      this.renderColEditTableHeader({
        filterOptions: {},
        tableFilterTestId: "disputes-table-header-buttons"
      }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { columns: columns2, data, deferRenderTimeout: 500, fixedColumnCount: 1, handleColSizeChange: this.handleColSizeChange.bind(this), handleResetTable: clearFilters2, height: tableHeight, loading, onRowClick, onSort, rightAlignFixedColumns: true, scrollToTopUpdateKey: updateKey, sort }, tableKey),
      this.renderPagination()
    ] });
  }
}
DisputesTable.propTypes = {
  sort: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  onSort: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  updateKey: PropTypes.string.isRequired,
  height: PropTypes.number,
  verticalOffset: PropTypes.number,
  localStorageKey: PropTypes.string.isRequired
};
DisputesTable.defaultProps = {
  height: 800,
  verticalOffset: 0,
  localStorageKey: "DisputesTableColumnsConfig"
};
const heightOffset$1 = 56;
const DisputesTable$1 = containerHeightHOC(observer(DisputesTable), heightOffset$1);
const TABS_ARRAY = Object.values(DISPUTES_TABS);
const DisputesTabs = ({
  hydrate,
  state,
  setState
}) => {
  const onTabChange = useCallback((tab) => {
    setState(tab);
    hydrate();
  }, [hydrate, setState]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Tabs, { activeTab: state, tabs: TABS_ARRAY, onTabChange });
};
DisputesTabs.propTypes = {
  state: PropTypes.string,
  setState: PropTypes.func,
  hydrate: PropTypes.func
};
const VALUES = Object.values(SORT_OPTIONS);
const OPTIONS = VALUES.map((val) => ({
  id: val,
  val,
  render: SORT_OPTIONS_LABELS[val]
}));
const WIDTH = "272px";
const NUM_OPTIONS = 5;
const DisputesSorter = ({
  onChange,
  sortBy
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { testId: "disputes-sorter", width: WIDTH, showSearch: false, options: OPTIONS, value: sortBy, onChange, numOptions: NUM_OPTIONS });
DisputesSorter.propTypes = {
  onChange: PropTypes.func.isRequired,
  sortBy: PropTypes.oneOf(VALUES).isRequired
};
const {
  LAST_MODIFIED_NEWEST
} = SORT_OPTIONS;
const SEARCH_OPTIONS = {
  assignee: "String",
  state: "String",
  dispute_state: "String",
  cardholder_token: "ID",
  dispute_amount: "String",
  next_actor: "NEXT_ACTOR",
  original_transaction_token: "ID",
  reason: "String",
  sort_by: "String",
  type: "String",
  network_case_number: "String",
  acquirer_ref_nbr: "String"
};
const STORE_MAP = {
  assignee: "assignee",
  cardholderToken: "cardholder_token",
  reason: "reason",
  disputeAmount: "dispute_amount",
  integrated: "type",
  nextActor: "next_actor",
  state: "state",
  subStates: "subStates",
  transactionToken: "original_transaction_token",
  sortBy: "sort_by",
  networkCaseNumber: "network_case_number",
  acquirerReferenceNumber: "acquirer_ref_nbr"
};
const COUNTABLE_FILTER_LIST = ["assignee", "cardholderToken", "reason", "disputeAmount", "integrated", "nextActor", "state", "transactionToken", "networkCaseNumber", "acquirerReferenceNumber"];
const STORE_DEFAULT_VALUES = {
  assignee: "",
  cardholderToken: "",
  reason: "",
  disputeAmount: "",
  integrated: "",
  nextActor: "",
  state: DISPUTES_TABS.ALL_DISPUTES,
  subStates: [],
  transactionToken: "",
  sortBy: LAST_MODIFIED_NEWEST,
  networkCaseNumber: "",
  acquirerReferenceNumber: ""
};
const REQUIRED_PARSE = {
  subStates: true
};
const InputFilter = ({
  onChange,
  label,
  placeholder,
  value,
  testId
}) => {
  const memoizedOnChange = useCallback((e) => {
    if (onChange) {
      const {
        target: {
          value: value2
        }
      } = e;
      onChange(value2);
    }
  }, [onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label, placeholder, value, type: "text", onChange: memoizedOnChange, preventErrorPushdown: true, testId }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
};
InputFilter.propTypes = {
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  testId: PropTypes.string,
  options: PropTypes.array.isRequired
};
InputFilter.defaultProps = {
  placeholder: "",
  value: ""
};
const RadioGroupFilter = ({
  onChange,
  label,
  value,
  testId,
  options
}) => {
  const memoizedOnChange = useCallback((value2) => onChange && onChange(value2), [onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroup, { value, label, groupItems: options, onChange: memoizedOnChange, testId }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
};
RadioGroupFilter.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  testId: PropTypes.string,
  options: PropTypes.array.isRequired
};
RadioGroupFilter.defaultProps = {
  value: "",
  options: []
};
const SelectFilter = ({
  onChange,
  label,
  placeholder,
  value,
  testId,
  options
}) => {
  const memoizedOnChange = useCallback((e) => onChange && onChange(e), [onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { label, placeholder, value, options, type: "text", onChange: memoizedOnChange, testId, showSearch: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
};
SelectFilter.propTypes = {
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string.isRequired,
  testId: PropTypes.string,
  options: PropTypes.array.isRequired
};
SelectFilter.defaultProps = {
  placeholder: "",
  value: "",
  options: []
};
const CheckboxFilter = ({
  options
}) => {
  return options.map(({
    active,
    label,
    value,
    onClick,
    testId
  }) => {
    return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Checkbox, { active, label, name: value, onClick, testId }, value)
    ] });
  });
};
CheckboxFilter.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    active: PropTypes.string,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    testId: PropTypes.string.isRequired
  })).isRequired
};
CheckboxFilter.defaultProps = {
  options: []
};
const RadioWithChildren = ({
  onChange,
  active,
  testId,
  options,
  innerContent,
  name,
  filterLabel
}) => {
  const memoizedOnChange = useCallback((value) => onChange && onChange(value), [onChange]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": testId, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FormLabel, { children: filterLabel }),
    options.map(({
      value,
      label
    }) => {
      const isActive = active === value;
      return /* @__PURE__ */ jsxRuntimeExports.jsxs(k$1.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Radio, { label, active: isActive, name, onClick: () => memoizedOnChange(value), testId: label }, value),
        isActive ? innerContent : null,
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 })
      ] }, value);
    })
  ] });
};
RadioWithChildren.propTypes = {
  onChange: PropTypes.func,
  active: PropTypes.string.isRequired,
  testId: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })).isRequired,
  innerContent: PropTypes.element,
  name: PropTypes.string.isRequired,
  filterLabel: PropTypes.string.isRequired
};
RadioWithChildren.defaultProps = {
  active: "",
  options: [],
  name: "",
  filterLabel: ""
};
const disputeTableContainer = "_disputeTableContainer_fjlfe_1";
const drawerContent = "_drawerContent_fjlfe_5";
const filterCounter = "_filterCounter_fjlfe_9";
const drawerIsOpened = "_drawerIsOpened_fjlfe_25";
const drawerIsClosed = "_drawerIsClosed_fjlfe_29";
const s$1 = {
  disputeTableContainer,
  drawerContent,
  filterCounter,
  drawerIsOpened,
  drawerIsClosed
};
const DrawerFilters = ({
  setDrawerFiltersState,
  drawerFiltersState
}) => {
  const {
    state,
    subStates,
    nextActor,
    integrated,
    reason,
    cardholderToken,
    transactionToken,
    disputeAmount,
    assignee,
    networkCaseNumber,
    acquirerReferenceNumber
  } = drawerFiltersState;
  const caseStateOnChange = useCallback((val) => setDrawerFiltersState({
    ...drawerFiltersState,
    state: val,
    subStates: DISPUTES_FILTERS_SUB_STATES[val]
  }), [setDrawerFiltersState, drawerFiltersState]);
  const handleFilterChange = useCallback((field, val) => setDrawerFiltersState({
    ...drawerFiltersState,
    [field]: val
  }), [drawerFiltersState]);
  const nextActorOptions = useMemo(() => getOptions(ACTOR_OPTIONS), []);
  const integratedOptions = useMemo(() => getOptions(TYPE_OPTIONS), []);
  const caseCheckboxOnClick = useCallback((isActive, option) => {
    const newSubState = isActive ? subStates.filter((subState) => subState !== option) : [...subStates, option];
    setDrawerFiltersState((prevState) => ({
      ...prevState,
      subStates: newSubState
    }));
  }, [setDrawerFiltersState, subStates]);
  const caseStateOptions2 = useMemo(() => {
    const subStates2 = DISPUTES_FILTERS_SUB_STATES[state];
    return Array.isArray(subStates2) ? subStates2 : [];
  }, [state]);
  const checkboxOptions = caseStateOptions2.map((option) => {
    const isActive = subStates.includes(option);
    return {
      label: getKeyByValue(DISPUTE_STATE_OPTIONS, option),
      value: option,
      active: isActive,
      onClick: () => caseCheckboxOnClick(isActive, option),
      testId: option
    };
  });
  const reasonOptions = useMemo(() => formatDisputeReasonsForFilter(), []);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$1.drawerContent, "data-testid": "drawer-content", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioWithChildren, { onChange: caseStateOnChange, active: state, testId: "table-filter-case-state", options: Object.values(DISPUTES_TABS).map((value) => ({
      value,
      label: value
    })), filterLabel: "Case state", innerContent: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", flexDirection: "row", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flexDirection: "column", children: /* @__PURE__ */ jsxRuntimeExports.jsx(CheckboxFilter, { options: checkboxOptions }) })
    ] }), name: "group-with-checkboxes" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupFilter, { onChange: (val) => handleFilterChange("nextActor", val), label: "Next actor", value: nextActor, testId: "table-filter-radio-actor", options: nextActorOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(RadioGroupFilter, { onChange: (val) => handleFilterChange("integrated", val), label: "Integrated", value: integrated, testId: "table-filter-radio-type", options: integratedOptions }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(SelectFilter, { onChange: ({
      val
    }) => handleFilterChange("reason", val), label: "Dispute reason", value: reason, testId: "table-filter-select-reason", options: reasonOptions, showSearch: true, placeholder: "Select reason or enter reason code" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Dispute amount", value: disputeAmount, onChange: (val) => handleFilterChange("disputeAmount", val), testId: "table-filter-amount-input" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Cardholder token", value: cardholderToken, onChange: (val) => handleFilterChange("cardholderToken", val), testId: "table-filter-cardholder-input" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Transaction token", value: transactionToken, onChange: (val) => handleFilterChange("transactionToken", val), testId: "table-filter-transaction-input" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Case assignee", value: assignee, onChange: (val) => handleFilterChange("assignee", val), testId: "table-filter-assignee-input" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Network case ID", value: networkCaseNumber, onChange: (val) => handleFilterChange("networkCaseNumber", val), testId: "table-filter-network-id-input" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(InputFilter, { label: "Acquirer reference number", value: acquirerReferenceNumber, onChange: (val) => handleFilterChange("acquirerReferenceNumber", val), testId: "table-filter-arn-number" })
  ] });
};
DrawerFilters.propTypes = {
  setDrawerFiltersState: PropTypes.func,
  drawerFiltersState: PropTypes.object
};
DrawerFilters.defaultProps = {
  setDrawerFiltersState: () => {
  },
  drawerFiltersState: {}
};
const DrawerContainer = ({
  isDrawerVisible,
  onDrawerToggle,
  hydrate,
  tableFilter
}) => {
  const {
    setAttr,
    state,
    nextActor,
    integrated,
    reason,
    disputeAmount,
    assignee,
    cardholderToken,
    transactionToken,
    networkCaseNumber,
    acquirerReferenceNumber,
    subStates
  } = tableFilter || EMPTY_OBJECT;
  const parsedSubStates = toJS(subStates || EMPTY_ARRAY);
  const prefilledSubStates = !parsedSubStates.length && state ? DISPUTES_FILTERS_SUB_STATES[state] : parsedSubStates;
  const [drawerFiltersState, setDrawerFiltersState] = useState({
    state,
    nextActor,
    integrated,
    reason,
    disputeAmount,
    assignee,
    cardholderToken,
    transactionToken,
    subStates: prefilledSubStates,
    networkCaseNumber,
    acquirerReferenceNumber
  });
  const handleClear = useCallback(() => {
    setDrawerFiltersState({
      ...STORE_DEFAULT_VALUES
    });
    tableFilter.clear();
    hydrate();
  }, [hydrate, tableFilter]);
  const handleSearch = useCallback((filterState) => {
    Object.keys(filterState).forEach((filterKey) => {
      setAttr(filterKey, filterState[filterKey]);
    });
    hydrate();
  }, [hydrate]);
  const footerButtonsConfig = useMemo(() => {
    return [{
      text: "Clear",
      type: "tertiary",
      testId: "filter-clear-button",
      style: {
        width: "208px"
      },
      key: "clear",
      onClick: handleClear
    }, {
      text: "Filter",
      type: "primary",
      testId: "filter-submit-button",
      style: {
        width: "208px"
      },
      key: "search",
      onClick: () => handleSearch(drawerFiltersState)
    }];
  }, [hydrate, drawerFiltersState]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(Drawer, { isOpened: isDrawerVisible, orientation: "right", backdrop: false, closeDrawer: () => onDrawerToggle(false), dynamicWidth: true, testId: "drawer-for-disputes-table", header: "Filter table", showCloseButton: true, footer: footerButtonsConfig, children: /* @__PURE__ */ jsxRuntimeExports.jsx(DrawerFilters, { drawerFiltersState, setDrawerFiltersState }) });
};
DrawerContainer.propTypes = {
  hydrate: PropTypes.func,
  tableFilter: PropTypes.object,
  isDrawerVisible: PropTypes.bool,
  onDrawerToggle: PropTypes.func
};
const DrawerContainer$1 = observer(DrawerContainer);
function DisputesBanner(props) {
  const {
    banner,
    link,
    label
  } = props;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "disputes-banner", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Alert, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("strong", { children: [
        " ",
        banner
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: () => window.open(link, "_blank"), inline: true, testId: "disputes-inline-btn", children: label })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 })
  ] });
}
DisputesBanner.propTypes = {
  banner: PropTypes.string,
  link: PropTypes.string,
  label: PropTypes.string
};
DisputesBanner.defaultProps = {
  banner: "",
  link: "",
  label: ""
};
const PAGE_HEADER_AND_PADDING = 64;
const PAGE_TAB_HEIGHT = 52;
function DisputesContainer({
  goToDispute,
  goToNewDispute,
  goToBulkUpload,
  store,
  newDispute,
  verticalOffset
}) {
  const {
    hasFullDisputesAccess,
    findInitiatedDisputeSubmission = {},
    currentList,
    itemsAreLoading,
    loading,
    updateKey,
    selectedDispute,
    hydrate,
    activeSort,
    tableFilter
  } = store || EMPTY_OBJECT;
  const {
    setAttr,
    sortBy,
    setState,
    state,
    numberOfAppliedFilters,
    clear
  } = tableFilter || EMPTY_OBJECT;
  const {
    transitions = {},
    isLegacyDisputeType
  } = findInitiatedDisputeSubmission;
  const {
    showNetworkSubmissionModal,
    toggleSubmissionModal,
    transitionToInitiated
  } = transitions;
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const {
    verifyAndLoadAuxDetails
  } = newDispute || {};
  const augmentedVerticalOffset = verticalOffset + PAGE_HEADER_AND_PADDING + PAGE_TAB_HEIGHT;
  const {
    removeCreationOrigin
  } = disputeStorage || {};
  const {
    isModalVisible,
    ...restTransitionProps
  } = transtionCaseWithNoteModal(selectedDispute);
  const hideDocumentModal = () => store.setAttr("documentModalVisible", false);
  const handleTransitionToReady = () => {
    store.transitionToReady();
    hideDocumentModal();
  };
  useEffect(() => {
    removeCreationOrigin && removeCreationOrigin();
    hydrate && hydrate();
  }, [hydrate, removeCreationOrigin]);
  const onSort = useCallback((newSort) => store.setAttr("activeSort", newSort), [store.setAttr]);
  const onRowClick = useCallback(({
    row
  }) => {
    const {
      token
    } = row;
    goToDispute(token);
  }, [goToDispute]);
  const isLoading = useMemo(() => loading || itemsAreLoading, [loading, itemsAreLoading]);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const {
    dispute_details,
    transitions: caseTransitions,
    formattedDisputeAmountWithCurrency,
    useWriteOffV2,
    disputesAccess,
    documents: documents2
  } = selectedDispute || EMPTY_OBJECT;
  const {
    attachedDocs
  } = documents2 || EMPTY_OBJECT;
  const {
    canPerformIssuerWriteOff
  } = disputesAccess || EMPTY_OBJECT;
  const {
    isPCTimeframeExpired,
    dispute_reason
  } = dispute_details || EMPTY_OBJECT;
  const {
    transitionToClosed,
    transitionToWithdrawnAndClosed,
    writeoffAndClose
  } = caseTransitions || EMPTY_OBJECT;
  const showDisputesNetworkMandatesBanner = flipFlop.get("show-disputes-nw-mandates-banner", false);
  const link = "https://www.marqeta.com/docs/developer-guides/card-network-certifications/#_articles_in_development";
  const bannerMessage = "Disputes network mandates. See our release notes ";
  const label = "learn more";
  const isIncorrectTransactionAmountReason = dispute_reason === "INCORRECT_TRANSACTION_AMOUNT";
  const nwSubmissionValidationError = flipFlop.get("disputes-nw-mandates-oct-2023", false) && isIncorrectTransactionAmountReason && !attachedDocs.length ? ATTACHED_FILES_ARE_REQUIRED : "";
  const onSorterChange = useCallback(({
    val
  }) => {
    setAttr("sortBy", val);
    hydrate();
  }, [hydrate, setAttr]);
  const onDrawerToggle = useCallback((flag) => {
    setIsDrawerVisible(flag);
  }, [setIsDrawerVisible]);
  const [drawerContainerKey, setDrawerContainerKey] = useState(state);
  const setTabsState = useCallback((state2) => {
    setDrawerContainerKey(state2);
    setState(state2);
  }, [setState, setDrawerContainerKey]);
  const onToggleButtonClick = useCallback(() => onDrawerToggle(!isDrawerVisible), [onDrawerToggle, isDrawerVisible]);
  const onClearFilters = useCallback(() => {
    clear();
    hydrate();
    setDrawerContainerKey(Math.random());
  }, [clear, hydrate, setDrawerContainerKey]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "disputes-table-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAlert$1, {}),
    showDisputesNetworkMandatesBanner && /* @__PURE__ */ jsxRuntimeExports.jsx(DisputesBanner, { banner: bannerMessage, link, label }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", testId: "disputes-table-header", children: "Disputes" }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { justifyContent: "flex-end", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "tertiary", onClick: goToBulkUpload, testId: "bulk-upload-button", children: "Bulk upload" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "tertiary", onClick: () => setShowTransactionModal(true), testId: "initiate-dispute-creation-button", children: "Create manual case" })
      ] })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputesTabs, { hydrate, state, setState: setTabsState }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s$1.disputeTableContainer, "data-testid": "dispute-table-wrapper", children: [
      store.documentModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(DocumentModal, { transitionToReady: handleTransitionToReady, hide: hideDocumentModal }),
      isModalVisible && /* @__PURE__ */ jsxRuntimeExports.jsx(TransitionCaseWithNoteModal, { ...restTransitionProps }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(CloseCaseModalContextWrapper, { isPCTimeframeExpired, transitionToClosed, transitionToWithdrawnAndClosed, formattedDisputeAmountWithCurrency, useWriteOffV2, canPerformIssuerWriteOff, writeoffAndClose, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", justifyContent: "flex-start", type: "div", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Button, { type: "tertiary", testId: "drawer-filter-toggle-button", onClick: onToggleButtonClick, className: classUtil(numberOfAppliedFilters && s$1.withoutFilters, isDrawerVisible ? s$1.drawerIsOpened : s$1.drawerIsClosed), children: [
            "Filter table",
            !!numberOfAppliedFilters && /* @__PURE__ */ jsxRuntimeExports.jsx("span", { className: s$1.filterCounter, children: numberOfAppliedFilters })
          ] }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 2 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(DisputesSorter, { onChange: onSorterChange, sortBy })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: isLoading, children: /* @__PURE__ */ jsxRuntimeExports.jsx(
          DisputesTable$1,
          {
            store,
            verticalOffset: augmentedVerticalOffset,
            sort: activeSort,
            data: currentList,
            loading: isLoading,
            onSort,
            onRowClick,
            updateKey,
            clearFilters: onClearFilters
          }
        ) })
      ] })
    ] }),
    hasFullDisputesAccess && showNetworkSubmissionModal && /* @__PURE__ */ jsxRuntimeExports.jsx(NetworkSubmissionModal$1, { submitToNetwork: transitionToInitiated, hide: toggleSubmissionModal, isLegacyDisputeType, error: nwSubmissionValidationError }),
    showTransactionModal && /* @__PURE__ */ jsxRuntimeExports.jsx(TransactionTokenInputModal$1, { goToNewDispute, hide: () => setShowTransactionModal(false), verifyTransaction: verifyAndLoadAuxDetails }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(
      DrawerContainer$1,
      {
        isDrawerVisible,
        onDrawerToggle,
        hydrate,
        tableFilter
      },
      drawerContainerKey
    )
  ] });
}
DisputesContainer.propTypes = {
  store: PropTypes.object,
  newDispute: PropTypes.object,
  goTo: PropTypes.func,
  goToNewDispute: PropTypes.func,
  goToDispute: PropTypes.func,
  goToBulkUpload: PropTypes.func,
  verticalOffset: PropTypes.number
};
DisputesContainer.defaultProps = {
  store: {},
  newDispute: {},
  goTo: null,
  goToNewDispute: null,
  goToDispute: null,
  goToBulkUpload: null,
  verticalOffset: 0
};
const DisputesContainer$1 = observer(DisputesContainer);
const BULK_HISTORY_TABLE_COPY = "Refresh this page periodically after uploading a file to see if the upload has completed. Download the failure report to view any disputes that failed to upload. If the file is empty then no failures occurred.";
const STATUSES_KEYS = {
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  PROCESSING: "PROCESSING"
};
const STATUSES = /* @__PURE__ */ new Map([[STATUSES_KEYS.COMPLETED, "Completed"], [STATUSES_KEYS.FAILED, "Failed"], [STATUSES_KEYS.PENDING, "Pending"], [STATUSES_KEYS.PROCESSING, "Processing"]]);
const formatStatus = (value) => STATUSES.get(value);
const initColumns = [{
  header: "File name",
  accessor: "name",
  key: "name",
  renderer: ({
    row
  }) => {
    const {
      file,
      name
    } = row;
    if (!file) {
      return name;
    }
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: file, newTab: true, children: name });
  }
}, {
  header: "Status",
  accessor: "status",
  key: "status",
  renderer: ({
    cellValue
  }) => formatStatus(cellValue)
}, {
  header: "Upload date",
  accessor: "time",
  key: "time",
  minWidth: 228,
  renderer: ({
    cellValue
  }) => formatUTCMoment(cellValue)
}, {
  header: "Failure report",
  accessor: "report",
  key: "report",
  renderer: ({
    row
  }) => row.report ? /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: () => {
    window.open(row.report, "_blank");
    disputesSegmentTrackEvent(BULK_REJECT_FILE_DOWNLOAD_EVENT);
  }, children: "Download report" }) : "",
  minWidth: 264
}];
const UploadHistoryTable = (props) => {
  const {
    dynamicHeight,
    verticalOffset,
    bulkUploadListOptions
  } = props;
  const {
    data,
    loading,
    onNext,
    onPrev
  } = bulkUploadListOptions;
  const tableMinHeight = data?.list?.length > 0 ? 140 : 360;
  const tableHeight = Math.max(tableMinHeight, dynamicHeight - verticalOffset);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "bulk-upload-history-table-wrapper", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "flex", flexWrap: "wrap", children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
      maxWidth: "728px"
    }, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: BULK_HISTORY_TABLE_COPY }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loading, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { columns: initColumns, data: data?.list, deferRenderTimeout: 500, height: tableHeight, loading }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "flex", justifyContent: "flex-end", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Pagination, { endIndex: data?.end, handleNextClick: onNext, handlePreviousClick: onPrev, isLess: data?.start !== 0, isMore: data?.isMore, startIndex: data?.start }) })
    ] })
  ] });
};
UploadHistoryTable.propTypes = {
  dynamicHeight: PropTypes.number,
  height: PropTypes.number,
  refresh: PropTypes.func,
  verticalOffset: PropTypes.number,
  bulkUploadListOptions: PropTypes.shape({
    data: PropTypes.array,
    loading: PropTypes.bool,
    onNext: PropTypes.func,
    onPrev: PropTypes.func
  })
};
UploadHistoryTable.defaultProps = {
  height: 800,
  refresh: () => {
  },
  verticalOffset: 0
};
const tableHeaderAndPadding = 56;
const paginationAndPadding = 32;
const tabsAndPadding = 52;
const heightOffset = tableHeaderAndPadding + paginationAndPadding + tabsAndPadding;
const UploadHistoryTable$1 = containerHeightHOC(UploadHistoryTable, heightOffset);
const SEND_FILE_MUTATION$1 = gql`
  mutation uploadBulkDisputeFile($file_data: String, $file_name: String) {
    file: uploadBulkDisputeFile(file_data: $file_data, file_name: $file_name) {
      file: original_file_link
      name: file_name
      report: reject_report_link
      status
      time: created_time
    }
  }
`;
gql`
  mutation CreateSmartbotQuery($query: String!, $applicationName: String!, $indexName: String!) {
    createSmartbotQuery(query: $query, applicationName: $applicationName, indexName: $indexName) {
      responseText
      queryId
      sessionId
      query
      model_name
      url_list
      metadata
      user_feedback
    }
  }
`;
const defaultState = {
  name: "",
  base64: ""
};
const FileUpload = ({
  acceptedFileTypes,
  mutation,
  onSuccess,
  onError,
  testIdPrefix,
  getMutationVariables
}) => {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [file, setFile] = useState(defaultState);
  const {
    setError
  } = useAlertStore();
  const [uploadFile, {
    loading
  }] = useMutation(mutation, {
    onError,
    onCompleted: () => {
      setFile(defaultState);
      onSuccess(fileInputRef?.current?.resetFile);
    }
  });
  const handleFiles = useCallback(async (file2) => {
    if (!file2) {
      setFile(defaultState);
      return;
    }
    setIsUploading(true);
    try {
      const {
        name
      } = file2;
      const base64 = await toBase64(file2);
      setFile({
        name,
        base64
      });
    } finally {
      setIsUploading(false);
    }
  }, [setFile, setIsUploading]);
  const sendFile = useCallback(() => {
    if (!file?.name) {
      setError(null, "Please select a file to be uploaded using the field above.", {
        modalHeading: "No file selected",
        withSupportLink: false
      });
      return;
    }
    uploadFile({
      variables: getMutationVariables(file.name, file.base64)
    });
  }, [file, uploadFile, getMutationVariables, setError]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": testIdPrefix, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(FileUpload$1, { acceptedFileTypes, allowMultiFiles: false, handleFiles, width: 540, placeholder: "Select file", ref: fileInputRef }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { loading: isUploading || loading, onClick: sendFile, testId: `${testIdPrefix}-submit-button`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", children: [
      "Upload",
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, {}),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "upload", noHoverEffects: true, overrideColor: Colors.white })
    ] }) })
  ] });
};
FileUpload.propTypes = {
  acceptedFileTypes: PropTypes.string,
  mutation: PropTypes.object.isRequired,
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  testIdPrefix: PropTypes.string,
  getMutationVariables: PropTypes.func.isRequired
};
FileUpload.defaultProps = {
  acceptedFileTypes: ".xlsx",
  onSuccess: noop,
  onError: noop,
  testIdPrefix: ""
};
function UploadInput({
  refetch
}) {
  const {
    setError,
    setSuccess
  } = useAlertStore();
  const onUploadSuccess = useCallback(() => {
    setSuccess("File upload initiated");
    if (refetch)
      refetch();
    disputesSegmentTrackEvent(BULK_FILE_UPLOADED_EVENT, {
      errorStatus: false
    });
  }, [setSuccess, refetch]);
  const onUploadError = useCallback((error) => {
    setError(error, "There was an issue uploading the bulk file.", {
      modalHeading: "Bulk upload failed"
    });
    disputesSegmentTrackEvent(BULK_FILE_UPLOADED_EVENT, {
      errorStatus: true
    });
  }, [setError]);
  const getMutationVariables = (fileName, fileData) => {
    return {
      file_data: fileData,
      file_name: fileName
    };
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "bulk-upload-input-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { display: "flex", flexWrap: "wrap", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Flex, { flex: "0 0 728px", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", children: " Bulk upload " }) }) }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(FileUpload, { acceptedFileTypes: ".xlsx", mutation: SEND_FILE_MUTATION$1, onSuccess: onUploadSuccess, onError: onUploadError, testIdPrefix: "bulk-upload", getMutationVariables })
  ] });
}
UploadInput.propTypes = {
  refetch: PropTypes.func.isRequired
};
const GET_BULK_UPLOAD_LIST = gql`
  query getBulkUploadList($count: Int = 50, $start_index: Int = 0, $sort_by: String) {
    response: bulkUploadList(count: $count, sort_by: $sort_by, start_index: $start_index) {
      count
      list: data {
        file: original_file_link
        name: file_name
        report: reject_report_link
        status
        time: created_time
      }
      end: end_index
      isMore: is_more
      start: start_index
    }
  }
`;
const GET_BULK_DISPUTE_TEMPLATE_LINK = gql`
  query bulkDisputeTemplateLink {
    link: bulkDisputeTemplateLink
  }
`;
const GET_FRAUD_TEMPLATE_LINK = gql`
  query fraudTemplateLink {
    link: fraudTemplateLink
  }
`;
const RECORDS_PER_REQUEST = 50;
const useBulkUploadedList = (options) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_BULK_UPLOAD_LIST, options);
  const onNext = useCallback(() => refetch({
    count: RECORDS_PER_REQUEST,
    start_index: data?.response?.end + 1,
    sort_by: "-lastModifiedTime"
  }), [data?.response?.end, refetch]);
  const onPrev = useCallback(() => refetch({
    count: RECORDS_PER_REQUEST,
    start_index: data?.response?.start - RECORDS_PER_REQUEST,
    sort_by: "-lastModifiedTime"
  }), [data?.response?.start, refetch]);
  const refetchFirstPage = useCallback(() => refetch({
    count: RECORDS_PER_REQUEST,
    start_index: 0,
    sort_by: "-lastModifiedTime"
  }), [options, refetch]);
  return {
    data: data?.response,
    loading,
    error,
    refetch: refetchFirstPage,
    onNext,
    onPrev
  };
};
const useGetTemplateLink = (options) => {
  const {
    data
  } = useQuery(GET_BULK_DISPUTE_TEMPLATE_LINK, options);
  return data?.link;
};
const useGetFraudTemplateLink = (options) => {
  const {
    data
  } = useQuery(GET_FRAUD_TEMPLATE_LINK, options);
  return data?.link;
};
const CHARGEBACK_LINK_TEXT = `This format is for submitting a chargeback and reporting fraud automatically (when applicable) to the card network.`;
const FRAUD_LINK_TEXT = `This format is for only reporting fraud to the card network without the creation of a chargeback.`;
const BULK_UPLOAD_BANNER_TEXT = `This is a beta feature currently supported for Visa programs only. 
Please contact your Customer Success Manager if you are interested in using this feature. `;
const TEMPLATE_LINK_ICON_STYLE = {
  marginRight: "7px"
};
const BANNER_STYLE = {
  maxWidth: "728px"
};
const bulkUploadTemplates = "_bulkUploadTemplates_1wyys_1";
const bulkUploadHelperText = "_bulkUploadHelperText_1wyys_9";
const s = {
  bulkUploadTemplates,
  bulkUploadHelperText
};
function TemplateLink({
  link,
  text,
  description
}) {
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: link, newTab: true, testId: `upload_template-link-${text}`, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", alignItems: "center", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "download", mod: "default", overrideColor: Colors.actionColor, factor: 1, noHoverEffects: true, style: TEMPLATE_LINK_ICON_STYLE }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", inline: true, testId: "bulk-xlsx-templates", color: Colors.actionColor, children: text })
      ] }) }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 0.5 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "body/sm", className: s.bulkUploadHelperText, testId: "template-link-description", children: description })
    ] })
  ] });
}
TemplateLink.propTypes = {
  link: PropTypes.string,
  text: PropTypes.string,
  description: PropTypes.string
};
TemplateLink.defaultProps = {
  link: "",
  text: "",
  description: ""
};
const TemplateLink$1 = observer(TemplateLink);
function UploadTemplates() {
  const chargebackLink = useGetTemplateLink();
  const fraudLink = useGetFraudTemplateLink();
  const bulkUploadTemplateStyle = {
    borderColor: Colors.blackLighter6
  };
  const iconStyle = {
    display: "inlineBlock",
    marginRight: "7px"
  };
  const uploadTemplates = [{
    text: "Chargeback",
    link: chargebackLink,
    description: CHARGEBACK_LINK_TEXT
  }, {
    text: "Fraud report",
    link: fraudLink,
    description: FRAUD_LINK_TEXT
  }];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { className: s.bulkUploadTemplates, style: bulkUploadTemplateStyle, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", className: s.templatesHeader, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "doc", mod: "default", factor: 1, noHoverEffects: true, style: iconStyle }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h6", testId: "bulk-xlsx-templates", children: ".xlsx templates" })
    ] }),
    uploadTemplates.map((item) => /* @__PURE__ */ jsxRuntimeExports.jsx(TemplateLink$1, { ...item }, item.text))
  ] });
}
const UploadTemplates$1 = observer(UploadTemplates);
function BulkUploadContainer({
  verticalOffset,
  goToDisputes
}) {
  const bulkUploadInputHeightAndPadding = 184 + 24;
  const augmentedVerticalOffset = verticalOffset + bulkUploadInputHeightAndPadding;
  const {
    data,
    loading,
    onNext,
    onPrev,
    refetch
  } = useBulkUploadedList({
    notifyOnNetworkStatusChange: true,
    variables: {
      count: 50,
      sort_by: "-lastModifiedTime"
    }
  });
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { "data-testid": "bulk-upload-container", children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAlert$1, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { display: "flex", justifyContent: "space-between", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
        flex: 1
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: BANNER_STYLE, children: /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { maxTextWidth: "100%", children: BULK_UPLOAD_BANNER_TEXT }) }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(UploadInput, { refetch }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(UploadHistoryTable$1, { bulkUploadListOptions: {
          data,
          loading,
          onNext,
          onPrev
        }, verticalOffset: augmentedVerticalOffset })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(UploadTemplates$1, {})
    ] })
  ] });
}
BulkUploadContainer.propTypes = {
  verticalOffset: PropTypes.number,
  goToDisputes: PropTypes.func,
  gqlClient: PropTypes.object
};
BulkUploadContainer.defaultProps = {
  verticalPadding: 0,
  goToDisputes: null,
  gqlClient: null
};
const BulkUploadContainer$1 = observer(BulkUploadContainer);
const inputMonthDateFormat = "MM/YYYY";
const sectionTitleDateFormat = "MMMM YYYY";
const uploadDateFormat = "YYYY-MM-DD HH:mm";
const sortByDate = (a, b) => moment(b.reporting_month, inputMonthDateFormat).diff(moment(a.reporting_month, inputMonthDateFormat));
const formatAccordionHeading = (reportingMonth) => moment(reportingMonth, inputMonthDateFormat).format(sectionTitleDateFormat);
const formatUploadDate = (uploadDate) => moment(uploadDate).local().format(uploadDateFormat);
const BankReportUploadBanner = ({
  goToReports
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(BoxContainer, { width: 91, children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { children: [
    "Please upload the modified bank report here. Smaller files will result in faster upload times. If you want to refer to the latest version, please head to the ",
    /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { inline: true, testId: "report-page-link", onClick: goToReports, children: "Reports page." })
  ] }) });
};
BankReportUploadBanner.propTypes = {
  goToReports: PropTypes.func.isRequired
};
const SEND_FILE_MUTATION = gql`
  mutation uploadBankReport(
    $type: String
    $report_name: String
    $multi_program_code: String
    $report_data: String
    $created_by: String
  ) {
    file: uploadBankReport(
      type: $type
      report_name: $report_name
      multi_program_code: $multi_program_code
      report_data: $report_data
      created_by: $created_by
    ) {
      message: message
    }
  }
`;
const BankReportUpload = ({
  refetch
}) => {
  const {
    setError,
    setSuccess
  } = useAlertStore();
  const onUploadSuccess = useCallback((reset = () => {
  }) => {
    setSuccess("File upload initiated");
    refetch();
    reset();
  }, [setSuccess, refetch]);
  const onUploadError = useCallback((error) => {
    setError(error, "There was an issue uploading the bank report file.", {
      modalHeading: "Bank report upload failed"
    });
  }, [setError]);
  const getMutationVariables = useCallback((fileName, fileData) => {
    const date = moment().format("DDMMYYYY");
    const ext = fileName.split(".").pop();
    const activeProgram = disputeStorage?.getActiveProgram();
    const programName = safeParse(activeProgram)?.program || "";
    const updatedFileName = `BankReport_${programName}_${date}.${ext}`;
    return {
      type: "BANK",
      report_name: updatedFileName,
      report_data: fileData,
      created_by: currentUserFromStorage()
    };
  }, []);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(FileUpload, { acceptedFileTypes: ".xlsx, .xls", mutation: SEND_FILE_MUTATION, onSuccess: onUploadSuccess, onError: onUploadError, testIdPrefix: "bank-report-upload", getMutationVariables });
};
BankReportUpload.propTypes = {
  refetch: PropTypes$1.func.isRequired
};
BankReportUpload.propTypes = {
  refetch: () => {
  }
};
const RefreshButton = ({
  onClick
}) => /* @__PURE__ */ jsxRuntimeExports.jsx(BoxContainer, { padding: [0, 2, 0, 2], children: /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick, type: "secondary", iconType: "refresh12", iconDirection: "left", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { color: Colors.blackLighter3, inline: true, type: "pre", children: "Refresh" }) }) });
RefreshButton.propTypes = {
  onClick: PropTypes.func.isRequired
};
RefreshButton.defaultProps = {
  onClick: noop
};
const UPLOAD_ERROR = "Completed files will appear in the table below. After uploading a file refresh the upload history section periodically to see if uploads have completed. Download the failure report to view any error message. If the file is empty then no failures occurred.";
const UPLOAD_TITLE = "Bank report upload history";
const PAGE_TITLE = "Disputes bank reporting";
const FailedReportLink = ({
  url
}) => /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { children: [
  "Issue found from validation, download the",
  " ",
  /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab: true, inline: true, children: "failure report" })
] });
FailedReportLink.propTypes = {
  url: PropTypes.string.isRequired
};
const columns = [{
  header: "File name",
  accessor: "report_name",
  key: "report_name",
  width: 380,
  renderer: ({
    row
  }) => {
    const {
      original_file_url,
      report_name,
      failed_file_url
    } = row;
    const url = failed_file_url || original_file_url;
    if (!url)
      return report_name;
    return /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { href: url, newTab: true, children: report_name });
  }
}, {
  header: "Upload date",
  accessor: "uploaded_date",
  key: "uploaded_date",
  renderer: ({
    cellValue
  }) => formatUTCMoment(cellValue)
}, {
  header: "Upload status",
  accessor: "status",
  key: "status",
  width: 420,
  renderer: ({
    row
  }) => {
    const {
      failed_file_url,
      status
    } = row;
    if (failed_file_url)
      return /* @__PURE__ */ jsxRuntimeExports.jsx(FailedReportLink, { url: failed_file_url });
    return STATUS_MESSAGES[status] || status;
  }
}];
const STATUS_MESSAGES = {
  PENDING: "Successfully uploaded, waiting in queue for validation",
  PROCESSING: "File is being validated",
  PROCESSED: "Successfully validated, no issue found",
  FAILED: "File processing failed"
};
const ROW_HEIGHT = 40;
const HEADER_HEIGHT = ROW_HEIGHT;
const MAX_TABLE_HEIGHT = 600;
const BankReportUploadHistory = ({
  onRefresh,
  reports
}) => {
  const rowCount = reports.length;
  const tableHeight = rowCount > 10 ? MAX_TABLE_HEIGHT : rowCount * ROW_HEIGHT + HEADER_HEIGHT;
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsxs(BoxContainer, { width: 91, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "center", justifyContent: "flex-start", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h5", inline: true, children: UPLOAD_TITLE }),
        onRefresh ? /* @__PURE__ */ jsxRuntimeExports.jsx(RefreshButton, { onClick: onRefresh }) : null
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: UPLOAD_ERROR })
    ] }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    reports.length > 0 ? /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { maxColumnWidth: 1e4, height: tableHeight, automaticallySizeColumnWidth: true, testId: "bank-report-history-table", loading: false, data: reports, columns }) : /* @__PURE__ */ jsxRuntimeExports.jsx(EmptyState, { type: "large", text: "No reports uploaded yet", testId: "sections-empty", iconType: "empty-state-folder" })
  ] });
};
BankReportUploadHistory.propTypes = {
  onRefresh: PropTypes.func,
  reports: PropTypes.array.isRequired
};
const sectionsList = (map, goToReports, onRefresh, mostRecentMonth) => {
  return Array.from(map, ([name, reports], idx) => {
    const hasReports = !!reports.length;
    const isMostRecentMonth = name === mostRecentMonth;
    return {
      title: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h4", inline: false, children: moment(name).format(sectionTitleDateFormat) }),
      key: name,
      defaultExpanded: !idx,
      content: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: {
        width: "100%"
      }, children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
        isMostRecentMonth && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(BankReportUploadBanner, { goToReports }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(BankReportUpload, { refetch: onRefresh })
        ] }),
        isMostRecentMonth && hasReports && /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        hasReports && /* @__PURE__ */ jsxRuntimeExports.jsx(BankReportUploadHistory, { reports, onRefresh: isMostRecentMonth ? onRefresh : null })
      ] })
    };
  });
};
const BankReportingHistoryAccordion = ({
  bankReports = [],
  goToReports,
  onRefresh,
  mostRecentMonth
}) => {
  const initialMap = /* @__PURE__ */ new Map([[mostRecentMonth, []]]);
  const sectionsContent = useMemo(() => {
    const sortedMap = bankReports.sort(sortByDate).reduce((map, report) => {
      const {
        reporting_month,
        uploaded_date
      } = report;
      const accordionItemHeader = formatAccordionHeading(reporting_month);
      const formattedUploadedDate = formatUploadDate(uploaded_date);
      return map.set(accordionItemHeader, [...map.get(accordionItemHeader) || [], {
        ...report,
        uploaded_date: formattedUploadedDate
      }]);
    }, initialMap);
    return sectionsList(sortedMap, goToReports, onRefresh, mostRecentMonth);
  }, [bankReports]);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Accordion, { spaceBetween: "18px", divideSections: true, sections: sectionsContent })
  ] });
};
BankReportingHistoryAccordion.propTypes = {
  bankReports: PropTypes.arrayOf(PropTypes.any).isRequired,
  goToReports: PropTypes.func.isRequired,
  onRefresh: PropTypes.func.isRequired,
  mostRecentMonth: PropTypes.string.isRequired
};
BankReportingHistoryAccordion.defaultProps = {
  bankReports: [],
  goToReports: () => {
  },
  onRefresh: () => {
  }
};
const GET_BANK_REPORTS = gql`
  query bankReports(
    $start_index: Int = 0
    $type: String = "BANK"
    $count: Int = 100
    $sort_by: String = "-createdTime"
  ) {
    bankReports: bankReports(
      start_index: $start_index
      count: $count
      type: $type
      sort_by: $sort_by
    ) {
      count
      start_index
      end_index
      is_more
      data {
        report_name
        type
        reporting_month
        uploaded_date
        processed_date
        submit_date
        program_short_code
        created_by
        status
        original_file_url
        failed_file_url
      }
    }
  }
`;
const useBankReports = (options) => {
  const {
    data: {
      bankReports: {
        data,
        end_index,
        is_more
      } = {}
    } = {},
    refetch,
    fetchMore,
    ...rest
  } = useQuery(GET_BANK_REPORTS, options);
  const loadMore = useCallback(() => {
    fetchMore({
      variables: {
        start_index: end_index + 1
      },
      updateQuery: ({
        bankReports: prevBankReports
      }, {
        fetchMoreResult: {
          bankReports = {}
        }
      }) => {
        const {
          data: data2
        } = bankReports;
        if (!data2.length) {
          return {
            bankReports: prevBankReports
          };
        }
        return {
          bankReports: {
            ...bankReports,
            data: [...prevBankReports.data, ...data2]
          }
        };
      }
    });
  }, [end_index, fetchMore]);
  return {
    data,
    refetch,
    loadMore,
    is_more,
    ...rest
  };
};
const BankReportingContainer = ({
  goToReports
}) => {
  const {
    data,
    loading,
    refetch,
    loadMore,
    is_more
  } = useBankReports({
    fetchPolicy: "network-only",
    notifyOnNetworkStatusChange: true
  });
  const mostRecentMonth = moment().subtract(1, "months").format(sectionTitleDateFormat);
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(DisputeAlert$1, {}),
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", children: PAGE_TITLE }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { size: 32, active: loading, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(BankReportingHistoryAccordion, { bankReports: data, goToReports, onRefresh: refetch, mostRecentMonth }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      is_more ? /* @__PURE__ */ jsxRuntimeExports.jsx(Link, { onClick: loadMore, href: "", newTab: false, children: "Load more" }) : null
    ] })
  ] });
};
BankReportingContainer.propTypes = {
  gqlClient: PropTypes.object,
  goToReports: PropTypes.func.isRequired
};
BankReportingContainer.defaultProps = {
  gqlClient: null
};
const {
  FRONTEND_INTAKE,
  BACKEND_RESOLUTION,
  CLOSED
} = DISPUTES_TABS;
const {
  getFilter = NO_OP,
  setFilter = NO_OP,
  clearFilters = NO_OP
} = disputeStorage || EMPTY_OBJECT;
class DisputesTableFilterStore {
  constructor(initialValues) {
    this.clear = () => {
      clearFilters();
      Object.assign(this, STORE_DEFAULT_VALUES);
    };
    this.initiate = () => {
      try {
        Object.keys(STORE_MAP).map((key) => {
          const value = getFilter(STORE_MAP[key]);
          if (value) {
            this[key] = REQUIRED_PARSE[key] ? JSON.parse(value) : value;
          }
        });
      } catch (e) {
        console.error(e);
      }
    };
    this.setAttr = (attr, value) => {
      if (STORE_MAP[attr]) {
        this[attr] = value;
        if (REQUIRED_PARSE[attr]) {
          setFilter(STORE_MAP[attr], JSON.stringify(value));
        } else {
          setFilter(STORE_MAP[attr], value);
        }
      }
    };
    this.setState = (state) => {
      this.setAttr("state", state);
      this.subStates = [];
    };
    Object.assign(this, initialValues);
  }
  // computed
  get stateQueryParam() {
    let state = "";
    let dispute_state = "";
    try {
      state = DISPUTES_TABS_FILTER_MAP[this.state].join(",");
      if (this.state === FRONTEND_INTAKE) {
        if (this.subStates.length) {
          state = this.subStates.join(",");
        }
      } else if ([BACKEND_RESOLUTION, CLOSED].includes(this.state)) {
        if (this.subStates.length) {
          dispute_state = this.subStates.join(",");
        }
      }
      return {
        state,
        dispute_state
      };
    } catch (e) {
      return {
        state,
        dispute_state
      };
    }
  }
  get formattedQueryParams() {
    const paramsInfo = {
      dispute_state: {
        type: SEARCH_OPTIONS["dispute_state"],
        val: this.stateQueryParam.dispute_state
      },
      state: {
        type: SEARCH_OPTIONS["state"],
        val: this.stateQueryParam.state
      }
    };
    Object.keys(STORE_MAP).filter((key) => !["state", "subStates"].includes(key)).forEach((option) => {
      if (this[option]) {
        paramsInfo[STORE_MAP[option]] = {
          type: SEARCH_OPTIONS[STORE_MAP[option]],
          val: this[option]
        };
      }
    });
    return paramsInfo;
  }
  get numberOfAppliedFilters() {
    return COUNTABLE_FILTER_LIST.reduce((sum, key) => {
      if (this[key] && this[key] !== DISPUTES_TABS.ALL_DISPUTES) {
        sum++;
      }
      return sum;
    }, 0);
  }
}
decorate(DisputesTableFilterStore, {
  // observables
  activeSort: observable,
  acquirerReferenceNumber: observable,
  assignee: observable,
  cardholderToken: observable,
  disputeAmount: observable,
  reason: observable,
  integrated: observable,
  nextActor: observable,
  sortBy: observable,
  state: observable,
  subStates: observable,
  transactionToken: observable,
  networkCaseNumber: observable,
  // actions
  clear: action.bound,
  initiate: action.bound,
  setAttr: action.bound,
  setState: action.bound,
  // computeds
  formattedQueryParams: computed,
  stateQueryParam: computed,
  numberOfAppliedFilters: computed
});
const {
  fragments,
  templates
} = gqlUtils;
class DisputesTableStore extends ParentTableStore {
  constructor(args = {}) {
    super(args);
    this.items = [];
    this.count = 50;
    this.disputesAccess = {};
    this.documentModalVisible = false;
    this.transitionToReady = () => {
    };
    this.selectedDispute = null;
    this.tableFilter = new DisputesTableFilterStore(STORE_DEFAULT_VALUES);
    this.programConfigs = {};
    this.load(args);
    this.tableFilter.initiate();
  }
  // actions
  async hydrate() {
    this.loading = true;
    const disputesAccess = this.disputesAccess;
    try {
      const result = await this.fetchDisputes();
      const {
        programConfigs
      } = this;
      runInAction(() => {
        const items = this.extract(result, "cases");
        const modifiedItems = {
          ...items,
          data: items.data.map((entry) => ({
            ...entry,
            programConfigs,
            disputesAccess
          }))
        };
        this.processPaginationResponse(modifiedItems, DisputeStore);
        this.trackFilterEvent(false);
        this.loading = false;
      });
    } catch (err) {
      this.loading = false;
      this.trackFilterEvent(true);
    }
  }
  trackFilterEvent(errorStatus) {
    const queryParams = this.configureQueryParams(this.tableFilter.formattedQueryParams);
    const filterKeys = Object.keys(queryParams);
    disputesSegmentTrackEvent(DISPUTES_QUEUE_FILTERED, {
      filterKeys,
      errorStatus
    });
  }
  async fetchDisputes() {
    const queryParams = this.configureQueryParams(this.tableFilter.formattedQueryParams);
    const queryAndPaginationParams = Object.assign({}, this.paginationParams, queryParams);
    return await this.gqlQuery(this.queryStatement(this.tableFilter.formattedQueryParams), queryAndPaginationParams);
  }
  queryStatement(paramsInfo = {}) {
    if (!this.enableNoParamQuery && !this.validParams)
      return;
    const defaultOuterParams = `(${this.configureOuterQueryParams(paramsInfo)} $count: Int $start_index: Int)`;
    const defaultInnerParams = `(${this.configureInnerQueryParams(paramsInfo)} count: $count start_index: $start_index)`;
    return `
      query cases${defaultOuterParams} {
        cases${defaultInnerParams} {
          data {
            ${templates.disputeBaseInfo}
            documents {
              count
            }
            transaction {
              network
              business_token
            }
          }
          ${this.paginationAttributes}
        }
      }
      ${fragments.disputeDetailsInfo}
      ${fragments.networkCaseStatusDetailsInfo}
    `;
  }
  setSelectedDispute(dispute) {
    this.selectedDispute = dispute;
  }
  get findInitiatedDisputeSubmission() {
    if (!(this.items && this.items.find))
      return null;
    return this.items.find((item) => this.dig(item, "transitions", "showNetworkSubmissionModal"));
  }
  get itemsAreLoading() {
    try {
      return this.items.some((item) => item.loading);
    } catch {
      return false;
    }
  }
}
decorate(DisputesTableStore, {
  // values
  documentModalVisible: observable,
  disputesAccess: observable,
  items: observable,
  transitionToReady: observable,
  selectedDispute: observable,
  programConfigs: observable,
  // actions
  fetchDisputes: action.bound,
  hydrate: action.bound,
  queryStatement: action.bound,
  setSelectedDispute: action.bound,
  // computed
  findInitiatedDisputeSubmission: computed,
  itemsAreLoading: computed
});
const ONBOARD_PROGRAM = gql`
  mutation OnboardProgram($program_short_code: ID!, $payload: OnboardProgramPayload) {
    onboardProgram(program_short_code: $program_short_code, payload: $payload) {
      apiEnabledPrograms
      allowedProgramShortCodesForFolder
    }
  }
`;
const useOnboardProgram = () => {
  const [onboardProgramMutation, {
    data,
    loading,
    error
  }] = useMutation(ONBOARD_PROGRAM);
  const onboardProgram = async (program_short_code, payload) => {
    const variables = {
      program_short_code,
      payload
    };
    return await onboardProgramMutation({
      variables
    });
  };
  return {
    onboardProgram,
    data,
    loading,
    error
  };
};
function at(o) {
  return Object.prototype.toString.call(o).slice(8, -1).toLowerCase();
}
function z(o, i) {
  const s2 = at(i);
  return at(o) === (s2 === "string" ? i : s2);
}
function Rt(o) {
  return o && o.__esModule && Object.prototype.hasOwnProperty.call(o, "default") ? o.default : o;
}
var Ie = { exports: {} }, x = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Le, it;
function Ot() {
  if (it)
    return Le;
  it = 1;
  var o = Object.getOwnPropertySymbols, i = Object.prototype.hasOwnProperty, s2 = Object.prototype.propertyIsEnumerable;
  function c(S2) {
    if (S2 == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(S2);
  }
  function L() {
    try {
      if (!Object.assign)
        return false;
      var S2 = new String("abc");
      if (S2[5] = "de", Object.getOwnPropertyNames(S2)[0] === "5")
        return false;
      for (var I = {}, b = 0; b < 10; b++)
        I["_" + String.fromCharCode(b)] = b;
      var A = Object.getOwnPropertyNames(I).map(function(d) {
        return I[d];
      });
      if (A.join("") !== "0123456789")
        return false;
      var _ = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        _[d] = d;
      }), Object.keys(Object.assign({}, _)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return false;
    }
  }
  return Le = L() ? Object.assign : function(S2, I) {
    for (var b, A = c(S2), _, d = 1; d < arguments.length; d++) {
      b = Object(arguments[d]);
      for (var l in b)
        i.call(b, l) && (A[l] = b[l]);
      if (o) {
        _ = o(b);
        for (var p = 0; p < _.length; p++)
          s2.call(b, _[p]) && (A[_[p]] = b[_[p]]);
      }
    }
    return A;
  }, Le;
}
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var st;
function Er() {
  if (st)
    return x;
  st = 1;
  var o = Ot(), i = typeof Symbol == "function" && Symbol.for, s2 = i ? Symbol.for("react.element") : 60103, c = i ? Symbol.for("react.portal") : 60106, L = i ? Symbol.for("react.fragment") : 60107, S2 = i ? Symbol.for("react.strict_mode") : 60108, I = i ? Symbol.for("react.profiler") : 60114, b = i ? Symbol.for("react.provider") : 60109, A = i ? Symbol.for("react.context") : 60110, _ = i ? Symbol.for("react.forward_ref") : 60112, d = i ? Symbol.for("react.suspense") : 60113, l = i ? Symbol.for("react.memo") : 60115, p = i ? Symbol.for("react.lazy") : 60116, E = typeof Symbol == "function" && Symbol.iterator;
  function C(r) {
    for (var u = "https://reactjs.org/docs/error-decoder.html?invariant=" + r, h = 1; h < arguments.length; h++)
      u += "&args[]=" + encodeURIComponent(arguments[h]);
    return "Minified React error #" + r + "; visit " + u + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var T = { isMounted: function() {
    return false;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, $ = {};
  function F(r, u, h) {
    this.props = r, this.context = u, this.refs = $, this.updater = h || T;
  }
  F.prototype.isReactComponent = {}, F.prototype.setState = function(r, u) {
    if (typeof r != "object" && typeof r != "function" && r != null)
      throw Error(C(85));
    this.updater.enqueueSetState(this, r, u, "setState");
  }, F.prototype.forceUpdate = function(r) {
    this.updater.enqueueForceUpdate(this, r, "forceUpdate");
  };
  function ee() {
  }
  ee.prototype = F.prototype;
  function j(r, u, h) {
    this.props = r, this.context = u, this.refs = $, this.updater = h || T;
  }
  var m = j.prototype = new ee();
  m.constructor = j, o(m, F.prototype), m.isPureReactComponent = true;
  var W = { current: null }, w = Object.prototype.hasOwnProperty, V = { key: true, ref: true, __self: true, __source: true };
  function H(r, u, h) {
    var P, y = {}, N = null, K2 = null;
    if (u != null)
      for (P in u.ref !== void 0 && (K2 = u.ref), u.key !== void 0 && (N = "" + u.key), u)
        w.call(u, P) && !V.hasOwnProperty(P) && (y[P] = u[P]);
    var D = arguments.length - 2;
    if (D === 1)
      y.children = h;
    else if (1 < D) {
      for (var Y = Array(D), J = 0; J < D; J++)
        Y[J] = arguments[J + 2];
      y.children = Y;
    }
    if (r && r.defaultProps)
      for (P in D = r.defaultProps, D)
        y[P] === void 0 && (y[P] = D[P]);
    return { $$typeof: s2, type: r, key: N, ref: K2, props: y, _owner: W.current };
  }
  function B(r, u) {
    return { $$typeof: s2, type: r.type, key: u, ref: r.ref, props: r.props, _owner: r._owner };
  }
  function U(r) {
    return typeof r == "object" && r !== null && r.$$typeof === s2;
  }
  function ae2(r) {
    var u = { "=": "=0", ":": "=2" };
    return "$" + ("" + r).replace(/[=:]/g, function(h) {
      return u[h];
    });
  }
  var te = /\/+/g, re2 = [];
  function ie2(r, u, h, P) {
    if (re2.length) {
      var y = re2.pop();
      return y.result = r, y.keyPrefix = u, y.func = h, y.context = P, y.count = 0, y;
    }
    return { result: r, keyPrefix: u, func: h, context: P, count: 0 };
  }
  function de2(r) {
    r.result = null, r.keyPrefix = null, r.func = null, r.context = null, r.count = 0, 10 > re2.length && re2.push(r);
  }
  function M(r, u, h, P) {
    var y = typeof r;
    (y === "undefined" || y === "boolean") && (r = null);
    var N = false;
    if (r === null)
      N = true;
    else
      switch (y) {
        case "string":
        case "number":
          N = true;
          break;
        case "object":
          switch (r.$$typeof) {
            case s2:
            case c:
              N = true;
          }
      }
    if (N)
      return h(P, r, u === "" ? "." + ue(r, 0) : u), 1;
    if (N = 0, u = u === "" ? "." : u + ":", Array.isArray(r))
      for (var K2 = 0; K2 < r.length; K2++) {
        y = r[K2];
        var D = u + ue(y, K2);
        N += M(y, D, h, P);
      }
    else if (r === null || typeof r != "object" ? D = null : (D = E && r[E] || r["@@iterator"], D = typeof D == "function" ? D : null), typeof D == "function")
      for (r = D.call(r), K2 = 0; !(y = r.next()).done; )
        y = y.value, D = u + ue(y, K2++), N += M(y, D, h, P);
    else if (y === "object")
      throw h = "" + r, Error(C(31, h === "[object Object]" ? "object with keys {" + Object.keys(r).join(", ") + "}" : h, ""));
    return N;
  }
  function G(r, u, h) {
    return r == null ? 0 : M(r, "", u, h);
  }
  function ue(r, u) {
    return typeof r == "object" && r !== null && r.key != null ? ae2(r.key) : u.toString(36);
  }
  function se2(r, u) {
    r.func.call(r.context, u, r.count++);
  }
  function _e2(r, u, h) {
    var P = r.result, y = r.keyPrefix;
    r = r.func.call(r.context, u, r.count++), Array.isArray(r) ? ce2(r, P, h, function(N) {
      return N;
    }) : r != null && (U(r) && (r = B(r, y + (!r.key || u && u.key === r.key ? "" : ("" + r.key).replace(te, "$&/") + "/") + h)), P.push(r));
  }
  function ce2(r, u, h, P, y) {
    var N = "";
    h != null && (N = ("" + h).replace(te, "$&/") + "/"), u = ie2(u, N, P, y), G(r, _e2, u), de2(u);
  }
  var fe2 = { current: null };
  function O() {
    var r = fe2.current;
    if (r === null)
      throw Error(C(321));
    return r;
  }
  var he2 = { ReactCurrentDispatcher: fe2, ReactCurrentBatchConfig: { suspense: null }, ReactCurrentOwner: W, IsSomeRendererActing: { current: false }, assign: o };
  return x.Children = { map: function(r, u, h) {
    if (r == null)
      return r;
    var P = [];
    return ce2(r, P, null, u, h), P;
  }, forEach: function(r, u, h) {
    if (r == null)
      return r;
    u = ie2(null, null, u, h), G(r, se2, u), de2(u);
  }, count: function(r) {
    return G(r, function() {
      return null;
    }, null);
  }, toArray: function(r) {
    var u = [];
    return ce2(r, u, null, function(h) {
      return h;
    }), u;
  }, only: function(r) {
    if (!U(r))
      throw Error(C(143));
    return r;
  } }, x.Component = F, x.Fragment = L, x.Profiler = I, x.PureComponent = j, x.StrictMode = S2, x.Suspense = d, x.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = he2, x.cloneElement = function(r, u, h) {
    if (r == null)
      throw Error(C(267, r));
    var P = o({}, r.props), y = r.key, N = r.ref, K2 = r._owner;
    if (u != null) {
      if (u.ref !== void 0 && (N = u.ref, K2 = W.current), u.key !== void 0 && (y = "" + u.key), r.type && r.type.defaultProps)
        var D = r.type.defaultProps;
      for (Y in u)
        w.call(u, Y) && !V.hasOwnProperty(Y) && (P[Y] = u[Y] === void 0 && D !== void 0 ? D[Y] : u[Y]);
    }
    var Y = arguments.length - 2;
    if (Y === 1)
      P.children = h;
    else if (1 < Y) {
      D = Array(Y);
      for (var J = 0; J < Y; J++)
        D[J] = arguments[J + 2];
      P.children = D;
    }
    return {
      $$typeof: s2,
      type: r.type,
      key: y,
      ref: N,
      props: P,
      _owner: K2
    };
  }, x.createContext = function(r, u) {
    return u === void 0 && (u = null), r = { $$typeof: A, _calculateChangedBits: u, _currentValue: r, _currentValue2: r, _threadCount: 0, Provider: null, Consumer: null }, r.Provider = { $$typeof: b, _context: r }, r.Consumer = r;
  }, x.createElement = H, x.createFactory = function(r) {
    var u = H.bind(null, r);
    return u.type = r, u;
  }, x.createRef = function() {
    return { current: null };
  }, x.forwardRef = function(r) {
    return { $$typeof: _, render: r };
  }, x.isValidElement = U, x.lazy = function(r) {
    return { $$typeof: p, _ctor: r, _status: -1, _result: null };
  }, x.memo = function(r, u) {
    return { $$typeof: l, type: r, compare: u === void 0 ? null : u };
  }, x.useCallback = function(r, u) {
    return O().useCallback(r, u);
  }, x.useContext = function(r, u) {
    return O().useContext(r, u);
  }, x.useDebugValue = function() {
  }, x.useEffect = function(r, u) {
    return O().useEffect(r, u);
  }, x.useImperativeHandle = function(r, u, h) {
    return O().useImperativeHandle(r, u, h);
  }, x.useLayoutEffect = function(r, u) {
    return O().useLayoutEffect(r, u);
  }, x.useMemo = function(r, u) {
    return O().useMemo(r, u);
  }, x.useReducer = function(r, u, h) {
    return O().useReducer(r, u, h);
  }, x.useRef = function(r) {
    return O().useRef(r);
  }, x.useState = function(r) {
    return O().useState(r);
  }, x.version = "16.14.0", x;
}
var k = {}, Ae$1, ct;
function Sr() {
  if (ct)
    return Ae$1;
  ct = 1;
  var o = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ae$1 = o, Ae$1;
}
var Te, ft;
function br() {
  if (ft)
    return Te;
  ft = 1;
  var o = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var i = Sr(), s2 = {}, c = Function.call.bind(Object.prototype.hasOwnProperty);
    o = function(S2) {
      var I = "Warning: " + S2;
      typeof console < "u" && console.error(I);
      try {
        throw new Error(I);
      } catch {
      }
    };
  }
  function L(S2, I, b, A, _) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in S2)
        if (c(S2, d)) {
          var l;
          try {
            if (typeof S2[d] != "function") {
              var p = Error(
                (A || "React class") + ": " + b + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof S2[d] + "`."
              );
              throw p.name = "Invariant Violation", p;
            }
            l = S2[d](I, d, A, b, null, i);
          } catch (C) {
            l = C;
          }
          if (l && !(l instanceof Error) && o(
            (A || "React class") + ": type specification of " + b + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in s2)) {
            s2[l.message] = true;
            var E = _ ? _() : "";
            o(
              "Failed " + b + " type: " + l.message + (E ?? "")
            );
          }
        }
    }
  }
  return L.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (s2 = {});
  }, Te = L, Te;
}
/** @license React v16.14.0
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lt;
function Rr() {
  return lt || (lt = 1, process.env.NODE_ENV !== "production" && function() {
    var o = Ot(), i = br(), s2 = "16.14.0", c = typeof Symbol == "function" && Symbol.for, L = c ? Symbol.for("react.element") : 60103, S2 = c ? Symbol.for("react.portal") : 60106, I = c ? Symbol.for("react.fragment") : 60107, b = c ? Symbol.for("react.strict_mode") : 60108, A = c ? Symbol.for("react.profiler") : 60114, _ = c ? Symbol.for("react.provider") : 60109, d = c ? Symbol.for("react.context") : 60110, l = c ? Symbol.for("react.concurrent_mode") : 60111, p = c ? Symbol.for("react.forward_ref") : 60112, E = c ? Symbol.for("react.suspense") : 60113, C = c ? Symbol.for("react.suspense_list") : 60120, T = c ? Symbol.for("react.memo") : 60115, $ = c ? Symbol.for("react.lazy") : 60116, F = c ? Symbol.for("react.block") : 60121, ee = c ? Symbol.for("react.fundamental") : 60117, j = c ? Symbol.for("react.responder") : 60118, m = c ? Symbol.for("react.scope") : 60119, W = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
    function V(e) {
      if (e === null || typeof e != "object")
        return null;
      var t = W && e[W] || e[w];
      return typeof t == "function" ? t : null;
    }
    var H = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, B = {
      suspense: null
    }, U = {
      /**
       * @internal
       * @type {ReactComponent}
       */
      current: null
    }, ae2 = /^(.*)[\\\/]/;
    function te(e, t, n) {
      var a = "";
      if (t) {
        var f = t.fileName, R = f.replace(ae2, "");
        if (/^index\./.test(R)) {
          var v = f.match(ae2);
          if (v) {
            var g = v[1];
            if (g) {
              var q = g.replace(ae2, "");
              R = q + "/" + R;
            }
          }
        }
        a = " (at " + R + ":" + t.lineNumber + ")";
      } else
        n && (a = " (created by " + n + ")");
      return `
    in ` + (e || "Unknown") + a;
    }
    var re2 = 1;
    function ie2(e) {
      return e._status === re2 ? e._result : null;
    }
    function de2(e, t, n) {
      var a = t.displayName || t.name || "";
      return e.displayName || (a !== "" ? n + "(" + a + ")" : n);
    }
    function M(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && O("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case I:
          return "Fragment";
        case S2:
          return "Portal";
        case A:
          return "Profiler";
        case b:
          return "StrictMode";
        case E:
          return "Suspense";
        case C:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case d:
            return "Context.Consumer";
          case _:
            return "Context.Provider";
          case p:
            return de2(e, e.render, "ForwardRef");
          case T:
            return M(e.type);
          case F:
            return M(e.render);
          case $: {
            var t = e, n = ie2(t);
            if (n)
              return M(n);
            break;
          }
        }
      return null;
    }
    var G = {}, ue = null;
    function se2(e) {
      ue = e;
    }
    G.getCurrentStack = null, G.getStackAddendum = function() {
      var e = "";
      if (ue) {
        var t = M(ue.type), n = ue._owner;
        e += te(t, ue._source, n && M(n.type));
      }
      var a = G.getCurrentStack;
      return a && (e += a() || ""), e;
    };
    var _e2 = {
      current: false
    }, ce2 = {
      ReactCurrentDispatcher: H,
      ReactCurrentBatchConfig: B,
      ReactCurrentOwner: U,
      IsSomeRendererActing: _e2,
      // Used by renderers to avoid bundling object-assign twice in UMD bundles:
      assign: o
    };
    o(ce2, {
      // These should not be included in production.
      ReactDebugCurrentFrame: G,
      // Shim for React DOM 16.0.0 which still destructured (but not used) this.
      // TODO: remove in React 17.0.
      ReactComponentTreeHook: {}
    });
    function fe2(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
          n[a - 1] = arguments[a];
        he2("warn", e, n);
      }
    }
    function O(e) {
      {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++)
          n[a - 1] = arguments[a];
        he2("error", e, n);
      }
    }
    function he2(e, t, n) {
      {
        var a = n.length > 0 && typeof n[n.length - 1] == "string" && n[n.length - 1].indexOf(`
    in`) === 0;
        if (!a) {
          var f = ce2.ReactDebugCurrentFrame, R = f.getStackAddendum();
          R !== "" && (t += "%s", n = n.concat([R]));
        }
        var v = n.map(function(X) {
          return "" + X;
        });
        v.unshift("Warning: " + t), Function.prototype.apply.call(console[e], console, v);
        try {
          var g = 0, q = "Warning: " + t.replace(/%s/g, function() {
            return n[g++];
          });
          throw new Error(q);
        } catch {
        }
      }
    }
    var r = {};
    function u(e, t) {
      {
        var n = e.constructor, a = n && (n.displayName || n.name) || "ReactClass", f = a + "." + t;
        if (r[f])
          return;
        O("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", t, a), r[f] = true;
      }
    }
    var h = {
      /**
       * Checks whether or not this composite component is mounted.
       * @param {ReactClass} publicInstance The instance we want to test.
       * @return {boolean} True if mounted, false otherwise.
       * @protected
       * @final
       */
      isMounted: function(e) {
        return false;
      },
      /**
       * Forces an update. This should only be invoked when it is known with
       * certainty that we are **not** in a DOM transaction.
       *
       * You may want to call this when you know that some deeper aspect of the
       * component's state has changed but `setState` was not called.
       *
       * This will not invoke `shouldComponentUpdate`, but it will invoke
       * `componentWillUpdate` and `componentDidUpdate`.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueForceUpdate: function(e, t, n) {
        u(e, "forceUpdate");
      },
      /**
       * Replaces all of the state. Always use this or `setState` to mutate state.
       * You should treat `this.state` as immutable.
       *
       * There is no guarantee that `this.state` will be immediately updated, so
       * accessing `this.state` after calling this method may return the old value.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} completeState Next state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} callerName name of the calling function in the public API.
       * @internal
       */
      enqueueReplaceState: function(e, t, n, a) {
        u(e, "replaceState");
      },
      /**
       * Sets a subset of the state. This only exists because _pendingState is
       * internal. This provides a merging strategy that is not available to deep
       * properties which is confusing. TODO: Expose pendingState or don't use it
       * during the merge.
       *
       * @param {ReactClass} publicInstance The instance that should rerender.
       * @param {object} partialState Next partial state to be merged with state.
       * @param {?function} callback Called after component is updated.
       * @param {?string} Name of the calling function in the public API.
       * @internal
       */
      enqueueSetState: function(e, t, n, a) {
        u(e, "setState");
      }
    }, P = {};
    Object.freeze(P);
    function y(e, t, n) {
      this.props = e, this.context = t, this.refs = P, this.updater = n || h;
    }
    y.prototype.isReactComponent = {}, y.prototype.setState = function(e, t) {
      if (!(typeof e == "object" || typeof e == "function" || e == null))
        throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, e, t, "setState");
    }, y.prototype.forceUpdate = function(e) {
      this.updater.enqueueForceUpdate(this, e, "forceUpdate");
    };
    {
      var N = {
        isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
        replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
      }, K2 = function(e, t) {
        Object.defineProperty(y.prototype, e, {
          get: function() {
            fe2("%s(...) is deprecated in plain JavaScript React classes. %s", t[0], t[1]);
          }
        });
      };
      for (var D in N)
        N.hasOwnProperty(D) && K2(D, N[D]);
    }
    function Y() {
    }
    Y.prototype = y.prototype;
    function J(e, t, n) {
      this.props = e, this.context = t, this.refs = P, this.updater = n || h;
    }
    var Ee2 = J.prototype = new Y();
    Ee2.constructor = J, o(Ee2, y.prototype), Ee2.isPureReactComponent = true;
    function Pt() {
      var e = {
        current: null
      };
      return Object.seal(e), e;
    }
    var ye2 = Object.prototype.hasOwnProperty, Ve = {
      key: true,
      ref: true,
      __self: true,
      __source: true
    }, Ne, Ue, Se2;
    Se2 = {};
    function Me(e) {
      if (ye2.call(e, "ref")) {
        var t = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (t && t.isReactWarning)
          return false;
      }
      return e.ref !== void 0;
    }
    function qe(e) {
      if (ye2.call(e, "key")) {
        var t = Object.getOwnPropertyDescriptor(e, "key").get;
        if (t && t.isReactWarning)
          return false;
      }
      return e.key !== void 0;
    }
    function Lt(e, t) {
      var n = function() {
        Ne || (Ne = true, O("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", t));
      };
      n.isReactWarning = true, Object.defineProperty(e, "key", {
        get: n,
        configurable: true
      });
    }
    function At(e, t) {
      var n = function() {
        Ue || (Ue = true, O("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://fb.me/react-special-props)", t));
      };
      n.isReactWarning = true, Object.defineProperty(e, "ref", {
        get: n,
        configurable: true
      });
    }
    function Tt(e) {
      if (typeof e.ref == "string" && U.current && e.__self && U.current.stateNode !== e.__self) {
        var t = M(U.current.type);
        Se2[t] || (O('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://fb.me/react-strict-mode-string-ref', M(U.current.type), e.ref), Se2[t] = true);
      }
    }
    var be2 = function(e, t, n, a, f, R, v) {
      var g = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: L,
        // Built-in properties that belong on the element
        type: e,
        key: t,
        ref: n,
        props: v,
        // Record the component responsible for creating this element.
        _owner: R
      };
      return g._store = {}, Object.defineProperty(g._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      }), Object.defineProperty(g, "_self", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: a
      }), Object.defineProperty(g, "_source", {
        configurable: false,
        enumerable: false,
        writable: false,
        value: f
      }), Object.freeze && (Object.freeze(g.props), Object.freeze(g)), g;
    };
    function xt(e, t, n) {
      var a, f = {}, R = null, v = null, g = null, q = null;
      if (t != null) {
        Me(t) && (v = t.ref, Tt(t)), qe(t) && (R = "" + t.key), g = t.__self === void 0 ? null : t.__self, q = t.__source === void 0 ? null : t.__source;
        for (a in t)
          ye2.call(t, a) && !Ve.hasOwnProperty(a) && (f[a] = t[a]);
      }
      var X = arguments.length - 2;
      if (X === 1)
        f.children = n;
      else if (X > 1) {
        for (var Q = Array(X), Z = 0; Z < X; Z++)
          Q[Z] = arguments[Z + 2];
        Object.freeze && Object.freeze(Q), f.children = Q;
      }
      if (e && e.defaultProps) {
        var le = e.defaultProps;
        for (a in le)
          f[a] === void 0 && (f[a] = le[a]);
      }
      if (R || v) {
        var oe = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
        R && Lt(f, oe), v && At(f, oe);
      }
      return be2(e, R, v, g, q, U.current, f);
    }
    function kt(e, t) {
      var n = be2(e.type, t, e.ref, e._self, e._source, e._owner, e.props);
      return n;
    }
    function jt(e, t, n) {
      if (e == null)
        throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + e + ".");
      var a, f = o({}, e.props), R = e.key, v = e.ref, g = e._self, q = e._source, X = e._owner;
      if (t != null) {
        Me(t) && (v = t.ref, X = U.current), qe(t) && (R = "" + t.key);
        var Q;
        e.type && e.type.defaultProps && (Q = e.type.defaultProps);
        for (a in t)
          ye2.call(t, a) && !Ve.hasOwnProperty(a) && (t[a] === void 0 && Q !== void 0 ? f[a] = Q[a] : f[a] = t[a]);
      }
      var Z = arguments.length - 2;
      if (Z === 1)
        f.children = n;
      else if (Z > 1) {
        for (var le = Array(Z), oe = 0; oe < Z; oe++)
          le[oe] = arguments[oe + 2];
        f.children = le;
      }
      return be2(e.type, R, v, g, q, X, f);
    }
    function pe2(e) {
      return typeof e == "object" && e !== null && e.$$typeof === L;
    }
    var Fe2 = ".", Dt = ":";
    function It(e) {
      var t = /[=:]/g, n = {
        "=": "=0",
        ":": "=2"
      }, a = ("" + e).replace(t, function(f) {
        return n[f];
      });
      return "$" + a;
    }
    var He = false, $t = /\/+/g;
    function Be(e) {
      return ("" + e).replace($t, "$&/");
    }
    var Wt = 10, ge2 = [];
    function Ye(e, t, n, a) {
      if (ge2.length) {
        var f = ge2.pop();
        return f.result = e, f.keyPrefix = t, f.func = n, f.context = a, f.count = 0, f;
      } else
        return {
          result: e,
          keyPrefix: t,
          func: n,
          context: a,
          count: 0
        };
    }
    function ze(e) {
      e.result = null, e.keyPrefix = null, e.func = null, e.context = null, e.count = 0, ge2.length < Wt && ge2.push(e);
    }
    function Re(e, t, n, a) {
      var f = typeof e;
      (f === "undefined" || f === "boolean") && (e = null);
      var R = false;
      if (e === null)
        R = true;
      else
        switch (f) {
          case "string":
          case "number":
            R = true;
            break;
          case "object":
            switch (e.$$typeof) {
              case L:
              case S2:
                R = true;
            }
        }
      if (R)
        return n(
          a,
          e,
          // If it's the only child, treat the name as if it was wrapped in an array
          // so that it's consistent if the number of children grows.
          t === "" ? Fe2 + Ce2(e, 0) : t
        ), 1;
      var v, g, q = 0, X = t === "" ? Fe2 : t + Dt;
      if (Array.isArray(e))
        for (var Q = 0; Q < e.length; Q++)
          v = e[Q], g = X + Ce2(v, Q), q += Re(v, g, n, a);
      else {
        var Z = V(e);
        if (typeof Z == "function") {
          Z === e.entries && (He || fe2("Using Maps as children is deprecated and will be removed in a future major release. Consider converting children to an array of keyed ReactElements instead."), He = true);
          for (var le = Z.call(e), oe, gr = 0; !(oe = le.next()).done; )
            v = oe.value, g = X + Ce2(v, gr++), q += Re(v, g, n, a);
        } else if (f === "object") {
          var nt = "";
          nt = " If you meant to render a collection of children, use an array instead." + G.getStackAddendum();
          var ot = "" + e;
          throw Error("Objects are not valid as a React child (found: " + (ot === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : ot) + ")." + nt);
        }
      }
      return q;
    }
    function Oe(e, t, n) {
      return e == null ? 0 : Re(e, "", t, n);
    }
    function Ce2(e, t) {
      return typeof e == "object" && e !== null && e.key != null ? It(e.key) : t.toString(36);
    }
    function Vt(e, t, n) {
      var a = e.func, f = e.context;
      a.call(f, t, e.count++);
    }
    function Nt(e, t, n) {
      if (e == null)
        return e;
      var a = Ye(null, null, t, n);
      Oe(e, Vt, a), ze(a);
    }
    function Ut(e, t, n) {
      var a = e.result, f = e.keyPrefix, R = e.func, v = e.context, g = R.call(v, t, e.count++);
      Array.isArray(g) ? we2(g, a, n, function(q) {
        return q;
      }) : g != null && (pe2(g) && (g = kt(
        g,
        // Keep both the (mapped) and old keys if they differ, just as
        // traverseAllChildren used to do for objects as children
        f + (g.key && (!t || t.key !== g.key) ? Be(g.key) + "/" : "") + n
      )), a.push(g));
    }
    function we2(e, t, n, a, f) {
      var R = "";
      n != null && (R = Be(n) + "/");
      var v = Ye(t, R, a, f);
      Oe(e, Ut, v), ze(v);
    }
    function Mt(e, t, n) {
      if (e == null)
        return e;
      var a = [];
      return we2(e, a, null, t, n), a;
    }
    function qt(e) {
      return Oe(e, function() {
        return null;
      }, null);
    }
    function Ft(e) {
      var t = [];
      return we2(e, t, null, function(n) {
        return n;
      }), t;
    }
    function Ht(e) {
      if (!pe2(e))
        throw Error("React.Children.only expected to receive a single React element child.");
      return e;
    }
    function Bt(e, t) {
      t === void 0 ? t = null : t !== null && typeof t != "function" && O("createContext: Expected the optional second argument to be a function. Instead received: %s", t);
      var n = {
        $$typeof: d,
        _calculateChangedBits: t,
        // As a workaround to support multiple concurrent renderers, we categorize
        // some renderers as primary and others as secondary. We only expect
        // there to be two concurrent renderers at most: React Native (primary) and
        // Fabric (secondary); React DOM (primary) and React ART (secondary).
        // Secondary renderers store their context values on separate fields.
        _currentValue: e,
        _currentValue2: e,
        // Used to track how many concurrent renderers this context currently
        // supports within in a single renderer. Such as parallel server rendering.
        _threadCount: 0,
        // These are circular
        Provider: null,
        Consumer: null
      };
      n.Provider = {
        $$typeof: _,
        _context: n
      };
      var a = false, f = false;
      {
        var R = {
          $$typeof: d,
          _context: n,
          _calculateChangedBits: n._calculateChangedBits
        };
        Object.defineProperties(R, {
          Provider: {
            get: function() {
              return f || (f = true, O("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), n.Provider;
            },
            set: function(v) {
              n.Provider = v;
            }
          },
          _currentValue: {
            get: function() {
              return n._currentValue;
            },
            set: function(v) {
              n._currentValue = v;
            }
          },
          _currentValue2: {
            get: function() {
              return n._currentValue2;
            },
            set: function(v) {
              n._currentValue2 = v;
            }
          },
          _threadCount: {
            get: function() {
              return n._threadCount;
            },
            set: function(v) {
              n._threadCount = v;
            }
          },
          Consumer: {
            get: function() {
              return a || (a = true, O("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), n.Consumer;
            }
          }
        }), n.Consumer = R;
      }
      return n._currentRenderer = null, n._currentRenderer2 = null, n;
    }
    function Yt(e) {
      var t = {
        $$typeof: $,
        _ctor: e,
        // React uses these fields to store the result.
        _status: -1,
        _result: null
      };
      {
        var n, a;
        Object.defineProperties(t, {
          defaultProps: {
            configurable: true,
            get: function() {
              return n;
            },
            set: function(f) {
              O("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), n = f, Object.defineProperty(t, "defaultProps", {
                enumerable: true
              });
            }
          },
          propTypes: {
            configurable: true,
            get: function() {
              return a;
            },
            set: function(f) {
              O("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), a = f, Object.defineProperty(t, "propTypes", {
                enumerable: true
              });
            }
          }
        });
      }
      return t;
    }
    function zt(e) {
      return e != null && e.$$typeof === T ? O("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof e != "function" ? O("forwardRef requires a render function but was given %s.", e === null ? "null" : typeof e) : e.length !== 0 && e.length !== 2 && O("forwardRef render functions accept exactly two parameters: props and ref. %s", e.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), e != null && (e.defaultProps != null || e.propTypes != null) && O("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?"), {
        $$typeof: p,
        render: e
      };
    }
    function Ge(e) {
      return typeof e == "string" || typeof e == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      e === I || e === l || e === A || e === b || e === E || e === C || typeof e == "object" && e !== null && (e.$$typeof === $ || e.$$typeof === T || e.$$typeof === _ || e.$$typeof === d || e.$$typeof === p || e.$$typeof === ee || e.$$typeof === j || e.$$typeof === m || e.$$typeof === F);
    }
    function Gt(e, t) {
      return Ge(e) || O("memo: The first argument must be a component. Instead received: %s", e === null ? "null" : typeof e), {
        $$typeof: T,
        type: e,
        compare: t === void 0 ? null : t
      };
    }
    function ne() {
      var e = H.current;
      if (e === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://fb.me/react-invalid-hook-call for tips about how to debug and fix this problem.`);
      return e;
    }
    function Kt(e, t) {
      var n = ne();
      if (t !== void 0 && O("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", t, typeof t == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://fb.me/rules-of-hooks` : ""), e._context !== void 0) {
        var a = e._context;
        a.Consumer === e ? O("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : a.Provider === e && O("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
      }
      return n.useContext(e, t);
    }
    function Jt(e) {
      var t = ne();
      return t.useState(e);
    }
    function Xt(e, t, n) {
      var a = ne();
      return a.useReducer(e, t, n);
    }
    function Zt(e) {
      var t = ne();
      return t.useRef(e);
    }
    function Qt(e, t) {
      var n = ne();
      return n.useEffect(e, t);
    }
    function er(e, t) {
      var n = ne();
      return n.useLayoutEffect(e, t);
    }
    function tr(e, t) {
      var n = ne();
      return n.useCallback(e, t);
    }
    function rr(e, t) {
      var n = ne();
      return n.useMemo(e, t);
    }
    function nr(e, t, n) {
      var a = ne();
      return a.useImperativeHandle(e, t, n);
    }
    function or(e, t) {
      {
        var n = ne();
        return n.useDebugValue(e, t);
      }
    }
    var Pe;
    Pe = false;
    function Ke() {
      if (U.current) {
        var e = M(U.current.type);
        if (e)
          return `

Check the render method of \`` + e + "`.";
      }
      return "";
    }
    function ar(e) {
      if (e !== void 0) {
        var t = e.fileName.replace(/^.*[\\\/]/, ""), n = e.lineNumber;
        return `

Check your code at ` + t + ":" + n + ".";
      }
      return "";
    }
    function ur(e) {
      return e != null ? ar(e.__source) : "";
    }
    var Je = {};
    function ir(e) {
      var t = Ke();
      if (!t) {
        var n = typeof e == "string" ? e : e.displayName || e.name;
        n && (t = `

Check the top-level render call using <` + n + ">.");
      }
      return t;
    }
    function Xe(e, t) {
      if (!(!e._store || e._store.validated || e.key != null)) {
        e._store.validated = true;
        var n = ir(t);
        if (!Je[n]) {
          Je[n] = true;
          var a = "";
          e && e._owner && e._owner !== U.current && (a = " It was passed a child from " + M(e._owner.type) + "."), se2(e), O('Each child in a list should have a unique "key" prop.%s%s See https://fb.me/react-warning-keys for more information.', n, a), se2(null);
        }
      }
    }
    function Ze(e, t) {
      if (typeof e == "object") {
        if (Array.isArray(e))
          for (var n = 0; n < e.length; n++) {
            var a = e[n];
            pe2(a) && Xe(a, t);
          }
        else if (pe2(e))
          e._store && (e._store.validated = true);
        else if (e) {
          var f = V(e);
          if (typeof f == "function" && f !== e.entries)
            for (var R = f.call(e), v; !(v = R.next()).done; )
              pe2(v.value) && Xe(v.value, t);
        }
      }
    }
    function Qe(e) {
      {
        var t = e.type;
        if (t == null || typeof t == "string")
          return;
        var n = M(t), a;
        if (typeof t == "function")
          a = t.propTypes;
        else if (typeof t == "object" && (t.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        t.$$typeof === T))
          a = t.propTypes;
        else
          return;
        a ? (se2(e), i(a, e.props, "prop", n, G.getStackAddendum), se2(null)) : t.PropTypes !== void 0 && !Pe && (Pe = true, O("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", n || "Unknown")), typeof t.getDefaultProps == "function" && !t.getDefaultProps.isReactClassApproved && O("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function sr(e) {
      {
        se2(e);
        for (var t = Object.keys(e.props), n = 0; n < t.length; n++) {
          var a = t[n];
          if (a !== "children" && a !== "key") {
            O("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", a);
            break;
          }
        }
        e.ref !== null && O("Invalid attribute `ref` supplied to `React.Fragment`."), se2(null);
      }
    }
    function et(e, t, n) {
      var a = Ge(e);
      if (!a) {
        var f = "";
        (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var R = ur(t);
        R ? f += R : f += Ke();
        var v;
        e === null ? v = "null" : Array.isArray(e) ? v = "array" : e !== void 0 && e.$$typeof === L ? (v = "<" + (M(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : v = typeof e, O("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", v, f);
      }
      var g = xt.apply(this, arguments);
      if (g == null)
        return g;
      if (a)
        for (var q = 2; q < arguments.length; q++)
          Ze(arguments[q], e);
      return e === I ? sr(g) : Qe(g), g;
    }
    var tt = false;
    function cr(e) {
      var t = et.bind(null, e);
      return t.type = e, tt || (tt = true, fe2("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(t, "type", {
        enumerable: false,
        get: function() {
          return fe2("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
            value: e
          }), e;
        }
      }), t;
    }
    function fr(e, t, n) {
      for (var a = jt.apply(this, arguments), f = 2; f < arguments.length; f++)
        Ze(arguments[f], a.type);
      return Qe(a), a;
    }
    try {
      var rt = Object.freeze({}), lr = /* @__PURE__ */ new Map([[rt, null]]), dr = /* @__PURE__ */ new Set([rt]);
      lr.set(0, 0), dr.add(0);
    } catch {
    }
    var pr = et, vr = fr, hr = cr, yr = {
      map: Mt,
      forEach: Nt,
      count: qt,
      toArray: Ft,
      only: Ht
    };
    k.Children = yr, k.Component = y, k.Fragment = I, k.Profiler = A, k.PureComponent = J, k.StrictMode = b, k.Suspense = E, k.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ce2, k.cloneElement = vr, k.createContext = Bt, k.createElement = pr, k.createFactory = hr, k.createRef = Pt, k.forwardRef = zt, k.isValidElement = pe2, k.lazy = Yt, k.memo = Gt, k.useCallback = tr, k.useContext = Kt, k.useDebugValue = or, k.useEffect = Qt, k.useImperativeHandle = nr, k.useLayoutEffect = er, k.useMemo = rr, k.useReducer = Xt, k.useRef = Zt, k.useState = Jt, k.version = s2;
  }()), k;
}
process.env.NODE_ENV === "production" ? Ie.exports = Er() : Ie.exports = Rr();
var ve$1 = Ie.exports;
const Ct = /* @__PURE__ */ Rt(ve$1);
var Or = { BASE_URL: "/", MODE: "production", DEV: false, PROD: true, SSR: false };
const dt = (o) => {
  let i;
  const s2 = /* @__PURE__ */ new Set(), c = (d, l) => {
    const p = typeof d == "function" ? d(i) : d;
    if (!Object.is(p, i)) {
      const E = i;
      i = l ?? (typeof p != "object" || p === null) ? p : Object.assign({}, i, p), s2.forEach((C) => C(i, E));
    }
  }, L = () => i, A = { setState: c, getState: L, getInitialState: () => _, subscribe: (d) => (s2.add(d), () => s2.delete(d)), destroy: () => {
    (Or ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), s2.clear();
  } }, _ = i = o(c, L, A);
  return A;
}, Cr = (o) => o ? dt(o) : dt;
var $e$1 = { exports: {} }, xe$1 = {}, me$1 = { exports: {} }, ke$1 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pt;
function wr() {
  if (pt)
    return ke$1;
  pt = 1;
  var o = ve$1;
  function i(l, p) {
    return l === p && (l !== 0 || 1 / l === 1 / p) || l !== l && p !== p;
  }
  var s2 = typeof Object.is == "function" ? Object.is : i, c = o.useState, L = o.useEffect, S2 = o.useLayoutEffect, I = o.useDebugValue;
  function b(l, p) {
    var E = p(), C = c({ inst: { value: E, getSnapshot: p } }), T = C[0].inst, $ = C[1];
    return S2(function() {
      T.value = E, T.getSnapshot = p, A(T) && $({ inst: T });
    }, [l, E, p]), L(function() {
      return A(T) && $({ inst: T }), l(function() {
        A(T) && $({ inst: T });
      });
    }, [l]), I(E), E;
  }
  function A(l) {
    var p = l.getSnapshot;
    l = l.value;
    try {
      var E = p();
      return !s2(l, E);
    } catch {
      return true;
    }
  }
  function _(l, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? _ : b;
  return ke$1.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : d, ke$1;
}
var je = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vt;
function Pr() {
  return vt || (vt = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var o = ve$1, i = o.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function s2(j) {
      {
        for (var m = arguments.length, W = new Array(m > 1 ? m - 1 : 0), w = 1; w < m; w++)
          W[w - 1] = arguments[w];
        c("error", j, W);
      }
    }
    function c(j, m, W) {
      {
        var w = i.ReactDebugCurrentFrame, V = w.getStackAddendum();
        V !== "" && (m += "%s", W = W.concat([V]));
        var H = W.map(function(B) {
          return String(B);
        });
        H.unshift("Warning: " + m), Function.prototype.apply.call(console[j], console, H);
      }
    }
    function L(j, m) {
      return j === m && (j !== 0 || 1 / j === 1 / m) || j !== j && m !== m;
    }
    var S2 = typeof Object.is == "function" ? Object.is : L, I = o.useState, b = o.useEffect, A = o.useLayoutEffect, _ = o.useDebugValue, d = false, l = false;
    function p(j, m, W) {
      d || o.startTransition !== void 0 && (d = true, s2("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var w = m();
      if (!l) {
        var V = m();
        S2(w, V) || (s2("The result of getSnapshot should be cached to avoid an infinite loop"), l = true);
      }
      var H = I({
        inst: {
          value: w,
          getSnapshot: m
        }
      }), B = H[0].inst, U = H[1];
      return A(function() {
        B.value = w, B.getSnapshot = m, E(B) && U({
          inst: B
        });
      }, [j, w, m]), b(function() {
        E(B) && U({
          inst: B
        });
        var ae2 = function() {
          E(B) && U({
            inst: B
          });
        };
        return j(ae2);
      }, [j]), _(w), w;
    }
    function E(j) {
      var m = j.getSnapshot, W = j.value;
      try {
        var w = m();
        return !S2(W, w);
      } catch {
        return true;
      }
    }
    function C(j, m, W) {
      return m();
    }
    var T = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", $ = !T, F = $ ? C : p, ee = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : F;
    je.useSyncExternalStore = ee, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), je;
}
var ht;
function wt() {
  return ht || (ht = 1, process.env.NODE_ENV === "production" ? me$1.exports = wr() : me$1.exports = Pr()), me$1.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yt;
function Lr() {
  if (yt)
    return xe$1;
  yt = 1;
  var o = ve$1, i = wt();
  function s2(_, d) {
    return _ === d && (_ !== 0 || 1 / _ === 1 / d) || _ !== _ && d !== d;
  }
  var c = typeof Object.is == "function" ? Object.is : s2, L = i.useSyncExternalStore, S2 = o.useRef, I = o.useEffect, b = o.useMemo, A = o.useDebugValue;
  return xe$1.useSyncExternalStoreWithSelector = function(_, d, l, p, E) {
    var C = S2(null);
    if (C.current === null) {
      var T = { hasValue: false, value: null };
      C.current = T;
    } else
      T = C.current;
    C = b(function() {
      function F(w) {
        if (!ee) {
          if (ee = true, j = w, w = p(w), E !== void 0 && T.hasValue) {
            var V = T.value;
            if (E(V, w))
              return m = V;
          }
          return m = w;
        }
        if (V = m, c(j, w))
          return V;
        var H = p(w);
        return E !== void 0 && E(V, H) ? V : (j = w, m = H);
      }
      var ee = false, j, m, W = l === void 0 ? null : l;
      return [function() {
        return F(d());
      }, W === null ? void 0 : function() {
        return F(W());
      }];
    }, [d, l, p, E]);
    var $ = L(_, C[0], C[1]);
    return I(function() {
      T.hasValue = true, T.value = $;
    }, [$]), A($), $;
  }, xe$1;
}
var De = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gt;
function Ar() {
  return gt || (gt = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var o = ve$1, i = wt();
    function s2(d, l) {
      return d === l && (d !== 0 || 1 / d === 1 / l) || d !== d && l !== l;
    }
    var c = typeof Object.is == "function" ? Object.is : s2, L = i.useSyncExternalStore, S2 = o.useRef, I = o.useEffect, b = o.useMemo, A = o.useDebugValue;
    function _(d, l, p, E, C) {
      var T = S2(null), $;
      T.current === null ? ($ = {
        hasValue: false,
        value: null
      }, T.current = $) : $ = T.current;
      var F = b(function() {
        var W = false, w, V, H = function(te) {
          if (!W) {
            W = true, w = te;
            var re2 = E(te);
            if (C !== void 0 && $.hasValue) {
              var ie2 = $.value;
              if (C(ie2, re2))
                return V = ie2, ie2;
            }
            return V = re2, re2;
          }
          var de2 = w, M = V;
          if (c(de2, te))
            return M;
          var G = E(te);
          return C !== void 0 && C(M, G) ? M : (w = te, V = G, G);
        }, B = p === void 0 ? null : p, U = function() {
          return H(l());
        }, ae2 = B === null ? void 0 : function() {
          return H(B());
        };
        return [U, ae2];
      }, [l, p, E, C]), ee = F[0], j = F[1], m = L(d, ee, j);
      return I(function() {
        $.hasValue = true, $.value = m;
      }, [m]), A(m), m;
    }
    De.useSyncExternalStoreWithSelector = _, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), De;
}
process.env.NODE_ENV === "production" ? $e$1.exports = Lr() : $e$1.exports = Ar();
var Tr = $e$1.exports;
const xr = /* @__PURE__ */ Rt(Tr);
var We = { BASE_URL: "/", MODE: "production", DEV: false, PROD: true, SSR: false };
const { useDebugValue: kr } = Ct, { useSyncExternalStoreWithSelector: jr } = xr;
let mt = false;
const Dr = (o) => o;
function Ir(o, i = Dr, s2) {
  (We ? "production" : void 0) !== "production" && s2 && !mt && (console.warn(
    "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937"
  ), mt = true);
  const c = jr(
    o.subscribe,
    o.getState,
    o.getServerState || o.getInitialState,
    i,
    s2
  );
  return kr(c), c;
}
const _t = (o) => {
  (We ? "production" : void 0) !== "production" && typeof o != "function" && console.warn(
    "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`."
  );
  const i = typeof o == "function" ? Cr(o) : o, s2 = (c, L) => Ir(i, c, L);
  return Object.assign(s2, i), s2;
}, $r = (o) => o ? _t(o) : _t;
var Wr = (o) => ((We ? "production" : void 0) !== "production" && console.warn(
  "[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`."
), $r(o));
const Et = {
  loading: false,
  // Whether page content is loading.
  leftNav: {
    show: false,
    // Whether LeftNav is displayed.
    showHeader: true,
    // Whether to show LeftNav header (if one is configured).
    pinned: true,
    // Whether LeftNav is pinned.
    menus: {}
    // Provides an optional method for tracking open state of left nav menus across mounts. Signature: { [title]: openState }.
  },
  go: null,
  // Default onClick handler for global links.
  dom: {
    // Current DOM elements.
    topBar: null,
    leftNav: null,
    content: null
  }
};
Wr((o, i) => ({
  ...Et,
  // Toggle loading for page content.
  toggleLoading: (s2) => o((c) => ({
    loading: z(s2, "boolean") ? s2 : !c.loading
  })),
  // Update leftNav state.
  setLeftNav: (s2 = {}) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      ...s2
    }
  })),
  // Update DOM elements.
  setDom: (s2 = {}) => o((c) => ({
    dom: {
      ...c.dom,
      ...s2
    }
  })),
  // Toggle leftNav.pinned.
  toggleLeftNav: (s2) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      pinned: z(s2, "boolean") ? s2 : !c.leftNav.pinned
    }
  })),
  // Toggle leftNav.showHeader.
  toggleLeftNavHeader: (s2) => o((c) => ({
    leftNav: {
      ...c.leftNav,
      showHeader: z(s2, "boolean") ? s2 : !c.leftNav.showHeader
    }
  })),
  // Set the default onClick handler for global links.
  setGo: (s2) => o((c) => ({ go: s2 })),
  // Reset all of Volt State.
  reset: () => o({ ...Et })
}));
const Vr = "#476ed1", Nr = "#c9462c", Ur = "#05805b", Mr = "#c9315b", qr = "#7e5eba", Fr = "#017d92", Hr = "#6256e9", Br = "#6256e9", Yr = "#0093e8", zr = "#0093e8", Gr = "#feff84", Kr = "#feff84", Jr = "#feff8466", Xr = "#feff8466", Zr = "#3b2ce3", Qr = "#3b2ce3", en = "#2100d9", tn = "#1e1672", rn = "#b4ccfc", nn = "#e9f0fe", on = "#f8fafd", an = "#2100d9", un = "#1e1672", sn = "#b4ccfc", cn = "#e9f0fe", fn = "#f8fafd", ln = "#1a8198", dn = "#13d0c5", pn = "#13d0c5", vn = "#00041e", hn = "#262631", yn = "#434355", gn = "#666679", mn = "#a7a8bd", _n = "#dedfe6", En = "#f0f0f3", Sn = "#f8f9f9", bn = "#80a4ff", Rn = "#b20030", On = "#b20030", Cn = "#a0012c", wn = "#f28a97", Pn = "#ffeaed", Ln = "#a0012c", An = "#f28a97", Tn = "#ffeaed", xn = "#2a206a", kn = "#2a206a", jn = "#602865", Dn = "#9f5ab1", In = "#9f5ab1", $n = "#1cc283", Wn = "#1cc283", Vn = "#434355", Nn = "#cdced9", Un = "#cdced9", Mn = "#f0f0f3", qn = "#ff304a", Fn = "#ff304a", Hn = "#ffeaed", Bn = "#f0f0f3", Yn = "#16accd", zn = "#16accd", Gn = "#e5f7fc", Kn = "#3db65c", Jn = "#3db65c", Xn = "#e4fcea", Zn = "#ffc13b", Qn = "#ffc13b", eo = "#fff4de", to = "#a1dadd", ro = "#f2f4ff", no = "#f2f4ff", oo = "#ffffff", po = {
  aaBlue: Vr,
  aaBurnt: Nr,
  aaGreen: Ur,
  aaMagenta: Mr,
  aaPurple: qr,
  aaTeal: Fr,
  accent: Hr,
  accentColor: Br,
  accentEducation: Yr,
  accentEducationColor: zr,
  accentHighlight: Gr,
  accentHighlightColor: Kr,
  accentHighlightColorTransparent: Jr,
  accentHighlightTransparent: Xr,
  action: Zr,
  actionColor: Qr,
  actionColorDarker1: en,
  actionColorDarker2: tn,
  actionColorLighter1: rn,
  actionColorLighter2: nn,
  actionColorLighter3: on,
  actionDarker1: an,
  actionDarker2: un,
  actionLighter1: sn,
  actionLighter2: cn,
  actionLighter3: fn,
  aqua: ln,
  aquaLight1: dn,
  aquaLighter1: pn,
  blackLighter1: vn,
  blackLighter2: hn,
  blackLighter3: yn,
  blackLighter4: gn,
  blackLighter5: mn,
  blackLighter6: _n,
  blackLighter7: En,
  blackLighter8: Sn,
  blueLight: bn,
  danger: Rn,
  dangerColor: On,
  dangerColorDarker1: Cn,
  dangerColorLighter1: wn,
  dangerColorLighter2: Pn,
  dangerDarker1: Ln,
  dangerLighter1: An,
  dangerLighter2: Tn,
  logo: xn,
  logoColor: kn,
  royal: jn,
  royalLight1: Dn,
  royalLighter1: In,
  secondary: $n,
  secondaryColor: Wn,
  statusDarkWash: Vn,
  statusDraft: Nn,
  statusDraftColor: Un,
  statusDraftWash: Mn,
  statusError: qn,
  statusErrorColor: Fn,
  statusErrorWash: Hn,
  statusLightWash: Bn,
  statusPending: Yn,
  statusPendingColor: zn,
  statusPendingWash: Gn,
  statusSuccess: Kn,
  statusSuccessColor: Jn,
  statusSuccessWash: Xn,
  statusWarning: Zn,
  statusWarningColor: Qn,
  statusWarningWash: eo,
  tealLight: to,
  wash: ro,
  washColor: no,
  white: oo
};
var ae = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ce(m) {
  return m && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m;
}
var ie = { exports: {} };
(function(m) {
  var C = typeof window < "u" ? window : typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope ? self : {};
  /**
   * Prism: Lightweight, robust, elegant syntax highlighting
   *
   * @license MIT <https://opensource.org/licenses/MIT>
   * @author Lea Verou <https://lea.verou.me>
   * @namespace
   * @public
   */
  var s2 = function(p) {
    var A = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i, E = 0, c = {}, i = {
      /**
       * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
       * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
       * additional languages or plugins yourself.
       *
       * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
       *
       * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.manual = true;
       * // add a new <script> to load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      manual: p.Prism && p.Prism.manual,
      /**
       * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
       * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
       * own worker, you don't want it to do this.
       *
       * By setting this value to `true`, Prism will not add its own listeners to the worker.
       *
       * You obviously have to change this value before Prism executes. To do this, you can add an
       * empty Prism object into the global scope before loading the Prism script like this:
       *
       * ```js
       * window.Prism = window.Prism || {};
       * Prism.disableWorkerMessageHandler = true;
       * // Load Prism's script
       * ```
       *
       * @default false
       * @type {boolean}
       * @memberof Prism
       * @public
       */
      disableWorkerMessageHandler: p.Prism && p.Prism.disableWorkerMessageHandler,
      /**
       * A namespace for utility methods.
       *
       * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
       * change or disappear at any time.
       *
       * @namespace
       * @memberof Prism
       */
      util: {
        encode: function t(e) {
          return e instanceof u ? new u(e.type, t(e.content), e.alias) : Array.isArray(e) ? e.map(t) : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\u00a0/g, " ");
        },
        /**
         * Returns the name of the type of the given value.
         *
         * @param {any} o
         * @returns {string}
         * @example
         * type(null)      === 'Null'
         * type(undefined) === 'Undefined'
         * type(123)       === 'Number'
         * type('foo')     === 'String'
         * type(true)      === 'Boolean'
         * type([1, 2])    === 'Array'
         * type({})        === 'Object'
         * type(String)    === 'Function'
         * type(/abc+/)    === 'RegExp'
         */
        type: function(t) {
          return Object.prototype.toString.call(t).slice(8, -1);
        },
        /**
         * Returns a unique number for the given object. Later calls will still return the same number.
         *
         * @param {Object} obj
         * @returns {number}
         */
        objId: function(t) {
          return t.__id || Object.defineProperty(t, "__id", { value: ++E }), t.__id;
        },
        /**
         * Creates a deep clone of the given object.
         *
         * The main intended use of this function is to clone language definitions.
         *
         * @param {T} o
         * @param {Record<number, any>} [visited]
         * @returns {T}
         * @template T
         */
        clone: function t(e, a) {
          a = a || {};
          var r, n;
          switch (i.util.type(e)) {
            case "Object":
              if (n = i.util.objId(e), a[n])
                return a[n];
              r = /** @type {Record<string, any>} */
              {}, a[n] = r;
              for (var o in e)
                e.hasOwnProperty(o) && (r[o] = t(e[o], a));
              return (
                /** @type {any} */
                r
              );
            case "Array":
              return n = i.util.objId(e), a[n] ? a[n] : (r = [], a[n] = r, e.forEach(function(g, l) {
                r[l] = t(g, a);
              }), /** @type {any} */
              r);
            default:
              return e;
          }
        },
        /**
         * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
         *
         * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
         *
         * @param {Element} element
         * @returns {string}
         */
        getLanguage: function(t) {
          for (; t; ) {
            var e = A.exec(t.className);
            if (e)
              return e[1].toLowerCase();
            t = t.parentElement;
          }
          return "none";
        },
        /**
         * Sets the Prism `language-xxxx` class of the given element.
         *
         * @param {Element} element
         * @param {string} language
         * @returns {void}
         */
        setLanguage: function(t, e) {
          t.className = t.className.replace(RegExp(A, "gi"), ""), t.classList.add("language-" + e);
        },
        /**
         * Returns the script element that is currently executing.
         *
         * This does __not__ work for line script element.
         *
         * @returns {HTMLScriptElement | null}
         */
        currentScript: function() {
          if (typeof document > "u")
            return null;
          if ("currentScript" in document)
            return (
              /** @type {any} */
              document.currentScript
            );
          try {
            throw new Error();
          } catch (r) {
            var t = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(r.stack) || [])[1];
            if (t) {
              var e = document.getElementsByTagName("script");
              for (var a in e)
                if (e[a].src == t)
                  return e[a];
            }
            return null;
          }
        },
        /**
         * Returns whether a given class is active for `element`.
         *
         * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
         * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
         * given class is just the given class with a `no-` prefix.
         *
         * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
         * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
         * ancestors have the given class or the negated version of it, then the default activation will be returned.
         *
         * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
         * version of it, the class is considered active.
         *
         * @param {Element} element
         * @param {string} className
         * @param {boolean} [defaultActivation=false]
         * @returns {boolean}
         */
        isActive: function(t, e, a) {
          for (var r = "no-" + e; t; ) {
            var n = t.classList;
            if (n.contains(e))
              return true;
            if (n.contains(r))
              return false;
            t = t.parentElement;
          }
          return !!a;
        }
      },
      /**
       * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
       *
       * @namespace
       * @memberof Prism
       * @public
       */
      languages: {
        /**
         * The grammar for plain, unformatted text.
         */
        plain: c,
        plaintext: c,
        text: c,
        txt: c,
        /**
         * Creates a deep copy of the language with the given id and appends the given tokens.
         *
         * If a token in `redef` also appears in the copied language, then the existing token in the copied language
         * will be overwritten at its original position.
         *
         * ## Best practices
         *
         * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
         * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
         * understand the language definition because, normally, the order of tokens matters in Prism grammars.
         *
         * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
         * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
         *
         * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
         * @param {Grammar} redef The new tokens to append.
         * @returns {Grammar} The new language created.
         * @public
         * @example
         * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
         *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
         *     // at its original position
         *     'comment': { ... },
         *     // CSS doesn't have a 'color' token, so this token will be appended
         *     'color': /\b(?:red|green|blue)\b/
         * });
         */
        extend: function(t, e) {
          var a = i.util.clone(i.languages[t]);
          for (var r in e)
            a[r] = e[r];
          return a;
        },
        /**
         * Inserts tokens _before_ another token in a language definition or any other grammar.
         *
         * ## Usage
         *
         * This helper method makes it easy to modify existing languages. For example, the CSS language definition
         * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
         * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
         * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
         * this:
         *
         * ```js
         * Prism.languages.markup.style = {
         *     // token
         * };
         * ```
         *
         * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
         * before existing tokens. For the CSS example above, you would use it like this:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'cdata', {
         *     'style': {
         *         // token
         *     }
         * });
         * ```
         *
         * ## Special cases
         *
         * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
         * will be ignored.
         *
         * This behavior can be used to insert tokens after `before`:
         *
         * ```js
         * Prism.languages.insertBefore('markup', 'comment', {
         *     'comment': Prism.languages.markup.comment,
         *     // tokens after 'comment'
         * });
         * ```
         *
         * ## Limitations
         *
         * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
         * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
         * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
         * deleting properties which is necessary to insert at arbitrary positions.
         *
         * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
         * Instead, it will create a new object and replace all references to the target object with the new one. This
         * can be done without temporarily deleting properties, so the iteration order is well-defined.
         *
         * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
         * you hold the target object in a variable, then the value of the variable will not change.
         *
         * ```js
         * var oldMarkup = Prism.languages.markup;
         * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
         *
         * assert(oldMarkup !== Prism.languages.markup);
         * assert(newMarkup === Prism.languages.markup);
         * ```
         *
         * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
         * object to be modified.
         * @param {string} before The key to insert before.
         * @param {Grammar} insert An object containing the key-value pairs to be inserted.
         * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
         * object to be modified.
         *
         * Defaults to `Prism.languages`.
         * @returns {Grammar} The new grammar object.
         * @public
         */
        insertBefore: function(t, e, a, r) {
          r = r || /** @type {any} */
          i.languages;
          var n = r[t], o = {};
          for (var g in n)
            if (n.hasOwnProperty(g)) {
              if (g == e)
                for (var l in a)
                  a.hasOwnProperty(l) && (o[l] = a[l]);
              a.hasOwnProperty(g) || (o[g] = n[g]);
            }
          var b = r[t];
          return r[t] = o, i.languages.DFS(i.languages, function(F, L) {
            L === b && F != t && (this[F] = o);
          }), o;
        },
        // Traverse a language definition with Depth First Search
        DFS: function t(e, a, r, n) {
          n = n || {};
          var o = i.util.objId;
          for (var g in e)
            if (e.hasOwnProperty(g)) {
              a.call(e, g, e[g], r || g);
              var l = e[g], b = i.util.type(l);
              b === "Object" && !n[o(l)] ? (n[o(l)] = true, t(l, a, null, n)) : b === "Array" && !n[o(l)] && (n[o(l)] = true, t(l, a, g, n));
            }
        }
      },
      plugins: {},
      /**
       * This is the most high-level function in Prism’s API.
       * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
       * each one of them.
       *
       * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
       *
       * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
       * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
       * @memberof Prism
       * @public
       */
      highlightAll: function(t, e) {
        i.highlightAllUnder(document, t, e);
      },
      /**
       * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
       * {@link Prism.highlightElement} on each one of them.
       *
       * The following hooks will be run:
       * 1. `before-highlightall`
       * 2. `before-all-elements-highlight`
       * 3. All hooks of {@link Prism.highlightElement} for each element.
       *
       * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
       * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
       * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
       * @memberof Prism
       * @public
       */
      highlightAllUnder: function(t, e, a) {
        var r = {
          callback: a,
          container: t,
          selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
        };
        i.hooks.run("before-highlightall", r), r.elements = Array.prototype.slice.apply(r.container.querySelectorAll(r.selector)), i.hooks.run("before-all-elements-highlight", r);
        for (var n = 0, o; o = r.elements[n++]; )
          i.highlightElement(o, e === true, r.callback);
      },
      /**
       * Highlights the code inside a single element.
       *
       * The following hooks will be run:
       * 1. `before-sanity-check`
       * 2. `before-highlight`
       * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
       * 4. `before-insert`
       * 5. `after-highlight`
       * 6. `complete`
       *
       * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
       * the element's language.
       *
       * @param {Element} element The element containing the code.
       * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
       * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
       * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
       * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
       *
       * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
       * asynchronous highlighting to work. You can build your own bundle on the
       * [Download page](https://prismjs.com/download.html).
       * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
       * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
       * @memberof Prism
       * @public
       */
      highlightElement: function(t, e, a) {
        var r = i.util.getLanguage(t), n = i.languages[r];
        i.util.setLanguage(t, r);
        var o = t.parentElement;
        o && o.nodeName.toLowerCase() === "pre" && i.util.setLanguage(o, r);
        var g = t.textContent, l = {
          element: t,
          language: r,
          grammar: n,
          code: g
        };
        function b(L) {
          l.highlightedCode = L, i.hooks.run("before-insert", l), l.element.innerHTML = l.highlightedCode, i.hooks.run("after-highlight", l), i.hooks.run("complete", l), a && a.call(l.element);
        }
        if (i.hooks.run("before-sanity-check", l), o = l.element.parentElement, o && o.nodeName.toLowerCase() === "pre" && !o.hasAttribute("tabindex") && o.setAttribute("tabindex", "0"), !l.code) {
          i.hooks.run("complete", l), a && a.call(l.element);
          return;
        }
        if (i.hooks.run("before-highlight", l), !l.grammar) {
          b(i.util.encode(l.code));
          return;
        }
        if (e && p.Worker) {
          var F = new Worker(i.filename);
          F.onmessage = function(L) {
            b(L.data);
          }, F.postMessage(JSON.stringify({
            language: l.language,
            code: l.code,
            immediateClose: true
          }));
        } else
          b(i.highlight(l.code, l.grammar, l.language));
      },
      /**
       * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
       * and the language definitions to use, and returns a string with the HTML produced.
       *
       * The following hooks will be run:
       * 1. `before-tokenize`
       * 2. `after-tokenize`
       * 3. `wrap`: On each {@link Token}.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @param {string} language The name of the language definition passed to `grammar`.
       * @returns {string} The highlighted HTML.
       * @memberof Prism
       * @public
       * @example
       * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
       */
      highlight: function(t, e, a) {
        var r = {
          code: t,
          grammar: e,
          language: a
        };
        if (i.hooks.run("before-tokenize", r), !r.grammar)
          throw new Error('The language "' + r.language + '" has no grammar.');
        return r.tokens = i.tokenize(r.code, r.grammar), i.hooks.run("after-tokenize", r), u.stringify(i.util.encode(r.tokens), r.language);
      },
      /**
       * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
       * and the language definitions to use, and returns an array with the tokenized code.
       *
       * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
       *
       * This method could be useful in other contexts as well, as a very crude parser.
       *
       * @param {string} text A string with the code to be highlighted.
       * @param {Grammar} grammar An object containing the tokens to use.
       *
       * Usually a language definition like `Prism.languages.markup`.
       * @returns {TokenStream} An array of strings and tokens, a token stream.
       * @memberof Prism
       * @public
       * @example
       * let code = `var foo = 0;`;
       * let tokens = Prism.tokenize(code, Prism.languages.javascript);
       * tokens.forEach(token => {
       *     if (token instanceof Prism.Token && token.type === 'number') {
       *         console.log(`Found numeric literal: ${token.content}`);
       *     }
       * });
       */
      tokenize: function(t, e) {
        var a = e.rest;
        if (a) {
          for (var r in a)
            e[r] = a[r];
          delete e.rest;
        }
        var n = new d();
        return w(n, n.head, t), v(t, n, e, n.head, 0), H(n);
      },
      /**
       * @namespace
       * @memberof Prism
       * @public
       */
      hooks: {
        all: {},
        /**
         * Adds the given callback to the list of callbacks for the given hook.
         *
         * The callback will be invoked when the hook it is registered for is run.
         * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
         *
         * One callback function can be registered to multiple hooks and the same hook multiple times.
         *
         * @param {string} name The name of the hook.
         * @param {HookCallback} callback The callback function which is given environment variables.
         * @public
         */
        add: function(t, e) {
          var a = i.hooks.all;
          a[t] = a[t] || [], a[t].push(e);
        },
        /**
         * Runs a hook invoking all registered callbacks with the given environment variables.
         *
         * Callbacks will be invoked synchronously and in the order in which they were registered.
         *
         * @param {string} name The name of the hook.
         * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
         * @public
         */
        run: function(t, e) {
          var a = i.hooks.all[t];
          if (!(!a || !a.length))
            for (var r = 0, n; n = a[r++]; )
              n(e);
        }
      },
      Token: u
    };
    p.Prism = i;
    function u(t, e, a, r) {
      this.type = t, this.content = e, this.alias = a, this.length = (r || "").length | 0;
    }
    u.stringify = function t(e, a) {
      if (typeof e == "string")
        return e;
      if (Array.isArray(e)) {
        var r = "";
        return e.forEach(function(b) {
          r += t(b, a);
        }), r;
      }
      var n = {
        type: e.type,
        content: t(e.content, a),
        tag: "span",
        classes: ["token", e.type],
        attributes: {},
        language: a
      }, o = e.alias;
      o && (Array.isArray(o) ? Array.prototype.push.apply(n.classes, o) : n.classes.push(o)), i.hooks.run("wrap", n);
      var g = "";
      for (var l in n.attributes)
        g += " " + l + '="' + (n.attributes[l] || "").replace(/"/g, "&quot;") + '"';
      return "<" + n.tag + ' class="' + n.classes.join(" ") + '"' + g + ">" + n.content + "</" + n.tag + ">";
    };
    function h(t, e, a, r) {
      t.lastIndex = e;
      var n = t.exec(a);
      if (n && r && n[1]) {
        var o = n[1].length;
        n.index += o, n[0] = n[0].slice(o);
      }
      return n;
    }
    function v(t, e, a, r, n, o) {
      for (var g in a)
        if (!(!a.hasOwnProperty(g) || !a[g])) {
          var l = a[g];
          l = Array.isArray(l) ? l : [l];
          for (var b = 0; b < l.length; ++b) {
            if (o && o.cause == g + "," + b)
              return;
            var F = l[b], L = F.inside, R = !!F.lookbehind, O = !!F.greedy, $ = F.alias;
            if (O && !F.pattern.global) {
              var D = F.pattern.toString().match(/[imsuy]*$/)[0];
              F.pattern = RegExp(F.pattern.source, D + "g");
            }
            for (var Q = F.pattern || F, _ = r.next, I = n; _ !== e.tail && !(o && I >= o.reach); I += _.value.length, _ = _.next) {
              var j = _.value;
              if (e.length > t.length)
                return;
              if (!(j instanceof u)) {
                var W = 1, M;
                if (O) {
                  if (M = h(Q, I, t, R), !M || M.index >= t.length)
                    break;
                  var q = M.index, oe = M.index + M[0].length, N = I;
                  for (N += _.value.length; q >= N; )
                    _ = _.next, N += _.value.length;
                  if (N -= _.value.length, I = N, _.value instanceof u)
                    continue;
                  for (var B = _; B !== e.tail && (N < oe || typeof B.value == "string"); B = B.next)
                    W++, N += B.value.length;
                  W--, j = t.slice(I, N), M.index -= I;
                } else if (M = h(Q, 0, j, R), !M)
                  continue;
                var q = M.index, G = M[0], Z = j.slice(0, q), ee = j.slice(q + G.length), V = I + j.length;
                o && V > o.reach && (o.reach = V);
                var U = _.prev;
                Z && (U = w(e, U, Z), I += Z.length), T(e, U, W);
                var le = new u(g, L ? i.tokenize(G, L) : G, $, G);
                if (_ = w(e, U, le), ee && w(e, _, ee), W > 1) {
                  var X = {
                    cause: g + "," + b,
                    reach: V
                  };
                  v(t, e, a, _.prev, I, X), o && X.reach > o.reach && (o.reach = X.reach);
                }
              }
            }
          }
        }
    }
    function d() {
      var t = { value: null, prev: null, next: null }, e = { value: null, prev: t, next: null };
      t.next = e, this.head = t, this.tail = e, this.length = 0;
    }
    function w(t, e, a) {
      var r = e.next, n = { value: a, prev: e, next: r };
      return e.next = n, r.prev = n, t.length++, n;
    }
    function T(t, e, a) {
      for (var r = e.next, n = 0; n < a && r !== t.tail; n++)
        r = r.next;
      e.next = r, r.prev = e, t.length -= n;
    }
    function H(t) {
      for (var e = [], a = t.head.next; a !== t.tail; )
        e.push(a.value), a = a.next;
      return e;
    }
    if (!p.document)
      return p.addEventListener && (i.disableWorkerMessageHandler || p.addEventListener("message", function(t) {
        var e = JSON.parse(t.data), a = e.language, r = e.code, n = e.immediateClose;
        p.postMessage(i.highlight(r, i.languages[a], a)), n && p.close();
      }, false)), i;
    var y = i.util.currentScript();
    y && (i.filename = y.src, y.hasAttribute("data-manual") && (i.manual = true));
    function f() {
      i.manual || i.highlightAll();
    }
    if (!i.manual) {
      var x2 = document.readyState;
      x2 === "loading" || x2 === "interactive" && y && y.defer ? document.addEventListener("DOMContentLoaded", f) : window.requestAnimationFrame ? window.requestAnimationFrame(f) : window.setTimeout(f, 16);
    }
    return i;
  }(C);
  m.exports && (m.exports = s2), typeof ae < "u" && (ae.Prism = s2), s2.languages.markup = {
    comment: {
      pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
      greedy: true
    },
    prolog: {
      pattern: /<\?[\s\S]+?\?>/,
      greedy: true
    },
    doctype: {
      // https://www.w3.org/TR/xml/#NT-doctypedecl
      pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
      greedy: true,
      inside: {
        "internal-subset": {
          pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
          lookbehind: true,
          greedy: true,
          inside: null
          // see below
        },
        string: {
          pattern: /"[^"]*"|'[^']*'/,
          greedy: true
        },
        punctuation: /^<!|>$|[[\]]/,
        "doctype-tag": /^DOCTYPE/i,
        name: /[^\s<>'"]+/
      }
    },
    cdata: {
      pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
      greedy: true
    },
    tag: {
      pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
      greedy: true,
      inside: {
        tag: {
          pattern: /^<\/?[^\s>\/]+/,
          inside: {
            punctuation: /^<\/?/,
            namespace: /^[^\s>\/:]+:/
          }
        },
        "special-attr": [],
        "attr-value": {
          pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
          inside: {
            punctuation: [
              {
                pattern: /^=/,
                alias: "attr-equals"
              },
              /"|'/
            ]
          }
        },
        punctuation: /\/?>/,
        "attr-name": {
          pattern: /[^\s>\/]+/,
          inside: {
            namespace: /^[^\s>\/:]+:/
          }
        }
      }
    },
    entity: [
      {
        pattern: /&[\da-z]{1,8};/i,
        alias: "named-entity"
      },
      /&#x?[\da-f]{1,8};/i
    ]
  }, s2.languages.markup.tag.inside["attr-value"].inside.entity = s2.languages.markup.entity, s2.languages.markup.doctype.inside["internal-subset"].inside = s2.languages.markup, s2.hooks.add("wrap", function(p) {
    p.type === "entity" && (p.attributes.title = p.content.replace(/&amp;/, "&"));
  }), Object.defineProperty(s2.languages.markup.tag, "addInlined", {
    /**
     * Adds an inlined language to markup.
     *
     * An example of an inlined language is CSS with `<style>` tags.
     *
     * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addInlined('style', 'css');
     */
    value: function(A, E) {
      var c = {};
      c["language-" + E] = {
        pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
        lookbehind: true,
        inside: s2.languages[E]
      }, c.cdata = /^<!\[CDATA\[|\]\]>$/i;
      var i = {
        "included-cdata": {
          pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
          inside: c
        }
      };
      i["language-" + E] = {
        pattern: /[\s\S]+/,
        inside: s2.languages[E]
      };
      var u = {};
      u[A] = {
        pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
          return A;
        }), "i"),
        lookbehind: true,
        greedy: true,
        inside: i
      }, s2.languages.insertBefore("markup", "cdata", u);
    }
  }), Object.defineProperty(s2.languages.markup.tag, "addAttribute", {
    /**
     * Adds an pattern to highlight languages embedded in HTML attributes.
     *
     * An example of an inlined language is CSS with `style` attributes.
     *
     * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
     * case insensitive.
     * @param {string} lang The language key.
     * @example
     * addAttribute('style', 'css');
     */
    value: function(p, A) {
      s2.languages.markup.tag.inside["special-attr"].push({
        pattern: RegExp(
          /(^|["'\s])/.source + "(?:" + p + ")" + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source,
          "i"
        ),
        lookbehind: true,
        inside: {
          "attr-name": /^[^\s=]+/,
          "attr-value": {
            pattern: /=[\s\S]+/,
            inside: {
              value: {
                pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                lookbehind: true,
                alias: [A, "language-" + A],
                inside: s2.languages[A]
              },
              punctuation: [
                {
                  pattern: /^=/,
                  alias: "attr-equals"
                },
                /"|'/
              ]
            }
          }
        }
      });
    }
  }), s2.languages.html = s2.languages.markup, s2.languages.mathml = s2.languages.markup, s2.languages.svg = s2.languages.markup, s2.languages.xml = s2.languages.extend("markup", {}), s2.languages.ssml = s2.languages.xml, s2.languages.atom = s2.languages.xml, s2.languages.rss = s2.languages.xml, function(p) {
    var A = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    p.languages.css = {
      comment: /\/\*[\s\S]*?\*\//,
      atrule: {
        pattern: /@[\w-](?:[^;{\s]|\s+(?![\s{]))*(?:;|(?=\s*\{))/,
        inside: {
          rule: /^@[\w-]+/,
          "selector-function-argument": {
            pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
            lookbehind: true,
            alias: "selector"
          },
          keyword: {
            pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
            lookbehind: true
          }
          // See rest below
        }
      },
      url: {
        // https://drafts.csswg.org/css-values-3/#urls
        pattern: RegExp("\\burl\\((?:" + A.source + "|" + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ")\\)", "i"),
        greedy: true,
        inside: {
          function: /^url/i,
          punctuation: /^\(|\)$/,
          string: {
            pattern: RegExp("^" + A.source + "$"),
            alias: "url"
          }
        }
      },
      selector: {
        pattern: RegExp(`(^|[{}\\s])[^{}\\s](?:[^{};"'\\s]|\\s+(?![\\s{])|` + A.source + ")*(?=\\s*\\{)"),
        lookbehind: true
      },
      string: {
        pattern: A,
        greedy: true
      },
      property: {
        pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
        lookbehind: true
      },
      important: /!important\b/i,
      function: {
        pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
        lookbehind: true
      },
      punctuation: /[(){};:,]/
    }, p.languages.css.atrule.inside.rest = p.languages.css;
    var E = p.languages.markup;
    E && (E.tag.addInlined("style", "css"), E.tag.addAttribute("style", "css"));
  }(s2), s2.languages.clike = {
    comment: [
      {
        pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
        lookbehind: true,
        greedy: true
      },
      {
        pattern: /(^|[^\\:])\/\/.*/,
        lookbehind: true,
        greedy: true
      }
    ],
    string: {
      pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
      greedy: true
    },
    "class-name": {
      pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
      lookbehind: true,
      inside: {
        punctuation: /[.\\]/
      }
    },
    keyword: /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    boolean: /\b(?:false|true)\b/,
    function: /\b\w+(?=\()/,
    number: /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    operator: /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    punctuation: /[{}[\];(),.:]/
  }, s2.languages.javascript = s2.languages.extend("clike", {
    "class-name": [
      s2.languages.clike["class-name"],
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
        lookbehind: true
      }
    ],
    keyword: [
      {
        pattern: /((?:^|\})\s*)catch\b/,
        lookbehind: true
      },
      {
        pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
        lookbehind: true
      }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    function: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    number: {
      pattern: RegExp(
        /(^|[^\w$])/.source + "(?:" + // constant
        (/NaN|Infinity/.source + "|" + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + "|" + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + "|" + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + "|" + // decimal bigint
        /\d+(?:_\d+)*n/.source + "|" + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ")" + /(?![\w$])/.source
      ),
      lookbehind: true
    },
    operator: /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
  }), s2.languages.javascript["class-name"][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/, s2.languages.insertBefore("javascript", "keyword", {
    regex: {
      // eslint-disable-next-line regexp/no-dupe-characters-character-class
      pattern: /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)\/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/,
      lookbehind: true,
      greedy: true,
      inside: {
        "regex-source": {
          pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
          lookbehind: true,
          alias: "language-regex",
          inside: s2.languages.regex
        },
        "regex-delimiter": /^\/|\/$/,
        "regex-flags": /^[a-z]+$/
      }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    "function-variable": {
      pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
      alias: "function"
    },
    parameter: [
      {
        pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
        lookbehind: true,
        inside: s2.languages.javascript
      },
      {
        pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
        lookbehind: true,
        inside: s2.languages.javascript
      },
      {
        pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
        lookbehind: true,
        inside: s2.languages.javascript
      },
      {
        pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
        lookbehind: true,
        inside: s2.languages.javascript
      }
    ],
    constant: /\b[A-Z](?:[A-Z_]|\dx?)*\b/
  }), s2.languages.insertBefore("javascript", "string", {
    hashbang: {
      pattern: /^#!.*/,
      greedy: true,
      alias: "comment"
    },
    "template-string": {
      pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
      greedy: true,
      inside: {
        "template-punctuation": {
          pattern: /^`|`$/,
          alias: "string"
        },
        interpolation: {
          pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
          lookbehind: true,
          inside: {
            "interpolation-punctuation": {
              pattern: /^\$\{|\}$/,
              alias: "punctuation"
            },
            rest: s2.languages.javascript
          }
        },
        string: /[\s\S]+/
      }
    },
    "string-property": {
      pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
      lookbehind: true,
      greedy: true,
      alias: "property"
    }
  }), s2.languages.insertBefore("javascript", "operator", {
    "literal-property": {
      pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
      lookbehind: true,
      alias: "property"
    }
  }), s2.languages.markup && (s2.languages.markup.tag.addInlined("script", "javascript"), s2.languages.markup.tag.addAttribute(
    /on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
    "javascript"
  )), s2.languages.js = s2.languages.javascript, function() {
    if (typeof s2 > "u" || typeof document > "u")
      return;
    Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector);
    var p = "Loading…", A = function(y, f) {
      return "✖ Error " + y + " while fetching file: " + f;
    }, E = "✖ Error: File does not exist or is empty", c = {
      js: "javascript",
      py: "python",
      rb: "ruby",
      ps1: "powershell",
      psm1: "powershell",
      sh: "bash",
      bat: "batch",
      h: "c",
      tex: "latex"
    }, i = "data-src-status", u = "loading", h = "loaded", v = "failed", d = "pre[data-src]:not([" + i + '="' + h + '"]):not([' + i + '="' + u + '"])';
    function w(y, f, x2) {
      var t = new XMLHttpRequest();
      t.open("GET", y, true), t.onreadystatechange = function() {
        t.readyState == 4 && (t.status < 400 && t.responseText ? f(t.responseText) : t.status >= 400 ? x2(A(t.status, t.statusText)) : x2(E));
      }, t.send(null);
    }
    function T(y) {
      var f = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(y || "");
      if (f) {
        var x2 = Number(f[1]), t = f[2], e = f[3];
        return t ? e ? [x2, Number(e)] : [x2, void 0] : [x2, x2];
      }
    }
    s2.hooks.add("before-highlightall", function(y) {
      y.selector += ", " + d;
    }), s2.hooks.add("before-sanity-check", function(y) {
      var f = (
        /** @type {HTMLPreElement} */
        y.element
      );
      if (f.matches(d)) {
        y.code = "", f.setAttribute(i, u);
        var x2 = f.appendChild(document.createElement("CODE"));
        x2.textContent = p;
        var t = f.getAttribute("data-src"), e = y.language;
        if (e === "none") {
          var a = (/\.(\w+)$/.exec(t) || [, "none"])[1];
          e = c[a] || a;
        }
        s2.util.setLanguage(x2, e), s2.util.setLanguage(f, e);
        var r = s2.plugins.autoloader;
        r && r.loadLanguages(e), w(
          t,
          function(n) {
            f.setAttribute(i, h);
            var o = T(f.getAttribute("data-range"));
            if (o) {
              var g = n.split(/\r\n?|\n/g), l = o[0], b = o[1] == null ? g.length : o[1];
              l < 0 && (l += g.length), l = Math.max(0, Math.min(l - 1, g.length)), b < 0 && (b += g.length), b = Math.max(0, Math.min(b, g.length)), n = g.slice(l, b).join(`
`), f.hasAttribute("data-start") || f.setAttribute("data-start", String(l + 1));
            }
            x2.textContent = n, s2.highlightElement(x2);
          },
          function(n) {
            f.setAttribute(i, v), x2.textContent = n;
          }
        );
      }
    }), s2.plugins.fileHighlight = {
      /**
       * Executes the File Highlight plugin for all matching `pre` elements under the given container.
       *
       * Note: Elements which are already loaded or currently loading will not be touched by this method.
       *
       * @param {ParentNode} [container=document]
       */
      highlight: function(f) {
        for (var x2 = (f || document).querySelectorAll(d), t = 0, e; e = x2[t++]; )
          s2.highlightElement(e);
      }
    };
    var H = false;
    s2.fileHighlight = function() {
      H || (console.warn("Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead."), H = true), s2.plugins.fileHighlight.highlight.apply(this, arguments);
    };
  }();
})(ie);
var ge = ie.exports;
const de = /* @__PURE__ */ ce(ge);
Prism.languages.json = {
  property: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: true,
    greedy: true
  },
  string: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
    lookbehind: true,
    greedy: true
  },
  comment: {
    pattern: /\/\/.*|\/\*[\s\S]*?(?:\*\/|$)/,
    greedy: true
  },
  number: /-?\b\d+(?:\.\d+)?(?:e[+-]?\d+)?\b/i,
  punctuation: /[{}[\],]/,
  operator: /:/,
  boolean: /\b(?:false|true)\b/,
  null: {
    pattern: /\bnull\b/,
    alias: "keyword"
  }
};
Prism.languages.webmanifest = Prism.languages.json;
(function() {
  if (typeof Prism > "u" || typeof document > "u")
    return;
  var m = "line-numbers", C = /\n(?!$)/g, s2 = Prism.plugins.lineNumbers = {
    /**
     * Get node for provided line number
     *
     * @param {Element} element pre element
     * @param {number} number line number
     * @returns {Element|undefined}
     */
    getLine: function(c, i) {
      if (!(c.tagName !== "PRE" || !c.classList.contains(m))) {
        var u = c.querySelector(".line-numbers-rows");
        if (u) {
          var h = parseInt(c.getAttribute("data-start"), 10) || 1, v = h + (u.children.length - 1);
          i < h && (i = h), i > v && (i = v);
          var d = i - h;
          return u.children[d];
        }
      }
    },
    /**
     * Resizes the line numbers of the given element.
     *
     * This function will not add line numbers. It will only resize existing ones.
     *
     * @param {HTMLElement} element A `<pre>` element with line numbers.
     * @returns {void}
     */
    resize: function(c) {
      p([c]);
    },
    /**
     * Whether the plugin can assume that the units font sizes and margins are not depended on the size of
     * the current viewport.
     *
     * Setting this to `true` will allow the plugin to do certain optimizations for better performance.
     *
     * Set this to `false` if you use any of the following CSS units: `vh`, `vw`, `vmin`, `vmax`.
     *
     * @type {boolean}
     */
    assumeViewportIndependence: true
  };
  function p(c) {
    if (c = c.filter(function(u) {
      var h = A(u), v = h["white-space"];
      return v === "pre-wrap" || v === "pre-line";
    }), c.length != 0) {
      var i = c.map(function(u) {
        var h = u.querySelector("code"), v = u.querySelector(".line-numbers-rows");
        if (!(!h || !v)) {
          var d = u.querySelector(".line-numbers-sizer"), w = h.textContent.split(C);
          d || (d = document.createElement("span"), d.className = "line-numbers-sizer", h.appendChild(d)), d.innerHTML = "0", d.style.display = "block";
          var T = d.getBoundingClientRect().height;
          return d.innerHTML = "", {
            element: u,
            lines: w,
            lineHeights: [],
            oneLinerHeight: T,
            sizer: d
          };
        }
      }).filter(Boolean);
      i.forEach(function(u) {
        var h = u.sizer, v = u.lines, d = u.lineHeights, w = u.oneLinerHeight;
        d[v.length - 1] = void 0, v.forEach(function(T, H) {
          if (T && T.length > 1) {
            var y = h.appendChild(document.createElement("span"));
            y.style.display = "block", y.textContent = T;
          } else
            d[H] = w;
        });
      }), i.forEach(function(u) {
        for (var h = u.sizer, v = u.lineHeights, d = 0, w = 0; w < v.length; w++)
          v[w] === void 0 && (v[w] = h.children[d++].getBoundingClientRect().height);
      }), i.forEach(function(u) {
        var h = u.sizer, v = u.element.querySelector(".line-numbers-rows");
        h.style.display = "none", h.innerHTML = "", u.lineHeights.forEach(function(d, w) {
          v.children[w].style.height = d + "px";
        });
      });
    }
  }
  function A(c) {
    return c ? window.getComputedStyle ? getComputedStyle(c) : c.currentStyle || null : null;
  }
  var E = void 0;
  window.addEventListener("resize", function() {
    s2.assumeViewportIndependence && E === window.innerWidth || (E = window.innerWidth, p(Array.prototype.slice.call(document.querySelectorAll("pre." + m))));
  }), Prism.hooks.add("complete", function(c) {
    if (c.code) {
      var i = (
        /** @type {Element} */
        c.element
      ), u = (
        /** @type {HTMLElement} */
        i.parentNode
      );
      if (!(!u || !/pre/i.test(u.nodeName)) && !i.querySelector(".line-numbers-rows") && Prism.util.isActive(i, m)) {
        i.classList.remove(m), u.classList.add(m);
        var h = c.code.match(C), v = h ? h.length + 1 : 1, d, w = new Array(v + 1).join("<span></span>");
        d = document.createElement("span"), d.setAttribute("aria-hidden", "true"), d.className = "line-numbers-rows", d.innerHTML = w, u.hasAttribute("data-start") && (u.style.counterReset = "linenumber " + (parseInt(u.getAttribute("data-start"), 10) - 1)), c.element.appendChild(d), p([u]), Prism.hooks.run("line-numbers", c);
      }
    }
  }), Prism.hooks.add("line-numbers", function(c) {
    c.plugins = c.plugins || {}, c.plugins.lineNumbers = true;
  });
})();
const pe = (m) => {
  const C = document.createElement("textArea");
  C.value = m, C.style.position = "fixed", C.style.zIndex = -100, document.body.appendChild(C), C.select(), document.execCommand("copy"), document.body.removeChild(C);
}, fe = (m) => new Option(m).innerHTML.trim(), he = (m) => m && typeof m.split == "function" ? m.split(`
`).length : [], me = "_codeBlock_1ifgb_1", ve = "_codeWrap_1ifgb_11", be = "_iconBar_1ifgb_17", ye = "_copiedMessage_1ifgb_25", we = "_copiedMessageActive_1ifgb_37", Ae = "_darkMode_1ifgb_43", xe = "_copyIcon_1ifgb_47", Fe = "_themeIcon_1ifgb_57", Ee = "_showMoreTab_1ifgb_67", ke = "_lightMode_1ifgb_84", _e = "_header_1ifgb_97", Se = "_languageTabContainer_1ifgb_110", $e = "_active_1ifgb_118", Ce = "_toggleSelect_1ifgb_128", S = {
  codeBlock: me,
  codeWrap: ve,
  iconBar: be,
  copiedMessage: ye,
  copiedMessageActive: we,
  darkMode: Ae,
  copyIcon: xe,
  themeIcon: Fe,
  showMoreTab: Ee,
  lightMode: ke,
  header: _e,
  languageTabContainer: Se,
  active: $e,
  toggleSelect: Ce
};
Prism.languages.curl = {
  curl: /\bcurl\b/,
  apiUrl: /https?:[a-zA-Z0-9:.?=\/\-_{}]*/,
  property: {
    pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?=\s*:)/,
    lookbehind: true,
    greedy: true
  },
  string: [
    {
      pattern: /(^|[^\\])"(?:\\.|[^\\"\r\n])*"(?!\s*:)/,
      lookbehind: true,
      greedy: true
    },
    {
      pattern: /'[^'"]*'(?=(?:[^"]*"[^"]*")*[^"]*$)/
    }
  ],
  comment: {
    pattern: /(^|[^"{\\$])#.*/,
    greedy: true
  },
  punctuation: /[{}[\],]/,
  boolean: /\b(?:true|false)\b/
};
const K = "voltLightCode", re = "voltDarkCode", se = ({
  activeLanguage: m,
  codeWrap: C = true,
  content: s2 = [{ language: "javascript", content: "" }],
  onColorToggle: p = () => {
  },
  onCopy: A = () => {
  },
  onLanguageChange: E = () => {
  },
  previewLineCount: c = 1 / 0,
  showLineNumbers: i = true,
  theme: u = K,
  testId: h = "volt-codeblock"
}) => {
  const [v, d] = useState(""), [w, T] = useState(u), [H, y] = useState(1), [f, x2] = useState(false), [t, e] = useState(false), [a, r] = useState(0), [n, o] = useState(
    () => s2.find(($) => $.language === m) || s2[0]
  ), g = w === re, l = () => {
    clearTimeout(a), e(true), r(setTimeout(() => e(false), 3e3));
  };
  useEffect(() => {
    const $ = fe(n.content);
    d($), y(he($)), setTimeout(() => de.highlightAll(), 0);
  }, [n]), useEffect(() => {
    o(s2.find(($) => $.language === m) || s2[0]);
  }, [s2, m]), useEffect(() => {
    T(u);
  }, [u]);
  const b = c > H, F = !b, L = !F || F && f ? "auto" : c * 22 + 56 + 40;
  return /* @__PURE__ */ k$1.createElement(
    "div",
    {
      className: `${S.codeBlock} ${g ? S.darkMode : S.lightMode} ${w}`,
      "data-testid": h,
      style: { height: L, paddingBottom: b ? 0 : 40 }
    },
    /* @__PURE__ */ k$1.createElement("div", { className: S.header }, R(), O()),
    /* @__PURE__ */ k$1.createElement(
      "pre",
      {
        className: `${S.codeWrap} ${C && "codeWrap"} ${i && "line-numbers"}`
      },
      /* @__PURE__ */ k$1.createElement(
        "code",
        {
          className: `language-${n.language && n.language.toLowerCase()} ${g ? S.darkMode : S.lightMode}`,
          dangerouslySetInnerHTML: { __html: v }
        }
      )
    ),
    F ? /* @__PURE__ */ k$1.createElement("div", { className: S.showMoreTab, onClick: () => x2(!f) }, /* @__PURE__ */ k$1.createElement(Text$1, { type: "h6", color: g ? po.white : po.blackLighter3 }, f ? "Collapse" : `View all ${H} lines`), /* @__PURE__ */ k$1.createElement(HSpacer, { factor: 0.5 }), /* @__PURE__ */ k$1.createElement(
      Icon,
      {
        type: f ? "caret-up" : "caret-down",
        factor: 0.5,
        noHoverEffects: true,
        mod: g ? "reversed" : "default"
      }
    )) : null
  );
  function R() {
    return /* @__PURE__ */ k$1.createElement("div", { className: S.languageTabContainer }, s2.map(($) => {
      const D = $.language;
      return /* @__PURE__ */ k$1.createElement(
        "div",
        {
          "data-testid": `language-tabs__${D}`,
          key: D,
          onClick: () => {
            o($), E($.language);
          },
          className: `${S.toggleSelect} ${D === n.language && S.active}`
        },
        D
      );
    }));
  }
  function O() {
    return /* @__PURE__ */ k$1.createElement("div", { className: S.iconBar }, /* @__PURE__ */ k$1.createElement(
      "span",
      {
        "data-testid": "copied-message",
        className: `${S.copiedMessage} ${t ? S.copiedMessageActive : ""}`
      },
      "Copied"
    ), /* @__PURE__ */ k$1.createElement("span", { className: S.copyIcon }, /* @__PURE__ */ k$1.createElement(
      Icon,
      {
        type: "copy",
        onClick: () => {
          pe(n.copyValue || n.content), l(), A();
        },
        noHoverEffects: true
      }
    )), /* @__PURE__ */ k$1.createElement(HSpacer, { factor: 1 }), /* @__PURE__ */ k$1.createElement("span", { className: S.themeIcon }, /* @__PURE__ */ k$1.createElement(
      Icon,
      {
        type: "color-toggle",
        onClick: () => {
          const $ = g ? K : re;
          T($), p($);
        },
        noHoverEffects: true
      }
    )));
  }
};
se.propTypes = {
  activeLanguage: PropTypes.string,
  codeWrap: PropTypes.bool,
  content: PropTypes.any,
  onColorToggle: PropTypes.func,
  onCopy: PropTypes.func,
  onLanguageChange: PropTypes.func,
  previewLineCount: PropTypes.number,
  showLineNumbers: PropTypes.bool,
  theme: PropTypes.string,
  testId: PropTypes.string
};
se.defaultProps = {
  codeWrap: true,
  content: [{ language: "javascript", content: "" }],
  previewLineCount: 1 / 0,
  showLineNumbers: true,
  theme: K
};
const ONBOARD_PROGRAM_COUNTRYCODE = gql`
 mutation OnboardCountryCode($program_short_code: ID!, $payload: OnboardCountryCodePayload) {
  onboardCountryCode(program_short_code: $program_short_code, payload: $payload) {
    status
  }
}
`;
const useOnboardProgramCountryCode = () => {
  const [onboardProgramCountryCodeMutation, {
    data,
    loading,
    error
  }] = useMutation(ONBOARD_PROGRAM_COUNTRYCODE);
  const onboardProgramCountryCode = async (program_short_code, payload) => {
    const variables = {
      program_short_code,
      payload
    };
    return await onboardProgramCountryCodeMutation({
      variables
    });
  };
  return {
    onboardProgramCountryCode,
    data,
    loading,
    error
  };
};
const UPDATE_HOLIDAY_PROGRAM_CONFIG = gql`
 mutation UpdateCaseProgramConfigTemplateAssociation($payload: UpdateProgramConfigTemplateAssociation) {
  updateCaseProgramConfigTemplateAssociation(payload: $payload) {
    program_code
    program_configs {
      type
      token
      program_code
      template_token
      template_name
      template_version
      enabled
      lock_version
      change_reference
      created_time
      last_modified_time
    }
  }
}
`;
const useUpdateHolidayConfigs = () => {
  const [updateHolidayConfigsMutation, {
    data,
    loading,
    error
  }] = useMutation(UPDATE_HOLIDAY_PROGRAM_CONFIG);
  const updateHolidayConfigs = async (payload) => {
    const variables = {
      payload
    };
    return await updateHolidayConfigsMutation({
      variables
    });
  };
  return {
    updateHolidayConfigs,
    data,
    loading,
    error
  };
};
const UPDATE_PROGRAM_CONFIG$1 = gql`
mutation UpdateCaseProgramConfigTemplateGroup($payload: UpdateProgramConfigTemplateGroup) {
  updateCaseProgramConfigTemplateGroup(payload: $payload) {
    program_code
    program_configs {
      type
      token
      program_code
      template_token
      template_name
      template_version
      enabled
      lock_version
      change_reference
      created_time
      last_modified_time
    }
  }
}
`;
const useUpdateTemplateGroups = () => {
  const [updateTemplateGroupsMutation, {
    data,
    loading,
    error
  }] = useMutation(UPDATE_PROGRAM_CONFIG$1);
  const updateTemplateGroups = async (payload, selectedShortCode) => {
    const variables = {
      payload,
      "x-marqeta-program-short-code": selectedShortCode
    };
    return await updateTemplateGroupsMutation({
      variables
    });
  };
  return {
    updateTemplateGroups,
    data,
    loading,
    error
  };
};
const TEMPLATE_GROUPS = gql`
  query caseTemplateGroups($count: Int) {
  caseTemplateGroups(count: $count) {
    data {
      type
      token
      name
      description
    }
  }
}
`;
const useTemplateGroups = () => {
  const {
    data,
    loading,
    error
  } = useQuery(TEMPLATE_GROUPS, {
    variables: {
      count: 999,
      "x-marqeta-program-short-code": "marqeta"
    }
    // changed count to 999
  });
  return {
    data,
    loading,
    error
  };
};
const TemplateGroupSelection = ({
  setSelectedTemplateGroups
}) => {
  const {
    data,
    loading,
    error
  } = useTemplateGroups();
  const [templateGroups, setTemplateGroups] = useState([]);
  const [selectedTemplateGroupNames, setSelectedTemplateGroupNames] = useState([]);
  useEffect(() => {
    if (data && data?.caseTemplateGroups) {
      setTemplateGroups(data.caseTemplateGroups.data);
    }
  }, [data]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Multiselect, { collapseSelected: true, collapseSelectedLimit: 1, disabled: false, dropDownWrap: {
    width: "300px"
  }, error: null, fixOverflow: false, label: "Template Groups", labelSize: "small", numOptions: 6, onOptionClick: (option) => {
    let newSelectedTemplateGroupNames = [...selectedTemplateGroupNames];
    if (newSelectedTemplateGroupNames.includes(option)) {
      newSelectedTemplateGroupNames = newSelectedTemplateGroupNames.filter((s2) => s2 !== option);
    } else {
      newSelectedTemplateGroupNames.push(option);
    }
    setSelectedTemplateGroups(newSelectedTemplateGroupNames.map((name) => templateGroups.find((group) => group.name === name).token));
    setSelectedTemplateGroupNames(newSelectedTemplateGroupNames);
  }, options: templateGroups ? templateGroups.map((group) => group.name) : [], searchableOptions: templateGroups ? templateGroups.map((group) => group.name) : [], searchableOptionsMaxDisplayNum: 50, placeholder: "Select from options", preventErrorPushdown: false, runValidatorOnLoad: false, selected: selectedTemplateGroupNames, selectedToTop: true, showSearch: true, sortOptions: false, sublabel: "", tooltipWidth: "{null}", width: "540px", hasChangedType: void 0 }) }) });
};
const CONFIG_TEMPLATES = gql`
  query caseConfigTemplates($count: Int) {
    caseConfigTemplates(count: $count) {
      data {
        type
        token
        name
        description
        created_time
        last_modified_time
      }
    }
  }
`;
const useConfigTemplates = () => {
  const {
    data,
    loading,
    error
  } = useQuery(CONFIG_TEMPLATES, {
    variables: {
      count: 999,
      "x-marqeta-program-short-code": "marqeta"
    }
    // changed count to 999
  });
  return {
    data,
    loading,
    error
  };
};
const HolidayGroupSelection = ({
  setSelectedHolidayGroup
}) => {
  const {
    data,
    loading,
    error
  } = useConfigTemplates();
  const [holidayGroups, setHolidayGroups] = useState([]);
  const [selectedHolidayGroup, setHolidayGroup] = useState([]);
  useEffect(() => {
    if (data && data?.caseConfigTemplates) {
      const filteredGroups = data.caseConfigTemplates.data.filter((group) => group.type === "COUNTRY");
      setHolidayGroups(filteredGroups);
    }
  }, [data]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { anchor: "left", backgroundColor: "undefined", disabled: false, dropDownWrap: {
    width: "500px",
    height: "300px"
  }, error: null, fixOverflow: false, hasChangedType: "undefined", label: "Holiday Groups", labelSize: "small", onChange: (value) => {
    const selectedGroup = holidayGroups.find((group) => group.name === value);
    setSelectedHolidayGroup(selectedGroup ? selectedGroup.token : null);
    setHolidayGroup(value);
  }, options: holidayGroups ? holidayGroups.map((group) => group.name) : [], preventErrorPushdown: false, runValidatorOnLoad: false, searchableOptions: holidayGroups ? holidayGroups.map((group) => group.name) : [], showSearch: true, sublabel: "", value: selectedHolidayGroup, width: "500px" }) }) });
};
const EnableRegToggle = ({
  setEnableReg,
  enableReg
}) => {
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Toggle, { type: "default", labelSize: "small", labelOptional: false, labelTooltip: "null", active: enableReg, disabled: false, onClick: () => {
    setEnableReg((prev) => !prev);
  }, children: "Enable Regulation Config (Reg E, Reg Z, PSD2)" }) });
};
const RegulationRegionDropdown = ({
  setSelectedRegion,
  countryCode = null
}) => {
  const [selectedRegion, setLocalSelectedRegion] = useState(countryCode);
  useEffect(() => {
  }, [selectedRegion]);
  const regions = ["US", "UK", "EU"];
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { anchor: "left", backgroundColor: "undefined", disabled: false, dropDownWrap: {
    width: "300px",
    height: "200px"
  }, error: null, fixOverflow: false, hasChangedType: "undefined", label: "Region", labelSize: "small", numOptions: 3, onChange: (value) => {
    setSelectedRegion(value);
    setLocalSelectedRegion(value);
  }, options: regions, placeholder: "Select an option", preventErrorPushdown: false, runValidatorOnLoad: false, searchableOptions: regions, searchableOptionsMaxDisplayNum: 50, showSearch: true, sortOptions: false, sublabel: "", value: selectedRegion, width: "300px" }) });
};
const ProgramShortCodeDropdown = ({
  setSelectedShortCode,
  programs
}) => {
  const [selectedShortCode, setLocalSelectedShortCode] = useState();
  const {
    refreshApplicationProperties,
    data: refreshApplicationPropertiesData
  } = useRefreshApplicationProperties();
  useEffect(() => {
    refreshApplicationProperties();
  }, []);
  const options = useMemo(() => {
    let onboardedProgramList = [];
    if (refreshApplicationPropertiesData?.refreshApplicationProperties) {
      onboardedProgramList = refreshApplicationPropertiesData?.refreshApplicationProperties?.api_enabled_program_short_codes;
    }
    const combinedPrograms = [...programs];
    return combinedPrograms.map(({
      program,
      short_name
    }) => {
      const isOnboarded = onboardedProgramList.includes(short_name);
      return {
        id: short_name,
        val: short_name,
        disabled: isOnboarded,
        render: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { style: {
          pointerEvents: isOnboarded ? "none" : "",
          opacity: isOnboarded ? 0.5 : 1
        }, children: [
          short_name,
          " - ",
          isOnboarded ? "Onboarded" : "Not Onboarded",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
        ] }),
        renderSelected: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
          short_name,
          " - ",
          isOnboarded ? "Onboarded" : "Not Onboarded",
          /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
        ] }),
        searchString: `${short_name} ${program}`
      };
    });
  }, [refreshApplicationPropertiesData]);
  const onSelect = ({
    val
  }) => {
    const shortCode = val.replace(/"/g, "");
    setSelectedShortCode(shortCode);
    setLocalSelectedShortCode(JSON.stringify(val));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { id: "dispute-program-selection", children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { anchor: "left", label: "Program Shortcode", labelSize: "small", onChange: onSelect, options, placeholder: "Select an option", searchableOptionsMaxDisplayNum: 50, showSearch: true, value: selectedShortCode, width: "300px" }) });
};
const CONFIG_TEMPLATE_BY_TOKEN = gql`
  query getConfigTemplateByToken($token: ID!) {
    getConfigTemplateByToken(token: $token) {
      type
      token
      name
      description
      created_time
      last_modified_time
      details {
          values {
            pc_grant_days_to_act
            pc_perm_days_to_act
            pc_reversed_coms_days_to_act
            pc_reversed_days_to_act
            created_time
          }
          filter_constraints {
            version
            created_time
          }
          template_criteria{
            dispute_reason
            country_code
            transaction_type
            created_time
          }
     }
    }
  }
`;
const useConfigTemplateByToken = () => {
  const [getConfigTemplateByTokenQuery, {
    data,
    loading,
    error
  }] = useLazyQuery(CONFIG_TEMPLATE_BY_TOKEN);
  const getConfigTemplateByToken = async (token) => {
    const variables = {
      token,
      "x-marqeta-program-short-code": "marqeta"
    };
    return await getConfigTemplateByTokenQuery({
      variables
    });
  };
  return {
    getConfigTemplateByToken,
    data,
    loading,
    error
  };
};
const TEMPLATE_GROUP_BY_TOKEN = gql`
 query GetTemplateGroupByToken($token: String) {
  getTemplateGroupByToken(token: $token) {
    type
    token
    name
    description
    created_time
    last_modified_time
    details {
      template_associations {
        template_token
        template_name
        dispute_reason
        country_code
      }
    }
  }
}
`;
const useTemplateGroupByToken = () => {
  const [getTemplateGroupByTokenQuery, {
    data,
    loading,
    error
  }] = useLazyQuery(TEMPLATE_GROUP_BY_TOKEN);
  const getTemplateGroupByToken = async (token) => {
    const variables = {
      token,
      "x-marqeta-program-short-code": "marqeta"
    };
    return await getTemplateGroupByTokenQuery({
      variables
    });
  };
  return {
    getTemplateGroupByToken,
    data,
    loading,
    error
  };
};
const CONFIG_HOLIDAY_TEMPLATE_BY_TOKEN = gql`
   query getConfigCountryTemplateByToken($token: ID!) {
    getConfigCountryTemplateByToken(token: $token) {
    type
    token
    name
    description
    created_time
    last_modified_time
    details {
      values {
        version
        holidays {
          name
          start_date
        }
        created_time
      }
      template_criteria {
        criterion_token
        country_code
        created_time
      }
    }
  }
  }
`;
const useHolidayTemplateByToken = () => {
  const [getHolidayTemplateByTokenQuery, {
    data,
    loading,
    error
  }] = useLazyQuery(CONFIG_HOLIDAY_TEMPLATE_BY_TOKEN);
  const getHolidayTemplateByToken = async (token) => {
    const variables = {
      token,
      "x-marqeta-program-short-code": "marqeta"
    };
    return await getHolidayTemplateByTokenQuery({
      variables
    });
  };
  return {
    getHolidayTemplateByToken,
    data,
    loading,
    error
  };
};
const TemplateData = ({
  templateToken,
  templateGroups
}) => {
  const [groupDataArray, setGroupDataArray] = useState([]);
  const [templateDetails, setTemplateDetails] = useState({});
  const {
    getHolidayTemplateByToken,
    data: localTemplateTokenData1,
    loading: templateTokenLoading1,
    error: templateByTokenError1
  } = useHolidayTemplateByToken();
  const {
    getTemplateGroupByToken,
    data: templateGroupData,
    loading: templateGroupLoading,
    error: templateGroupError
  } = useTemplateGroupByToken();
  const {
    getConfigTemplateByToken: getConfigTemplateByToken2,
    data: localTemplateTokenData2,
    loading: templateTokenLoading2,
    error: templateByTokenError2
  } = useConfigTemplateByToken();
  useEffect(() => {
    if (templateToken) {
      try {
        getHolidayTemplateByToken(templateToken);
      } catch (error) {
      }
    }
  }, [templateToken]);
  const templateDataMapped = useMemo(() => {
    if (!localTemplateTokenData1?.getConfigCountryTemplateByToken) {
      return [];
    }
    const {
      type,
      token,
      name,
      description,
      details,
      created_time,
      last_modified_time
    } = localTemplateTokenData1.getConfigCountryTemplateByToken;
    removeTypenameField(details?.values);
    return [{
      type,
      token,
      name,
      description,
      countryCode: details?.template_criteria?.country_code,
      values: details?.values ? JSON.stringify(details.values) : null,
      filterConstraints: details?.filter_constraints ? JSON.stringify(details.filter_constraints) : null,
      createdTime: created_time,
      lastModifiedTime: last_modified_time
    }];
  }, [localTemplateTokenData1]);
  useEffect(() => {
    if (templateGroups) {
      const fetchData = () => {
        for (const token of templateGroups) {
          try {
            getTemplateGroupByToken(token);
          } catch (error) {
          }
        }
      };
      fetchData();
    }
  }, [templateGroups]);
  useEffect(() => {
    if (templateGroupData) {
      setGroupDataArray((prev) => [...prev, templateGroupData]);
    }
  }, [templateGroupData]);
  const FilterData = useMemo(() => {
    if (groupDataArray) {
      const uniqueTokens = /* @__PURE__ */ new Set();
      return groupDataArray.filter((groupData) => {
        const token = groupData.getTemplateGroupByToken.token;
        if (templateGroups.includes(token) && !uniqueTokens.has(token)) {
          uniqueTokens.add(token);
          return true;
        }
        return false;
      });
    }
    return [];
  }, [groupDataArray, templateGroups]);
  useEffect(() => {
    const fetchTemplateDetails = () => {
      for (const groupData of FilterData) {
        const {
          details: groupDetails
        } = groupData.getTemplateGroupByToken;
        for (const association of groupDetails.template_associations) {
          const {
            template_token
          } = association;
          getConfigTemplateByToken2(template_token);
        }
      }
    };
    fetchTemplateDetails();
  }, [FilterData]);
  useEffect(() => {
    if (localTemplateTokenData2) {
      setTemplateDetails((prev) => ({
        ...prev,
        [localTemplateTokenData2?.getConfigTemplateByToken?.token]: localTemplateTokenData2?.getConfigTemplateByToken?.details
      }));
    }
  }, [localTemplateTokenData2]);
  function removeTypenameField(obj) {
    for (let property in obj) {
      if (property === "__typename") {
        delete obj[property];
      } else if (typeof obj[property] === "object") {
        removeTypenameField(obj[property]);
      }
    }
  }
  const templateGroupDataMapped = useMemo(() => {
    if (FilterData.length === 0) {
      return [];
    }
    return FilterData.flatMap((groupData) => {
      const {
        type,
        description,
        created_time,
        last_modified_time,
        details: groupDetails
      } = groupData.getTemplateGroupByToken;
      return groupDetails.template_associations.map((association) => {
        const details = templateDetails[association.template_token] || {};
        removeTypenameField(details.filter_constraints);
        removeTypenameField(details.values);
        return {
          type,
          description,
          createdTime: created_time,
          lastModifiedTime: last_modified_time,
          token: association.template_token,
          name: association.template_name,
          disputeReason: association.dispute_reason,
          countryCode: association.country_code,
          filterConstraints: JSON.stringify(details.filter_constraints, null, 2),
          // Add the filter constraints
          values: JSON.stringify(details.values, null, 2)
          // Add the values
        };
      });
    });
  }, [FilterData, templateDetails]);
  const data = [...templateDataMapped, ...templateGroupDataMapped];
  const columns2 = [{
    header: "Type",
    accessor: "type",
    key: "type"
  }, {
    header: "Name",
    accessor: "name",
    key: "name"
  }, {
    header: "Dispute Reason",
    accessor: "disputeReason",
    key: "disputeReason"
  }, {
    header: "Country Code",
    accessor: "countryCode",
    key: "countryCode"
  }, {
    header: "Description",
    accessor: "description",
    key: "description"
  }, {
    header: "Values",
    accessor: "values",
    key: "values"
  }, {
    header: "Filters",
    accessor: "filterConstraints",
    key: "filterConstraints"
  }, {
    header: "Token",
    accessor: "token",
    key: "token"
  }, {
    header: "Created Time",
    accessor: "createdTime",
    key: "createdTime"
  }, {
    header: "Last Modified Time",
    accessor: "lastModifiedTime",
    key: "lastModifiedTime"
  }];
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { defaultWidth: 100, maxColumnWidth: 1e4, minWidth: 8, data, columns: columns2, automaticallySizeColumnWidth: true }) });
};
const getRequestBody = (selectedShortCode, selectedRegion, selectedChangeTicket, selectedHolidayGroup, selectedTemplateGroups) => {
  const requestBodyArray = [];
  if (selectedShortCode) {
    const variables = {
      program_short_code: selectedShortCode,
      payload: {
        isRegEProgram: false
      },
      "x-marqeta-program-short-code": "marqeta"
    };
    requestBodyArray.push(variables);
  }
  if (selectedRegion) {
    const variables_country = {
      program_short_code: selectedShortCode,
      payload: {
        country_code: selectedRegion
      }
    };
    requestBodyArray.push(variables_country);
  }
  if (selectedHolidayGroup) {
    const update_variables = {
      payload: {
        type: "COUNTRY",
        change_reference: selectedChangeTicket,
        details: {
          template_association: {
            template_token: selectedHolidayGroup,
            country_code: selectedRegion,
            lock_version: true,
            version_number: 1,
            enabled: true
          }
        }
      }
    };
    requestBodyArray.push(update_variables);
  }
  if (selectedTemplateGroups && selectedTemplateGroups.length > 0) {
    selectedTemplateGroups.forEach((templateGroup) => {
      const update_template_variables = {
        payload: {
          type: "REG_E",
          change_reference: selectedChangeTicket,
          details: {
            template_group: {
              template_token: templateGroup,
              enabled: true,
              lock_latest_version: true
            }
          }
        }
      };
      requestBodyArray.push(update_template_variables);
    });
  }
  return JSON.stringify(requestBodyArray, null, 2);
};
function DisputesOnboardProgram({
  programs
}) {
  const [selectedShortCode, setSelectedShortCode] = useState("");
  const [showConfirmationModel, setShowConfirmationModel] = useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [requestBody, setRequestBody] = useState("");
  const [dataLogs, setDataLogs] = useState([]);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [enableReg, setEnableReg] = useState(false);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [changeTicket, setChangeTicket] = useState("");
  const [selectedTemplateGroups, setSelectedTemplateGroups] = useState([]);
  const [selectedHolidayGroup, setSelectedHolidayGroup] = useState(null);
  const [loadingOverlayActive, setLoadingOverlayActive] = useState(false);
  const {
    onboardProgram,
    data,
    loading,
    error
  } = useOnboardProgram();
  const {
    refreshApplicationProperties,
    data: refreshApplicationPropertiesData,
    loading: refreshApplicationPropertiesLoading,
    error: refreshApplicationPropertiesError
  } = useRefreshApplicationProperties();
  const {
    onboardProgramCountryCode,
    data: countryCodeData,
    loading: countryCodeLoading,
    error: countryCodeError
  } = useOnboardProgramCountryCode();
  const {
    updateHolidayConfigs,
    data: HolidayConfigsData,
    loading: HolidayConfigsLoading,
    error: HolidayConfigsError
  } = useUpdateHolidayConfigs();
  const {
    updateTemplateGroups,
    data: UpdateTemplateGroupsData,
    loading: UpdateTemplateGroupsLoading,
    error: UpdateTemplateGroupsError
  } = useUpdateTemplateGroups();
  useEffect(() => {
    refreshApplicationProperties();
  }, []);
  useEffect(() => {
    const requestBody2 = getRequestBody(selectedShortCode, selectedRegion, changeTicket, selectedHolidayGroup, selectedTemplateGroups);
    setRequestBody(requestBody2);
  }, [selectedShortCode, selectedRegion, changeTicket, selectedHolidayGroup, selectedTemplateGroups]);
  const oneClickOnboard = async () => {
    setLoadingOverlayActive(true);
    const data2 = [];
    const variables = {
      "program_short_code": selectedShortCode,
      "payload": {
        "isRegEProgram": false
      },
      "x-marqeta-program-short-code": "marqeta"
    };
    try {
      const result = await onboardProgram(variables.program_short_code, variables.payload);
      data2.push(result);
    } catch (error2) {
      data2.push(error2);
    }
    if (!enableReg) {
      for (let i = 0; i < 100; i++) {
        try {
          await refreshApplicationProperties();
        } catch (error2) {
        }
      }
    }
    if (enableReg) {
      const variables_country = {
        "program_short_code": selectedShortCode,
        "payload": {
          "country_code": selectedRegion
        }
      };
      try {
        const result = await onboardProgramCountryCode(variables_country.program_short_code, variables_country.payload);
        data2.push(result);
        for (let i = 0; i < 100; i++) {
          try {
            await refreshApplicationProperties();
          } catch (error2) {
          }
        }
      } catch (error2) {
        data2.push(error2);
      }
      if (selectedHolidayGroup) {
        const update_variables = {
          "payload": {
            "type": "COUNTRY",
            "change_reference": changeTicket,
            "details": {
              "template_association": {
                "template_token": selectedHolidayGroup,
                "country_code": selectedRegion,
                "lock_version": true,
                "version_number": 1,
                "enabled": true
              }
            }
          }
        };
        try {
          const result = await updateHolidayConfigs(update_variables.payload);
          data2.push(result);
        } catch (error2) {
          data2.push(error2);
        }
      }
      if (selectedTemplateGroups && selectedTemplateGroups.length > 0) {
        for (let templateGroup of selectedTemplateGroups) {
          const update_template_variables = {
            "payload": {
              "type": "REG_E",
              "change_reference": changeTicket,
              "details": {
                "template_group": {
                  "template_token": templateGroup,
                  "enabled": true,
                  "lock_latest_version": true
                }
              }
            }
          };
          try {
            const result = await updateTemplateGroups(update_template_variables.payload, selectedShortCode);
            data2.push(result);
          } catch (error2) {
            data2.push(error2);
          }
        }
      }
    }
    const errorMeassage = data2.find((item) => item instanceof Error)?.message;
    const allSuccessful = data2.every((item) => !(item instanceof Error));
    setErrorMessage(errorMeassage);
    setDataLogs(Array.isArray(data2) ? data2 : [data2]);
    setLoadingOverlayActive(false);
    return {
      allSuccessful,
      data: data2
    };
  };
  const resetData = () => {
    setShowConfirmationModel(false);
    setEnableReg(false);
    setSelectedRegion(null);
    setChangeTicket("");
    setSelectedTemplateGroups(null);
    setSelectedHolidayGroup(null);
  };
  const safeStringify = (obj) => {
    const seen = /* @__PURE__ */ new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    }, 2);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loadingOverlayActive, transparentBackground: true, children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", testId: "onboard-header", children: "Dispute Onboard Program" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "", display: "flex", flex: "", flexDirection: "column", flexWrap: "", justifyContent: "flex-start", type: "div", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "row", children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramShortCodeDropdown, { setSelectedShortCode, testId: "program-short-code", programs }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 10 }),
          /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "right", children: [
            /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 0.5 }),
            /* @__PURE__ */ jsxRuntimeExports.jsx(EnableRegToggle, { setEnableReg, enableReg })
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HSpacer, { factor: 10 })
      ] }),
      enableReg && /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(RegulationRegionDropdown, { setSelectedRegion }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { id: "changeTicket", onChange: (e) => setChangeTicket(e.target.value), value: changeTicket, type: "text", label: "Change Ticket", width: "540" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Please enter the APPROVED change ticket and select Region before onboarding the program" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TemplateGroupSelection, { setSelectedTemplateGroups }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(HolidayGroupSelection, { setSelectedHolidayGroup }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(TemplateData, { templateToken: selectedHolidayGroup, templateGroups: selectedTemplateGroups })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 10 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "right", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "primary", disabled: false, loading: false, onClick: async () => {
          if (enableReg && (changeTicket === "" || selectedRegion === "" || selectedShortCode === "")) {
            setErrorMessage("Please select the program, enter the APPROVED change ticket and select Region before onboarding the program");
            setShowErrorMessage(true);
            return;
          }
          if (!enableReg && selectedShortCode === "") {
            setErrorMessage("Please select the program before onboarding the program");
            setShowErrorMessage(true);
            return;
          }
          setShowConfirmationModel(true);
        }, children: "Submit" }),
        showConfirmationModel && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { type: "sm", testId: "onboard-program-confirmation", heading: "Onboard Program confirmation", hideModal: () => setShowConfirmationModel(false), footerButtons: [/* @__PURE__ */ jsxRuntimeExports.jsx(Button, { onClick: async () => {
          setShowConfirmationModel(false);
          setLoadingOverlayActive(true);
          const {
            allSuccessful,
            data: data2
          } = await oneClickOnboard();
          setLoadingOverlayActive(false);
          if (allSuccessful) {
            setShowSuccessMessage(true);
            resetData();
          } else {
            setShowErrorMessage(true);
            resetData();
          }
        }, testId: "onboard-program-modal-button", children: "Confirm" }, "confirmation")], children: /* @__PURE__ */ jsxRuntimeExports.jsxs(Text$1, { children: [
          "Do you want to Onboard ",
          selectedShortCode,
          " program ?"
        ] }) }),
        showErrorMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(Modal, { type: "sm", testId: "onboard-program-error", heading: "Onboard Program Error", hideModal: () => setShowErrorMessage(false), children: /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { children: errorMessage }) }),
        showSuccessMessage && /* @__PURE__ */ jsxRuntimeExports.jsxs(ToastAlert, { icon: "success", action: "undefined", remove: () => {
          setShowSuccessMessage(false);
        }, dismissTime: "2", children: [
          "Successfully Onboarded ",
          selectedShortCode,
          " Program"
        ] }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 10 })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(se, { codeWrap: true, previewLineCount: "15", content: [{
        language: "REQUEST",
        content: requestBody ? requestBody : "{}",
        copyValue: requestBody ? requestBody : "{}"
      }, {
        language: "RESPONSE",
        content: dataLogs ? dataLogs?.map((data2) => safeStringify(data2)).join("\n") : "{}",
        copyValue: dataLogs ? dataLogs?.map((data2) => safeStringify(data2)).join("\n") : "{}"
      }] })
    ] })
  ] }) });
}
DisputesOnboardProgram.propTypes = {
  programs: PropTypes.object
};
DisputesOnboardProgram.defaultProps = {
  programs: {}
};
const DisputesOnboardProgram$1 = observer(DisputesOnboardProgram);
const CASE_PROGRAM_CONFIGS = gql`
  query caseProgramConfigs($count: Int) {
    caseProgramConfigs(count: $count) {
      count
      is_more
      data {
        type
        token
        enabled
        lock_version
        change_reference
        created_time
        last_modified_time
        filter_constraint {
          category
          values {
            min_days
            max_days
          }
        }
        template_criteria {
          dispute_reason
          country_code
        }
        template_values {
          pc_grant_days_to_act
          pc_perm_days_to_act
          pc_reversed_coms_days_to_act
          pc_reversed_days_to_act
          holidays {
            name
            start_date
          }
        }
      }
    }
  }
`;
const useCaseProgramConfigs = (activeProgramShortCode) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(CASE_PROGRAM_CONFIGS, {
    variables: {
      count: 200
    },
    skip: !activeProgramShortCode
  });
  return {
    data,
    loading,
    error,
    refetch
  };
};
const UPDATE_PROGRAM_CONFIG = gql`
  mutation updateCaseProgramConfigs($payload: UpdateProgramConfig) {
  updateCaseProgramConfigs(payload: $payload) {
    program_code
    program_configs {
      token
      enabled
    change_reference
    last_modified_time
    }    
  }
}
`;
const useUpdateProgramConfig = () => {
  const [updateProgramConfigMutation, {
    data,
    loading,
    error
  }] = useMutation(UPDATE_PROGRAM_CONFIG);
  const updateProgramConfig = async (payload) => {
    const variables = {
      payload
    };
    return await updateProgramConfigMutation({
      variables
    });
  };
  return {
    updateProgramConfig,
    data,
    loading,
    error
  };
};
const ProgramConfigData = ({
  selectedShortCode,
  selectedChangeTicket
}) => {
  const {
    data,
    loading,
    error,
    refetch
  } = useCaseProgramConfigs(selectedShortCode);
  const [resultData, setResultData] = useState(null);
  const {
    updateProgramConfig,
    data: mutationData
  } = useUpdateProgramConfig();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  useEffect(() => {
    refetch();
  }, []);
  useEffect(() => {
    if (data?.caseProgramConfigs?.data) {
      setResultData(data?.caseProgramConfigs?.data);
    }
  }, [data]);
  const handleStatusChange = async (token, selectedShortCode2, status) => {
    if (selectedChangeTicket) {
      const payload = {
        operation: "UPDATE",
        change_reference: selectedChangeTicket,
        details: {
          program_configs: [{
            token,
            enabled: status
          }]
        }
      };
      await updateProgramConfig(payload);
      setToastMessage(`Successfully ${status ? "enabled" : "disabled"} the config on ${selectedShortCode2} Program`);
      setShowSuccessMessage(true);
      refetch();
    }
  };
  const tableData = resultData ? resultData.map((template) => {
    let template_values = template.template_values;
    if (template.type === "COUNTRY") {
      template_values = template_values ? {
        holidays: template_values.holidays
      } : {};
    } else {
      if (template_values) {
        const {
          holidays,
          __typename,
          ...rest
        } = template_values;
        template_values = rest;
      } else {
        template_values = {};
      }
    }
    return {
      enabled: template?.enabled,
      type: template?.type,
      templateCriteria: `${template?.template_criteria.dispute_reason ? `${template.template_criteria.dispute_reason} | ` : ""}${template.template_criteria.country_code}`,
      token: template?.token,
      change_reference: template?.change_reference,
      lock_version: template?.lock_version,
      created_time: template?.created_time,
      last_modified_time: template?.last_modified_time,
      template_values: JSON.stringify(template_values)
    };
  }) : [];
  const columns2 = [{
    header: "Update Status",
    accessor: "enabled",
    key: "enabled",
    renderer: ({
      row
    }) => {
      return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { style: {
        pointerEvents: selectedChangeTicket ? "" : "none",
        opacity: selectedChangeTicket ? 1 : 0.5,
        cursor: selectedChangeTicket ? "pointer" : "default"
      }, children: row.enabled ? /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "close", mod: "default", overrideColor: Colors.statusErrorColor, factor: 1, hasTooltip: false, onClick: () => selectedChangeTicket && handleStatusChange(row.token, selectedShortCode, !row.enabled) }) : /* @__PURE__ */ jsxRuntimeExports.jsx(Icon, { type: "check", overrideColor: Colors.statusSuccessColor, mod: "default", factor: 1, hasTooltip: false, onClick: () => selectedChangeTicket && handleStatusChange(row.token, selectedShortCode, !row.enabled) }) });
    }
  }, {
    header: "Status",
    accessor: "statusIndicator",
    key: "statusIndicator",
    renderer: ({
      row
    }) => {
      const status = row.enabled ? "Enabled" : "Disabled";
      const colorOverride = row.enabled ? Colors.statusSuccessColor : Colors.statusErrorColor;
      return /* @__PURE__ */ jsxRuntimeExports.jsx(StatusIndicator, { type: "dot", status, colorOverride });
    }
  }, {
    header: "Type",
    accessor: "type",
    key: "type"
  }, {
    header: "Template Criteria",
    accessor: "templateCriteria",
    key: "templateCriteria"
  }, {
    header: "Token",
    accessor: "token",
    key: "token"
  }, {
    header: "Change Reference",
    accessor: "change_reference",
    key: "change_reference"
  }, {
    header: "Lock Version",
    accessor: "lock_version",
    key: "lock_version"
  }, {
    header: "Template Values",
    accessor: "template_values",
    key: "template_values"
  }, {
    header: "Created time",
    accessor: "created_time",
    key: "created_time"
  }, {
    header: "Last modified time",
    accessor: "last_modified_time",
    key: "last_modified_time"
  }];
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: loading, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx(Table, { data: tableData, columns: columns2 }),
      showSuccessMessage && /* @__PURE__ */ jsxRuntimeExports.jsx(
        ToastAlert,
        {
          icon: "success",
          action: "undefined",
          remove: () => {
            setShowSuccessMessage(false);
          },
          dismissTime: 2,
          children: toastMessage
        }
      )
    ] })
  ] });
};
const ConfigTemplateSelection = ({
  setConfigTemplateSelection
}) => {
  const {
    data,
    loading,
    error
  } = useConfigTemplates();
  const [configTemplates, setConfigTemplates] = useState([]);
  const [selectedConfigTemplate, setSelectedConfigTemplate] = useState([]);
  useEffect(() => {
    if (data && data?.caseConfigTemplates) {
      const configTemplateGroups = data.caseConfigTemplates.data;
      setConfigTemplates(configTemplateGroups);
    }
  }, [data]);
  const options = configTemplates.map((group) => ({
    id: group.token,
    val: group.name,
    render: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", style: {
      display: "flex",
      alignItems: "start",
      width: "100%",
      height: "100%"
    }, children: [
      /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: group.name }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { style: {
        opacity: 0.5
      }, children: [
        group.type,
        " - ",
        group.description
      ] })
    ] }),
    renderSelected: /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { children: [
      group.name,
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {}),
      group.type,
      " - ",
      group.description,
      /* @__PURE__ */ jsxRuntimeExports.jsx("br", {})
    ] }),
    searchString: `${group.name} ${group.type} ${group.description}`
  }));
  const onSelect = ({
    val
  }) => {
    const selectedGroup = configTemplates.find((group) => group.name === val);
    setConfigTemplateSelection(selectedGroup ? selectedGroup : null);
    setSelectedConfigTemplate(JSON.stringify(val));
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports.jsx(Select, { anchor: "left", label: "Config Template", labelSize: "small", onChange: onSelect, options, placeholder: "Select an option", showSearch: true, value: selectedConfigTemplate, width: "600px" }) });
};
const ConfigTemplateCodeBlock = ({
  selectedConfigTemplate,
  setConfigTemplateDetail,
  updateData
}) => {
  const [codeBlock, setCodeBlock] = useState(null);
  const {
    getConfigTemplateByToken,
    data,
    loading,
    error
  } = useConfigTemplateByToken();
  const {
    getHolidayTemplateByToken,
    data: localTemplateTokenData,
    loading: templateTokenLoading,
    error: templateByTokenError
  } = useHolidayTemplateByToken();
  useEffect(() => {
    const processData = (data2) => {
      try {
        removeTypenameField(data2);
        const formattedData = JSON.stringify(data2, null, 2);
        setCodeBlock(formattedData);
        setConfigTemplateDetail(data2?.getConfigTemplateByToken || data2?.getConfigCountryTemplateByToken);
      } catch (e) {
        console.error("Error formatting data", e);
        setCodeBlock("Error formatting data");
      }
    };
    if (selectedConfigTemplate) {
      if (selectedConfigTemplate?.type === "COUNTRY") {
        getHolidayTemplateByToken(selectedConfigTemplate?.token);
        if (localTemplateTokenData) {
          processData(localTemplateTokenData);
        }
      } else {
        getConfigTemplateByToken(selectedConfigTemplate?.token);
        if (data) {
          processData(data);
        }
      }
      if (error || templateByTokenError) {
        console.error("GraphQL error", error || templateByTokenError);
        setCodeBlock("Error fetching data");
      }
    }
  }, [selectedConfigTemplate, data, localTemplateTokenData, error, templateByTokenError]);
  function removeTypenameField(obj) {
    for (let property in obj) {
      if (property === "__typename") {
        delete obj[property];
      } else if (typeof obj[property] === "object") {
        removeTypenameField(obj[property]);
      }
    }
  }
  const activeLanguage = updateData ? "RESPONSE" : "REQUEST";
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(LoadingOverlay, { active: loading || templateTokenLoading, transparentBackground: true }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(se, { previewLineCount: "15", showLineNumbers: true, activeLanguage, codeWrap: true, content: [{
      language: "REQUEST",
      content: codeBlock,
      copyValue: codeBlock ? codeBlock : "{}"
    }, {
      language: "RESPONSE",
      content: updateData ? JSON.stringify(updateData, null, 2) : "{}",
      copyValue: updateData ? JSON.stringify(updateData, null, 2) : "{}"
    }] })
  ] });
};
function ProgramRegConfig({
  activeProgram,
  countryCode
}) {
  const [selectedShortCode] = useState(activeProgram?.short_name);
  const [selectedChangeTicket, setSelectedChangeTicket] = useState("");
  const [selectedConfigTemplate, setSelectedConfigTemplate] = useState("");
  const [configTemplateDetail, setConfigTemplateDetail] = useState(null);
  const [activeTab, setActiveTab] = useState("Program Config");
  const [activeDisplayLanguage, setActiveDisplayLanguage] = useState("REQUEST");
  const [selectedTemplateGroups, setSelectedTemplateGroups] = useState([]);
  const [selectedHolidayGroup, setSelectedHolidayGroup] = useState(null);
  const [requestBody, setRequestBody] = useState("");
  const [dataLogs, setDataLogs] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(countryCode);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    updateHolidayConfigs,
    data: updateData,
    loading: updateLoading,
    error: updateError
  } = useUpdateHolidayConfigs();
  const {
    updateTemplateGroups,
    data: UpdateTemplateGroupsData,
    loading: UpdateTemplateGroupsLoading,
    error: UpdateTemplateGroupsError
  } = useUpdateTemplateGroups();
  useEffect(() => {
    if (countryCode == "null") {
      setSelectedRegion(null);
    } else {
      setSelectedRegion(countryCode);
    }
  }, [countryCode]);
  useEffect(() => {
    const requestBody2 = getRequestBody(selectedShortCode, selectedRegion, selectedChangeTicket, selectedHolidayGroup, selectedTemplateGroups);
    setRequestBody(requestBody2);
  }, [selectedRegion, selectedChangeTicket, selectedHolidayGroup, selectedTemplateGroups]);
  const handleCopyConfigTemplate = async () => {
    if (!configTemplateDetail) {
      return;
    }
    const {
      type,
      details
    } = configTemplateDetail;
    if (!type || !details) {
      return;
    }
    const {
      template_criteria = []
    } = details;
    let payload = {};
    if (type !== "COUNTRY") {
      const template_associations = template_criteria.map(({
        dispute_reason,
        country_code
      }) => ({
        template_token: selectedConfigTemplate?.token,
        dispute_reason,
        country_code,
        version_number: 1,
        enabled: true,
        lock_version: true
      }));
      payload = {
        type,
        change_reference: selectedChangeTicket,
        details: {
          template_associations
        }
      };
    } else {
      const template_association = {
        template_token: selectedConfigTemplate?.token,
        country_code: template_criteria?.country_code || "",
        lock_version: true,
        version_number: 1,
        enabled: true
      };
      payload = {
        type,
        change_reference: selectedChangeTicket,
        details: {
          template_association
        }
      };
    }
    try {
      await updateHolidayConfigs(payload);
    } catch (error) {
    }
  };
  const handleSetConfigtoProgram = async () => {
    setIsSubmitting(true);
    const data = [];
    const changeTicket = selectedChangeTicket;
    if (!changeTicket) {
      setIsSubmitting(false);
      return;
    }
    if (!selectedRegion) {
      setIsSubmitting(false);
      return;
    }
    if (selectedHolidayGroup) {
      const update_variables = {
        payload: {
          type: "COUNTRY",
          change_reference: changeTicket,
          details: {
            template_association: {
              template_token: selectedHolidayGroup,
              country_code: selectedRegion,
              lock_version: true,
              version_number: 1,
              enabled: true
            }
          }
        }
      };
      try {
        const result = await updateHolidayConfigs(update_variables.payload);
        data.push(result);
      } catch (error) {
        data.push(error);
      }
    }
    if (selectedTemplateGroups && selectedTemplateGroups.length > 0) {
      for (let templateGroup of selectedTemplateGroups) {
        const update_template_variables = {
          payload: {
            type: "REG_E",
            change_reference: changeTicket,
            details: {
              template_group: {
                template_token: templateGroup,
                enabled: true,
                lock_latest_version: true
              }
            }
          }
        };
        try {
          const result = await updateTemplateGroups(update_template_variables.payload, selectedShortCode);
          data.push(result);
        } catch (error) {
          data.push(error);
        }
      }
    }
    setDataLogs(data);
    setIsSubmitting(false);
    setActiveDisplayLanguage("RESPONSE");
  };
  const safeStringify = (obj) => {
    const seen = /* @__PURE__ */ new WeakSet();
    return JSON.stringify(obj, (key, value) => {
      if (typeof value === "object" && value !== null) {
        if (seen.has(value)) {
          return;
        }
        seen.add(value);
      }
      return value;
    }, 2);
  };
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };
  return /* @__PURE__ */ jsxRuntimeExports.jsxs("div", { children: [
    /* @__PURE__ */ jsxRuntimeExports.jsx(Text$1, { type: "h3", testId: "onboard-header", children: "Dispute Program Regulation Config" }),
    /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
    /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { alignItems: "", display: "flex", flex: "", flexDirection: "column", flexWrap: "", justifyContent: "flex-start", type: "div", children: [
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Flex, { flexDirection: "column", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { label: "Program Shortcode", type: "text", value: selectedShortCode, width: "540", readOnly: true }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Input, { id: "changeTicket", onChange: (e) => setSelectedChangeTicket(e.target.value), value: selectedChangeTicket, type: "text", label: "Change Ticket", width: "540" }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 1 }),
        /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { children: "Please enter the APPROVED change ticket details before you modify program configs" })
      ] }),
      /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
      /* @__PURE__ */ jsxRuntimeExports.jsxs(Tabs, { activeTab, tabs: ["Program Config", "Add Program Config to Program", "Add Template Groups and Holiday Groups to Program"], onTabChange: handleTabChange, testId: "tabs-screen", children: [
        /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
        activeTab === "Program Config" && /* @__PURE__ */ jsxRuntimeExports.jsx(ProgramConfigData, { selectedShortCode, selectedChangeTicket }),
        activeTab === "Add Program Config to Program" && /* @__PURE__ */ jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, { children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(ConfigTemplateSelection, { setConfigTemplateSelection: setSelectedConfigTemplate }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(ConfigTemplateCodeBlock, { selectedConfigTemplate, setConfigTemplateDetail, updateData }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "primary", onClick: handleCopyConfigTemplate, disabled: !selectedChangeTicket || !selectedConfigTemplate || updateLoading, children: "Copy Config Template to Program" }),
          updateError && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: updateError.message })
        ] }),
        activeTab === "Add Template Groups and Holiday Groups to Program" && /* @__PURE__ */ jsxRuntimeExports.jsx(jsxRuntimeExports.Fragment, { children: /* @__PURE__ */ jsxRuntimeExports.jsxs(LoadingOverlay, { active: isSubmitting, children: [
          /* @__PURE__ */ jsxRuntimeExports.jsx(RegulationRegionDropdown, { setSelectedRegion, countryCode: selectedRegion }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TemplateGroupSelection, { setSelectedTemplateGroups }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(HolidayGroupSelection, { setSelectedHolidayGroup }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 2 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(TemplateData, { templateToken: selectedHolidayGroup, templateGroups: selectedTemplateGroups }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(Button, { type: "primary", onClick: handleSetConfigtoProgram, disabled: !selectedChangeTicket || !selectedRegion || !selectedHolidayGroup && selectedTemplateGroups.length === 0, children: "Submit" }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(VSpacer, { factor: 3 }),
          /* @__PURE__ */ jsxRuntimeExports.jsx(se, { codeWrap: true, previewLineCount: "15", activeLanguage: activeDisplayLanguage, content: [{
            language: "REQUEST",
            content: requestBody ? requestBody : "{}",
            copyValue: requestBody ? requestBody : "{}"
          }, {
            language: "RESPONSE",
            content: dataLogs ? dataLogs?.map((data) => safeStringify(data)).join("\n") : "{}",
            copyValue: dataLogs ? dataLogs?.map((data) => safeStringify(data)).join("\n") : "{}"
          }] }),
          updateError && /* @__PURE__ */ jsxRuntimeExports.jsx(Alert, { type: "error", children: updateError.message })
        ] }) })
      ] })
    ] })
  ] });
}
ProgramRegConfig.propTypes = {
  activeProgram: PropTypes.object
};
ProgramRegConfig.defaultProps = {
  activeProgram: null
};
const ProgramRegConfig$1 = observer(ProgramRegConfig);
export {
  APPLICATION_PROPERTIES_COUNTRY_CODE,
  BankReportingContainer,
  BulkUploadContainer$1 as BulkUploadContainer,
  CasesProgramConfigsContext,
  CreateDisputeForm$1 as CreateDisputeForm,
  DisputeDetails$1 as DisputeDetails,
  DisputeSegmentTrackHOC,
  DisputeStore,
  DisputesContainer$1 as DisputesContainer,
  DisputesOnboardProgram$1 as DisputesOnboardProgram,
  DisputesTableStore,
  EditDisputeForm$1 as EditDisputeForm,
  ProgramConfigsListStore,
  ProgramRegConfig$1 as ProgramRegConfig,
  RelatedTransactions,
  TransactionTokenInputModal$1 as TransactionTokenInputModal,
  disputeStorage,
  disputesSegmentTrackEvent,
  useServiceIntegrations
};
